export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date with time (isoformat) */
  DateTime: { input: any; output: any; }
  _date: { input: any; output: any; }
  _jsonb: { input: any; output: any; }
  _text: { input: any; output: any; }
  _uuid: { input: any; output: any; }
  _varchar: { input: any; output: any; }
  bigint: { input: number; output: number; }
  date: { input: any; output: any; }
  float8: { input: number; output: number; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  smallint: { input: any; output: any; }
  time: { input: string; output: string; }
  timestamptz: { input: string; output: string; }
  uuid: { input: string; output: string; }
};

export type ActiveOrderResponse = {
  __typename?: 'ActiveOrderResponse';
  active_order_id?: Maybe<Scalars['uuid']['output']>;
  chat_employee?: Maybe<Chats_Employees>;
  chat_employee_id: Scalars['uuid']['output'];
  order?: Maybe<Orders>;
};

export enum AdCampaignModuleType {
  DisplayAd = 'DISPLAY_AD',
  PaidSearch = 'PAID_SEARCH',
  SampleRequest = 'SAMPLE_REQUEST'
}

export type AdEventInput = {
  ad_campaign_id: Scalars['uuid']['input'];
  ad_manager_id: Scalars['uuid']['input'];
  ad_module: AdCampaignModuleType;
  advertiser_id: Scalars['uuid']['input'];
  event_id: Scalars['uuid']['input'];
  gtin: Scalars['String']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type AddItemToSmartOrderResponse = {
  __typename?: 'AddItemToSmartOrderResponse';
  smart_order_search_input?: Maybe<Smart_Order_Search_Input>;
  smart_order_search_input_id: Scalars['uuid']['output'];
};

export type AdditionalInputValueInput = {
  id: Scalars['String']['input'];
  title: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Alert = {
  __typename?: 'Alert';
  alert_level: AlertLevel;
  alert_message: Scalars['String']['output'];
};

export enum AlertLevel {
  Info = 'INFO',
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE',
  Warning = 'WARNING'
}

export enum AllergenContainmentLevel {
  Contains = 'CONTAINS',
  DerivedFrom = 'DERIVED_FROM',
  FreeFrom = 'FREE_FROM',
  FreeFromNotTested = 'FREE_FROM_NOT_TESTED',
  MayContain = 'MAY_CONTAIN',
  NotDerivedFrom = 'NOT_DERIVED_FROM',
  Undeclared = 'UNDECLARED'
}

export type AllergenInput = {
  /** System or taxonomy code representing the allergen (e.g., 'PEA'). */
  code: Scalars['String']['input'];
  /** The containment level of the allergen (e.g., 'CONTAINS', 'DERIVED_FROM', 'FREE_FROM', 'FREE_FROM_NOT_TESTED', 'MAY_CONTAIN', 'NOT_DERIVED_FROM', 'UNDECLARED'). */
  containmentLevel?: AllergenContainmentLevel;
  /** Locale for the allergen label, formatted as a language-region code (e.g., 'en-US'). */
  locale?: Scalars['String']['input'];
  /** Human-readable name of the allergen (e.g., 'Peanuts'). */
  name: Scalars['String']['input'];
};

export type AllergenType = {
  __typename?: 'AllergenType';
  containmentLevel?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AllergenV2 = {
  __typename?: 'AllergenV2';
  /** System or taxonomy code representing the allergen (e.g., 'PEA'). */
  code: Scalars['String']['output'];
  /** The containment level of the allergen (e.g., 'CONTAINS', 'DERIVED_FROM', 'FREE_FROM', 'FREE_FROM_NOT_TESTED', 'MAY_CONTAIN', 'NOT_DERIVED_FROM', 'UNDECLARED'). */
  containmentLevel: AllergenContainmentLevel;
  /** Locale for the allergen label, formatted as a language-region code (e.g., 'en-US'). */
  locale: Scalars['String']['output'];
  /** Human-readable name of the allergen (e.g., 'Peanuts'). */
  name: Scalars['String']['output'];
};

export type AlternativeMatch = {
  variant_pack_uuid: Scalars['uuid']['input'];
};

export enum AnalyticsAlertActionType {
  Dismiss = 'DISMISS',
  Resolve = 'RESOLVE',
  Viewed = 'VIEWED'
}

export enum AnalyticsAlertDisplayType {
  BarGraph = 'BAR_GRAPH',
  Info = 'INFO',
  Table = 'TABLE'
}

export type AnalyticsAlertPayload = {
  __typename?: 'AnalyticsAlertPayload';
  display_data_json: Scalars['String']['output'];
  display_options_json: Scalars['String']['output'];
  display_type: AnalyticsAlertDisplayType;
};

export type AnalyticsAlertResponse = {
  __typename?: 'AnalyticsAlertResponse';
  payload: AnalyticsAlertPayload;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: AnalyticsAlertType;
  uuid: Scalars['uuid']['output'];
};

export enum AnalyticsAlertStatusType {
  Active = 'ACTIVE',
  Delete = 'DELETE',
  Hidden = 'HIDDEN'
}

export enum AnalyticsAlertType {
  ChurnRisk = 'CHURN_RISK',
  LostItem = 'LOST_ITEM',
  OrderAttention = 'ORDER_ATTENTION',
  OverduePayment = 'OVERDUE_PAYMENT'
}

export type AssignSmartOrderResponse = {
  __typename?: 'AssignSmartOrderResponse';
  smart_order?: Maybe<Smart_Order>;
  smart_order_id: Scalars['uuid']['output'];
};

export enum AutoPayBasedOn {
  DueDate = 'DUE_DATE',
  InvoiceDate = 'INVOICE_DATE'
}

export type AutoPayCustomer = {
  __typename?: 'AutoPayCustomer';
  account_id?: Maybe<Scalars['String']['output']>;
  auto_pay_settings?: Maybe<Auto_Pay_Settings>;
  chats: Array<AutoPayCustomerChat>;
  current_auto_pay_setting_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  payment_method?: Maybe<Scalars['String']['output']>;
  self_enrolled_via_restaurant_app: Scalars['Boolean']['output'];
  type: AutoPayCustomerType;
};

export type AutoPayCustomerChat = {
  __typename?: 'AutoPayCustomerChat';
  account_id?: Maybe<Scalars['String']['output']>;
  auto_pay_settings?: Maybe<Auto_Pay_Settings>;
  chat?: Maybe<Chats>;
  current_auto_pay_setting_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  payment_method?: Maybe<Scalars['String']['output']>;
  self_enrolled_via_restaurant_app: Scalars['Boolean']['output'];
  type: AutoPayCustomerType;
};

export enum AutoPayCustomerType {
  Chat = 'CHAT',
  PaymentGroup = 'PAYMENT_GROUP'
}

export type AutoPayFrequency = {
  __typename?: 'AutoPayFrequency';
  days_of_month: Array<Scalars['Int']['output']>;
  days_of_week: Array<Scalars['Int']['output']>;
  run_on_odd_weeks: Scalars['Boolean']['output'];
  type: FrequencySettingType;
};

export type AutoPayFrequencyInput = {
  days_of_month?: InputMaybe<Array<Scalars['Int']['input']>>;
  days_of_week?: InputMaybe<Array<Scalars['Int']['input']>>;
  run_on_odd_weeks?: InputMaybe<Scalars['Boolean']['input']>;
  type: FrequencySettingType;
};

export type AutoPayRunPreviewChatItem = {
  __typename?: 'AutoPayRunPreviewChatItem';
  chat?: Maybe<Chats>;
  chat_id: Scalars['uuid']['output'];
  credit_memos_to_use: Array<AutoPayRunPreviewCreditMemoItem>;
  default_payment_method_display_text?: Maybe<Scalars['String']['output']>;
  invoices_to_pay: Array<AutoPayRunPreviewInvoiceItem>;
  net_amount_in_micros: Scalars['Int']['output'];
};

export type AutoPayRunPreviewCreditMemoItem = {
  __typename?: 'AutoPayRunPreviewCreditMemoItem';
  credit_memo?: Maybe<Credit_Memos>;
  credit_memo_id: Scalars['uuid']['output'];
  current_balance_in_micros: Scalars['Int']['output'];
};

export type AutoPayRunPreviewInvoiceItem = {
  __typename?: 'AutoPayRunPreviewInvoiceItem';
  current_balance_in_micros: Scalars['Int']['output'];
  invoice_id: Scalars['uuid']['output'];
  order_invoice?: Maybe<Order_Invoices>;
};

export type AutoPayRunPreviewResponse = {
  __typename?: 'AutoPayRunPreviewResponse';
  auto_pay_settings?: Maybe<Auto_Pay_Settings>;
  auto_pay_settings_id: Scalars['uuid']['output'];
  auto_pay_settings_next_run: Scalars['String']['output'];
  chat_previews: Array<AutoPayRunPreviewChatItem>;
};

export type AutoPaySetting = {
  __typename?: 'AutoPaySetting';
  auto_enroll_with_payment_method: Scalars['Boolean']['output'];
  auto_pay_settings?: Maybe<Auto_Pay_Settings>;
  currency_code: Scalars['String']['output'];
  customer_count: Scalars['Int']['output'];
  email_reminder: Scalars['Boolean']['output'];
  estimated_next_run_total_in_micros?: Maybe<Scalars['bigint']['output']>;
  frequency: AutoPayFrequency;
  id: Scalars['uuid']['output'];
  is_visible_to_restaurants: Scalars['Boolean']['output'];
  lookback_period_days: Scalars['Int']['output'];
  max_amount_in_micros?: Maybe<Scalars['bigint']['output']>;
  name: Scalars['String']['output'];
  next_run: Scalars['String']['output'];
  pay_based_on: AutoPayBasedOn;
};

export type AutoPaySettingInput = {
  auto_enroll_with_payment_method?: InputMaybe<Scalars['Boolean']['input']>;
  email_reminder?: InputMaybe<Scalars['Boolean']['input']>;
  frequency: AutoPaySettingsFrequencyInput;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_visible_to_restaurants?: InputMaybe<Scalars['Boolean']['input']>;
  lookback_period_days?: InputMaybe<Scalars['Int']['input']>;
  max_amount_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pay_based_on?: InputMaybe<AutoPayBasedOn>;
};

export type AutoPaySettingV2Input = {
  auto_enroll_with_payment_method: Scalars['Boolean']['input'];
  email_reminder: Scalars['Boolean']['input'];
  frequency: AutoPayFrequencyInput;
  is_visible_to_restaurants: Scalars['Boolean']['input'];
  lookback_period_days: Scalars['Int']['input'];
  max_amount_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  name: Scalars['String']['input'];
  pay_based_on: AutoPayBasedOn;
  supplier_id: Scalars['uuid']['input'];
};

export type AutoPaySettingsFrequencyInput = {
  day_of_month?: InputMaybe<Scalars['Int']['input']>;
  day_of_week?: InputMaybe<Scalars['Int']['input']>;
  type: FrequencySettingType;
};

export type AutoPaySettingsResponse = {
  __typename?: 'AutoPaySettingsResponse';
  auto_pay_settings?: Maybe<Auto_Pay_Settings>;
  auto_pay_settings_id: Scalars['uuid']['output'];
  auto_pay_settings_next_run: Scalars['String']['output'];
};

export type AutoPayStatusResponse = {
  __typename?: 'AutoPayStatusResponse';
  auto_payment?: Maybe<Auto_Payments>;
  auto_payments_id?: Maybe<Scalars['uuid']['output']>;
  show_error_banner: Scalars['Boolean']['output'];
};

export type AutoPaySupplier = {
  __typename?: 'AutoPaySupplier';
  business?: Maybe<Businesses>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
};

export type BaseHubCardData = {
  __typename?: 'BaseHubCardData';
  card_type: HubCardType;
  description?: Maybe<CompleteTranslation>;
  subtitle: CompleteTranslation;
  title: CompleteTranslation;
};

export type BaseSalesAlertAccountViewData = {
  __typename?: 'BaseSalesAlertAccountViewData';
  alert_status: AnalyticsAlertStatusType;
  alert_type: AnalyticsAlertType;
  chat_uuid: Scalars['String']['output'];
  restaurant_uuid: Scalars['String']['output'];
  subtitle: CompleteTranslation;
  supplier_uuid: Scalars['String']['output'];
  title: CompleteTranslation;
};

export type BaseSalesAlertHubCardData = {
  __typename?: 'BaseSalesAlertHubCardData';
  alert_status: AnalyticsAlertStatusType;
  alert_uuid: Scalars['String']['output'];
  card_type: HubCardType;
  chat_uuid: Scalars['String']['output'];
  description?: Maybe<CompleteTranslation>;
  restaurant_uuid: Scalars['String']['output'];
  subtitle: CompleteTranslation;
  supplier_uuid: Scalars['String']['output'];
  title: CompleteTranslation;
};

export type BasicInformationType = {
  __typename?: 'BasicInformationType';
  additionalInformation: Array<GenericAttributeType>;
  descriptions: Array<GenericAttributeType>;
  names: Array<GenericAttributeType>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type BrandInformationType = {
  __typename?: 'BrandInformationType';
  additionalInformation: Array<GenericAttributeType>;
  brandName?: Maybe<Scalars['String']['output']>;
  brandOwner?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  subBrandName?: Maybe<Scalars['String']['output']>;
};

export type BulkCreateMediaInput = {
  items: Array<CreateMediaInput>;
};

export type BulkCreateMediaPayload = {
  __typename?: 'BulkCreateMediaPayload';
  results: Array<CreateMediaPayload>;
  userErrors: Array<Error>;
};

export type BusinessDetailsResponse = {
  __typename?: 'BusinessDetailsResponse';
  hours?: Maybe<Array<OpenHours>>;
  menu_items?: Maybe<Array<MenuItem>>;
  phone_number?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<Businesses>;
  restaurant_id: Scalars['uuid']['output'];
};

export type BusinessOpenHoursDetailsInput = {
  day: Scalars['Int']['input'];
  end: Scalars['String']['input'];
  is_overnight: Scalars['Boolean']['input'];
  start: Scalars['String']['input'];
};

export type BusinessOpenHoursInput = {
  hour_type: Scalars['String']['input'];
  is_open_now: Scalars['Boolean']['input'];
  open: Array<BusinessOpenHoursDetailsInput>;
};

export type BusinessSearchResponse = {
  __typename?: 'BusinessSearchResponse';
  business_display_address: Scalars['String']['output'];
  business_name: Scalars['String']['output'];
  categories?: Maybe<Array<Scalars['String']['output']>>;
  display_phone_number: Scalars['String']['output'];
  distance?: Maybe<Scalars['Float']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  phone_number: Scalars['String']['output'];
  rating?: Maybe<Scalars['String']['output']>;
  restaurant_uuid?: Maybe<Scalars['String']['output']>;
  review_count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ChatStatus>;
  supplier_uuid?: Maybe<Scalars['String']['output']>;
  yelp_business_id: Scalars['String']['output'];
};

export type CrmActivitiesPage = {
  __typename?: 'CRMActivitiesPage';
  activities: Array<CrmActivity>;
  cursor?: Maybe<Scalars['uuid']['output']>;
};

export type CrmActivity = {
  __typename?: 'CRMActivity';
  check_in?: Maybe<CrmActivityCheckIn>;
  created_at: Scalars['String']['output'];
  created_by_name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<CrmActivityNote>;
  reminder?: Maybe<CrmActivityReminder>;
  uuid: Scalars['uuid']['output'];
};

export type CrmActivityCheckIn = {
  __typename?: 'CRMActivityCheckIn';
  interactions: Array<CrmCheckInInteraction>;
};

export type CrmActivityCheckInInput = {
  interactions: Array<CrmCheckInInteraction>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type CrmActivityNote = {
  __typename?: 'CRMActivityNote';
  content: Scalars['String']['output'];
};

export type CrmActivityNoteInput = {
  content: Scalars['String']['input'];
};

export type CrmActivityReminder = {
  __typename?: 'CRMActivityReminder';
  message: Scalars['String']['output'];
  remind_at: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
};

export type CrmActivityReminderInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  remind_at: Scalars['String']['input'];
};

export enum CrmCheckInInteraction {
  Closed = 'CLOSED',
  Merchandising = 'MERCHANDISING',
  Payment = 'PAYMENT',
  PlacedOrder = 'PLACED_ORDER',
  Return = 'RETURN',
  Visited = 'VISITED'
}

export enum CardFundingSource {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Prepaid = 'PREPAID'
}

export type CartDetailsInput = {
  currency_code?: InputMaybe<Scalars['String']['input']>;
  pack_price_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  pack_tax_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  quantity: Scalars['Int']['input'];
};

export enum CartUpdateError {
  CartNotFound = 'CART_NOT_FOUND',
  InvalidCartData = 'INVALID_CART_DATA',
  UnexpectedException = 'UNEXPECTED_EXCEPTION'
}

export type CategoryType = {
  __typename?: 'CategoryType';
  level?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** A variant pack to refresh and the time its served data changed. */
export type ChangedVariantPack = {
  __typename?: 'ChangedVariantPack';
  /** When this variant pack's served data changed. */
  publishedAt: Scalars['DateTime']['output'];
  /** The variant pack to refresh. */
  variantPackId: Scalars['uuid']['output'];
};

/** A position in the distributor-item change log. Pass it back unchanged as `after` to resume from that position. */
export type ChangedVariantPacksCursor = {
  __typename?: 'ChangedVariantPacksCursor';
  /** The tie-breaker when rows share a `publishedAt`. This is a distributor item ID, not a variant pack ID. */
  distributorItemId: Scalars['uuid']['output'];
  /** The change time at this cursor position. */
  publishedAt: Scalars['DateTime']['output'];
};

/** The `nextCursor` from the previous page. To start from a specific time, use that time with `00000000-0000-0000-0000-000000000000` as `distributorItemId`; this includes all rows at that time. */
export type ChangedVariantPacksCursorInput = {
  /** The distributor-item tie-breaker from the previous `nextCursor`. */
  distributorItemId: Scalars['uuid']['input'];
  /** The change time from which to resume. */
  publishedAt: Scalars['DateTime']['input'];
};

/** One page of the change feed, oldest change first. */
export type ChangedVariantPacksPage = {
  __typename?: 'ChangedVariantPacksPage';
  /** The newest `publishedAt` this read would accept. When `hasMore` is false, this page and `nextCursor` are caught up through this time. */
  completeThrough: Scalars['DateTime']['output'];
  /** True when this read returned `limit` change-log rows. A final full page can therefore be followed by an empty page. Later writes can appear after this returns false. */
  hasMore: Scalars['Boolean']['output'];
  /** Variant packs to refresh, including ones marked deleted. A page can contain no variant packs after consuming distributor-item changes, so use `nextCursor` and `hasMore` to track progress. No deletion flag is included. */
  items: Array<ChangedVariantPack>;
  /** Persist this value and pass it back as `after`. An empty page echoes the input cursor. This is null only when the initial read finds no changes. */
  nextCursor?: Maybe<ChangedVariantPacksCursor>;
};

export type ChatProspectAutoFillBigIntField = {
  __typename?: 'ChatProspectAutoFillBigIntField';
  confidence?: Maybe<Scalars['Float']['output']>;
  filled_at: Scalars['String']['output'];
  source: ProspectAutoFillSource;
  value?: Maybe<Scalars['bigint']['output']>;
};

export type ChatProspectAutoFillStringField = {
  __typename?: 'ChatProspectAutoFillStringField';
  confidence?: Maybe<Scalars['Float']['output']>;
  filled_at: Scalars['String']['output'];
  source: ProspectAutoFillSource;
  value?: Maybe<Scalars['String']['output']>;
};

export type ChatProspectAutoFillStringListField = {
  __typename?: 'ChatProspectAutoFillStringListField';
  confidence?: Maybe<Scalars['Float']['output']>;
  filled_at: Scalars['String']['output'];
  source: ProspectAutoFillSource;
  value?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ChatProspectProcessingStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum ChatProspectStage {
  Cold = 'COLD',
  Discovery = 'DISCOVERY',
  Engaged = 'ENGAGED',
  New = 'NEW',
  Quote = 'QUOTE',
  Won = 'WON'
}

export enum ChatStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  New = 'NEW',
  Prospect = 'PROSPECT'
}

export type ChatbotMessage = {
  __typename?: 'ChatbotMessage';
  id: Scalars['String']['output'];
  role: ChatbotMessageRole;
  text: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export enum ChatbotMessageRole {
  Chatbot = 'CHATBOT',
  User = 'USER'
}

export type CheckInOrderInvoiceItemQuantityInput = {
  final_quantity?: InputMaybe<Scalars['Int']['input']>;
  order_invoice_check_in_item_id: Scalars['uuid']['input'];
  quantity: Scalars['Int']['input'];
};

export type CheckInOrderInvoiceItemsResponse = {
  __typename?: 'CheckInOrderInvoiceItemsResponse';
  order_invoice_check_in_item?: Maybe<Order_Invoice_Check_In_Items>;
  order_invoice_check_in_item_id: Scalars['uuid']['output'];
};

export type ChurnRiskAccountViewData = {
  __typename?: 'ChurnRiskAccountViewData';
  alert_status: AnalyticsAlertStatusType;
  alert_type: AnalyticsAlertType;
  alert_uuid: Scalars['String']['output'];
  chat_uuid: Scalars['String']['output'];
  restaurant_uuid: Scalars['String']['output'];
  subtitle: CompleteTranslation;
  supplier_uuid: Scalars['String']['output'];
  title: CompleteTranslation;
};

export type ChurnRiskHubCardData = {
  __typename?: 'ChurnRiskHubCardData';
  alert_status: AnalyticsAlertStatusType;
  alert_uuid: Scalars['String']['output'];
  card_type: HubCardType;
  chat_uuid: Scalars['String']['output'];
  description?: Maybe<CompleteTranslation>;
  restaurant_uuid: Scalars['String']['output'];
  subtitle: CompleteTranslation;
  supplier_uuid: Scalars['String']['output'];
  title: CompleteTranslation;
};

export type ClearItemSubstitutionResponse = {
  __typename?: 'ClearItemSubstitutionResponse';
  order?: Maybe<Orders>;
  order_id: Scalars['uuid']['output'];
};

export type CollectedManualPayment = {
  __typename?: 'CollectedManualPayment';
  collected_date: Scalars['String']['output'];
  credit_memos_count: Scalars['Int']['output'];
  invoices_count: Scalars['Int']['output'];
  paid_source: PaidSource;
  payment_batch?: Maybe<Payment_Batches>;
  payment_batch_id: Scalars['uuid']['output'];
  payment_method_display_text?: Maybe<Scalars['String']['output']>;
  total_amount_in_micros: Scalars['bigint']['output'];
};

export type CompetitorLineItemInput = {
  item_name: Scalars['String']['input'];
  pack_price_in_micros: Scalars['bigint']['input'];
  pack_size?: InputMaybe<Scalars['String']['input']>;
};

export type CompleteTranslation = {
  __typename?: 'CompleteTranslation';
  en: Scalars['String']['output'];
  es: Scalars['String']['output'];
  fr: Scalars['String']['output'];
  zh: Scalars['String']['output'];
};

export type CompositionInput = {
  /** List of hazards or warnings associated with the product. */
  hazards?: Array<CompositionItemInput>;
  /** List of substances that make up the product. */
  substances?: Array<CompositionItemInput>;
  /** Sustainability attributes or certifications for the product. */
  sustainability?: Array<CompositionItemInput>;
};

export type CompositionItemInput = {
  /** Locale of the composition item (e.g., 'en-US'). */
  locale?: Scalars['String']['input'];
  /** Name of the substance, hazard, or sustainability attribute. */
  name: Scalars['String']['input'];
  /** Additional metadata as key-value pairs. */
  parameters?: Array<ParameterInput>;
};

export type CompositionItemType = {
  __typename?: 'CompositionItemType';
  /** Locale of the composition item (e.g., 'en-US'). */
  locale: Scalars['String']['output'];
  /** Name of the substance, hazard, or sustainability attribute. */
  name: Scalars['String']['output'];
  /** Additional metadata as key-value pairs. */
  parameters: Array<ParameterType>;
};

export type CompositionType = {
  __typename?: 'CompositionType';
  /** List of hazards or warnings associated with the product. */
  hazards: Array<CompositionItemType>;
  /** List of substances that make up the product. */
  substances: Array<CompositionItemType>;
  /** Sustainability attributes or certifications for the product. */
  sustainability: Array<CompositionItemType>;
};

export type ConfirmKlarnaPaymentResponse = {
  __typename?: 'ConfirmKlarnaPaymentResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  payment_batch?: Maybe<Payment_Batches>;
  payment_batch_id?: Maybe<Scalars['uuid']['output']>;
};

export type ContactInfoInput = {
  disable_default_notifications?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  login_email?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
};

export enum CostChangeLookbackMode {
  CompletedWeek = 'COMPLETED_WEEK',
  LastChange = 'LAST_CHANGE',
  RollingWindow = 'ROLLING_WINDOW'
}

export type CreateActivityReminderResponse = {
  __typename?: 'CreateActivityReminderResponse';
  activity_id: Scalars['uuid']['output'];
  crm_activity?: Maybe<Crm_Activities>;
  crm_activity_reminder?: Maybe<Crm_Activity_Reminders>;
  reminder_id: Scalars['uuid']['output'];
};

export type CreateAutoPaySettingResponse = {
  __typename?: 'CreateAutoPaySettingResponse';
  auto_pay_setting_id: Scalars['uuid']['output'];
  auto_pay_settings?: Maybe<Auto_Pay_Settings>;
};

export type CreateCrmActivityResponse = {
  __typename?: 'CreateCRMActivityResponse';
  activity_id: Scalars['uuid']['output'];
};

export type CreateCreditRequestBatchResponse = {
  __typename?: 'CreateCreditRequestBatchResponse';
  alerts: Array<CreditRequestAlert>;
  credit_request_batch?: Maybe<Credit_Request_Batches>;
  credit_request_batch_id?: Maybe<Scalars['uuid']['output']>;
  credit_request_batch_ids: Array<Scalars['uuid']['output']>;
};

export type CreateDefaultOrderGuideRecordsResponse = {
  __typename?: 'CreateDefaultOrderGuideRecordsResponse';
  collection_id: Scalars['uuid']['output'];
  order_guide_restaurant_collection?: Maybe<Order_Guide_Restaurant_Collection>;
  order_guide_restaurant_partition?: Maybe<Order_Guide_Restaurant_Partition>;
  partition_id: Scalars['uuid']['output'];
};

export type CreateFtniPaymentSessionResponse = {
  __typename?: 'CreateFTNIPaymentSessionResponse';
  payment_amount_in_micros: Scalars['bigint']['output'];
  payment_endpoint_url: Scalars['String']['output'];
  session_id: Scalars['String']['output'];
  webhook_url: Scalars['String']['output'];
};

export type CreateGhostMessageResponse = {
  __typename?: 'CreateGhostMessageResponse';
  ghost_message?: Maybe<Ghost_Messages>;
  ghost_message_id: Scalars['uuid']['output'];
};

export type CreateMediaInput = {
  collection: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  mediaType: Scalars['String']['input'];
  override?: Scalars['Boolean']['input'];
  supplierId?: InputMaybe<Scalars['String']['input']>;
  uris: Array<Scalars['String']['input']>;
};

export type CreateMediaPayload = {
  __typename?: 'CreateMediaPayload';
  media?: Maybe<MediaEntry>;
  userErrors: Array<Error>;
};

export type CreateMobileTerminalPaymentCreditMemoInput = {
  amount_in_micros: Scalars['bigint']['input'];
  credit_memo_id?: InputMaybe<Scalars['uuid']['input']>;
  credit_memo_number: Scalars['String']['input'];
  restaurant_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type CreateMobileTerminalPaymentInvoiceInput = {
  amount_in_micros: Scalars['bigint']['input'];
  invoice_id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_number: Scalars['String']['input'];
  restaurant_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type CreateMobileTerminalPaymentRequestResponse = {
  __typename?: 'CreateMobileTerminalPaymentRequestResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  nexo_request?: Maybe<Scalars['String']['output']>;
  payment_batch?: Maybe<Payment_Batches>;
  payment_batch_id?: Maybe<Scalars['uuid']['output']>;
};

export type CreateNoteAcitivityResponse = {
  __typename?: 'CreateNoteAcitivityResponse';
  activity_id: Scalars['uuid']['output'];
  crm_activity?: Maybe<Crm_Activities>;
};

export type CreateOrUpdatePaymentPlanResponse = {
  __typename?: 'CreateOrUpdatePaymentPlanResponse';
  payment_plan?: Maybe<Payment_Plans>;
  payment_plan_id: Scalars['uuid']['output'];
};

export type CreateOrderGuideFromGeneratedMenuItemsResponse = {
  __typename?: 'CreateOrderGuideFromGeneratedMenuItemsResponse';
  order_guide_collection_uuid: Scalars['uuid']['output'];
  order_guide_partition_uuid: Scalars['uuid']['output'];
};

export type CreateOrderGuideFromMenuResponse = {
  __typename?: 'CreateOrderGuideFromMenuResponse';
  order_guide_collection_uuid: Scalars['uuid']['output'];
  order_guide_partition_uuid: Scalars['uuid']['output'];
};

export type CreateOrderInvoiceCheckInItemIssueResponse = {
  __typename?: 'CreateOrderInvoiceCheckInItemIssueResponse';
  order_invoice_check_in_item?: Maybe<Order_Invoice_Check_In_Items>;
  order_invoice_check_in_item_id: Scalars['uuid']['output'];
  order_invoice_check_in_item_issue?: Maybe<Order_Invoice_Check_In_Item_Issues>;
  order_invoice_check_in_item_issue_id: Scalars['uuid']['output'];
};

export type CreateOverrideInput = {
  collection: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  field: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type CreateOverridePayload = {
  __typename?: 'CreateOverridePayload';
  override?: Maybe<OverrideEntry>;
  userErrors: Array<Error>;
};

export type CreatePriceQuoteFromVariantPacksResponse = {
  __typename?: 'CreatePriceQuoteFromVariantPacksResponse';
  price_quote_id: Scalars['uuid']['output'];
};

export type CreateSearchTermCorrectionResponse = {
  __typename?: 'CreateSearchTermCorrectionResponse';
  search_term_correction_id: Scalars['uuid']['output'];
  smart_order_search_term_correction?: Maybe<Smart_Order_Search_Term_Corrections>;
};

export type CreateUpdateAutoPaySettingsResponse = {
  __typename?: 'CreateUpdateAutoPaySettingsResponse';
  auto_pay_settings?: Maybe<Auto_Pay_Settings>;
  auto_pay_settings_id: Scalars['uuid']['output'];
};

export type CreateUpdatePaymentStatementEmailSettingsResponse = {
  __typename?: 'CreateUpdatePaymentStatementEmailSettingsResponse';
  payment_statement_email_settings_id: Scalars['uuid']['output'];
};

export type CreatedCreditMemoResponse = {
  __typename?: 'CreatedCreditMemoResponse';
  amount_in_micros: Scalars['bigint']['output'];
  id: Scalars['uuid']['output'];
  reference: Scalars['String']['output'];
};

export type CreatedOrderInvoiceResponse = {
  __typename?: 'CreatedOrderInvoiceResponse';
  amount_in_micros: Scalars['bigint']['output'];
  id: Scalars['uuid']['output'];
  reference: Scalars['String']['output'];
};

export enum CreationSourceFeatures {
  AppReview = 'APP_REVIEW',
  Custom = 'CUSTOM',
  LeadGenerator = 'LEAD_GENERATOR'
}

export type CreditMemo = {
  __typename?: 'CreditMemo';
  credit_amount_in_micros: Scalars['bigint']['output'];
  credit_date?: Maybe<Scalars['String']['output']>;
  credit_id: Scalars['uuid']['output'];
  credit_line_items: Array<CreditMemoLineItem>;
  credit_number: Scalars['String']['output'];
  currency_code: Scalars['String']['output'];
  has_payment_link: Scalars['Boolean']['output'];
};

export type CreditMemoAmountInput = {
  amount_in_micros: Scalars['bigint']['input'];
  credit_memo_id: Scalars['uuid']['input'];
};

export type CreditMemoInput = {
  amount_in_micros: Scalars['bigint']['input'];
  credit_memo_id: Scalars['String']['input'];
  credit_memo_number: Scalars['String']['input'];
  restaurant_id: Scalars['String']['input'];
};

export type CreditMemoLineItem = {
  __typename?: 'CreditMemoLineItem';
  item_code: Scalars['String']['output'];
  item_name: Scalars['String']['output'];
  pack_unit?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  unit_price_in_micros: Scalars['bigint']['output'];
  unit_tax_in_micros: Scalars['bigint']['output'];
};

export type CreditMemoToCreateInput = {
  amount_in_micros: Scalars['bigint']['input'];
  reference: Scalars['String']['input'];
};

export type CreditRequestAlert = {
  __typename?: 'CreditRequestAlert';
  alert_level: AlertLevel;
  alert_message: Scalars['String']['output'];
  ineligible_variant_pack_ids: Array<Scalars['uuid']['output']>;
};

export type CreditRequestBatchLineItemInput = {
  credit_request_reason_id: Scalars['uuid']['input'];
  custom_properties?: InputMaybe<Array<CreditRequestCustomPropertyInput>>;
  notes: Scalars['String']['input'];
  order_invoice_id?: InputMaybe<Scalars['uuid']['input']>;
  pack_price_in_micros: Scalars['bigint']['input'];
  photo_url_list?: InputMaybe<Array<Scalars['String']['input']>>;
  quantity: Scalars['Int']['input'];
  uom_override?: InputMaybe<Scalars['String']['input']>;
  variant_pack_id: Scalars['uuid']['input'];
};

export type CreditRequestCustomPropertyInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CreditRequestReasonResponse = {
  __typename?: 'CreditRequestReasonResponse';
  credit_request_reason?: Maybe<Credit_Request_Reasons>;
  credit_request_reason_id: Scalars['uuid']['output'];
};

export type CurrentOrdersHubCardData = {
  __typename?: 'CurrentOrdersHubCardData';
  card_data: Array<CurrentOrdersHubCardDataItem>;
  card_type: HubCardType;
  description?: Maybe<CompleteTranslation>;
  subtitle: CompleteTranslation;
  title: CompleteTranslation;
};

export type CurrentOrdersHubCardDataItem = {
  __typename?: 'CurrentOrdersHubCardDataItem';
  chat_uuid: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  description: CompleteTranslation;
  invoice_uuid?: Maybe<Scalars['String']['output']>;
  is_draft_order: Scalars['Boolean']['output'];
  item_count_display?: Maybe<CompleteTranslation>;
  operator_employees?: Maybe<Array<OperatorEmployeeContact>>;
  order_amount_in_micros?: Maybe<Scalars['Int']['output']>;
  order_status: Scalars['String']['output'];
  order_uuid?: Maybe<Scalars['String']['output']>;
  ordered_by_user_phone_number?: Maybe<Scalars['String']['output']>;
  ordered_by_user_uuid?: Maybe<Scalars['String']['output']>;
  restaurant_name: Scalars['String']['output'];
  restaurant_name_i18n: CompleteTranslation;
  restaurant_uuid: Scalars['String']['output'];
  supplier_uuid: Scalars['String']['output'];
};

export type CustomerDetailHeader = {
  __typename?: 'CustomerDetailHeader';
  gross_profit_in_micros_total: Scalars['Int']['output'];
  line_items_total: Scalars['Float']['output'];
  margin_percentage?: Maybe<Scalars['Float']['output']>;
  order_count: Scalars['Float']['output'];
  pending_edits_count: Scalars['Int']['output'];
  pending_recommendations_count: Scalars['Int']['output'];
  price_floor_enabled: Scalars['Boolean']['output'];
  price_floor_mode?: Maybe<VariantPackCostType>;
  restaurant?: Maybe<Businesses>;
  restaurant_account_id?: Maybe<Scalars['String']['output']>;
  restaurant_id: Scalars['uuid']['output'];
  revenue_in_micros_total: Scalars['Int']['output'];
};

export type CustomerDetailRow = {
  __typename?: 'CustomerDetailRow';
  base_unit?: Maybe<Scalars['String']['output']>;
  bookmark_note?: Maybe<Scalars['String']['output']>;
  bookmarked_at?: Maybe<Scalars['String']['output']>;
  cost_in_micros_delta: Scalars['Int']['output'];
  current_cost_in_micros?: Maybe<Scalars['Int']['output']>;
  current_margin_percentage?: Maybe<Scalars['Float']['output']>;
  current_price_in_micros?: Maybe<Scalars['Int']['output']>;
  gross_margin_delta_in_micros: Scalars['Int']['output'];
  gross_profit_in_micros_total: Scalars['Int']['output'];
  gross_profit_per_unit_in_micros?: Maybe<Scalars['Int']['output']>;
  invoice_history: Array<DetailVariantPackInvoiceHistoryEntry>;
  last_cost_in_micros?: Maybe<Scalars['Int']['output']>;
  last_margin_percentage?: Maybe<Scalars['Float']['output']>;
  last_price_in_micros?: Maybe<Scalars['Int']['output']>;
  last_sale_date?: Maybe<Scalars['String']['output']>;
  line_items_total: Scalars['Float']['output'];
  previous_margin_percentage?: Maybe<Scalars['Float']['output']>;
  price_edit_display_info: Array<PriceEditDisplayInfoDetail>;
  price_in_micros_delta: Scalars['Int']['output'];
  restaurant?: Maybe<Businesses>;
  restaurant_id: Scalars['uuid']['output'];
  revenue_in_micros_total: Scalars['Int']['output'];
  supplier_id: Scalars['uuid']['output'];
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
  weekly_purchase_quantities: Array<WeeklyPurchaseQuantity>;
};

export type CustomerRow = {
  __typename?: 'CustomerRow';
  employee?: Maybe<Employees>;
  gross_profit_in_micros_total: Scalars['Int']['output'];
  last_invoice_date?: Maybe<Scalars['String']['output']>;
  line_items_total: Scalars['Float']['output'];
  margin_percentage?: Maybe<Scalars['Float']['output']>;
  order_count: Scalars['Float']['output'];
  pending_edits_count: Scalars['Int']['output'];
  pending_recommendations_count: Scalars['Int']['output'];
  restaurant?: Maybe<Businesses>;
  restaurant_id: Scalars['uuid']['output'];
  restaurant_name: Scalars['String']['output'];
  restaurant_segment?: Maybe<Scalars['String']['output']>;
  revenue_in_micros_total: Scalars['Int']['output'];
  sales_rep_id?: Maybe<Scalars['uuid']['output']>;
  sales_rep_name?: Maybe<Scalars['String']['output']>;
  supplier_id: Scalars['uuid']['output'];
};

export type DateFilterInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export enum DaysOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DeleteAutoPaySettingResponse = {
  __typename?: 'DeleteAutoPaySettingResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteIdentifierInput = {
  collection: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  supplierId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteIdentifierPayload = {
  __typename?: 'DeleteIdentifierPayload';
  deleted: Scalars['Boolean']['output'];
  userErrors: Array<Error>;
};

export type DeleteMediaInput = {
  collection: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  mediaType?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  uris?: Array<Scalars['String']['input']>;
};

export type DeleteMediaPayload = {
  __typename?: 'DeleteMediaPayload';
  deletedCount: Scalars['Int']['output'];
  userErrors: Array<Error>;
};

export type DeletePriceQuoteResponse = {
  __typename?: 'DeletePriceQuoteResponse';
  success: Scalars['Boolean']['output'];
};

export type DeletePricingBookmarkEntryInput = {
  restaurant_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};

export type DeletePricingBookmarksResponse = {
  __typename?: 'DeletePricingBookmarksResponse';
  deleted_count: Scalars['Int']['output'];
};

export type DepositManualPaymentsResponse = {
  __typename?: 'DepositManualPaymentsResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  manual_deposit_id?: Maybe<Scalars['uuid']['output']>;
};

export type DetailVariantPackCostChange = {
  __typename?: 'DetailVariantPackCostChange';
  base_unit?: Maybe<Scalars['String']['output']>;
  bookmark_note?: Maybe<Scalars['String']['output']>;
  bookmarked_at?: Maybe<Scalars['String']['output']>;
  cost_in_micros?: Maybe<Scalars['Int']['output']>;
  cost_in_micros_delta?: Maybe<Scalars['Int']['output']>;
  gross_margin_delta_in_micros?: Maybe<Scalars['Int']['output']>;
  gross_profit_percentage?: Maybe<Scalars['Float']['output']>;
  groups: Array<VariantPackGroupMembership>;
  invoice_history?: Maybe<Array<DetailVariantPackInvoiceHistoryEntry>>;
  is_locked?: Maybe<Scalars['Boolean']['output']>;
  monthly_quantity: Scalars['Int']['output'];
  price_edit_display_headers?: Maybe<Array<PriceEditDisplayHeader>>;
  price_floor_enabled: Scalars['Boolean']['output'];
  price_floor_mode?: Maybe<VariantPackCostType>;
  price_in_micros?: Maybe<Scalars['Int']['output']>;
  price_in_micros_delta?: Maybe<Scalars['Int']['output']>;
  pricing_peer_group?: Maybe<PricingPeerGroup>;
  restaurant?: Maybe<Businesses>;
  restaurant_account_id?: Maybe<Scalars['String']['output']>;
  restaurant_id: Scalars['uuid']['output'];
  supplier_display_info?: Maybe<Array<PriceEditDisplayInfoDetail>>;
  supplier_id: Scalars['uuid']['output'];
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
  weekly_purchase_quantities: Array<WeeklyPurchaseQuantity>;
  weekly_quantity: Scalars['Float']['output'];
};

export type DetailVariantPackInvoiceHistoryEntry = {
  __typename?: 'DetailVariantPackInvoiceHistoryEntry';
  gross_margin_percentage?: Maybe<Scalars['Float']['output']>;
  invoice_date: Scalars['String']['output'];
  price_in_micros: Scalars['Int']['output'];
  quantity: Scalars['Float']['output'];
};

export type DeviceTrackingHasuraInput = {
  app_bundle_id: Scalars['String']['input'];
  app_version: Scalars['String']['input'];
  device_model: Scalars['String']['input'];
  device_system_name: Scalars['String']['input'];
  device_system_version: Scalars['String']['input'];
  vendor: Scalars['String']['input'];
};

export type DietaryInformationType = {
  __typename?: 'DietaryInformationType';
  additionalInformation: Array<GenericAttributeType>;
  allergens: Array<AllergenType>;
  dietTypes: Array<GenericAttributeType>;
  ingredients: Array<Scalars['String']['output']>;
  microbes: Array<MicrobeType>;
  nutrients: Array<NutrientType>;
};

export type DisplayAdContentEventData = {
  __typename?: 'DisplayAdContentEventData';
  click_event_id: Scalars['String']['output'];
  impression_event_id: Scalars['String']['output'];
};

export type DisplayAdEventContent = {
  __typename?: 'DisplayAdEventContent';
  banner_image_url: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  desktop_banner_image_url?: Maybe<Scalars['String']['output']>;
  event_data: DisplayAdContentEventData;
  logo_image_url?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DisplayAdVariantPackEventData = {
  __typename?: 'DisplayAdVariantPackEventData';
  add_to_cart_event_id: Scalars['String']['output'];
  click_event_id: Scalars['String']['output'];
  impression_event_id: Scalars['String']['output'];
  purchase_event_id: Scalars['String']['output'];
};

export enum DisplayConfigCategory {
  Custom = 'CUSTOM',
  Inventory = 'INVENTORY',
  Pricing = 'PRICING'
}

export enum DocumentCollection {
  Override = 'OVERRIDE',
  Source = 'SOURCE',
  Split = 'SPLIT'
}

export type DocumentIdentifierInput = {
  docId?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  vpId?: InputMaybe<Scalars['String']['input']>;
};

export type DsrAnalyticsModelsAggregated = {
  __typename?: 'DsrAnalyticsModelsAggregated';
  base_hub_card?: Maybe<BaseHubCardData>;
  base_sales_alert_account_view?: Maybe<BaseSalesAlertAccountViewData>;
  base_sales_alert_hub_card?: Maybe<BaseSalesAlertHubCardData>;
  churn_risk_account_view?: Maybe<ChurnRiskAccountViewData>;
  churn_risk_hub_card?: Maybe<ChurnRiskHubCardData>;
  current_orders_hub_card?: Maybe<CurrentOrdersHubCardData>;
  lost_item_account_view?: Maybe<LostItemAccountViewData>;
  lost_item_hub_card?: Maybe<LostItemHubCardData>;
  lowest_performing_customers_hub_card?: Maybe<LowestPerformingCustomersHubCardData>;
  monthly_commissions_hub_card?: Maybe<MonthlyCommissionsHubCardData>;
  operator_employee_contact?: Maybe<OperatorEmployeeContact>;
  order_attention_hub_card?: Maybe<OrderAttentionAlertHubCardData>;
  overdue_payment_account_view?: Maybe<OverduePaymentAccountViewData>;
  overdue_payment_hub_card?: Maybe<OverduePaymentHubCardData>;
  weekly_profit_rollup_hub_card?: Maybe<WeeklyProfitRollupHubCardData>;
};

export type DuplicateMenuItemOutput = {
  __typename?: 'DuplicateMenuItemOutput';
  menu_item?: Maybe<Menu_Items>;
  menu_item_id: Scalars['uuid']['output'];
};

export type EditIngredientFields = {
  base_unit?: InputMaybe<Scalars['String']['input']>;
  cost_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  ingredient_name?: InputMaybe<Scalars['String']['input']>;
  pack_unit?: InputMaybe<Scalars['String']['input']>;
  unit_count?: InputMaybe<Scalars['Float']['input']>;
};

export type EmployeeResponse = {
  __typename?: 'EmployeeResponse';
  employee?: Maybe<Employees>;
  employee_id: Scalars['uuid']['output'];
};

export enum EmployeeRole {
  Admin = 'ADMIN',
  Cashier = 'CASHIER',
  Dsm = 'DSM',
  SupplierDefault = 'SUPPLIER_DEFAULT',
  User = 'USER'
}

export enum EmployeeStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  Pending = 'PENDING',
  Unverified = 'UNVERIFIED'
}

export type Error = {
  __typename?: 'Error';
  field: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type EstablishMobileTerminalSessionResponse = {
  __typename?: 'EstablishMobileTerminalSessionResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  installation_id?: Maybe<Scalars['String']['output']>;
  sdk_data?: Maybe<Scalars['String']['output']>;
};

export type ExpandedGtinMetadataData = {
  __typename?: 'ExpandedGtinMetadataData';
  gtin?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  uuid: Scalars['uuid']['output'];
};

export type ExpandedItemData = {
  __typename?: 'ExpandedItemData';
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  extra_keywords?: Maybe<Scalars['String']['output']>;
  photo_url_list?: Maybe<Array<Scalars['String']['output']>>;
  restaurant_item_overrides: Array<ExpandedRestaurantItemOverrideData>;
  uuid: Scalars['uuid']['output'];
};

export type ExpandedModifierOptionData = {
  __typename?: 'ExpandedModifierOptionData';
  modifier_option_group?: Maybe<ExpandedModifierOptionGroupData>;
  name?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['uuid']['output'];
};

export type ExpandedModifierOptionGroupData = {
  __typename?: 'ExpandedModifierOptionGroupData';
  name?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['uuid']['output'];
};

export type ExpandedPackData = {
  __typename?: 'ExpandedPackData';
  base_unit?: Maybe<Scalars['String']['output']>;
  max_unit_size?: Maybe<Scalars['Float']['output']>;
  min_unit_size?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  unit_count?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['uuid']['output'];
};

export type ExpandedRestaurantItemOverrideData = {
  __typename?: 'ExpandedRestaurantItemOverrideData';
  category?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['uuid']['output'];
};

export type ExpandedSaltItemInfo = {
  __typename?: 'ExpandedSaltItemInfo';
  description?: Maybe<Scalars['String']['output']>;
  image_urls?: Maybe<Array<Scalars['String']['output']>>;
  long_description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ExpandedVariantPackData = {
  __typename?: 'ExpandedVariantPackData';
  external_item_id?: Maybe<Scalars['String']['output']>;
  gtin_metadata?: Maybe<Array<ExpandedGtinMetadataData>>;
  item?: Maybe<ExpandedItemData>;
  lead_time_cutoff_time?: Maybe<Scalars['String']['output']>;
  lead_time_days?: Maybe<Scalars['Int']['output']>;
  lead_time_settings_uuid?: Maybe<Scalars['uuid']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  modifier_options: Array<ExpandedVariantPackModifierOptionData>;
  pack?: Maybe<ExpandedPackData>;
  prebook_config?: Maybe<Scalars['jsonb']['output']>;
  upc_list?: Maybe<Array<Scalars['String']['output']>>;
  uuid: Scalars['uuid']['output'];
  variant_pack_group_memberships?: Maybe<Array<ExpandedVariantPackGroupMembershipData>>;
};

export type ExpandedVariantPackGroupData = {
  __typename?: 'ExpandedVariantPackGroupData';
  display_image_url?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['uuid']['output'];
};

export type ExpandedVariantPackGroupMembershipData = {
  __typename?: 'ExpandedVariantPackGroupMembershipData';
  uuid: Scalars['uuid']['output'];
  variant_pack_group_uuid: Scalars['uuid']['output'];
};

export type ExpandedVariantPackModifierOptionData = {
  __typename?: 'ExpandedVariantPackModifierOptionData';
  modifier_option: ExpandedModifierOptionData;
};

export enum ExportFileFormat {
  Csv = 'CSV',
  Pdf = 'PDF'
}

export type ExportPriceQuoteResponse = {
  __typename?: 'ExportPriceQuoteResponse';
  document_url: Scalars['String']['output'];
};

export type ExternalContentResponse = {
  __typename?: 'ExternalContentResponse';
  external_content?: Maybe<External_Content>;
  external_content_id: Scalars['uuid']['output'];
};

export type FinalizedSmartOrderResult = {
  alternative_matches?: InputMaybe<Array<AlternativeMatch>>;
  final_quantity?: InputMaybe<Scalars['Float']['input']>;
  item_code?: InputMaybe<Scalars['String']['input']>;
  item_name?: InputMaybe<Scalars['String']['input']>;
  metonym_uuid?: InputMaybe<Scalars['uuid']['input']>;
  reason: Scalars['String']['input'];
  search_term: Scalars['String']['input'];
  variant_pack_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type FinanceHubCustomerListItem = {
  __typename?: 'FinanceHubCustomerListItem';
  account_id?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  chat?: Maybe<Chats>;
  chat_id: Scalars['uuid']['output'];
  currency_code: Scalars['String']['output'];
  customer_name?: Maybe<Scalars['String']['output']>;
  has_autopay: Scalars['Boolean']['output'];
  has_contact_info: Scalars['Boolean']['output'];
  has_payment_method: Scalars['Boolean']['output'];
  has_payment_plan: Scalars['Boolean']['output'];
  has_statement: Scalars['Boolean']['output'];
  invoice_count: Scalars['Int']['output'];
  outstanding_balance_in_micros: Scalars['bigint']['output'];
};

export type FollowUpResponse = {
  added_to_order_guide?: InputMaybe<Scalars['Boolean']['input']>;
  feedback_text?: InputMaybe<Scalars['String']['input']>;
  feedback_type?: InputMaybe<SampleRequestFeedbackType>;
  sample_received: Scalars['Boolean']['input'];
};

export enum FrequencySettingType {
  Biweekly = 'BIWEEKLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum FulfillmentName {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP',
  SecondRunDelivery = 'SECOND_RUN_DELIVERY',
  Ups_2Day = 'UPS_2_DAY',
  UpsGround = 'UPS_GROUND',
  UpsNextDay = 'UPS_NEXT_DAY'
}

export type FulfillmentTimeslotEntry = {
  __typename?: 'FulfillmentTimeslotEntry';
  end_time: Scalars['String']['output'];
  start_time: Scalars['String']['output'];
};

export enum FulfillmentTimeslotSelection {
  FirstAvailable = 'FIRST_AVAILABLE',
  None = 'NONE'
}

export type FulfillmentTimeslotSettings = {
  __typename?: 'FulfillmentTimeslotSettings';
  default_selection: FulfillmentTimeslotSelection;
  lead_time_minutes?: Maybe<Scalars['Int']['output']>;
  selection_required: Scalars['Boolean']['output'];
  timeslots: Array<FulfillmentTimeslotEntry>;
};

export enum FulfillmentType {
  FulfillmentDays = 'FULFILLMENT_DAYS',
  FulfillmentShippingOption = 'FULFILLMENT_SHIPPING_OPTION'
}

export enum GtinFilterAvailabilityFlags {
  ChildNutritionLabel = 'CHILD_NUTRITION_LABEL',
  Kosher = 'KOSHER'
}

export type GtinFilterListFilters = {
  __typename?: 'GTINFilterListFilters';
  brand_names: Array<Scalars['String']['output']>;
  free_from_allergens: Array<Scalars['String']['output']>;
  origin_countries: Array<Scalars['String']['output']>;
  pack_sizes: Array<Scalars['String']['output']>;
  subcategories: Array<Scalars['String']['output']>;
};

export type GeneratePaymentLinkResponse = {
  __typename?: 'GeneratePaymentLinkResponse';
  created_credit_memos: Array<CreatedCreditMemoResponse>;
  created_order_invoices: Array<CreatedOrderInvoiceResponse>;
  payment_link_url: Scalars['String']['output'];
  supplier?: Maybe<Businesses>;
  supplier_id: Scalars['uuid']['output'];
};

export type GeneratePaymentStatementLinkResponse = {
  __typename?: 'GeneratePaymentStatementLinkResponse';
  payment_statement_url: Scalars['String']['output'];
};

export type GenericAttributeType = {
  __typename?: 'GenericAttributeType';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GetAdyenDropinConfigResponse = {
  __typename?: 'GetAdyenDropinConfigResponse';
  client_key: Scalars['String']['output'];
  environment: Scalars['String']['output'];
  klarna_payment_methods: Array<Scalars['String']['output']>;
  payment_methods_json: Scalars['String']['output'];
};

export type GetAllHubAnalyticsAlertsResponse = {
  __typename?: 'GetAllHubAnalyticsAlertsResponse';
  card_data_json: Array<Scalars['String']['output']>;
};

export type GetAnalyticsAlertsResponse = {
  __typename?: 'GetAnalyticsAlertsResponse';
  alerts_json: Array<Scalars['String']['output']>;
};

export type GetAnalyticsModelsResponse = {
  __typename?: 'GetAnalyticsModelsResponse';
  data: DsrAnalyticsModelsAggregated;
};

export type GetAvailableCreditMemosByCustomerResponse = {
  __typename?: 'GetAvailableCreditMemosByCustomerResponse';
  credit_memos: Array<CreditMemo>;
  restaurant?: Maybe<Businesses>;
  restaurant_id: Scalars['uuid']['output'];
  restaurant_name?: Maybe<Scalars['String']['output']>;
};

export type GetAvailableOrderFulfillmentResponse = {
  __typename?: 'GetAvailableOrderFulfillmentResponse';
  availability: Array<OrderFulfillmentAvailability>;
  default_cutoff_time?: Maybe<Scalars['String']['output']>;
  default_lead_time_days?: Maybe<Scalars['Int']['output']>;
  fulfillment_disclaimer?: Maybe<Scalars['String']['output']>;
  fulfillment_display_name?: Maybe<Scalars['String']['output']>;
  fulfillment_name: FulfillmentName;
  fulfillment_settings_id: Scalars['uuid']['output'];
  fulfillment_type: FulfillmentType;
  order_minimum_display_string?: Maybe<Scalars['String']['output']>;
  primary_fulfillment_settings_id?: Maybe<Scalars['uuid']['output']>;
};

export type GetBrandPageDetailsResponse = {
  __typename?: 'GetBrandPageDetailsResponse';
  brand_page?: Maybe<Brand_Pages>;
  brand_page_id: Scalars['uuid']['output'];
  collection_title?: Maybe<Scalars['String']['output']>;
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type GetBrandPageVariantPacksResponse = {
  __typename?: 'GetBrandPageVariantPacksResponse';
  brand_page?: Maybe<Brand_Pages>;
  brand_page_id: Scalars['uuid']['output'];
  collection_title?: Maybe<Scalars['String']['output']>;
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type GetBrandsCarouselResponse = {
  __typename?: 'GetBrandsCarouselResponse';
  brand_page?: Maybe<Brand_Pages>;
  brand_page_id: Scalars['uuid']['output'];
};

export type GetCardDetailsResponse = {
  __typename?: 'GetCardDetailsResponse';
  funding_source: CardFundingSource;
};

export type GetChatbotMessageResponse = {
  __typename?: 'GetChatbotMessageResponse';
  messages: Array<ChatbotMessage>;
  session_id: Scalars['String']['output'];
};

export type GetCollectedManualPaymentsResponse = {
  __typename?: 'GetCollectedManualPaymentsResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  payments: Array<CollectedManualPayment>;
};

export type GetCreditMemoByIdResponse = {
  __typename?: 'GetCreditMemoByIdResponse';
  credit_memo?: Maybe<Credit_Memos>;
  credit_memo_id: Scalars['uuid']['output'];
  public_url?: Maybe<Scalars['String']['output']>;
};

export type GetCreditRequestEligibilityResponse = {
  __typename?: 'GetCreditRequestEligibilityResponse';
  credit_request_reasons: Array<CreditRequestReasonResponse>;
  variant_pack_credit_request_data: Array<VariantPackCreditRequestData>;
};

export type GetCustomerDetailDataResponse = {
  __typename?: 'GetCustomerDetailDataResponse';
  header: CustomerDetailHeader;
  price_edit_display_headers: Array<PriceEditDisplayHeader>;
  rows: Array<CustomerDetailRow>;
};

export type GetCustomerListDataForBusinessOrganizationResponse = {
  __typename?: 'GetCustomerListDataForBusinessOrganizationResponse';
  customers: Array<OrgCustomerRow>;
};

export type GetCustomerListDataResponse = {
  __typename?: 'GetCustomerListDataResponse';
  customers: Array<CustomerRow>;
};

export type GetDisplayAdVariantPacksEventsResponse = {
  __typename?: 'GetDisplayAdVariantPacksEventsResponse';
  ad_campaign_id: Scalars['uuid']['output'];
  ad_manager_id: Scalars['uuid']['output'];
  advertiser_id: Scalars['uuid']['output'];
  display_ad_content: DisplayAdEventContent;
  gtin: Scalars['String']['output'];
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_event_data: DisplayAdVariantPackEventData;
  variant_pack_id: Scalars['uuid']['output'];
};

export type GetExternalContentUrlForRestaurantResponse = {
  __typename?: 'GetExternalContentUrlForRestaurantResponse';
  url: Scalars['String']['output'];
};

export type GetFinanceHubCustomerListResponse = {
  __typename?: 'GetFinanceHubCustomerListResponse';
  customers: Array<FinanceHubCustomerListItem>;
};

export type GetGtinFiltersForCategoryResponse = {
  __typename?: 'GetGTINFiltersForCategoryResponse';
  flag_filters: Array<GtinFilterAvailabilityFlags>;
  list_filters: GtinFilterListFilters;
};

export type GetGhostConversationResponse = {
  __typename?: 'GetGhostConversationResponse';
  ghost_conversation?: Maybe<Ghost_Conversations>;
  ghost_conversation_id: Scalars['uuid']['output'];
};

export type GetGuestModeContentResponse = {
  __typename?: 'GetGuestModeContentResponse';
  chat?: Maybe<Chats>;
  public_chat_id: Scalars['uuid']['output'];
};

export type GetHubCardDataResponse = {
  __typename?: 'GetHubCardDataResponse';
  card_data_json: Array<Scalars['String']['output']>;
  card_type: HubCardType;
};

export type GetHubCurrentOrdersResponse = {
  __typename?: 'GetHubCurrentOrdersResponse';
  chat_id: Scalars['uuid']['output'];
  created_at: Scalars['String']['output'];
  description: CompleteTranslation;
  is_call_sheet_order: Scalars['Boolean']['output'];
  is_draft_order?: Maybe<Scalars['Boolean']['output']>;
  item_count_display?: Maybe<CompleteTranslation>;
  operator_employees: Array<OperatorEmployeeContact>;
  order_amount_in_micros?: Maybe<Scalars['Int']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  order_status?: Maybe<Scalars['String']['output']>;
  ordered_by_user_id?: Maybe<Scalars['uuid']['output']>;
  ordered_by_user_phone_number?: Maybe<Scalars['String']['output']>;
  restaurant_id: Scalars['uuid']['output'];
  restaurant_name: Scalars['String']['output'];
  restaurant_name_i18n: CompleteTranslation;
  supplier_id: Scalars['uuid']['output'];
};

export type GetHubPastOrdersData = {
  __typename?: 'GetHubPastOrdersData';
  amount_in_micros?: Maybe<Scalars['Int']['output']>;
  chat_id: Scalars['uuid']['output'];
  invoice_id?: Maybe<Scalars['uuid']['output']>;
  item_count_display?: Maybe<CompleteTranslation>;
  operator_employees?: Maybe<Array<OperatorEmployeeContact>>;
  order_date: Scalars['String']['output'];
  order_date_display: CompleteTranslation;
  order_id?: Maybe<Scalars['uuid']['output']>;
  restaurant_id: Scalars['uuid']['output'];
  restaurant_name: Scalars['String']['output'];
  restaurant_name_i18n: CompleteTranslation;
  supplier_id: Scalars['uuid']['output'];
};

export type GetHubPastOrdersResponse = {
  __typename?: 'GetHubPastOrdersResponse';
  next_available_date?: Maybe<Scalars['String']['output']>;
  past_order_data: Array<GetHubPastOrdersData>;
};

export type GetItemRecommendationResponse = {
  __typename?: 'GetItemRecommendationResponse';
  available_quantity?: Maybe<Scalars['Int']['output']>;
  currency_code: Scalars['String']['output'];
  item_recommendation_id: Scalars['uuid']['output'];
  price_in_micros?: Maybe<Scalars['bigint']['output']>;
  rank: Scalars['Int']['output'];
  unit_count: Scalars['Float']['output'];
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type GetItemSubstitutionsResponse = {
  __typename?: 'GetItemSubstitutionsResponse';
  available_quantity?: Maybe<Scalars['Float']['output']>;
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type GetItemsFromMenuImagesResponse = {
  __typename?: 'GetItemsFromMenuImagesResponse';
  items: Array<MenuItem>;
};

export type GetLeadTimeFulfillmentResponse = {
  __typename?: 'GetLeadTimeFulfillmentResponse';
  earliest_fulfillment_at?: Maybe<Scalars['String']['output']>;
  lead_time_settings_id: Scalars['uuid']['output'];
};

export type GetManualDepositsResponse = {
  __typename?: 'GetManualDepositsResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  deposits: Array<ManualDepositSummary>;
};

export type GetObiItemsResponse = {
  __typename?: 'GetObiItemsResponse';
  obi_items: Array<ObiItem>;
};

export type GetOrderConstraintsForRestaurantResponse = {
  __typename?: 'GetOrderConstraintsForRestaurantResponse';
  order_constraints: Array<VariantPackConstraint>;
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type GetOrderEntryItemDetailResponse = {
  __typename?: 'GetOrderEntryItemDetailResponse';
  purchase_history: Array<GetVariantPackPurchaseHistoryResponse>;
  related_variant_packs: Array<OrderEntryRelatedVariantPack>;
  salt_info?: Maybe<OrderEntrySaltInfo>;
};

export type GetOrderEntrySummaryResponse = {
  __typename?: 'GetOrderEntrySummaryResponse';
  summaries: Array<OrderEntryCartSummary>;
};

export type GetOrderEstimatedCommissionResponse = {
  __typename?: 'GetOrderEstimatedCommissionResponse';
  commissions: Array<OrderCommission>;
};

export type GetOrderFeesResponse = {
  __typename?: 'GetOrderFeesResponse';
  amount_at_invoice_micros?: Maybe<Scalars['bigint']['output']>;
  amount_at_order_micros?: Maybe<Scalars['bigint']['output']>;
  display_type: OrderFeeDisplayType;
  external_item_id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  order?: Maybe<Orders>;
  order_id: Scalars['uuid']['output'];
};

export type GetOrderGrossProfitResponse = {
  __typename?: 'GetOrderGrossProfitResponse';
  gross_profit?: Maybe<OrderGrossProfit>;
};

export type GetOrderGuideCollectionsForOrderEntryResponse = {
  __typename?: 'GetOrderGuideCollectionsForOrderEntryResponse';
  collections: Array<OrderGuideCollectionForOrderEntry>;
};

export type GetOrderHistoryResponse = {
  __typename?: 'GetOrderHistoryResponse';
  variant_pack_history: Array<VariantPackOrderHistory>;
  variant_pack_metonyms: Array<VariantPackMetonym>;
};

export type GetOrderInvoiceByIdResponse = {
  __typename?: 'GetOrderInvoiceByIdResponse';
  order?: Maybe<Orders>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  order_invoice?: Maybe<Order_Invoices>;
  order_invoice_id: Scalars['uuid']['output'];
  public_url?: Maybe<Scalars['String']['output']>;
  translated_order_fulfillment_display_name?: Maybe<Scalars['String']['output']>;
};

export type GetOrderInvoiceGrossProfitResponse = {
  __typename?: 'GetOrderInvoiceGrossProfitResponse';
  gross_profit?: Maybe<OrderInvoiceGrossProfit>;
};

export type GetOrderResponse = {
  __typename?: 'GetOrderResponse';
  order?: Maybe<Orders>;
  order_id: Scalars['uuid']['output'];
  translated_fulfillment_display_name?: Maybe<Scalars['String']['output']>;
};

export type GetOrdersFiltersInput = {
  created_sources?: InputMaybe<Array<OrderSource>>;
  order_domains?: InputMaybe<Array<OrderDomain>>;
  statuses?: InputMaybe<Array<OrderStatus>>;
};

export type GetPadConsentFormsForPaymentMethodResponse = {
  __typename?: 'GetPadConsentFormsForPaymentMethodResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  pad_additional_terms_and_conditions?: Maybe<Scalars['String']['output']>;
  pad_agreement?: Maybe<Scalars['String']['output']>;
};

export type GetPadConsentFormsResponse = {
  __typename?: 'GetPadConsentFormsResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  pad_additional_terms_and_conditions?: Maybe<Scalars['String']['output']>;
  pad_agreement?: Maybe<Scalars['String']['output']>;
};

export type GetPaymentLinkLineItemsResponse = {
  __typename?: 'GetPaymentLinkLineItemsResponse';
  created_at: Scalars['String']['output'];
  credit_memos: Array<PaymentLinkCreditMemo>;
  invoices: Array<PaymentLinkInvoice>;
  payment_link_url: Scalars['String']['output'];
  supplier?: Maybe<Businesses>;
  supplier_id: Scalars['String']['output'];
  total_remaining_balance_in_micros: Scalars['Int']['output'];
};

export type GetPaymentLinksResponse = {
  __typename?: 'GetPaymentLinksResponse';
  payment_links: Array<PaymentLinkResponse>;
};

export type GetPaymentPlanNextRunDateResponse = {
  __typename?: 'GetPaymentPlanNextRunDateResponse';
  estimated_end_date: Scalars['String']['output'];
  next_run_date: Scalars['String']['output'];
  payment_plan?: Maybe<Payment_Plans>;
  payment_plan_id: Scalars['uuid']['output'];
};

export type GetPaymentPlanResponse = {
  __typename?: 'GetPaymentPlanResponse';
  chat_id: Scalars['uuid']['output'];
  next_run_date: Scalars['String']['output'];
  order_invoices: Array<PaymentPlanInvoice>;
  payment_plan?: Maybe<Payment_Plans>;
  payment_plan_id: Scalars['uuid']['output'];
  remaining_balance_in_micros: Scalars['bigint']['output'];
};

export type GetPaymentPlansResponse = {
  __typename?: 'GetPaymentPlansResponse';
  payment_plans: Array<GetPaymentPlanResponse>;
};

export type GetPendingOrderPriceEditApprovalRequestResponse = {
  __typename?: 'GetPendingOrderPriceEditApprovalRequestResponse';
  price_edit_approval_request?: Maybe<OrderPriceEditApprovalRequestResponse>;
};

export type GetPeriodSalesAnalyticsResponse = {
  __typename?: 'GetPeriodSalesAnalyticsResponse';
  avg_order_size: Scalars['Float']['output'];
  avg_order_size_percent_change?: Maybe<Scalars['Float']['output']>;
  currency_code: Scalars['String']['output'];
  period_type: SalesAnalyticsPeriodType;
  total_orders: Scalars['Int']['output'];
  total_orders_percent_change?: Maybe<Scalars['Float']['output']>;
  total_sales_in_micros: Scalars['Int']['output'];
  total_sales_percent_change?: Maybe<Scalars['Float']['output']>;
};

export type GetPriceQuoteCompetitorLineItem = {
  __typename?: 'GetPriceQuoteCompetitorLineItem';
  item_name: Scalars['String']['output'];
  pack_price_in_micros: Scalars['bigint']['output'];
  pack_size?: Maybe<Scalars['String']['output']>;
  savings_in_micros: Scalars['bigint']['output'];
};

export type GetPriceQuoteLineItem = {
  __typename?: 'GetPriceQuoteLineItem';
  competitor?: Maybe<GetPriceQuoteCompetitorLineItem>;
  currency_code: Scalars['String']['output'];
  is_catalog_item_removed: Scalars['Boolean']['output'];
  item_code?: Maybe<Scalars['String']['output']>;
  item_description?: Maybe<Scalars['String']['output']>;
  item_name: Scalars['String']['output'];
  item_pack_size?: Maybe<Scalars['String']['output']>;
  line_item_id: Scalars['uuid']['output'];
  line_total_in_micros: Scalars['bigint']['output'];
  pack_price_in_micros: Scalars['bigint']['output'];
  per_unit_price_in_micros?: Maybe<Scalars['bigint']['output']>;
  quantity: Scalars['Float']['output'];
  variant_pack_id?: Maybe<Scalars['uuid']['output']>;
};

export type GetPriceQuoteResponse = {
  __typename?: 'GetPriceQuoteResponse';
  account_name: Scalars['String']['output'];
  chat_id: Scalars['uuid']['output'];
  competitor_name?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['String']['output'];
  currency_code: Scalars['String']['output'];
  line_items: Array<GetPriceQuoteLineItem>;
  name: Scalars['String']['output'];
  price_quote_id: Scalars['uuid']['output'];
  quote_type: Scalars['String']['output'];
  total_amount_in_micros: Scalars['bigint']['output'];
  total_savings_in_micros?: Maybe<Scalars['bigint']['output']>;
  updated_at: Scalars['String']['output'];
};

export type GetPriceQuoteSummaryResponse = {
  __typename?: 'GetPriceQuoteSummaryResponse';
  account_name: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  currency_code: Scalars['String']['output'];
  item_count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  price_quote_id: Scalars['uuid']['output'];
  quote_type: Scalars['String']['output'];
  total_amount_in_micros: Scalars['bigint']['output'];
  total_savings_in_micros?: Maybe<Scalars['bigint']['output']>;
  updated_at: Scalars['String']['output'];
};

export type GetPriceTrendsDataResponse = {
  __typename?: 'GetPriceTrendsDataResponse';
  median_price_l7: Scalars['Int']['output'];
  median_price_l30: Scalars['Int']['output'];
  median_price_l90: Scalars['Int']['output'];
  median_price_yoy: Scalars['Int']['output'];
  price_occurrences_l7: Array<PriceTrendsDataPoint>;
  price_occurrences_l30: Array<PriceTrendsDataPoint>;
  price_occurrences_l90: Array<PriceTrendsDataPoint>;
  price_occurrences_yoy: Array<PriceTrendsDataPoint>;
};

export type GetPriceTrendsWithCustomerGroupsDataResponse = {
  __typename?: 'GetPriceTrendsWithCustomerGroupsDataResponse';
  gp_occurrences_l7: Array<GrossProfitTrendsDataPoint>;
  gp_occurrences_l30: Array<GrossProfitTrendsDataPoint>;
  gp_occurrences_l90: Array<GrossProfitTrendsDataPoint>;
  gp_occurrences_yoy: Array<GrossProfitTrendsDataPoint>;
  last_gp_l7?: Maybe<Scalars['Float']['output']>;
  last_gp_l30?: Maybe<Scalars['Float']['output']>;
  last_gp_l90?: Maybe<Scalars['Float']['output']>;
  last_gp_yoy?: Maybe<Scalars['Float']['output']>;
  last_price_l7?: Maybe<Scalars['Int']['output']>;
  last_price_l30?: Maybe<Scalars['Int']['output']>;
  last_price_l90?: Maybe<Scalars['Int']['output']>;
  last_price_yoy?: Maybe<Scalars['Int']['output']>;
  median_gp_l7: Scalars['Float']['output'];
  median_gp_l30: Scalars['Float']['output'];
  median_gp_l90: Scalars['Float']['output'];
  median_gp_yoy: Scalars['Float']['output'];
  median_price_l7: Scalars['Int']['output'];
  median_price_l30: Scalars['Int']['output'];
  median_price_l90: Scalars['Int']['output'];
  median_price_yoy: Scalars['Int']['output'];
  price_occurrences_l7: Array<PriceTrendsDataPoint>;
  price_occurrences_l30: Array<PriceTrendsDataPoint>;
  price_occurrences_l90: Array<PriceTrendsDataPoint>;
  price_occurrences_yoy: Array<PriceTrendsDataPoint>;
};

export type GetPricingBookmarksResponse = {
  __typename?: 'GetPricingBookmarksResponse';
  bookmarks: Array<DetailVariantPackCostChange>;
};

export type GetPricingRecommendationsResponse = {
  __typename?: 'GetPricingRecommendationsResponse';
  auto_publish_at?: Maybe<Scalars['String']['output']>;
  progress: PricingRecommendationProgress;
  publish_enabled: Scalars['Boolean']['output'];
  recommendations: Array<PricingRecommendationOutput>;
};

export type GetPricingTaskRunsByTypeForBusinessOrganizationResponse = {
  __typename?: 'GetPricingTaskRunsByTypeForBusinessOrganizationResponse';
  task_runs: Array<PricingTaskRunSummaryByType>;
};

export type GetPricingTaskRunsForBusinessOrganizationResponse = {
  __typename?: 'GetPricingTaskRunsForBusinessOrganizationResponse';
  task_runs: Array<PricingTaskRunSummary>;
};

export type GetPrintTagTemplateForRestaurantResponse = {
  __typename?: 'GetPrintTagTemplateForRestaurantResponse';
  preview_display_fields: Array<PrintTagPreviewDisplayField>;
  print_tag_template?: Maybe<Print_Tag_Templates>;
  print_tag_template_id: Scalars['uuid']['output'];
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type GetPromotionForRestaurantResponse = {
  __typename?: 'GetPromotionForRestaurantResponse';
  promotion?: Maybe<Promotions>;
  promotion_effect?: Maybe<Promotion_Effects>;
  promotion_effect_id?: Maybe<Scalars['uuid']['output']>;
  promotion_id: Scalars['uuid']['output'];
  promotion_qualification?: Maybe<Promotion_Qualifications>;
  promotion_qualification_id?: Maybe<Scalars['uuid']['output']>;
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id?: Maybe<Scalars['uuid']['output']>;
};

export type GetResolvedLeadTimeFulfillmentResponse = {
  __typename?: 'GetResolvedLeadTimeFulfillmentResponse';
  settings: GetResolvedLeadTimeFulfillmentSettings;
  variant_pack_ids: Array<Scalars['uuid']['output']>;
};

export type GetResolvedLeadTimeFulfillmentSettings = {
  __typename?: 'GetResolvedLeadTimeFulfillmentSettings';
  earliest_fulfillment_at?: Maybe<Scalars['String']['output']>;
};

export type GetRestaurantEmployeesResponse = {
  __typename?: 'GetRestaurantEmployeesResponse';
  chat_employee_id: Scalars['uuid']['output'];
  employee_contact_email?: Maybe<Scalars['String']['output']>;
  employee_contact_phone_number: Scalars['String']['output'];
  employee_contact_protected: Scalars['Boolean']['output'];
  employee_id: Scalars['uuid']['output'];
  employee_login_email?: Maybe<Scalars['String']['output']>;
  employee_name: Scalars['String']['output'];
  employee_status: EmployeeStatus;
  restaurant_employee_id: Scalars['uuid']['output'];
  restaurant_employee_role: EmployeeRole;
  show_app_payments_tab: Scalars['Boolean']['output'];
};

export type GetRestaurantPlanogramsResponse = {
  __typename?: 'GetRestaurantPlanogramsResponse';
  planogram?: Maybe<Planograms>;
  planogram_id: Scalars['uuid']['output'];
};

export type GetSalesAnalyticsAlertsResponse = {
  __typename?: 'GetSalesAnalyticsAlertsResponse';
  alerts: Array<AnalyticsAlertResponse>;
  chat?: Maybe<Chats>;
  chat_id: Scalars['uuid']['output'];
};

export type GetSalesDataAnalyticsResponse = {
  __typename?: 'GetSalesDataAnalyticsResponse';
  avg_order_size: Scalars['Float']['output'];
  total_orders: Scalars['Int']['output'];
  total_sales_data: Array<TotalSalesByDay>;
  total_sales_in_micros: Scalars['Int']['output'];
  total_sales_percent_over_period?: Maybe<Scalars['Float']['output']>;
};

export type GetSalesPortalOrderGuideCollectionsForOrderEntryResponse = {
  __typename?: 'GetSalesPortalOrderGuideCollectionsForOrderEntryResponse';
  collections: Array<SalesPortalOrderGuideCollectionForOrderEntry>;
};

export type GetSalesPortalOrderGuideCollectionsResponse = {
  __typename?: 'GetSalesPortalOrderGuideCollectionsResponse';
  collections: Array<SalesPortalOrderGuideCollection>;
};

export type GetSalesPortalTabsResponse = {
  __typename?: 'GetSalesPortalTabsResponse';
  tabs: Array<SalesPortalTab>;
};

export type GetSampleRequestVariantPacksResponse = {
  __typename?: 'GetSampleRequestVariantPacksResponse';
  ad_campaign_id: Scalars['uuid']['output'];
  ad_manager_id: Scalars['uuid']['output'];
  advertiser_id: Scalars['uuid']['output'];
  advertiser_name?: Maybe<Scalars['String']['output']>;
  earliest_requested_at?: Maybe<Scalars['String']['output']>;
  follow_up_period_days?: Maybe<Scalars['Int']['output']>;
  gtin: Scalars['String']['output'];
  lookback_period_days?: Maybe<Scalars['Int']['output']>;
  qualification_questions?: Maybe<Array<Scalars['String']['output']>>;
  request_count?: Maybe<Scalars['Int']['output']>;
  request_limit?: Maybe<Scalars['Int']['output']>;
  require_contact_information?: Maybe<Scalars['Boolean']['output']>;
  sample_request?: Maybe<Sample_Requests>;
  sample_request_event_data: SampleRequestEventData;
  sample_request_id?: Maybe<Scalars['uuid']['output']>;
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type GetSmartOrderAssignableEmployeesResponse = {
  __typename?: 'GetSmartOrderAssignableEmployeesResponse';
  assignable_employees: Array<SmartOrderAssignableEmployee>;
};

export type GetSmartOrderDetailsResponse = {
  __typename?: 'GetSmartOrderDetailsResponse';
  search_inputs: Array<SmartOrderDetailsSearchInput>;
  smart_order?: Maybe<Smart_Order>;
  smart_order_id: Scalars['uuid']['output'];
};

export type GetSmartOrderInboundAssigneesResponse = {
  __typename?: 'GetSmartOrderInboundAssigneesResponse';
  assignees: Array<SmartOrderInboundAssignee>;
};

export type GetSmartOrderInboundHistoryResponse = {
  __typename?: 'GetSmartOrderInboundHistoryResponse';
  smart_orders: Array<SmartOrderInboundHistoryItem>;
  total_count: Scalars['Int']['output'];
};

export type GetSmartOrderResponse = {
  __typename?: 'GetSmartOrderResponse';
  quantity: Scalars['Int']['output'];
  search_term: Scalars['String']['output'];
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id?: Maybe<Scalars['uuid']['output']>;
};

export type GetSupplierCatalogVariantPackGroupResponse = {
  __typename?: 'GetSupplierCatalogVariantPackGroupResponse';
  variant_pack_group_display_image_url?: Maybe<Scalars['String']['output']>;
  variant_pack_group_display_name?: Maybe<Scalars['String']['output']>;
  variant_pack_group_id?: Maybe<Scalars['uuid']['output']>;
  variant_pack_group_item_count: Scalars['Int']['output'];
};

export type GetSupplierCategoryItemsResponse = {
  __typename?: 'GetSupplierCategoryItemsResponse';
  category?: Maybe<Scalars['String']['output']>;
  category_item_count: Scalars['Int']['output'];
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type GetSupplierVariantPackGroupItemExpandedResponse = {
  __typename?: 'GetSupplierVariantPackGroupItemExpandedResponse';
  salt_data?: Maybe<ExpandedSaltItemInfo>;
  variant_pack_data?: Maybe<ExpandedVariantPackData>;
  variant_pack_group_data?: Maybe<ExpandedVariantPackGroupData>;
  variant_pack_group_display_name?: Maybe<Scalars['String']['output']>;
  variant_pack_group_id?: Maybe<Scalars['uuid']['output']>;
  variant_pack_group_item_count: Scalars['Int']['output'];
  variant_pack_id: Scalars['uuid']['output'];
};

export type GetSupplierVariantPackGroupItemResponse = {
  __typename?: 'GetSupplierVariantPackGroupItemResponse';
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_group?: Maybe<Variant_Pack_Groups>;
  variant_pack_group_display_name?: Maybe<Scalars['String']['output']>;
  variant_pack_group_id?: Maybe<Scalars['uuid']['output']>;
  variant_pack_group_item_count: Scalars['Int']['output'];
  variant_pack_id: Scalars['uuid']['output'];
};

export type GetUniversalAppLinkResponse = {
  __typename?: 'GetUniversalAppLinkResponse';
  url?: Maybe<Scalars['String']['output']>;
};

export type GetUnpaidInvoiceListResponse = {
  __typename?: 'GetUnpaidInvoiceListResponse';
  has_more_pages: Scalars['Boolean']['output'];
  invoices: Array<UnpaidInvoiceListItem>;
};

export type GetUnpaidInvoiceSummaryResponse = {
  __typename?: 'GetUnpaidInvoiceSummaryResponse';
  currency_code: Scalars['String']['output'];
  current: UnpaidInvoiceSummaryBucket;
  days_0_14: UnpaidInvoiceSummaryBucket;
  days_15_30: UnpaidInvoiceSummaryBucket;
  days_31_60: UnpaidInvoiceSummaryBucket;
  days_61_90: UnpaidInvoiceSummaryBucket;
  days_90_plus: UnpaidInvoiceSummaryBucket;
  overdue: UnpaidInvoiceSummaryBucket;
  total_credits: UnpaidInvoiceSummaryBucket;
  total_due: UnpaidInvoiceSummaryBucket;
};

export type GetUnpaidOrderInvoicesByCustomerResponse = {
  __typename?: 'GetUnpaidOrderInvoicesByCustomerResponse';
  order_invoices: Array<OrderInvoice>;
  restaurant?: Maybe<Businesses>;
  restaurant_id: Scalars['uuid']['output'];
  restaurant_name?: Maybe<Scalars['String']['output']>;
  supplier_id?: Maybe<Scalars['uuid']['output']>;
};

export type GetVariantPackGroupsResponse = {
  __typename?: 'GetVariantPackGroupsResponse';
  translated_display_name: Scalars['String']['output'];
  variant_pack_group?: Maybe<Variant_Pack_Groups>;
  variant_pack_group_id: Scalars['uuid']['output'];
};

export type GetVariantPackInfoResponse = {
  __typename?: 'GetVariantPackInfoResponse';
  availability_status?: Maybe<Scalars['String']['output']>;
  available_quantity?: Maybe<Scalars['Int']['output']>;
  cost_info?: Maybe<VariantPackCostInfoResponse>;
  currency_code: Scalars['String']['output'];
  default_price_in_micros?: Maybe<Scalars['bigint']['output']>;
  inventory_info?: Maybe<VariantPackInventoryInfoResponse>;
  list_item_display_text?: Maybe<Scalars['String']['output']>;
  manufacturer_suggested_retail_price_in_micros?: Maybe<Scalars['bigint']['output']>;
  price_in_micros?: Maybe<Scalars['bigint']['output']>;
  sales_rep_gross_profit_in_percentage?: Maybe<Scalars['Float']['output']>;
  sales_rep_metadata?: Maybe<VariantPackSalesRepMetadataResponse>;
  sales_rep_price_in_micros?: Maybe<Scalars['bigint']['output']>;
  suggested_retail_price_in_micros?: Maybe<Scalars['bigint']['output']>;
  unit_count: Scalars['Float']['output'];
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type GetVariantPackInvoicesForCreditRequestResponse = {
  __typename?: 'GetVariantPackInvoicesForCreditRequestResponse';
  invoices: Array<VariantPackCreditRequestInvoice>;
  other_creditable_uoms?: Maybe<Array<VariantPackCreditRequestUom>>;
};

export type GetVariantPackLastPurchaseInfoResponse = {
  __typename?: 'GetVariantPackLastPurchaseInfoResponse';
  base_unit?: Maybe<Scalars['String']['output']>;
  cost_info?: Maybe<VariantPackCostInfoResponse>;
  fulfillment_date?: Maybe<Scalars['String']['output']>;
  order_date?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  order_item_id?: Maybe<Scalars['uuid']['output']>;
  price_in_micros?: Maybe<Scalars['bigint']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  unit_count?: Maybe<Scalars['Float']['output']>;
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id?: Maybe<Scalars['uuid']['output']>;
};

export type GetVariantPackPriceDraftUpdatesResponse = {
  __typename?: 'GetVariantPackPriceDraftUpdatesResponse';
  pricing_price_draft_updates: Array<PriceDraftUpdate>;
};

export type GetVariantPackPurchaseHistoryResponse = {
  __typename?: 'GetVariantPackPurchaseHistoryResponse';
  base_quantity?: Maybe<Scalars['Float']['output']>;
  base_unit?: Maybe<Scalars['String']['output']>;
  base_unit_price_in_micros?: Maybe<Scalars['bigint']['output']>;
  cost_info?: Maybe<VariantPackCostInfoResponse>;
  currency_code: Scalars['String']['output'];
  fulfillment_date?: Maybe<Scalars['String']['output']>;
  item_modifiers?: Maybe<Scalars['String']['output']>;
  order_date?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  order_item_id?: Maybe<Scalars['uuid']['output']>;
  price_in_micros?: Maybe<Scalars['bigint']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sales_rep_gross_profit_in_micros?: Maybe<Scalars['bigint']['output']>;
  sales_rep_gross_profit_in_percentage?: Maybe<Scalars['Float']['output']>;
  total_price_in_micros?: Maybe<Scalars['bigint']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  unit_count?: Maybe<Scalars['Float']['output']>;
};

export type GetVariantPackSubstitutionsResponse = {
  __typename?: 'GetVariantPackSubstitutionsResponse';
  substitutions: Array<VariantPackSubstitution>;
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type GetVisibleVariantPackPrintingPricesResponse = {
  __typename?: 'GetVisibleVariantPackPrintingPricesResponse';
  variant_pack_prices: Array<VariantPackPricesResponse>;
};

export type GetVisibleVariantPacksByVariantPackGroupResponse = {
  __typename?: 'GetVisibleVariantPacksByVariantPackGroupResponse';
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_group?: Maybe<Variant_Pack_Groups>;
  variant_pack_group_id: Scalars['uuid']['output'];
  variant_pack_id: Scalars['uuid']['output'];
};

export type GetWhitelabelConfigResponse = {
  __typename?: 'GetWhitelabelConfigResponse';
  render_contact_form?: Maybe<Scalars['Boolean']['output']>;
  translated_become_customer_address_label: Scalars['String']['output'];
  translated_become_customer_name_label: Scalars['String']['output'];
  translated_tagline?: Maybe<Scalars['String']['output']>;
  whitelabel_config?: Maybe<Whitelabel_Config>;
  whitelabel_config_id: Scalars['uuid']['output'];
};

export enum GhostMessageType {
  Agent = 'AGENT',
  Human = 'HUMAN',
  System = 'SYSTEM'
}

export type GrantSmartOrderRestaurantAccessResponse = {
  __typename?: 'GrantSmartOrderRestaurantAccessResponse';
  access_granted: Scalars['Boolean']['output'];
  employee?: Maybe<Employees>;
  employee_id: Scalars['uuid']['output'];
  has_restaurant_access: Scalars['Boolean']['output'];
};

export type GrossProfitTrendsDataPoint = {
  __typename?: 'GrossProfitTrendsDataPoint';
  gross_profit: Scalars['Float']['output'];
  occurrences: Scalars['Int']['output'];
};

export type HubCardFilters = {
  alert_statuses?: InputMaybe<Array<AnalyticsAlertStatusType>>;
};

export enum HubCardType {
  ChurnRisk = 'CHURN_RISK',
  CurrentOrders = 'CURRENT_ORDERS',
  LostItem = 'LOST_ITEM',
  LowestPerformingCustomers = 'LOWEST_PERFORMING_CUSTOMERS',
  MonthlyCommissions = 'MONTHLY_COMMISSIONS',
  OrderAttention = 'ORDER_ATTENTION',
  OverduePayment = 'OVERDUE_PAYMENT',
  WeeklyProfitRollup = 'WEEKLY_PROFIT_ROLLUP'
}

export type IdentifierEntry = {
  __typename?: 'IdentifierEntry';
  collection: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ImageCoords = {
  x_coord: Scalars['Int']['input'];
  y_coord: Scalars['Int']['input'];
};

export type ImageType = {
  __typename?: 'ImageType';
  language?: Maybe<Scalars['String']['output']>;
  orderPriority?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type InitiateKlarnaPaymentResponse = {
  __typename?: 'InitiateKlarnaPaymentResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  klarna_action?: Maybe<Scalars['String']['output']>;
  payment_batch?: Maybe<Payment_Batches>;
  payment_batch_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InviteRestaurantEmployeeResponse = {
  __typename?: 'InviteRestaurantEmployeeResponse';
  employee?: Maybe<Employees>;
  employee_id: Scalars['uuid']['output'];
  is_duplicate_employee?: Maybe<Scalars['Boolean']['output']>;
  pepper_url: Scalars['String']['output'];
  whitelabel_android_url?: Maybe<Scalars['String']['output']>;
  whitelabel_ios_url?: Maybe<Scalars['String']['output']>;
  whitelabel_universal_url?: Maybe<Scalars['String']['output']>;
};

export type InvoiceInput = {
  amount_in_micros: Scalars['bigint']['input'];
  invoice_id: Scalars['String']['input'];
  invoice_number: Scalars['String']['input'];
  restaurant_id: Scalars['String']['input'];
};

export enum InvoiceListAgingBucket {
  Current = 'CURRENT',
  Days_0_14 = 'DAYS_0_14',
  Days_15_30 = 'DAYS_15_30',
  Days_31_60 = 'DAYS_31_60',
  Days_61_90 = 'DAYS_61_90',
  Days_90Plus = 'DAYS_90_PLUS',
  Overdue = 'OVERDUE'
}

export enum InvoiceListRecordType {
  CreditMemo = 'CREDIT_MEMO',
  Invoice = 'INVOICE'
}

export enum InvoiceListSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum InvoiceListSortField {
  CustomerName = 'CUSTOMER_NAME',
  DaysOverdue = 'DAYS_OVERDUE',
  DueAt = 'DUE_AT',
  ErpLastModifiedAt = 'ERP_LAST_MODIFIED_AT',
  InvoiceNumber = 'INVOICE_NUMBER',
  RemainingBalance = 'REMAINING_BALANCE'
}

export type ItemInfoWithVpUuidListType = {
  __typename?: 'ItemInfoWithVpUuidListType';
  items: Array<ItemInfoWithVpUuidType>;
};

export type ItemInfoWithVpUuidType = {
  __typename?: 'ItemInfoWithVpUuidType';
  basicInformation: BasicInformationType;
  brandInformation: BrandInformationType;
  categories: Array<CategoryType>;
  dietaryInformation: DietaryInformationType;
  images: Array<ImageType>;
  licenseInformation: Array<GenericAttributeType>;
  packagingAndStorage: PackagingAndStorageType;
  servingAndPreparation: ServingAndPreparationType;
  vpUuid: Scalars['String']['output'];
};

export type ItemSectionEntry = {
  __typename?: 'ItemSectionEntry';
  collection: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  section: Scalars['String']['output'];
};

export type ItemType = {
  __typename?: 'ItemType';
  /** Storage for all localized key-value pairs that will not be exposed externally to users. Any additional fields or metadata we want to store during transformation should go here. */
  internal: Array<LocalizedParameterType>;
  /** Nutritional data, ingredient declarations, allergens, and dietary tags (e.g., vegan, kosher). */
  nutritionProfile: NutritionProfileType;
  /** Packaging configurations for the product (e.g., cases, inner packs). */
  packaging: Array<PackagingType>;
  /** Usage guidance including preparation, safety, storage, and composition context. */
  productUsageInformation: ProductUsageInformationType;
  /** Product identity details including name, brand, manufacturer, and multilingual descriptions. */
  profile: ProfileType;
};

export type LocalizationContext = {
  locale: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export type LocalizedParameterInput = {
  /** The key of the parameter. */
  key: Scalars['String']['input'];
  /** The locale of the parameter. */
  locale?: Scalars['String']['input'];
  /** The value of the parameter. */
  value: Scalars['String']['input'];
};

export type LocalizedParameterType = {
  __typename?: 'LocalizedParameterType';
  /** The key of the parameter. */
  key: Scalars['String']['output'];
  /** The locale of the parameter. */
  locale: Scalars['String']['output'];
  /** The value of the parameter. */
  value: Scalars['String']['output'];
};

export type LocalizedValueInput = {
  /** Locale of the entity, formatted as language-region code (e.g., 'en-US'). */
  locale?: Scalars['String']['input'];
  /** The display name of the entity (e.g., 'sugar', 'vitamin C'). */
  value: Scalars['String']['input'];
};

export type LocalizedValueType = {
  __typename?: 'LocalizedValueType';
  /** Locale of the entity, formatted as language-region code (e.g., 'en-US'). */
  locale: Scalars['String']['output'];
  /** The display name of the entity (e.g., 'sugar', 'vitamin C'). */
  value: Scalars['String']['output'];
};

export type LostItemAccountViewData = {
  __typename?: 'LostItemAccountViewData';
  alert_status: AnalyticsAlertStatusType;
  alert_type: AnalyticsAlertType;
  alert_uuid: Scalars['String']['output'];
  chat_uuid: Scalars['String']['output'];
  display_name: Scalars['String']['output'];
  external_item_id: Scalars['String']['output'];
  pack_unit: Scalars['String']['output'];
  photo_url_list?: Maybe<Array<Scalars['String']['output']>>;
  restaurant_uuid: Scalars['String']['output'];
  subtitle: CompleteTranslation;
  supplier_uuid: Scalars['String']['output'];
  title: CompleteTranslation;
  variant_pack_uuid: Scalars['String']['output'];
};

export type LostItemHubCardData = {
  __typename?: 'LostItemHubCardData';
  alert_status: AnalyticsAlertStatusType;
  alert_uuid: Scalars['String']['output'];
  card_type: HubCardType;
  chat_uuid: Scalars['String']['output'];
  description?: Maybe<CompleteTranslation>;
  display_name: Scalars['String']['output'];
  external_item_id: Scalars['String']['output'];
  pack_unit: Scalars['String']['output'];
  photo_url_list?: Maybe<Array<Scalars['String']['output']>>;
  restaurant_uuid: Scalars['String']['output'];
  subtitle: CompleteTranslation;
  supplier_uuid: Scalars['String']['output'];
  title: CompleteTranslation;
  variant_pack_uuid: Scalars['String']['output'];
};

export enum LowestPerformingCustomerDataType {
  Percentage = 'PERCENTAGE',
  Unit = 'UNIT'
}

export type LowestPerformingCustomersHubCardData = {
  __typename?: 'LowestPerformingCustomersHubCardData';
  card_data: LowestPerformingCustomersHubCardDataPage;
  card_type: HubCardType;
  description?: Maybe<CompleteTranslation>;
  subtitle: CompleteTranslation;
  title: CompleteTranslation;
};

export type LowestPerformingCustomersHubCardDataContent = {
  __typename?: 'LowestPerformingCustomersHubCardDataContent';
  items: Array<LowestPerformingCustomersHubCardDataItem>;
  type_subtitle: CompleteTranslation;
};

export type LowestPerformingCustomersHubCardDataItem = {
  __typename?: 'LowestPerformingCustomersHubCardDataItem';
  restaurant_name: CompleteTranslation;
  restaurant_uuid: Scalars['String']['output'];
  subtitle: CompleteTranslation;
  supplier_uuid: Scalars['String']['output'];
  type: LowestPerformingCustomerDataType;
  value: Scalars['Float']['output'];
};

export type LowestPerformingCustomersHubCardDataPage = {
  __typename?: 'LowestPerformingCustomersHubCardDataPage';
  avg_gp_percentage: LowestPerformingCustomersHubCardDataContent;
  units_sold: LowestPerformingCustomersHubCardDataContent;
};

export type LoyaltyEnrollmentFormResponseInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum LoyaltyProgramErrorCode {
  EmployeeEmailRequired = 'EMPLOYEE_EMAIL_REQUIRED',
  EnrollmentNotAccepted = 'ENROLLMENT_NOT_ACCEPTED',
  EnrollmentNotFound = 'ENROLLMENT_NOT_FOUND',
  EnrollmentNotPending = 'ENROLLMENT_NOT_PENDING',
  InvalidFormResponse = 'INVALID_FORM_RESPONSE',
  LoyaltyAdminRequired = 'LOYALTY_ADMIN_REQUIRED',
  TermsMismatch = 'TERMS_MISMATCH'
}

export type MakePaymentBatchInput = {
  credit_amount_in_micros_string?: InputMaybe<Scalars['String']['input']>;
  fees?: InputMaybe<Array<PaymentBatchFeeInput>>;
  invoices: Array<MakePaymentInvoiceInput>;
  memo?: InputMaybe<Scalars['String']['input']>;
  paid_source?: InputMaybe<PaidSource>;
  payment_method: Scalars['String']['input'];
  payor_id?: InputMaybe<Scalars['uuid']['input']>;
  restaurant_id: Scalars['uuid']['input'];
};

export type MakePaymentInvoiceInput = {
  amount_in_micros_string: Scalars['String']['input'];
  due_at?: InputMaybe<Scalars['String']['input']>;
  invoice_id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_number: Scalars['String']['input'];
  restaurant_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type MakePaymentResponse = {
  __typename?: 'MakePaymentResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  payment_batch?: Maybe<Payment_Batches>;
  payment_batch_id?: Maybe<Scalars['uuid']['output']>;
};

export type ManagerForecastWindow = {
  __typename?: 'ManagerForecastWindow';
  currency_code: Scalars['String']['output'];
  prospect_count: Scalars['Int']['output'];
  total_value_in_micros: Scalars['bigint']['output'];
  window_days: Scalars['Int']['output'];
};

export type ManagerPipelineStage = {
  __typename?: 'ManagerPipelineStage';
  currency_code: Scalars['String']['output'];
  prospect_count: Scalars['Int']['output'];
  stage: ChatProspectStage;
  total_value_in_micros: Scalars['bigint']['output'];
};

export type ManagerProspectRow = {
  __typename?: 'ManagerProspectRow';
  chat_id: Scalars['uuid']['output'];
  currency_code: Scalars['String']['output'];
  date_added_at: Scalars['String']['output'];
  date_added_display: Scalars['String']['output'];
  estimated_close_date?: Maybe<Scalars['String']['output']>;
  last_activity_at?: Maybe<Scalars['String']['output']>;
  last_activity_display?: Maybe<Scalars['String']['output']>;
  owned_by_id?: Maybe<Scalars['uuid']['output']>;
  owned_by_name?: Maybe<Scalars['String']['output']>;
  restaurant_address: Scalars['String']['output'];
  restaurant_id: Scalars['uuid']['output'];
  restaurant_name: Scalars['String']['output'];
  stage: ChatProspectStage;
  supplier_id: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
  weekly_estimated_value_in_micros?: Maybe<Scalars['bigint']['output']>;
};

export type ManagerRepSummary = {
  __typename?: 'ManagerRepSummary';
  currency_code: Scalars['String']['output'];
  employee_id: Scalars['uuid']['output'];
  employee_name: Scalars['String']['output'];
  mtd: ProspectMetrics;
  wtd: ProspectMetrics;
  ytd: ProspectMetrics;
};

export type ManualDepositPaymentBatchInput = {
  payment_batch_id: Scalars['uuid']['input'];
};

export type ManualDepositSummary = {
  __typename?: 'ManualDepositSummary';
  cash_count: Scalars['Int']['output'];
  check_count: Scalars['Int']['output'];
  deposit_date: Scalars['String']['output'];
  deposit_number: Scalars['String']['output'];
  manual_deposit_id: Scalars['uuid']['output'];
  total_amount_in_micros: Scalars['bigint']['output'];
};

export type ManualIngredientFields = {
  base_unit?: InputMaybe<Scalars['String']['input']>;
  cost_in_micros: Scalars['bigint']['input'];
  ingredient_name: Scalars['String']['input'];
  pack_unit: Scalars['String']['input'];
  unit_count: Scalars['Float']['input'];
};

export type MarkCreditMemoAsClaimedResponse = {
  __typename?: 'MarkCreditMemoAsClaimedResponse';
  credit_memo?: Maybe<Credit_Memos>;
  credit_memo_id: Scalars['uuid']['output'];
};

export type MarkOrderInvoiceAsPaidResponse = {
  __typename?: 'MarkOrderInvoiceAsPaidResponse';
  order_invoice?: Maybe<Order_Invoices>;
  order_invoice_id: Scalars['uuid']['output'];
};

export type MaybeOrderResponse = {
  __typename?: 'MaybeOrderResponse';
  order?: Maybe<Orders>;
  order_id?: Maybe<Scalars['uuid']['output']>;
};

export type MediaEntry = {
  __typename?: 'MediaEntry';
  collection: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  mediaType: Scalars['String']['output'];
  override: Scalars['Boolean']['output'];
  uris: Array<Scalars['String']['output']>;
};

export type MediaOrderEntry = {
  order: Scalars['Int']['input'];
  uri: Scalars['String']['input'];
};

export type MediaType = {
  __typename?: 'MediaType';
  /** Checksum of the normalized media file (e.g., hash for integrity verification). */
  checksum: Scalars['String']['output'];
  /** MIME type of the media file (e.g., 'image/png'). */
  contentType: Scalars['String']['output'];
  /** Timestamp when the media was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Locale of the media asset, formatted as a language-region code (e.g., 'en-US'). */
  locale: Scalars['String']['output'];
  /** General category of the media (e.g., 'image', 'pdf', 'video'). */
  mediaType: Scalars['String']['output'];
  /** Display or usage priority; lower numbers appear first. */
  order: Scalars['Int']['output'];
  /** Metadata for the media, including 'uri', 'alt_text', and optional display hints. */
  parameters: Array<ParameterType>;
  /** URI of the media asset (e.g., '/path/to/media/file.ext'). */
  uri: Scalars['String']['output'];
};

export type MemorizeSmartOrderResponse = {
  __typename?: 'MemorizeSmartOrderResponse';
  smart_order?: Maybe<Smart_Order>;
  smart_order_id: Scalars['uuid']['output'];
};

export type MenuItem = {
  __typename?: 'MenuItem';
  category?: Maybe<Scalars['String']['output']>;
  ingredients: Array<Scalars['String']['output']>;
  item_name: Scalars['String']['output'];
};

export type MenuItemIngredientOutput = {
  __typename?: 'MenuItemIngredientOutput';
  menu_item_ingredient?: Maybe<Menu_Item_Ingredients>;
  menu_item_ingredient_id: Scalars['uuid']['output'];
};

export type MenuItemInput = {
  ingredients: Array<Scalars['String']['input']>;
  item_name: Scalars['String']['input'];
};

export type MessageResponse = {
  __typename?: 'MessageResponse';
  message?: Maybe<Messages>;
  message_id: Scalars['uuid']['output'];
};

export type MetadataType = {
  __typename?: 'MetadataType';
  /** System-level metadata including item checksum, creation/update timestamps, and extra metadata. */
  system: SystemMetadataType;
  /** Tags for the item, used for filtering and searching. */
  tags: Array<Scalars['String']['output']>;
  /** Validation results for specific fields with result, severity, and timestamp. */
  validation: Array<ValidationType>;
};

export type MicrobeType = {
  __typename?: 'MicrobeType';
  method?: Maybe<Scalars['String']['output']>;
  microbeCode?: Maybe<Scalars['String']['output']>;
  minValue?: Maybe<Scalars['String']['output']>;
  uom?: Maybe<Scalars['String']['output']>;
};

export type MonthlyCommissionsHubCardData = {
  __typename?: 'MonthlyCommissionsHubCardData';
  card_type: HubCardType;
  currency_code: Scalars['String']['output'];
  current_month_commission_in_micros?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<CompleteTranslation>;
  previous_month_commission_in_micros?: Maybe<Scalars['Int']['output']>;
  previous_period: CompleteTranslation;
  subtitle: CompleteTranslation;
  title: CompleteTranslation;
};

export type NextAutoPayInfoResponse = {
  __typename?: 'NextAutoPayInfoResponse';
  amount_in_micros: Scalars['bigint']['output'];
  auto_pay_settings?: Maybe<Auto_Pay_Settings>;
  auto_pay_settings_id: Scalars['uuid']['output'];
  date: Scalars['String']['output'];
};

export type NextDeliveryDateResponse = {
  __typename?: 'NextDeliveryDateResponse';
  next_delivery_date: Scalars['String']['output'];
  next_placement_date: Scalars['String']['output'];
};

/** An object with globally unique ID */
export type Node = {
  /** A globally unique identifier */
  id: Scalars['ID']['output'];
};

export type NutrientInput = {
  /** Measured quantity of the nutrient (e.g., 12.5). */
  amount: Scalars['Float']['input'];
  /** Locale for the nutrient name, formatted as a language-region code (e.g., 'en-US'). */
  locale?: Scalars['String']['input'];
  /** Name of the nutrient (e.g., 'Protein', 'Vitamin C'). */
  name: Scalars['String']['input'];
  /** Optional percent daily value (%DV), represented as a string (e.g., '25%'). */
  percentDv?: Scalars['String']['input'];
  /** Unit of measurement (e.g., 'g', 'mg', 'kcal'). */
  unitName: Scalars['String']['input'];
};

export type NutrientType = {
  __typename?: 'NutrientType';
  additionalInformation: Array<GenericAttributeType>;
  amount?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentDv?: Maybe<Scalars['String']['output']>;
  unitName?: Maybe<Scalars['String']['output']>;
};

export type NutrientV2 = {
  __typename?: 'NutrientV2';
  /** Measured quantity of the nutrient (e.g., 12.5). */
  amount: Scalars['Float']['output'];
  /** Locale for the nutrient name, formatted as a language-region code (e.g., 'en-US'). */
  locale: Scalars['String']['output'];
  /** Name of the nutrient (e.g., 'Protein', 'Vitamin C'). */
  name: Scalars['String']['output'];
  /** Optional percent daily value (%DV), represented as a string (e.g., '25%'). */
  percentDv: Scalars['String']['output'];
  /** Unit of measurement (e.g., 'g', 'mg', 'kcal'). */
  unitName: Scalars['String']['output'];
};

export type NutritionFactsInput = {
  /** Additional label entries as key-value pairs (e.g., 'density': '1.2 g/mL'). */
  additionalFacts?: Array<ParameterInput>;
  /** Calories per declared serving size. */
  caloriesPerServing?: InputMaybe<Scalars['Int']['input']>;
  /** Optional text for legal or brand-specific disclaimers. */
  disclaimer?: Scalars['String']['input'];
  /** Declared serving size (e.g., '30g', '1 cup'). */
  servingSize?: Scalars['String']['input'];
};

export type NutritionFactsType = {
  __typename?: 'NutritionFactsType';
  /** Additional label entries as key-value pairs (e.g., 'density': '1.2 g/mL'). */
  additionalFacts: Array<ParameterType>;
  /** Calories per declared serving size. */
  caloriesPerServing?: Maybe<Scalars['Int']['output']>;
  /** Optional text for legal or brand-specific disclaimers. */
  disclaimer: Scalars['String']['output'];
  /** Declared serving size (e.g., '30g', '1 cup'). */
  servingSize: Scalars['String']['output'];
};

export type NutritionInput = {
  /** Nutrition label context including serving size, calories, and label-level declarations such as disclaimers or footnotes. */
  facts: NutritionFactsInput;
  /** List of measured nutrients (e.g., protein, fat, vitamins), each with localized name, amount, unit, and optional daily value percentage. */
  nutrients?: Array<NutrientInput>;
};

export type NutritionProfileInput = {
  /** Declared or detected allergens associated with the product (e.g., 'milk', 'soy'). Localized per language-region and optionally parameterized. */
  allergens?: Array<AllergenInput>;
  /** List of supported dietary tags (e.g., 'vegan', 'halal', 'gluten-free'), expressed as localized parameters with optional context. */
  dietTypes?: Array<LocalizedValueInput>;
  /** List of localized ingredient names, optionally enriched with metadata such as percentage, origin, or processing details. */
  ingredients?: Array<LocalizedValueInput>;
  /** Comprehensive nutrition block, including calories, serving size, and a list of measured nutrient values. Reflects how the product would appear on a nutrition label. */
  nutrition: NutritionInput;
};

export type NutritionProfileType = {
  __typename?: 'NutritionProfileType';
  /** Declared or detected allergens associated with the product (e.g., 'milk', 'soy'). Localized per language-region and optionally parameterized. */
  allergens: Array<AllergenV2>;
  /** List of supported dietary tags (e.g., 'vegan', 'halal', 'gluten-free'), expressed as localized parameters with optional context. */
  dietTypes: Array<LocalizedValueType>;
  /** List of localized ingredient names, optionally enriched with metadata such as percentage, origin, or processing details. */
  ingredients: Array<LocalizedValueType>;
  /** Comprehensive nutrition block, including calories, serving size, and a list of measured nutrient values. Reflects how the product would appear on a nutrition label. */
  nutrition: NutritionType;
};

export type NutritionType = {
  __typename?: 'NutritionType';
  /** Nutrition label context including serving size, calories, and label-level declarations such as disclaimers or footnotes. */
  facts: NutritionFactsType;
  /** List of measured nutrients (e.g., protein, fat, vitamins), each with localized name, amount, unit, and optional daily value percentage. */
  nutrients: Array<NutrientV2>;
};

export enum ObiItemType {
  ItemClickedInCatalog = 'ITEM_CLICKED_IN_CATALOG',
  ItemClickedInSearch = 'ITEM_CLICKED_IN_SEARCH',
  ItemInCart = 'ITEM_IN_CART'
}

export type ObiItem = {
  __typename?: 'ObiItem';
  event_time: Scalars['String']['output'];
  obi_item_type: ObiItemType;
  subtitle: CompleteTranslation;
  title: Scalars['String']['output'];
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_uuid: Scalars['String']['output'];
};

export type OpenHours = {
  __typename?: 'OpenHours';
  hours_type: Scalars['String']['output'];
  open: Array<OpenHoursDetails>;
};

export type OpenHoursDetails = {
  __typename?: 'OpenHoursDetails';
  day: Scalars['Int']['output'];
  end: Scalars['String']['output'];
  is_overnight: Scalars['Boolean']['output'];
  start: Scalars['String']['output'];
};

export type OperatorEmployeeContact = {
  __typename?: 'OperatorEmployeeContact';
  name: Scalars['String']['output'];
  phone_number: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
};

export type OrderAttentionAlertHubCardData = {
  __typename?: 'OrderAttentionAlertHubCardData';
  alert_status: AnalyticsAlertStatusType;
  alert_uuid: Scalars['String']['output'];
  card_type: HubCardType;
  chat_uuid: Scalars['String']['output'];
  description?: Maybe<CompleteTranslation>;
  issue_description: CompleteTranslation;
  order_amount_in_micros: Scalars['Int']['output'];
  order_number: Scalars['String']['output'];
  order_uuid: Scalars['String']['output'];
  restaurant_uuid: Scalars['String']['output'];
  subtitle: CompleteTranslation;
  supplier_uuid: Scalars['String']['output'];
  title: CompleteTranslation;
};

export type OrderCommission = {
  __typename?: 'OrderCommission';
  estimated_commission_in_micros: Scalars['Int']['output'];
  gross_profit_in_micros?: Maybe<Scalars['Int']['output']>;
  order_id: Scalars['uuid']['output'];
};

export enum OrderConstraintUnit {
  Amount = 'AMOUNT',
  Case = 'CASE',
  Kg = 'KG'
}

export enum OrderDomain {
  Ecomm = 'ECOMM',
  Global = 'GLOBAL',
  OrderAgent = 'ORDER_AGENT',
  SalesPortal = 'SALES_PORTAL',
  SmartOrder = 'SMART_ORDER',
  Storefront = 'STOREFRONT'
}

export type OrderEntryAvailabilityLabel = {
  __typename?: 'OrderEntryAvailabilityLabel';
  i18n_key: Scalars['String']['output'];
  level: OrderEntryLabelLevel;
};

export type OrderEntryCartSummary = {
  __typename?: 'OrderEntryCartSummary';
  currency: Scalars['String']['output'];
  order_fees: OrderEntryOrderFees;
  order_id: Scalars['uuid']['output'];
  split_order_metrics: Array<OrderEntrySplitMetrics>;
};

export type OrderEntryCollectionRequestNote = {
  __typename?: 'OrderEntryCollectionRequestNote';
  collection_id: Scalars['uuid']['output'];
  persist_request: Scalars['Boolean']['output'];
  request?: Maybe<Scalars['String']['output']>;
};

export type OrderEntryCostInfo = {
  __typename?: 'OrderEntryCostInfo';
  details?: Maybe<Array<OrderEntryDetailedCostInfo>>;
};

export type OrderEntryDetailedCostInfo = {
  __typename?: 'OrderEntryDetailedCostInfo';
  cost_in_micros: Scalars['Int']['output'];
  type: VariantPackCostType;
};

export type OrderEntryEssentialItemLabel = {
  __typename?: 'OrderEntryEssentialItemLabel';
  i18n_key: Scalars['String']['output'];
  level: OrderEntryLabelLevel;
};

export type OrderEntryFee = {
  __typename?: 'OrderEntryFee';
  amount_in_micros: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type OrderEntryItem = {
  __typename?: 'OrderEntryItem';
  item_info?: Maybe<OrderEntryItemInfo>;
  labels: OrderEntryLabels;
  order_guide_collection_ids?: Maybe<Array<Scalars['uuid']['output']>>;
  order_info?: Maybe<OrderEntryOrderInfo>;
  order_price_edit?: Maybe<OrderEntryOrderPriceEdit>;
  price_edit_display_info?: Maybe<Array<OrderEntryPriceEditDisplayInfo>>;
  request_notes?: Maybe<Array<OrderEntryCollectionRequestNote>>;
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
  variant_pack_info?: Maybe<OrderEntryVariantPackInfo>;
};

export type OrderEntryItemInfo = {
  __typename?: 'OrderEntryItemInfo';
  brand?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pack_size?: Maybe<Scalars['String']['output']>;
};

export enum OrderEntryLabelLevel {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type OrderEntryLabels = {
  __typename?: 'OrderEntryLabels';
  availability_label?: Maybe<OrderEntryAvailabilityLabel>;
  essential_item_label?: Maybe<OrderEntryEssentialItemLabel>;
  lead_time_label?: Maybe<OrderEntryLeadTimeLabel>;
  order_guide_labels: Array<OrderEntryOrderGuideLabel>;
};

export type OrderEntryLeadTimeLabel = {
  __typename?: 'OrderEntryLeadTimeLabel';
  display_text: CompleteTranslation;
  level: OrderEntryLabelLevel;
};

export type OrderEntryOrderFees = {
  __typename?: 'OrderEntryOrderFees';
  discount?: Maybe<OrderEntryFee>;
  order_promotion_discount?: Maybe<OrderEntryFee>;
  promotion_discount?: Maybe<OrderEntryFee>;
  subtotal?: Maybe<OrderEntryFee>;
  tax?: Maybe<OrderEntryFee>;
  tip?: Maybe<OrderEntryFee>;
  total?: Maybe<OrderEntryFee>;
  volume_discount?: Maybe<OrderEntryFee>;
};

export enum OrderEntryOrderGuideItemFilter {
  All = 'ALL',
  DefaultOnly = 'DEFAULT_ONLY',
  NonDefaultOnly = 'NON_DEFAULT_ONLY'
}

export type OrderEntryOrderGuideLabel = {
  __typename?: 'OrderEntryOrderGuideLabel';
  level: OrderEntryLabelLevel;
  order_guide_name: Scalars['String']['output'];
};

export type OrderEntryOrderInfo = {
  __typename?: 'OrderEntryOrderInfo';
  added_at?: Maybe<Scalars['String']['output']>;
  cart_quantity: Scalars['Float']['output'];
  order?: Maybe<Orders>;
  order_id: Scalars['uuid']['output'];
  order_item?: Maybe<Orders_Items>;
  order_item_id: Scalars['uuid']['output'];
};

export type OrderEntryOrderPriceEdit = {
  __typename?: 'OrderEntryOrderPriceEdit';
  gross_profit_override_in_percentage?: Maybe<Scalars['String']['output']>;
  price_override_in_micros?: Maybe<Scalars['bigint']['output']>;
};

export type OrderEntryPriceEditDisplayHeader = {
  __typename?: 'OrderEntryPriceEditDisplayHeader';
  category: DisplayConfigCategory;
  is_confidential: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  translation: CompleteTranslation;
};

export type OrderEntryPriceEditDisplayInfo = {
  __typename?: 'OrderEntryPriceEditDisplayInfo';
  currency?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  trend?: Maybe<PriceEditDisplayInfoTrend>;
  value?: Maybe<Scalars['String']['output']>;
  value_display?: Maybe<Scalars['String']['output']>;
};

export type OrderEntryPriceEditInfo = {
  __typename?: 'OrderEntryPriceEditInfo';
  active_override?: Maybe<PriceEditType>;
  ceiling_price_in_micros?: Maybe<Scalars['Int']['output']>;
  cost_info?: Maybe<OrderEntryCostInfo>;
  expiration_source?: Maybe<SalesRepOverrideExpirationSource>;
  expires_at?: Maybe<Scalars['String']['output']>;
  gross_profit_override_in_percentage?: Maybe<Scalars['Float']['output']>;
  price_edited_by_user_name?: Maybe<Scalars['String']['output']>;
  price_override_in_micros?: Maybe<Scalars['Int']['output']>;
  variant_pack_settings?: Maybe<OrderEntryVariantPackSettings>;
};

export type OrderEntryRelatedVariantPack = {
  __typename?: 'OrderEntryRelatedVariantPack';
  availability_status?: Maybe<VariantPackAvailabilityStatus>;
  currency_code: Scalars['String']['output'];
  external_item_id?: Maybe<Scalars['String']['output']>;
  pack_display_string: Scalars['String']['output'];
  salt_info?: Maybe<OrderEntrySaltInfo>;
  unit_price_in_micros?: Maybe<Scalars['bigint']['output']>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type OrderEntrySaltInfo = {
  __typename?: 'OrderEntrySaltInfo';
  additional_information: Array<OrderEntrySaltNameValuePair>;
  description?: Maybe<Scalars['String']['output']>;
  image_urls?: Maybe<Array<Scalars['String']['output']>>;
  long_description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  packaging: Array<OrderEntrySaltNameValuePair>;
};

export type OrderEntrySaltNameValuePair = {
  __typename?: 'OrderEntrySaltNameValuePair';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OrderEntrySplitMetrics = {
  __typename?: 'OrderEntrySplitMetrics';
  fulfillment_date?: Maybe<Scalars['String']['output']>;
  fulfillment_type: OrderFulfillmentType;
  gross_profit_in_micros?: Maybe<Scalars['Int']['output']>;
  gross_profit_in_percentage?: Maybe<Scalars['Float']['output']>;
  item_count: Scalars['Float']['output'];
  subtotal_in_micros?: Maybe<Scalars['Int']['output']>;
  unit_count: Scalars['Float']['output'];
};

export type OrderEntryTablePage = {
  __typename?: 'OrderEntryTablePage';
  cursor?: Maybe<Scalars['String']['output']>;
  has_more_pages: Scalars['Boolean']['output'];
  order_entry_items: Array<OrderEntryItem>;
  price_edit_display_headers: Array<OrderEntryPriceEditDisplayHeader>;
};

export type OrderEntryVariantPackInfo = {
  __typename?: 'OrderEntryVariantPackInfo';
  currency: Scalars['String']['output'];
  default_pack_price_in_micros?: Maybe<Scalars['Int']['output']>;
  default_unit_price_in_micros?: Maybe<Scalars['Int']['output']>;
  earliest_fulfillment_date?: Maybe<Scalars['String']['output']>;
  gross_profit_amount_display?: Maybe<Scalars['String']['output']>;
  gross_profit_in_percentage?: Maybe<Scalars['Float']['output']>;
  max_quantity?: Maybe<Scalars['Float']['output']>;
  min_quantity?: Maybe<Scalars['Float']['output']>;
  on_hand_quantity?: Maybe<Scalars['Float']['output']>;
  pack_cost_in_micros?: Maybe<Scalars['Int']['output']>;
  pack_price_display?: Maybe<Scalars['String']['output']>;
  pack_price_in_micros?: Maybe<Scalars['Int']['output']>;
  price_edit_info: OrderEntryPriceEditInfo;
  unit_cost_in_micros?: Maybe<Scalars['Int']['output']>;
  unit_count: Scalars['Float']['output'];
  unit_price_display?: Maybe<Scalars['String']['output']>;
  unit_price_in_micros?: Maybe<Scalars['Int']['output']>;
};

export type OrderEntryVariantPackSettings = {
  __typename?: 'OrderEntryVariantPackSettings';
  disable_override_editing?: Maybe<Scalars['Boolean']['output']>;
  disable_sales_rep_info?: Maybe<Scalars['Boolean']['output']>;
  enable_peak_price_protection?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderFee = {
  __typename?: 'OrderFee';
  amount_at_invoice_micros?: Maybe<Scalars['bigint']['output']>;
  amount_at_order_micros?: Maybe<Scalars['bigint']['output']>;
  display_type: OrderFeeDisplayType;
  external_item_id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum OrderFeeDisplayType {
  Fee = 'FEE',
  Subtotal = 'SUBTOTAL',
  Total = 'TOTAL'
}

export type OrderFulfillmentAvailability = {
  __typename?: 'OrderFulfillmentAvailability';
  cutoff_time?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  lead_time_days?: Maybe<Scalars['Int']['output']>;
  order_minimum_display_string?: Maybe<Scalars['String']['output']>;
  timeslot_settings?: Maybe<FulfillmentTimeslotSettings>;
};

export type OrderFulfillmentFee = {
  __typename?: 'OrderFulfillmentFee';
  amount_in_micros: Scalars['bigint']['output'];
  fulfillment_settings_id: Scalars['uuid']['output'];
};

export enum OrderFulfillmentType {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP',
  SecondRunDelivery = 'SECOND_RUN_DELIVERY',
  Ups_2Day = 'UPS_2_DAY',
  UpsGround = 'UPS_GROUND',
  UpsNextDay = 'UPS_NEXT_DAY'
}

export type OrderGrossProfit = {
  __typename?: 'OrderGrossProfit';
  amount_in_micros: Scalars['Int']['output'];
  currency_code: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

export type OrderGuideCollectionEntryResponse = {
  __typename?: 'OrderGuideCollectionEntryResponse';
  order_guide_collection_id: Scalars['uuid']['output'];
  order_guide_restaurant_collection?: Maybe<Order_Guide_Restaurant_Collection>;
};

export type OrderGuideCollectionForOrderEntry = {
  __typename?: 'OrderGuideCollectionForOrderEntry';
  is_default: Scalars['Boolean']['output'];
  linked_supplier_collection_uuid?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  type: OrderGuideCollectionType;
  uuid: Scalars['uuid']['output'];
};

export enum OrderGuideCollectionType {
  Restaurant = 'RESTAURANT',
  Supplier = 'SUPPLIER'
}

export type OrderGuideItemEntryResponse = {
  __typename?: 'OrderGuideItemEntryResponse';
  order_guide_item_id: Scalars['uuid']['output'];
  order_guide_item_partition_id?: Maybe<Scalars['uuid']['output']>;
  order_guide_restaurant?: Maybe<Order_Guide_Restaurant>;
  order_guide_restaurant_partition?: Maybe<Order_Guide_Restaurant_Partition>;
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type OrderGuidePartitionEntryResponse = {
  __typename?: 'OrderGuidePartitionEntryResponse';
  order_guide_partition_id: Scalars['uuid']['output'];
  order_guide_restaurant_partition?: Maybe<Order_Guide_Restaurant_Partition>;
};

export enum OrderGuideSortOrder {
  Alphabetical = 'ALPHABETICAL',
  AlphabeticalReverse = 'ALPHABETICAL_REVERSE',
  Custom = 'CUSTOM',
  ItemCode = 'ITEM_CODE',
  ItemCodeReverse = 'ITEM_CODE_REVERSE',
  PurchasedDate = 'PURCHASED_DATE'
}

export enum OrderHistoryFilterOperation {
  AnyOf = 'ANY_OF',
  Contains = 'CONTAINS',
  Equals = 'EQUALS',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO'
}

export enum OrderHistoryFilterType {
  FulfillmentDate = 'FULFILLMENT_DATE',
  PlacedDate = 'PLACED_DATE',
  Scope = 'SCOPE',
  Status = 'STATUS',
  SyncStatus = 'SYNC_STATUS',
  Text = 'TEXT'
}

export enum OrderHistorySortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum OrderHistorySortType {
  CustomerName = 'CUSTOMER_NAME',
  FulfillmentDate = 'FULFILLMENT_DATE',
  FulfillmentType = 'FULFILLMENT_TYPE',
  PlacedDate = 'PLACED_DATE',
  Status = 'STATUS'
}

export type OrderInvoice = {
  __typename?: 'OrderInvoice';
  currency_code: Scalars['String']['output'];
  due_at?: Maybe<Scalars['String']['output']>;
  has_payment_link: Scalars['Boolean']['output'];
  invoice_id: Scalars['uuid']['output'];
  invoice_number: Scalars['String']['output'];
  order_fulfillment_at?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  public_url?: Maybe<Scalars['String']['output']>;
  unpaid_amount_in_micros: Scalars['bigint']['output'];
};

export type OrderInvoiceAmountInput = {
  amount_in_micros: Scalars['bigint']['input'];
  order_invoice_id: Scalars['uuid']['input'];
};

export type OrderInvoiceByOrderResponse = {
  __typename?: 'OrderInvoiceByOrderResponse';
  order_invoice?: Maybe<Order_Invoices>;
  order_invoice_id?: Maybe<Scalars['uuid']['output']>;
  public_url?: Maybe<Scalars['String']['output']>;
};

export enum OrderInvoiceCheckInItemStatus {
  Damaged = 'DAMAGED',
  Expired = 'EXPIRED',
  NotOrdered = 'NOT_ORDERED',
  Other = 'OTHER'
}

export type OrderInvoiceGrossProfit = {
  __typename?: 'OrderInvoiceGrossProfit';
  amount_in_micros: Scalars['Int']['output'];
  currency_code: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

export enum OrderInvoiceSource {
  Ingestion = 'INGESTION',
  OrderPlacement = 'ORDER_PLACEMENT',
  PaymentPlan = 'PAYMENT_PLAN',
  SupplierPayments = 'SUPPLIER_PAYMENTS'
}

export type OrderInvoiceToCreateInput = {
  amount_in_micros: Scalars['bigint']['input'];
  reference: Scalars['String']['input'];
};

export type OrderItemPriceEditResponse = {
  __typename?: 'OrderItemPriceEditResponse';
  customer_cost_in_micros?: Maybe<Scalars['bigint']['output']>;
  gross_profit_override_in_percentage?: Maybe<Scalars['String']['output']>;
  order_item_price_edit_id: Scalars['uuid']['output'];
  price_override_in_micros?: Maybe<Scalars['bigint']['output']>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type OrderItemRatingInput = {
  comment: Scalars['String']['input'];
  order_item_id: Scalars['uuid']['input'];
  photo_url_list: Array<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
};

export type OrderMetadataResponse = {
  __typename?: 'OrderMetadataResponse';
  order_metadata_id: Scalars['uuid']['output'];
  storefront_order_metadata?: Maybe<Storefront_Order_Metadata>;
};

export type OrderMinimum = {
  __typename?: 'OrderMinimum';
  amount: Scalars['Float']['output'];
  is_hard: Scalars['Boolean']['output'];
  unit: OrderConstraintUnit;
};

export type OrderPriceEditApprovalRequestResponse = {
  __typename?: 'OrderPriceEditApprovalRequestResponse';
  id: Scalars['uuid']['output'];
  status: OrderPriceEditApprovalRequestStatus;
};

export enum OrderPriceEditApprovalRequestStatus {
  Open = 'OPEN',
  Submitted = 'SUBMITTED'
}

export type OrderResponse = {
  __typename?: 'OrderResponse';
  order?: Maybe<Orders>;
  order_id: Scalars['uuid']['output'];
};

export enum OrderSource {
  Airtable = 'AIRTABLE',
  Api = 'API',
  Invoice = 'INVOICE',
  Mobile = 'MOBILE',
  Payments = 'PAYMENTS',
  Punchout = 'PUNCHOUT',
  SmartOrder = 'SMART_ORDER',
  Subscription = 'SUBSCRIPTION',
  Web = 'WEB'
}

export enum OrderStatus {
  AutoCreated = 'AUTO_CREATED',
  Cancelled = 'CANCELLED',
  ConfirmedBySupplier = 'CONFIRMED_BY_SUPPLIER',
  Delivered = 'DELIVERED',
  Draft = 'DRAFT',
  InExternalReview = 'IN_EXTERNAL_REVIEW',
  InReview = 'IN_REVIEW',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  PendingPayment = 'PENDING_PAYMENT',
  Rated = 'RATED',
  ReceivedBySupplier = 'RECEIVED_BY_SUPPLIER',
  SentToSupplier = 'SENT_TO_SUPPLIER',
  ShouldBeDelivered = 'SHOULD_BE_DELIVERED',
  Undelivered = 'UNDELIVERED',
  ViewedBySupplier = 'VIEWED_BY_SUPPLIER'
}

export type OrderWithFees = {
  __typename?: 'OrderWithFees';
  order?: Maybe<Orders>;
  order_fees: Array<OrderFee>;
  order_id: Scalars['uuid']['output'];
};

export type OrgCustomerRow = {
  __typename?: 'OrgCustomerRow';
  employee?: Maybe<Employees>;
  gross_profit_in_micros_total: Scalars['Int']['output'];
  last_invoice_date?: Maybe<Scalars['String']['output']>;
  line_items_total: Scalars['Float']['output'];
  margin_percentage?: Maybe<Scalars['Float']['output']>;
  order_count: Scalars['Float']['output'];
  pending_edits_count: Scalars['Int']['output'];
  pending_recommendations_count: Scalars['Int']['output'];
  restaurant?: Maybe<Businesses>;
  restaurant_account_id?: Maybe<Scalars['String']['output']>;
  restaurant_id: Scalars['uuid']['output'];
  restaurant_name: Scalars['String']['output'];
  restaurant_segment?: Maybe<Scalars['String']['output']>;
  revenue_in_micros_total: Scalars['Int']['output'];
  sales_rep_id?: Maybe<Scalars['uuid']['output']>;
  sales_rep_name?: Maybe<Scalars['String']['output']>;
  supplier_id: Scalars['uuid']['output'];
};

export type OrgPricingConfigResponse = {
  __typename?: 'OrgPricingConfigResponse';
  bookmarking_enabled: Scalars['Boolean']['output'];
  cost_change_lookback_mode: CostChangeLookbackMode;
  cost_change_week_anchor_day?: Maybe<Scalars['Int']['output']>;
  currency_code?: Maybe<Scalars['String']['output']>;
  customer_table_enabled: Scalars['Boolean']['output'];
  peer_range_column_enabled: Scalars['Boolean']['output'];
  pricing_agent_enabled: Scalars['Boolean']['output'];
  pricing_management_enabled: Scalars['Boolean']['output'];
  show_invoice_history_popover: Scalars['Boolean']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
};

export type OrgVariantPackCostChange = {
  __typename?: 'OrgVariantPackCostChange';
  base_unit?: Maybe<Scalars['String']['output']>;
  cost_in_micros?: Maybe<Scalars['Int']['output']>;
  cost_in_micros_delta?: Maybe<Scalars['Int']['output']>;
  gross_margin_delta_in_micros?: Maybe<Scalars['Int']['output']>;
  gross_profit_percentage?: Maybe<Scalars['Float']['output']>;
  groups: Array<VariantPackGroupMembership>;
  monthly_quantity: Scalars['Int']['output'];
  price_edit_display_headers?: Maybe<Array<PriceEditDisplayHeader>>;
  price_in_micros?: Maybe<Scalars['Int']['output']>;
  price_in_micros_delta?: Maybe<Scalars['Int']['output']>;
  restaurant?: Maybe<Businesses>;
  restaurant_account_id?: Maybe<Scalars['String']['output']>;
  restaurant_id: Scalars['uuid']['output'];
  supplier_display_info?: Maybe<Array<PriceEditDisplayInfoDetail>>;
  supplier_id: Scalars['uuid']['output'];
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
  weekly_quantity: Scalars['Float']['output'];
};

export type OverduePaymentAccountViewData = {
  __typename?: 'OverduePaymentAccountViewData';
  alert_status: AnalyticsAlertStatusType;
  alert_type: AnalyticsAlertType;
  chat_uuid: Scalars['String']['output'];
  data: Array<OverduePaymentAccountViewDataDetails>;
  restaurant_uuid: Scalars['String']['output'];
  subtitle: CompleteTranslation;
  supplier_uuid: Scalars['String']['output'];
  title: CompleteTranslation;
};

export type OverduePaymentAccountViewDataDetails = {
  __typename?: 'OverduePaymentAccountViewDataDetails';
  alert_uuid: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  due_at: Scalars['String']['output'];
  invoice_number: Scalars['String']['output'];
  order_invoice_uuid: Scalars['String']['output'];
};

export type OverduePaymentHubCardData = {
  __typename?: 'OverduePaymentHubCardData';
  alert_status: AnalyticsAlertStatusType;
  alert_uuid: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  card_type: HubCardType;
  chat_uuid: Scalars['String']['output'];
  currency_code: Scalars['String']['output'];
  description?: Maybe<CompleteTranslation>;
  invoice_number: Scalars['String']['output'];
  order_invoice_uuid: Scalars['String']['output'];
  overdue_by_text: CompleteTranslation;
  restaurant_uuid: Scalars['String']['output'];
  subtitle: CompleteTranslation;
  supplier_uuid: Scalars['String']['output'];
  title: CompleteTranslation;
};

export type OverrideEntry = {
  __typename?: 'OverrideEntry';
  collection: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  field: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type PackType = {
  __typename?: 'PackType';
  additionalInformation: Array<GenericAttributeType>;
  grossWeight?: Maybe<Scalars['String']['output']>;
  grossWeightUom?: Maybe<Scalars['String']['output']>;
  netWeight?: Maybe<Scalars['String']['output']>;
  netWeightUom?: Maybe<Scalars['String']['output']>;
  packHeight?: Maybe<Scalars['String']['output']>;
  packHeightUom?: Maybe<Scalars['String']['output']>;
  packLength?: Maybe<Scalars['String']['output']>;
  packLengthUom?: Maybe<Scalars['String']['output']>;
  packWidth?: Maybe<Scalars['String']['output']>;
  packWidthUom?: Maybe<Scalars['String']['output']>;
  unitHeight?: Maybe<Scalars['String']['output']>;
  unitHeightUom?: Maybe<Scalars['String']['output']>;
  unitLength?: Maybe<Scalars['String']['output']>;
  unitLengthUom?: Maybe<Scalars['String']['output']>;
  unitWidth?: Maybe<Scalars['String']['output']>;
  unitWidthUom?: Maybe<Scalars['String']['output']>;
};

export enum PackUnit {
  Bag = 'BAG',
  Bale = 'BALE',
  Barrel = 'BARREL',
  Basket = 'BASKET',
  Bch = 'BCH',
  Bin = 'BIN',
  BinOf_36 = 'BIN_OF_36',
  BinOf_45 = 'BIN_OF_45',
  BinOf_60 = 'BIN_OF_60',
  Block = 'BLOCK',
  BoardFoot = 'BOARD_FOOT',
  Bottle = 'BOTTLE',
  Bouquet = 'BOUQUET',
  Box = 'BOX',
  Braid = 'BRAID',
  Break = 'BREAK',
  Bucket = 'BUCKET',
  Bulk = 'BULK',
  Bunch = 'BUNCH',
  Bundle = 'BUNDLE',
  Bushel = 'BUSHEL',
  Can = 'CAN',
  Canister = 'CANISTER',
  Card = 'CARD',
  Carton = 'CARTON',
  Case = 'CASE',
  Centimeter = 'CENTIMETER',
  ClamshellBox = 'CLAMSHELL_BOX',
  Container = 'CONTAINER',
  Count = 'COUNT',
  Crate = 'CRATE',
  Cube = 'CUBE',
  CubicCentimeter = 'CUBIC_CENTIMETER',
  CubicFoot = 'CUBIC_FOOT',
  CubicYard = 'CUBIC_YARD',
  Cup = 'CUP',
  Curie = 'CURIE',
  Cylinder = 'CYLINDER',
  Day = 'DAY',
  Deal = 'DEAL',
  Dewar = 'DEWAR',
  Diameter = 'DIAMETER',
  Dispenser = 'DISPENSER',
  Display = 'DISPLAY',
  Dozen = 'DOZEN',
  Drum = 'DRUM',
  Each = 'EACH',
  EighthWheel = 'EIGHTH_WHEEL',
  Fish = 'FISH',
  FivePoundSplit = 'FIVE_POUND_SPLIT',
  Flat = 'FLAT',
  Foot = 'FOOT',
  Gallon = 'GALLON',
  Grain = 'GRAIN',
  Gram = 'GRAM',
  Gross = 'GROSS',
  HalfBox = 'HALF_BOX',
  HalfBushel = 'HALF_BUSHEL',
  HalfCase = 'HALF_CASE',
  HalfDozen = 'HALF_DOZEN',
  HalfFlat = 'HALF_FLAT',
  HalfGallon = 'HALF_GALLON',
  HalfPound = 'HALF_POUND',
  HalfWheel = 'HALF_WHEEL',
  Hamper = 'HAMPER',
  Head = 'HEAD',
  Hour = 'HOUR',
  Hundred = 'HUNDRED',
  HundredWeight = 'HUNDRED_WEIGHT',
  Inch = 'INCH',
  Individual = 'INDIVIDUAL',
  Inner = 'INNER',
  Jar = 'JAR',
  Jerry = 'JERRY',
  Jug = 'JUG',
  Keg = 'KEG',
  Kg = 'KG',
  Kilogram = 'KILOGRAM',
  Kit = 'KIT',
  Label = 'LABEL',
  Lambda = 'LAMBDA',
  Layer = 'LAYER',
  Lb = 'LB',
  Length = 'LENGTH',
  LinearFoot = 'LINEAR_FOOT',
  LinearYard = 'LINEAR_YARD',
  Liter = 'LITER',
  Loaf = 'LOAF',
  Loin = 'LOIN',
  Lot = 'LOT',
  Lug = 'LUG',
  MasterCase = 'MASTER_CASE',
  MasterPack = 'MASTER_PACK',
  Meter = 'METER',
  Micron = 'MICRON',
  Milligram = 'MILLIGRAM',
  Milliliter = 'MILLILITER',
  Millimeter = 'MILLIMETER',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Number_6Can = 'NUMBER_6_CAN',
  Number_10Can = 'NUMBER_10_CAN',
  Omega = 'OMEGA',
  Ounce = 'OUNCE',
  Outer = 'OUTER',
  Pack = 'PACK',
  Package = 'PACKAGE',
  Packet = 'PACKET',
  Page = 'PAGE',
  Pail = 'PAIL',
  Pair = 'PAIR',
  Pallet = 'PALLET',
  Pc1 = 'PC1',
  Pc5 = 'PC5',
  Peck = 'PECK',
  Piece = 'PIECE',
  Pint = 'PINT',
  Portion = 'PORTION',
  Pouch = 'POUCH',
  Pound = 'POUND',
  PoundSplit = 'POUND_SPLIT',
  Quart = 'QUART',
  Quarter = 'QUARTER',
  QuarterBox = 'QUARTER_BOX',
  QuarterWheel = 'QUARTER_WHEEL',
  Rack = 'RACK',
  Ream = 'REAM',
  Rod = 'ROD',
  Roll = 'ROLL',
  Sack = 'SACK',
  Segment = 'SEGMENT',
  Set = 'SET',
  Sheet = 'SHEET',
  Side = 'SIDE',
  Sleeve = 'SLEEVE',
  Slv = 'SLV',
  SmallBox = 'SMALL_BOX',
  Split = 'SPLIT',
  Spool = 'SPOOL',
  SquareFoot = 'SQUARE_FOOT',
  SquareYard = 'SQUARE_YARD',
  Stalk = 'STALK',
  Stem = 'STEM',
  Tag = 'TAG',
  Tail = 'TAIL',
  Thousand = 'THOUSAND',
  Tin = 'TIN',
  Tote = 'TOTE',
  Transaction = 'TRANSACTION',
  Tray = 'TRAY',
  Tub = 'TUB',
  Tube = 'TUBE',
  Unit = 'UNIT',
  Vial = 'VIAL',
  Wedge = 'WEDGE',
  Week = 'WEEK',
  WetPack = 'WET_PACK',
  Wheel = 'WHEEL',
  Whole = 'WHOLE',
  Wing = 'WING',
  Yard = 'YARD',
  Year = 'YEAR',
  '2EachPack' = '_2_EACH_PACK',
  '2Gallon' = '_2_GALLON',
  '2PoundSplit' = '_2_POUND_SPLIT',
  '3EachPack' = '_3_EACH_PACK',
  '4EachPack' = '_4_EACH_PACK',
  '5Gallon' = '_5_GALLON',
  '6EachPack' = '_6_EACH_PACK',
  '8EachPack' = '_8_EACH_PACK'
}

export type PackageDimensionsInput = {
  /** Height of the package (e.g., '12 in'). */
  height?: Scalars['String']['input'];
  /** Length of the package (e.g., '12 in'). */
  length?: Scalars['String']['input'];
  /** Unit of measurement (e.g., 'in', 'cm'). */
  uom?: Scalars['String']['input'];
  /** Width of the package (e.g., '12 in'). */
  width?: Scalars['String']['input'];
};

export type PackageDimensionsType = {
  __typename?: 'PackageDimensionsType';
  /** Height of the package (e.g., '12 in'). */
  height: Scalars['String']['output'];
  /** Length of the package (e.g., '12 in'). */
  length: Scalars['String']['output'];
  /** Unit of measurement (e.g., 'in', 'cm'). */
  uom: Scalars['String']['output'];
  /** Width of the package (e.g., '12 in'). */
  width: Scalars['String']['output'];
};

export type PackagingAndStorageType = {
  __typename?: 'PackagingAndStorageType';
  packaging: PackType;
  storage: Array<GenericAttributeType>;
};

export type PackagingInfoResult = {
  processed_packaging_info: ProcessedPackagingInfo;
  variant_pack_id: Scalars['uuid']['input'];
};

export type PackagingInput = {
  /** Gross weight of the package (e.g., '12 lbs'). */
  grossWeight?: Scalars['String']['input'];
  /** Primary identifier for this package (e.g., GTIN). */
  identifier?: Scalars['String']['input'];
  /** Net weight of the package (e.g., '12 lbs'). */
  netWeight?: Scalars['String']['input'];
  /** Amount of the unit in the pack e.g. '12 oz. Used to construct the pack size. */
  packSizeUnitAmount?: InputMaybe<Scalars['String']['input']>;
  /** Number of units in the pack. */
  packSizeUnitCount?: InputMaybe<Scalars['Int']['input']>;
  /** Dimensions of the package. */
  packageDimensions: PackageDimensionsInput;
  /** Identifier for the package configuration (e.g., pack ID). */
  packageIdentifier?: Scalars['String']['input'];
  /** Type of packaging (e.g., 'box', 'case', 'bag'). */
  packageType?: Scalars['String']['input'];
  /** Unit of measurement for the weight (e.g., 'lbs', 'kg'). */
  packageWeightUom?: Scalars['String']['input'];
  /** Number of servings contained in the package. */
  servingsPerPackage?: Scalars['String']['input'];
  /** Shipping information of the package. */
  shippingInfo: ShippingInfoInput;
  /** Identifier type (e.g., 'GTIN-14', 'GTIN-12'). */
  type?: Scalars['String']['input'];
};

export type PackagingType = {
  __typename?: 'PackagingType';
  /** Gross weight of the package (e.g., '12 lbs'). */
  grossWeight: Scalars['String']['output'];
  /** Primary identifier for this package (e.g., GTIN). */
  identifier: Scalars['String']['output'];
  /** Net weight of the package (e.g., '12 lbs'). */
  netWeight: Scalars['String']['output'];
  /** Amount of the unit in the pack e.g. '12 oz. Used to construct the pack size. */
  packSizeUnitAmount?: Maybe<Scalars['String']['output']>;
  /** Number of units in the pack. */
  packSizeUnitCount?: Maybe<Scalars['Int']['output']>;
  /** Dimensions of the package. */
  packageDimensions: PackageDimensionsType;
  /** Identifier for the package configuration (e.g., pack ID). */
  packageIdentifier: Scalars['String']['output'];
  /** Type of packaging (e.g., 'box', 'case', 'bag'). */
  packageType: Scalars['String']['output'];
  /** Unit of measurement for the weight (e.g., 'lbs', 'kg'). */
  packageWeightUom: Scalars['String']['output'];
  /** Number of servings contained in the package. */
  servingsPerPackage: Scalars['String']['output'];
  /** Shipping information of the package. */
  shippingInfo: ShippingInfoType;
  /** Identifier type (e.g., 'GTIN-14', 'GTIN-12'). */
  type: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
};

export type PaidSearchEventData = {
  __typename?: 'PaidSearchEventData';
  ad_campaign_id: Scalars['uuid']['output'];
  ad_manager_id: Scalars['uuid']['output'];
  add_to_cart_event_id: Scalars['String']['output'];
  advertiser_id: Scalars['uuid']['output'];
  click_event_id: Scalars['String']['output'];
  gtin: Scalars['String']['output'];
  impression_event_id: Scalars['String']['output'];
  matching_keyword: Scalars['String']['output'];
  purchase_event_id: Scalars['String']['output'];
  variant_pack_id: Scalars['uuid']['output'];
};

export enum PaidSource {
  Api = 'API',
  AppMobile = 'APP_MOBILE',
  AppWeb = 'APP_WEB',
  Autopay = 'AUTOPAY',
  Backfill = 'BACKFILL',
  BulkCsvPayment = 'BULK_CSV_PAYMENT',
  BulkPayment = 'BULK_PAYMENT',
  Cash = 'CASH',
  CheckCapture = 'CHECK_CAPTURE',
  CheckScanner = 'CHECK_SCANNER',
  CustomPayment = 'CUSTOM_PAYMENT',
  Klarna = 'KLARNA',
  ManagedPayout = 'MANAGED_PAYOUT',
  ManualCheck = 'MANUAL_CHECK',
  MobileTerminal = 'MOBILE_TERMINAL',
  PaymentLink = 'PAYMENT_LINK',
  PaymentPlan = 'PAYMENT_PLAN',
  StatementEmail = 'STATEMENT_EMAIL',
  Terminal = 'TERMINAL'
}

export type ParameterInput = {
  /** The name of the parameter (e.g., 'confidence', 'source'). */
  key: Scalars['String']['input'];
  /** The value associated with the key (stored as a string). */
  value: Scalars['String']['input'];
};

export type ParameterType = {
  __typename?: 'ParameterType';
  /** The name of the parameter (e.g., 'confidence', 'source'). */
  key: Scalars['String']['output'];
  /** The value associated with the key (stored as a string). */
  value: Scalars['String']['output'];
};

export type ParsedAttachmentResult = {
  attachment_id?: InputMaybe<Scalars['String']['input']>;
  is_for_parsing: Scalars['Boolean']['input'];
  is_for_viewing: Scalars['Boolean']['input'];
  is_original: Scalars['Boolean']['input'];
  mime_type: Scalars['String']['input'];
  original_filename?: InputMaybe<Scalars['String']['input']>;
  page_number?: InputMaybe<Scalars['Int']['input']>;
  parsed_text?: InputMaybe<Scalars['String']['input']>;
  segments?: InputMaybe<Array<ParsedOrderSegment>>;
  transcript_words?: InputMaybe<Array<TranscriptWord>>;
  url: Scalars['String']['input'];
};

export type ParsedItemResult = {
  alternative_matches?: InputMaybe<Array<AlternativeMatch>>;
  final_quantity?: InputMaybe<Scalars['Float']['input']>;
  intent: SmartOrderIntent;
  item_code?: InputMaybe<Scalars['String']['input']>;
  item_name?: InputMaybe<Scalars['String']['input']>;
  matched_image_coords?: InputMaybe<Array<ImageCoords>>;
  matched_image_url?: InputMaybe<Scalars['String']['input']>;
  matched_text: Scalars['String']['input'];
  metonym_uuid?: InputMaybe<Scalars['uuid']['input']>;
  original_pack_unit?: InputMaybe<Scalars['String']['input']>;
  original_quantity?: InputMaybe<Scalars['Float']['input']>;
  pack_unit?: InputMaybe<PackUnit>;
  reason: Scalars['String']['input'];
  search_term: Scalars['String']['input'];
  translations?: InputMaybe<ParsedItemResultTranslations>;
  variant_pack_uuid?: InputMaybe<Scalars['uuid']['input']>;
};

export type ParsedItemResultTranslations = {
  item_code?: InputMaybe<ParsedTranslationInfo>;
  matched_text?: InputMaybe<ParsedTranslationInfo>;
  original_pack_unit?: InputMaybe<ParsedTranslationInfo>;
  original_quantity?: InputMaybe<ParsedTranslationInfo>;
  search_term?: InputMaybe<ParsedTranslationInfo>;
};

export type ParsedOrderResponseTranslations = {
  search_text?: InputMaybe<ParsedTranslationInfo>;
  subject?: InputMaybe<ParsedTranslationInfo>;
};

export type ParsedOrderSegment = {
  matched_text: Scalars['String']['input'];
  start_seconds?: InputMaybe<Scalars['Float']['input']>;
  translations?: InputMaybe<ParsedOrderSegmentTranslations>;
};

export type ParsedOrderSegmentTranslations = {
  matched_text: ParsedTranslationInfo;
};

export type ParsedSmartOrder = {
  column_headers?: InputMaybe<Array<Scalars['String']['input']>>;
  final_results: Array<ParsedItemResult>;
  fulfillment_date_str?: InputMaybe<Scalars['String']['input']>;
  fulfillment_type?: InputMaybe<OrderFulfillmentType>;
  parsed_attachments: Array<ParsedAttachmentResult>;
  po_number?: InputMaybe<Scalars['String']['input']>;
  restaurant_matched_text?: InputMaybe<Scalars['String']['input']>;
  restaurant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  search_text?: InputMaybe<Scalars['String']['input']>;
  segments?: InputMaybe<Array<ParsedOrderSegment>>;
  supplier_uuid: Scalars['uuid']['input'];
  transcript_words: Array<TranscriptWord>;
  translations?: InputMaybe<ParsedOrderResponseTranslations>;
};

export type ParsedTranslationCase = {
  locale: Scalars['String']['input'];
  translation: Scalars['String']['input'];
};

export type ParsedTranslationInfo = {
  detected_languages: Array<Scalars['String']['input']>;
  translations: Array<ParsedTranslationCase>;
};

export type PartialPaymentCreditMemoInput = {
  credit_memo_id: Scalars['uuid']['input'];
};

export type PartialPaymentInvoiceInput = {
  amount_in_micros_string: Scalars['String']['input'];
  order_invoice_id: Scalars['uuid']['input'];
};

export type PayByLinkRecipient = {
  __typename?: 'PayByLinkRecipient';
  email?: Maybe<Scalars['String']['output']>;
  employee_id?: Maybe<Scalars['uuid']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['uuid']['output'];
};

export type PaymentBatchFeeInput = {
  amount_in_micros_string: Scalars['String']['input'];
  name: PaymentBatchLineItemName;
  type?: InputMaybe<TransactionFeesType>;
};

export enum PaymentBatchLineItemName {
  Refund = 'REFUND',
  TransactionFee = 'TRANSACTION_FEE'
}

export type PaymentLinkCreditMemo = {
  __typename?: 'PaymentLinkCreditMemo';
  credit_memo?: Maybe<Credit_Memos>;
  id: Scalars['uuid']['output'];
  public_url?: Maybe<Scalars['String']['output']>;
  remaining_balance_in_micros: Scalars['Int']['output'];
};

export type PaymentLinkInvoice = {
  __typename?: 'PaymentLinkInvoice';
  id: Scalars['uuid']['output'];
  order_invoice?: Maybe<Order_Invoices>;
  public_url?: Maybe<Scalars['String']['output']>;
  remaining_balance_in_micros: Scalars['Int']['output'];
};

export type PaymentLinkResponse = {
  __typename?: 'PaymentLinkResponse';
  credit_memos_count: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  invoices_count: Scalars['Int']['output'];
  payment_link?: Maybe<Payment_Links>;
  payment_link_url: Scalars['String']['output'];
  total_remaining_balance_in_micros: Scalars['Int']['output'];
};

export type PaymentPlanInvoice = {
  __typename?: 'PaymentPlanInvoice';
  invoice_id: Scalars['uuid']['output'];
  invoice_number: Scalars['String']['output'];
  unpaid_amount_in_micros: Scalars['bigint']['output'];
};

export type PaymentStatementEmailSettingsInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_default: Scalars['Boolean']['input'];
  task_frequency_settings: TaskFrequencySettingsInput;
};

export type PlaidCreatePaymentMethodOutput = {
  __typename?: 'PlaidCreatePaymentMethodOutput';
  account_id?: Maybe<Scalars['String']['output']>;
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
};

export type PlaidCreateSessionResponse = {
  __typename?: 'PlaidCreateSessionResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  session_token?: Maybe<Scalars['String']['output']>;
};

export type PlaidGetSessionInfoResponse = {
  __typename?: 'PlaidGetSessionInfoResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  link_token?: Maybe<Scalars['String']['output']>;
  restaurant_id?: Maybe<Scalars['uuid']['output']>;
  supplier_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

export type PrepareCheckCaptureResponse = {
  __typename?: 'PrepareCheckCaptureResponse';
  alert_level?: Maybe<Scalars['String']['output']>;
  alert_message?: Maybe<Scalars['String']['output']>;
  front_s3_key?: Maybe<Scalars['String']['output']>;
  front_upload_url?: Maybe<Scalars['String']['output']>;
  misnap_license?: Maybe<Scalars['String']['output']>;
  rear_s3_key?: Maybe<Scalars['String']['output']>;
  rear_upload_url?: Maybe<Scalars['String']['output']>;
};

export type PriceDraftUpdate = {
  __typename?: 'PriceDraftUpdate';
  new_gross_profit_in_percentage?: Maybe<Scalars['String']['output']>;
  new_sales_rep_price_in_micros: Scalars['bigint']['output'];
  restaurant?: Maybe<Businesses>;
  restaurant_id: Scalars['uuid']['output'];
  supplier_id: Scalars['uuid']['output'];
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type PriceEditDisplayHeader = {
  __typename?: 'PriceEditDisplayHeader';
  category: DisplayConfigCategory;
  is_confidential: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  translation: CompleteTranslation;
};

export type PriceEditDisplayInfoDetail = {
  __typename?: 'PriceEditDisplayInfoDetail';
  currency?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  trend?: Maybe<PriceEditDisplayInfoTrend>;
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type PriceEditDisplayInfoResponse = {
  __typename?: 'PriceEditDisplayInfoResponse';
  title_translations: Array<PriceEditTitleTranslation>;
  variant_pack_details: Array<PriceEditVariantPackDetail>;
};

export enum PriceEditDisplayInfoTrend {
  Down = 'DOWN',
  Up = 'UP'
}

export type PriceEditTitleTranslation = {
  __typename?: 'PriceEditTitleTranslation';
  title: Scalars['String']['output'];
  translation: Scalars['String']['output'];
};

export enum PriceEditType {
  GrossProfit = 'GROSS_PROFIT',
  Price = 'PRICE'
}

export type PriceEditVariantPackDetail = {
  __typename?: 'PriceEditVariantPackDetail';
  detail: Array<PriceEditDisplayInfoDetail>;
  settings?: Maybe<PriceEditVariantPackDisplaySettings>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type PriceEditVariantPackDisplaySettings = {
  __typename?: 'PriceEditVariantPackDisplaySettings';
  disable_override_editing?: Maybe<Scalars['Boolean']['output']>;
  disable_sales_rep_info?: Maybe<Scalars['Boolean']['output']>;
  enable_peak_price_protection?: Maybe<Scalars['Boolean']['output']>;
};

export type PriceQuoteByOrderGuideResponse = {
  __typename?: 'PriceQuoteByOrderGuideResponse';
  order_guide_collection_id: Scalars['uuid']['output'];
  public_url?: Maybe<Scalars['String']['output']>;
};

export type PriceQuoteDetailsResponse = {
  __typename?: 'PriceQuoteDetailsResponse';
  price_quote_document_url: Scalars['String']['output'];
  supplier_accent_color: Scalars['String']['output'];
  supplier_app_icon_image_url: Scalars['String']['output'];
  supplier_name: Scalars['String']['output'];
};

export enum PriceQuoteFormat {
  Csv = 'CSV',
  Pdf = 'PDF'
}

export type PriceQuoteItemSearchResult = {
  __typename?: 'PriceQuoteItemSearchResult';
  currency_code: Scalars['String']['output'];
  item_code?: Maybe<Scalars['String']['output']>;
  item_description?: Maybe<Scalars['String']['output']>;
  item_name: Scalars['String']['output'];
  item_pack_size?: Maybe<Scalars['String']['output']>;
  pack_price_in_micros: Scalars['bigint']['output'];
  per_unit_price_in_micros?: Maybe<Scalars['bigint']['output']>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type PriceTrendsDataPoint = {
  __typename?: 'PriceTrendsDataPoint';
  occurrences: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
};

export type PricingBookmarkRef = {
  __typename?: 'PricingBookmarkRef';
  bookmarked_at: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<Businesses>;
  restaurant_id: Scalars['uuid']['output'];
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type PricingHubAgentRecs = {
  __typename?: 'PricingHubAgentRecs';
  to_review_count: Scalars['Int']['output'];
  weekly_gp_impact_in_micros: Scalars['bigint']['output'];
};

export type PricingHubCostChanges = {
  __typename?: 'PricingHubCostChanges';
  item_count: Scalars['Int']['output'];
  weekly_gp_impact_in_micros: Scalars['bigint']['output'];
};

export type PricingHubCustomers = {
  __typename?: 'PricingHubCustomers';
  realized_gm_percentage?: Maybe<Scalars['Float']['output']>;
  weekly_gross_profit_in_micros: Scalars['bigint']['output'];
  weekly_revenue_in_micros: Scalars['bigint']['output'];
};

export type PricingHubRecentChange = {
  __typename?: 'PricingHubRecentChange';
  base_unit?: Maybe<Scalars['String']['output']>;
  cost_in_micros?: Maybe<Scalars['bigint']['output']>;
  event: Scalars['String']['output'];
  gross_profit_percentage?: Maybe<Scalars['Float']['output']>;
  item_name: Scalars['String']['output'];
  price_in_micros: Scalars['bigint']['output'];
  restaurant_id: Scalars['uuid']['output'];
  restaurant_name: Scalars['String']['output'];
  source: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
  variant_pack_id: Scalars['uuid']['output'];
  weekly_gp_impact_in_micros: Scalars['bigint']['output'];
};

export type PricingPeerGroup = {
  __typename?: 'PricingPeerGroup';
  id: Scalars['String']['output'];
  max_gross_profit_in_percentage: Scalars['Float']['output'];
  min_gross_profit_in_percentage: Scalars['Float']['output'];
};

export enum PricingPriceUpdateSource {
  Api = 'API',
  CatalogResolver = 'CATALOG_RESOLVER',
  Chile = 'CHILE',
  Greedyants = 'GREEDYANTS',
  OrderEntry = 'ORDER_ENTRY',
  PricingAgent = 'PRICING_AGENT',
  PricingManagement = 'PRICING_MANAGEMENT',
  SalesRepTooling = 'SALES_REP_TOOLING',
  Storefront = 'STOREFRONT'
}

export type PricingRecommendationActionInput = {
  action: RecommendationAction;
  new_gross_profit_in_percentage?: InputMaybe<Scalars['String']['input']>;
  new_price_in_micros?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<PricingRecommendationReasonInput>;
  recommendation_id: Scalars['uuid']['input'];
};

export type PricingRecommendationActionsSupplierResult = {
  __typename?: 'PricingRecommendationActionsSupplierResult';
  alert?: Maybe<PricingRecommendationAlert>;
  supplier_id: Scalars['uuid']['output'];
};

export type PricingRecommendationAlert = {
  __typename?: 'PricingRecommendationAlert';
  alert_level: AlertLevel;
  alert_message: Scalars['String']['output'];
  deleted_draft_update_ids: Array<Scalars['uuid']['output']>;
};

export type PricingRecommendationOutput = {
  __typename?: 'PricingRecommendationOutput';
  created_at: Scalars['String']['output'];
  gross_profit_in_percentage?: Maybe<Scalars['Float']['output']>;
  invoice_history?: Maybe<Array<DetailVariantPackInvoiceHistoryEntry>>;
  new_price_in_micros: Scalars['Int']['output'];
  peer_group?: Maybe<PricingPeerGroup>;
  published_at?: Maybe<Scalars['String']['output']>;
  reasoning: Scalars['String']['output'];
  recommended_gross_profit_in_percentage?: Maybe<Scalars['Float']['output']>;
  recommended_price_in_micros?: Maybe<Scalars['Int']['output']>;
  restaurant?: Maybe<Businesses>;
  restaurant_account_id?: Maybe<Scalars['String']['output']>;
  restaurant_id: Scalars['uuid']['output'];
  review_status: Scalars['String']['output'];
  snapshot_cost_in_micros: Scalars['Int']['output'];
  snapshot_gross_profit_in_percentage?: Maybe<Scalars['Float']['output']>;
  snapshot_price_in_micros: Scalars['Int']['output'];
  supplier_id: Scalars['uuid']['output'];
  task_run_id: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
  weekly_gp_impact_in_micros?: Maybe<Scalars['Int']['output']>;
  weekly_volume?: Maybe<Scalars['Float']['output']>;
};

export type PricingRecommendationProgress = {
  __typename?: 'PricingRecommendationProgress';
  accepted: Scalars['Int']['output'];
  overridden: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
};

export type PricingRecommendationReasonInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  tags: Array<Scalars['String']['input']>;
};

export enum PricingTaskCategory {
  Margin = 'MARGIN',
  Volume = 'VOLUME'
}

export type PricingTaskRunSummary = {
  __typename?: 'PricingTaskRunSummary';
  auto_publish_at?: Maybe<Scalars['String']['output']>;
  completed_at?: Maybe<Scalars['String']['output']>;
  methodology_summary?: Maybe<Scalars['String']['output']>;
  pending_recommendations_count: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  supplier_id: Scalars['uuid']['output'];
  task_id: Scalars['uuid']['output'];
  task_name: Scalars['String']['output'];
  task_run_id: Scalars['uuid']['output'];
};

export type PricingTaskRunSummaryByType = {
  __typename?: 'PricingTaskRunSummaryByType';
  accepted_recommendations_count: Scalars['Int']['output'];
  auto_publish_at?: Maybe<Scalars['String']['output']>;
  category: PricingTaskCategory;
  description?: Maybe<Scalars['String']['output']>;
  last_completed_at?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  overridden_recommendations_count: Scalars['Int']['output'];
  pending_recommendations_count: Scalars['Int']['output'];
  rejected_recommendations_count: Scalars['Int']['output'];
  sort_order: Scalars['Int']['output'];
  task_group?: Maybe<Scalars['String']['output']>;
  task_type_id: Scalars['uuid']['output'];
  weekly_gp_impact_in_micros: Scalars['bigint']['output'];
};

export type PrintTagAttribute = {
  __typename?: 'PrintTagAttribute';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum PrintTagBatchRenderOrderBy {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC'
}

export type PrintTagBatchResponse = {
  __typename?: 'PrintTagBatchResponse';
  print_tag_batch?: Maybe<Print_Tag_Batches>;
  print_tag_batch_id: Scalars['uuid']['output'];
};

export type PrintTagBatchVariantPackInput = {
  quantity: Scalars['Int']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};

export type PrintTagPreviewDisplayField = {
  __typename?: 'PrintTagPreviewDisplayField';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProcessMobileTerminalResponseResponse = {
  __typename?: 'ProcessMobileTerminalResponseResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  result_code?: Maybe<Scalars['String']['output']>;
};

export type ProcessedPackagingInfo = {
  sub_packs?: InputMaybe<Array<ProcessedPackagingInfo>>;
  unit: PackUnit;
  unit_count: Scalars['Float']['input'];
};

export type ProductUsageInformationInput = {
  /** Structured composition information including substances, hazards, and sustainability. */
  composition: CompositionInput;
  /** Localized preparation instructions for the product. */
  preparations?: Array<LocalizedParameterInput>;
  /** Localized safety information and warnings. */
  safety?: Array<LocalizedParameterInput>;
  /** Localized storage guidance and conditions. */
  storage?: Array<LocalizedParameterInput>;
};

export type ProductUsageInformationType = {
  __typename?: 'ProductUsageInformationType';
  /** Structured composition information including substances, hazards, and sustainability. */
  composition: CompositionType;
  /** Localized preparation instructions for the product. */
  preparations: Array<LocalizedParameterType>;
  /** Localized safety information and warnings. */
  safety: Array<LocalizedParameterType>;
  /** Localized storage guidance and conditions. */
  storage: Array<LocalizedParameterType>;
};

export type ProfileInput = {
  /** Localized brand names, allowing for aliases or client-specific branding. */
  brands?: Array<LocalizedParameterInput>;
  /** Localized product descriptions, typically used in marketing or UI labels. */
  descriptions?: Array<LocalizedParameterInput>;
  /** Localized names of manufacturing entities or facilities. */
  manufacturers?: Array<LocalizedParameterInput>;
  /** Localized product names, including region- or language-specific variants. */
  names?: Array<LocalizedParameterInput>;
  /** Simple list of product tags (e.g., 'Beef', 'Frozen') to support search and merchandising. */
  tags?: Array<Scalars['String']['input']>;
  /** Taxonomic classifications that define product category placement. */
  taxonomyMappings?: Array<TaxonomyMappingInput>;
};

export type ProfileType = {
  __typename?: 'ProfileType';
  /** Localized brand names, allowing for aliases or client-specific branding. */
  brands: Array<LocalizedParameterType>;
  /** Localized product descriptions, typically used in marketing or UI labels. */
  descriptions: Array<LocalizedParameterType>;
  /** Localized names of manufacturing entities or facilities. */
  manufacturers: Array<LocalizedParameterType>;
  /** Localized product names, including region- or language-specific variants. */
  names: Array<LocalizedParameterType>;
  /** Simple list of product tags (e.g., 'Beef', 'Frozen') to support search and merchandising. */
  tags: Array<Scalars['String']['output']>;
  /** Taxonomic classifications that define product category placement. */
  taxonomyMappings: Array<TaxonomyMappingType>;
};

export enum ProspectAutoFillSource {
  Auto = 'AUTO',
  User = 'USER'
}

export type ProspectDetailsUpdateInput = {
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone?: InputMaybe<Scalars['String']['input']>;
  contact_role?: InputMaybe<Scalars['String']['input']>;
  estimated_close_date?: InputMaybe<Scalars['String']['input']>;
  incumbents?: InputMaybe<Array<Scalars['String']['input']>>;
  stage?: InputMaybe<ChatProspectStage>;
  weekly_estimated_value_in_micros?: InputMaybe<Scalars['bigint']['input']>;
};

export type ProspectMetrics = {
  __typename?: 'ProspectMetrics';
  average_conversion_days?: Maybe<Scalars['Int']['output']>;
  conversion_rate?: Maybe<Scalars['Float']['output']>;
  converted_weekly_estimated_value_in_micros?: Maybe<Scalars['bigint']['output']>;
  note_count: Scalars['Int']['output'];
};

export type PunchoutOrderMessage = {
  __typename?: 'PunchoutOrderMessage';
  order_message_url: Scalars['String']['output'];
  order_message_xml: Scalars['String']['output'];
};

export type QualificationResponse = {
  question: Scalars['String']['input'];
  response: Scalars['String']['input'];
};

export enum RecommendationAction {
  Accept = 'ACCEPT',
  Override = 'OVERRIDE',
  Reject = 'REJECT'
}

export type RecordCashPaymentResponse = {
  __typename?: 'RecordCashPaymentResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  payment_batch?: Maybe<Payment_Batches>;
  payment_batch_id?: Maybe<Scalars['uuid']['output']>;
};

export type RecordCheckPaymentResponse = {
  __typename?: 'RecordCheckPaymentResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  payment_batch?: Maybe<Payment_Batches>;
  payment_batch_id?: Maybe<Scalars['uuid']['output']>;
};

export type RegenerateSmartOrdersResponse = {
  __typename?: 'RegenerateSmartOrdersResponse';
  smart_order?: Maybe<Smart_Order>;
  smart_order_id: Scalars['uuid']['output'];
};

export type RemovePaymentMethodResponse = {
  __typename?: 'RemovePaymentMethodResponse';
  payment_method?: Maybe<Payment_Methods>;
  payment_method_id: Scalars['uuid']['output'];
};

export type RenderPrintTagTemplateForRestaurantResponse = {
  __typename?: 'RenderPrintTagTemplateForRestaurantResponse';
  print_tag_template?: Maybe<Print_Tag_Templates>;
  print_tag_template_id: Scalars['uuid']['output'];
  rendered_template: Scalars['String']['output'];
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type RenderedTemplateResponse = {
  __typename?: 'RenderedTemplateResponse';
  rendered_template: Scalars['String']['output'];
};

export type ReorderMediaInput = {
  collection: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  mediaType: Scalars['String']['input'];
  orderMapping: Array<MediaOrderEntry>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
};

export type ReorderMediaPayload = {
  __typename?: 'ReorderMediaPayload';
  reorderedCount: Scalars['Int']['output'];
  userErrors: Array<Error>;
};

export type RepublishPricingRecommendationActionsForBusinessOrganizationResponse = {
  __typename?: 'RepublishPricingRecommendationActionsForBusinessOrganizationResponse';
  accepted_count: Scalars['Int']['output'];
  alerts_by_supplier: Array<PricingRecommendationActionsSupplierResult>;
  overridden_count: Scalars['Int']['output'];
  rejected_count: Scalars['Int']['output'];
};

export type RequestASampleResponse = {
  __typename?: 'RequestASampleResponse';
  sample_request?: Maybe<Sample_Requests>;
  sample_request_id: Scalars['uuid']['output'];
};

export type RequestContactInfo = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
};

export type ResendPayByLinkResponse = {
  __typename?: 'ResendPayByLinkResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  payment_batch?: Maybe<Payment_Batches>;
  payment_batch_id?: Maybe<Scalars['uuid']['output']>;
  recipients?: Maybe<Array<PayByLinkRecipient>>;
};

export type RestaurantMetadataInput = {
  cuisine?: InputMaybe<Scalars['String']['input']>;
  display_phone_number: Scalars['String']['input'];
  open_hours?: InputMaybe<Array<BusinessOpenHoursInput>>;
  yelp_business_id: Scalars['String']['input'];
};

export type RestaurantPaymentLinkSendInput = {
  credit_memo_ids: Array<Scalars['uuid']['input']>;
  order_invoice_ids: Array<Scalars['uuid']['input']>;
  restaurant_id: Scalars['uuid']['input'];
};

export type RestaurantPaymentLinkSendResponse = {
  __typename?: 'RestaurantPaymentLinkSendResponse';
  restaurant_id: Scalars['uuid']['output'];
  status: Scalars['String']['output'];
};

export type RestaurantVariantPackSubscriptionData = {
  __typename?: 'RestaurantVariantPackSubscriptionData';
  frequency_days: Scalars['Int']['output'];
  fulfillment_settings_id: Scalars['uuid']['output'];
  last_delivery_date?: Maybe<Scalars['String']['output']>;
  next_delivery_date: Scalars['String']['output'];
  next_delivery_date_excluding_pauses: Scalars['String']['output'];
  pause_from?: Maybe<Scalars['String']['output']>;
  pause_until?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  restaurant_id: Scalars['uuid']['output'];
  restaurant_variant_pack_subscription?: Maybe<Restaurant_Variant_Pack_Subscriptions>;
  restaurant_variant_pack_subscription_id: Scalars['uuid']['output'];
  start_date: Scalars['String']['output'];
  supplier_id: Scalars['uuid']['output'];
  variant_pack_id: Scalars['uuid']['output'];
  weekday: DaysOfWeek;
};

export type RestaurantVariantPackSubscriptionResponse = {
  __typename?: 'RestaurantVariantPackSubscriptionResponse';
  restaurant_variant_pack_subscription?: Maybe<Restaurant_Variant_Pack_Subscriptions>;
  restaurant_variant_pack_subscription_id: Scalars['uuid']['output'];
};

export type RetrieveOrderCheckInResponse = {
  __typename?: 'RetrieveOrderCheckInResponse';
  order_invoice_check_in?: Maybe<Order_Invoice_Check_Ins>;
  order_invoice_check_in_id: Scalars['uuid']['output'];
};

export enum SalesAnalyticsPeriodType {
  Mtd = 'MTD',
  Wtd = 'WTD',
  Ytd = 'YTD'
}

export type SalesPortalAccount = {
  __typename?: 'SalesPortalAccount';
  chat?: Maybe<Chats>;
  chat_id: Scalars['uuid']['output'];
  currency_code: Scalars['String']['output'];
  on_hold: Scalars['Boolean']['output'];
  restaurant?: Maybe<Businesses>;
  restaurant_id: Scalars['uuid']['output'];
  supplier?: Maybe<Businesses>;
  supplier_id: Scalars['uuid']['output'];
};

export type SalesPortalAccountInfo = {
  __typename?: 'SalesPortalAccountInfo';
  chat?: Maybe<Chats>;
  chat_id: Scalars['uuid']['output'];
  chat_status: ChatStatus;
  last_fulfilled_date?: Maybe<Scalars['String']['output']>;
  last_fulfilled_date_display?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<Businesses>;
  restaurant_account_id?: Maybe<Scalars['String']['output']>;
  restaurant_address: Scalars['String']['output'];
  restaurant_groups: Array<SalesPortalRestaurantGroup>;
  restaurant_id: Scalars['uuid']['output'];
  restaurant_name: Scalars['String']['output'];
  supplier?: Maybe<Businesses>;
  supplier_id: Scalars['uuid']['output'];
};

export type SalesPortalAccountListFilterCounts = {
  __typename?: 'SalesPortalAccountListFilterCounts';
  group_counts: Array<SalesPortalAccountListGroupCount>;
  status_counts: Array<SalesPortalAccountListStatusCount>;
};

export type SalesPortalAccountListFilters = {
  customer_groups?: InputMaybe<Array<Scalars['uuid']['input']>>;
  search_term?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ChatStatus>>;
};

export type SalesPortalAccountListGroupCount = {
  __typename?: 'SalesPortalAccountListGroupCount';
  count: Scalars['Int']['output'];
  group_id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  restaurant_group?: Maybe<Restaurant_Groups>;
};

export type SalesPortalAccountListInfoPage = {
  __typename?: 'SalesPortalAccountListInfoPage';
  accounts: Array<SalesPortalPaginatedAccountInfo>;
  cursor?: Maybe<Scalars['uuid']['output']>;
};

export type SalesPortalAccountListStatusCount = {
  __typename?: 'SalesPortalAccountListStatusCount';
  count: Scalars['Int']['output'];
  status: ChatStatus;
};

export type SalesPortalAccountMetrics = {
  __typename?: 'SalesPortalAccountMetrics';
  chat?: Maybe<Chats>;
  chat_id: Scalars['uuid']['output'];
  restaurant?: Maybe<Businesses>;
  restaurant_id: Scalars['uuid']['output'];
  sales_wtd_in_micros: Scalars['Int']['output'];
  sales_wtd_percentage_delta?: Maybe<Scalars['Float']['output']>;
  supplier?: Maybe<Businesses>;
  supplier_id: Scalars['uuid']['output'];
  units_wtd: Scalars['Int']['output'];
  units_wtd_percentage_delta?: Maybe<Scalars['Float']['output']>;
};

export type SalesPortalAccountsPage = {
  __typename?: 'SalesPortalAccountsPage';
  accounts: Array<SalesPortalAccount>;
  cursor?: Maybe<Scalars['uuid']['output']>;
};

export type SalesPortalCartError = {
  __typename?: 'SalesPortalCartError';
  code: CartUpdateError;
  message: Scalars['String']['output'];
};

export type SalesPortalCartInput = {
  cart_items: Array<SalesPortalCartItemInput>;
  metadata: SalesPortalCartMetadataInput;
};

export type SalesPortalCartItemInput = {
  order_item_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity: Scalars['Float']['input'];
  unit_price_in_micros?: InputMaybe<Scalars['Int']['input']>;
  variant_pack_id: Scalars['uuid']['input'];
};

export type SalesPortalCartItemOutput = {
  __typename?: 'SalesPortalCartItemOutput';
  added_at?: Maybe<Scalars['String']['output']>;
  order_item_id: Scalars['uuid']['output'];
  quantity: Scalars['Float']['output'];
  variant_pack_id: Scalars['uuid']['output'];
};

export type SalesPortalCartMetadataInput = {
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  fulfillment_timeslot_end?: InputMaybe<Scalars['String']['input']>;
  fulfillment_timeslot_start?: InputMaybe<Scalars['String']['input']>;
  fulfillment_type: Scalars['String']['input'];
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  order_source?: InputMaybe<Scalars['String']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  updated_at: Scalars['String']['input'];
};

export type SalesPortalCartMetadataOutput = {
  __typename?: 'SalesPortalCartMetadataOutput';
  delivery_date?: Maybe<Scalars['String']['output']>;
  fulfillment_timeslot_end?: Maybe<Scalars['String']['output']>;
  fulfillment_timeslot_start?: Maybe<Scalars['String']['output']>;
  fulfillment_type: Scalars['String']['output'];
  order_id?: Maybe<Scalars['uuid']['output']>;
  restaurant_id: Scalars['uuid']['output'];
  supplier_id: Scalars['uuid']['output'];
  updated_at: Scalars['String']['output'];
};

export type SalesPortalCartOutput = {
  __typename?: 'SalesPortalCartOutput';
  cart_items: Array<SalesPortalCartItemOutput>;
  metadata: SalesPortalCartMetadataOutput;
};

export type SalesPortalCartValidation = {
  __typename?: 'SalesPortalCartValidation';
  alerts: Array<SalesPortalValidationAlert>;
  can_place_order: Scalars['Boolean']['output'];
  requires_approval: Scalars['Boolean']['output'];
};

export type SalesPortalCopilotMessage = {
  __typename?: 'SalesPortalCopilotMessage';
  text: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type SalesPortalCopilotSendMessageResponse = {
  __typename?: 'SalesPortalCopilotSendMessageResponse';
  messages: Array<SalesPortalCopilotMessage>;
  session_id?: Maybe<Scalars['String']['output']>;
};

export type SalesPortalOrderGuideCollection = {
  __typename?: 'SalesPortalOrderGuideCollection';
  is_default: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  type: SalesPortalOrderGuideCollectionType;
  uuid: Scalars['uuid']['output'];
};

export type SalesPortalOrderGuideCollectionForOrderEntry = {
  __typename?: 'SalesPortalOrderGuideCollectionForOrderEntry';
  is_default: Scalars['Boolean']['output'];
  linked_supplier_collection_uuid?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  type: SalesPortalOrderGuideCollectionType;
  uuid: Scalars['uuid']['output'];
};

export enum SalesPortalOrderGuideCollectionType {
  Restaurant = 'RESTAURANT',
  Supplier = 'SUPPLIER'
}

export type SalesPortalOrderGuideEntryInfo = {
  __typename?: 'SalesPortalOrderGuideEntryInfo';
  is_minimized: Scalars['Boolean']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  par_level?: Maybe<Scalars['Float']['output']>;
  persist_memo: Scalars['Boolean']['output'];
  persist_request: Scalars['Boolean']['output'];
  request?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

export type SalesPortalOrderGuideItem = {
  __typename?: 'SalesPortalOrderGuideItem';
  entry_info?: Maybe<SalesPortalOrderGuideEntryInfo>;
  item_info: SalesPortalOrderGuideItemInfo;
  order_guide_item_id?: Maybe<Scalars['uuid']['output']>;
  order_guide_item_partition_id?: Maybe<Scalars['uuid']['output']>;
  pack_info: SalesPortalOrderGuidePackInfo;
  variant_pack_id: Scalars['uuid']['output'];
};

export type SalesPortalOrderGuideItemInfo = {
  __typename?: 'SalesPortalOrderGuideItemInfo';
  image_url?: Maybe<Scalars['String']['output']>;
  item_id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
};

export type SalesPortalOrderGuidePackInfo = {
  __typename?: 'SalesPortalOrderGuidePackInfo';
  base_unit?: Maybe<PackUnit>;
  external_item_id?: Maybe<Scalars['String']['output']>;
  max_unit_size: Scalars['Float']['output'];
  min_unit_size: Scalars['Float']['output'];
  unit: PackUnit;
  unit_count: Scalars['Float']['output'];
};

export type SalesPortalPaginatedAccountInfo = {
  __typename?: 'SalesPortalPaginatedAccountInfo';
  chat?: Maybe<Chats>;
  chat_id: Scalars['uuid']['output'];
  last_fulfilled_date_display?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<Businesses>;
  restaurant_account_id?: Maybe<Scalars['String']['output']>;
  restaurant_address: Scalars['String']['output'];
  restaurant_id: Scalars['uuid']['output'];
  restaurant_name: Scalars['String']['output'];
  supplier?: Maybe<Businesses>;
  supplier_id: Scalars['uuid']['output'];
};

export type SalesPortalProspectDetails = {
  __typename?: 'SalesPortalProspectDetails';
  chat_id: Scalars['uuid']['output'];
  contact_email?: Maybe<ChatProspectAutoFillStringField>;
  contact_name?: Maybe<ChatProspectAutoFillStringField>;
  contact_phone?: Maybe<ChatProspectAutoFillStringField>;
  contact_role?: Maybe<ChatProspectAutoFillStringField>;
  estimated_close_date?: Maybe<ChatProspectAutoFillStringField>;
  incumbents?: Maybe<ChatProspectAutoFillStringListField>;
  last_refreshed_at?: Maybe<Scalars['String']['output']>;
  owned_by_id: Scalars['uuid']['output'];
  processing_status: ChatProspectProcessingStatus;
  stage: ChatProspectStage;
  uuid: Scalars['uuid']['output'];
  weekly_estimated_value_in_micros?: Maybe<ChatProspectAutoFillBigIntField>;
};

export type SalesPortalProspectInfo = {
  __typename?: 'SalesPortalProspectInfo';
  chat_id: Scalars['uuid']['output'];
  currency_code: Scalars['String']['output'];
  date_added_at: Scalars['String']['output'];
  date_added_display: Scalars['String']['output'];
  last_activity_at?: Maybe<Scalars['String']['output']>;
  last_activity_display?: Maybe<Scalars['String']['output']>;
  prospect_id: Scalars['uuid']['output'];
  restaurant_address: Scalars['String']['output'];
  restaurant_id: Scalars['uuid']['output'];
  restaurant_name: Scalars['String']['output'];
  stage: ChatProspectStage;
  supplier_id: Scalars['uuid']['output'];
  weekly_estimated_value_in_micros?: Maybe<Scalars['bigint']['output']>;
};

export type SalesPortalRestaurantGroup = {
  __typename?: 'SalesPortalRestaurantGroup';
  name: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
};

export type SalesPortalTab = {
  __typename?: 'SalesPortalTab';
  tab_id: SalesPortalTabId;
};

export enum SalesPortalTabId {
  Accounts = 'ACCOUNTS',
  Copilot = 'COPILOT',
  Insights = 'INSIGHTS',
  OrderEntry = 'ORDER_ENTRY',
  OrderGuides = 'ORDER_GUIDES',
  PriceQuotes = 'PRICE_QUOTES',
  Pricing = 'PRICING',
  Prospects = 'PROSPECTS'
}

export type SalesPortalValidationAlert = {
  __typename?: 'SalesPortalValidationAlert';
  alert_code?: Maybe<Scalars['String']['output']>;
  alert_level: AlertLevel;
  alert_message: Scalars['String']['output'];
};

export enum SalesRepOverrideExpirationSource {
  SalesRepTemporary = 'SALES_REP_TEMPORARY',
  SupplierDefault = 'SUPPLIER_DEFAULT'
}

export type SalesRepUpdateVariantPackGrossProfitInput = {
  gross_profit_in_percentage?: InputMaybe<Scalars['String']['input']>;
  sales_rep_price_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  variant_pack_id: Scalars['uuid']['input'];
};

export type SalesRepUpdateVariantPackInput = {
  sales_rep_price_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  variant_pack_id: Scalars['uuid']['input'];
};

export type SaltItemInput = {
  saltId?: InputMaybe<Scalars['String']['input']>;
  variantPackId: Scalars['String']['input'];
};

export type SaltMasterDocumentType = {
  __typename?: 'SaltMasterDocumentType';
  docId: Scalars['String']['output'];
  identifiers: Array<ParameterType>;
  item: ItemType;
  media: Array<MediaType>;
};

export type SaltOverrideDocumentType = {
  __typename?: 'SaltOverrideDocumentType';
  /** Cross-system unique identifiers such as GTINs, SKUs, or internal reference IDs. */
  identifiers: Array<ParameterType>;
  /** Overridable subset of the item's descriptive content (e.g., localized name, usage, branding). */
  item: ItemType;
  /** Overridable media assets (images, videos, PDFs) associated with the item. */
  media: Array<MediaType>;
  /** ID of the organization that this override document belongs to. Currently, this corresponds to supplier_uuid. */
  orgId: Scalars['String']['output'];
  /** ID of the variant pack that this override document belongs to. */
  vpId: Scalars['String']['output'];
};

export type SaltSourceDocumentType = {
  __typename?: 'SaltSourceDocumentType';
  /** Primary unique identifier for the item (SALT ID). */
  _id: Scalars['String']['output'];
  /** Cross-system unique identifiers such as GTINs, SKUs, or internal reference IDs. */
  identifiers: Array<ParameterType>;
  /** Full descriptive and localized content about the product (e.g., name, nutrition, usage). */
  item: ItemType;
  /** Media assets (images, videos, PDFs) associated with the item. Stored at root level to separate from item object for checksum calculations. */
  media: Array<MediaType>;
  /** Platform-specific internal metadata, including system, validation, and source records. */
  metadata: MetadataType;
  /** Version of the SALT schema used. */
  schemaVersion: Scalars['String']['output'];
  /** Automated or manual scoring block to assess item completeness or quality. */
  scorecard: ScorecardType;
};

export type SaltSourceDocumentTypeSaltOverrideDocumentTypeSplitDocumentType = SaltOverrideDocumentType | SaltSourceDocumentType | SplitDocumentType;

export type SampleRequestEventData = {
  __typename?: 'SampleRequestEventData';
  add_to_cart_event_id: Scalars['String']['output'];
  click_event_id: Scalars['String']['output'];
  form_submit_event_id: Scalars['String']['output'];
  impression_event_id: Scalars['String']['output'];
  purchase_event_id: Scalars['String']['output'];
};

export enum SampleRequestFeedbackType {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type SavePadPaymentMethodWithConsentResponse = {
  __typename?: 'SavePadPaymentMethodWithConsentResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  payment_method?: Maybe<Payment_Methods>;
  payment_method_id?: Maybe<Scalars['uuid']['output']>;
};

export type SavePaymentMethodDetailsResponse = {
  __typename?: 'SavePaymentMethodDetailsResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  payment_method?: Maybe<Payment_Methods>;
  payment_method_id?: Maybe<Scalars['uuid']['output']>;
};

export type SavePaymentMethodResponse = {
  __typename?: 'SavePaymentMethodResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  payment_method?: Maybe<Payment_Methods>;
  payment_method_id?: Maybe<Scalars['uuid']['output']>;
  threeds_action?: Maybe<Scalars['String']['output']>;
};

export type SavePriceQuoteLineItemInput = {
  competitor?: InputMaybe<CompetitorLineItemInput>;
  item_code?: InputMaybe<Scalars['String']['input']>;
  item_description?: InputMaybe<Scalars['String']['input']>;
  item_name: Scalars['String']['input'];
  item_pack_size?: InputMaybe<Scalars['String']['input']>;
  pack_price_in_micros: Scalars['bigint']['input'];
  quantity: Scalars['Float']['input'];
  variant_pack_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type SavePriceQuoteResponse = {
  __typename?: 'SavePriceQuoteResponse';
  created_at: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price_quote_id: Scalars['uuid']['output'];
  updated_at: Scalars['String']['output'];
};

export type SaveSalesPortalCartResponse = {
  __typename?: 'SaveSalesPortalCartResponse';
  cart: SalesPortalCartOutput;
  error?: Maybe<SalesPortalCartError>;
  order_validation?: Maybe<SalesPortalCartValidation>;
  success: Scalars['Boolean']['output'];
};

export type ScorecardType = {
  __typename?: 'ScorecardType';
  parameter: Scalars['String']['output'];
};

export type SearchFilterInput = {
  field: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type SearchFilterResponse = {
  __typename?: 'SearchFilterResponse';
  display_strategy: Scalars['String']['output'];
  name: TranslatedValue;
  sort_order?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  values?: Maybe<Array<TranslatedValue>>;
};

export type SearchOrderHistoryFilterInput = {
  operation: OrderHistoryFilterOperation;
  type: OrderHistoryFilterType;
  value?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SearchOrderHistoryResponse = {
  __typename?: 'SearchOrderHistoryResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  orders: Array<OrderWithFees>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type SearchOrderHistorySortByInput = {
  direction: OrderHistorySortDirection;
  type: OrderHistorySortType;
};

export type SearchPriceQuoteItemsResponse = {
  __typename?: 'SearchPriceQuoteItemsResponse';
  items: Array<PriceQuoteItemSearchResult>;
};

export enum SearchSortOrder {
  DisplayName = 'DISPLAY_NAME',
  DisplayNameReverse = 'DISPLAY_NAME_REVERSE',
  ItemCode = 'ITEM_CODE',
  ItemCodeReverse = 'ITEM_CODE_REVERSE',
  PurchasedDate = 'PURCHASED_DATE',
  Relevance = 'RELEVANCE'
}

export type SearchVariantPacksForBusinessOrganizationResponse = {
  __typename?: 'SearchVariantPacksForBusinessOrganizationResponse';
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type SearchVariantPacksForCreditRequestResponse = {
  __typename?: 'SearchVariantPacksForCreditRequestResponse';
  available_quantity_for_credit?: Maybe<Scalars['Int']['output']>;
  eligible_for_credit: Scalars['Boolean']['output'];
  guaranteed: Scalars['Boolean']['output'];
  last_fulfillment_date?: Maybe<Scalars['String']['output']>;
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
  variant_pack_order_counts?: Maybe<Array<VariantPackOrderCount>>;
};

export type SearchVariantPacksResponse = {
  __typename?: 'SearchVariantPacksResponse';
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
  variant_pack_order_counts?: Maybe<Array<VariantPackOrderCount>>;
};

export type SectionHeader = {
  __typename?: 'SectionHeader';
  header_text: Scalars['String']['output'];
  order_fulfillment_date?: Maybe<Scalars['String']['output']>;
};

export type SelectAutoPaySettingsResponse = {
  __typename?: 'SelectAutoPaySettingsResponse';
  auto_pay_settings?: Maybe<Auto_Pay_Settings>;
  auto_pay_settings_id: Scalars['uuid']['output'];
};

export type SendChatbotMessageResponse = {
  __typename?: 'SendChatbotMessageResponse';
  messages: Array<ChatbotMessage>;
  session_id: Scalars['String']['output'];
};

export type SendPayByLinkRecipients = {
  email?: InputMaybe<Scalars['String']['input']>;
  employee_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
};

export type SendPricingRulesWritebackResponse = {
  __typename?: 'SendPricingRulesWritebackResponse';
  restaurant_count: Scalars['Int']['output'];
  variant_pack_count: Scalars['Int']['output'];
};

export type ServingAndPreparationType = {
  __typename?: 'ServingAndPreparationType';
  preparation: Array<GenericAttributeType>;
  serving: Array<GenericAttributeType>;
};

export type SetItemSubstitutionResponse = {
  __typename?: 'SetItemSubstitutionResponse';
  order?: Maybe<Orders>;
  order_id: Scalars['uuid']['output'];
};

export type SetOrderGuideCollectionPartitionInput = {
  items: Array<SetOrderGuideCollectionPartitionItemInput>;
  partition_id?: InputMaybe<Scalars['uuid']['input']>;
  partition_name?: InputMaybe<Scalars['String']['input']>;
};

export type SetOrderGuideCollectionPartitionItemInput = {
  is_minimized?: InputMaybe<Scalars['Boolean']['input']>;
  is_request?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  par_level?: InputMaybe<Scalars['Float']['input']>;
  persist_notes?: InputMaybe<Scalars['Boolean']['input']>;
  variant_pack_id: Scalars['uuid']['input'];
};

export type SetupAppResponse = {
  __typename?: 'SetupAppResponse';
  restaurant_id: Scalars['uuid']['output'];
};

export type ShippingInfoInput = {
  /** Ti-Hi configuration for shipping pallet. */
  shipTiHi?: Scalars['String']['input'];
  /** The volume of the package for shipping purchases */
  shipVolume?: Scalars['String']['input'];
};

export type ShippingInfoType = {
  __typename?: 'ShippingInfoType';
  /** Ti-Hi configuration for shipping pallet. */
  shipTiHi: Scalars['String']['output'];
  /** The volume of the package for shipping purchases */
  shipVolume: Scalars['String']['output'];
};

export type SignatureMatchProvenanceInput = {
  selected: Scalars['Boolean']['input'];
  signature_identifier_id: Scalars['uuid']['input'];
  used_for_decision: Scalars['Boolean']['input'];
  vote_status?: InputMaybe<Scalars['String']['input']>;
};

export type SmartOrderAssignableEmployee = {
  __typename?: 'SmartOrderAssignableEmployee';
  employee?: Maybe<Employees>;
  employee_id: Scalars['uuid']['output'];
  group: SmartOrderAssignableGroup;
  has_restaurant_access: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  submitted_recently: Scalars['Boolean']['output'];
};

export enum SmartOrderAssignableGroup {
  Available = 'AVAILABLE',
  NeedsAccess = 'NEEDS_ACCESS',
  RecentlyActive = 'RECENTLY_ACTIVE'
}

export type SmartOrderDetailsSearchInput = {
  __typename?: 'SmartOrderDetailsSearchInput';
  alternative_variant_pack_matches: Array<VariantPackMatch>;
  previous_variant_pack_matches: Array<VariantPackMatch>;
  search_input_id: Scalars['uuid']['output'];
  search_term_id: Scalars['uuid']['output'];
  smart_order_search_input?: Maybe<Smart_Order_Search_Input>;
  smart_order_search_term?: Maybe<Smart_Order_Search_Term>;
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id?: Maybe<Scalars['uuid']['output']>;
  variant_pack_order_counts?: Maybe<Array<VariantPackOrderCount>>;
};

export type SmartOrderInboundAssignee = {
  __typename?: 'SmartOrderInboundAssignee';
  employee?: Maybe<Employees>;
  employee_id: Scalars['uuid']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SmartOrderInboundHistoryItem = {
  __typename?: 'SmartOrderInboundHistoryItem';
  smart_order?: Maybe<Smart_Order>;
  smart_order_id: Scalars['uuid']['output'];
};

export enum SmartOrderInboundHistoryOrderBy {
  ClosestCutoff = 'CLOSEST_CUTOFF',
  NewestFirst = 'NEWEST_FIRST',
  OldestFirst = 'OLDEST_FIRST'
}

export enum SmartOrderIntent {
  Explore = 'EXPLORE',
  Order = 'ORDER'
}

export enum SmartOrderStatus {
  Memorized = 'MEMORIZED',
  NotVerified = 'NOT_VERIFIED',
  NoResults = 'NO_RESULTS',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED',
  UnknownContact = 'UNKNOWN_CONTACT'
}

export type SortOrderGuideResponse = {
  __typename?: 'SortOrderGuideResponse';
  order_guide?: Maybe<Order_Guide>;
  order_guide_id: Scalars['uuid']['output'];
};

export type SplitDocumentType = {
  __typename?: 'SplitDocumentType';
  masterDoc?: Maybe<SaltMasterDocumentType>;
  overrideDoc?: Maybe<SaltOverrideDocumentType>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitCheckDepositCreditMemoInput = {
  amount_in_micros: Scalars['bigint']['input'];
  credit_memo_id: Scalars['uuid']['input'];
  credit_memo_number: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
};

export type SubmitCheckDepositInvoiceInput = {
  amount_in_micros: Scalars['bigint']['input'];
  invoice_id: Scalars['uuid']['input'];
  invoice_number: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
};

export type SubmitCheckDepositResponse = {
  __typename?: 'SubmitCheckDepositResponse';
  alert_level?: Maybe<Scalars['String']['output']>;
  alert_message?: Maybe<Scalars['String']['output']>;
  error_code?: Maybe<Scalars['String']['output']>;
  payment_batch?: Maybe<Payment_Batches>;
  payment_batch_id?: Maybe<Scalars['uuid']['output']>;
};

export type SubmitLoyaltyEnrollmentFormResponse = {
  __typename?: 'SubmitLoyaltyEnrollmentFormResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  error_code?: Maybe<LoyaltyProgramErrorCode>;
  supplier_loyalty_program_restaurant_id?: Maybe<Scalars['uuid']['output']>;
};

export type SubmitLoyaltyProgramTermsDecisionResponse = {
  __typename?: 'SubmitLoyaltyProgramTermsDecisionResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  error_code?: Maybe<LoyaltyProgramErrorCode>;
  supplier_loyalty_program_restaurant_id?: Maybe<Scalars['uuid']['output']>;
};

export type SubmitOrderLoyaltyEarn = {
  __typename?: 'SubmitOrderLoyaltyEarn';
  order_id: Scalars['uuid']['output'];
  programs: Array<SubmitOrderLoyaltyProgramEarn>;
};

export type SubmitOrderLoyaltyProgramEarn = {
  __typename?: 'SubmitOrderLoyaltyProgramEarn';
  earned_points: Scalars['bigint']['output'];
  program_id: Scalars['uuid']['output'];
  program_name: Scalars['String']['output'];
};

export type SubmitOrderResponse = {
  __typename?: 'SubmitOrderResponse';
  loyalty_earns?: Maybe<Array<SubmitOrderLoyaltyEarn>>;
  order?: Maybe<Orders>;
  order_id: Scalars['uuid']['output'];
  punchout_order_message?: Maybe<PunchoutOrderMessage>;
  split_order_id_list?: Maybe<Array<Scalars['uuid']['output']>>;
};

export type SubmitPriceDraftBatchAlert = {
  __typename?: 'SubmitPriceDraftBatchAlert';
  alert_level: AlertLevel;
  alert_message: Scalars['String']['output'];
  deleted_draft_update_ids: Array<Scalars['uuid']['output']>;
};

export type SubmitPriceDraftBatchResponse = {
  __typename?: 'SubmitPriceDraftBatchResponse';
  alert?: Maybe<SubmitPriceDraftBatchAlert>;
  cost_changes: Array<VariantPackCostChange>;
};

export type SubmitPricingPriceDraftUpdateBatchForBusinessOrganizationResult = {
  __typename?: 'SubmitPricingPriceDraftUpdateBatchForBusinessOrganizationResult';
  alert?: Maybe<SubmitPriceDraftBatchAlert>;
  supplier_id: Scalars['uuid']['output'];
};

export type SubmitPricingPriceDraftUpdateBatchesForBusinessOrganizationResponse = {
  __typename?: 'SubmitPricingPriceDraftUpdateBatchesForBusinessOrganizationResponse';
  cost_changes: Array<OrgVariantPackCostChange>;
  per_supplier: Array<SubmitPricingPriceDraftUpdateBatchForBusinessOrganizationResult>;
};

export type SubmitPricingRecommendationActionsForBusinessOrganizationResponse = {
  __typename?: 'SubmitPricingRecommendationActionsForBusinessOrganizationResponse';
  accepted_count: Scalars['Int']['output'];
  alerts_by_supplier: Array<PricingRecommendationActionsSupplierResult>;
  overridden_count: Scalars['Int']['output'];
  rejected_count: Scalars['Int']['output'];
};

export type SubmitPricingRecommendationActionsResponse = {
  __typename?: 'SubmitPricingRecommendationActionsResponse';
  accepted_count: Scalars['Int']['output'];
  alert?: Maybe<PricingRecommendationAlert>;
  overridden_count: Scalars['Int']['output'];
  rejected_count: Scalars['Int']['output'];
};

export type SubstitutionEntryInput = {
  requested_quantity: Scalars['Float']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  success: Scalars['Boolean']['output'];
};

export type SupplierAutoPaySettings = {
  __typename?: 'SupplierAutoPaySettings';
  autopay_settings: Array<AutoPaySetting>;
  supplier: AutoPaySupplier;
};

export type SupplierCreateOrUpdateRestaurantResponse = {
  __typename?: 'SupplierCreateOrUpdateRestaurantResponse';
  business?: Maybe<Businesses>;
  restaurant_id: Scalars['uuid']['output'];
};

export type SystemMetadataType = {
  __typename?: 'SystemMetadataType';
  /** ISO 8601 timestamp of document creation. */
  createdAt: Scalars['DateTime']['output'];
  /** Additional system-level metadata as key-value pairs. */
  extra: Array<ParameterType>;
  /** Checksum of the item object (excluding media) for integrity verification. */
  itemChecksum: Scalars['String']['output'];
  /** ISO 8601 timestamp of the most recent update. */
  updatedAt: Scalars['DateTime']['output'];
};

export type TagPrinterConfiguration = {
  __typename?: 'TagPrinterConfiguration';
  language: TagPrinterLanguage;
  print_markup_content: Scalars['String']['output'];
};

export enum TagPrinterLanguage {
  ZebraProgrammingLanguage = 'ZEBRA_PROGRAMMING_LANGUAGE'
}

export type TaskFrequencyInput = {
  days_of_month?: InputMaybe<Array<Scalars['Int']['input']>>;
  days_of_week?: InputMaybe<Array<Scalars['Int']['input']>>;
  type: FrequencySettingType;
};

export type TaskFrequencySettingsInput = {
  frequency: TaskFrequencyInput;
  hour_of_day?: InputMaybe<Scalars['Int']['input']>;
};

export type TaxonomyMappingInput = {
  /** Unique identifier for the leaf node in the taxonomy. */
  categoryId: Scalars['String']['input'];
  /** The full category tree path as a list (e.g., ['food', 'snacks', 'chips']). */
  categoryPath: Array<Scalars['String']['input']>;
  /** Additional structured metadata for the mapping (e.g., scoring source, algorithm). */
  parameters?: Array<ParameterInput>;
  /** The name of the taxonomy system (e.g., 'pepper_salt', 'gs1'). */
  taxonomyName: Scalars['String']['input'];
  /** Version string for the taxonomy used (e.g., 'v1.2'). */
  taxonomyVersion: Scalars['String']['input'];
};

export type TaxonomyMappingType = {
  __typename?: 'TaxonomyMappingType';
  /** Unique identifier for the leaf node in the taxonomy. */
  categoryId: Scalars['String']['output'];
  /** The full category tree path as a list (e.g., ['food', 'snacks', 'chips']). */
  categoryPath: Array<Scalars['String']['output']>;
  /** Additional structured metadata for the mapping (e.g., scoring source, algorithm). */
  parameters: Array<ParameterType>;
  /** The name of the taxonomy system (e.g., 'pepper_salt', 'gs1'). */
  taxonomyName: Scalars['String']['output'];
  /** Version string for the taxonomy used (e.g., 'v1.2'). */
  taxonomyVersion: Scalars['String']['output'];
};

export type TotalSalesByDay = {
  __typename?: 'TotalSalesByDay';
  date: Scalars['String']['output'];
  total_sales_amount_in_micros: Scalars['Int']['output'];
};

export enum TransactionFeesType {
  Flat = 'FLAT',
  Percentage = 'PERCENTAGE'
}

export type TranscriptWord = {
  end: Scalars['Float']['input'];
  start: Scalars['Float']['input'];
  word: Scalars['String']['input'];
};

export type TranslatedValue = {
  __typename?: 'TranslatedValue';
  original_value: Scalars['String']['output'];
  translated_value: Scalars['String']['output'];
};

export type UnpaidInvoiceListItem = {
  __typename?: 'UnpaidInvoiceListItem';
  amount_paid_in_micros: Scalars['bigint']['output'];
  currency_code: Scalars['String']['output'];
  customer_id?: Maybe<Scalars['uuid']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  days_overdue: Scalars['Int']['output'];
  due_at?: Maybe<Scalars['String']['output']>;
  erp_last_modified_at?: Maybe<Scalars['String']['output']>;
  invoice_number?: Maybe<Scalars['String']['output']>;
  is_partially_paid: Scalars['Boolean']['output'];
  record_id: Scalars['uuid']['output'];
  record_type: InvoiceListRecordType;
  remaining_balance_in_micros: Scalars['bigint']['output'];
  restaurant?: Maybe<Businesses>;
};

export type UnpaidInvoiceSummaryBucket = {
  __typename?: 'UnpaidInvoiceSummaryBucket';
  amount_in_micros: Scalars['bigint']['output'];
  count: Scalars['Int']['output'];
};

export type UnreadChatMessageCountResponse = {
  __typename?: 'UnreadChatMessageCountResponse';
  chat?: Maybe<Chats>;
  chat_id: Scalars['uuid']['output'];
  unread_message_count: Scalars['Int']['output'];
};

export type UpdateAnalyticsAlertsActionsResponse = {
  __typename?: 'UpdateAnalyticsAlertsActionsResponse';
  updated: Array<UpdateAnalyticsAlertsActionsResponseDetails>;
};

export type UpdateAnalyticsAlertsActionsResponseDetails = {
  __typename?: 'UpdateAnalyticsAlertsActionsResponseDetails';
  alert_id: Scalars['uuid']['output'];
  status: AnalyticsAlertStatusType;
};

export type UpdateAnalyticsAlertsStatusResponse = {
  __typename?: 'UpdateAnalyticsAlertsStatusResponse';
  updated_count: Scalars['Int']['output'];
};

export type UpdateAutoPaySettingResponse = {
  __typename?: 'UpdateAutoPaySettingResponse';
  auto_pay_setting_id: Scalars['uuid']['output'];
  auto_pay_settings?: Maybe<Auto_Pay_Settings>;
};

export type UpdateHubLastVisitedResponse = {
  __typename?: 'UpdateHubLastVisitedResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateItemInput = {
  add_to_cart_event_payloads?: InputMaybe<Array<AdEventInput>>;
  add_to_cart_event_urls?: InputMaybe<Array<Scalars['String']['input']>>;
  cart_details_at_invoice?: InputMaybe<CartDetailsInput>;
  cart_details_at_supplier_acceptance?: InputMaybe<CartDetailsInput>;
  cart_details_at_time_of_order?: InputMaybe<CartDetailsInput>;
  cart_details_for_pricing_pack?: InputMaybe<CartDetailsInput>;
  item_name?: InputMaybe<Scalars['String']['input']>;
  item_notes?: InputMaybe<Scalars['String']['input']>;
  purchase_event_payloads?: InputMaybe<Array<AdEventInput>>;
  purchase_event_urls?: InputMaybe<Array<Scalars['String']['input']>>;
  variant_pack_id: Scalars['String']['input'];
};

export type UpdateOrderGuideItemDispositionsItemInput = {
  is_minimized: Scalars['Boolean']['input'];
  order_guide_item_id?: InputMaybe<Scalars['uuid']['input']>;
  partition_id?: InputMaybe<Scalars['uuid']['input']>;
  variant_pack_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type UpdatePadPaymentMethodConsentResponse = {
  __typename?: 'UpdatePadPaymentMethodConsentResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  payment_method?: Maybe<Payment_Methods>;
  payment_method_id?: Maybe<Scalars['uuid']['output']>;
};

export type UpdatePaymentPlanPaymentMethodResponse = {
  __typename?: 'UpdatePaymentPlanPaymentMethodResponse';
  alert_level?: Maybe<AlertLevel>;
  alert_message?: Maybe<Scalars['String']['output']>;
  payment_plan?: Maybe<Payment_Plans>;
  payment_plan_id?: Maybe<Scalars['uuid']['output']>;
};

export type UpdateSmartOrderAssigneeResponse = {
  __typename?: 'UpdateSmartOrderAssigneeResponse';
  assigned_employee_id?: Maybe<Scalars['uuid']['output']>;
  employee?: Maybe<Employees>;
  smart_order_ids: Array<Scalars['uuid']['output']>;
};

export type UpdateSmartOrderSearchInputResponse = {
  __typename?: 'UpdateSmartOrderSearchInputResponse';
  smart_order_search_input?: Maybe<Smart_Order_Search_Input>;
  smart_order_search_input_id: Scalars['uuid']['output'];
};

export type UpsertIdentifierInput = {
  collection: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  supplierId?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type UpsertIdentifierPayload = {
  __typename?: 'UpsertIdentifierPayload';
  identifier?: Maybe<IdentifierEntry>;
  userErrors: Array<Error>;
};

export type UpsertItemProfileInput = {
  collection: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  profile: ProfileInput;
  supplierId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertItemSectionPayload = {
  __typename?: 'UpsertItemSectionPayload';
  entry?: Maybe<ItemSectionEntry>;
  userErrors: Array<Error>;
};

export type UpsertNutritionProfileInput = {
  collection: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  nutritionProfile: NutritionProfileInput;
  supplierId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertPackagingInput = {
  collection: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  packaging: Array<PackagingInput>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertPriceDraftForBusinessOrganizationInput = {
  gross_profit_in_percentage: Scalars['String']['input'];
  new_sales_rep_price_in_micros: Scalars['bigint']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};

export type UpsertPriceDraftInput = {
  gross_profit_in_percentage: Scalars['String']['input'];
  is_revert?: InputMaybe<Scalars['Boolean']['input']>;
  new_sales_rep_price_in_micros: Scalars['bigint']['input'];
  restaurant_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};

export type UpsertPricingBookmarkEntryInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};

export type UpsertPricingBookmarksResponse = {
  __typename?: 'UpsertPricingBookmarksResponse';
  bookmarks: Array<PricingBookmarkRef>;
  upsert_count: Scalars['Int']['output'];
};

export type UpsertPricingPriceDraftUpdatesForBusinessOrganizationPerSupplier = {
  __typename?: 'UpsertPricingPriceDraftUpdatesForBusinessOrganizationPerSupplier';
  pricing_price_draft_update_batch_id: Scalars['uuid']['output'];
  supplier_id: Scalars['uuid']['output'];
  upsert_count: Scalars['Int']['output'];
};

export type UpsertPricingPriceDraftUpdatesForBusinessOrganizationResponse = {
  __typename?: 'UpsertPricingPriceDraftUpdatesForBusinessOrganizationResponse';
  cost_changes: Array<DetailVariantPackCostChange>;
  per_supplier: Array<UpsertPricingPriceDraftUpdatesForBusinessOrganizationPerSupplier>;
  publish_enabled: Scalars['Boolean']['output'];
  total_upsert_count: Scalars['Int']['output'];
};

export type UpsertPricingPriceDraftUpdatesResponse = {
  __typename?: 'UpsertPricingPriceDraftUpdatesResponse';
  cost_changes: Array<DetailVariantPackCostChange>;
  pricing_price_draft_update_batch_id: Scalars['uuid']['output'];
  upsert_count: Scalars['Int']['output'];
};

export type UpsertPricingRecommendationsStatusForBusinessOrganizationResponse = {
  __typename?: 'UpsertPricingRecommendationsStatusForBusinessOrganizationResponse';
  accepted_count: Scalars['Int']['output'];
  overridden_count: Scalars['Int']['output'];
  rejected_count: Scalars['Int']['output'];
};

export type UpsertProductUsageInformationInput = {
  collection: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  productUsageInformation: ProductUsageInformationInput;
  supplierId?: InputMaybe<Scalars['String']['input']>;
};

export type UrlResponse = {
  __typename?: 'UrlResponse';
  url: Scalars['String']['output'];
};

export type ValidateCreditRequestBatchResponse = {
  __typename?: 'ValidateCreditRequestBatchResponse';
  alerts: Array<CreditRequestAlert>;
};

export type ValidateOrderAlert = {
  __typename?: 'ValidateOrderAlert';
  alert_code?: Maybe<Scalars['String']['output']>;
  alert_level: AlertLevel;
  alert_message: Scalars['String']['output'];
  order_fulfillment_date?: Maybe<Scalars['String']['output']>;
};

export type ValidateOrderLoyalty = {
  __typename?: 'ValidateOrderLoyalty';
  can_enroll: Scalars['Boolean']['output'];
  enrollment_status: Scalars['String']['output'];
  estimated_points: Scalars['bigint']['output'];
  items: Array<ValidateOrderLoyaltyItem>;
  program_id: Scalars['uuid']['output'];
  program_name: Scalars['String']['output'];
  supplier_loyalty_program_restaurant_id: Scalars['uuid']['output'];
};

export type ValidateOrderLoyaltyItem = {
  __typename?: 'ValidateOrderLoyaltyItem';
  estimated_points: Scalars['bigint']['output'];
  order_item_id: Scalars['uuid']['output'];
};

export type ValidateOrderResponse = {
  __typename?: 'ValidateOrderResponse';
  alert_list: Array<Alert>;
  alerts?: Maybe<Array<ValidateOrderAlert>>;
  can_place_order: Scalars['Boolean']['output'];
  loyalty?: Maybe<Array<ValidateOrderLoyalty>>;
  missing_essential_item_ids?: Maybe<Array<Scalars['uuid']['output']>>;
  order?: Maybe<Orders>;
  order_fees: Array<OrderFee>;
  order_id: Scalars['uuid']['output'];
  order_minimum?: Maybe<OrderMinimum>;
  section_headers?: Maybe<Array<SectionHeader>>;
  translated_fulfillment_display_name?: Maybe<Scalars['String']['output']>;
};

export type ValidationType = {
  __typename?: 'ValidationType';
  /** The field or section being validated (e.g., 'description'). */
  field: Scalars['String']['output'];
  /** Optional explanation for failure or warning context. */
  message: Scalars['String']['output'];
  /** Validation result status: 'ok', 'not_ok', 'warning', etc. */
  result: Scalars['String']['output'];
  /** Severity level: 'info', 'warning', 'error', or 'critical'. */
  severity: Scalars['String']['output'];
  /** Timestamp of the validation event (ISO 8601). */
  validatedAt: Scalars['DateTime']['output'];
  /** System or rule that performed the validation. */
  validator: Scalars['String']['output'];
};

export enum VariantPackAvailabilityStatus {
  Discontinued = 'DISCONTINUED',
  LowStock = 'LOW_STOCK',
  OutOfStock = 'OUT_OF_STOCK',
  SpecialOrder = 'SPECIAL_ORDER'
}

export type VariantPackConstraint = {
  __typename?: 'VariantPackConstraint';
  max_quantity?: Maybe<Scalars['Float']['output']>;
  min_quantity?: Maybe<Scalars['Float']['output']>;
};

export type VariantPackCostChange = {
  __typename?: 'VariantPackCostChange';
  base_unit?: Maybe<Scalars['String']['output']>;
  cost_in_micros?: Maybe<Scalars['Int']['output']>;
  cost_in_micros_delta?: Maybe<Scalars['Int']['output']>;
  gross_margin_delta_in_micros?: Maybe<Scalars['Int']['output']>;
  gross_profit_percentage?: Maybe<Scalars['Float']['output']>;
  groups: Array<VariantPackGroupMembership>;
  monthly_quantity: Scalars['Int']['output'];
  price_edit_display_headers?: Maybe<Array<PriceEditDisplayHeader>>;
  price_in_micros?: Maybe<Scalars['Int']['output']>;
  price_in_micros_delta?: Maybe<Scalars['Int']['output']>;
  restaurant?: Maybe<Businesses>;
  restaurant_id: Scalars['uuid']['output'];
  supplier_display_info?: Maybe<Array<PriceEditDisplayInfoDetail>>;
  supplier_id: Scalars['uuid']['output'];
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
  weekly_quantity: Scalars['Float']['output'];
};

export type VariantPackCostInfoResponse = {
  __typename?: 'VariantPackCostInfoResponse';
  details?: Maybe<Array<VariantPackDetailedCostInfoResponse>>;
};

export enum VariantPackCostType {
  DeviatedAmount = 'DEVIATED_AMOUNT',
  DeviatedCost = 'DEVIATED_COST',
  FloorCost = 'FLOOR_COST',
  FloorCostAlt = 'FLOOR_COST_ALT',
  InventoryCost = 'INVENTORY_COST',
  LandedCost = 'LANDED_COST',
  OfficeCost = 'OFFICE_COST',
  SalesCost = 'SALES_COST',
  StandardCost = 'STANDARD_COST'
}

export type VariantPackCreditRequestData = {
  __typename?: 'VariantPackCreditRequestData';
  latest_invoice?: Maybe<VariantPackCreditRequestInvoice>;
  other_creditable_uoms?: Maybe<Array<VariantPackCreditRequestUom>>;
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type VariantPackCreditRequestInvoice = {
  __typename?: 'VariantPackCreditRequestInvoice';
  available_quantity_for_credit?: Maybe<Scalars['Int']['output']>;
  date: Scalars['String']['output'];
  order_invoice_id: Scalars['uuid']['output'];
  order_invoice_number: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  unit_price_in_micros: Scalars['bigint']['output'];
};

export type VariantPackCreditRequestUom = {
  __typename?: 'VariantPackCreditRequestUOM';
  quantity: Scalars['Int']['output'];
  uom: PackUnit;
};

export type VariantPackDetailedCostInfoResponse = {
  __typename?: 'VariantPackDetailedCostInfoResponse';
  cost_in_micros: Scalars['Int']['output'];
  type: VariantPackCostType;
};

export type VariantPackGroupMembership = {
  __typename?: 'VariantPackGroupMembership';
  display_name: Scalars['String']['output'];
  source: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
};

export type VariantPackIncomingInventoryResponse = {
  __typename?: 'VariantPackIncomingInventoryResponse';
  date: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
};

export type VariantPackInput = {
  user_input?: InputMaybe<VariantPackUserInput>;
  variant_pack_id: Scalars['uuid']['input'];
};

export type VariantPackInventoryInfoResponse = {
  __typename?: 'VariantPackInventoryInfoResponse';
  incoming?: Maybe<Array<VariantPackIncomingInventoryResponse>>;
  quantity_on_hand?: Maybe<Scalars['Float']['output']>;
};

export type VariantPackMatch = {
  __typename?: 'VariantPackMatch';
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
  variant_pack_order_counts?: Maybe<Array<VariantPackOrderCount>>;
};

export type VariantPackMetonym = {
  __typename?: 'VariantPackMetonym';
  item_code?: Maybe<Scalars['String']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  metonym: Scalars['String']['output'];
  metonym_uuid: Scalars['uuid']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  variant_pack_uuid: Scalars['uuid']['output'];
};

export type VariantPackOrderCount = {
  __typename?: 'VariantPackOrderCount';
  days: Scalars['Int']['output'];
  order_count: Scalars['Int']['output'];
};

export type VariantPackOrderHistory = {
  __typename?: 'VariantPackOrderHistory';
  is_essential_item: Scalars['Boolean']['output'];
  is_in_order_guide: Scalars['Boolean']['output'];
  variant_pack_uuid: Scalars['uuid']['output'];
};

export type VariantPackPricesResponse = {
  __typename?: 'VariantPackPricesResponse';
  manufacturer_suggested_retail_price?: Maybe<Scalars['bigint']['output']>;
  retail_price?: Maybe<Scalars['bigint']['output']>;
  suggested_retail_price?: Maybe<Scalars['bigint']['output']>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type VariantPackPrintTagConfiguration = {
  __typename?: 'VariantPackPrintTagConfiguration';
  printer_config: TagPrinterConfiguration;
  tag_attributes: Array<PrintTagAttribute>;
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
};

export enum VariantPackPurchaseHistoryOrderBy {
  FulfillmentDate = 'FULFILLMENT_DATE',
  OrderDate = 'ORDER_DATE'
}

export type VariantPackResponse = {
  __typename?: 'VariantPackResponse';
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type VariantPackSalesRepMetadataResponse = {
  __typename?: 'VariantPackSalesRepMetadataResponse';
  price_ceiling_in_micros?: Maybe<Scalars['Int']['output']>;
  updated_by_name?: Maybe<Scalars['String']['output']>;
};

export type VariantPackSubstitution = {
  __typename?: 'VariantPackSubstitution';
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
  variant_pack_order_counts?: Maybe<Array<VariantPackOrderCount>>;
};

export type VariantPackUserInput = {
  retail_price_in_micros?: InputMaybe<Scalars['bigint']['input']>;
};

export type VariantPackWithAvailabilityResponse = {
  __typename?: 'VariantPackWithAvailabilityResponse';
  available_quantity?: Maybe<Scalars['Float']['output']>;
  filters?: Maybe<Array<SearchFilterResponse>>;
  next_offset?: Maybe<Scalars['Int']['output']>;
  paid_search_event_data?: Maybe<PaidSearchEventData>;
  total_count?: Maybe<Scalars['Int']['output']>;
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
  variant_pack_order_counts?: Maybe<Array<VariantPackOrderCount>>;
};

export type VariantPackWithFiltersResponse = {
  __typename?: 'VariantPackWithFiltersResponse';
  filters?: Maybe<Array<SearchFilterResponse>>;
  next_offset?: Maybe<Scalars['Int']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_id: Scalars['uuid']['output'];
};

export type WeeklyProfitRollupHubCardData = {
  __typename?: 'WeeklyProfitRollupHubCardData';
  avg_gp_percentage?: Maybe<Scalars['Float']['output']>;
  avg_gp_percentage_delta?: Maybe<Scalars['Float']['output']>;
  card_type: HubCardType;
  currency_code: Scalars['String']['output'];
  description?: Maybe<CompleteTranslation>;
  subtitle: CompleteTranslation;
  title: CompleteTranslation;
  total_sales_in_micros: Scalars['Int']['output'];
  total_sales_percentage_delta?: Maybe<Scalars['Float']['output']>;
};

export type WeeklyPurchaseQuantity = {
  __typename?: 'WeeklyPurchaseQuantity';
  end_date: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  start_date: Scalars['String']['output'];
};

export type YelpCategoryOptionResponse = {
  __typename?: 'YelpCategoryOptionResponse';
  display_name: Scalars['String']['output'];
  yelp_alias: Scalars['String']['output'];
};

/** Boolean expression to compare columns of type "_date". All fields are combined with logical 'AND'. */
export type _Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_date']['input']>;
  _gt?: InputMaybe<Scalars['_date']['input']>;
  _gte?: InputMaybe<Scalars['_date']['input']>;
  _in?: InputMaybe<Array<Scalars['_date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['_date']['input']>;
  _lte?: InputMaybe<Scalars['_date']['input']>;
  _neq?: InputMaybe<Scalars['_date']['input']>;
  _nin?: InputMaybe<Array<Scalars['_date']['input']>>;
};

/** Boolean expression to compare columns of type "_jsonb". All fields are combined with logical 'AND'. */
export type _Jsonb_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_jsonb']['input']>;
  _gt?: InputMaybe<Scalars['_jsonb']['input']>;
  _gte?: InputMaybe<Scalars['_jsonb']['input']>;
  _in?: InputMaybe<Array<Scalars['_jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['_jsonb']['input']>;
  _lte?: InputMaybe<Scalars['_jsonb']['input']>;
  _neq?: InputMaybe<Scalars['_jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['_jsonb']['input']>>;
};

/** Boolean expression to compare columns of type "_text". All fields are combined with logical 'AND'. */
export type _Text_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_text']['input']>;
  _gt?: InputMaybe<Scalars['_text']['input']>;
  _gte?: InputMaybe<Scalars['_text']['input']>;
  _in?: InputMaybe<Array<Scalars['_text']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['_text']['input']>;
  _lte?: InputMaybe<Scalars['_text']['input']>;
  _neq?: InputMaybe<Scalars['_text']['input']>;
  _nin?: InputMaybe<Array<Scalars['_text']['input']>>;
};

/** Boolean expression to compare columns of type "_uuid". All fields are combined with logical 'AND'. */
export type _Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_uuid']['input']>;
  _gt?: InputMaybe<Scalars['_uuid']['input']>;
  _gte?: InputMaybe<Scalars['_uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['_uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['_uuid']['input']>;
  _lte?: InputMaybe<Scalars['_uuid']['input']>;
  _neq?: InputMaybe<Scalars['_uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['_uuid']['input']>>;
};

/** Boolean expression to compare columns of type "_varchar". All fields are combined with logical 'AND'. */
export type _Varchar_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_varchar']['input']>;
  _gt?: InputMaybe<Scalars['_varchar']['input']>;
  _gte?: InputMaybe<Scalars['_varchar']['input']>;
  _in?: InputMaybe<Array<Scalars['_varchar']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['_varchar']['input']>;
  _lte?: InputMaybe<Scalars['_varchar']['input']>;
  _neq?: InputMaybe<Scalars['_varchar']['input']>;
  _nin?: InputMaybe<Array<Scalars['_varchar']['input']>>;
};

/** columns and relationships of "addresses" */
export type Addresses = Node & {
  __typename?: 'addresses';
  address: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  businesses: Array<Businesses>;
  /** An array relationship connection */
  businesses_connection: BusinessesConnection;
  city: Scalars['String']['output'];
  country_code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  latitude: Scalars['float8']['output'];
  longitude: Scalars['float8']['output'];
  postal_code?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  timezone: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "addresses" */
export type AddressesBusinessesArgs = {
  distinct_on?: InputMaybe<Array<Businesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Businesses_Order_By>>;
  where?: InputMaybe<Businesses_Bool_Exp>;
};


/** columns and relationships of "addresses" */
export type AddressesBusinesses_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Businesses_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Businesses_Order_By>>;
  where?: InputMaybe<Businesses_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "addresses". All fields are combined with a logical 'AND'. */
export type Addresses_Bool_Exp = {
  _and?: InputMaybe<Array<Addresses_Bool_Exp>>;
  _not?: InputMaybe<Addresses_Bool_Exp>;
  _or?: InputMaybe<Array<Addresses_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  address2?: InputMaybe<String_Comparison_Exp>;
  businesses?: InputMaybe<Businesses_Bool_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  latitude?: InputMaybe<Float8_Comparison_Exp>;
  longitude?: InputMaybe<Float8_Comparison_Exp>;
  postal_code?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  timezone?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "addresses". */
export type Addresses_Order_By = {
  address?: InputMaybe<Order_By>;
  address2?: InputMaybe<Order_By>;
  businesses_aggregate?: InputMaybe<Businesses_Aggregate_Order_By>;
  city?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  postal_code?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "analytics_alerts" */
export type Analytics_Alerts = Node & {
  __typename?: 'analytics_alerts';
  alert_status?: Maybe<Scalars['String']['output']>;
  alert_type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  chat: Chats;
  chat_uuid: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['ID']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "analytics_alerts" */
export type Analytics_AlertsConnection = {
  __typename?: 'analytics_alertsConnection';
  edges: Array<Analytics_AlertsEdge>;
  pageInfo: PageInfo;
};

export type Analytics_AlertsEdge = {
  __typename?: 'analytics_alertsEdge';
  cursor: Scalars['String']['output'];
  node: Analytics_Alerts;
};

/** aggregated selection of "analytics_alerts" */
export type Analytics_Alerts_Aggregate = {
  __typename?: 'analytics_alerts_aggregate';
  aggregate?: Maybe<Analytics_Alerts_Aggregate_Fields>;
  nodes: Array<Analytics_Alerts>;
};

/** aggregate fields of "analytics_alerts" */
export type Analytics_Alerts_Aggregate_Fields = {
  __typename?: 'analytics_alerts_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Analytics_Alerts_Max_Fields>;
  min?: Maybe<Analytics_Alerts_Min_Fields>;
};


/** aggregate fields of "analytics_alerts" */
export type Analytics_Alerts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Analytics_Alerts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "analytics_alerts". All fields are combined with a logical 'AND'. */
export type Analytics_Alerts_Bool_Exp = {
  _and?: InputMaybe<Array<Analytics_Alerts_Bool_Exp>>;
  _not?: InputMaybe<Analytics_Alerts_Bool_Exp>;
  _or?: InputMaybe<Array<Analytics_Alerts_Bool_Exp>>;
  alert_status?: InputMaybe<String_Comparison_Exp>;
  alert_type?: InputMaybe<String_Comparison_Exp>;
  chat?: InputMaybe<Chats_Bool_Exp>;
  chat_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Analytics_Alerts_Max_Fields = {
  __typename?: 'analytics_alerts_max_fields';
  alert_status?: Maybe<Scalars['String']['output']>;
  alert_type?: Maybe<Scalars['String']['output']>;
  chat_uuid?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Analytics_Alerts_Min_Fields = {
  __typename?: 'analytics_alerts_min_fields';
  alert_status?: Maybe<Scalars['String']['output']>;
  alert_type?: Maybe<Scalars['String']['output']>;
  chat_uuid?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "analytics_alerts". */
export type Analytics_Alerts_Order_By = {
  alert_status?: InputMaybe<Order_By>;
  alert_type?: InputMaybe<Order_By>;
  chat?: InputMaybe<Chats_Order_By>;
  chat_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "analytics_alerts" */
export enum Analytics_Alerts_Select_Column {
  /** column name */
  AlertStatus = 'alert_status',
  /** column name */
  AlertType = 'alert_type',
  /** column name */
  ChatUuid = 'chat_uuid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "analytics_alerts" */
export type Analytics_Alerts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Analytics_Alerts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Analytics_Alerts_Stream_Cursor_Value_Input = {
  alert_status?: InputMaybe<Scalars['String']['input']>;
  alert_type?: InputMaybe<Scalars['String']['input']>;
  chat_uuid?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "application_decision_notifications" */
export type Application_Decision_Notifications = Node & {
  __typename?: 'application_decision_notifications';
  adverse_action_codes?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  credit_application: Credit_Applications;
  credit_application_uuid: Scalars['uuid']['output'];
  decision: Scalars['String']['output'];
  email_message_id: Scalars['String']['output'];
  email_template_version: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** An object relationship */
  reviewer?: Maybe<Employees>;
  reviewer_uuid?: Maybe<Scalars['uuid']['output']>;
  sent_at: Scalars['timestamptz']['output'];
  sent_to: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "application_decision_notifications" */
export type Application_Decision_NotificationsAdverse_Action_CodesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "application_decision_notifications" */
export type Application_Decision_NotificationsConnection = {
  __typename?: 'application_decision_notificationsConnection';
  edges: Array<Application_Decision_NotificationsEdge>;
  pageInfo: PageInfo;
};

export type Application_Decision_NotificationsEdge = {
  __typename?: 'application_decision_notificationsEdge';
  cursor: Scalars['String']['output'];
  node: Application_Decision_Notifications;
};

/** Boolean expression to filter rows from the table "application_decision_notifications". All fields are combined with a logical 'AND'. */
export type Application_Decision_Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Application_Decision_Notifications_Bool_Exp>>;
  _not?: InputMaybe<Application_Decision_Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Application_Decision_Notifications_Bool_Exp>>;
  adverse_action_codes?: InputMaybe<Jsonb_Comparison_Exp>;
  credit_application?: InputMaybe<Credit_Applications_Bool_Exp>;
  credit_application_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  decision?: InputMaybe<String_Comparison_Exp>;
  email_message_id?: InputMaybe<String_Comparison_Exp>;
  email_template_version?: InputMaybe<String_Comparison_Exp>;
  reviewer?: InputMaybe<Employees_Bool_Exp>;
  reviewer_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  sent_to?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "application_decision_notifications". */
export type Application_Decision_Notifications_Order_By = {
  adverse_action_codes?: InputMaybe<Order_By>;
  credit_application?: InputMaybe<Credit_Applications_Order_By>;
  credit_application_uuid?: InputMaybe<Order_By>;
  decision?: InputMaybe<Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  email_template_version?: InputMaybe<Order_By>;
  reviewer?: InputMaybe<Employees_Order_By>;
  reviewer_uuid?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  sent_to?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "application_decision_notifications" */
export enum Application_Decision_Notifications_Select_Column {
  /** column name */
  AdverseActionCodes = 'adverse_action_codes',
  /** column name */
  CreditApplicationUuid = 'credit_application_uuid',
  /** column name */
  Decision = 'decision',
  /** column name */
  EmailMessageId = 'email_message_id',
  /** column name */
  EmailTemplateVersion = 'email_template_version',
  /** column name */
  ReviewerUuid = 'reviewer_uuid',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  SentTo = 'sent_to',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "application_decision_notifications" */
export type Application_Decision_Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Application_Decision_Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Application_Decision_Notifications_Stream_Cursor_Value_Input = {
  adverse_action_codes?: InputMaybe<Scalars['jsonb']['input']>;
  credit_application_uuid?: InputMaybe<Scalars['uuid']['input']>;
  decision?: InputMaybe<Scalars['String']['input']>;
  email_message_id?: InputMaybe<Scalars['String']['input']>;
  email_template_version?: InputMaybe<Scalars['String']['input']>;
  reviewer_uuid?: InputMaybe<Scalars['uuid']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sent_to?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "auto_pay_settings" */
export type Auto_Pay_Settings = Node & {
  __typename?: 'auto_pay_settings';
  /** An array relationship */
  chat_auto_pay_settings: Array<Chats_Auto_Pay_Settings>;
  /** An array relationship connection */
  chat_auto_pay_settings_connection: Chats_Auto_Pay_SettingsConnection;
  created_at: Scalars['timestamptz']['output'];
  frequency: Scalars['jsonb']['output'];
  id: Scalars['ID']['output'];
  is_visible_to_restaurants: Scalars['Boolean']['output'];
  lookback_period_days: Scalars['Int']['output'];
  max_amount_in_micros?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pay_based_on: Scalars['String']['output'];
  /** An object relationship */
  supplier: Businesses;
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "auto_pay_settings" */
export type Auto_Pay_SettingsChat_Auto_Pay_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Chats_Auto_Pay_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Auto_Pay_Settings_Order_By>>;
  where?: InputMaybe<Chats_Auto_Pay_Settings_Bool_Exp>;
};


/** columns and relationships of "auto_pay_settings" */
export type Auto_Pay_SettingsChat_Auto_Pay_Settings_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Chats_Auto_Pay_Settings_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Auto_Pay_Settings_Order_By>>;
  where?: InputMaybe<Chats_Auto_Pay_Settings_Bool_Exp>;
};


/** columns and relationships of "auto_pay_settings" */
export type Auto_Pay_SettingsFrequencyArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "auto_pay_settings" */
export type Auto_Pay_SettingsConnection = {
  __typename?: 'auto_pay_settingsConnection';
  edges: Array<Auto_Pay_SettingsEdge>;
  pageInfo: PageInfo;
};

export type Auto_Pay_SettingsEdge = {
  __typename?: 'auto_pay_settingsEdge';
  cursor: Scalars['String']['output'];
  node: Auto_Pay_Settings;
};

/** Boolean expression to filter rows from the table "auto_pay_settings". All fields are combined with a logical 'AND'. */
export type Auto_Pay_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Auto_Pay_Settings_Bool_Exp>>;
  _not?: InputMaybe<Auto_Pay_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Auto_Pay_Settings_Bool_Exp>>;
  chat_auto_pay_settings?: InputMaybe<Chats_Auto_Pay_Settings_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  frequency?: InputMaybe<Jsonb_Comparison_Exp>;
  is_visible_to_restaurants?: InputMaybe<Boolean_Comparison_Exp>;
  lookback_period_days?: InputMaybe<Int_Comparison_Exp>;
  max_amount_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  pay_based_on?: InputMaybe<String_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "auto_pay_settings". */
export type Auto_Pay_Settings_Order_By = {
  chat_auto_pay_settings_aggregate?: InputMaybe<Chats_Auto_Pay_Settings_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  is_visible_to_restaurants?: InputMaybe<Order_By>;
  lookback_period_days?: InputMaybe<Order_By>;
  max_amount_in_micros?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pay_based_on?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "auto_pay_settings" */
export enum Auto_Pay_Settings_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  IsVisibleToRestaurants = 'is_visible_to_restaurants',
  /** column name */
  LookbackPeriodDays = 'lookback_period_days',
  /** column name */
  MaxAmountInMicros = 'max_amount_in_micros',
  /** column name */
  Name = 'name',
  /** column name */
  PayBasedOn = 'pay_based_on',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "auto_pay_settings" */
export type Auto_Pay_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auto_Pay_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auto_Pay_Settings_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  frequency?: InputMaybe<Scalars['jsonb']['input']>;
  is_visible_to_restaurants?: InputMaybe<Scalars['Boolean']['input']>;
  lookback_period_days?: InputMaybe<Scalars['Int']['input']>;
  max_amount_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pay_based_on?: InputMaybe<Scalars['String']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "auto_payments" */
export type Auto_Payments = Node & {
  __typename?: 'auto_payments';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['ID']['output'];
  uuid: Scalars['uuid']['output'];
};

/** columns and relationships of "badge_variant_pack_group_rel" */
export type Badge_Variant_Pack_Group_Rel = Node & {
  __typename?: 'badge_variant_pack_group_rel';
  /** An object relationship */
  badge: Badges;
  badge_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  uuid: Scalars['uuid']['output'];
  /** An object relationship */
  variant_pack_group: Variant_Pack_Groups;
  variant_pack_group_uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "badge_variant_pack_group_rel" */
export type Badge_Variant_Pack_Group_RelConnection = {
  __typename?: 'badge_variant_pack_group_relConnection';
  edges: Array<Badge_Variant_Pack_Group_RelEdge>;
  pageInfo: PageInfo;
};

export type Badge_Variant_Pack_Group_RelEdge = {
  __typename?: 'badge_variant_pack_group_relEdge';
  cursor: Scalars['String']['output'];
  node: Badge_Variant_Pack_Group_Rel;
};

/** order by aggregate values of table "badge_variant_pack_group_rel" */
export type Badge_Variant_Pack_Group_Rel_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Badge_Variant_Pack_Group_Rel_Max_Order_By>;
  min?: InputMaybe<Badge_Variant_Pack_Group_Rel_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "badge_variant_pack_group_rel". All fields are combined with a logical 'AND'. */
export type Badge_Variant_Pack_Group_Rel_Bool_Exp = {
  _and?: InputMaybe<Array<Badge_Variant_Pack_Group_Rel_Bool_Exp>>;
  _not?: InputMaybe<Badge_Variant_Pack_Group_Rel_Bool_Exp>;
  _or?: InputMaybe<Array<Badge_Variant_Pack_Group_Rel_Bool_Exp>>;
  badge?: InputMaybe<Badges_Bool_Exp>;
  badge_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack_group?: InputMaybe<Variant_Pack_Groups_Bool_Exp>;
  variant_pack_group_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "badge_variant_pack_group_rel" */
export type Badge_Variant_Pack_Group_Rel_Max_Order_By = {
  badge_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_group_uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "badge_variant_pack_group_rel" */
export type Badge_Variant_Pack_Group_Rel_Min_Order_By = {
  badge_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_group_uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "badge_variant_pack_group_rel". */
export type Badge_Variant_Pack_Group_Rel_Order_By = {
  badge?: InputMaybe<Badges_Order_By>;
  badge_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_group?: InputMaybe<Variant_Pack_Groups_Order_By>;
  variant_pack_group_uuid?: InputMaybe<Order_By>;
};

/** select columns of table "badge_variant_pack_group_rel" */
export enum Badge_Variant_Pack_Group_Rel_Select_Column {
  /** column name */
  BadgeUuid = 'badge_uuid',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VariantPackGroupUuid = 'variant_pack_group_uuid'
}

/** columns and relationships of "badges" */
export type Badges = Node & {
  __typename?: 'badges';
  background_color?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  badge_variant_pack_group_rels: Array<Badge_Variant_Pack_Group_Rel>;
  /** An array relationship connection */
  badge_variant_pack_group_rels_connection: Badge_Variant_Pack_Group_RelConnection;
  id: Scalars['ID']['output'];
  image_url: Scalars['String']['output'];
  name: Scalars['String']['output'];
  short_name?: Maybe<Scalars['String']['output']>;
  sort_order: Scalars['Int']['output'];
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "badges" */
export type BadgesBadge_Variant_Pack_Group_RelsArgs = {
  distinct_on?: InputMaybe<Array<Badge_Variant_Pack_Group_Rel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Badge_Variant_Pack_Group_Rel_Order_By>>;
  where?: InputMaybe<Badge_Variant_Pack_Group_Rel_Bool_Exp>;
};


/** columns and relationships of "badges" */
export type BadgesBadge_Variant_Pack_Group_Rels_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Badge_Variant_Pack_Group_Rel_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Badge_Variant_Pack_Group_Rel_Order_By>>;
  where?: InputMaybe<Badge_Variant_Pack_Group_Rel_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "badges". All fields are combined with a logical 'AND'. */
export type Badges_Bool_Exp = {
  _and?: InputMaybe<Array<Badges_Bool_Exp>>;
  _not?: InputMaybe<Badges_Bool_Exp>;
  _or?: InputMaybe<Array<Badges_Bool_Exp>>;
  background_color?: InputMaybe<String_Comparison_Exp>;
  badge_variant_pack_group_rels?: InputMaybe<Badge_Variant_Pack_Group_Rel_Bool_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
  sort_order?: InputMaybe<Int_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "badges". */
export type Badges_Order_By = {
  background_color?: InputMaybe<Order_By>;
  badge_variant_pack_group_rels_aggregate?: InputMaybe<Badge_Variant_Pack_Group_Rel_Aggregate_Order_By>;
  image_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "brand_page_variant_packs" */
export type Brand_Page_Variant_Packs = {
  __typename?: 'brand_page_variant_packs';
  /** An object relationship */
  brand_page?: Maybe<Brand_Pages>;
  brand_page_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  supplier?: Maybe<Businesses>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
  variant_pack_uuid?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "brand_page_variant_packs". All fields are combined with a logical 'AND'. */
export type Brand_Page_Variant_Packs_Bool_Exp = {
  _and?: InputMaybe<Array<Brand_Page_Variant_Packs_Bool_Exp>>;
  _not?: InputMaybe<Brand_Page_Variant_Packs_Bool_Exp>;
  _or?: InputMaybe<Array<Brand_Page_Variant_Packs_Bool_Exp>>;
  brand_page?: InputMaybe<Brand_Pages_Bool_Exp>;
  brand_page_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "brand_page_variant_packs". */
export type Brand_Page_Variant_Packs_Order_By = {
  brand_page?: InputMaybe<Brand_Pages_Order_By>;
  brand_page_uuid?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** select columns of table "brand_page_variant_packs" */
export enum Brand_Page_Variant_Packs_Select_Column {
  /** column name */
  BrandPageUuid = 'brand_page_uuid',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VariantPackUuid = 'variant_pack_uuid'
}

/** Streaming cursor of the table "brand_page_variant_packs" */
export type Brand_Page_Variant_Packs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Brand_Page_Variant_Packs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Brand_Page_Variant_Packs_Stream_Cursor_Value_Input = {
  brand_page_uuid?: InputMaybe<Scalars['uuid']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
  variant_pack_uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "brand_pages" */
export type Brand_Pages = Node & {
  __typename?: 'brand_pages';
  /** An object relationship */
  advertiser: Businesses;
  brand_name: Scalars['String']['output'];
  carousel_module?: Maybe<Scalars['jsonb']['output']>;
  content_text?: Maybe<Scalars['String']['output']>;
  desktop_image_url?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo_image_url?: Maybe<Scalars['String']['output']>;
  mobile_image_url?: Maybe<Scalars['String']['output']>;
  storefront_module?: Maybe<Scalars['jsonb']['output']>;
  uuid: Scalars['uuid']['output'];
  video_url?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "brand_pages" */
export type Brand_PagesCarousel_ModuleArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "brand_pages" */
export type Brand_PagesStorefront_ModuleArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "brand_pages" */
export type Brand_PagesConnection = {
  __typename?: 'brand_pagesConnection';
  edges: Array<Brand_PagesEdge>;
  pageInfo: PageInfo;
};

export type Brand_PagesEdge = {
  __typename?: 'brand_pagesEdge';
  cursor: Scalars['String']['output'];
  node: Brand_Pages;
};

/** Boolean expression to filter rows from the table "brand_pages". All fields are combined with a logical 'AND'. */
export type Brand_Pages_Bool_Exp = {
  _and?: InputMaybe<Array<Brand_Pages_Bool_Exp>>;
  _not?: InputMaybe<Brand_Pages_Bool_Exp>;
  _or?: InputMaybe<Array<Brand_Pages_Bool_Exp>>;
  advertiser?: InputMaybe<Businesses_Bool_Exp>;
  brand_name?: InputMaybe<String_Comparison_Exp>;
  carousel_module?: InputMaybe<Jsonb_Comparison_Exp>;
  content_text?: InputMaybe<String_Comparison_Exp>;
  desktop_image_url?: InputMaybe<String_Comparison_Exp>;
  headline?: InputMaybe<String_Comparison_Exp>;
  logo_image_url?: InputMaybe<String_Comparison_Exp>;
  mobile_image_url?: InputMaybe<String_Comparison_Exp>;
  storefront_module?: InputMaybe<Jsonb_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  video_url?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "brand_pages". */
export type Brand_Pages_Order_By = {
  advertiser?: InputMaybe<Businesses_Order_By>;
  brand_name?: InputMaybe<Order_By>;
  carousel_module?: InputMaybe<Order_By>;
  content_text?: InputMaybe<Order_By>;
  desktop_image_url?: InputMaybe<Order_By>;
  headline?: InputMaybe<Order_By>;
  logo_image_url?: InputMaybe<Order_By>;
  mobile_image_url?: InputMaybe<Order_By>;
  storefront_module?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  video_url?: InputMaybe<Order_By>;
};

/** select columns of table "brand_pages" */
export enum Brand_Pages_Select_Column {
  /** column name */
  BrandName = 'brand_name',
  /** column name */
  CarouselModule = 'carousel_module',
  /** column name */
  ContentText = 'content_text',
  /** column name */
  DesktopImageUrl = 'desktop_image_url',
  /** column name */
  Headline = 'headline',
  /** column name */
  LogoImageUrl = 'logo_image_url',
  /** column name */
  MobileImageUrl = 'mobile_image_url',
  /** column name */
  StorefrontModule = 'storefront_module',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VideoUrl = 'video_url'
}

/** Streaming cursor of the table "brand_pages" */
export type Brand_Pages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Brand_Pages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Brand_Pages_Stream_Cursor_Value_Input = {
  brand_name?: InputMaybe<Scalars['String']['input']>;
  carousel_module?: InputMaybe<Scalars['jsonb']['input']>;
  content_text?: InputMaybe<Scalars['String']['input']>;
  desktop_image_url?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  logo_image_url?: InputMaybe<Scalars['String']['input']>;
  mobile_image_url?: InputMaybe<Scalars['String']['input']>;
  storefront_module?: InputMaybe<Scalars['jsonb']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
  video_url?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "business_organizations" */
export type Business_Organizations = Node & {
  __typename?: 'business_organizations';
  /** An array relationship */
  businesses: Array<Businesses>;
  /** An array relationship connection */
  businesses_connection: BusinessesConnection;
  id: Scalars['ID']['output'];
  uuid: Scalars['uuid']['output'];
  /** An array relationship */
  whitelabel_config: Array<Whitelabel_Config>;
  /** An array relationship connection */
  whitelabel_config_connection: Whitelabel_ConfigConnection;
};


/** columns and relationships of "business_organizations" */
export type Business_OrganizationsBusinessesArgs = {
  distinct_on?: InputMaybe<Array<Businesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Businesses_Order_By>>;
  where?: InputMaybe<Businesses_Bool_Exp>;
};


/** columns and relationships of "business_organizations" */
export type Business_OrganizationsBusinesses_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Businesses_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Businesses_Order_By>>;
  where?: InputMaybe<Businesses_Bool_Exp>;
};


/** columns and relationships of "business_organizations" */
export type Business_OrganizationsWhitelabel_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Whitelabel_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whitelabel_Config_Order_By>>;
  where?: InputMaybe<Whitelabel_Config_Bool_Exp>;
};


/** columns and relationships of "business_organizations" */
export type Business_OrganizationsWhitelabel_Config_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Whitelabel_Config_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whitelabel_Config_Order_By>>;
  where?: InputMaybe<Whitelabel_Config_Bool_Exp>;
};

/** A Relay connection object on "business_organizations" */
export type Business_OrganizationsConnection = {
  __typename?: 'business_organizationsConnection';
  edges: Array<Business_OrganizationsEdge>;
  pageInfo: PageInfo;
};

export type Business_OrganizationsEdge = {
  __typename?: 'business_organizationsEdge';
  cursor: Scalars['String']['output'];
  node: Business_Organizations;
};

/** Boolean expression to filter rows from the table "business_organizations". All fields are combined with a logical 'AND'. */
export type Business_Organizations_Bool_Exp = {
  _and?: InputMaybe<Array<Business_Organizations_Bool_Exp>>;
  _not?: InputMaybe<Business_Organizations_Bool_Exp>;
  _or?: InputMaybe<Array<Business_Organizations_Bool_Exp>>;
  businesses?: InputMaybe<Businesses_Bool_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  whitelabel_config?: InputMaybe<Whitelabel_Config_Bool_Exp>;
};

/** Ordering options when selecting data from "business_organizations". */
export type Business_Organizations_Order_By = {
  businesses_aggregate?: InputMaybe<Businesses_Aggregate_Order_By>;
  uuid?: InputMaybe<Order_By>;
  whitelabel_config_aggregate?: InputMaybe<Whitelabel_Config_Aggregate_Order_By>;
};

/** select columns of table "business_organizations" */
export enum Business_Organizations_Select_Column {
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "business_organizations" */
export type Business_Organizations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Business_Organizations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Business_Organizations_Stream_Cursor_Value_Input = {
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "businesses" */
export type Businesses = Node & {
  __typename?: 'businesses';
  /** An object relationship */
  address: Addresses;
  address_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  business_organization?: Maybe<Business_Organizations>;
  business_organization_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  businesses_employees: Array<Businesses_Employees>;
  /** An array relationship connection */
  businesses_employees_connection: Businesses_EmployeesConnection;
  contact_info_uuid?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  credit_application_forms: Array<Credit_Application_Forms>;
  /** An array relationship connection */
  credit_application_forms_connection: Credit_Application_FormsConnection;
  /** An array relationship */
  credit_applications: Array<Credit_Applications>;
  /** An array relationship connection */
  credit_applications_connection: Credit_ApplicationsConnection;
  id: Scalars['ID']['output'];
  internal_notes?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  payments_status?: Maybe<Supplier_Payments_Status>;
  /** An array relationship */
  restaurant_chats: Array<Chats>;
  /** An array relationship connection */
  restaurant_chats_connection: ChatsConnection;
  /** An array relationship */
  restaurant_group_members: Array<Restaurant_Group_Members>;
  /** An aggregate relationship */
  restaurant_group_members_aggregate: Restaurant_Group_Members_Aggregate;
  /** An array relationship connection */
  restaurant_group_members_connection: Restaurant_Group_MembersConnection;
  /** An array relationship */
  restaurant_orders: Array<Orders>;
  /** An aggregate relationship */
  restaurant_orders_aggregate: Orders_Aggregate;
  /** An array relationship connection */
  restaurant_orders_connection: OrdersConnection;
  /** An array relationship */
  restaurant_payment_methods: Array<Payment_Methods>;
  /** An array relationship connection */
  restaurant_payment_methods_connection: Payment_MethodsConnection;
  status: Scalars['String']['output'];
  /** An array relationship */
  supplier_chats: Array<Chats>;
  /** An array relationship connection */
  supplier_chats_connection: ChatsConnection;
  /** An array relationship */
  supplier_items: Array<Items>;
  /** An array relationship connection */
  supplier_items_connection: ItemsConnection;
  /** An array relationship */
  supplier_loyalty_programs: Array<Supplier_Loyalty_Programs>;
  /** An array relationship connection */
  supplier_loyalty_programs_connection: Supplier_Loyalty_ProgramsConnection;
  /** An object relationship */
  supplier_metadata?: Maybe<Supplier_Metadata>;
  supplier_metadata_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  supplier_order_invoices: Array<Order_Invoices>;
  /** An aggregate relationship */
  supplier_order_invoices_aggregate: Order_Invoices_Aggregate;
  /** An array relationship connection */
  supplier_order_invoices_connection: Order_InvoicesConnection;
  /** An array relationship */
  supplier_orders: Array<Orders>;
  /** An aggregate relationship */
  supplier_orders_aggregate: Orders_Aggregate;
  /** An array relationship connection */
  supplier_orders_connection: OrdersConnection;
  /** An array relationship */
  supplier_payment_batches: Array<Payment_Batches>;
  /** An aggregate relationship */
  supplier_payment_batches_aggregate: Payment_Batches_Aggregate;
  /** An array relationship connection */
  supplier_payment_batches_connection: Payment_BatchesConnection;
  type: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "businesses" */
export type BusinessesBusinesses_EmployeesArgs = {
  distinct_on?: InputMaybe<Array<Businesses_Employees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Businesses_Employees_Order_By>>;
  where?: InputMaybe<Businesses_Employees_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesBusinesses_Employees_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Businesses_Employees_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Businesses_Employees_Order_By>>;
  where?: InputMaybe<Businesses_Employees_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesCredit_Application_FormsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Application_Forms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Forms_Order_By>>;
  where?: InputMaybe<Credit_Application_Forms_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesCredit_Application_Forms_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Application_Forms_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Forms_Order_By>>;
  where?: InputMaybe<Credit_Application_Forms_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesCredit_ApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Applications_Order_By>>;
  where?: InputMaybe<Credit_Applications_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesCredit_Applications_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Applications_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Applications_Order_By>>;
  where?: InputMaybe<Credit_Applications_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesRestaurant_ChatsArgs = {
  distinct_on?: InputMaybe<Array<Chats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Order_By>>;
  where?: InputMaybe<Chats_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesRestaurant_Chats_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Chats_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Order_By>>;
  where?: InputMaybe<Chats_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesRestaurant_Group_MembersArgs = {
  distinct_on?: InputMaybe<Array<Restaurant_Group_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Group_Members_Order_By>>;
  where?: InputMaybe<Restaurant_Group_Members_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesRestaurant_Group_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Restaurant_Group_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Group_Members_Order_By>>;
  where?: InputMaybe<Restaurant_Group_Members_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesRestaurant_Group_Members_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Restaurant_Group_Members_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Group_Members_Order_By>>;
  where?: InputMaybe<Restaurant_Group_Members_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesRestaurant_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesRestaurant_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesRestaurant_Orders_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesRestaurant_Payment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesRestaurant_Payment_Methods_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesSupplier_ChatsArgs = {
  distinct_on?: InputMaybe<Array<Chats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Order_By>>;
  where?: InputMaybe<Chats_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesSupplier_Chats_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Chats_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Order_By>>;
  where?: InputMaybe<Chats_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesSupplier_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Items_Order_By>>;
  where?: InputMaybe<Items_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesSupplier_Items_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Items_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Items_Order_By>>;
  where?: InputMaybe<Items_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesSupplier_Loyalty_ProgramsArgs = {
  distinct_on?: InputMaybe<Array<Supplier_Loyalty_Programs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supplier_Loyalty_Programs_Order_By>>;
  where?: InputMaybe<Supplier_Loyalty_Programs_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesSupplier_Loyalty_Programs_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Supplier_Loyalty_Programs_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supplier_Loyalty_Programs_Order_By>>;
  where?: InputMaybe<Supplier_Loyalty_Programs_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesSupplier_Order_InvoicesArgs = {
  distinct_on?: InputMaybe<Array<Order_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoices_Order_By>>;
  where?: InputMaybe<Order_Invoices_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesSupplier_Order_Invoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoices_Order_By>>;
  where?: InputMaybe<Order_Invoices_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesSupplier_Order_Invoices_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Invoices_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoices_Order_By>>;
  where?: InputMaybe<Order_Invoices_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesSupplier_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesSupplier_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesSupplier_Orders_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesSupplier_Payment_BatchesArgs = {
  distinct_on?: InputMaybe<Array<Payment_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Batches_Order_By>>;
  where?: InputMaybe<Payment_Batches_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesSupplier_Payment_Batches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Batches_Order_By>>;
  where?: InputMaybe<Payment_Batches_Bool_Exp>;
};


/** columns and relationships of "businesses" */
export type BusinessesSupplier_Payment_Batches_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Payment_Batches_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Batches_Order_By>>;
  where?: InputMaybe<Payment_Batches_Bool_Exp>;
};

/** A Relay connection object on "businesses" */
export type BusinessesConnection = {
  __typename?: 'businessesConnection';
  edges: Array<BusinessesEdge>;
  pageInfo: PageInfo;
};

export type BusinessesEdge = {
  __typename?: 'businessesEdge';
  cursor: Scalars['String']['output'];
  node: Businesses;
};

/** order by aggregate values of table "businesses" */
export type Businesses_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Businesses_Max_Order_By>;
  min?: InputMaybe<Businesses_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "businesses". All fields are combined with a logical 'AND'. */
export type Businesses_Bool_Exp = {
  _and?: InputMaybe<Array<Businesses_Bool_Exp>>;
  _not?: InputMaybe<Businesses_Bool_Exp>;
  _or?: InputMaybe<Array<Businesses_Bool_Exp>>;
  address?: InputMaybe<Addresses_Bool_Exp>;
  address_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  business_organization?: InputMaybe<Business_Organizations_Bool_Exp>;
  business_organization_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  businesses_employees?: InputMaybe<Businesses_Employees_Bool_Exp>;
  contact_info_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_application_forms?: InputMaybe<Credit_Application_Forms_Bool_Exp>;
  credit_applications?: InputMaybe<Credit_Applications_Bool_Exp>;
  internal_notes?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  payments_status?: InputMaybe<Supplier_Payments_Status_Bool_Exp>;
  restaurant_chats?: InputMaybe<Chats_Bool_Exp>;
  restaurant_group_members?: InputMaybe<Restaurant_Group_Members_Bool_Exp>;
  restaurant_orders?: InputMaybe<Orders_Bool_Exp>;
  restaurant_payment_methods?: InputMaybe<Payment_Methods_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  supplier_chats?: InputMaybe<Chats_Bool_Exp>;
  supplier_items?: InputMaybe<Items_Bool_Exp>;
  supplier_loyalty_programs?: InputMaybe<Supplier_Loyalty_Programs_Bool_Exp>;
  supplier_metadata?: InputMaybe<Supplier_Metadata_Bool_Exp>;
  supplier_metadata_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  supplier_order_invoices?: InputMaybe<Order_Invoices_Bool_Exp>;
  supplier_orders?: InputMaybe<Orders_Bool_Exp>;
  supplier_payment_batches?: InputMaybe<Payment_Batches_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "businesses_employees" */
export type Businesses_Employees = Node & {
  __typename?: 'businesses_employees';
  /** An object relationship */
  business: Businesses;
  business_uuid: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  employee: Employees;
  employee_config?: Maybe<Scalars['jsonb']['output']>;
  employee_permissions?: Maybe<Scalars['jsonb']['output']>;
  employee_role: Scalars['String']['output'];
  employee_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "businesses_employees" */
export type Businesses_EmployeesEmployee_ConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "businesses_employees" */
export type Businesses_EmployeesEmployee_PermissionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "businesses_employees" */
export type Businesses_EmployeesConnection = {
  __typename?: 'businesses_employeesConnection';
  edges: Array<Businesses_EmployeesEdge>;
  pageInfo: PageInfo;
};

export type Businesses_EmployeesEdge = {
  __typename?: 'businesses_employeesEdge';
  cursor: Scalars['String']['output'];
  node: Businesses_Employees;
};

/** order by aggregate values of table "businesses_employees" */
export type Businesses_Employees_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Businesses_Employees_Max_Order_By>;
  min?: InputMaybe<Businesses_Employees_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "businesses_employees". All fields are combined with a logical 'AND'. */
export type Businesses_Employees_Bool_Exp = {
  _and?: InputMaybe<Array<Businesses_Employees_Bool_Exp>>;
  _not?: InputMaybe<Businesses_Employees_Bool_Exp>;
  _or?: InputMaybe<Array<Businesses_Employees_Bool_Exp>>;
  business?: InputMaybe<Businesses_Bool_Exp>;
  business_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  employee?: InputMaybe<Employees_Bool_Exp>;
  employee_config?: InputMaybe<Jsonb_Comparison_Exp>;
  employee_permissions?: InputMaybe<Jsonb_Comparison_Exp>;
  employee_role?: InputMaybe<String_Comparison_Exp>;
  employee_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "businesses_employees" */
export type Businesses_Employees_Max_Order_By = {
  business_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  employee_role?: InputMaybe<Order_By>;
  employee_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "businesses_employees" */
export type Businesses_Employees_Min_Order_By = {
  business_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  employee_role?: InputMaybe<Order_By>;
  employee_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "businesses_employees" */
export type Businesses_Employees_Mutation_Response = {
  __typename?: 'businesses_employees_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Businesses_Employees>;
};

/** Ordering options when selecting data from "businesses_employees". */
export type Businesses_Employees_Order_By = {
  business?: InputMaybe<Businesses_Order_By>;
  business_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  employee?: InputMaybe<Employees_Order_By>;
  employee_config?: InputMaybe<Order_By>;
  employee_permissions?: InputMaybe<Order_By>;
  employee_role?: InputMaybe<Order_By>;
  employee_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: businesses_employees */
export type Businesses_Employees_Pk_Columns_Input = {
  uuid: Scalars['uuid']['input'];
};

/** select columns of table "businesses_employees" */
export enum Businesses_Employees_Select_Column {
  /** column name */
  BusinessUuid = 'business_uuid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmployeeConfig = 'employee_config',
  /** column name */
  EmployeePermissions = 'employee_permissions',
  /** column name */
  EmployeeRole = 'employee_role',
  /** column name */
  EmployeeUuid = 'employee_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "businesses_employees" */
export type Businesses_Employees_Set_Input = {
  employee_role?: InputMaybe<Scalars['String']['input']>;
};

export type Businesses_Employees_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Businesses_Employees_Set_Input>;
  where: Businesses_Employees_Bool_Exp;
};

/** order by max() on columns of table "businesses" */
export type Businesses_Max_Order_By = {
  address_uuid?: InputMaybe<Order_By>;
  business_organization_uuid?: InputMaybe<Order_By>;
  contact_info_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  internal_notes?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_metadata_uuid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "businesses" */
export type Businesses_Min_Order_By = {
  address_uuid?: InputMaybe<Order_By>;
  business_organization_uuid?: InputMaybe<Order_By>;
  contact_info_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  internal_notes?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_metadata_uuid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "businesses". */
export type Businesses_Order_By = {
  address?: InputMaybe<Addresses_Order_By>;
  address_uuid?: InputMaybe<Order_By>;
  business_organization?: InputMaybe<Business_Organizations_Order_By>;
  business_organization_uuid?: InputMaybe<Order_By>;
  businesses_employees_aggregate?: InputMaybe<Businesses_Employees_Aggregate_Order_By>;
  contact_info_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_application_forms_aggregate?: InputMaybe<Credit_Application_Forms_Aggregate_Order_By>;
  credit_applications_aggregate?: InputMaybe<Credit_Applications_Aggregate_Order_By>;
  internal_notes?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  payments_status?: InputMaybe<Supplier_Payments_Status_Order_By>;
  restaurant_chats_aggregate?: InputMaybe<Chats_Aggregate_Order_By>;
  restaurant_group_members_aggregate?: InputMaybe<Restaurant_Group_Members_Aggregate_Order_By>;
  restaurant_orders_aggregate?: InputMaybe<Orders_Aggregate_Order_By>;
  restaurant_payment_methods_aggregate?: InputMaybe<Payment_Methods_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_chats_aggregate?: InputMaybe<Chats_Aggregate_Order_By>;
  supplier_items_aggregate?: InputMaybe<Items_Aggregate_Order_By>;
  supplier_loyalty_programs_aggregate?: InputMaybe<Supplier_Loyalty_Programs_Aggregate_Order_By>;
  supplier_metadata?: InputMaybe<Supplier_Metadata_Order_By>;
  supplier_metadata_uuid?: InputMaybe<Order_By>;
  supplier_order_invoices_aggregate?: InputMaybe<Order_Invoices_Aggregate_Order_By>;
  supplier_orders_aggregate?: InputMaybe<Orders_Aggregate_Order_By>;
  supplier_payment_batches_aggregate?: InputMaybe<Payment_Batches_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "businesses" */
export enum Businesses_Select_Column {
  /** column name */
  AddressUuid = 'address_uuid',
  /** column name */
  BusinessOrganizationUuid = 'business_organization_uuid',
  /** column name */
  ContactInfoUuid = 'contact_info_uuid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  InternalNotes = 'internal_notes',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  SupplierMetadataUuid = 'supplier_metadata_uuid',
  /** column name */
  Type = 'type',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "businesses" */
export type Businesses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Businesses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Businesses_Stream_Cursor_Value_Input = {
  address_uuid?: InputMaybe<Scalars['uuid']['input']>;
  business_organization_uuid?: InputMaybe<Scalars['uuid']['input']>;
  contact_info_uuid?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  internal_notes?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier_metadata_uuid?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "cart_details" */
export type Cart_Details = Node & {
  __typename?: 'cart_details';
  cost_info?: Maybe<Scalars['jsonb']['output']>;
  currency_code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pack_price_in_micros?: Maybe<Scalars['bigint']['output']>;
  pack_tax_in_micros?: Maybe<Scalars['bigint']['output']>;
  quantity: Scalars['float8']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "cart_details" */
export type Cart_DetailsCost_InfoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "cart_details". All fields are combined with a logical 'AND'. */
export type Cart_Details_Bool_Exp = {
  _and?: InputMaybe<Array<Cart_Details_Bool_Exp>>;
  _not?: InputMaybe<Cart_Details_Bool_Exp>;
  _or?: InputMaybe<Array<Cart_Details_Bool_Exp>>;
  cost_info?: InputMaybe<Jsonb_Comparison_Exp>;
  currency_code?: InputMaybe<String_Comparison_Exp>;
  pack_price_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  pack_tax_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  quantity?: InputMaybe<Float8_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "cart_details". */
export type Cart_Details_Order_By = {
  cost_info?: InputMaybe<Order_By>;
  currency_code?: InputMaybe<Order_By>;
  pack_price_in_micros?: InputMaybe<Order_By>;
  pack_tax_in_micros?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "chat_last_message" */
export type Chat_Last_Message = {
  __typename?: 'chat_last_message';
  business_organization_uuid?: Maybe<Scalars['uuid']['output']>;
  chat_uuid?: Maybe<Scalars['uuid']['output']>;
  employee_uuid?: Maybe<Scalars['uuid']['output']>;
  last_message_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  last_message_uuid?: Maybe<Scalars['uuid']['output']>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "chat_last_message". All fields are combined with a logical 'AND'. */
export type Chat_Last_Message_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Last_Message_Bool_Exp>>;
  _not?: InputMaybe<Chat_Last_Message_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Last_Message_Bool_Exp>>;
  business_organization_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  chat_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  employee_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  last_message_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_message_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "chat_last_message". */
export type Chat_Last_Message_Order_By = {
  business_organization_uuid?: InputMaybe<Order_By>;
  chat_uuid?: InputMaybe<Order_By>;
  employee_uuid?: InputMaybe<Order_By>;
  last_message_sent_at?: InputMaybe<Order_By>;
  last_message_uuid?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "chat_last_message" */
export enum Chat_Last_Message_Select_Column {
  /** column name */
  BusinessOrganizationUuid = 'business_organization_uuid',
  /** column name */
  ChatUuid = 'chat_uuid',
  /** column name */
  EmployeeUuid = 'employee_uuid',
  /** column name */
  LastMessageSentAt = 'last_message_sent_at',
  /** column name */
  LastMessageUuid = 'last_message_uuid',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "chat_last_message" */
export type Chat_Last_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Last_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Last_Message_Stream_Cursor_Value_Input = {
  business_organization_uuid?: InputMaybe<Scalars['uuid']['input']>;
  chat_uuid?: InputMaybe<Scalars['uuid']['input']>;
  employee_uuid?: InputMaybe<Scalars['uuid']['input']>;
  last_message_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_message_uuid?: InputMaybe<Scalars['uuid']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "chat_unread_message_count" */
export type Chat_Unread_Message_Count = {
  __typename?: 'chat_unread_message_count';
  business_organization_uuid?: Maybe<Scalars['uuid']['output']>;
  chat_employee_uuid?: Maybe<Scalars['uuid']['output']>;
  chat_uuid?: Maybe<Scalars['uuid']['output']>;
  employee_uuid?: Maybe<Scalars['uuid']['output']>;
  unread_message_count?: Maybe<Scalars['Int']['output']>;
};

/** Boolean expression to filter rows from the table "chat_unread_message_count". All fields are combined with a logical 'AND'. */
export type Chat_Unread_Message_Count_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Unread_Message_Count_Bool_Exp>>;
  _not?: InputMaybe<Chat_Unread_Message_Count_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Unread_Message_Count_Bool_Exp>>;
  business_organization_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  chat_employee_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  chat_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  employee_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  unread_message_count?: InputMaybe<Int_Comparison_Exp>;
};

/** Ordering options when selecting data from "chat_unread_message_count". */
export type Chat_Unread_Message_Count_Order_By = {
  business_organization_uuid?: InputMaybe<Order_By>;
  chat_employee_uuid?: InputMaybe<Order_By>;
  chat_uuid?: InputMaybe<Order_By>;
  employee_uuid?: InputMaybe<Order_By>;
  unread_message_count?: InputMaybe<Order_By>;
};

/** select columns of table "chat_unread_message_count" */
export enum Chat_Unread_Message_Count_Select_Column {
  /** column name */
  BusinessOrganizationUuid = 'business_organization_uuid',
  /** column name */
  ChatEmployeeUuid = 'chat_employee_uuid',
  /** column name */
  ChatUuid = 'chat_uuid',
  /** column name */
  EmployeeUuid = 'employee_uuid',
  /** column name */
  UnreadMessageCount = 'unread_message_count'
}

/** Streaming cursor of the table "chat_unread_message_count" */
export type Chat_Unread_Message_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Unread_Message_Count_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Unread_Message_Count_Stream_Cursor_Value_Input = {
  business_organization_uuid?: InputMaybe<Scalars['uuid']['input']>;
  chat_employee_uuid?: InputMaybe<Scalars['uuid']['input']>;
  chat_uuid?: InputMaybe<Scalars['uuid']['input']>;
  employee_uuid?: InputMaybe<Scalars['uuid']['input']>;
  unread_message_count?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "chats" */
export type Chats = Node & {
  __typename?: 'chats';
  app_payments_enabled: Scalars['Boolean']['output'];
  /** An array relationship */
  chat_auto_pay_settings: Array<Chats_Auto_Pay_Settings>;
  /** An array relationship connection */
  chat_auto_pay_settings_connection: Chats_Auto_Pay_SettingsConnection;
  /** An array relationship */
  chat_fulfillment_settings: Array<Chats_Fulfillment_Settings>;
  /** An array relationship connection */
  chat_fulfillment_settings_connection: Chats_Fulfillment_SettingsConnection;
  /** An object relationship */
  chat_route_metadata?: Maybe<Chats_Route_Metadata>;
  /** An array relationship */
  chats_employees: Array<Chats_Employees>;
  /** An array relationship connection */
  chats_employees_connection: Chats_EmployeesConnection;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  credit_request_batches: Array<Credit_Request_Batches>;
  /** An aggregate relationship */
  credit_request_batches_aggregate: Credit_Request_Batches_Aggregate;
  /** An array relationship connection */
  credit_request_batches_connection: Credit_Request_BatchesConnection;
  custom_order_guide_editing_enabled: Scalars['Boolean']['output'];
  custom_order_guide_sort_editing_enabled: Scalars['Boolean']['output'];
  cutoff_time?: Maybe<Scalars['time']['output']>;
  default_fulfillment_type: Scalars['String']['output'];
  delivery_days?: Maybe<Scalars['jsonb']['output']>;
  display_item_prices?: Maybe<Scalars['Boolean']['output']>;
  dynamic_config: Scalars['jsonb']['output'];
  existing_relationship: Scalars['Boolean']['output'];
  flat_transaction_fees: Scalars['jsonb']['output'];
  fulfillment_days: Scalars['jsonb']['output'];
  id: Scalars['ID']['output'];
  item_modifiers_enabled: Scalars['Boolean']['output'];
  /** A computed field, executes function "chat_last_message_uuid" */
  last_message_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  messages: Array<Messages>;
  /** An array relationship connection */
  messages_connection: MessagesConnection;
  on_hold: Scalars['Boolean']['output'];
  order_guide_merge_strategy?: Maybe<Scalars['String']['output']>;
  order_review_required: Scalars['Boolean']['output'];
  /** An array relationship */
  orders: Array<Orders>;
  /** An aggregate relationship */
  orders_aggregate: Orders_Aggregate;
  /** An array relationship connection */
  orders_connection: OrdersConnection;
  po_number_display?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  restaurant: Businesses;
  restaurant_account_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  restaurant_corporation?: Maybe<Businesses>;
  restaurant_notes?: Maybe<Scalars['String']['output']>;
  restaurant_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  sales_rep_chat_relation?: Maybe<Sales_Rep_Chat_Relations>;
  show_app_payments_tab: Scalars['Boolean']['output'];
  show_catalog_inclusions_only: Scalars['Boolean']['output'];
  show_order_guide_only: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  /** An object relationship */
  supplier: Businesses;
  supplier_uuid: Scalars['uuid']['output'];
  transaction_fees: Scalars['jsonb']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "chats" */
export type ChatsChat_Auto_Pay_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Chats_Auto_Pay_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Auto_Pay_Settings_Order_By>>;
  where?: InputMaybe<Chats_Auto_Pay_Settings_Bool_Exp>;
};


/** columns and relationships of "chats" */
export type ChatsChat_Auto_Pay_Settings_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Chats_Auto_Pay_Settings_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Auto_Pay_Settings_Order_By>>;
  where?: InputMaybe<Chats_Auto_Pay_Settings_Bool_Exp>;
};


/** columns and relationships of "chats" */
export type ChatsChat_Fulfillment_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Chats_Fulfillment_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Fulfillment_Settings_Order_By>>;
  where?: InputMaybe<Chats_Fulfillment_Settings_Bool_Exp>;
};


/** columns and relationships of "chats" */
export type ChatsChat_Fulfillment_Settings_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Chats_Fulfillment_Settings_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Fulfillment_Settings_Order_By>>;
  where?: InputMaybe<Chats_Fulfillment_Settings_Bool_Exp>;
};


/** columns and relationships of "chats" */
export type ChatsChats_EmployeesArgs = {
  distinct_on?: InputMaybe<Array<Chats_Employees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Employees_Order_By>>;
  where?: InputMaybe<Chats_Employees_Bool_Exp>;
};


/** columns and relationships of "chats" */
export type ChatsChats_Employees_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Chats_Employees_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Employees_Order_By>>;
  where?: InputMaybe<Chats_Employees_Bool_Exp>;
};


/** columns and relationships of "chats" */
export type ChatsCredit_Request_BatchesArgs = {
  distinct_on?: InputMaybe<Array<Credit_Request_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Batches_Order_By>>;
  where?: InputMaybe<Credit_Request_Batches_Bool_Exp>;
};


/** columns and relationships of "chats" */
export type ChatsCredit_Request_Batches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Request_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Batches_Order_By>>;
  where?: InputMaybe<Credit_Request_Batches_Bool_Exp>;
};


/** columns and relationships of "chats" */
export type ChatsCredit_Request_Batches_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Request_Batches_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Batches_Order_By>>;
  where?: InputMaybe<Credit_Request_Batches_Bool_Exp>;
};


/** columns and relationships of "chats" */
export type ChatsDelivery_DaysArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "chats" */
export type ChatsDynamic_ConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "chats" */
export type ChatsFlat_Transaction_FeesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "chats" */
export type ChatsFulfillment_DaysArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "chats" */
export type ChatsMessagesArgs = {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


/** columns and relationships of "chats" */
export type ChatsMessages_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


/** columns and relationships of "chats" */
export type ChatsOrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "chats" */
export type ChatsOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "chats" */
export type ChatsOrders_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "chats" */
export type ChatsTransaction_FeesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "chats" */
export type ChatsConnection = {
  __typename?: 'chatsConnection';
  edges: Array<ChatsEdge>;
  pageInfo: PageInfo;
};

export type ChatsEdge = {
  __typename?: 'chatsEdge';
  cursor: Scalars['String']['output'];
  node: Chats;
};

/** order by aggregate values of table "chats" */
export type Chats_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Chats_Max_Order_By>;
  min?: InputMaybe<Chats_Min_Order_By>;
};

/** columns and relationships of "chats_auto_pay_settings" */
export type Chats_Auto_Pay_Settings = Node & {
  __typename?: 'chats_auto_pay_settings';
  /** An object relationship */
  auto_pay_settings: Auto_Pay_Settings;
  auto_pay_settings_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  chat: Chats;
  chat_uuid: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['ID']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "chats_auto_pay_settings" */
export type Chats_Auto_Pay_SettingsConnection = {
  __typename?: 'chats_auto_pay_settingsConnection';
  edges: Array<Chats_Auto_Pay_SettingsEdge>;
  pageInfo: PageInfo;
};

export type Chats_Auto_Pay_SettingsEdge = {
  __typename?: 'chats_auto_pay_settingsEdge';
  cursor: Scalars['String']['output'];
  node: Chats_Auto_Pay_Settings;
};

/** order by aggregate values of table "chats_auto_pay_settings" */
export type Chats_Auto_Pay_Settings_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Chats_Auto_Pay_Settings_Max_Order_By>;
  min?: InputMaybe<Chats_Auto_Pay_Settings_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "chats_auto_pay_settings". All fields are combined with a logical 'AND'. */
export type Chats_Auto_Pay_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Chats_Auto_Pay_Settings_Bool_Exp>>;
  _not?: InputMaybe<Chats_Auto_Pay_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Chats_Auto_Pay_Settings_Bool_Exp>>;
  auto_pay_settings?: InputMaybe<Auto_Pay_Settings_Bool_Exp>;
  auto_pay_settings_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  chat?: InputMaybe<Chats_Bool_Exp>;
  chat_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "chats_auto_pay_settings" */
export type Chats_Auto_Pay_Settings_Max_Order_By = {
  auto_pay_settings_uuid?: InputMaybe<Order_By>;
  chat_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "chats_auto_pay_settings" */
export type Chats_Auto_Pay_Settings_Min_Order_By = {
  auto_pay_settings_uuid?: InputMaybe<Order_By>;
  chat_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "chats_auto_pay_settings". */
export type Chats_Auto_Pay_Settings_Order_By = {
  auto_pay_settings?: InputMaybe<Auto_Pay_Settings_Order_By>;
  auto_pay_settings_uuid?: InputMaybe<Order_By>;
  chat?: InputMaybe<Chats_Order_By>;
  chat_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "chats_auto_pay_settings" */
export enum Chats_Auto_Pay_Settings_Select_Column {
  /** column name */
  AutoPaySettingsUuid = 'auto_pay_settings_uuid',
  /** column name */
  ChatUuid = 'chat_uuid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Uuid = 'uuid'
}

/** Boolean expression to filter rows from the table "chats". All fields are combined with a logical 'AND'. */
export type Chats_Bool_Exp = {
  _and?: InputMaybe<Array<Chats_Bool_Exp>>;
  _not?: InputMaybe<Chats_Bool_Exp>;
  _or?: InputMaybe<Array<Chats_Bool_Exp>>;
  app_payments_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  chat_auto_pay_settings?: InputMaybe<Chats_Auto_Pay_Settings_Bool_Exp>;
  chat_fulfillment_settings?: InputMaybe<Chats_Fulfillment_Settings_Bool_Exp>;
  chat_route_metadata?: InputMaybe<Chats_Route_Metadata_Bool_Exp>;
  chats_employees?: InputMaybe<Chats_Employees_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_request_batches?: InputMaybe<Credit_Request_Batches_Bool_Exp>;
  custom_order_guide_editing_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  custom_order_guide_sort_editing_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  cutoff_time?: InputMaybe<Time_Comparison_Exp>;
  default_fulfillment_type?: InputMaybe<String_Comparison_Exp>;
  delivery_days?: InputMaybe<Jsonb_Comparison_Exp>;
  display_item_prices?: InputMaybe<Boolean_Comparison_Exp>;
  dynamic_config?: InputMaybe<Jsonb_Comparison_Exp>;
  existing_relationship?: InputMaybe<Boolean_Comparison_Exp>;
  flat_transaction_fees?: InputMaybe<Jsonb_Comparison_Exp>;
  fulfillment_days?: InputMaybe<Jsonb_Comparison_Exp>;
  item_modifiers_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  last_message_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  messages?: InputMaybe<Messages_Bool_Exp>;
  on_hold?: InputMaybe<Boolean_Comparison_Exp>;
  order_guide_merge_strategy?: InputMaybe<String_Comparison_Exp>;
  order_review_required?: InputMaybe<Boolean_Comparison_Exp>;
  orders?: InputMaybe<Orders_Bool_Exp>;
  po_number_display?: InputMaybe<String_Comparison_Exp>;
  restaurant?: InputMaybe<Businesses_Bool_Exp>;
  restaurant_account_id?: InputMaybe<String_Comparison_Exp>;
  restaurant_corporation?: InputMaybe<Businesses_Bool_Exp>;
  restaurant_notes?: InputMaybe<String_Comparison_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  sales_rep_chat_relation?: InputMaybe<Sales_Rep_Chat_Relations_Bool_Exp>;
  show_app_payments_tab?: InputMaybe<Boolean_Comparison_Exp>;
  show_catalog_inclusions_only?: InputMaybe<Boolean_Comparison_Exp>;
  show_order_guide_only?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  transaction_fees?: InputMaybe<Jsonb_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "chats_employees" */
export type Chats_Employees = Node & {
  __typename?: 'chats_employees';
  /** An object relationship */
  chat: Chats;
  chat_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  employee: Employees;
  employee_uuid: Scalars['uuid']['output'];
  external_sessions_enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  last_viewed?: Maybe<Scalars['timestamptz']['output']>;
  show_app_payments_tab?: Maybe<Scalars['Boolean']['output']>;
  storefront_active_order_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "chats_employees" */
export type Chats_EmployeesConnection = {
  __typename?: 'chats_employeesConnection';
  edges: Array<Chats_EmployeesEdge>;
  pageInfo: PageInfo;
};

export type Chats_EmployeesEdge = {
  __typename?: 'chats_employeesEdge';
  cursor: Scalars['String']['output'];
  node: Chats_Employees;
};

/** order by aggregate values of table "chats_employees" */
export type Chats_Employees_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Chats_Employees_Max_Order_By>;
  min?: InputMaybe<Chats_Employees_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "chats_employees". All fields are combined with a logical 'AND'. */
export type Chats_Employees_Bool_Exp = {
  _and?: InputMaybe<Array<Chats_Employees_Bool_Exp>>;
  _not?: InputMaybe<Chats_Employees_Bool_Exp>;
  _or?: InputMaybe<Array<Chats_Employees_Bool_Exp>>;
  chat?: InputMaybe<Chats_Bool_Exp>;
  chat_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  employee?: InputMaybe<Employees_Bool_Exp>;
  employee_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  external_sessions_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  last_viewed?: InputMaybe<Timestamptz_Comparison_Exp>;
  show_app_payments_tab?: InputMaybe<Boolean_Comparison_Exp>;
  storefront_active_order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "chats_employees" */
export type Chats_Employees_Max_Order_By = {
  chat_uuid?: InputMaybe<Order_By>;
  employee_uuid?: InputMaybe<Order_By>;
  last_viewed?: InputMaybe<Order_By>;
  storefront_active_order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "chats_employees" */
export type Chats_Employees_Min_Order_By = {
  chat_uuid?: InputMaybe<Order_By>;
  employee_uuid?: InputMaybe<Order_By>;
  last_viewed?: InputMaybe<Order_By>;
  storefront_active_order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "chats_employees" */
export type Chats_Employees_Mutation_Response = {
  __typename?: 'chats_employees_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Chats_Employees>;
};

/** Ordering options when selecting data from "chats_employees". */
export type Chats_Employees_Order_By = {
  chat?: InputMaybe<Chats_Order_By>;
  chat_uuid?: InputMaybe<Order_By>;
  employee?: InputMaybe<Employees_Order_By>;
  employee_uuid?: InputMaybe<Order_By>;
  external_sessions_enabled?: InputMaybe<Order_By>;
  last_viewed?: InputMaybe<Order_By>;
  show_app_payments_tab?: InputMaybe<Order_By>;
  storefront_active_order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chats_employees */
export type Chats_Employees_Pk_Columns_Input = {
  uuid: Scalars['uuid']['input'];
};

/** select columns of table "chats_employees" */
export enum Chats_Employees_Select_Column {
  /** column name */
  ChatUuid = 'chat_uuid',
  /** column name */
  EmployeeUuid = 'employee_uuid',
  /** column name */
  ExternalSessionsEnabled = 'external_sessions_enabled',
  /** column name */
  LastViewed = 'last_viewed',
  /** column name */
  ShowAppPaymentsTab = 'show_app_payments_tab',
  /** column name */
  StorefrontActiveOrderUuid = 'storefront_active_order_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "chats_employees" */
export type Chats_Employees_Set_Input = {
  show_app_payments_tab?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Chats_Employees_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Chats_Employees_Set_Input>;
  where: Chats_Employees_Bool_Exp;
};

/** columns and relationships of "chats_fulfillment_settings" */
export type Chats_Fulfillment_Settings = Node & {
  __typename?: 'chats_fulfillment_settings';
  /** An object relationship */
  fulfillment_settings: Fulfillment_Settings;
  fulfillment_settings_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  sort_order?: Maybe<Scalars['float8']['output']>;
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "chats_fulfillment_settings" */
export type Chats_Fulfillment_SettingsConnection = {
  __typename?: 'chats_fulfillment_settingsConnection';
  edges: Array<Chats_Fulfillment_SettingsEdge>;
  pageInfo: PageInfo;
};

export type Chats_Fulfillment_SettingsEdge = {
  __typename?: 'chats_fulfillment_settingsEdge';
  cursor: Scalars['String']['output'];
  node: Chats_Fulfillment_Settings;
};

/** order by aggregate values of table "chats_fulfillment_settings" */
export type Chats_Fulfillment_Settings_Aggregate_Order_By = {
  avg?: InputMaybe<Chats_Fulfillment_Settings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Chats_Fulfillment_Settings_Max_Order_By>;
  min?: InputMaybe<Chats_Fulfillment_Settings_Min_Order_By>;
  stddev?: InputMaybe<Chats_Fulfillment_Settings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Chats_Fulfillment_Settings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Chats_Fulfillment_Settings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Chats_Fulfillment_Settings_Sum_Order_By>;
  var_pop?: InputMaybe<Chats_Fulfillment_Settings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Chats_Fulfillment_Settings_Var_Samp_Order_By>;
  variance?: InputMaybe<Chats_Fulfillment_Settings_Variance_Order_By>;
};

/** order by avg() on columns of table "chats_fulfillment_settings" */
export type Chats_Fulfillment_Settings_Avg_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "chats_fulfillment_settings". All fields are combined with a logical 'AND'. */
export type Chats_Fulfillment_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Chats_Fulfillment_Settings_Bool_Exp>>;
  _not?: InputMaybe<Chats_Fulfillment_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Chats_Fulfillment_Settings_Bool_Exp>>;
  fulfillment_settings?: InputMaybe<Fulfillment_Settings_Bool_Exp>;
  fulfillment_settings_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  sort_order?: InputMaybe<Float8_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "chats_fulfillment_settings" */
export type Chats_Fulfillment_Settings_Max_Order_By = {
  fulfillment_settings_uuid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "chats_fulfillment_settings" */
export type Chats_Fulfillment_Settings_Min_Order_By = {
  fulfillment_settings_uuid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "chats_fulfillment_settings". */
export type Chats_Fulfillment_Settings_Order_By = {
  fulfillment_settings?: InputMaybe<Fulfillment_Settings_Order_By>;
  fulfillment_settings_uuid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "chats_fulfillment_settings" */
export enum Chats_Fulfillment_Settings_Select_Column {
  /** column name */
  FulfillmentSettingsUuid = 'fulfillment_settings_uuid',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  Uuid = 'uuid'
}

/** order by stddev() on columns of table "chats_fulfillment_settings" */
export type Chats_Fulfillment_Settings_Stddev_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "chats_fulfillment_settings" */
export type Chats_Fulfillment_Settings_Stddev_Pop_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "chats_fulfillment_settings" */
export type Chats_Fulfillment_Settings_Stddev_Samp_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "chats_fulfillment_settings" */
export type Chats_Fulfillment_Settings_Sum_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "chats_fulfillment_settings" */
export type Chats_Fulfillment_Settings_Var_Pop_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "chats_fulfillment_settings" */
export type Chats_Fulfillment_Settings_Var_Samp_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "chats_fulfillment_settings" */
export type Chats_Fulfillment_Settings_Variance_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "chats" */
export type Chats_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  default_fulfillment_type?: InputMaybe<Order_By>;
  order_guide_merge_strategy?: InputMaybe<Order_By>;
  po_number_display?: InputMaybe<Order_By>;
  restaurant_account_id?: InputMaybe<Order_By>;
  restaurant_notes?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "chats" */
export type Chats_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  default_fulfillment_type?: InputMaybe<Order_By>;
  order_guide_merge_strategy?: InputMaybe<Order_By>;
  po_number_display?: InputMaybe<Order_By>;
  restaurant_account_id?: InputMaybe<Order_By>;
  restaurant_notes?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "chats". */
export type Chats_Order_By = {
  app_payments_enabled?: InputMaybe<Order_By>;
  chat_auto_pay_settings_aggregate?: InputMaybe<Chats_Auto_Pay_Settings_Aggregate_Order_By>;
  chat_fulfillment_settings_aggregate?: InputMaybe<Chats_Fulfillment_Settings_Aggregate_Order_By>;
  chat_route_metadata?: InputMaybe<Chats_Route_Metadata_Order_By>;
  chats_employees_aggregate?: InputMaybe<Chats_Employees_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_request_batches_aggregate?: InputMaybe<Credit_Request_Batches_Aggregate_Order_By>;
  custom_order_guide_editing_enabled?: InputMaybe<Order_By>;
  custom_order_guide_sort_editing_enabled?: InputMaybe<Order_By>;
  cutoff_time?: InputMaybe<Order_By>;
  default_fulfillment_type?: InputMaybe<Order_By>;
  delivery_days?: InputMaybe<Order_By>;
  display_item_prices?: InputMaybe<Order_By>;
  dynamic_config?: InputMaybe<Order_By>;
  existing_relationship?: InputMaybe<Order_By>;
  flat_transaction_fees?: InputMaybe<Order_By>;
  fulfillment_days?: InputMaybe<Order_By>;
  item_modifiers_enabled?: InputMaybe<Order_By>;
  last_message_uuid?: InputMaybe<Order_By>;
  messages_aggregate?: InputMaybe<Messages_Aggregate_Order_By>;
  on_hold?: InputMaybe<Order_By>;
  order_guide_merge_strategy?: InputMaybe<Order_By>;
  order_review_required?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Orders_Aggregate_Order_By>;
  po_number_display?: InputMaybe<Order_By>;
  restaurant?: InputMaybe<Businesses_Order_By>;
  restaurant_account_id?: InputMaybe<Order_By>;
  restaurant_corporation?: InputMaybe<Businesses_Order_By>;
  restaurant_notes?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  sales_rep_chat_relation?: InputMaybe<Sales_Rep_Chat_Relations_Order_By>;
  show_app_payments_tab?: InputMaybe<Order_By>;
  show_catalog_inclusions_only?: InputMaybe<Order_By>;
  show_order_guide_only?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  transaction_fees?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "chats_route_metadata" */
export type Chats_Route_Metadata = Node & {
  __typename?: 'chats_route_metadata';
  /** An object relationship */
  chat: Chats;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** A Relay connection object on "chats_route_metadata" */
export type Chats_Route_MetadataConnection = {
  __typename?: 'chats_route_metadataConnection';
  edges: Array<Chats_Route_MetadataEdge>;
  pageInfo: PageInfo;
};

export type Chats_Route_MetadataEdge = {
  __typename?: 'chats_route_metadataEdge';
  cursor: Scalars['String']['output'];
  node: Chats_Route_Metadata;
};

/** Boolean expression to filter rows from the table "chats_route_metadata". All fields are combined with a logical 'AND'. */
export type Chats_Route_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Chats_Route_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Chats_Route_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Chats_Route_Metadata_Bool_Exp>>;
  chat?: InputMaybe<Chats_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "chats_route_metadata". */
export type Chats_Route_Metadata_Order_By = {
  chat?: InputMaybe<Chats_Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "chats_route_metadata" */
export enum Chats_Route_Metadata_Select_Column {
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "chats_route_metadata" */
export type Chats_Route_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chats_Route_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chats_Route_Metadata_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** select columns of table "chats" */
export enum Chats_Select_Column {
  /** column name */
  AppPaymentsEnabled = 'app_payments_enabled',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomOrderGuideEditingEnabled = 'custom_order_guide_editing_enabled',
  /** column name */
  CustomOrderGuideSortEditingEnabled = 'custom_order_guide_sort_editing_enabled',
  /** column name */
  CutoffTime = 'cutoff_time',
  /** column name */
  DefaultFulfillmentType = 'default_fulfillment_type',
  /** column name */
  DeliveryDays = 'delivery_days',
  /** column name */
  DisplayItemPrices = 'display_item_prices',
  /** column name */
  DynamicConfig = 'dynamic_config',
  /** column name */
  ExistingRelationship = 'existing_relationship',
  /** column name */
  FlatTransactionFees = 'flat_transaction_fees',
  /** column name */
  FulfillmentDays = 'fulfillment_days',
  /** column name */
  ItemModifiersEnabled = 'item_modifiers_enabled',
  /** column name */
  OnHold = 'on_hold',
  /** column name */
  OrderGuideMergeStrategy = 'order_guide_merge_strategy',
  /** column name */
  OrderReviewRequired = 'order_review_required',
  /** column name */
  PoNumberDisplay = 'po_number_display',
  /** column name */
  RestaurantAccountId = 'restaurant_account_id',
  /** column name */
  RestaurantNotes = 'restaurant_notes',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  ShowAppPaymentsTab = 'show_app_payments_tab',
  /** column name */
  ShowCatalogInclusionsOnly = 'show_catalog_inclusions_only',
  /** column name */
  ShowOrderGuideOnly = 'show_order_guide_only',
  /** column name */
  Status = 'status',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  TransactionFees = 'transaction_fees',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "chats" */
export type Chats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chats_Stream_Cursor_Value_Input = {
  app_payments_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_order_guide_editing_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  custom_order_guide_sort_editing_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  cutoff_time?: InputMaybe<Scalars['time']['input']>;
  default_fulfillment_type?: InputMaybe<Scalars['String']['input']>;
  delivery_days?: InputMaybe<Scalars['jsonb']['input']>;
  display_item_prices?: InputMaybe<Scalars['Boolean']['input']>;
  dynamic_config?: InputMaybe<Scalars['jsonb']['input']>;
  existing_relationship?: InputMaybe<Scalars['Boolean']['input']>;
  flat_transaction_fees?: InputMaybe<Scalars['jsonb']['input']>;
  fulfillment_days?: InputMaybe<Scalars['jsonb']['input']>;
  item_modifiers_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  on_hold?: InputMaybe<Scalars['Boolean']['input']>;
  order_guide_merge_strategy?: InputMaybe<Scalars['String']['input']>;
  order_review_required?: InputMaybe<Scalars['Boolean']['input']>;
  po_number_display?: InputMaybe<Scalars['String']['input']>;
  restaurant_account_id?: InputMaybe<Scalars['String']['input']>;
  restaurant_notes?: InputMaybe<Scalars['String']['input']>;
  restaurant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  show_app_payments_tab?: InputMaybe<Scalars['Boolean']['input']>;
  show_catalog_inclusions_only?: InputMaybe<Scalars['Boolean']['input']>;
  show_order_guide_only?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  transaction_fees?: InputMaybe<Scalars['jsonb']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "credit_application_consent_acceptances" */
export type Credit_Application_Consent_Acceptances = Node & {
  __typename?: 'credit_application_consent_acceptances';
  consent_version: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  credit_application: Credit_Applications;
  credit_application_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "credit_application_consent_acceptances" */
export type Credit_Application_Consent_AcceptancesConnection = {
  __typename?: 'credit_application_consent_acceptancesConnection';
  edges: Array<Credit_Application_Consent_AcceptancesEdge>;
  pageInfo: PageInfo;
};

export type Credit_Application_Consent_AcceptancesEdge = {
  __typename?: 'credit_application_consent_acceptancesEdge';
  cursor: Scalars['String']['output'];
  node: Credit_Application_Consent_Acceptances;
};

/** Boolean expression to filter rows from the table "credit_application_consent_acceptances". All fields are combined with a logical 'AND'. */
export type Credit_Application_Consent_Acceptances_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Application_Consent_Acceptances_Bool_Exp>>;
  _not?: InputMaybe<Credit_Application_Consent_Acceptances_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Application_Consent_Acceptances_Bool_Exp>>;
  consent_version?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_application?: InputMaybe<Credit_Applications_Bool_Exp>;
  credit_application_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "credit_application_consent_acceptances". */
export type Credit_Application_Consent_Acceptances_Order_By = {
  consent_version?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_application?: InputMaybe<Credit_Applications_Order_By>;
  credit_application_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "credit_application_consent_acceptances" */
export enum Credit_Application_Consent_Acceptances_Select_Column {
  /** column name */
  ConsentVersion = 'consent_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditApplicationUuid = 'credit_application_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "credit_application_consent_acceptances" */
export type Credit_Application_Consent_Acceptances_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Application_Consent_Acceptances_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Application_Consent_Acceptances_Stream_Cursor_Value_Input = {
  consent_version?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  credit_application_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "credit_application_form_fields" */
export type Credit_Application_Form_Fields = Node & {
  __typename?: 'credit_application_form_fields';
  created_at: Scalars['timestamptz']['output'];
  default_value?: Maybe<Scalars['String']['output']>;
  field_key: Scalars['String']['output'];
  field_type: Scalars['String']['output'];
  help_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_required: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  options?: Maybe<Scalars['jsonb']['output']>;
  order_index: Scalars['Int']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  section_parent: Credit_Application_Form_Sections;
  section_parent_uuid: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  uuid: Scalars['uuid']['output'];
  validation_rules?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "credit_application_form_fields" */
export type Credit_Application_Form_FieldsOptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "credit_application_form_fields" */
export type Credit_Application_Form_FieldsValidation_RulesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "credit_application_form_fields" */
export type Credit_Application_Form_FieldsConnection = {
  __typename?: 'credit_application_form_fieldsConnection';
  edges: Array<Credit_Application_Form_FieldsEdge>;
  pageInfo: PageInfo;
};

export type Credit_Application_Form_FieldsEdge = {
  __typename?: 'credit_application_form_fieldsEdge';
  cursor: Scalars['String']['output'];
  node: Credit_Application_Form_Fields;
};

/** order by aggregate values of table "credit_application_form_fields" */
export type Credit_Application_Form_Fields_Aggregate_Order_By = {
  avg?: InputMaybe<Credit_Application_Form_Fields_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Credit_Application_Form_Fields_Max_Order_By>;
  min?: InputMaybe<Credit_Application_Form_Fields_Min_Order_By>;
  stddev?: InputMaybe<Credit_Application_Form_Fields_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Credit_Application_Form_Fields_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Credit_Application_Form_Fields_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Credit_Application_Form_Fields_Sum_Order_By>;
  var_pop?: InputMaybe<Credit_Application_Form_Fields_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Credit_Application_Form_Fields_Var_Samp_Order_By>;
  variance?: InputMaybe<Credit_Application_Form_Fields_Variance_Order_By>;
};

/** order by avg() on columns of table "credit_application_form_fields" */
export type Credit_Application_Form_Fields_Avg_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "credit_application_form_fields". All fields are combined with a logical 'AND'. */
export type Credit_Application_Form_Fields_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Application_Form_Fields_Bool_Exp>>;
  _not?: InputMaybe<Credit_Application_Form_Fields_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Application_Form_Fields_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  default_value?: InputMaybe<String_Comparison_Exp>;
  field_key?: InputMaybe<String_Comparison_Exp>;
  field_type?: InputMaybe<String_Comparison_Exp>;
  help_text?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_required?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
  order_index?: InputMaybe<Int_Comparison_Exp>;
  placeholder?: InputMaybe<String_Comparison_Exp>;
  section_parent?: InputMaybe<Credit_Application_Form_Sections_Bool_Exp>;
  section_parent_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  validation_rules?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** order by max() on columns of table "credit_application_form_fields" */
export type Credit_Application_Form_Fields_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  default_value?: InputMaybe<Order_By>;
  field_key?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  help_text?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  placeholder?: InputMaybe<Order_By>;
  section_parent_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "credit_application_form_fields" */
export type Credit_Application_Form_Fields_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  default_value?: InputMaybe<Order_By>;
  field_key?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  help_text?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  placeholder?: InputMaybe<Order_By>;
  section_parent_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "credit_application_form_fields". */
export type Credit_Application_Form_Fields_Order_By = {
  created_at?: InputMaybe<Order_By>;
  default_value?: InputMaybe<Order_By>;
  field_key?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  help_text?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_required?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  placeholder?: InputMaybe<Order_By>;
  section_parent?: InputMaybe<Credit_Application_Form_Sections_Order_By>;
  section_parent_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  validation_rules?: InputMaybe<Order_By>;
};

/** select columns of table "credit_application_form_fields" */
export enum Credit_Application_Form_Fields_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DefaultValue = 'default_value',
  /** column name */
  FieldKey = 'field_key',
  /** column name */
  FieldType = 'field_type',
  /** column name */
  HelpText = 'help_text',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsRequired = 'is_required',
  /** column name */
  Label = 'label',
  /** column name */
  Options = 'options',
  /** column name */
  OrderIndex = 'order_index',
  /** column name */
  Placeholder = 'placeholder',
  /** column name */
  SectionParentUuid = 'section_parent_uuid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  ValidationRules = 'validation_rules'
}

/** order by stddev() on columns of table "credit_application_form_fields" */
export type Credit_Application_Form_Fields_Stddev_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "credit_application_form_fields" */
export type Credit_Application_Form_Fields_Stddev_Pop_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "credit_application_form_fields" */
export type Credit_Application_Form_Fields_Stddev_Samp_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "credit_application_form_fields" */
export type Credit_Application_Form_Fields_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Application_Form_Fields_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Application_Form_Fields_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  default_value?: InputMaybe<Scalars['String']['input']>;
  field_key?: InputMaybe<Scalars['String']['input']>;
  field_type?: InputMaybe<Scalars['String']['input']>;
  help_text?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_required?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  order_index?: InputMaybe<Scalars['Int']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  section_parent_uuid?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
  validation_rules?: InputMaybe<Scalars['jsonb']['input']>;
};

/** order by sum() on columns of table "credit_application_form_fields" */
export type Credit_Application_Form_Fields_Sum_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "credit_application_form_fields" */
export type Credit_Application_Form_Fields_Var_Pop_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "credit_application_form_fields" */
export type Credit_Application_Form_Fields_Var_Samp_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "credit_application_form_fields" */
export type Credit_Application_Form_Fields_Variance_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** columns and relationships of "credit_application_form_sections" */
export type Credit_Application_Form_Sections = Node & {
  __typename?: 'credit_application_form_sections';
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  form_fields: Array<Credit_Application_Form_Fields>;
  /** An array relationship connection */
  form_fields_connection: Credit_Application_Form_FieldsConnection;
  /** An array relationship */
  form_version_form_section_rels: Array<Credit_Form_Version_Form_Section_Rel>;
  /** An array relationship connection */
  form_version_form_section_rels_connection: Credit_Form_Version_Form_Section_RelConnection;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  order_index: Scalars['Int']['output'];
  section_name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "credit_application_form_sections" */
export type Credit_Application_Form_SectionsForm_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Application_Form_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Form_Fields_Order_By>>;
  where?: InputMaybe<Credit_Application_Form_Fields_Bool_Exp>;
};


/** columns and relationships of "credit_application_form_sections" */
export type Credit_Application_Form_SectionsForm_Fields_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Application_Form_Fields_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Form_Fields_Order_By>>;
  where?: InputMaybe<Credit_Application_Form_Fields_Bool_Exp>;
};


/** columns and relationships of "credit_application_form_sections" */
export type Credit_Application_Form_SectionsForm_Version_Form_Section_RelsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Form_Version_Form_Section_Rel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Form_Version_Form_Section_Rel_Order_By>>;
  where?: InputMaybe<Credit_Form_Version_Form_Section_Rel_Bool_Exp>;
};


/** columns and relationships of "credit_application_form_sections" */
export type Credit_Application_Form_SectionsForm_Version_Form_Section_Rels_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Form_Version_Form_Section_Rel_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Form_Version_Form_Section_Rel_Order_By>>;
  where?: InputMaybe<Credit_Form_Version_Form_Section_Rel_Bool_Exp>;
};

/** A Relay connection object on "credit_application_form_sections" */
export type Credit_Application_Form_SectionsConnection = {
  __typename?: 'credit_application_form_sectionsConnection';
  edges: Array<Credit_Application_Form_SectionsEdge>;
  pageInfo: PageInfo;
};

export type Credit_Application_Form_SectionsEdge = {
  __typename?: 'credit_application_form_sectionsEdge';
  cursor: Scalars['String']['output'];
  node: Credit_Application_Form_Sections;
};

/** Boolean expression to filter rows from the table "credit_application_form_sections". All fields are combined with a logical 'AND'. */
export type Credit_Application_Form_Sections_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Application_Form_Sections_Bool_Exp>>;
  _not?: InputMaybe<Credit_Application_Form_Sections_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Application_Form_Sections_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  form_fields?: InputMaybe<Credit_Application_Form_Fields_Bool_Exp>;
  form_version_form_section_rels?: InputMaybe<Credit_Form_Version_Form_Section_Rel_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  order_index?: InputMaybe<Int_Comparison_Exp>;
  section_name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "credit_application_form_sections". */
export type Credit_Application_Form_Sections_Order_By = {
  created_at?: InputMaybe<Order_By>;
  form_fields_aggregate?: InputMaybe<Credit_Application_Form_Fields_Aggregate_Order_By>;
  form_version_form_section_rels_aggregate?: InputMaybe<Credit_Form_Version_Form_Section_Rel_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  section_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "credit_application_form_sections" */
export enum Credit_Application_Form_Sections_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  OrderIndex = 'order_index',
  /** column name */
  SectionName = 'section_name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "credit_application_form_sections" */
export type Credit_Application_Form_Sections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Application_Form_Sections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Application_Form_Sections_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  order_index?: InputMaybe<Scalars['Int']['input']>;
  section_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "credit_application_form_versions" */
export type Credit_Application_Form_Versions = Node & {
  __typename?: 'credit_application_form_versions';
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  credit_applications: Array<Credit_Applications>;
  /** An array relationship connection */
  credit_applications_connection: Credit_ApplicationsConnection;
  /** An object relationship */
  form_parent: Credit_Application_Forms;
  form_parent_uuid: Scalars['uuid']['output'];
  /** An array relationship */
  form_version_form_section_rels: Array<Credit_Form_Version_Form_Section_Rel>;
  /** An array relationship connection */
  form_version_form_section_rels_connection: Credit_Form_Version_Form_Section_RelConnection;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  updated_at: Scalars['timestamptz']['output'];
  uuid: Scalars['uuid']['output'];
  version: Scalars['Int']['output'];
};


/** columns and relationships of "credit_application_form_versions" */
export type Credit_Application_Form_VersionsCredit_ApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Applications_Order_By>>;
  where?: InputMaybe<Credit_Applications_Bool_Exp>;
};


/** columns and relationships of "credit_application_form_versions" */
export type Credit_Application_Form_VersionsCredit_Applications_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Applications_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Applications_Order_By>>;
  where?: InputMaybe<Credit_Applications_Bool_Exp>;
};


/** columns and relationships of "credit_application_form_versions" */
export type Credit_Application_Form_VersionsForm_Version_Form_Section_RelsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Form_Version_Form_Section_Rel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Form_Version_Form_Section_Rel_Order_By>>;
  where?: InputMaybe<Credit_Form_Version_Form_Section_Rel_Bool_Exp>;
};


/** columns and relationships of "credit_application_form_versions" */
export type Credit_Application_Form_VersionsForm_Version_Form_Section_Rels_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Form_Version_Form_Section_Rel_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Form_Version_Form_Section_Rel_Order_By>>;
  where?: InputMaybe<Credit_Form_Version_Form_Section_Rel_Bool_Exp>;
};

/** A Relay connection object on "credit_application_form_versions" */
export type Credit_Application_Form_VersionsConnection = {
  __typename?: 'credit_application_form_versionsConnection';
  edges: Array<Credit_Application_Form_VersionsEdge>;
  pageInfo: PageInfo;
};

export type Credit_Application_Form_VersionsEdge = {
  __typename?: 'credit_application_form_versionsEdge';
  cursor: Scalars['String']['output'];
  node: Credit_Application_Form_Versions;
};

/** order by aggregate values of table "credit_application_form_versions" */
export type Credit_Application_Form_Versions_Aggregate_Order_By = {
  avg?: InputMaybe<Credit_Application_Form_Versions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Credit_Application_Form_Versions_Max_Order_By>;
  min?: InputMaybe<Credit_Application_Form_Versions_Min_Order_By>;
  stddev?: InputMaybe<Credit_Application_Form_Versions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Credit_Application_Form_Versions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Credit_Application_Form_Versions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Credit_Application_Form_Versions_Sum_Order_By>;
  var_pop?: InputMaybe<Credit_Application_Form_Versions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Credit_Application_Form_Versions_Var_Samp_Order_By>;
  variance?: InputMaybe<Credit_Application_Form_Versions_Variance_Order_By>;
};

/** order by avg() on columns of table "credit_application_form_versions" */
export type Credit_Application_Form_Versions_Avg_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "credit_application_form_versions". All fields are combined with a logical 'AND'. */
export type Credit_Application_Form_Versions_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Application_Form_Versions_Bool_Exp>>;
  _not?: InputMaybe<Credit_Application_Form_Versions_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Application_Form_Versions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_applications?: InputMaybe<Credit_Applications_Bool_Exp>;
  form_parent?: InputMaybe<Credit_Application_Forms_Bool_Exp>;
  form_parent_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  form_version_form_section_rels?: InputMaybe<Credit_Form_Version_Form_Section_Rel_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** order by max() on columns of table "credit_application_form_versions" */
export type Credit_Application_Form_Versions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  form_parent_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "credit_application_form_versions" */
export type Credit_Application_Form_Versions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  form_parent_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "credit_application_form_versions". */
export type Credit_Application_Form_Versions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credit_applications_aggregate?: InputMaybe<Credit_Applications_Aggregate_Order_By>;
  form_parent?: InputMaybe<Credit_Application_Forms_Order_By>;
  form_parent_uuid?: InputMaybe<Order_By>;
  form_version_form_section_rels_aggregate?: InputMaybe<Credit_Form_Version_Form_Section_Rel_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** select columns of table "credit_application_form_versions" */
export enum Credit_Application_Form_Versions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FormParentUuid = 'form_parent_uuid',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Version = 'version'
}

/** order by stddev() on columns of table "credit_application_form_versions" */
export type Credit_Application_Form_Versions_Stddev_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "credit_application_form_versions" */
export type Credit_Application_Form_Versions_Stddev_Pop_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "credit_application_form_versions" */
export type Credit_Application_Form_Versions_Stddev_Samp_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "credit_application_form_versions" */
export type Credit_Application_Form_Versions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Application_Form_Versions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Application_Form_Versions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  form_parent_uuid?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "credit_application_form_versions" */
export type Credit_Application_Form_Versions_Sum_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "credit_application_form_versions" */
export type Credit_Application_Form_Versions_Var_Pop_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "credit_application_form_versions" */
export type Credit_Application_Form_Versions_Var_Samp_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "credit_application_form_versions" */
export type Credit_Application_Form_Versions_Variance_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** columns and relationships of "credit_application_forms" */
export type Credit_Application_Forms = Node & {
  __typename?: 'credit_application_forms';
  created_at: Scalars['timestamptz']['output'];
  credit_check_enabled: Scalars['Boolean']['output'];
  credit_check_live_mode: Scalars['Boolean']['output'];
  form_name?: Maybe<Scalars['String']['output']>;
  form_slug?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  form_versions: Array<Credit_Application_Form_Versions>;
  /** An array relationship connection */
  form_versions_connection: Credit_Application_Form_VersionsConnection;
  id: Scalars['ID']['output'];
  is_template: Scalars['Boolean']['output'];
  layout_columns: Scalars['Int']['output'];
  /** An object relationship */
  supplier: Businesses;
  supplier_uuid: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "credit_application_forms" */
export type Credit_Application_FormsForm_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Application_Form_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Form_Versions_Order_By>>;
  where?: InputMaybe<Credit_Application_Form_Versions_Bool_Exp>;
};


/** columns and relationships of "credit_application_forms" */
export type Credit_Application_FormsForm_Versions_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Application_Form_Versions_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Form_Versions_Order_By>>;
  where?: InputMaybe<Credit_Application_Form_Versions_Bool_Exp>;
};

/** A Relay connection object on "credit_application_forms" */
export type Credit_Application_FormsConnection = {
  __typename?: 'credit_application_formsConnection';
  edges: Array<Credit_Application_FormsEdge>;
  pageInfo: PageInfo;
};

export type Credit_Application_FormsEdge = {
  __typename?: 'credit_application_formsEdge';
  cursor: Scalars['String']['output'];
  node: Credit_Application_Forms;
};

/** order by aggregate values of table "credit_application_forms" */
export type Credit_Application_Forms_Aggregate_Order_By = {
  avg?: InputMaybe<Credit_Application_Forms_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Credit_Application_Forms_Max_Order_By>;
  min?: InputMaybe<Credit_Application_Forms_Min_Order_By>;
  stddev?: InputMaybe<Credit_Application_Forms_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Credit_Application_Forms_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Credit_Application_Forms_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Credit_Application_Forms_Sum_Order_By>;
  var_pop?: InputMaybe<Credit_Application_Forms_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Credit_Application_Forms_Var_Samp_Order_By>;
  variance?: InputMaybe<Credit_Application_Forms_Variance_Order_By>;
};

/** order by avg() on columns of table "credit_application_forms" */
export type Credit_Application_Forms_Avg_Order_By = {
  layout_columns?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "credit_application_forms". All fields are combined with a logical 'AND'. */
export type Credit_Application_Forms_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Application_Forms_Bool_Exp>>;
  _not?: InputMaybe<Credit_Application_Forms_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Application_Forms_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_check_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  credit_check_live_mode?: InputMaybe<Boolean_Comparison_Exp>;
  form_name?: InputMaybe<String_Comparison_Exp>;
  form_slug?: InputMaybe<String_Comparison_Exp>;
  form_versions?: InputMaybe<Credit_Application_Form_Versions_Bool_Exp>;
  is_template?: InputMaybe<Boolean_Comparison_Exp>;
  layout_columns?: InputMaybe<Int_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "credit_application_forms" */
export type Credit_Application_Forms_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  form_name?: InputMaybe<Order_By>;
  form_slug?: InputMaybe<Order_By>;
  layout_columns?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "credit_application_forms" */
export type Credit_Application_Forms_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  form_name?: InputMaybe<Order_By>;
  form_slug?: InputMaybe<Order_By>;
  layout_columns?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "credit_application_forms". */
export type Credit_Application_Forms_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credit_check_enabled?: InputMaybe<Order_By>;
  credit_check_live_mode?: InputMaybe<Order_By>;
  form_name?: InputMaybe<Order_By>;
  form_slug?: InputMaybe<Order_By>;
  form_versions_aggregate?: InputMaybe<Credit_Application_Form_Versions_Aggregate_Order_By>;
  is_template?: InputMaybe<Order_By>;
  layout_columns?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "credit_application_forms" */
export enum Credit_Application_Forms_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditCheckEnabled = 'credit_check_enabled',
  /** column name */
  CreditCheckLiveMode = 'credit_check_live_mode',
  /** column name */
  FormName = 'form_name',
  /** column name */
  FormSlug = 'form_slug',
  /** column name */
  IsTemplate = 'is_template',
  /** column name */
  LayoutColumns = 'layout_columns',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** order by stddev() on columns of table "credit_application_forms" */
export type Credit_Application_Forms_Stddev_Order_By = {
  layout_columns?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "credit_application_forms" */
export type Credit_Application_Forms_Stddev_Pop_Order_By = {
  layout_columns?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "credit_application_forms" */
export type Credit_Application_Forms_Stddev_Samp_Order_By = {
  layout_columns?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "credit_application_forms" */
export type Credit_Application_Forms_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Application_Forms_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Application_Forms_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  credit_check_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  credit_check_live_mode?: InputMaybe<Scalars['Boolean']['input']>;
  form_name?: InputMaybe<Scalars['String']['input']>;
  form_slug?: InputMaybe<Scalars['String']['input']>;
  is_template?: InputMaybe<Scalars['Boolean']['input']>;
  layout_columns?: InputMaybe<Scalars['Int']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "credit_application_forms" */
export type Credit_Application_Forms_Sum_Order_By = {
  layout_columns?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "credit_application_forms" */
export type Credit_Application_Forms_Var_Pop_Order_By = {
  layout_columns?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "credit_application_forms" */
export type Credit_Application_Forms_Var_Samp_Order_By = {
  layout_columns?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "credit_application_forms" */
export type Credit_Application_Forms_Variance_Order_By = {
  layout_columns?: InputMaybe<Order_By>;
};

/** columns and relationships of "credit_applications" */
export type Credit_Applications = Node & {
  __typename?: 'credit_applications';
  created_at: Scalars['timestamptz']['output'];
  credit_check_mode: Scalars['String']['output'];
  credit_check_token_expires_at?: Maybe<Scalars['timestamptz']['output']>;
  credit_check_token_requested_at?: Maybe<Scalars['timestamptz']['output']>;
  credit_check_token_used_at?: Maybe<Scalars['timestamptz']['output']>;
  credit_report?: Maybe<Scalars['jsonb']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  form_data: Scalars['jsonb']['output'];
  /** An object relationship */
  form_version_submitted?: Maybe<Credit_Application_Form_Versions>;
  form_version_submitted_uuid?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['ID']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  ssn_last_four_digits?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  supplier: Businesses;
  supplier_uuid: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "credit_applications" */
export type Credit_ApplicationsCredit_ReportArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "credit_applications" */
export type Credit_ApplicationsForm_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "credit_applications" */
export type Credit_ApplicationsConnection = {
  __typename?: 'credit_applicationsConnection';
  edges: Array<Credit_ApplicationsEdge>;
  pageInfo: PageInfo;
};

export type Credit_ApplicationsEdge = {
  __typename?: 'credit_applicationsEdge';
  cursor: Scalars['String']['output'];
  node: Credit_Applications;
};

/** order by aggregate values of table "credit_applications" */
export type Credit_Applications_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Credit_Applications_Max_Order_By>;
  min?: InputMaybe<Credit_Applications_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "credit_applications". All fields are combined with a logical 'AND'. */
export type Credit_Applications_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Applications_Bool_Exp>>;
  _not?: InputMaybe<Credit_Applications_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Applications_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_check_mode?: InputMaybe<String_Comparison_Exp>;
  credit_check_token_expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_check_token_requested_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_check_token_used_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_report?: InputMaybe<Jsonb_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  form_data?: InputMaybe<Jsonb_Comparison_Exp>;
  form_version_submitted?: InputMaybe<Credit_Application_Form_Versions_Bool_Exp>;
  form_version_submitted_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  ssn_last_four_digits?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "credit_applications" */
export type Credit_Applications_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credit_check_mode?: InputMaybe<Order_By>;
  credit_check_token_expires_at?: InputMaybe<Order_By>;
  credit_check_token_requested_at?: InputMaybe<Order_By>;
  credit_check_token_used_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  form_version_submitted_uuid?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  ssn_last_four_digits?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "credit_applications" */
export type Credit_Applications_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credit_check_mode?: InputMaybe<Order_By>;
  credit_check_token_expires_at?: InputMaybe<Order_By>;
  credit_check_token_requested_at?: InputMaybe<Order_By>;
  credit_check_token_used_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  form_version_submitted_uuid?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  ssn_last_four_digits?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "credit_applications". */
export type Credit_Applications_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credit_check_mode?: InputMaybe<Order_By>;
  credit_check_token_expires_at?: InputMaybe<Order_By>;
  credit_check_token_requested_at?: InputMaybe<Order_By>;
  credit_check_token_used_at?: InputMaybe<Order_By>;
  credit_report?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  form_data?: InputMaybe<Order_By>;
  form_version_submitted?: InputMaybe<Credit_Application_Form_Versions_Order_By>;
  form_version_submitted_uuid?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  ssn_last_four_digits?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "credit_applications" */
export enum Credit_Applications_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditCheckMode = 'credit_check_mode',
  /** column name */
  CreditCheckTokenExpiresAt = 'credit_check_token_expires_at',
  /** column name */
  CreditCheckTokenRequestedAt = 'credit_check_token_requested_at',
  /** column name */
  CreditCheckTokenUsedAt = 'credit_check_token_used_at',
  /** column name */
  CreditReport = 'credit_report',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FormData = 'form_data',
  /** column name */
  FormVersionSubmittedUuid = 'form_version_submitted_uuid',
  /** column name */
  LastName = 'last_name',
  /** column name */
  SsnLastFourDigits = 'ssn_last_four_digits',
  /** column name */
  Status = 'status',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "credit_applications" */
export type Credit_Applications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Applications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Applications_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  credit_check_mode?: InputMaybe<Scalars['String']['input']>;
  credit_check_token_expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  credit_check_token_requested_at?: InputMaybe<Scalars['timestamptz']['input']>;
  credit_check_token_used_at?: InputMaybe<Scalars['timestamptz']['input']>;
  credit_report?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  form_data?: InputMaybe<Scalars['jsonb']['input']>;
  form_version_submitted_uuid?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  ssn_last_four_digits?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "credit_form_version_form_section_rel" */
export type Credit_Form_Version_Form_Section_Rel = Node & {
  __typename?: 'credit_form_version_form_section_rel';
  /** An object relationship */
  form_section: Credit_Application_Form_Sections;
  form_section_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  form_version: Credit_Application_Form_Versions;
  form_version_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "credit_form_version_form_section_rel" */
export type Credit_Form_Version_Form_Section_RelConnection = {
  __typename?: 'credit_form_version_form_section_relConnection';
  edges: Array<Credit_Form_Version_Form_Section_RelEdge>;
  pageInfo: PageInfo;
};

export type Credit_Form_Version_Form_Section_RelEdge = {
  __typename?: 'credit_form_version_form_section_relEdge';
  cursor: Scalars['String']['output'];
  node: Credit_Form_Version_Form_Section_Rel;
};

/** order by aggregate values of table "credit_form_version_form_section_rel" */
export type Credit_Form_Version_Form_Section_Rel_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Credit_Form_Version_Form_Section_Rel_Max_Order_By>;
  min?: InputMaybe<Credit_Form_Version_Form_Section_Rel_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "credit_form_version_form_section_rel". All fields are combined with a logical 'AND'. */
export type Credit_Form_Version_Form_Section_Rel_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Form_Version_Form_Section_Rel_Bool_Exp>>;
  _not?: InputMaybe<Credit_Form_Version_Form_Section_Rel_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Form_Version_Form_Section_Rel_Bool_Exp>>;
  form_section?: InputMaybe<Credit_Application_Form_Sections_Bool_Exp>;
  form_section_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  form_version?: InputMaybe<Credit_Application_Form_Versions_Bool_Exp>;
  form_version_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "credit_form_version_form_section_rel" */
export type Credit_Form_Version_Form_Section_Rel_Max_Order_By = {
  form_section_uuid?: InputMaybe<Order_By>;
  form_version_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "credit_form_version_form_section_rel" */
export type Credit_Form_Version_Form_Section_Rel_Min_Order_By = {
  form_section_uuid?: InputMaybe<Order_By>;
  form_version_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "credit_form_version_form_section_rel". */
export type Credit_Form_Version_Form_Section_Rel_Order_By = {
  form_section?: InputMaybe<Credit_Application_Form_Sections_Order_By>;
  form_section_uuid?: InputMaybe<Order_By>;
  form_version?: InputMaybe<Credit_Application_Form_Versions_Order_By>;
  form_version_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "credit_form_version_form_section_rel" */
export enum Credit_Form_Version_Form_Section_Rel_Select_Column {
  /** column name */
  FormSectionUuid = 'form_section_uuid',
  /** column name */
  FormVersionUuid = 'form_version_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "credit_form_version_form_section_rel" */
export type Credit_Form_Version_Form_Section_Rel_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Form_Version_Form_Section_Rel_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Form_Version_Form_Section_Rel_Stream_Cursor_Value_Input = {
  form_section_uuid?: InputMaybe<Scalars['uuid']['input']>;
  form_version_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** Credit memo line items associated with credit memos. */
export type Credit_Memo_Line_Items = Node & {
  __typename?: 'credit_memo_line_items';
  /** Credit memo of the item being credited. */
  credit_memo_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  /** Code of the item being credited. */
  item_code?: Maybe<Scalars['String']['output']>;
  /** Name of the item being credited. */
  item_name?: Maybe<Scalars['String']['output']>;
  /** Order item of the item being credited. */
  order_item_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  orders_item?: Maybe<Orders_Items>;
  /** Pack unit of the item being credited. */
  pack_unit?: Maybe<Scalars['String']['output']>;
  /** Quantity of the item being credited. */
  quantity: Scalars['float8']['output'];
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  /** Unit price of the item being credited. */
  unit_price_in_micros: Scalars['bigint']['output'];
  uuid: Scalars['uuid']['output'];
  /** Variant pack of the item being credited. */
  variant_pack_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  variants_pack?: Maybe<Variants_Packs>;
};

/** A Relay connection object on "credit_memo_line_items" */
export type Credit_Memo_Line_ItemsConnection = {
  __typename?: 'credit_memo_line_itemsConnection';
  edges: Array<Credit_Memo_Line_ItemsEdge>;
  pageInfo: PageInfo;
};

export type Credit_Memo_Line_ItemsEdge = {
  __typename?: 'credit_memo_line_itemsEdge';
  cursor: Scalars['String']['output'];
  node: Credit_Memo_Line_Items;
};

/** order by aggregate values of table "credit_memo_line_items" */
export type Credit_Memo_Line_Items_Aggregate_Order_By = {
  avg?: InputMaybe<Credit_Memo_Line_Items_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Credit_Memo_Line_Items_Max_Order_By>;
  min?: InputMaybe<Credit_Memo_Line_Items_Min_Order_By>;
  stddev?: InputMaybe<Credit_Memo_Line_Items_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Credit_Memo_Line_Items_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Credit_Memo_Line_Items_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Credit_Memo_Line_Items_Sum_Order_By>;
  var_pop?: InputMaybe<Credit_Memo_Line_Items_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Credit_Memo_Line_Items_Var_Samp_Order_By>;
  variance?: InputMaybe<Credit_Memo_Line_Items_Variance_Order_By>;
};

/** order by avg() on columns of table "credit_memo_line_items" */
export type Credit_Memo_Line_Items_Avg_Order_By = {
  /** Quantity of the item being credited. */
  quantity?: InputMaybe<Order_By>;
  /** Unit price of the item being credited. */
  unit_price_in_micros?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "credit_memo_line_items". All fields are combined with a logical 'AND'. */
export type Credit_Memo_Line_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Memo_Line_Items_Bool_Exp>>;
  _not?: InputMaybe<Credit_Memo_Line_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Memo_Line_Items_Bool_Exp>>;
  credit_memo_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  item_code?: InputMaybe<String_Comparison_Exp>;
  item_name?: InputMaybe<String_Comparison_Exp>;
  order_item_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  orders_item?: InputMaybe<Orders_Items_Bool_Exp>;
  pack_unit?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Float8_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  unit_price_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variants_pack?: InputMaybe<Variants_Packs_Bool_Exp>;
};

/** order by max() on columns of table "credit_memo_line_items" */
export type Credit_Memo_Line_Items_Max_Order_By = {
  /** Credit memo of the item being credited. */
  credit_memo_uuid?: InputMaybe<Order_By>;
  /** Code of the item being credited. */
  item_code?: InputMaybe<Order_By>;
  /** Name of the item being credited. */
  item_name?: InputMaybe<Order_By>;
  /** Order item of the item being credited. */
  order_item_uuid?: InputMaybe<Order_By>;
  /** Pack unit of the item being credited. */
  pack_unit?: InputMaybe<Order_By>;
  /** Quantity of the item being credited. */
  quantity?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  /** Unit price of the item being credited. */
  unit_price_in_micros?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  /** Variant pack of the item being credited. */
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "credit_memo_line_items" */
export type Credit_Memo_Line_Items_Min_Order_By = {
  /** Credit memo of the item being credited. */
  credit_memo_uuid?: InputMaybe<Order_By>;
  /** Code of the item being credited. */
  item_code?: InputMaybe<Order_By>;
  /** Name of the item being credited. */
  item_name?: InputMaybe<Order_By>;
  /** Order item of the item being credited. */
  order_item_uuid?: InputMaybe<Order_By>;
  /** Pack unit of the item being credited. */
  pack_unit?: InputMaybe<Order_By>;
  /** Quantity of the item being credited. */
  quantity?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  /** Unit price of the item being credited. */
  unit_price_in_micros?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  /** Variant pack of the item being credited. */
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "credit_memo_line_items". */
export type Credit_Memo_Line_Items_Order_By = {
  credit_memo_uuid?: InputMaybe<Order_By>;
  item_code?: InputMaybe<Order_By>;
  item_name?: InputMaybe<Order_By>;
  order_item_uuid?: InputMaybe<Order_By>;
  orders_item?: InputMaybe<Orders_Items_Order_By>;
  pack_unit?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  unit_price_in_micros?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
  variants_pack?: InputMaybe<Variants_Packs_Order_By>;
};

/** select columns of table "credit_memo_line_items" */
export enum Credit_Memo_Line_Items_Select_Column {
  /** column name */
  CreditMemoUuid = 'credit_memo_uuid',
  /** column name */
  ItemCode = 'item_code',
  /** column name */
  ItemName = 'item_name',
  /** column name */
  OrderItemUuid = 'order_item_uuid',
  /** column name */
  PackUnit = 'pack_unit',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  UnitPriceInMicros = 'unit_price_in_micros',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VariantPackUuid = 'variant_pack_uuid'
}

/** order by stddev() on columns of table "credit_memo_line_items" */
export type Credit_Memo_Line_Items_Stddev_Order_By = {
  /** Quantity of the item being credited. */
  quantity?: InputMaybe<Order_By>;
  /** Unit price of the item being credited. */
  unit_price_in_micros?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "credit_memo_line_items" */
export type Credit_Memo_Line_Items_Stddev_Pop_Order_By = {
  /** Quantity of the item being credited. */
  quantity?: InputMaybe<Order_By>;
  /** Unit price of the item being credited. */
  unit_price_in_micros?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "credit_memo_line_items" */
export type Credit_Memo_Line_Items_Stddev_Samp_Order_By = {
  /** Quantity of the item being credited. */
  quantity?: InputMaybe<Order_By>;
  /** Unit price of the item being credited. */
  unit_price_in_micros?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "credit_memo_line_items" */
export type Credit_Memo_Line_Items_Sum_Order_By = {
  /** Quantity of the item being credited. */
  quantity?: InputMaybe<Order_By>;
  /** Unit price of the item being credited. */
  unit_price_in_micros?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "credit_memo_line_items" */
export type Credit_Memo_Line_Items_Var_Pop_Order_By = {
  /** Quantity of the item being credited. */
  quantity?: InputMaybe<Order_By>;
  /** Unit price of the item being credited. */
  unit_price_in_micros?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "credit_memo_line_items" */
export type Credit_Memo_Line_Items_Var_Samp_Order_By = {
  /** Quantity of the item being credited. */
  quantity?: InputMaybe<Order_By>;
  /** Unit price of the item being credited. */
  unit_price_in_micros?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "credit_memo_line_items" */
export type Credit_Memo_Line_Items_Variance_Order_By = {
  /** Quantity of the item being credited. */
  quantity?: InputMaybe<Order_By>;
  /** Unit price of the item being credited. */
  unit_price_in_micros?: InputMaybe<Order_By>;
};

/** columns and relationships of "credit_memo_status" */
export type Credit_Memo_Status = Node & {
  __typename?: 'credit_memo_status';
  balance_in_micros?: Maybe<Scalars['bigint']['output']>;
  credit_memo_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  use_pepper_balance: Scalars['Boolean']['output'];
  uuid: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "credit_memo_status". All fields are combined with a logical 'AND'. */
export type Credit_Memo_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Memo_Status_Bool_Exp>>;
  _not?: InputMaybe<Credit_Memo_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Memo_Status_Bool_Exp>>;
  balance_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  credit_memo_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  use_pepper_balance?: InputMaybe<Boolean_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "credit_memo_status". */
export type Credit_Memo_Status_Order_By = {
  balance_in_micros?: InputMaybe<Order_By>;
  credit_memo_uuid?: InputMaybe<Order_By>;
  use_pepper_balance?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "credit_memos" */
export type Credit_Memos = Node & {
  __typename?: 'credit_memos';
  balance_in_micros?: Maybe<Scalars['bigint']['output']>;
  credit_date: Scalars['timestamptz']['output'];
  /** An array relationship */
  credit_memo_line_items: Array<Credit_Memo_Line_Items>;
  /** An array relationship connection */
  credit_memo_line_items_connection: Credit_Memo_Line_ItemsConnection;
  /** An object relationship */
  credit_memo_status?: Maybe<Credit_Memo_Status>;
  credit_number?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  integration_id?: Maybe<Scalars['String']['output']>;
  pre_payment_balance_in_micros?: Maybe<Scalars['bigint']['output']>;
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "credit_memos" */
export type Credit_MemosCredit_Memo_Line_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Memo_Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Memo_Line_Items_Order_By>>;
  where?: InputMaybe<Credit_Memo_Line_Items_Bool_Exp>;
};


/** columns and relationships of "credit_memos" */
export type Credit_MemosCredit_Memo_Line_Items_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Memo_Line_Items_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Memo_Line_Items_Order_By>>;
  where?: InputMaybe<Credit_Memo_Line_Items_Bool_Exp>;
};

/** A Relay connection object on "credit_memos" */
export type Credit_MemosConnection = {
  __typename?: 'credit_memosConnection';
  edges: Array<Credit_MemosEdge>;
  pageInfo: PageInfo;
};

export type Credit_MemosEdge = {
  __typename?: 'credit_memosEdge';
  cursor: Scalars['String']['output'];
  node: Credit_Memos;
};

/** Boolean expression to filter rows from the table "credit_memos". All fields are combined with a logical 'AND'. */
export type Credit_Memos_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Memos_Bool_Exp>>;
  _not?: InputMaybe<Credit_Memos_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Memos_Bool_Exp>>;
  balance_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  credit_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_memo_line_items?: InputMaybe<Credit_Memo_Line_Items_Bool_Exp>;
  credit_memo_status?: InputMaybe<Credit_Memo_Status_Bool_Exp>;
  credit_number?: InputMaybe<String_Comparison_Exp>;
  integration_id?: InputMaybe<String_Comparison_Exp>;
  pre_payment_balance_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "credit_memos". */
export type Credit_Memos_Order_By = {
  balance_in_micros?: InputMaybe<Order_By>;
  credit_date?: InputMaybe<Order_By>;
  credit_memo_line_items_aggregate?: InputMaybe<Credit_Memo_Line_Items_Aggregate_Order_By>;
  credit_memo_status?: InputMaybe<Credit_Memo_Status_Order_By>;
  credit_number?: InputMaybe<Order_By>;
  integration_id?: InputMaybe<Order_By>;
  pre_payment_balance_in_micros?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "credit_memos" */
export enum Credit_Memos_Select_Column {
  /** column name */
  BalanceInMicros = 'balance_in_micros',
  /** column name */
  CreditDate = 'credit_date',
  /** column name */
  CreditNumber = 'credit_number',
  /** column name */
  IntegrationId = 'integration_id',
  /** column name */
  PrePaymentBalanceInMicros = 'pre_payment_balance_in_micros',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "credit_memos" */
export type Credit_Memos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Memos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Memos_Stream_Cursor_Value_Input = {
  balance_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  credit_date?: InputMaybe<Scalars['timestamptz']['input']>;
  credit_number?: InputMaybe<Scalars['String']['input']>;
  integration_id?: InputMaybe<Scalars['String']['input']>;
  pre_payment_balance_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "credit_request_batch_line_items" */
export type Credit_Request_Batch_Line_Items = Node & {
  __typename?: 'credit_request_batch_line_items';
  /** An object relationship */
  credit_request_reason: Credit_Request_Reasons;
  custom_properties?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  pack_price_in_micros: Scalars['bigint']['output'];
  photo_url_list?: Maybe<Scalars['_text']['output']>;
  quantity: Scalars['float8']['output'];
  uom_override?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['uuid']['output'];
  /** An object relationship */
  variant_pack: Variants_Packs;
};


/** columns and relationships of "credit_request_batch_line_items" */
export type Credit_Request_Batch_Line_ItemsCustom_PropertiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "credit_request_batch_line_items" */
export type Credit_Request_Batch_Line_ItemsConnection = {
  __typename?: 'credit_request_batch_line_itemsConnection';
  edges: Array<Credit_Request_Batch_Line_ItemsEdge>;
  pageInfo: PageInfo;
};

export type Credit_Request_Batch_Line_ItemsEdge = {
  __typename?: 'credit_request_batch_line_itemsEdge';
  cursor: Scalars['String']['output'];
  node: Credit_Request_Batch_Line_Items;
};

/** order by aggregate values of table "credit_request_batch_line_items" */
export type Credit_Request_Batch_Line_Items_Aggregate_Order_By = {
  avg?: InputMaybe<Credit_Request_Batch_Line_Items_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Credit_Request_Batch_Line_Items_Max_Order_By>;
  min?: InputMaybe<Credit_Request_Batch_Line_Items_Min_Order_By>;
  stddev?: InputMaybe<Credit_Request_Batch_Line_Items_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Credit_Request_Batch_Line_Items_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Credit_Request_Batch_Line_Items_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Credit_Request_Batch_Line_Items_Sum_Order_By>;
  var_pop?: InputMaybe<Credit_Request_Batch_Line_Items_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Credit_Request_Batch_Line_Items_Var_Samp_Order_By>;
  variance?: InputMaybe<Credit_Request_Batch_Line_Items_Variance_Order_By>;
};

/** order by avg() on columns of table "credit_request_batch_line_items" */
export type Credit_Request_Batch_Line_Items_Avg_Order_By = {
  pack_price_in_micros?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "credit_request_batch_line_items". All fields are combined with a logical 'AND'. */
export type Credit_Request_Batch_Line_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Request_Batch_Line_Items_Bool_Exp>>;
  _not?: InputMaybe<Credit_Request_Batch_Line_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Request_Batch_Line_Items_Bool_Exp>>;
  credit_request_reason?: InputMaybe<Credit_Request_Reasons_Bool_Exp>;
  custom_properties?: InputMaybe<Jsonb_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  pack_price_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  photo_url_list?: InputMaybe<_Text_Comparison_Exp>;
  quantity?: InputMaybe<Float8_Comparison_Exp>;
  uom_override?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack?: InputMaybe<Variants_Packs_Bool_Exp>;
};

/** order by max() on columns of table "credit_request_batch_line_items" */
export type Credit_Request_Batch_Line_Items_Max_Order_By = {
  notes?: InputMaybe<Order_By>;
  pack_price_in_micros?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  uom_override?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "credit_request_batch_line_items" */
export type Credit_Request_Batch_Line_Items_Min_Order_By = {
  notes?: InputMaybe<Order_By>;
  pack_price_in_micros?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  uom_override?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "credit_request_batch_line_items". */
export type Credit_Request_Batch_Line_Items_Order_By = {
  credit_request_reason?: InputMaybe<Credit_Request_Reasons_Order_By>;
  custom_properties?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  pack_price_in_micros?: InputMaybe<Order_By>;
  photo_url_list?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  uom_override?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack?: InputMaybe<Variants_Packs_Order_By>;
};

/** select columns of table "credit_request_batch_line_items" */
export enum Credit_Request_Batch_Line_Items_Select_Column {
  /** column name */
  CustomProperties = 'custom_properties',
  /** column name */
  Notes = 'notes',
  /** column name */
  PackPriceInMicros = 'pack_price_in_micros',
  /** column name */
  PhotoUrlList = 'photo_url_list',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  UomOverride = 'uom_override',
  /** column name */
  Uuid = 'uuid'
}

/** order by stddev() on columns of table "credit_request_batch_line_items" */
export type Credit_Request_Batch_Line_Items_Stddev_Order_By = {
  pack_price_in_micros?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "credit_request_batch_line_items" */
export type Credit_Request_Batch_Line_Items_Stddev_Pop_Order_By = {
  pack_price_in_micros?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "credit_request_batch_line_items" */
export type Credit_Request_Batch_Line_Items_Stddev_Samp_Order_By = {
  pack_price_in_micros?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "credit_request_batch_line_items" */
export type Credit_Request_Batch_Line_Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Request_Batch_Line_Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Request_Batch_Line_Items_Stream_Cursor_Value_Input = {
  custom_properties?: InputMaybe<Scalars['jsonb']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pack_price_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  photo_url_list?: InputMaybe<Scalars['_text']['input']>;
  quantity?: InputMaybe<Scalars['float8']['input']>;
  uom_override?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "credit_request_batch_line_items" */
export type Credit_Request_Batch_Line_Items_Sum_Order_By = {
  pack_price_in_micros?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "credit_request_batch_line_items" */
export type Credit_Request_Batch_Line_Items_Var_Pop_Order_By = {
  pack_price_in_micros?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "credit_request_batch_line_items" */
export type Credit_Request_Batch_Line_Items_Var_Samp_Order_By = {
  pack_price_in_micros?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "credit_request_batch_line_items" */
export type Credit_Request_Batch_Line_Items_Variance_Order_By = {
  pack_price_in_micros?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "credit_request_batches" */
export type Credit_Request_Batches = Node & {
  __typename?: 'credit_request_batches';
  chat_uuid: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by: Employees;
  created_by_uuid: Scalars['uuid']['output'];
  /** An array relationship */
  credit_request_batch_line_items: Array<Credit_Request_Batch_Line_Items>;
  /** An array relationship connection */
  credit_request_batch_line_items_connection: Credit_Request_Batch_Line_ItemsConnection;
  credit_request_session_uuid?: Maybe<Scalars['uuid']['output']>;
  customer_facing_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  order_invoice_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "credit_request_batches" */
export type Credit_Request_BatchesCredit_Request_Batch_Line_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Request_Batch_Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Batch_Line_Items_Order_By>>;
  where?: InputMaybe<Credit_Request_Batch_Line_Items_Bool_Exp>;
};


/** columns and relationships of "credit_request_batches" */
export type Credit_Request_BatchesCredit_Request_Batch_Line_Items_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Request_Batch_Line_Items_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Batch_Line_Items_Order_By>>;
  where?: InputMaybe<Credit_Request_Batch_Line_Items_Bool_Exp>;
};

/** A Relay connection object on "credit_request_batches" */
export type Credit_Request_BatchesConnection = {
  __typename?: 'credit_request_batchesConnection';
  edges: Array<Credit_Request_BatchesEdge>;
  pageInfo: PageInfo;
};

export type Credit_Request_BatchesEdge = {
  __typename?: 'credit_request_batchesEdge';
  cursor: Scalars['String']['output'];
  node: Credit_Request_Batches;
};

/** aggregated selection of "credit_request_batches" */
export type Credit_Request_Batches_Aggregate = {
  __typename?: 'credit_request_batches_aggregate';
  aggregate?: Maybe<Credit_Request_Batches_Aggregate_Fields>;
  nodes: Array<Credit_Request_Batches>;
};

/** aggregate fields of "credit_request_batches" */
export type Credit_Request_Batches_Aggregate_Fields = {
  __typename?: 'credit_request_batches_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Credit_Request_Batches_Max_Fields>;
  min?: Maybe<Credit_Request_Batches_Min_Fields>;
};


/** aggregate fields of "credit_request_batches" */
export type Credit_Request_Batches_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Credit_Request_Batches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "credit_request_batches" */
export type Credit_Request_Batches_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Credit_Request_Batches_Max_Order_By>;
  min?: InputMaybe<Credit_Request_Batches_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "credit_request_batches". All fields are combined with a logical 'AND'. */
export type Credit_Request_Batches_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Request_Batches_Bool_Exp>>;
  _not?: InputMaybe<Credit_Request_Batches_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Request_Batches_Bool_Exp>>;
  chat_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Employees_Bool_Exp>;
  created_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  credit_request_batch_line_items?: InputMaybe<Credit_Request_Batch_Line_Items_Bool_Exp>;
  credit_request_session_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  customer_facing_id?: InputMaybe<String_Comparison_Exp>;
  order_invoice_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Credit_Request_Batches_Max_Fields = {
  __typename?: 'credit_request_batches_max_fields';
  chat_uuid?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_uuid?: Maybe<Scalars['uuid']['output']>;
  credit_request_session_uuid?: Maybe<Scalars['uuid']['output']>;
  customer_facing_id?: Maybe<Scalars['String']['output']>;
  order_invoice_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "credit_request_batches" */
export type Credit_Request_Batches_Max_Order_By = {
  chat_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  credit_request_session_uuid?: InputMaybe<Order_By>;
  customer_facing_id?: InputMaybe<Order_By>;
  order_invoice_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "credit_request_batches_messages" */
export type Credit_Request_Batches_Messages = Node & {
  __typename?: 'credit_request_batches_messages';
  /** An object relationship */
  credit_request_batch: Credit_Request_Batches;
  credit_request_batch_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  /** An object relationship */
  message: Messages;
  message_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "credit_request_batches_messages" */
export type Credit_Request_Batches_MessagesConnection = {
  __typename?: 'credit_request_batches_messagesConnection';
  edges: Array<Credit_Request_Batches_MessagesEdge>;
  pageInfo: PageInfo;
};

export type Credit_Request_Batches_MessagesEdge = {
  __typename?: 'credit_request_batches_messagesEdge';
  cursor: Scalars['String']['output'];
  node: Credit_Request_Batches_Messages;
};

/** order by aggregate values of table "credit_request_batches_messages" */
export type Credit_Request_Batches_Messages_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Credit_Request_Batches_Messages_Max_Order_By>;
  min?: InputMaybe<Credit_Request_Batches_Messages_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "credit_request_batches_messages". All fields are combined with a logical 'AND'. */
export type Credit_Request_Batches_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Request_Batches_Messages_Bool_Exp>>;
  _not?: InputMaybe<Credit_Request_Batches_Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Request_Batches_Messages_Bool_Exp>>;
  credit_request_batch?: InputMaybe<Credit_Request_Batches_Bool_Exp>;
  credit_request_batch_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<Messages_Bool_Exp>;
  message_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "credit_request_batches_messages" */
export type Credit_Request_Batches_Messages_Max_Order_By = {
  credit_request_batch_uuid?: InputMaybe<Order_By>;
  message_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "credit_request_batches_messages" */
export type Credit_Request_Batches_Messages_Min_Order_By = {
  credit_request_batch_uuid?: InputMaybe<Order_By>;
  message_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "credit_request_batches_messages". */
export type Credit_Request_Batches_Messages_Order_By = {
  credit_request_batch?: InputMaybe<Credit_Request_Batches_Order_By>;
  credit_request_batch_uuid?: InputMaybe<Order_By>;
  message?: InputMaybe<Messages_Order_By>;
  message_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "credit_request_batches_messages" */
export enum Credit_Request_Batches_Messages_Select_Column {
  /** column name */
  CreditRequestBatchUuid = 'credit_request_batch_uuid',
  /** column name */
  MessageUuid = 'message_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** aggregate min on columns */
export type Credit_Request_Batches_Min_Fields = {
  __typename?: 'credit_request_batches_min_fields';
  chat_uuid?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_uuid?: Maybe<Scalars['uuid']['output']>;
  credit_request_session_uuid?: Maybe<Scalars['uuid']['output']>;
  customer_facing_id?: Maybe<Scalars['String']['output']>;
  order_invoice_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "credit_request_batches" */
export type Credit_Request_Batches_Min_Order_By = {
  chat_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  credit_request_session_uuid?: InputMaybe<Order_By>;
  customer_facing_id?: InputMaybe<Order_By>;
  order_invoice_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "credit_request_batches". */
export type Credit_Request_Batches_Order_By = {
  chat_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Employees_Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  credit_request_batch_line_items_aggregate?: InputMaybe<Credit_Request_Batch_Line_Items_Aggregate_Order_By>;
  credit_request_session_uuid?: InputMaybe<Order_By>;
  customer_facing_id?: InputMaybe<Order_By>;
  order_invoice_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "credit_request_batches" */
export enum Credit_Request_Batches_Select_Column {
  /** column name */
  ChatUuid = 'chat_uuid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUuid = 'created_by_uuid',
  /** column name */
  CreditRequestSessionUuid = 'credit_request_session_uuid',
  /** column name */
  CustomerFacingId = 'customer_facing_id',
  /** column name */
  OrderInvoiceUuid = 'order_invoice_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "credit_request_batches" */
export type Credit_Request_Batches_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Request_Batches_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Request_Batches_Stream_Cursor_Value_Input = {
  chat_uuid?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
  credit_request_session_uuid?: InputMaybe<Scalars['uuid']['input']>;
  customer_facing_id?: InputMaybe<Scalars['String']['input']>;
  order_invoice_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "credit_request_reasons" */
export type Credit_Request_Reasons = Node & {
  __typename?: 'credit_request_reasons';
  display_name: Scalars['jsonb']['output'];
  id: Scalars['ID']['output'];
  invoice_required: Scalars['Boolean']['output'];
  is_active: Scalars['Boolean']['output'];
  request_period_days?: Maybe<Scalars['smallint']['output']>;
  /** An object relationship */
  supplier: Businesses;
  supplier_uuid: Scalars['uuid']['output'];
  type: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "credit_request_reasons" */
export type Credit_Request_ReasonsDisplay_NameArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "credit_request_reasons" */
export type Credit_Request_ReasonsConnection = {
  __typename?: 'credit_request_reasonsConnection';
  edges: Array<Credit_Request_ReasonsEdge>;
  pageInfo: PageInfo;
};

export type Credit_Request_ReasonsEdge = {
  __typename?: 'credit_request_reasonsEdge';
  cursor: Scalars['String']['output'];
  node: Credit_Request_Reasons;
};

/** Boolean expression to filter rows from the table "credit_request_reasons". All fields are combined with a logical 'AND'. */
export type Credit_Request_Reasons_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Request_Reasons_Bool_Exp>>;
  _not?: InputMaybe<Credit_Request_Reasons_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Request_Reasons_Bool_Exp>>;
  display_name?: InputMaybe<Jsonb_Comparison_Exp>;
  invoice_required?: InputMaybe<Boolean_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  request_period_days?: InputMaybe<Smallint_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "credit_request_reasons". */
export type Credit_Request_Reasons_Order_By = {
  display_name?: InputMaybe<Order_By>;
  invoice_required?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  request_period_days?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "credit_request_reasons" */
export enum Credit_Request_Reasons_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  InvoiceRequired = 'invoice_required',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  RequestPeriodDays = 'request_period_days',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Type = 'type',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "credit_request_reasons" */
export type Credit_Request_Reasons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Request_Reasons_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Request_Reasons_Stream_Cursor_Value_Input = {
  display_name?: InputMaybe<Scalars['jsonb']['input']>;
  invoice_required?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  request_period_days?: InputMaybe<Scalars['smallint']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "crm_activities" */
export type Crm_Activities = Node & {
  __typename?: 'crm_activities';
  /** An object relationship */
  chat: Chats;
  chat_uuid: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  crm_activity_notes?: Maybe<Crm_Activity_Notes>;
  /** An array relationship */
  crm_activity_reminders: Array<Crm_Activity_Reminders>;
  /** An array relationship connection */
  crm_activity_reminders_connection: Crm_Activity_RemindersConnection;
  /** An object relationship */
  employee?: Maybe<Employees>;
  employee_uuid?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['ID']['output'];
  updated_at: Scalars['timestamptz']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "crm_activities" */
export type Crm_ActivitiesCrm_Activity_RemindersArgs = {
  distinct_on?: InputMaybe<Array<Crm_Activity_Reminders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Activity_Reminders_Order_By>>;
  where?: InputMaybe<Crm_Activity_Reminders_Bool_Exp>;
};


/** columns and relationships of "crm_activities" */
export type Crm_ActivitiesCrm_Activity_Reminders_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Crm_Activity_Reminders_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Activity_Reminders_Order_By>>;
  where?: InputMaybe<Crm_Activity_Reminders_Bool_Exp>;
};

/** A Relay connection object on "crm_activities" */
export type Crm_ActivitiesConnection = {
  __typename?: 'crm_activitiesConnection';
  edges: Array<Crm_ActivitiesEdge>;
  pageInfo: PageInfo;
};

export type Crm_ActivitiesEdge = {
  __typename?: 'crm_activitiesEdge';
  cursor: Scalars['String']['output'];
  node: Crm_Activities;
};

/** aggregated selection of "crm_activities" */
export type Crm_Activities_Aggregate = {
  __typename?: 'crm_activities_aggregate';
  aggregate?: Maybe<Crm_Activities_Aggregate_Fields>;
  nodes: Array<Crm_Activities>;
};

/** aggregate fields of "crm_activities" */
export type Crm_Activities_Aggregate_Fields = {
  __typename?: 'crm_activities_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Crm_Activities_Max_Fields>;
  min?: Maybe<Crm_Activities_Min_Fields>;
};


/** aggregate fields of "crm_activities" */
export type Crm_Activities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crm_Activities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "crm_activities". All fields are combined with a logical 'AND'. */
export type Crm_Activities_Bool_Exp = {
  _and?: InputMaybe<Array<Crm_Activities_Bool_Exp>>;
  _not?: InputMaybe<Crm_Activities_Bool_Exp>;
  _or?: InputMaybe<Array<Crm_Activities_Bool_Exp>>;
  chat?: InputMaybe<Chats_Bool_Exp>;
  chat_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crm_activity_notes?: InputMaybe<Crm_Activity_Notes_Bool_Exp>;
  crm_activity_reminders?: InputMaybe<Crm_Activity_Reminders_Bool_Exp>;
  employee?: InputMaybe<Employees_Bool_Exp>;
  employee_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Crm_Activities_Max_Fields = {
  __typename?: 'crm_activities_max_fields';
  chat_uuid?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  employee_uuid?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Crm_Activities_Min_Fields = {
  __typename?: 'crm_activities_min_fields';
  chat_uuid?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  employee_uuid?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "crm_activities". */
export type Crm_Activities_Order_By = {
  chat?: InputMaybe<Chats_Order_By>;
  chat_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crm_activity_notes?: InputMaybe<Crm_Activity_Notes_Order_By>;
  crm_activity_reminders_aggregate?: InputMaybe<Crm_Activity_Reminders_Aggregate_Order_By>;
  employee?: InputMaybe<Employees_Order_By>;
  employee_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "crm_activities" */
export enum Crm_Activities_Select_Column {
  /** column name */
  ChatUuid = 'chat_uuid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmployeeUuid = 'employee_uuid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "crm_activities" */
export type Crm_Activities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crm_Activities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crm_Activities_Stream_Cursor_Value_Input = {
  chat_uuid?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  employee_uuid?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "crm_activity_notes" */
export type Crm_Activity_Notes = Node & {
  __typename?: 'crm_activity_notes';
  content: Scalars['String']['output'];
  /** An object relationship */
  crm_activity_reminder: Crm_Activities;
  crm_activity_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "crm_activity_notes" */
export type Crm_Activity_NotesConnection = {
  __typename?: 'crm_activity_notesConnection';
  edges: Array<Crm_Activity_NotesEdge>;
  pageInfo: PageInfo;
};

export type Crm_Activity_NotesEdge = {
  __typename?: 'crm_activity_notesEdge';
  cursor: Scalars['String']['output'];
  node: Crm_Activity_Notes;
};

/** Boolean expression to filter rows from the table "crm_activity_notes". All fields are combined with a logical 'AND'. */
export type Crm_Activity_Notes_Bool_Exp = {
  _and?: InputMaybe<Array<Crm_Activity_Notes_Bool_Exp>>;
  _not?: InputMaybe<Crm_Activity_Notes_Bool_Exp>;
  _or?: InputMaybe<Array<Crm_Activity_Notes_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  crm_activity_reminder?: InputMaybe<Crm_Activities_Bool_Exp>;
  crm_activity_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "crm_activity_notes". */
export type Crm_Activity_Notes_Order_By = {
  content?: InputMaybe<Order_By>;
  crm_activity_reminder?: InputMaybe<Crm_Activities_Order_By>;
  crm_activity_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "crm_activity_notes" */
export enum Crm_Activity_Notes_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CrmActivityUuid = 'crm_activity_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "crm_activity_notes" */
export type Crm_Activity_Notes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crm_Activity_Notes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crm_Activity_Notes_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  crm_activity_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "crm_activity_reminders" */
export type Crm_Activity_Reminders = Node & {
  __typename?: 'crm_activity_reminders';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  crm_activity: Crm_Activities;
  crm_activity_uuid: Scalars['uuid']['output'];
  employee_uuid?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  notified_at?: Maybe<Scalars['timestamptz']['output']>;
  remind_at: Scalars['timestamptz']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "crm_activity_reminders" */
export type Crm_Activity_RemindersConnection = {
  __typename?: 'crm_activity_remindersConnection';
  edges: Array<Crm_Activity_RemindersEdge>;
  pageInfo: PageInfo;
};

export type Crm_Activity_RemindersEdge = {
  __typename?: 'crm_activity_remindersEdge';
  cursor: Scalars['String']['output'];
  node: Crm_Activity_Reminders;
};

/** order by aggregate values of table "crm_activity_reminders" */
export type Crm_Activity_Reminders_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Crm_Activity_Reminders_Max_Order_By>;
  min?: InputMaybe<Crm_Activity_Reminders_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "crm_activity_reminders". All fields are combined with a logical 'AND'. */
export type Crm_Activity_Reminders_Bool_Exp = {
  _and?: InputMaybe<Array<Crm_Activity_Reminders_Bool_Exp>>;
  _not?: InputMaybe<Crm_Activity_Reminders_Bool_Exp>;
  _or?: InputMaybe<Array<Crm_Activity_Reminders_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crm_activity?: InputMaybe<Crm_Activities_Bool_Exp>;
  crm_activity_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  employee_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  notified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  remind_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "crm_activity_reminders" */
export type Crm_Activity_Reminders_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  crm_activity_uuid?: InputMaybe<Order_By>;
  employee_uuid?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  notified_at?: InputMaybe<Order_By>;
  remind_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "crm_activity_reminders" */
export type Crm_Activity_Reminders_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  crm_activity_uuid?: InputMaybe<Order_By>;
  employee_uuid?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  notified_at?: InputMaybe<Order_By>;
  remind_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "crm_activity_reminders". */
export type Crm_Activity_Reminders_Order_By = {
  created_at?: InputMaybe<Order_By>;
  crm_activity?: InputMaybe<Crm_Activities_Order_By>;
  crm_activity_uuid?: InputMaybe<Order_By>;
  employee_uuid?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  notified_at?: InputMaybe<Order_By>;
  remind_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "crm_activity_reminders" */
export enum Crm_Activity_Reminders_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CrmActivityUuid = 'crm_activity_uuid',
  /** column name */
  EmployeeUuid = 'employee_uuid',
  /** column name */
  Message = 'message',
  /** column name */
  NotifiedAt = 'notified_at',
  /** column name */
  RemindAt = 'remind_at',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "employee_chats" */
export type Employee_Chats = {
  __typename?: 'employee_chats';
  app_payments_enabled?: Maybe<Scalars['Boolean']['output']>;
  business_organization_uuid?: Maybe<Scalars['uuid']['output']>;
  chat_dynamic_config?: Maybe<Scalars['jsonb']['output']>;
  chat_employee_uuid?: Maybe<Scalars['uuid']['output']>;
  chat_uuid?: Maybe<Scalars['uuid']['output']>;
  display_item_prices?: Maybe<Scalars['Boolean']['output']>;
  employee_uuid?: Maybe<Scalars['uuid']['output']>;
  external_sessions_enabled?: Maybe<Scalars['Boolean']['output']>;
  on_hold?: Maybe<Scalars['Boolean']['output']>;
  order_review_required?: Maybe<Scalars['Boolean']['output']>;
  restaurant_account_id?: Maybe<Scalars['String']['output']>;
  restaurant_address?: Maybe<Scalars['String']['output']>;
  restaurant_employee_role?: Maybe<Scalars['String']['output']>;
  restaurant_name?: Maybe<Scalars['String']['output']>;
  restaurant_timezone?: Maybe<Scalars['String']['output']>;
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  show_app_payments_tab?: Maybe<Scalars['Boolean']['output']>;
  smart_order_enabled?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "employee_chats" */
export type Employee_ChatsChat_Dynamic_ConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "employee_chats". All fields are combined with a logical 'AND'. */
export type Employee_Chats_Bool_Exp = {
  _and?: InputMaybe<Array<Employee_Chats_Bool_Exp>>;
  _not?: InputMaybe<Employee_Chats_Bool_Exp>;
  _or?: InputMaybe<Array<Employee_Chats_Bool_Exp>>;
  app_payments_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  business_organization_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  chat_dynamic_config?: InputMaybe<Jsonb_Comparison_Exp>;
  chat_employee_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  chat_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  display_item_prices?: InputMaybe<Boolean_Comparison_Exp>;
  employee_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  external_sessions_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  on_hold?: InputMaybe<Boolean_Comparison_Exp>;
  order_review_required?: InputMaybe<Boolean_Comparison_Exp>;
  restaurant_account_id?: InputMaybe<String_Comparison_Exp>;
  restaurant_address?: InputMaybe<String_Comparison_Exp>;
  restaurant_employee_role?: InputMaybe<String_Comparison_Exp>;
  restaurant_name?: InputMaybe<String_Comparison_Exp>;
  restaurant_timezone?: InputMaybe<String_Comparison_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  show_app_payments_tab?: InputMaybe<Boolean_Comparison_Exp>;
  smart_order_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "employee_chats". */
export type Employee_Chats_Order_By = {
  app_payments_enabled?: InputMaybe<Order_By>;
  business_organization_uuid?: InputMaybe<Order_By>;
  chat_dynamic_config?: InputMaybe<Order_By>;
  chat_employee_uuid?: InputMaybe<Order_By>;
  chat_uuid?: InputMaybe<Order_By>;
  display_item_prices?: InputMaybe<Order_By>;
  employee_uuid?: InputMaybe<Order_By>;
  external_sessions_enabled?: InputMaybe<Order_By>;
  on_hold?: InputMaybe<Order_By>;
  order_review_required?: InputMaybe<Order_By>;
  restaurant_account_id?: InputMaybe<Order_By>;
  restaurant_address?: InputMaybe<Order_By>;
  restaurant_employee_role?: InputMaybe<Order_By>;
  restaurant_name?: InputMaybe<Order_By>;
  restaurant_timezone?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  show_app_payments_tab?: InputMaybe<Order_By>;
  smart_order_enabled?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
};

/** select columns of table "employee_chats" */
export enum Employee_Chats_Select_Column {
  /** column name */
  AppPaymentsEnabled = 'app_payments_enabled',
  /** column name */
  BusinessOrganizationUuid = 'business_organization_uuid',
  /** column name */
  ChatDynamicConfig = 'chat_dynamic_config',
  /** column name */
  ChatEmployeeUuid = 'chat_employee_uuid',
  /** column name */
  ChatUuid = 'chat_uuid',
  /** column name */
  DisplayItemPrices = 'display_item_prices',
  /** column name */
  EmployeeUuid = 'employee_uuid',
  /** column name */
  ExternalSessionsEnabled = 'external_sessions_enabled',
  /** column name */
  OnHold = 'on_hold',
  /** column name */
  OrderReviewRequired = 'order_review_required',
  /** column name */
  RestaurantAccountId = 'restaurant_account_id',
  /** column name */
  RestaurantAddress = 'restaurant_address',
  /** column name */
  RestaurantEmployeeRole = 'restaurant_employee_role',
  /** column name */
  RestaurantName = 'restaurant_name',
  /** column name */
  RestaurantTimezone = 'restaurant_timezone',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  ShowAppPaymentsTab = 'show_app_payments_tab',
  /** column name */
  SmartOrderEnabled = 'smart_order_enabled',
  /** column name */
  Status = 'status',
  /** column name */
  SupplierUuid = 'supplier_uuid'
}

/** Streaming cursor of the table "employee_chats" */
export type Employee_Chats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Employee_Chats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Employee_Chats_Stream_Cursor_Value_Input = {
  app_payments_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  business_organization_uuid?: InputMaybe<Scalars['uuid']['input']>;
  chat_dynamic_config?: InputMaybe<Scalars['jsonb']['input']>;
  chat_employee_uuid?: InputMaybe<Scalars['uuid']['input']>;
  chat_uuid?: InputMaybe<Scalars['uuid']['input']>;
  display_item_prices?: InputMaybe<Scalars['Boolean']['input']>;
  employee_uuid?: InputMaybe<Scalars['uuid']['input']>;
  external_sessions_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  on_hold?: InputMaybe<Scalars['Boolean']['input']>;
  order_review_required?: InputMaybe<Scalars['Boolean']['input']>;
  restaurant_account_id?: InputMaybe<Scalars['String']['input']>;
  restaurant_address?: InputMaybe<Scalars['String']['input']>;
  restaurant_employee_role?: InputMaybe<Scalars['String']['input']>;
  restaurant_name?: InputMaybe<Scalars['String']['input']>;
  restaurant_timezone?: InputMaybe<Scalars['String']['input']>;
  restaurant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  show_app_payments_tab?: InputMaybe<Scalars['Boolean']['input']>;
  smart_order_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "employee_contact_info" */
export type Employee_Contact_Info = Node & {
  __typename?: 'employee_contact_info';
  email?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  employee: Array<Employees>;
  /** An array relationship connection */
  employee_connection: EmployeesConnection;
  id: Scalars['ID']['output'];
  login_email?: Maybe<Scalars['String']['output']>;
  phone_number: Scalars['String']['output'];
  smart_order_notification_settings: Scalars['jsonb']['output'];
  uuid: Scalars['uuid']['output'];
  wants_chat_email: Scalars['Boolean']['output'];
  wants_credit_request_email: Scalars['Boolean']['output'];
  wants_order_approval_email: Scalars['Boolean']['output'];
  wants_order_email: Scalars['Boolean']['output'];
  wants_order_tracking_notification: Scalars['Boolean']['output'];
  wants_payment_email: Scalars['Boolean']['output'];
};


/** columns and relationships of "employee_contact_info" */
export type Employee_Contact_InfoEmployeeArgs = {
  distinct_on?: InputMaybe<Array<Employees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Employees_Order_By>>;
  where?: InputMaybe<Employees_Bool_Exp>;
};


/** columns and relationships of "employee_contact_info" */
export type Employee_Contact_InfoEmployee_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Employees_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Employees_Order_By>>;
  where?: InputMaybe<Employees_Bool_Exp>;
};


/** columns and relationships of "employee_contact_info" */
export type Employee_Contact_InfoSmart_Order_Notification_SettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Employee_Contact_Info_Append_Input = {
  smart_order_notification_settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "employee_contact_info". All fields are combined with a logical 'AND'. */
export type Employee_Contact_Info_Bool_Exp = {
  _and?: InputMaybe<Array<Employee_Contact_Info_Bool_Exp>>;
  _not?: InputMaybe<Employee_Contact_Info_Bool_Exp>;
  _or?: InputMaybe<Array<Employee_Contact_Info_Bool_Exp>>;
  email?: InputMaybe<String_Comparison_Exp>;
  employee?: InputMaybe<Employees_Bool_Exp>;
  login_email?: InputMaybe<String_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  smart_order_notification_settings?: InputMaybe<Jsonb_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  wants_chat_email?: InputMaybe<Boolean_Comparison_Exp>;
  wants_credit_request_email?: InputMaybe<Boolean_Comparison_Exp>;
  wants_order_approval_email?: InputMaybe<Boolean_Comparison_Exp>;
  wants_order_email?: InputMaybe<Boolean_Comparison_Exp>;
  wants_order_tracking_notification?: InputMaybe<Boolean_Comparison_Exp>;
  wants_payment_email?: InputMaybe<Boolean_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Employee_Contact_Info_Delete_At_Path_Input = {
  smart_order_notification_settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Employee_Contact_Info_Delete_Elem_Input = {
  smart_order_notification_settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Employee_Contact_Info_Delete_Key_Input = {
  smart_order_notification_settings?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "employee_contact_info" */
export type Employee_Contact_Info_Mutation_Response = {
  __typename?: 'employee_contact_info_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Employee_Contact_Info>;
};

/** Ordering options when selecting data from "employee_contact_info". */
export type Employee_Contact_Info_Order_By = {
  email?: InputMaybe<Order_By>;
  employee_aggregate?: InputMaybe<Employees_Aggregate_Order_By>;
  login_email?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  smart_order_notification_settings?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  wants_chat_email?: InputMaybe<Order_By>;
  wants_credit_request_email?: InputMaybe<Order_By>;
  wants_order_approval_email?: InputMaybe<Order_By>;
  wants_order_email?: InputMaybe<Order_By>;
  wants_order_tracking_notification?: InputMaybe<Order_By>;
  wants_payment_email?: InputMaybe<Order_By>;
};

/** primary key columns input for table: employee_contact_info */
export type Employee_Contact_Info_Pk_Columns_Input = {
  uuid: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Employee_Contact_Info_Prepend_Input = {
  smart_order_notification_settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for updating data in table "employee_contact_info" */
export type Employee_Contact_Info_Set_Input = {
  smart_order_notification_settings?: InputMaybe<Scalars['jsonb']['input']>;
  wants_chat_email?: InputMaybe<Scalars['Boolean']['input']>;
  wants_credit_request_email?: InputMaybe<Scalars['Boolean']['input']>;
  wants_order_approval_email?: InputMaybe<Scalars['Boolean']['input']>;
  wants_order_email?: InputMaybe<Scalars['Boolean']['input']>;
  wants_order_tracking_notification?: InputMaybe<Scalars['Boolean']['input']>;
  wants_payment_email?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Employee_Contact_Info_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Employee_Contact_Info_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Employee_Contact_Info_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Employee_Contact_Info_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Employee_Contact_Info_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Employee_Contact_Info_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Employee_Contact_Info_Set_Input>;
  where: Employee_Contact_Info_Bool_Exp;
};

/** columns and relationships of "employee_smart_orders" */
export type Employee_Smart_Orders = {
  __typename?: 'employee_smart_orders';
  assigned_employee_name?: Maybe<Scalars['String']['output']>;
  assigned_employee_uuid?: Maybe<Scalars['uuid']['output']>;
  business_organization_uuid?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  employee_uuid?: Maybe<Scalars['uuid']['output']>;
  merge_uuid?: Maybe<Scalars['uuid']['output']>;
  processing_status?: Maybe<Scalars['String']['output']>;
  restaurant_address_uuid?: Maybe<Scalars['uuid']['output']>;
  restaurant_name?: Maybe<Scalars['String']['output']>;
  restaurant_timezone?: Maybe<Scalars['String']['output']>;
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  smart_order_uuid?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier_employee_override_name?: Maybe<Scalars['String']['output']>;
  supplier_employee_override_uuid?: Maybe<Scalars['uuid']['output']>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  thread_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Boolean expression to filter rows from the table "employee_smart_orders". All fields are combined with a logical 'AND'. */
export type Employee_Smart_Orders_Bool_Exp = {
  _and?: InputMaybe<Array<Employee_Smart_Orders_Bool_Exp>>;
  _not?: InputMaybe<Employee_Smart_Orders_Bool_Exp>;
  _or?: InputMaybe<Array<Employee_Smart_Orders_Bool_Exp>>;
  assigned_employee_name?: InputMaybe<String_Comparison_Exp>;
  assigned_employee_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  business_organization_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  employee_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  merge_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  processing_status?: InputMaybe<String_Comparison_Exp>;
  restaurant_address_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  restaurant_name?: InputMaybe<String_Comparison_Exp>;
  restaurant_timezone?: InputMaybe<String_Comparison_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  smart_order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  supplier_employee_override_name?: InputMaybe<String_Comparison_Exp>;
  supplier_employee_override_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  thread_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "employee_smart_orders". */
export type Employee_Smart_Orders_Order_By = {
  assigned_employee_name?: InputMaybe<Order_By>;
  assigned_employee_uuid?: InputMaybe<Order_By>;
  business_organization_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  employee_uuid?: InputMaybe<Order_By>;
  merge_uuid?: InputMaybe<Order_By>;
  processing_status?: InputMaybe<Order_By>;
  restaurant_address_uuid?: InputMaybe<Order_By>;
  restaurant_name?: InputMaybe<Order_By>;
  restaurant_timezone?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  smart_order_uuid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_employee_override_name?: InputMaybe<Order_By>;
  supplier_employee_override_uuid?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "employee_smart_orders" */
export enum Employee_Smart_Orders_Select_Column {
  /** column name */
  AssignedEmployeeName = 'assigned_employee_name',
  /** column name */
  AssignedEmployeeUuid = 'assigned_employee_uuid',
  /** column name */
  BusinessOrganizationUuid = 'business_organization_uuid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmployeeUuid = 'employee_uuid',
  /** column name */
  MergeUuid = 'merge_uuid',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  RestaurantAddressUuid = 'restaurant_address_uuid',
  /** column name */
  RestaurantName = 'restaurant_name',
  /** column name */
  RestaurantTimezone = 'restaurant_timezone',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  SmartOrderUuid = 'smart_order_uuid',
  /** column name */
  Status = 'status',
  /** column name */
  SupplierEmployeeOverrideName = 'supplier_employee_override_name',
  /** column name */
  SupplierEmployeeOverrideUuid = 'supplier_employee_override_uuid',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "employee_smart_orders" */
export type Employee_Smart_Orders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Employee_Smart_Orders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Employee_Smart_Orders_Stream_Cursor_Value_Input = {
  assigned_employee_name?: InputMaybe<Scalars['String']['input']>;
  assigned_employee_uuid?: InputMaybe<Scalars['uuid']['input']>;
  business_organization_uuid?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  employee_uuid?: InputMaybe<Scalars['uuid']['input']>;
  merge_uuid?: InputMaybe<Scalars['uuid']['input']>;
  processing_status?: InputMaybe<Scalars['String']['input']>;
  restaurant_address_uuid?: InputMaybe<Scalars['uuid']['input']>;
  restaurant_name?: InputMaybe<Scalars['String']['input']>;
  restaurant_timezone?: InputMaybe<Scalars['String']['input']>;
  restaurant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  smart_order_uuid?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier_employee_override_name?: InputMaybe<Scalars['String']['input']>;
  supplier_employee_override_uuid?: InputMaybe<Scalars['uuid']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  thread_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "employees" */
export type Employees = Node & {
  __typename?: 'employees';
  /** An array relationship */
  businesses_employees: Array<Businesses_Employees>;
  /** An array relationship connection */
  businesses_employees_connection: Businesses_EmployeesConnection;
  /** An array relationship */
  chats_employees: Array<Chats_Employees>;
  /** An array relationship connection */
  chats_employees_connection: Chats_EmployeesConnection;
  /** An object relationship */
  contact_info: Employee_Contact_Info;
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  /** An array relationship */
  messages: Array<Messages>;
  /** An array relationship connection */
  messages_connection: MessagesConnection;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  /** An array relationship */
  supplier_employee_overrides: Array<Supplier_Employee_Overrides>;
  /** An array relationship connection */
  supplier_employee_overrides_connection: Supplier_Employee_OverridesConnection;
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "employees" */
export type EmployeesBusinesses_EmployeesArgs = {
  distinct_on?: InputMaybe<Array<Businesses_Employees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Businesses_Employees_Order_By>>;
  where?: InputMaybe<Businesses_Employees_Bool_Exp>;
};


/** columns and relationships of "employees" */
export type EmployeesBusinesses_Employees_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Businesses_Employees_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Businesses_Employees_Order_By>>;
  where?: InputMaybe<Businesses_Employees_Bool_Exp>;
};


/** columns and relationships of "employees" */
export type EmployeesChats_EmployeesArgs = {
  distinct_on?: InputMaybe<Array<Chats_Employees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Employees_Order_By>>;
  where?: InputMaybe<Chats_Employees_Bool_Exp>;
};


/** columns and relationships of "employees" */
export type EmployeesChats_Employees_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Chats_Employees_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Employees_Order_By>>;
  where?: InputMaybe<Chats_Employees_Bool_Exp>;
};


/** columns and relationships of "employees" */
export type EmployeesMessagesArgs = {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


/** columns and relationships of "employees" */
export type EmployeesMessages_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


/** columns and relationships of "employees" */
export type EmployeesSupplier_Employee_OverridesArgs = {
  distinct_on?: InputMaybe<Array<Supplier_Employee_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supplier_Employee_Overrides_Order_By>>;
  where?: InputMaybe<Supplier_Employee_Overrides_Bool_Exp>;
};


/** columns and relationships of "employees" */
export type EmployeesSupplier_Employee_Overrides_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Supplier_Employee_Overrides_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supplier_Employee_Overrides_Order_By>>;
  where?: InputMaybe<Supplier_Employee_Overrides_Bool_Exp>;
};

/** A Relay connection object on "employees" */
export type EmployeesConnection = {
  __typename?: 'employeesConnection';
  edges: Array<EmployeesEdge>;
  pageInfo: PageInfo;
};

export type EmployeesEdge = {
  __typename?: 'employeesEdge';
  cursor: Scalars['String']['output'];
  node: Employees;
};

/** order by aggregate values of table "employees" */
export type Employees_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Employees_Max_Order_By>;
  min?: InputMaybe<Employees_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "employees". All fields are combined with a logical 'AND'. */
export type Employees_Bool_Exp = {
  _and?: InputMaybe<Array<Employees_Bool_Exp>>;
  _not?: InputMaybe<Employees_Bool_Exp>;
  _or?: InputMaybe<Array<Employees_Bool_Exp>>;
  businesses_employees?: InputMaybe<Businesses_Employees_Bool_Exp>;
  chats_employees?: InputMaybe<Chats_Employees_Bool_Exp>;
  contact_info?: InputMaybe<Employee_Contact_Info_Bool_Exp>;
  locale?: InputMaybe<String_Comparison_Exp>;
  messages?: InputMaybe<Messages_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  supplier_employee_overrides?: InputMaybe<Supplier_Employee_Overrides_Bool_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "employees" */
export type Employees_Max_Order_By = {
  locale?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "employees" */
export type Employees_Min_Order_By = {
  locale?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "employees" */
export type Employees_Mutation_Response = {
  __typename?: 'employees_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Employees>;
};

/** Ordering options when selecting data from "employees". */
export type Employees_Order_By = {
  businesses_employees_aggregate?: InputMaybe<Businesses_Employees_Aggregate_Order_By>;
  chats_employees_aggregate?: InputMaybe<Chats_Employees_Aggregate_Order_By>;
  contact_info?: InputMaybe<Employee_Contact_Info_Order_By>;
  locale?: InputMaybe<Order_By>;
  messages_aggregate?: InputMaybe<Messages_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_employee_overrides_aggregate?: InputMaybe<Supplier_Employee_Overrides_Aggregate_Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: employees */
export type Employees_Pk_Columns_Input = {
  uuid: Scalars['uuid']['input'];
};

/** select columns of table "employees" */
export enum Employees_Select_Column {
  /** column name */
  Locale = 'locale',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "employees" */
export type Employees_Set_Input = {
  locale?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "employees" */
export type Employees_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Employees_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Employees_Stream_Cursor_Value_Input = {
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

export type Employees_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Employees_Set_Input>;
  where: Employees_Bool_Exp;
};

/** columns and relationships of "external_content" */
export type External_Content = Node & {
  __typename?: 'external_content';
  config: Scalars['jsonb']['output'];
  display_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
  visibility_level: Scalars['String']['output'];
};


/** columns and relationships of "external_content" */
export type External_ContentConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "external_content_assignments" */
export type External_Content_Assignments = Node & {
  __typename?: 'external_content_assignments';
  business_uuid: Scalars['uuid']['output'];
  config?: Maybe<Scalars['jsonb']['output']>;
  deployment_target: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  external_content_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  restaurant_group_uuid?: Maybe<Scalars['uuid']['output']>;
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  sort_order?: Maybe<Scalars['float8']['output']>;
  uuid: Scalars['uuid']['output'];
  visibility_level?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "external_content_assignments" */
export type External_Content_AssignmentsConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "external_content_assignments_business_employees" */
export type External_Content_Assignments_Business_Employees = Node & {
  __typename?: 'external_content_assignments_business_employees';
  business_employee_uuid: Scalars['uuid']['output'];
  external_content_assignment_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  uuid: Scalars['uuid']['output'];
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "fulfillment_settings" */
export type Fulfillment_Settings = Node & {
  __typename?: 'fulfillment_settings';
  id: Scalars['ID']['output'];
  /** Akin to fulfillment type. */
  name: Scalars['String']['output'];
  /** Additional settings data, e.g. cutoff time, lead time, fees, and overrides for those on specific days. */
  settings: Scalars['jsonb']['output'];
  /** An object relationship */
  supplier: Businesses;
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "fulfillment_settings" */
export type Fulfillment_SettingsSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "fulfillment_settings". All fields are combined with a logical 'AND'. */
export type Fulfillment_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Fulfillment_Settings_Bool_Exp>>;
  _not?: InputMaybe<Fulfillment_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Fulfillment_Settings_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "fulfillment_settings". */
export type Fulfillment_Settings_Order_By = {
  name?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "ghost_agents" */
export type Ghost_Agents = Node & {
  __typename?: 'ghost_agents';
  id: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "ghost_agents" */
export type Ghost_AgentsConnection = {
  __typename?: 'ghost_agentsConnection';
  edges: Array<Ghost_AgentsEdge>;
  pageInfo: PageInfo;
};

export type Ghost_AgentsEdge = {
  __typename?: 'ghost_agentsEdge';
  cursor: Scalars['String']['output'];
  node: Ghost_Agents;
};

/** Boolean expression to filter rows from the table "ghost_agents". All fields are combined with a logical 'AND'. */
export type Ghost_Agents_Bool_Exp = {
  _and?: InputMaybe<Array<Ghost_Agents_Bool_Exp>>;
  _not?: InputMaybe<Ghost_Agents_Bool_Exp>;
  _or?: InputMaybe<Array<Ghost_Agents_Bool_Exp>>;
  model?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "ghost_agents". */
export type Ghost_Agents_Order_By = {
  model?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "ghost_agents" */
export enum Ghost_Agents_Select_Column {
  /** column name */
  Model = 'model',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "ghost_agents" */
export type Ghost_Agents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ghost_Agents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ghost_Agents_Stream_Cursor_Value_Input = {
  model?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "ghost_conversations" */
export type Ghost_Conversations = Node & {
  __typename?: 'ghost_conversations';
  id: Scalars['ID']['output'];
  restaurant_uuid: Scalars['uuid']['output'];
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "ghost_conversations" */
export type Ghost_ConversationsConnection = {
  __typename?: 'ghost_conversationsConnection';
  edges: Array<Ghost_ConversationsEdge>;
  pageInfo: PageInfo;
};

export type Ghost_ConversationsEdge = {
  __typename?: 'ghost_conversationsEdge';
  cursor: Scalars['String']['output'];
  node: Ghost_Conversations;
};

/** Boolean expression to filter rows from the table "ghost_conversations". All fields are combined with a logical 'AND'. */
export type Ghost_Conversations_Bool_Exp = {
  _and?: InputMaybe<Array<Ghost_Conversations_Bool_Exp>>;
  _not?: InputMaybe<Ghost_Conversations_Bool_Exp>;
  _or?: InputMaybe<Array<Ghost_Conversations_Bool_Exp>>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "ghost_conversations". */
export type Ghost_Conversations_Order_By = {
  restaurant_uuid?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "ghost_conversations" */
export enum Ghost_Conversations_Select_Column {
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "ghost_conversations" */
export type Ghost_Conversations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ghost_Conversations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ghost_Conversations_Stream_Cursor_Value_Input = {
  restaurant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "ghost_execution_logs" */
export type Ghost_Execution_Logs = Node & {
  __typename?: 'ghost_execution_logs';
  id: Scalars['ID']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "ghost_execution_logs" */
export type Ghost_Execution_LogsConnection = {
  __typename?: 'ghost_execution_logsConnection';
  edges: Array<Ghost_Execution_LogsEdge>;
  pageInfo: PageInfo;
};

export type Ghost_Execution_LogsEdge = {
  __typename?: 'ghost_execution_logsEdge';
  cursor: Scalars['String']['output'];
  node: Ghost_Execution_Logs;
};

/** Boolean expression to filter rows from the table "ghost_execution_logs". All fields are combined with a logical 'AND'. */
export type Ghost_Execution_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Ghost_Execution_Logs_Bool_Exp>>;
  _not?: InputMaybe<Ghost_Execution_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Ghost_Execution_Logs_Bool_Exp>>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "ghost_execution_logs". */
export type Ghost_Execution_Logs_Order_By = {
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "ghost_execution_logs" */
export enum Ghost_Execution_Logs_Select_Column {
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "ghost_execution_logs" */
export type Ghost_Execution_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ghost_Execution_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ghost_Execution_Logs_Stream_Cursor_Value_Input = {
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "ghost_messages" */
export type Ghost_Messages = Node & {
  __typename?: 'ghost_messages';
  content: Scalars['String']['output'];
  created_by_uuid: Scalars['uuid']['output'];
  ghost_conversation_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  sent_at: Scalars['timestamptz']['output'];
  type: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "ghost_messages" */
export type Ghost_MessagesConnection = {
  __typename?: 'ghost_messagesConnection';
  edges: Array<Ghost_MessagesEdge>;
  pageInfo: PageInfo;
};

export type Ghost_MessagesEdge = {
  __typename?: 'ghost_messagesEdge';
  cursor: Scalars['String']['output'];
  node: Ghost_Messages;
};

/** Boolean expression to filter rows from the table "ghost_messages". All fields are combined with a logical 'AND'. */
export type Ghost_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Ghost_Messages_Bool_Exp>>;
  _not?: InputMaybe<Ghost_Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Ghost_Messages_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  ghost_conversation_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "ghost_messages". */
export type Ghost_Messages_Order_By = {
  content?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  ghost_conversation_uuid?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "ghost_messages" */
export enum Ghost_Messages_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedByUuid = 'created_by_uuid',
  /** column name */
  GhostConversationUuid = 'ghost_conversation_uuid',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  Type = 'type',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "ghost_messages" */
export type Ghost_Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ghost_Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ghost_Messages_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  created_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
  ghost_conversation_uuid?: InputMaybe<Scalars['uuid']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "gtin_metadata" */
export type Gtin_Metadata = Node & {
  __typename?: 'gtin_metadata';
  gtin: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata: Scalars['jsonb']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "gtin_metadata" */
export type Gtin_MetadataMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "gtin_metadata" */
export type Gtin_MetadataConnection = {
  __typename?: 'gtin_metadataConnection';
  edges: Array<Gtin_MetadataEdge>;
  pageInfo: PageInfo;
};

export type Gtin_MetadataEdge = {
  __typename?: 'gtin_metadataEdge';
  cursor: Scalars['String']['output'];
  node: Gtin_Metadata;
};

/** order by aggregate values of table "gtin_metadata" */
export type Gtin_Metadata_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gtin_Metadata_Max_Order_By>;
  min?: InputMaybe<Gtin_Metadata_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "gtin_metadata". All fields are combined with a logical 'AND'. */
export type Gtin_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Gtin_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Gtin_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Gtin_Metadata_Bool_Exp>>;
  gtin?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "gtin_metadata" */
export type Gtin_Metadata_Max_Order_By = {
  gtin?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "gtin_metadata" */
export type Gtin_Metadata_Min_Order_By = {
  gtin?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "gtin_metadata". */
export type Gtin_Metadata_Order_By = {
  gtin?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "gtin_metadata" */
export enum Gtin_Metadata_Select_Column {
  /** column name */
  Gtin = 'gtin',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "gtin_metadata" */
export type Gtin_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gtin_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gtin_Metadata_Stream_Cursor_Value_Input = {
  gtin?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "hub_last_visited" */
export type Hub_Last_Visited = Node & {
  __typename?: 'hub_last_visited';
  employee_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  last_visited_at: Scalars['timestamptz']['output'];
};

/** A Relay connection object on "hub_last_visited" */
export type Hub_Last_VisitedConnection = {
  __typename?: 'hub_last_visitedConnection';
  edges: Array<Hub_Last_VisitedEdge>;
  pageInfo: PageInfo;
};

export type Hub_Last_VisitedEdge = {
  __typename?: 'hub_last_visitedEdge';
  cursor: Scalars['String']['output'];
  node: Hub_Last_Visited;
};

/** Boolean expression to filter rows from the table "hub_last_visited". All fields are combined with a logical 'AND'. */
export type Hub_Last_Visited_Bool_Exp = {
  _and?: InputMaybe<Array<Hub_Last_Visited_Bool_Exp>>;
  _not?: InputMaybe<Hub_Last_Visited_Bool_Exp>;
  _or?: InputMaybe<Array<Hub_Last_Visited_Bool_Exp>>;
  employee_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  last_visited_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "hub_last_visited". */
export type Hub_Last_Visited_Order_By = {
  employee_uuid?: InputMaybe<Order_By>;
  last_visited_at?: InputMaybe<Order_By>;
};

/** select columns of table "hub_last_visited" */
export enum Hub_Last_Visited_Select_Column {
  /** column name */
  EmployeeUuid = 'employee_uuid',
  /** column name */
  LastVisitedAt = 'last_visited_at'
}

/** Streaming cursor of the table "hub_last_visited" */
export type Hub_Last_Visited_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hub_Last_Visited_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hub_Last_Visited_Stream_Cursor_Value_Input = {
  employee_uuid?: InputMaybe<Scalars['uuid']['input']>;
  last_visited_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "item_order_count_l30_days" */
export type Item_Order_Count_L30_Days = {
  __typename?: 'item_order_count_l30_days';
  count?: Maybe<Scalars['bigint']['output']>;
  item_uuid?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "item_order_count_l30_days". All fields are combined with a logical 'AND'. */
export type Item_Order_Count_L30_Days_Bool_Exp = {
  _and?: InputMaybe<Array<Item_Order_Count_L30_Days_Bool_Exp>>;
  _not?: InputMaybe<Item_Order_Count_L30_Days_Bool_Exp>;
  _or?: InputMaybe<Array<Item_Order_Count_L30_Days_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  item_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "item_order_count_l30_days". */
export type Item_Order_Count_L30_Days_Order_By = {
  count?: InputMaybe<Order_By>;
  item_uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "items" */
export type Items = Node & {
  __typename?: 'items';
  additional_information_config?: Maybe<Scalars['jsonb']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by_uuid: Scalars['uuid']['output'];
  description?: Maybe<Scalars['String']['output']>;
  display_name: Scalars['String']['output'];
  extra_keywords?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  order_count_l30_days?: Maybe<Item_Order_Count_L30_Days>;
  photo_url_list?: Maybe<Scalars['_text']['output']>;
  /** An array relationship */
  restaurant_item_overrides: Array<Restaurant_Item_Overrides>;
  /** An array relationship connection */
  restaurant_item_overrides_connection: Restaurant_Item_OverridesConnection;
  /** An object relationship */
  supplier: Businesses;
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
  /** An array relationship */
  variant_packs: Array<Variants_Packs>;
  /** An aggregate relationship */
  variant_packs_aggregate: Variants_Packs_Aggregate;
  /** An array relationship connection */
  variant_packs_connection: Variants_PacksConnection;
};


/** columns and relationships of "items" */
export type ItemsAdditional_Information_ConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "items" */
export type ItemsRestaurant_Item_OverridesArgs = {
  distinct_on?: InputMaybe<Array<Restaurant_Item_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Item_Overrides_Order_By>>;
  where?: InputMaybe<Restaurant_Item_Overrides_Bool_Exp>;
};


/** columns and relationships of "items" */
export type ItemsRestaurant_Item_Overrides_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Restaurant_Item_Overrides_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Item_Overrides_Order_By>>;
  where?: InputMaybe<Restaurant_Item_Overrides_Bool_Exp>;
};


/** columns and relationships of "items" */
export type ItemsVariant_PacksArgs = {
  distinct_on?: InputMaybe<Array<Variants_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variants_Packs_Order_By>>;
  where?: InputMaybe<Variants_Packs_Bool_Exp>;
};


/** columns and relationships of "items" */
export type ItemsVariant_Packs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variants_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variants_Packs_Order_By>>;
  where?: InputMaybe<Variants_Packs_Bool_Exp>;
};


/** columns and relationships of "items" */
export type ItemsVariant_Packs_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Variants_Packs_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variants_Packs_Order_By>>;
  where?: InputMaybe<Variants_Packs_Bool_Exp>;
};

/** A Relay connection object on "items" */
export type ItemsConnection = {
  __typename?: 'itemsConnection';
  edges: Array<ItemsEdge>;
  pageInfo: PageInfo;
};

export type ItemsEdge = {
  __typename?: 'itemsEdge';
  cursor: Scalars['String']['output'];
  node: Items;
};

/** order by aggregate values of table "items" */
export type Items_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Items_Max_Order_By>;
  min?: InputMaybe<Items_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "items". All fields are combined with a logical 'AND'. */
export type Items_Bool_Exp = {
  _and?: InputMaybe<Array<Items_Bool_Exp>>;
  _not?: InputMaybe<Items_Bool_Exp>;
  _or?: InputMaybe<Array<Items_Bool_Exp>>;
  additional_information_config?: InputMaybe<Jsonb_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  extra_keywords?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_count_l30_days?: InputMaybe<Item_Order_Count_L30_Days_Bool_Exp>;
  photo_url_list?: InputMaybe<_Text_Comparison_Exp>;
  restaurant_item_overrides?: InputMaybe<Restaurant_Item_Overrides_Bool_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_packs?: InputMaybe<Variants_Packs_Bool_Exp>;
};

/** order by max() on columns of table "items" */
export type Items_Max_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  extra_keywords?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "items" */
export type Items_Min_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  extra_keywords?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "items". */
export type Items_Order_By = {
  additional_information_config?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  extra_keywords?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_count_l30_days?: InputMaybe<Item_Order_Count_L30_Days_Order_By>;
  photo_url_list?: InputMaybe<Order_By>;
  restaurant_item_overrides_aggregate?: InputMaybe<Restaurant_Item_Overrides_Aggregate_Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_packs_aggregate?: InputMaybe<Variants_Packs_Aggregate_Order_By>;
};

/** select columns of table "items" */
export enum Items_Select_Column {
  /** column name */
  AdditionalInformationConfig = 'additional_information_config',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUuid = 'created_by_uuid',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  ExtraKeywords = 'extra_keywords',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoUrlList = 'photo_url_list',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Uuid = 'uuid'
}

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "lead_time_settings" */
export type Lead_Time_Settings = Node & {
  __typename?: 'lead_time_settings';
  id: Scalars['ID']['output'];
  uuid: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "lead_time_settings". All fields are combined with a logical 'AND'. */
export type Lead_Time_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Lead_Time_Settings_Bool_Exp>>;
  _not?: InputMaybe<Lead_Time_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Lead_Time_Settings_Bool_Exp>>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "lead_time_settings". */
export type Lead_Time_Settings_Order_By = {
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "loyalty_program_terms" */
export type Loyalty_Program_Terms = Node & {
  __typename?: 'loyalty_program_terms';
  acceptance_disclaimer?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['ID']['output'];
  loyalty_program_uuid: Scalars['uuid']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  terms_url: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
  version: Scalars['String']['output'];
};

/** A Relay connection object on "loyalty_program_terms" */
export type Loyalty_Program_TermsConnection = {
  __typename?: 'loyalty_program_termsConnection';
  edges: Array<Loyalty_Program_TermsEdge>;
  pageInfo: PageInfo;
};

export type Loyalty_Program_TermsEdge = {
  __typename?: 'loyalty_program_termsEdge';
  cursor: Scalars['String']['output'];
  node: Loyalty_Program_Terms;
};

/** order by aggregate values of table "loyalty_program_terms" */
export type Loyalty_Program_Terms_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Loyalty_Program_Terms_Max_Order_By>;
  min?: InputMaybe<Loyalty_Program_Terms_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "loyalty_program_terms". All fields are combined with a logical 'AND'. */
export type Loyalty_Program_Terms_Bool_Exp = {
  _and?: InputMaybe<Array<Loyalty_Program_Terms_Bool_Exp>>;
  _not?: InputMaybe<Loyalty_Program_Terms_Bool_Exp>;
  _or?: InputMaybe<Array<Loyalty_Program_Terms_Bool_Exp>>;
  acceptance_disclaimer?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  loyalty_program_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  summary?: InputMaybe<String_Comparison_Exp>;
  terms_url?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  version?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "loyalty_program_terms" */
export type Loyalty_Program_Terms_Max_Order_By = {
  acceptance_disclaimer?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  loyalty_program_uuid?: InputMaybe<Order_By>;
  summary?: InputMaybe<Order_By>;
  terms_url?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "loyalty_program_terms" */
export type Loyalty_Program_Terms_Min_Order_By = {
  acceptance_disclaimer?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  loyalty_program_uuid?: InputMaybe<Order_By>;
  summary?: InputMaybe<Order_By>;
  terms_url?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "loyalty_program_terms". */
export type Loyalty_Program_Terms_Order_By = {
  acceptance_disclaimer?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  loyalty_program_uuid?: InputMaybe<Order_By>;
  summary?: InputMaybe<Order_By>;
  terms_url?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** select columns of table "loyalty_program_terms" */
export enum Loyalty_Program_Terms_Select_Column {
  /** column name */
  AcceptanceDisclaimer = 'acceptance_disclaimer',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LoyaltyProgramUuid = 'loyalty_program_uuid',
  /** column name */
  Summary = 'summary',
  /** column name */
  TermsUrl = 'terms_url',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Version = 'version'
}

/** columns and relationships of "loyalty_programs" */
export type Loyalty_Programs = Node & {
  __typename?: 'loyalty_programs';
  banner_image_url?: Maybe<Scalars['String']['output']>;
  banner_text?: Maybe<Scalars['String']['output']>;
  enrollment_completion_text?: Maybe<Scalars['String']['output']>;
  enrollment_form_config: Scalars['jsonb']['output'];
  id: Scalars['ID']['output'];
  /** An array relationship */
  loyalty_program_terms: Array<Loyalty_Program_Terms>;
  /** An array relationship connection */
  loyalty_program_terms_connection: Loyalty_Program_TermsConnection;
  name: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "loyalty_programs" */
export type Loyalty_ProgramsEnrollment_Form_ConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "loyalty_programs" */
export type Loyalty_ProgramsLoyalty_Program_TermsArgs = {
  distinct_on?: InputMaybe<Array<Loyalty_Program_Terms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Loyalty_Program_Terms_Order_By>>;
  where?: InputMaybe<Loyalty_Program_Terms_Bool_Exp>;
};


/** columns and relationships of "loyalty_programs" */
export type Loyalty_ProgramsLoyalty_Program_Terms_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Loyalty_Program_Terms_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Loyalty_Program_Terms_Order_By>>;
  where?: InputMaybe<Loyalty_Program_Terms_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "loyalty_programs". All fields are combined with a logical 'AND'. */
export type Loyalty_Programs_Bool_Exp = {
  _and?: InputMaybe<Array<Loyalty_Programs_Bool_Exp>>;
  _not?: InputMaybe<Loyalty_Programs_Bool_Exp>;
  _or?: InputMaybe<Array<Loyalty_Programs_Bool_Exp>>;
  banner_image_url?: InputMaybe<String_Comparison_Exp>;
  banner_text?: InputMaybe<String_Comparison_Exp>;
  enrollment_completion_text?: InputMaybe<String_Comparison_Exp>;
  enrollment_form_config?: InputMaybe<Jsonb_Comparison_Exp>;
  loyalty_program_terms?: InputMaybe<Loyalty_Program_Terms_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "loyalty_programs". */
export type Loyalty_Programs_Order_By = {
  banner_image_url?: InputMaybe<Order_By>;
  banner_text?: InputMaybe<Order_By>;
  enrollment_completion_text?: InputMaybe<Order_By>;
  enrollment_form_config?: InputMaybe<Order_By>;
  loyalty_program_terms_aggregate?: InputMaybe<Loyalty_Program_Terms_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "loyalty_terms_acceptance_log" */
export type Loyalty_Terms_Acceptance_Log = Node & {
  __typename?: 'loyalty_terms_acceptance_log';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['ID']['output'];
  /** An object relationship */
  loyalty_program_terms: Loyalty_Program_Terms;
  loyalty_program_terms_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  supplier_loyalty_program_restaurant: Supplier_Loyalty_Program_Restaurants;
  supplier_loyalty_program_restaurant_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "loyalty_terms_acceptance_log" */
export type Loyalty_Terms_Acceptance_LogConnection = {
  __typename?: 'loyalty_terms_acceptance_logConnection';
  edges: Array<Loyalty_Terms_Acceptance_LogEdge>;
  pageInfo: PageInfo;
};

export type Loyalty_Terms_Acceptance_LogEdge = {
  __typename?: 'loyalty_terms_acceptance_logEdge';
  cursor: Scalars['String']['output'];
  node: Loyalty_Terms_Acceptance_Log;
};

/** order by aggregate values of table "loyalty_terms_acceptance_log" */
export type Loyalty_Terms_Acceptance_Log_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Loyalty_Terms_Acceptance_Log_Max_Order_By>;
  min?: InputMaybe<Loyalty_Terms_Acceptance_Log_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "loyalty_terms_acceptance_log". All fields are combined with a logical 'AND'. */
export type Loyalty_Terms_Acceptance_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Loyalty_Terms_Acceptance_Log_Bool_Exp>>;
  _not?: InputMaybe<Loyalty_Terms_Acceptance_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Loyalty_Terms_Acceptance_Log_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  loyalty_program_terms?: InputMaybe<Loyalty_Program_Terms_Bool_Exp>;
  loyalty_program_terms_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  supplier_loyalty_program_restaurant?: InputMaybe<Supplier_Loyalty_Program_Restaurants_Bool_Exp>;
  supplier_loyalty_program_restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "loyalty_terms_acceptance_log" */
export type Loyalty_Terms_Acceptance_Log_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  loyalty_program_terms_uuid?: InputMaybe<Order_By>;
  supplier_loyalty_program_restaurant_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "loyalty_terms_acceptance_log" */
export type Loyalty_Terms_Acceptance_Log_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  loyalty_program_terms_uuid?: InputMaybe<Order_By>;
  supplier_loyalty_program_restaurant_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "loyalty_terms_acceptance_log". */
export type Loyalty_Terms_Acceptance_Log_Order_By = {
  created_at?: InputMaybe<Order_By>;
  loyalty_program_terms?: InputMaybe<Loyalty_Program_Terms_Order_By>;
  loyalty_program_terms_uuid?: InputMaybe<Order_By>;
  supplier_loyalty_program_restaurant?: InputMaybe<Supplier_Loyalty_Program_Restaurants_Order_By>;
  supplier_loyalty_program_restaurant_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "loyalty_terms_acceptance_log" */
export enum Loyalty_Terms_Acceptance_Log_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LoyaltyProgramTermsUuid = 'loyalty_program_terms_uuid',
  /** column name */
  SupplierLoyaltyProgramRestaurantUuid = 'supplier_loyalty_program_restaurant_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** columns and relationships of "menu_item_ingredient_metadata" */
export type Menu_Item_Ingredient_Metadata = Node & {
  __typename?: 'menu_item_ingredient_metadata';
  id: Scalars['ID']['output'];
  ingredient_metadata: Scalars['jsonb']['output'];
  /** An object relationship */
  menu_item: Menu_Items;
  /** An object relationship */
  menu_item_ingredient: Menu_Item_Ingredients;
  menu_item_ingredient_uuid: Scalars['uuid']['output'];
  menu_item_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "menu_item_ingredient_metadata" */
export type Menu_Item_Ingredient_MetadataIngredient_MetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "menu_item_ingredient_metadata" */
export type Menu_Item_Ingredient_MetadataConnection = {
  __typename?: 'menu_item_ingredient_metadataConnection';
  edges: Array<Menu_Item_Ingredient_MetadataEdge>;
  pageInfo: PageInfo;
};

export type Menu_Item_Ingredient_MetadataEdge = {
  __typename?: 'menu_item_ingredient_metadataEdge';
  cursor: Scalars['String']['output'];
  node: Menu_Item_Ingredient_Metadata;
};

/** order by aggregate values of table "menu_item_ingredient_metadata" */
export type Menu_Item_Ingredient_Metadata_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Menu_Item_Ingredient_Metadata_Max_Order_By>;
  min?: InputMaybe<Menu_Item_Ingredient_Metadata_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Menu_Item_Ingredient_Metadata_Append_Input = {
  ingredient_metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "menu_item_ingredient_metadata". All fields are combined with a logical 'AND'. */
export type Menu_Item_Ingredient_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Menu_Item_Ingredient_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Menu_Item_Ingredient_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Menu_Item_Ingredient_Metadata_Bool_Exp>>;
  ingredient_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  menu_item?: InputMaybe<Menu_Items_Bool_Exp>;
  menu_item_ingredient?: InputMaybe<Menu_Item_Ingredients_Bool_Exp>;
  menu_item_ingredient_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  menu_item_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Menu_Item_Ingredient_Metadata_Delete_At_Path_Input = {
  ingredient_metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Menu_Item_Ingredient_Metadata_Delete_Elem_Input = {
  ingredient_metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Menu_Item_Ingredient_Metadata_Delete_Key_Input = {
  ingredient_metadata?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "menu_item_ingredient_metadata" */
export type Menu_Item_Ingredient_Metadata_Max_Order_By = {
  menu_item_ingredient_uuid?: InputMaybe<Order_By>;
  menu_item_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "menu_item_ingredient_metadata" */
export type Menu_Item_Ingredient_Metadata_Min_Order_By = {
  menu_item_ingredient_uuid?: InputMaybe<Order_By>;
  menu_item_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "menu_item_ingredient_metadata" */
export type Menu_Item_Ingredient_Metadata_Mutation_Response = {
  __typename?: 'menu_item_ingredient_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Menu_Item_Ingredient_Metadata>;
};

/** Ordering options when selecting data from "menu_item_ingredient_metadata". */
export type Menu_Item_Ingredient_Metadata_Order_By = {
  ingredient_metadata?: InputMaybe<Order_By>;
  menu_item?: InputMaybe<Menu_Items_Order_By>;
  menu_item_ingredient?: InputMaybe<Menu_Item_Ingredients_Order_By>;
  menu_item_ingredient_uuid?: InputMaybe<Order_By>;
  menu_item_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: menu_item_ingredient_metadata */
export type Menu_Item_Ingredient_Metadata_Pk_Columns_Input = {
  uuid: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Menu_Item_Ingredient_Metadata_Prepend_Input = {
  ingredient_metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "menu_item_ingredient_metadata" */
export enum Menu_Item_Ingredient_Metadata_Select_Column {
  /** column name */
  IngredientMetadata = 'ingredient_metadata',
  /** column name */
  MenuItemIngredientUuid = 'menu_item_ingredient_uuid',
  /** column name */
  MenuItemUuid = 'menu_item_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "menu_item_ingredient_metadata" */
export type Menu_Item_Ingredient_Metadata_Set_Input = {
  ingredient_metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

export type Menu_Item_Ingredient_Metadata_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Menu_Item_Ingredient_Metadata_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Menu_Item_Ingredient_Metadata_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Menu_Item_Ingredient_Metadata_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Menu_Item_Ingredient_Metadata_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Menu_Item_Ingredient_Metadata_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Menu_Item_Ingredient_Metadata_Set_Input>;
  where: Menu_Item_Ingredient_Metadata_Bool_Exp;
};

/** columns and relationships of "menu_item_ingredients" */
export type Menu_Item_Ingredients = Node & {
  __typename?: 'menu_item_ingredients';
  cost_in_micros?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['ID']['output'];
  ingredient_metadata: Scalars['jsonb']['output'];
  ingredient_name: Scalars['String']['output'];
  /** An object relationship */
  menu_item?: Maybe<Menu_Items>;
  /** An array relationship */
  menu_item_ingredient_metadata: Array<Menu_Item_Ingredient_Metadata>;
  /** An array relationship connection */
  menu_item_ingredient_metadata_connection: Menu_Item_Ingredient_MetadataConnection;
  menu_item_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  pack: Packs;
  pack_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  restaurant: Businesses;
  restaurant_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  supplier: Businesses;
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
  /** An object relationship */
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_uuid?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "menu_item_ingredients" */
export type Menu_Item_IngredientsIngredient_MetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "menu_item_ingredients" */
export type Menu_Item_IngredientsMenu_Item_Ingredient_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Menu_Item_Ingredient_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menu_Item_Ingredient_Metadata_Order_By>>;
  where?: InputMaybe<Menu_Item_Ingredient_Metadata_Bool_Exp>;
};


/** columns and relationships of "menu_item_ingredients" */
export type Menu_Item_IngredientsMenu_Item_Ingredient_Metadata_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Menu_Item_Ingredient_Metadata_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menu_Item_Ingredient_Metadata_Order_By>>;
  where?: InputMaybe<Menu_Item_Ingredient_Metadata_Bool_Exp>;
};

/** A Relay connection object on "menu_item_ingredients" */
export type Menu_Item_IngredientsConnection = {
  __typename?: 'menu_item_ingredientsConnection';
  edges: Array<Menu_Item_IngredientsEdge>;
  pageInfo: PageInfo;
};

export type Menu_Item_IngredientsEdge = {
  __typename?: 'menu_item_ingredientsEdge';
  cursor: Scalars['String']['output'];
  node: Menu_Item_Ingredients;
};

/** order by aggregate values of table "menu_item_ingredients" */
export type Menu_Item_Ingredients_Aggregate_Order_By = {
  avg?: InputMaybe<Menu_Item_Ingredients_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Menu_Item_Ingredients_Max_Order_By>;
  min?: InputMaybe<Menu_Item_Ingredients_Min_Order_By>;
  stddev?: InputMaybe<Menu_Item_Ingredients_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Menu_Item_Ingredients_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Menu_Item_Ingredients_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Menu_Item_Ingredients_Sum_Order_By>;
  var_pop?: InputMaybe<Menu_Item_Ingredients_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Menu_Item_Ingredients_Var_Samp_Order_By>;
  variance?: InputMaybe<Menu_Item_Ingredients_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Menu_Item_Ingredients_Append_Input = {
  ingredient_metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** order by avg() on columns of table "menu_item_ingredients" */
export type Menu_Item_Ingredients_Avg_Order_By = {
  cost_in_micros?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "menu_item_ingredients". All fields are combined with a logical 'AND'. */
export type Menu_Item_Ingredients_Bool_Exp = {
  _and?: InputMaybe<Array<Menu_Item_Ingredients_Bool_Exp>>;
  _not?: InputMaybe<Menu_Item_Ingredients_Bool_Exp>;
  _or?: InputMaybe<Array<Menu_Item_Ingredients_Bool_Exp>>;
  cost_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  ingredient_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  ingredient_name?: InputMaybe<String_Comparison_Exp>;
  menu_item?: InputMaybe<Menu_Items_Bool_Exp>;
  menu_item_ingredient_metadata?: InputMaybe<Menu_Item_Ingredient_Metadata_Bool_Exp>;
  menu_item_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  pack?: InputMaybe<Packs_Bool_Exp>;
  pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  restaurant?: InputMaybe<Businesses_Bool_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack?: InputMaybe<Variants_Packs_Bool_Exp>;
  variant_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Menu_Item_Ingredients_Delete_At_Path_Input = {
  ingredient_metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Menu_Item_Ingredients_Delete_Elem_Input = {
  ingredient_metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Menu_Item_Ingredients_Delete_Key_Input = {
  ingredient_metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "menu_item_ingredients" */
export type Menu_Item_Ingredients_Inc_Input = {
  cost_in_micros?: InputMaybe<Scalars['bigint']['input']>;
};

/** order by max() on columns of table "menu_item_ingredients" */
export type Menu_Item_Ingredients_Max_Order_By = {
  cost_in_micros?: InputMaybe<Order_By>;
  ingredient_name?: InputMaybe<Order_By>;
  menu_item_uuid?: InputMaybe<Order_By>;
  pack_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "menu_item_ingredients" */
export type Menu_Item_Ingredients_Min_Order_By = {
  cost_in_micros?: InputMaybe<Order_By>;
  ingredient_name?: InputMaybe<Order_By>;
  menu_item_uuid?: InputMaybe<Order_By>;
  pack_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "menu_item_ingredients" */
export type Menu_Item_Ingredients_Mutation_Response = {
  __typename?: 'menu_item_ingredients_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Menu_Item_Ingredients>;
};

/** Ordering options when selecting data from "menu_item_ingredients". */
export type Menu_Item_Ingredients_Order_By = {
  cost_in_micros?: InputMaybe<Order_By>;
  ingredient_metadata?: InputMaybe<Order_By>;
  ingredient_name?: InputMaybe<Order_By>;
  menu_item?: InputMaybe<Menu_Items_Order_By>;
  menu_item_ingredient_metadata_aggregate?: InputMaybe<Menu_Item_Ingredient_Metadata_Aggregate_Order_By>;
  menu_item_uuid?: InputMaybe<Order_By>;
  pack?: InputMaybe<Packs_Order_By>;
  pack_uuid?: InputMaybe<Order_By>;
  restaurant?: InputMaybe<Businesses_Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack?: InputMaybe<Variants_Packs_Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: menu_item_ingredients */
export type Menu_Item_Ingredients_Pk_Columns_Input = {
  uuid: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Menu_Item_Ingredients_Prepend_Input = {
  ingredient_metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "menu_item_ingredients" */
export enum Menu_Item_Ingredients_Select_Column {
  /** column name */
  CostInMicros = 'cost_in_micros',
  /** column name */
  IngredientMetadata = 'ingredient_metadata',
  /** column name */
  IngredientName = 'ingredient_name',
  /** column name */
  MenuItemUuid = 'menu_item_uuid',
  /** column name */
  PackUuid = 'pack_uuid',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VariantPackUuid = 'variant_pack_uuid'
}

/** input type for updating data in table "menu_item_ingredients" */
export type Menu_Item_Ingredients_Set_Input = {
  cost_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  ingredient_metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** order by stddev() on columns of table "menu_item_ingredients" */
export type Menu_Item_Ingredients_Stddev_Order_By = {
  cost_in_micros?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "menu_item_ingredients" */
export type Menu_Item_Ingredients_Stddev_Pop_Order_By = {
  cost_in_micros?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "menu_item_ingredients" */
export type Menu_Item_Ingredients_Stddev_Samp_Order_By = {
  cost_in_micros?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "menu_item_ingredients" */
export type Menu_Item_Ingredients_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Menu_Item_Ingredients_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Menu_Item_Ingredients_Stream_Cursor_Value_Input = {
  cost_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  ingredient_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  ingredient_name?: InputMaybe<Scalars['String']['input']>;
  menu_item_uuid?: InputMaybe<Scalars['uuid']['input']>;
  pack_uuid?: InputMaybe<Scalars['uuid']['input']>;
  restaurant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
  variant_pack_uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "menu_item_ingredients" */
export type Menu_Item_Ingredients_Sum_Order_By = {
  cost_in_micros?: InputMaybe<Order_By>;
};

export type Menu_Item_Ingredients_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Menu_Item_Ingredients_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Menu_Item_Ingredients_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Menu_Item_Ingredients_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Menu_Item_Ingredients_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Menu_Item_Ingredients_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Menu_Item_Ingredients_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Menu_Item_Ingredients_Set_Input>;
  where: Menu_Item_Ingredients_Bool_Exp;
};

/** order by var_pop() on columns of table "menu_item_ingredients" */
export type Menu_Item_Ingredients_Var_Pop_Order_By = {
  cost_in_micros?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "menu_item_ingredients" */
export type Menu_Item_Ingredients_Var_Samp_Order_By = {
  cost_in_micros?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "menu_item_ingredients" */
export type Menu_Item_Ingredients_Variance_Order_By = {
  cost_in_micros?: InputMaybe<Order_By>;
};

/** columns and relationships of "menu_items" */
export type Menu_Items = Node & {
  __typename?: 'menu_items';
  created_by_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  item_name: Scalars['String']['output'];
  /** An array relationship */
  menu_item_ingredient_metadata: Array<Menu_Item_Ingredient_Metadata>;
  /** An array relationship connection */
  menu_item_ingredient_metadata_connection: Menu_Item_Ingredient_MetadataConnection;
  /** An array relationship */
  menu_item_ingredients: Array<Menu_Item_Ingredients>;
  /** An array relationship connection */
  menu_item_ingredients_connection: Menu_Item_IngredientsConnection;
  price_in_micros?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  restaurant: Businesses;
  restaurant_uuid: Scalars['uuid']['output'];
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "menu_items" */
export type Menu_ItemsMenu_Item_Ingredient_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Menu_Item_Ingredient_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menu_Item_Ingredient_Metadata_Order_By>>;
  where?: InputMaybe<Menu_Item_Ingredient_Metadata_Bool_Exp>;
};


/** columns and relationships of "menu_items" */
export type Menu_ItemsMenu_Item_Ingredient_Metadata_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Menu_Item_Ingredient_Metadata_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menu_Item_Ingredient_Metadata_Order_By>>;
  where?: InputMaybe<Menu_Item_Ingredient_Metadata_Bool_Exp>;
};


/** columns and relationships of "menu_items" */
export type Menu_ItemsMenu_Item_IngredientsArgs = {
  distinct_on?: InputMaybe<Array<Menu_Item_Ingredients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menu_Item_Ingredients_Order_By>>;
  where?: InputMaybe<Menu_Item_Ingredients_Bool_Exp>;
};


/** columns and relationships of "menu_items" */
export type Menu_ItemsMenu_Item_Ingredients_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Menu_Item_Ingredients_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menu_Item_Ingredients_Order_By>>;
  where?: InputMaybe<Menu_Item_Ingredients_Bool_Exp>;
};

/** A Relay connection object on "menu_items" */
export type Menu_ItemsConnection = {
  __typename?: 'menu_itemsConnection';
  edges: Array<Menu_ItemsEdge>;
  pageInfo: PageInfo;
};

export type Menu_ItemsEdge = {
  __typename?: 'menu_itemsEdge';
  cursor: Scalars['String']['output'];
  node: Menu_Items;
};

/** Boolean expression to filter rows from the table "menu_items". All fields are combined with a logical 'AND'. */
export type Menu_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Menu_Items_Bool_Exp>>;
  _not?: InputMaybe<Menu_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Menu_Items_Bool_Exp>>;
  created_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  item_name?: InputMaybe<String_Comparison_Exp>;
  menu_item_ingredient_metadata?: InputMaybe<Menu_Item_Ingredient_Metadata_Bool_Exp>;
  menu_item_ingredients?: InputMaybe<Menu_Item_Ingredients_Bool_Exp>;
  price_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  restaurant?: InputMaybe<Businesses_Bool_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "menu_items" */
export enum Menu_Items_Constraint {
  /** unique or primary key constraint on columns "uuid" */
  MenuItemsPkey = 'menu_items_pkey'
}

/** input type for incrementing numeric columns in table "menu_items" */
export type Menu_Items_Inc_Input = {
  price_in_micros?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "menu_items" */
export type Menu_Items_Insert_Input = {
  created_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
  item_name?: InputMaybe<Scalars['String']['input']>;
  price_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  restaurant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "menu_items" */
export type Menu_Items_Mutation_Response = {
  __typename?: 'menu_items_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Menu_Items>;
};

/** on_conflict condition type for table "menu_items" */
export type Menu_Items_On_Conflict = {
  constraint: Menu_Items_Constraint;
  update_columns?: Array<Menu_Items_Update_Column>;
  where?: InputMaybe<Menu_Items_Bool_Exp>;
};

/** Ordering options when selecting data from "menu_items". */
export type Menu_Items_Order_By = {
  created_by_uuid?: InputMaybe<Order_By>;
  item_name?: InputMaybe<Order_By>;
  menu_item_ingredient_metadata_aggregate?: InputMaybe<Menu_Item_Ingredient_Metadata_Aggregate_Order_By>;
  menu_item_ingredients_aggregate?: InputMaybe<Menu_Item_Ingredients_Aggregate_Order_By>;
  price_in_micros?: InputMaybe<Order_By>;
  restaurant?: InputMaybe<Businesses_Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: menu_items */
export type Menu_Items_Pk_Columns_Input = {
  uuid: Scalars['uuid']['input'];
};

/** select columns of table "menu_items" */
export enum Menu_Items_Select_Column {
  /** column name */
  CreatedByUuid = 'created_by_uuid',
  /** column name */
  ItemName = 'item_name',
  /** column name */
  PriceInMicros = 'price_in_micros',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "menu_items" */
export type Menu_Items_Set_Input = {
  item_name?: InputMaybe<Scalars['String']['input']>;
  price_in_micros?: InputMaybe<Scalars['bigint']['input']>;
};

/** Streaming cursor of the table "menu_items" */
export type Menu_Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Menu_Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Menu_Items_Stream_Cursor_Value_Input = {
  created_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
  item_name?: InputMaybe<Scalars['String']['input']>;
  price_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  restaurant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "menu_items" */
export enum Menu_Items_Update_Column {
  /** column name */
  ItemName = 'item_name',
  /** column name */
  PriceInMicros = 'price_in_micros'
}

export type Menu_Items_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Menu_Items_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Menu_Items_Set_Input>;
  where: Menu_Items_Bool_Exp;
};

/** columns and relationships of "messages" */
export type Messages = Node & {
  __typename?: 'messages';
  /** An object relationship */
  chat: Chats;
  chat_uuid: Scalars['uuid']['output'];
  /** An array relationship */
  credit_request_batches_messages: Array<Credit_Request_Batches_Messages>;
  /** An array relationship connection */
  credit_request_batches_messages_connection: Credit_Request_Batches_MessagesConnection;
  id: Scalars['ID']['output'];
  media_content_url?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  order_invoice?: Maybe<Order_Invoices>;
  order_invoice_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  order_status_update?: Maybe<Order_Status_Updates>;
  order_status_update_uuid?: Maybe<Scalars['uuid']['output']>;
  raw_text_content?: Maybe<Scalars['String']['output']>;
  sent_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  sent_by: Employees;
  /** A computed field, executes function "message_sent_by_name" */
  sent_by_name?: Maybe<Scalars['String']['output']>;
  sent_by_uuid: Scalars['uuid']['output'];
  text_content?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "messages" */
export type MessagesCredit_Request_Batches_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Credit_Request_Batches_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Batches_Messages_Order_By>>;
  where?: InputMaybe<Credit_Request_Batches_Messages_Bool_Exp>;
};


/** columns and relationships of "messages" */
export type MessagesCredit_Request_Batches_Messages_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Request_Batches_Messages_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Batches_Messages_Order_By>>;
  where?: InputMaybe<Credit_Request_Batches_Messages_Bool_Exp>;
};

/** A Relay connection object on "messages" */
export type MessagesConnection = {
  __typename?: 'messagesConnection';
  edges: Array<MessagesEdge>;
  pageInfo: PageInfo;
};

export type MessagesEdge = {
  __typename?: 'messagesEdge';
  cursor: Scalars['String']['output'];
  node: Messages;
};

/** order by aggregate values of table "messages" */
export type Messages_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Messages_Max_Order_By>;
  min?: InputMaybe<Messages_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "messages". All fields are combined with a logical 'AND'. */
export type Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Messages_Bool_Exp>>;
  _not?: InputMaybe<Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Messages_Bool_Exp>>;
  chat?: InputMaybe<Chats_Bool_Exp>;
  chat_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  credit_request_batches_messages?: InputMaybe<Credit_Request_Batches_Messages_Bool_Exp>;
  media_content_url?: InputMaybe<String_Comparison_Exp>;
  order_invoice?: InputMaybe<Order_Invoices_Bool_Exp>;
  order_invoice_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  order_status_update?: InputMaybe<Order_Status_Updates_Bool_Exp>;
  order_status_update_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  raw_text_content?: InputMaybe<String_Comparison_Exp>;
  sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  sent_by?: InputMaybe<Employees_Bool_Exp>;
  sent_by_name?: InputMaybe<String_Comparison_Exp>;
  sent_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  text_content?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "messages" */
export type Messages_Max_Order_By = {
  chat_uuid?: InputMaybe<Order_By>;
  media_content_url?: InputMaybe<Order_By>;
  order_invoice_uuid?: InputMaybe<Order_By>;
  order_status_update_uuid?: InputMaybe<Order_By>;
  raw_text_content?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  sent_by_uuid?: InputMaybe<Order_By>;
  text_content?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "messages" */
export type Messages_Min_Order_By = {
  chat_uuid?: InputMaybe<Order_By>;
  media_content_url?: InputMaybe<Order_By>;
  order_invoice_uuid?: InputMaybe<Order_By>;
  order_status_update_uuid?: InputMaybe<Order_By>;
  raw_text_content?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  sent_by_uuid?: InputMaybe<Order_By>;
  text_content?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "messages". */
export type Messages_Order_By = {
  chat?: InputMaybe<Chats_Order_By>;
  chat_uuid?: InputMaybe<Order_By>;
  credit_request_batches_messages_aggregate?: InputMaybe<Credit_Request_Batches_Messages_Aggregate_Order_By>;
  media_content_url?: InputMaybe<Order_By>;
  order_invoice?: InputMaybe<Order_Invoices_Order_By>;
  order_invoice_uuid?: InputMaybe<Order_By>;
  order_status_update?: InputMaybe<Order_Status_Updates_Order_By>;
  order_status_update_uuid?: InputMaybe<Order_By>;
  raw_text_content?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  sent_by?: InputMaybe<Employees_Order_By>;
  sent_by_name?: InputMaybe<Order_By>;
  sent_by_uuid?: InputMaybe<Order_By>;
  text_content?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "messages" */
export enum Messages_Select_Column {
  /** column name */
  ChatUuid = 'chat_uuid',
  /** column name */
  MediaContentUrl = 'media_content_url',
  /** column name */
  OrderInvoiceUuid = 'order_invoice_uuid',
  /** column name */
  OrderStatusUpdateUuid = 'order_status_update_uuid',
  /** column name */
  RawTextContent = 'raw_text_content',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  SentByUuid = 'sent_by_uuid',
  /** column name */
  TextContent = 'text_content',
  /** column name */
  Type = 'type',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "messages" */
export type Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Messages_Stream_Cursor_Value_Input = {
  chat_uuid?: InputMaybe<Scalars['uuid']['input']>;
  media_content_url?: InputMaybe<Scalars['String']['input']>;
  order_invoice_uuid?: InputMaybe<Scalars['uuid']['input']>;
  order_status_update_uuid?: InputMaybe<Scalars['uuid']['input']>;
  raw_text_content?: InputMaybe<Scalars['String']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sent_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
  text_content?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "mobile_payment_terminals" */
export type Mobile_Payment_Terminals = Node & {
  __typename?: 'mobile_payment_terminals';
  credit_surcharge_fees?: Maybe<Scalars['jsonb']['output']>;
  debit_surcharge_fees?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "mobile_payment_terminals" */
export type Mobile_Payment_TerminalsCredit_Surcharge_FeesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "mobile_payment_terminals" */
export type Mobile_Payment_TerminalsDebit_Surcharge_FeesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "mobile_payment_terminals" */
export type Mobile_Payment_TerminalsConnection = {
  __typename?: 'mobile_payment_terminalsConnection';
  edges: Array<Mobile_Payment_TerminalsEdge>;
  pageInfo: PageInfo;
};

export type Mobile_Payment_TerminalsEdge = {
  __typename?: 'mobile_payment_terminalsEdge';
  cursor: Scalars['String']['output'];
  node: Mobile_Payment_Terminals;
};

/** Boolean expression to filter rows from the table "mobile_payment_terminals". All fields are combined with a logical 'AND'. */
export type Mobile_Payment_Terminals_Bool_Exp = {
  _and?: InputMaybe<Array<Mobile_Payment_Terminals_Bool_Exp>>;
  _not?: InputMaybe<Mobile_Payment_Terminals_Bool_Exp>;
  _or?: InputMaybe<Array<Mobile_Payment_Terminals_Bool_Exp>>;
  credit_surcharge_fees?: InputMaybe<Jsonb_Comparison_Exp>;
  debit_surcharge_fees?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "mobile_payment_terminals". */
export type Mobile_Payment_Terminals_Order_By = {
  credit_surcharge_fees?: InputMaybe<Order_By>;
  debit_surcharge_fees?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "mobile_payment_terminals" */
export enum Mobile_Payment_Terminals_Select_Column {
  /** column name */
  CreditSurchargeFees = 'credit_surcharge_fees',
  /** column name */
  DebitSurchargeFees = 'debit_surcharge_fees',
  /** column name */
  Name = 'name',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "mobile_payment_terminals" */
export type Mobile_Payment_Terminals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mobile_Payment_Terminals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mobile_Payment_Terminals_Stream_Cursor_Value_Input = {
  credit_surcharge_fees?: InputMaybe<Scalars['jsonb']['input']>;
  debit_surcharge_fees?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "modifier_option_groups" */
export type Modifier_Option_Groups = Node & {
  __typename?: 'modifier_option_groups';
  created_at: Scalars['timestamptz']['output'];
  created_by_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sort_order?: Maybe<Scalars['float8']['output']>;
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "modifier_option_groups". All fields are combined with a logical 'AND'. */
export type Modifier_Option_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Modifier_Option_Groups_Bool_Exp>>;
  _not?: InputMaybe<Modifier_Option_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Modifier_Option_Groups_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  sort_order?: InputMaybe<Float8_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "modifier_option_groups". */
export type Modifier_Option_Groups_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "modifier_options" */
export type Modifier_Options = Node & {
  __typename?: 'modifier_options';
  created_at: Scalars['timestamptz']['output'];
  created_by_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  /** An object relationship */
  modifier_option_group: Modifier_Option_Groups;
  modifier_option_group_uuid: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  sort_order?: Maybe<Scalars['float8']['output']>;
  uuid: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "modifier_options". All fields are combined with a logical 'AND'. */
export type Modifier_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Modifier_Options_Bool_Exp>>;
  _not?: InputMaybe<Modifier_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Modifier_Options_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  modifier_option_group?: InputMaybe<Modifier_Option_Groups_Bool_Exp>;
  modifier_option_group_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  sort_order?: InputMaybe<Float8_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "modifier_options". */
export type Modifier_Options_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  modifier_option_group?: InputMaybe<Modifier_Option_Groups_Order_By>;
  modifier_option_group_uuid?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  addMenuItemIngredient: MenuItemIngredientOutput;
  addMessageToChat: MessageResponse;
  addMessageToChatFromRestaurantEmployee: MessageResponse;
  addSmartOrderItem: AddItemToSmartOrderResponse;
  applyPromotions: OrderResponse;
  approveOrderPriceEditApprovalRequest: SubmitOrderResponse;
  assignPrintTagBatchPlanograms: PrintTagBatchResponse;
  assignSmartOrder: AssignSmartOrderResponse;
  /** Bulk create media entries for one or more documents (up to 100 items). */
  bulkCreateMedia: BulkCreateMediaPayload;
  cancelPaymentPlan: CreateOrUpdatePaymentPlanResponse;
  checkInOrderInvoiceItems: Array<CheckInOrderInvoiceItemsResponse>;
  clearCart: SuccessResponse;
  clearItemSubstitution: ClearItemSubstitutionResponse;
  completeOrderInvoiceCheckIn: SuccessResponse;
  confirmKlarnaPayment: ConfirmKlarnaPaymentResponse;
  copyRestaurantOrder: SuccessResponse;
  createActivityReminder: CreateActivityReminderResponse;
  createAutoPaySetting: CreateAutoPaySettingResponse;
  createCreditRequest: CreateCreditRequestBatchResponse;
  createCriticalItems: Array<VariantPackResponse>;
  createCrmActivity: CreateCrmActivityResponse;
  createDefaultOrderGuideRecords: CreateDefaultOrderGuideRecordsResponse;
  createFtniPaymentSession: CreateFtniPaymentSessionResponse;
  createGhostExecutionLog: SuccessResponse;
  createGhostMessage: CreateGhostMessageResponse;
  /** Create a new override for media fields. */
  createMedia: CreateMediaPayload;
  createMobileTerminalPaymentRequest: CreateMobileTerminalPaymentRequestResponse;
  createNoteActivity: CreateNoteAcitivityResponse;
  createOrder: OrderResponse;
  createOrderGuideCollection: OrderGuideCollectionEntryResponse;
  createOrderGuideFromGeneratedMenuItems: CreateOrderGuideFromGeneratedMenuItemsResponse;
  createOrderGuideFromMenu: CreateOrderGuideFromMenuResponse;
  createOrderGuidePartition: OrderGuidePartitionEntryResponse;
  createOrderGuidePartitionItem: OrderGuideItemEntryResponse;
  createOrderInvoiceCheckInItemIssue: CreateOrderInvoiceCheckInItemIssueResponse;
  /** Create or update an override for a specific field in the override collection. */
  createOverride: CreateOverridePayload;
  createPaymentPlan: CreateOrUpdatePaymentPlanResponse;
  createPriceQuoteFromVariantPacks: CreatePriceQuoteFromVariantPacksResponse;
  createSalesAnalyticsAlertAction: SuccessResponse;
  createSearchTermCorrection: CreateSearchTermCorrectionResponse;
  createUpdateAutoPaySettings: CreateUpdateAutoPaySettingsResponse;
  deleteAutoPaySetting: SuccessResponse;
  deleteAutoPaySettingV2: DeleteAutoPaySettingResponse;
  deleteCriticalItems: SuccessResponse;
  /** Delete an identifier from the override collection by key. */
  deleteIdentifier: DeleteIdentifierPayload;
  /** Delete media entries from a document, by specific URIs or by media type. */
  deleteMedia: DeleteMediaPayload;
  deleteMenuItem: SuccessResponse;
  deleteOrder: SuccessResponse;
  deleteOrderGuideCollection: SuccessResponse;
  deleteOrderGuidePartitionItem: SuccessResponse;
  deleteOrderInvoiceCheckInItemIssue: SuccessResponse;
  deletePaymentStatementEmailSettings: SuccessResponse;
  deletePriceQuote: DeletePriceQuoteResponse;
  deletePricingBookmarks: DeletePricingBookmarksResponse;
  deletePrintTagBatchesForRestaurant: SuccessResponse;
  deleteRestaurantVariantPackSubscription: SuccessResponse;
  /** delete data from the table: "menu_item_ingredient_metadata" */
  delete_menu_item_ingredient_metadata?: Maybe<Menu_Item_Ingredient_Metadata_Mutation_Response>;
  /** delete single row from the table: "menu_item_ingredient_metadata" */
  delete_menu_item_ingredient_metadata_by_pk?: Maybe<Menu_Item_Ingredient_Metadata>;
  /** delete data from the table: "menu_item_ingredients" */
  delete_menu_item_ingredients?: Maybe<Menu_Item_Ingredients_Mutation_Response>;
  /** delete single row from the table: "menu_item_ingredients" */
  delete_menu_item_ingredients_by_pk?: Maybe<Menu_Item_Ingredients>;
  /** delete data from the table: "order_guide" */
  delete_order_guide?: Maybe<Order_Guide_Mutation_Response>;
  /** delete single row from the table: "order_guide" */
  delete_order_guide_by_pk?: Maybe<Order_Guide>;
  depositManualPayments: DepositManualPaymentsResponse;
  duplicateMenuItem: DuplicateMenuItemOutput;
  duplicateOrderGuideCollection: OrderGuideCollectionEntryResponse;
  editMenuItemIngredient: MenuItemIngredientOutput;
  establishMobileTerminalSession: EstablishMobileTerminalSessionResponse;
  exportPriceQuote: ExportPriceQuoteResponse;
  generatePaymentLink: GeneratePaymentLinkResponse;
  generatePaymentStatementLink: GeneratePaymentStatementLinkResponse;
  getGhostConversation: GetGhostConversationResponse;
  getSmartOrderHistory: GetOrderHistoryResponse;
  grantSmartOrderRestaurantAccess: GrantSmartOrderRestaurantAccessResponse;
  handleSmartOrderError: SuccessResponse;
  initiateKlarnaPayment: InitiateKlarnaPaymentResponse;
  /** insert data into the table: "menu_items" */
  insert_menu_items?: Maybe<Menu_Items_Mutation_Response>;
  /** insert a single row into the table: "menu_items" */
  insert_menu_items_one?: Maybe<Menu_Items>;
  /** insert data into the table: "notification_tokens" */
  insert_notification_tokens?: Maybe<Notification_Tokens_Mutation_Response>;
  /** insert a single row into the table: "notification_tokens" */
  insert_notification_tokens_one?: Maybe<Notification_Tokens>;
  /** insert data into the table: "order_guide" */
  insert_order_guide?: Maybe<Order_Guide_Mutation_Response>;
  /** insert a single row into the table: "order_guide" */
  insert_order_guide_one?: Maybe<Order_Guide>;
  inviteRestaurantEmployee: InviteRestaurantEmployeeResponse;
  makePartialPaymentWithCreditRequest: MakePaymentResponse;
  makePayment: Array<MakePaymentResponse>;
  markCreditMemoAsClaimed: MarkCreditMemoAsClaimedResponse;
  markOrderInvoiceAsPaid: MarkOrderInvoiceAsPaidResponse;
  memorizeSmartOrder: MemorizeSmartOrderResponse;
  pauseRestaurantVariantPackSubscription: RestaurantVariantPackSubscriptionResponse;
  plaidCreatePaymentMethod: Array<PlaidCreatePaymentMethodOutput>;
  plaidCreateSession: PlaidCreateSessionResponse;
  prepareCheckCapture: PrepareCheckCaptureResponse;
  processMobileTerminalResponse: ProcessMobileTerminalResponseResponse;
  rateOrder: OrderResponse;
  recordCashPayment: RecordCashPaymentResponse;
  recordCheckPayment: RecordCheckPaymentResponse;
  recoverLogin: SuccessResponse;
  regenerateSmartOrder: Array<GetSmartOrderResponse>;
  regenerateSmartOrders: Array<RegenerateSmartOrdersResponse>;
  rejectOrderPriceEditApprovalRequest: OrderPriceEditApprovalRequestResponse;
  removeEmployeeFromBusiness: EmployeeResponse;
  removePaymentMethod: RemovePaymentMethodResponse;
  removeRestaurantVariantPackSubscriptionPause: RestaurantVariantPackSubscriptionResponse;
  removeSelfFromChats: EmployeeResponse;
  reorder: OrderResponse;
  /** Reorder media entries on a source document by updating their order field. */
  reorderMedia: ReorderMediaPayload;
  republishPricingRecommendationActionsForBusinessOrganization: RepublishPricingRecommendationActionsForBusinessOrganizationResponse;
  requestASample: RequestASampleResponse;
  requestPrintTagBatchDelivery: PrintTagBatchResponse;
  resendPayByLink: ResendPayByLinkResponse;
  restaurantEmployeeLogin: EmployeeResponse;
  restaurantEmployeeLogout: EmployeeResponse;
  retrieveOrderInvoiceCheckInItems: RetrieveOrderCheckInResponse;
  salesPortalCopilotSendMessage: SalesPortalCopilotSendMessageResponse;
  savePadPaymentMethodWithConsent: SavePadPaymentMethodWithConsentResponse;
  savePaymentMethod: SavePaymentMethodResponse;
  savePriceQuote: SavePriceQuoteResponse;
  saveSalesPortalCart: SaveSalesPortalCartResponse;
  selectAutoPaySettings: SelectAutoPaySettingsResponse;
  sendChatbotMessage: SendChatbotMessageResponse;
  sendPayByLink: MakePaymentResponse;
  sendPaymentLink: Array<RestaurantPaymentLinkSendResponse>;
  sendPricingRulesWriteback: SendPricingRulesWritebackResponse;
  setActiveOrder: ActiveOrderResponse;
  setItemSubstitution: SetItemSubstitutionResponse;
  setOrderGuideCollection: OrderGuideCollectionEntryResponse;
  setupApp: SetupAppResponse;
  skipNextRestaurantVariantPackSubscription: RestaurantVariantPackSubscriptionResponse;
  sortOrderGuide: Array<SortOrderGuideResponse>;
  sortOrderGuideCollections: Array<OrderGuideCollectionEntryResponse>;
  submitCheckDeposit: SubmitCheckDepositResponse;
  submitLoyaltyEnrollmentForm: SubmitLoyaltyEnrollmentFormResponse;
  submitLoyaltyProgramTermsDecision: SubmitLoyaltyProgramTermsDecisionResponse;
  submitOfflineOrder: SubmitOrderResponse;
  submitOrder: SubmitOrderResponse;
  submitOrderPriceEditApprovalRequest: OrderPriceEditApprovalRequestResponse;
  submitPaymentMethodDetails: SavePaymentMethodDetailsResponse;
  submitPricingPriceDraftUpdateBatch: SubmitPriceDraftBatchResponse;
  submitPricingPriceDraftUpdateBatchesForBusinessOrganization: SubmitPricingPriceDraftUpdateBatchesForBusinessOrganizationResponse;
  submitPricingRecommendationActions: SubmitPricingRecommendationActionsResponse;
  submitPricingRecommendationActionsForBusinessOrganization: SubmitPricingRecommendationActionsForBusinessOrganizationResponse;
  submitProspectiveCustomer: SuccessResponse;
  submitSampleRequestFollowUp: RequestASampleResponse;
  supplierCreateRestaurant: SupplierCreateOrUpdateRestaurantResponse;
  supplierDeactivateRestaurant: SuccessResponse;
  supplierUpdateRestaurant: SupplierCreateOrUpdateRestaurantResponse;
  unlockExpiredFtniSessions: SuccessResponse;
  updateAnalyticsAlertsActions: UpdateAnalyticsAlertsActionsResponse;
  updateAnalyticsAlertsStatuses: UpdateAnalyticsAlertsStatusResponse;
  updateAutoPaySetting: UpdateAutoPaySettingResponse;
  updateCart: MaybeOrderResponse;
  updateEmployee: EmployeeResponse;
  updateFtniPayment: SuccessResponse;
  updateHubLastVisited: UpdateHubLastVisitedResponse;
  updateOrderEntryItemRequestNote: SuccessResponse;
  updateOrderGuideCollection: OrderGuideCollectionEntryResponse;
  updateOrderGuideItemDispositions: Array<OrderGuideItemEntryResponse>;
  updateOrderGuideItemNotes: OrderGuideItemEntryResponse;
  updateOrderInputs: OrderResponse;
  updateOrderItemPriceEditForApproval: OrderItemPriceEditResponse;
  updateOrderMetadata: OrderMetadataResponse;
  updatePackagingInfo: SuccessResponse;
  updatePadPaymentMethodConsent: UpdatePadPaymentMethodConsentResponse;
  updatePaymentPlanPaymentMethod: UpdatePaymentPlanPaymentMethodResponse;
  updateSalesPortalProspectDetails: SalesPortalProspectDetails;
  updateSalesRepGrossProfitPercentageOverrides: Array<GetVariantPackInfoResponse>;
  updateSalesRepPrice: Array<GetVariantPackInfoResponse>;
  updateSearchInput: UpdateSmartOrderSearchInputResponse;
  updateSmartOrder: SuccessResponse;
  updateSmartOrderAssignee: UpdateSmartOrderAssigneeResponse;
  updateSmartOrderRegeneration: SuccessResponse;
  /** update data of the table: "businesses_employees" */
  update_businesses_employees?: Maybe<Businesses_Employees_Mutation_Response>;
  /** update single row of the table: "businesses_employees" */
  update_businesses_employees_by_pk?: Maybe<Businesses_Employees>;
  /** update multiples rows of table: "businesses_employees" */
  update_businesses_employees_many?: Maybe<Array<Maybe<Businesses_Employees_Mutation_Response>>>;
  /** update data of the table: "chats_employees" */
  update_chats_employees?: Maybe<Chats_Employees_Mutation_Response>;
  /** update single row of the table: "chats_employees" */
  update_chats_employees_by_pk?: Maybe<Chats_Employees>;
  /** update multiples rows of table: "chats_employees" */
  update_chats_employees_many?: Maybe<Array<Maybe<Chats_Employees_Mutation_Response>>>;
  /** update data of the table: "employee_contact_info" */
  update_employee_contact_info?: Maybe<Employee_Contact_Info_Mutation_Response>;
  /** update single row of the table: "employee_contact_info" */
  update_employee_contact_info_by_pk?: Maybe<Employee_Contact_Info>;
  /** update multiples rows of table: "employee_contact_info" */
  update_employee_contact_info_many?: Maybe<Array<Maybe<Employee_Contact_Info_Mutation_Response>>>;
  /** update data of the table: "employees" */
  update_employees?: Maybe<Employees_Mutation_Response>;
  /** update single row of the table: "employees" */
  update_employees_by_pk?: Maybe<Employees>;
  /** update multiples rows of table: "employees" */
  update_employees_many?: Maybe<Array<Maybe<Employees_Mutation_Response>>>;
  /** update data of the table: "menu_item_ingredient_metadata" */
  update_menu_item_ingredient_metadata?: Maybe<Menu_Item_Ingredient_Metadata_Mutation_Response>;
  /** update single row of the table: "menu_item_ingredient_metadata" */
  update_menu_item_ingredient_metadata_by_pk?: Maybe<Menu_Item_Ingredient_Metadata>;
  /** update multiples rows of table: "menu_item_ingredient_metadata" */
  update_menu_item_ingredient_metadata_many?: Maybe<Array<Maybe<Menu_Item_Ingredient_Metadata_Mutation_Response>>>;
  /** update data of the table: "menu_item_ingredients" */
  update_menu_item_ingredients?: Maybe<Menu_Item_Ingredients_Mutation_Response>;
  /** update single row of the table: "menu_item_ingredients" */
  update_menu_item_ingredients_by_pk?: Maybe<Menu_Item_Ingredients>;
  /** update multiples rows of table: "menu_item_ingredients" */
  update_menu_item_ingredients_many?: Maybe<Array<Maybe<Menu_Item_Ingredients_Mutation_Response>>>;
  /** update data of the table: "menu_items" */
  update_menu_items?: Maybe<Menu_Items_Mutation_Response>;
  /** update single row of the table: "menu_items" */
  update_menu_items_by_pk?: Maybe<Menu_Items>;
  /** update multiples rows of table: "menu_items" */
  update_menu_items_many?: Maybe<Array<Maybe<Menu_Items_Mutation_Response>>>;
  /** update data of the table: "notification_tokens" */
  update_notification_tokens?: Maybe<Notification_Tokens_Mutation_Response>;
  /** update single row of the table: "notification_tokens" */
  update_notification_tokens_by_pk?: Maybe<Notification_Tokens>;
  /** update multiples rows of table: "notification_tokens" */
  update_notification_tokens_many?: Maybe<Array<Maybe<Notification_Tokens_Mutation_Response>>>;
  /** update data of the table: "order_invoices" */
  update_order_invoices?: Maybe<Order_Invoices_Mutation_Response>;
  /** update single row of the table: "order_invoices" */
  update_order_invoices_by_pk?: Maybe<Order_Invoices>;
  /** update multiples rows of table: "order_invoices" */
  update_order_invoices_many?: Maybe<Array<Maybe<Order_Invoices_Mutation_Response>>>;
  /** update data of the table: "orders" */
  update_orders?: Maybe<Orders_Mutation_Response>;
  /** update single row of the table: "orders" */
  update_orders_by_pk?: Maybe<Orders>;
  /** update multiples rows of table: "orders" */
  update_orders_many?: Maybe<Array<Maybe<Orders_Mutation_Response>>>;
  /** update data of the table: "payment_methods" */
  update_payment_methods?: Maybe<Payment_Methods_Mutation_Response>;
  /** update single row of the table: "payment_methods" */
  update_payment_methods_by_pk?: Maybe<Payment_Methods>;
  /** update multiples rows of table: "payment_methods" */
  update_payment_methods_many?: Maybe<Array<Maybe<Payment_Methods_Mutation_Response>>>;
  /** update data of the table: "smart_order" */
  update_smart_order?: Maybe<Smart_Order_Mutation_Response>;
  /** update single row of the table: "smart_order" */
  update_smart_order_by_pk?: Maybe<Smart_Order>;
  /** update multiples rows of table: "smart_order" */
  update_smart_order_many?: Maybe<Array<Maybe<Smart_Order_Mutation_Response>>>;
  /** update data of the table: "smart_order_search_input" */
  update_smart_order_search_input?: Maybe<Smart_Order_Search_Input_Mutation_Response>;
  /** update single row of the table: "smart_order_search_input" */
  update_smart_order_search_input_by_pk?: Maybe<Smart_Order_Search_Input>;
  /** update multiples rows of table: "smart_order_search_input" */
  update_smart_order_search_input_many?: Maybe<Array<Maybe<Smart_Order_Search_Input_Mutation_Response>>>;
  /** Upsert an identifier in the override collection, replacing existing. */
  upsertIdentifier: UpsertIdentifierPayload;
  /** Upsert the profile section of an item (names, descriptions, brands, etc.). */
  upsertItemProfile: UpsertItemSectionPayload;
  /** Upsert the nutrition profile section of an item. */
  upsertNutritionProfile: UpsertItemSectionPayload;
  /** Upsert the packaging section of an item (replaces the entire packaging list). */
  upsertPackaging: UpsertItemSectionPayload;
  upsertPaymentStatementEmailSettings: CreateUpdatePaymentStatementEmailSettingsResponse;
  upsertPricingBookmarks: UpsertPricingBookmarksResponse;
  upsertPricingPriceDraftUpdates: UpsertPricingPriceDraftUpdatesResponse;
  upsertPricingPriceDraftUpdatesForBusinessOrganization: UpsertPricingPriceDraftUpdatesForBusinessOrganizationResponse;
  upsertPricingRecommendationsStatusForBusinessOrganization: UpsertPricingRecommendationsStatusForBusinessOrganizationResponse;
  upsertPrintTagBatchForRestaurant: PrintTagBatchResponse;
  /** Upsert the product usage information section of an item. */
  upsertProductUsageInformation: UpsertItemSectionPayload;
  upsertRestaurantVariantPackSubscription: RestaurantVariantPackSubscriptionResponse;
  upsertVariantPackRestaurantRetailPrice: SuccessResponse;
  validateOrder: ValidateOrderResponse;
  viewMessage: SuccessResponse;
};


/** mutation root */
export type Mutation_RootAddMenuItemIngredientArgs = {
  manual_ingredient?: InputMaybe<ManualIngredientFields>;
  menu_item_id: Scalars['uuid']['input'];
  menu_item_ingredient_id?: InputMaybe<Scalars['uuid']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_cost_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  variant_pack_id?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootAddMessageToChatArgs = {
  chat_id: Scalars['uuid']['input'];
  media_content_url?: InputMaybe<Scalars['String']['input']>;
  text_content?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootAddMessageToChatFromRestaurantEmployeeArgs = {
  chat_id: Scalars['uuid']['input'];
  media_content_url?: InputMaybe<Scalars['String']['input']>;
  text_content?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootAddSmartOrderItemArgs = {
  quantity?: InputMaybe<Scalars['Int']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  search_term: Scalars['String']['input'];
  smart_order_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootApplyPromotionsArgs = {
  discount_codes: Array<Scalars['String']['input']>;
  order_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootApproveOrderPriceEditApprovalRequestArgs = {
  additional_input_values?: InputMaybe<Array<AdditionalInputValueInput>>;
  approval_request_id: Scalars['uuid']['input'];
  order_id: Scalars['uuid']['input'];
  order_notes?: InputMaybe<Scalars['String']['input']>;
  po_number?: InputMaybe<Scalars['String']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootAssignPrintTagBatchPlanogramsArgs = {
  planogram_ids: Array<Scalars['uuid']['input']>;
  print_tag_batch_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootAssignSmartOrderArgs = {
  assign_to_employee_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  smart_order_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootBulkCreateMediaArgs = {
  input: BulkCreateMediaInput;
};


/** mutation root */
export type Mutation_RootCancelPaymentPlanArgs = {
  payment_plan_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootCheckInOrderInvoiceItemsArgs = {
  order_invoice_check_in_id: Scalars['uuid']['input'];
  order_invoice_check_in_items: Array<CheckInOrderInvoiceItemQuantityInput>;
};


/** mutation root */
export type Mutation_RootClearCartArgs = {
  order_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootClearItemSubstitutionArgs = {
  order_id: Scalars['uuid']['input'];
  source_variant_pack_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootCompleteOrderInvoiceCheckInArgs = {
  order_invoice_check_in_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootConfirmKlarnaPaymentArgs = {
  klarna_payment_data?: InputMaybe<Scalars['String']['input']>;
  klarna_payment_details: Scalars['String']['input'];
  payment_batch_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootCopyRestaurantOrderArgs = {
  restaurant_id: Scalars['uuid']['input'];
  source_order_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  target_restaurant_ids: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootCreateActivityReminderArgs = {
  activity_id: Scalars['uuid']['input'];
  chat_id: Scalars['uuid']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  remind_at: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateAutoPaySettingArgs = {
  auto_pay_setting: AutoPaySettingV2Input;
  chat_ids: Array<Scalars['uuid']['input']>;
  payment_group_ids: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootCreateCreditRequestArgs = {
  chat_id: Scalars['uuid']['input'];
  credit_request_batch_line_items: Array<CreditRequestBatchLineItemInput>;
};


/** mutation root */
export type Mutation_RootCreateCriticalItemsArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id_list: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootCreateCrmActivityArgs = {
  chat_id: Scalars['uuid']['input'];
  check_in?: InputMaybe<CrmActivityCheckInInput>;
  note?: InputMaybe<CrmActivityNoteInput>;
  reminder?: InputMaybe<CrmActivityReminderInput>;
};


/** mutation root */
export type Mutation_RootCreateDefaultOrderGuideRecordsArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootCreateFtniPaymentSessionArgs = {
  order_invoice_ids: Array<Scalars['uuid']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootCreateGhostExecutionLogArgs = {
  conversation_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  stringified_metadata_json: Scalars['String']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootCreateGhostMessageArgs = {
  content: Scalars['String']['input'];
  conversation_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  type: GhostMessageType;
};


/** mutation root */
export type Mutation_RootCreateMediaArgs = {
  input: CreateMediaInput;
};


/** mutation root */
export type Mutation_RootCreateMobileTerminalPaymentRequestArgs = {
  credit_memos: Array<CreateMobileTerminalPaymentCreditMemoInput>;
  credit_request_batch_line_items?: InputMaybe<Array<CreditRequestBatchLineItemInput>>;
  installation_id: Scalars['String']['input'];
  invoices: Array<CreateMobileTerminalPaymentInvoiceInput>;
  memo_notes?: InputMaybe<Scalars['String']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootCreateNoteActivityArgs = {
  chat_id: Scalars['uuid']['input'];
  note_content: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateOrderArgs = {
  created_source?: InputMaybe<OrderSource>;
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  fulfillment_timeslot_end?: InputMaybe<Scalars['String']['input']>;
  fulfillment_timeslot_start?: InputMaybe<Scalars['String']['input']>;
  fulfillment_type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_domain?: InputMaybe<OrderDomain>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  visibility?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootCreateOrderGuideCollectionArgs = {
  name: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootCreateOrderGuideFromGeneratedMenuItemsArgs = {
  items: Array<MenuItemInput>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootCreateOrderGuideFromMenuArgs = {
  restaurant_id: Scalars['uuid']['input'];
  similarity_match_threshold?: InputMaybe<Scalars['Int']['input']>;
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootCreateOrderGuidePartitionArgs = {
  collection_id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootCreateOrderGuidePartitionItemArgs = {
  is_request?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  par_level?: InputMaybe<Scalars['Float']['input']>;
  partition_id: Scalars['uuid']['input'];
  persist_notes?: InputMaybe<Scalars['Boolean']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootCreateOrderInvoiceCheckInItemIssueArgs = {
  order_invoice_check_in_id: Scalars['uuid']['input'];
  order_invoice_check_in_item_id: Scalars['uuid']['input'];
  quantity: Scalars['Int']['input'];
  status: OrderInvoiceCheckInItemStatus;
};


/** mutation root */
export type Mutation_RootCreateOverrideArgs = {
  input: CreateOverrideInput;
};


/** mutation root */
export type Mutation_RootCreatePaymentPlanArgs = {
  installment_amount_in_micros: Scalars['bigint']['input'];
  order_invoice_ids?: InputMaybe<Array<Scalars['uuid']['input']>>;
  payment_method_id?: InputMaybe<Scalars['uuid']['input']>;
  requires_acceptance?: InputMaybe<Scalars['Boolean']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  start_date: Scalars['String']['input'];
  supplier_id: Scalars['uuid']['input'];
  task_frequency_settings: TaskFrequencySettingsInput;
  total_amount_in_micros: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootCreatePriceQuoteFromVariantPacksArgs = {
  chat_id: Scalars['uuid']['input'];
  variant_pack_ids: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootCreateSalesAnalyticsAlertActionArgs = {
  action_type: AnalyticsAlertActionType;
  analytics_alert_id: Scalars['uuid']['input'];
  chat_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootCreateSearchTermCorrectionArgs = {
  old_search_term_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  smart_order_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootCreateUpdateAutoPaySettingsArgs = {
  auto_pay_settings: AutoPaySettingInput;
  chat_id_list?: InputMaybe<Array<Scalars['uuid']['input']>>;
};


/** mutation root */
export type Mutation_RootDeleteAutoPaySettingArgs = {
  id_list: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootDeleteAutoPaySettingV2Args = {
  auto_pay_setting_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteCriticalItemsArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id_list: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootDeleteIdentifierArgs = {
  input: DeleteIdentifierInput;
};


/** mutation root */
export type Mutation_RootDeleteMediaArgs = {
  input: DeleteMediaInput;
};


/** mutation root */
export type Mutation_RootDeleteMenuItemArgs = {
  menu_item_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteOrderArgs = {
  order_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteOrderGuideCollectionArgs = {
  collection_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteOrderGuidePartitionItemArgs = {
  partition_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteOrderInvoiceCheckInItemIssueArgs = {
  order_invoice_check_in_id: Scalars['uuid']['input'];
  order_invoice_check_in_item_issue_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeletePaymentStatementEmailSettingsArgs = {
  payment_statement_email_settings_ids: Array<Scalars['uuid']['input']>;
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeletePriceQuoteArgs = {
  chat_id: Scalars['uuid']['input'];
  price_quote_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeletePricingBookmarksArgs = {
  entries: Array<DeletePricingBookmarkEntryInput>;
};


/** mutation root */
export type Mutation_RootDeletePrintTagBatchesForRestaurantArgs = {
  print_tag_batch_ids: Array<Scalars['uuid']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRestaurantVariantPackSubscriptionArgs = {
  restaurant_id: Scalars['uuid']['input'];
  restaurant_variant_pack_subscription_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Menu_Item_Ingredient_MetadataArgs = {
  where: Menu_Item_Ingredient_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Menu_Item_Ingredient_Metadata_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Menu_Item_IngredientsArgs = {
  where: Menu_Item_Ingredients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Menu_Item_Ingredients_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Order_GuideArgs = {
  where: Order_Guide_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Guide_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDepositManualPaymentsArgs = {
  deposit_number: Scalars['String']['input'];
  employee_id: Scalars['uuid']['input'];
  payment_batches: Array<ManualDepositPaymentBatchInput>;
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDuplicateMenuItemArgs = {
  menu_item_id: Scalars['uuid']['input'];
  menu_item_name: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDuplicateOrderGuideCollectionArgs = {
  collection_id: Scalars['uuid']['input'];
  new_collection_name: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
  should_duplicate_par_levels: Scalars['Boolean']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootEditMenuItemIngredientArgs = {
  ingredient_fields: EditIngredientFields;
  menu_item_ingredient_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootEstablishMobileTerminalSessionArgs = {
  setup_token: Scalars['String']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootExportPriceQuoteArgs = {
  chat_id: Scalars['uuid']['input'];
  file_format: ExportFileFormat;
  price_quote_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootGeneratePaymentLinkArgs = {
  credit_memo_amounts?: InputMaybe<Array<CreditMemoAmountInput>>;
  credit_memo_ids?: InputMaybe<Array<Scalars['uuid']['input']>>;
  credit_memos_to_create?: InputMaybe<Array<CreditMemoToCreateInput>>;
  order_invoice_amounts?: InputMaybe<Array<OrderInvoiceAmountInput>>;
  order_invoice_ids?: InputMaybe<Array<Scalars['uuid']['input']>>;
  order_invoices_to_create?: InputMaybe<Array<OrderInvoiceToCreateInput>>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootGeneratePaymentStatementLinkArgs = {
  employee_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootGetGhostConversationArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootGetSmartOrderHistoryArgs = {
  employee_id?: InputMaybe<Scalars['uuid']['input']>;
  item_names?: InputMaybe<Array<Scalars['String']['input']>>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootGrantSmartOrderRestaurantAccessArgs = {
  employee_id: Scalars['uuid']['input'];
  smart_order_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootHandleSmartOrderErrorArgs = {
  message: Scalars['String']['input'];
  smart_order_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInitiateKlarnaPaymentArgs = {
  credit_memos: Array<CreditMemoInput>;
  fees_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  invoices: Array<InvoiceInput>;
  payment_method: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
  return_url?: InputMaybe<Scalars['String']['input']>;
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsert_Menu_ItemsArgs = {
  objects: Array<Menu_Items_Insert_Input>;
  on_conflict?: InputMaybe<Menu_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Menu_Items_OneArgs = {
  object: Menu_Items_Insert_Input;
  on_conflict?: InputMaybe<Menu_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_TokensArgs = {
  objects: Array<Notification_Tokens_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Tokens_OneArgs = {
  object: Notification_Tokens_Insert_Input;
  on_conflict?: InputMaybe<Notification_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_GuideArgs = {
  objects: Array<Order_Guide_Insert_Input>;
  on_conflict?: InputMaybe<Order_Guide_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Guide_OneArgs = {
  object: Order_Guide_Insert_Input;
  on_conflict?: InputMaybe<Order_Guide_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInviteRestaurantEmployeeArgs = {
  contact_info: ContactInfoInput;
  employee_role?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootMakePartialPaymentWithCreditRequestArgs = {
  chat_id: Scalars['uuid']['input'];
  credit_memos?: InputMaybe<Array<PartialPaymentCreditMemoInput>>;
  credit_request_batch_line_items: Array<CreditRequestBatchLineItemInput>;
  fees?: InputMaybe<Array<PaymentBatchFeeInput>>;
  invoices: Array<PartialPaymentInvoiceInput>;
  memo?: InputMaybe<Scalars['String']['input']>;
  payment_method: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootMakePaymentArgs = {
  batches: Array<MakePaymentBatchInput>;
  payee_id?: InputMaybe<Scalars['uuid']['input']>;
  payor_id?: InputMaybe<Scalars['uuid']['input']>;
  restaurant_id?: InputMaybe<Scalars['uuid']['input']>;
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootMarkCreditMemoAsClaimedArgs = {
  credit_memo_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootMarkOrderInvoiceAsPaidArgs = {
  order_invoice_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootMemorizeSmartOrderArgs = {
  restaurant_id: Scalars['uuid']['input'];
  smart_order_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootPauseRestaurantVariantPackSubscriptionArgs = {
  restaurant_id: Scalars['uuid']['input'];
  restaurant_variant_pack_subscription_id: Scalars['uuid']['input'];
  resume_at: Scalars['String']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootPlaidCreatePaymentMethodArgs = {
  accounts: Array<Scalars['String']['input']>;
  institution_name?: InputMaybe<Scalars['String']['input']>;
  public_token: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
  session_token: Scalars['String']['input'];
  supplier_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootPlaidCreateSessionArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootPrepareCheckCaptureArgs = {
  chat_id: Scalars['uuid']['input'];
  device_tracking: DeviceTrackingHasuraInput;
  restaurant_id?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootProcessMobileTerminalResponseArgs = {
  credit_request_batch_line_items?: InputMaybe<Array<CreditRequestBatchLineItemInput>>;
  data: Scalars['String']['input'];
  payment_batch_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootRateOrderArgs = {
  order_item_ratings: Array<OrderItemRatingInput>;
};


/** mutation root */
export type Mutation_RootRecordCashPaymentArgs = {
  credit_memos?: InputMaybe<Array<PartialPaymentCreditMemoInput>>;
  credit_request_batch_line_items?: InputMaybe<Array<CreditRequestBatchLineItemInput>>;
  invoices: Array<PartialPaymentInvoiceInput>;
  memo?: InputMaybe<Scalars['String']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootRecordCheckPaymentArgs = {
  check_number: Scalars['String']['input'];
  credit_memos?: InputMaybe<Array<PartialPaymentCreditMemoInput>>;
  credit_request_batch_line_items?: InputMaybe<Array<CreditRequestBatchLineItemInput>>;
  invoices: Array<PartialPaymentInvoiceInput>;
  memo?: InputMaybe<Scalars['String']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootRecoverLoginArgs = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  business_address?: InputMaybe<Scalars['String']['input']>;
  business_name: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootRegenerateSmartOrderArgs = {
  restaurant_id: Scalars['uuid']['input'];
  smart_order_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootRegenerateSmartOrdersArgs = {
  restaurant_id: Scalars['uuid']['input'];
  smart_order_ids: Array<Scalars['uuid']['input']>;
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootRejectOrderPriceEditApprovalRequestArgs = {
  approval_request_id: Scalars['uuid']['input'];
  order_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootRemoveEmployeeFromBusinessArgs = {
  business_id: Scalars['uuid']['input'];
  employee_id: Scalars['uuid']['input'];
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootRemovePaymentMethodArgs = {
  payment_method_id: Scalars['uuid']['input'];
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootRemoveRestaurantVariantPackSubscriptionPauseArgs = {
  restaurant_id: Scalars['uuid']['input'];
  restaurant_variant_pack_subscription_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootRemoveSelfFromChatsArgs = {
  business_organization_id: Scalars['uuid']['input'];
  employee_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootReorderArgs = {
  created_source?: InputMaybe<OrderSource>;
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  fulfillment_timeslot_end?: InputMaybe<Scalars['String']['input']>;
  fulfillment_timeslot_start?: InputMaybe<Scalars['String']['input']>;
  fulfillment_type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_domain?: InputMaybe<OrderDomain>;
  previous_order_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  visibility?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootReorderMediaArgs = {
  input: ReorderMediaInput;
};


/** mutation root */
export type Mutation_RootRepublishPricingRecommendationActionsForBusinessOrganizationArgs = {
  actions: Array<PricingRecommendationActionInput>;
};


/** mutation root */
export type Mutation_RootRequestASampleArgs = {
  ad_campaign_id: Scalars['uuid']['input'];
  contact_info?: InputMaybe<RequestContactInfo>;
  form_submit_event_payload?: InputMaybe<AdEventInput>;
  qualification_responses?: InputMaybe<Array<QualificationResponse>>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootRequestPrintTagBatchDeliveryArgs = {
  print_tag_batch_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootResendPayByLinkArgs = {
  payment_batch_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootRestaurantEmployeeLoginArgs = {
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootRestaurantEmployeeLogoutArgs = {
  business_organization_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootRetrieveOrderInvoiceCheckInItemsArgs = {
  order_invoice_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSalesPortalCopilotSendMessageArgs = {
  session_id?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSavePadPaymentMethodWithConsentArgs = {
  account_type: Scalars['String']['input'];
  consent_city: Scalars['String']['input'];
  consent_email: Scalars['String']['input'];
  consent_employee_name: Scalars['String']['input'];
  consent_phone_number: Scalars['String']['input'];
  consent_postal_code: Scalars['String']['input'];
  consent_province: Scalars['String']['input'];
  consent_street_address: Scalars['String']['input'];
  payment_method: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSavePaymentMethodArgs = {
  payee_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_method: Scalars['String']['input'];
  payor_id?: InputMaybe<Scalars['uuid']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootSavePriceQuoteArgs = {
  chat_id: Scalars['uuid']['input'];
  competitor_name?: InputMaybe<Scalars['String']['input']>;
  line_items: Array<SavePriceQuoteLineItemInput>;
  name: Scalars['String']['input'];
  price_quote_id?: InputMaybe<Scalars['uuid']['input']>;
  quote_type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSaveSalesPortalCartArgs = {
  cart: SalesPortalCartInput;
  validate_post_save?: InputMaybe<Scalars['Boolean']['input']>;
};


/** mutation root */
export type Mutation_RootSelectAutoPaySettingsArgs = {
  auto_pay_settings_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSendChatbotMessageArgs = {
  restaurant_id: Scalars['uuid']['input'];
  session_id?: InputMaybe<Scalars['String']['input']>;
  supplier_id: Scalars['uuid']['input'];
  text: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSendPayByLinkArgs = {
  credit_amount_in_micros_string?: InputMaybe<Scalars['String']['input']>;
  fees?: InputMaybe<Array<PaymentBatchFeeInput>>;
  invoices: Array<MakePaymentInvoiceInput>;
  memo?: InputMaybe<Scalars['String']['input']>;
  paid_source: PaidSource;
  payment_due_at: Scalars['String']['input'];
  payor_id?: InputMaybe<Scalars['uuid']['input']>;
  recipients: Array<SendPayByLinkRecipients>;
  restaurant_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSendPaymentLinkArgs = {
  sends: Array<RestaurantPaymentLinkSendInput>;
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSendPricingRulesWritebackArgs = {
  business_organization_id: Scalars['uuid']['input'];
  restaurant_ids: Array<Scalars['uuid']['input']>;
  supplier_id: Scalars['uuid']['input'];
  variant_pack_ids: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootSetActiveOrderArgs = {
  chat_id: Scalars['uuid']['input'];
  order_id?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootSetItemSubstitutionArgs = {
  action: Scalars['String']['input'];
  order_id: Scalars['uuid']['input'];
  source_variant_pack_id: Scalars['uuid']['input'];
  substitution_entries: Array<SubstitutionEntryInput>;
};


/** mutation root */
export type Mutation_RootSetOrderGuideCollectionArgs = {
  collection_id: Scalars['uuid']['input'];
  collection_name?: InputMaybe<Scalars['String']['input']>;
  partitions: Array<SetOrderGuideCollectionPartitionInput>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSetupAppArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSkipNextRestaurantVariantPackSubscriptionArgs = {
  restaurant_id: Scalars['uuid']['input'];
  restaurant_variant_pack_subscription_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSortOrderGuideArgs = {
  restaurant_id: Scalars['uuid']['input'];
  sorted_order_guide_id_list: Array<Scalars['uuid']['input']>;
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootSortOrderGuideCollectionsArgs = {
  restaurant_id: Scalars['uuid']['input'];
  sorted_order_guide_collection_id_list: Array<Scalars['uuid']['input']>;
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSubmitCheckDepositArgs = {
  chat_id: Scalars['uuid']['input'];
  credit_memos: Array<SubmitCheckDepositCreditMemoInput>;
  credit_request_batch_line_items?: InputMaybe<Array<CreditRequestBatchLineItemInput>>;
  device_tracking: DeviceTrackingHasuraInput;
  front_s3_key: Scalars['String']['input'];
  invoices: Array<SubmitCheckDepositInvoiceInput>;
  memo_notes: Scalars['String']['input'];
  rear_s3_key: Scalars['String']['input'];
  restaurant_id?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootSubmitLoyaltyEnrollmentFormArgs = {
  responses: Array<LoyaltyEnrollmentFormResponseInput>;
  supplier_loyalty_program_restaurant_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSubmitLoyaltyProgramTermsDecisionArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  is_accepted: Scalars['Boolean']['input'];
  loyalty_program_terms_id: Scalars['uuid']['input'];
  supplier_loyalty_program_restaurant_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSubmitOfflineOrderArgs = {
  additional_input_values?: InputMaybe<Array<AdditionalInputValueInput>>;
  created_source?: InputMaybe<OrderSource>;
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  fulfillment_timeslot_end?: InputMaybe<Scalars['String']['input']>;
  fulfillment_timeslot_start?: InputMaybe<Scalars['String']['input']>;
  fulfillment_type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_domain?: InputMaybe<OrderDomain>;
  order_items: Array<UpdateItemInput>;
  order_notes?: InputMaybe<Scalars['String']['input']>;
  po_number?: InputMaybe<Scalars['String']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  visibility?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootSubmitOrderArgs = {
  additional_input_values?: InputMaybe<Array<AdditionalInputValueInput>>;
  order_id: Scalars['uuid']['input'];
  order_notes?: InputMaybe<Scalars['String']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  po_number?: InputMaybe<Scalars['String']['input']>;
  punchout_cookie?: InputMaybe<Scalars['String']['input']>;
  smart_order_id?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootSubmitOrderPriceEditApprovalRequestArgs = {
  order_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSubmitPaymentMethodDetailsArgs = {
  challenge_result: Scalars['String']['input'];
  payee_id: Scalars['uuid']['input'];
  payor_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSubmitPricingPriceDraftUpdateBatchArgs = {
  pricing_price_draft_update_batch_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSubmitPricingRecommendationActionsArgs = {
  actions: Array<PricingRecommendationActionInput>;
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSubmitPricingRecommendationActionsForBusinessOrganizationArgs = {
  actions: Array<PricingRecommendationActionInput>;
};


/** mutation root */
export type Mutation_RootSubmitProspectiveCustomerArgs = {
  contact_email: Scalars['String']['input'];
  contact_name: Scalars['String']['input'];
  contact_phone_number: Scalars['String']['input'];
  restaurant_address: Scalars['String']['input'];
  restaurant_name: Scalars['String']['input'];
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootSubmitSampleRequestFollowUpArgs = {
  follow_up_response?: InputMaybe<FollowUpResponse>;
  restaurant_id: Scalars['uuid']['input'];
  sample_request_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSupplierCreateRestaurantArgs = {
  creation_source_feature?: InputMaybe<CreationSourceFeatures>;
  restaurant_account_id?: InputMaybe<Scalars['String']['input']>;
  restaurant_address: Scalars['String']['input'];
  restaurant_address2?: InputMaybe<Scalars['String']['input']>;
  restaurant_metadata?: InputMaybe<RestaurantMetadataInput>;
  restaurant_name: Scalars['String']['input'];
  restaurant_notes?: InputMaybe<Scalars['String']['input']>;
  route_stop?: InputMaybe<Scalars['String']['input']>;
  set_as_prospect?: InputMaybe<Scalars['Boolean']['input']>;
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSupplierDeactivateRestaurantArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSupplierUpdateRestaurantArgs = {
  restaurant_account_id?: InputMaybe<Scalars['String']['input']>;
  restaurant_address?: InputMaybe<Scalars['String']['input']>;
  restaurant_address2?: InputMaybe<Scalars['String']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  restaurant_name?: InputMaybe<Scalars['String']['input']>;
  restaurant_notes?: InputMaybe<Scalars['String']['input']>;
  route_stop?: InputMaybe<Scalars['String']['input']>;
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUnlockExpiredFtniSessionsArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdateAnalyticsAlertsActionsArgs = {
  alert_action: AnalyticsAlertActionType;
  alert_ids: Array<Scalars['uuid']['input']>;
  chat_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdateAnalyticsAlertsStatusesArgs = {
  alert_ids: Array<Scalars['uuid']['input']>;
  alert_status: AnalyticsAlertStatusType;
  business_organization_id?: InputMaybe<Scalars['uuid']['input']>;
  chat_id?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootUpdateAutoPaySettingArgs = {
  auto_pay_setting: AutoPaySettingV2Input;
  auto_pay_setting_id: Scalars['uuid']['input'];
  chat_ids: Array<Scalars['uuid']['input']>;
  payment_group_ids: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootUpdateCartArgs = {
  order_id: Scalars['uuid']['input'];
  updated_items: Array<UpdateItemInput>;
};


/** mutation root */
export type Mutation_RootUpdateEmployeeArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  employee_id: Scalars['uuid']['input'];
  login_email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootUpdateFtniPaymentArgs = {
  order_invoice_ids: Array<Scalars['uuid']['input']>;
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdateOrderEntryItemRequestNoteArgs = {
  collection_id: Scalars['uuid']['input'];
  persist_request: Scalars['Boolean']['input'];
  request?: InputMaybe<Scalars['String']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdateOrderGuideCollectionArgs = {
  collection_id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdateOrderGuideItemDispositionsArgs = {
  order_guide_items: Array<UpdateOrderGuideItemDispositionsItemInput>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdateOrderGuideItemNotesArgs = {
  is_request?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  order_guide_item_id?: InputMaybe<Scalars['uuid']['input']>;
  partition_id?: InputMaybe<Scalars['uuid']['input']>;
  persist_notes?: InputMaybe<Scalars['Boolean']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootUpdateOrderInputsArgs = {
  additional_input_values?: InputMaybe<Array<AdditionalInputValueInput>>;
  order_id: Scalars['uuid']['input'];
  order_notes?: InputMaybe<Scalars['String']['input']>;
  po_number?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootUpdateOrderItemPriceEditForApprovalArgs = {
  delivery_date: Scalars['String']['input'];
  gross_profit_in_percentage?: InputMaybe<Scalars['String']['input']>;
  order_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  sales_rep_price_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdateOrderMetadataArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  order_id: Scalars['uuid']['input'];
  visibility?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootUpdatePackagingInfoArgs = {
  packaging_info_results: Array<PackagingInfoResult>;
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdatePadPaymentMethodConsentArgs = {
  account_type: Scalars['String']['input'];
  consent_city: Scalars['String']['input'];
  consent_email: Scalars['String']['input'];
  consent_employee_name: Scalars['String']['input'];
  consent_phone_number: Scalars['String']['input'];
  consent_postal_code: Scalars['String']['input'];
  consent_province: Scalars['String']['input'];
  consent_street_address: Scalars['String']['input'];
  payment_method_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdatePaymentPlanPaymentMethodArgs = {
  payment_method: Scalars['String']['input'];
  payment_plan_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdateSalesPortalProspectDetailsArgs = {
  prospect_details: ProspectDetailsUpdateInput;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdateSalesRepGrossProfitPercentageOverridesArgs = {
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  expiration_date?: InputMaybe<Scalars['String']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  update_source?: InputMaybe<PricingPriceUpdateSource>;
  variant_packs: Array<SalesRepUpdateVariantPackGrossProfitInput>;
};


/** mutation root */
export type Mutation_RootUpdateSalesRepPriceArgs = {
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  expiration_date?: InputMaybe<Scalars['String']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  update_source?: InputMaybe<PricingPriceUpdateSource>;
  variant_packs: Array<SalesRepUpdateVariantPackInput>;
};


/** mutation root */
export type Mutation_RootUpdateSearchInputArgs = {
  new_search_term: Scalars['String']['input'];
  new_variant_pack_id: Scalars['uuid']['input'];
  recalculate_quantity?: InputMaybe<Scalars['Boolean']['input']>;
  remember?: InputMaybe<Scalars['Boolean']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  smart_order_search_input_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdateSmartOrderArgs = {
  parse_results: Array<ParsedSmartOrder>;
  signature_match_provenance?: InputMaybe<Array<SignatureMatchProvenanceInput>>;
  smart_order_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdateSmartOrderAssigneeArgs = {
  employee_id?: InputMaybe<Scalars['uuid']['input']>;
  smart_order_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdateSmartOrderRegenerationArgs = {
  final_results: Array<FinalizedSmartOrderResult>;
  restaurant_id: Scalars['uuid']['input'];
  smart_order_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdate_Businesses_EmployeesArgs = {
  _set?: InputMaybe<Businesses_Employees_Set_Input>;
  where: Businesses_Employees_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Businesses_Employees_By_PkArgs = {
  _set?: InputMaybe<Businesses_Employees_Set_Input>;
  pk_columns: Businesses_Employees_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Businesses_Employees_ManyArgs = {
  updates: Array<Businesses_Employees_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Chats_EmployeesArgs = {
  _set?: InputMaybe<Chats_Employees_Set_Input>;
  where: Chats_Employees_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Chats_Employees_By_PkArgs = {
  _set?: InputMaybe<Chats_Employees_Set_Input>;
  pk_columns: Chats_Employees_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Chats_Employees_ManyArgs = {
  updates: Array<Chats_Employees_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Employee_Contact_InfoArgs = {
  _append?: InputMaybe<Employee_Contact_Info_Append_Input>;
  _delete_at_path?: InputMaybe<Employee_Contact_Info_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Employee_Contact_Info_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Employee_Contact_Info_Delete_Key_Input>;
  _prepend?: InputMaybe<Employee_Contact_Info_Prepend_Input>;
  _set?: InputMaybe<Employee_Contact_Info_Set_Input>;
  where: Employee_Contact_Info_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Employee_Contact_Info_By_PkArgs = {
  _append?: InputMaybe<Employee_Contact_Info_Append_Input>;
  _delete_at_path?: InputMaybe<Employee_Contact_Info_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Employee_Contact_Info_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Employee_Contact_Info_Delete_Key_Input>;
  _prepend?: InputMaybe<Employee_Contact_Info_Prepend_Input>;
  _set?: InputMaybe<Employee_Contact_Info_Set_Input>;
  pk_columns: Employee_Contact_Info_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Employee_Contact_Info_ManyArgs = {
  updates: Array<Employee_Contact_Info_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EmployeesArgs = {
  _set?: InputMaybe<Employees_Set_Input>;
  where: Employees_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Employees_By_PkArgs = {
  _set?: InputMaybe<Employees_Set_Input>;
  pk_columns: Employees_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Employees_ManyArgs = {
  updates: Array<Employees_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Menu_Item_Ingredient_MetadataArgs = {
  _append?: InputMaybe<Menu_Item_Ingredient_Metadata_Append_Input>;
  _delete_at_path?: InputMaybe<Menu_Item_Ingredient_Metadata_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Menu_Item_Ingredient_Metadata_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Menu_Item_Ingredient_Metadata_Delete_Key_Input>;
  _prepend?: InputMaybe<Menu_Item_Ingredient_Metadata_Prepend_Input>;
  _set?: InputMaybe<Menu_Item_Ingredient_Metadata_Set_Input>;
  where: Menu_Item_Ingredient_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Menu_Item_Ingredient_Metadata_By_PkArgs = {
  _append?: InputMaybe<Menu_Item_Ingredient_Metadata_Append_Input>;
  _delete_at_path?: InputMaybe<Menu_Item_Ingredient_Metadata_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Menu_Item_Ingredient_Metadata_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Menu_Item_Ingredient_Metadata_Delete_Key_Input>;
  _prepend?: InputMaybe<Menu_Item_Ingredient_Metadata_Prepend_Input>;
  _set?: InputMaybe<Menu_Item_Ingredient_Metadata_Set_Input>;
  pk_columns: Menu_Item_Ingredient_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Menu_Item_Ingredient_Metadata_ManyArgs = {
  updates: Array<Menu_Item_Ingredient_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Menu_Item_IngredientsArgs = {
  _append?: InputMaybe<Menu_Item_Ingredients_Append_Input>;
  _delete_at_path?: InputMaybe<Menu_Item_Ingredients_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Menu_Item_Ingredients_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Menu_Item_Ingredients_Delete_Key_Input>;
  _inc?: InputMaybe<Menu_Item_Ingredients_Inc_Input>;
  _prepend?: InputMaybe<Menu_Item_Ingredients_Prepend_Input>;
  _set?: InputMaybe<Menu_Item_Ingredients_Set_Input>;
  where: Menu_Item_Ingredients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Menu_Item_Ingredients_By_PkArgs = {
  _append?: InputMaybe<Menu_Item_Ingredients_Append_Input>;
  _delete_at_path?: InputMaybe<Menu_Item_Ingredients_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Menu_Item_Ingredients_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Menu_Item_Ingredients_Delete_Key_Input>;
  _inc?: InputMaybe<Menu_Item_Ingredients_Inc_Input>;
  _prepend?: InputMaybe<Menu_Item_Ingredients_Prepend_Input>;
  _set?: InputMaybe<Menu_Item_Ingredients_Set_Input>;
  pk_columns: Menu_Item_Ingredients_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Menu_Item_Ingredients_ManyArgs = {
  updates: Array<Menu_Item_Ingredients_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Menu_ItemsArgs = {
  _inc?: InputMaybe<Menu_Items_Inc_Input>;
  _set?: InputMaybe<Menu_Items_Set_Input>;
  where: Menu_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Menu_Items_By_PkArgs = {
  _inc?: InputMaybe<Menu_Items_Inc_Input>;
  _set?: InputMaybe<Menu_Items_Set_Input>;
  pk_columns: Menu_Items_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Menu_Items_ManyArgs = {
  updates: Array<Menu_Items_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_TokensArgs = {
  _set?: InputMaybe<Notification_Tokens_Set_Input>;
  where: Notification_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Tokens_By_PkArgs = {
  _set?: InputMaybe<Notification_Tokens_Set_Input>;
  pk_columns: Notification_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Tokens_ManyArgs = {
  updates: Array<Notification_Tokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_InvoicesArgs = {
  _set?: InputMaybe<Order_Invoices_Set_Input>;
  where: Order_Invoices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Invoices_By_PkArgs = {
  _set?: InputMaybe<Order_Invoices_Set_Input>;
  pk_columns: Order_Invoices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Invoices_ManyArgs = {
  updates: Array<Order_Invoices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrdersArgs = {
  _set?: InputMaybe<Orders_Set_Input>;
  where: Orders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Orders_By_PkArgs = {
  _set?: InputMaybe<Orders_Set_Input>;
  pk_columns: Orders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Orders_ManyArgs = {
  updates: Array<Orders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_MethodsArgs = {
  _set?: InputMaybe<Payment_Methods_Set_Input>;
  where: Payment_Methods_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Methods_By_PkArgs = {
  _set?: InputMaybe<Payment_Methods_Set_Input>;
  pk_columns: Payment_Methods_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Methods_ManyArgs = {
  updates: Array<Payment_Methods_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_OrderArgs = {
  _inc?: InputMaybe<Smart_Order_Inc_Input>;
  _set?: InputMaybe<Smart_Order_Set_Input>;
  where: Smart_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Order_By_PkArgs = {
  _inc?: InputMaybe<Smart_Order_Inc_Input>;
  _set?: InputMaybe<Smart_Order_Set_Input>;
  pk_columns: Smart_Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Order_ManyArgs = {
  updates: Array<Smart_Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Order_Search_InputArgs = {
  _inc?: InputMaybe<Smart_Order_Search_Input_Inc_Input>;
  _set?: InputMaybe<Smart_Order_Search_Input_Set_Input>;
  where: Smart_Order_Search_Input_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Order_Search_Input_By_PkArgs = {
  _inc?: InputMaybe<Smart_Order_Search_Input_Inc_Input>;
  _set?: InputMaybe<Smart_Order_Search_Input_Set_Input>;
  pk_columns: Smart_Order_Search_Input_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Order_Search_Input_ManyArgs = {
  updates: Array<Smart_Order_Search_Input_Updates>;
};


/** mutation root */
export type Mutation_RootUpsertIdentifierArgs = {
  input: UpsertIdentifierInput;
};


/** mutation root */
export type Mutation_RootUpsertItemProfileArgs = {
  input: UpsertItemProfileInput;
};


/** mutation root */
export type Mutation_RootUpsertNutritionProfileArgs = {
  input: UpsertNutritionProfileInput;
};


/** mutation root */
export type Mutation_RootUpsertPackagingArgs = {
  input: UpsertPackagingInput;
};


/** mutation root */
export type Mutation_RootUpsertPaymentStatementEmailSettingsArgs = {
  chat_id_list?: InputMaybe<Array<Scalars['uuid']['input']>>;
  payment_statement_email_settings: PaymentStatementEmailSettingsInput;
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpsertPricingBookmarksArgs = {
  entries: Array<UpsertPricingBookmarkEntryInput>;
};


/** mutation root */
export type Mutation_RootUpsertPricingPriceDraftUpdatesArgs = {
  supplier_id: Scalars['uuid']['input'];
  variant_packs: Array<UpsertPriceDraftInput>;
};


/** mutation root */
export type Mutation_RootUpsertPricingPriceDraftUpdatesForBusinessOrganizationArgs = {
  variant_packs: Array<UpsertPriceDraftForBusinessOrganizationInput>;
};


/** mutation root */
export type Mutation_RootUpsertPricingRecommendationsStatusForBusinessOrganizationArgs = {
  actions: Array<PricingRecommendationActionInput>;
};


/** mutation root */
export type Mutation_RootUpsertPrintTagBatchForRestaurantArgs = {
  items?: InputMaybe<Array<PrintTagBatchVariantPackInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  print_tag_batch_id?: InputMaybe<Scalars['uuid']['input']>;
  print_tag_template_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpsertProductUsageInformationArgs = {
  input: UpsertProductUsageInformationInput;
};


/** mutation root */
export type Mutation_RootUpsertRestaurantVariantPackSubscriptionArgs = {
  frequency_days: Scalars['Int']['input'];
  fulfillment_settings_id: Scalars['uuid']['input'];
  quantity: Scalars['Int']['input'];
  restaurant_id: Scalars['uuid']['input'];
  restaurant_variant_pack_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
  weekday: DaysOfWeek;
};


/** mutation root */
export type Mutation_RootUpsertVariantPackRestaurantRetailPriceArgs = {
  restaurant_id: Scalars['uuid']['input'];
  retail_price_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootValidateOrderArgs = {
  order_id: Scalars['uuid']['input'];
  smart_order_id?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootViewMessageArgs = {
  chat_id: Scalars['uuid']['input'];
  last_viewed_message_timestamp: Scalars['String']['input'];
};

/** columns and relationships of "notification_tokens" */
export type Notification_Tokens = Node & {
  __typename?: 'notification_tokens';
  /** An object relationship */
  business_organization?: Maybe<Business_Organizations>;
  id: Scalars['ID']['output'];
  uuid: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "notification_tokens". All fields are combined with a logical 'AND'. */
export type Notification_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Tokens_Bool_Exp>>;
  _not?: InputMaybe<Notification_Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Tokens_Bool_Exp>>;
  business_organization?: InputMaybe<Business_Organizations_Bool_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_tokens" */
export enum Notification_Tokens_Constraint {
  /** unique or primary key constraint on columns "employee_uuid", "device_identifier", "business_organization_uuid" */
  BackendNotificationtokenBizorgEmployeeDeviceIdentifierIs = 'backend_notificationtoken_bizorg_employee_device_identifier_is_',
  /** unique or primary key constraint on columns "uuid" */
  NotificationTokensPkey = 'notification_tokens_pkey'
}

/** input type for inserting data into table "notification_tokens" */
export type Notification_Tokens_Insert_Input = {
  business_organization_uuid?: InputMaybe<Scalars['uuid']['input']>;
  device_identifier?: InputMaybe<Scalars['String']['input']>;
  notification_token?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "notification_tokens" */
export type Notification_Tokens_Mutation_Response = {
  __typename?: 'notification_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Tokens>;
};

/** on_conflict condition type for table "notification_tokens" */
export type Notification_Tokens_On_Conflict = {
  constraint: Notification_Tokens_Constraint;
  update_columns?: Array<Notification_Tokens_Update_Column>;
  where?: InputMaybe<Notification_Tokens_Bool_Exp>;
};

/** primary key columns input for table: notification_tokens */
export type Notification_Tokens_Pk_Columns_Input = {
  uuid: Scalars['uuid']['input'];
};

/** input type for updating data in table "notification_tokens" */
export type Notification_Tokens_Set_Input = {
  business_organization_uuid?: InputMaybe<Scalars['uuid']['input']>;
  device_identifier?: InputMaybe<Scalars['String']['input']>;
  notification_token?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "notification_tokens" */
export enum Notification_Tokens_Update_Column {
  /** column name */
  BusinessOrganizationUuid = 'business_organization_uuid',
  /** column name */
  DeviceIdentifier = 'device_identifier',
  /** column name */
  NotificationToken = 'notification_token'
}

export type Notification_Tokens_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Tokens_Set_Input>;
  where: Notification_Tokens_Bool_Exp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** columns and relationships of "order_attention_items" */
export type Order_Attention_Items = Node & {
  __typename?: 'order_attention_items';
  attention_type: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  data: Scalars['jsonb']['output'];
  id: Scalars['ID']['output'];
  /** An object relationship */
  order: Orders;
  /** An object relationship */
  order_item: Orders_Items;
  order_item_uuid: Scalars['uuid']['output'];
  order_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "order_attention_items" */
export type Order_Attention_ItemsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "order_attention_items" */
export type Order_Attention_ItemsConnection = {
  __typename?: 'order_attention_itemsConnection';
  edges: Array<Order_Attention_ItemsEdge>;
  pageInfo: PageInfo;
};

export type Order_Attention_ItemsEdge = {
  __typename?: 'order_attention_itemsEdge';
  cursor: Scalars['String']['output'];
  node: Order_Attention_Items;
};

/** order by aggregate values of table "order_attention_items" */
export type Order_Attention_Items_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Attention_Items_Max_Order_By>;
  min?: InputMaybe<Order_Attention_Items_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "order_attention_items". All fields are combined with a logical 'AND'. */
export type Order_Attention_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Attention_Items_Bool_Exp>>;
  _not?: InputMaybe<Order_Attention_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Attention_Items_Bool_Exp>>;
  attention_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_item?: InputMaybe<Orders_Items_Bool_Exp>;
  order_item_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "order_attention_items" */
export type Order_Attention_Items_Max_Order_By = {
  attention_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  order_item_uuid?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_attention_items" */
export type Order_Attention_Items_Min_Order_By = {
  attention_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  order_item_uuid?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_attention_items". */
export type Order_Attention_Items_Order_By = {
  attention_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_item?: InputMaybe<Orders_Items_Order_By>;
  order_item_uuid?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "order_attention_items" */
export enum Order_Attention_Items_Select_Column {
  /** column name */
  AttentionType = 'attention_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  OrderItemUuid = 'order_item_uuid',
  /** column name */
  OrderUuid = 'order_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "order_constraint_variant_pack_rel" */
export type Order_Constraint_Variant_Pack_Rel = Node & {
  __typename?: 'order_constraint_variant_pack_rel';
  id: Scalars['ID']['output'];
  /** An object relationship */
  order_constraint: Order_Constraints;
  order_constraint_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
  /** An object relationship */
  variant_pack: Variants_Packs;
  variant_pack_uuid: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "order_constraint_variant_pack_rel". All fields are combined with a logical 'AND'. */
export type Order_Constraint_Variant_Pack_Rel_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Constraint_Variant_Pack_Rel_Bool_Exp>>;
  _not?: InputMaybe<Order_Constraint_Variant_Pack_Rel_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Constraint_Variant_Pack_Rel_Bool_Exp>>;
  order_constraint?: InputMaybe<Order_Constraints_Bool_Exp>;
  order_constraint_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack?: InputMaybe<Variants_Packs_Bool_Exp>;
  variant_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "order_constraint_variant_pack_rel". */
export type Order_Constraint_Variant_Pack_Rel_Order_By = {
  order_constraint?: InputMaybe<Order_Constraints_Order_By>;
  order_constraint_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack?: InputMaybe<Variants_Packs_Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_constraints" */
export type Order_Constraints = Node & {
  __typename?: 'order_constraints';
  id: Scalars['ID']['output'];
  metadata: Scalars['jsonb']['output'];
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "order_constraints" */
export type Order_ConstraintsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "order_constraints". All fields are combined with a logical 'AND'. */
export type Order_Constraints_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Constraints_Bool_Exp>>;
  _not?: InputMaybe<Order_Constraints_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Constraints_Bool_Exp>>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "order_constraints". */
export type Order_Constraints_Order_By = {
  metadata?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_fees" */
export type Order_Fees = {
  __typename?: 'order_fees';
  amount_at_invoice_micros?: Maybe<Scalars['bigint']['output']>;
  amount_at_order_micros?: Maybe<Scalars['bigint']['output']>;
  display_type?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by aggregate values of table "order_fees" */
export type Order_Fees_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Fees_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Fees_Max_Order_By>;
  min?: InputMaybe<Order_Fees_Min_Order_By>;
  stddev?: InputMaybe<Order_Fees_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Fees_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Fees_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Fees_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Fees_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Fees_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Fees_Variance_Order_By>;
};

/** order by avg() on columns of table "order_fees" */
export type Order_Fees_Avg_Order_By = {
  amount_at_invoice_micros?: InputMaybe<Order_By>;
  amount_at_order_micros?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_fees". All fields are combined with a logical 'AND'. */
export type Order_Fees_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Fees_Bool_Exp>>;
  _not?: InputMaybe<Order_Fees_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Fees_Bool_Exp>>;
  amount_at_invoice_micros?: InputMaybe<Bigint_Comparison_Exp>;
  amount_at_order_micros?: InputMaybe<Bigint_Comparison_Exp>;
  display_type?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "order_fees" */
export type Order_Fees_Max_Order_By = {
  amount_at_invoice_micros?: InputMaybe<Order_By>;
  amount_at_order_micros?: InputMaybe<Order_By>;
  display_type?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_fees" */
export type Order_Fees_Min_Order_By = {
  amount_at_invoice_micros?: InputMaybe<Order_By>;
  amount_at_order_micros?: InputMaybe<Order_By>;
  display_type?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_fees". */
export type Order_Fees_Order_By = {
  amount_at_invoice_micros?: InputMaybe<Order_By>;
  amount_at_order_micros?: InputMaybe<Order_By>;
  display_type?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "order_fees" */
export enum Order_Fees_Select_Column {
  /** column name */
  AmountAtInvoiceMicros = 'amount_at_invoice_micros',
  /** column name */
  AmountAtOrderMicros = 'amount_at_order_micros',
  /** column name */
  DisplayType = 'display_type',
  /** column name */
  Name = 'name',
  /** column name */
  OrderUuid = 'order_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** order by stddev() on columns of table "order_fees" */
export type Order_Fees_Stddev_Order_By = {
  amount_at_invoice_micros?: InputMaybe<Order_By>;
  amount_at_order_micros?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "order_fees" */
export type Order_Fees_Stddev_Pop_Order_By = {
  amount_at_invoice_micros?: InputMaybe<Order_By>;
  amount_at_order_micros?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "order_fees" */
export type Order_Fees_Stddev_Samp_Order_By = {
  amount_at_invoice_micros?: InputMaybe<Order_By>;
  amount_at_order_micros?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "order_fees" */
export type Order_Fees_Sum_Order_By = {
  amount_at_invoice_micros?: InputMaybe<Order_By>;
  amount_at_order_micros?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "order_fees" */
export type Order_Fees_Var_Pop_Order_By = {
  amount_at_invoice_micros?: InputMaybe<Order_By>;
  amount_at_order_micros?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "order_fees" */
export type Order_Fees_Var_Samp_Order_By = {
  amount_at_invoice_micros?: InputMaybe<Order_By>;
  amount_at_order_micros?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "order_fees" */
export type Order_Fees_Variance_Order_By = {
  amount_at_invoice_micros?: InputMaybe<Order_By>;
  amount_at_order_micros?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_fulfillment_fees" */
export type Order_Fulfillment_Fees = {
  __typename?: 'order_fulfillment_fees';
  amount?: Maybe<Scalars['float8']['output']>;
  amount_in_micros?: Maybe<Scalars['float8']['output']>;
  fulfillment_settings_display_name?: Maybe<Scalars['String']['output']>;
  fulfillment_settings_name?: Maybe<Scalars['String']['output']>;
  order_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by aggregate values of table "order_fulfillment_fees" */
export type Order_Fulfillment_Fees_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Fulfillment_Fees_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Fulfillment_Fees_Max_Order_By>;
  min?: InputMaybe<Order_Fulfillment_Fees_Min_Order_By>;
  stddev?: InputMaybe<Order_Fulfillment_Fees_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Fulfillment_Fees_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Fulfillment_Fees_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Fulfillment_Fees_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Fulfillment_Fees_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Fulfillment_Fees_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Fulfillment_Fees_Variance_Order_By>;
};

/** order by avg() on columns of table "order_fulfillment_fees" */
export type Order_Fulfillment_Fees_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_in_micros?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_fulfillment_fees". All fields are combined with a logical 'AND'. */
export type Order_Fulfillment_Fees_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Fulfillment_Fees_Bool_Exp>>;
  _not?: InputMaybe<Order_Fulfillment_Fees_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Fulfillment_Fees_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  amount_in_micros?: InputMaybe<Float8_Comparison_Exp>;
  fulfillment_settings_display_name?: InputMaybe<String_Comparison_Exp>;
  fulfillment_settings_name?: InputMaybe<String_Comparison_Exp>;
  order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "order_fulfillment_fees" */
export type Order_Fulfillment_Fees_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_in_micros?: InputMaybe<Order_By>;
  fulfillment_settings_display_name?: InputMaybe<Order_By>;
  fulfillment_settings_name?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_fulfillment_fees" */
export type Order_Fulfillment_Fees_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_in_micros?: InputMaybe<Order_By>;
  fulfillment_settings_display_name?: InputMaybe<Order_By>;
  fulfillment_settings_name?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_fulfillment_fees". */
export type Order_Fulfillment_Fees_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_in_micros?: InputMaybe<Order_By>;
  fulfillment_settings_display_name?: InputMaybe<Order_By>;
  fulfillment_settings_name?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "order_fulfillment_fees" */
export enum Order_Fulfillment_Fees_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountInMicros = 'amount_in_micros',
  /** column name */
  FulfillmentSettingsDisplayName = 'fulfillment_settings_display_name',
  /** column name */
  FulfillmentSettingsName = 'fulfillment_settings_name',
  /** column name */
  OrderUuid = 'order_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** order by stddev() on columns of table "order_fulfillment_fees" */
export type Order_Fulfillment_Fees_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_in_micros?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "order_fulfillment_fees" */
export type Order_Fulfillment_Fees_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_in_micros?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "order_fulfillment_fees" */
export type Order_Fulfillment_Fees_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_in_micros?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "order_fulfillment_fees" */
export type Order_Fulfillment_Fees_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_in_micros?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "order_fulfillment_fees" */
export type Order_Fulfillment_Fees_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_in_micros?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "order_fulfillment_fees" */
export type Order_Fulfillment_Fees_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_in_micros?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "order_fulfillment_fees" */
export type Order_Fulfillment_Fees_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_in_micros?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_guide" */
export type Order_Guide = Node & {
  __typename?: 'order_guide';
  created_by_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  /** An object relationship */
  restaurant: Businesses;
  restaurant_uuid: Scalars['uuid']['output'];
  sort_order?: Maybe<Scalars['float8']['output']>;
  uuid: Scalars['uuid']['output'];
  variant_pack_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  variants_pack: Variants_Packs;
};

/** A Relay connection object on "order_guide" */
export type Order_GuideConnection = {
  __typename?: 'order_guideConnection';
  edges: Array<Order_GuideEdge>;
  pageInfo: PageInfo;
};

export type Order_GuideEdge = {
  __typename?: 'order_guideEdge';
  cursor: Scalars['String']['output'];
  node: Order_Guide;
};

/** order by aggregate values of table "order_guide" */
export type Order_Guide_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Guide_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Guide_Max_Order_By>;
  min?: InputMaybe<Order_Guide_Min_Order_By>;
  stddev?: InputMaybe<Order_Guide_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Guide_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Guide_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Guide_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Guide_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Guide_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Guide_Variance_Order_By>;
};

/** order by avg() on columns of table "order_guide" */
export type Order_Guide_Avg_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_guide". All fields are combined with a logical 'AND'. */
export type Order_Guide_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Guide_Bool_Exp>>;
  _not?: InputMaybe<Order_Guide_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Guide_Bool_Exp>>;
  created_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  restaurant?: InputMaybe<Businesses_Bool_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  sort_order?: InputMaybe<Float8_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variants_pack?: InputMaybe<Variants_Packs_Bool_Exp>;
};

/** unique or primary key constraints on table "order_guide" */
export enum Order_Guide_Constraint {
  /** unique or primary key constraint on columns "variant_pack_uuid", "restaurant_uuid" */
  BackendOrderguideRestaurantVariantPackIsUnique = 'backend_orderguide_restaurant_variant_pack_is_unique',
  /** unique or primary key constraint on columns "uuid" */
  OrderGuidePkey = 'order_guide_pkey'
}

/** input type for inserting data into table "order_guide" */
export type Order_Guide_Insert_Input = {
  restaurant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  variant_pack_uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "order_guide" */
export type Order_Guide_Max_Order_By = {
  created_by_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_guide" */
export type Order_Guide_Min_Order_By = {
  created_by_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_guide" */
export type Order_Guide_Mutation_Response = {
  __typename?: 'order_guide_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Guide>;
};

/** on_conflict condition type for table "order_guide" */
export type Order_Guide_On_Conflict = {
  constraint: Order_Guide_Constraint;
  update_columns?: Array<Order_Guide_Update_Column>;
  where?: InputMaybe<Order_Guide_Bool_Exp>;
};

/** Ordering options when selecting data from "order_guide". */
export type Order_Guide_Order_By = {
  created_by_uuid?: InputMaybe<Order_By>;
  restaurant?: InputMaybe<Businesses_Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
  variants_pack?: InputMaybe<Variants_Packs_Order_By>;
};

/** columns and relationships of "order_guide_restaurant" */
export type Order_Guide_Restaurant = Node & {
  __typename?: 'order_guide_restaurant';
  id: Scalars['ID']['output'];
  is_minimized: Scalars['Boolean']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  order_guide_restaurant_partition: Order_Guide_Restaurant_Partition;
  order_guide_restaurant_partition_uuid: Scalars['uuid']['output'];
  par_level?: Maybe<Scalars['float8']['output']>;
  persist_memo: Scalars['Boolean']['output'];
  persist_notes: Scalars['Boolean']['output'];
  persist_request: Scalars['Boolean']['output'];
  request?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['float8']['output']>;
  uuid: Scalars['uuid']['output'];
};

/** columns and relationships of "order_guide_restaurant_collection" */
export type Order_Guide_Restaurant_Collection = Node & {
  __typename?: 'order_guide_restaurant_collection';
  id: Scalars['ID']['output'];
  is_default: Scalars['Boolean']['output'];
  linked_order_guide_supplier_collection_uuid?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  order_guide_restaurant_partitions: Array<Order_Guide_Restaurant_Partition>;
  /** An array relationship connection */
  order_guide_restaurant_partitions_connection: Order_Guide_Restaurant_PartitionConnection;
  /** An object relationship */
  restaurant: Businesses;
  restaurant_uuid: Scalars['uuid']['output'];
  sort_order?: Maybe<Scalars['float8']['output']>;
  supplier_uuid: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "order_guide_restaurant_collection" */
export type Order_Guide_Restaurant_CollectionOrder_Guide_Restaurant_PartitionsArgs = {
  distinct_on?: InputMaybe<Array<Order_Guide_Restaurant_Partition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Guide_Restaurant_Partition_Order_By>>;
  where?: InputMaybe<Order_Guide_Restaurant_Partition_Bool_Exp>;
};


/** columns and relationships of "order_guide_restaurant_collection" */
export type Order_Guide_Restaurant_CollectionOrder_Guide_Restaurant_Partitions_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Guide_Restaurant_Partition_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Guide_Restaurant_Partition_Order_By>>;
  where?: InputMaybe<Order_Guide_Restaurant_Partition_Bool_Exp>;
};

/** A Relay connection object on "order_guide_restaurant_collection" */
export type Order_Guide_Restaurant_CollectionConnection = {
  __typename?: 'order_guide_restaurant_collectionConnection';
  edges: Array<Order_Guide_Restaurant_CollectionEdge>;
  pageInfo: PageInfo;
};

export type Order_Guide_Restaurant_CollectionEdge = {
  __typename?: 'order_guide_restaurant_collectionEdge';
  cursor: Scalars['String']['output'];
  node: Order_Guide_Restaurant_Collection;
};

/** Boolean expression to filter rows from the table "order_guide_restaurant_collection". All fields are combined with a logical 'AND'. */
export type Order_Guide_Restaurant_Collection_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Guide_Restaurant_Collection_Bool_Exp>>;
  _not?: InputMaybe<Order_Guide_Restaurant_Collection_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Guide_Restaurant_Collection_Bool_Exp>>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  linked_order_guide_supplier_collection_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_guide_restaurant_partitions?: InputMaybe<Order_Guide_Restaurant_Partition_Bool_Exp>;
  restaurant?: InputMaybe<Businesses_Bool_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  sort_order?: InputMaybe<Float8_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "order_guide_restaurant_collection". */
export type Order_Guide_Restaurant_Collection_Order_By = {
  is_default?: InputMaybe<Order_By>;
  linked_order_guide_supplier_collection_uuid?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_guide_restaurant_partitions_aggregate?: InputMaybe<Order_Guide_Restaurant_Partition_Aggregate_Order_By>;
  restaurant?: InputMaybe<Businesses_Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "order_guide_restaurant_collection" */
export enum Order_Guide_Restaurant_Collection_Select_Column {
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  LinkedOrderGuideSupplierCollectionUuid = 'linked_order_guide_supplier_collection_uuid',
  /** column name */
  Name = 'name',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "order_guide_restaurant_collection" */
export type Order_Guide_Restaurant_Collection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Guide_Restaurant_Collection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Guide_Restaurant_Collection_Stream_Cursor_Value_Input = {
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  linked_order_guide_supplier_collection_uuid?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  restaurant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['float8']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "order_guide_restaurant_partition" */
export type Order_Guide_Restaurant_Partition = Node & {
  __typename?: 'order_guide_restaurant_partition';
  id: Scalars['ID']['output'];
  is_default: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  order_guide_restaurant_collection: Order_Guide_Restaurant_Collection;
  order_guide_restaurant_collection_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  restaurant: Businesses;
  sort_order?: Maybe<Scalars['float8']['output']>;
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "order_guide_restaurant_partition" */
export type Order_Guide_Restaurant_PartitionConnection = {
  __typename?: 'order_guide_restaurant_partitionConnection';
  edges: Array<Order_Guide_Restaurant_PartitionEdge>;
  pageInfo: PageInfo;
};

export type Order_Guide_Restaurant_PartitionEdge = {
  __typename?: 'order_guide_restaurant_partitionEdge';
  cursor: Scalars['String']['output'];
  node: Order_Guide_Restaurant_Partition;
};

/** order by aggregate values of table "order_guide_restaurant_partition" */
export type Order_Guide_Restaurant_Partition_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Guide_Restaurant_Partition_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Guide_Restaurant_Partition_Max_Order_By>;
  min?: InputMaybe<Order_Guide_Restaurant_Partition_Min_Order_By>;
  stddev?: InputMaybe<Order_Guide_Restaurant_Partition_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Guide_Restaurant_Partition_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Guide_Restaurant_Partition_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Guide_Restaurant_Partition_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Guide_Restaurant_Partition_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Guide_Restaurant_Partition_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Guide_Restaurant_Partition_Variance_Order_By>;
};

/** order by avg() on columns of table "order_guide_restaurant_partition" */
export type Order_Guide_Restaurant_Partition_Avg_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_guide_restaurant_partition". All fields are combined with a logical 'AND'. */
export type Order_Guide_Restaurant_Partition_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Guide_Restaurant_Partition_Bool_Exp>>;
  _not?: InputMaybe<Order_Guide_Restaurant_Partition_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Guide_Restaurant_Partition_Bool_Exp>>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_guide_restaurant_collection?: InputMaybe<Order_Guide_Restaurant_Collection_Bool_Exp>;
  order_guide_restaurant_collection_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  restaurant?: InputMaybe<Businesses_Bool_Exp>;
  sort_order?: InputMaybe<Float8_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "order_guide_restaurant_partition" */
export type Order_Guide_Restaurant_Partition_Max_Order_By = {
  name?: InputMaybe<Order_By>;
  order_guide_restaurant_collection_uuid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_guide_restaurant_partition" */
export type Order_Guide_Restaurant_Partition_Min_Order_By = {
  name?: InputMaybe<Order_By>;
  order_guide_restaurant_collection_uuid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_guide_restaurant_partition". */
export type Order_Guide_Restaurant_Partition_Order_By = {
  is_default?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_guide_restaurant_collection?: InputMaybe<Order_Guide_Restaurant_Collection_Order_By>;
  order_guide_restaurant_collection_uuid?: InputMaybe<Order_By>;
  restaurant?: InputMaybe<Businesses_Order_By>;
  sort_order?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "order_guide_restaurant_partition" */
export enum Order_Guide_Restaurant_Partition_Select_Column {
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Name = 'name',
  /** column name */
  OrderGuideRestaurantCollectionUuid = 'order_guide_restaurant_collection_uuid',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  Uuid = 'uuid'
}

/** order by stddev() on columns of table "order_guide_restaurant_partition" */
export type Order_Guide_Restaurant_Partition_Stddev_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "order_guide_restaurant_partition" */
export type Order_Guide_Restaurant_Partition_Stddev_Pop_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "order_guide_restaurant_partition" */
export type Order_Guide_Restaurant_Partition_Stddev_Samp_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "order_guide_restaurant_partition" */
export type Order_Guide_Restaurant_Partition_Sum_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "order_guide_restaurant_partition" */
export type Order_Guide_Restaurant_Partition_Var_Pop_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "order_guide_restaurant_partition" */
export type Order_Guide_Restaurant_Partition_Var_Samp_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "order_guide_restaurant_partition" */
export type Order_Guide_Restaurant_Partition_Variance_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** select columns of table "order_guide" */
export enum Order_Guide_Select_Column {
  /** column name */
  CreatedByUuid = 'created_by_uuid',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VariantPackUuid = 'variant_pack_uuid'
}

/** order by stddev() on columns of table "order_guide" */
export type Order_Guide_Stddev_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "order_guide" */
export type Order_Guide_Stddev_Pop_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "order_guide" */
export type Order_Guide_Stddev_Samp_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_guide" */
export type Order_Guide_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Guide_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Guide_Stream_Cursor_Value_Input = {
  created_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
  restaurant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['float8']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
  variant_pack_uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "order_guide" */
export type Order_Guide_Sum_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_guide_supplier_collection" */
export type Order_Guide_Supplier_Collection = Node & {
  __typename?: 'order_guide_supplier_collection';
  id: Scalars['ID']['output'];
  integration_id?: Maybe<Scalars['String']['output']>;
  is_default: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  order_guide_supplier_partitions: Array<Order_Guide_Supplier_Partition>;
  /** An array relationship connection */
  order_guide_supplier_partitions_connection: Order_Guide_Supplier_PartitionConnection;
  restaurant_uuid: Scalars['uuid']['output'];
  sort_order?: Maybe<Scalars['float8']['output']>;
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "order_guide_supplier_collection" */
export type Order_Guide_Supplier_CollectionOrder_Guide_Supplier_PartitionsArgs = {
  distinct_on?: InputMaybe<Array<Order_Guide_Supplier_Partition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Guide_Supplier_Partition_Order_By>>;
  where?: InputMaybe<Order_Guide_Supplier_Partition_Bool_Exp>;
};


/** columns and relationships of "order_guide_supplier_collection" */
export type Order_Guide_Supplier_CollectionOrder_Guide_Supplier_Partitions_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Guide_Supplier_Partition_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Guide_Supplier_Partition_Order_By>>;
  where?: InputMaybe<Order_Guide_Supplier_Partition_Bool_Exp>;
};

/** A Relay connection object on "order_guide_supplier_collection" */
export type Order_Guide_Supplier_CollectionConnection = {
  __typename?: 'order_guide_supplier_collectionConnection';
  edges: Array<Order_Guide_Supplier_CollectionEdge>;
  pageInfo: PageInfo;
};

export type Order_Guide_Supplier_CollectionEdge = {
  __typename?: 'order_guide_supplier_collectionEdge';
  cursor: Scalars['String']['output'];
  node: Order_Guide_Supplier_Collection;
};

/** Boolean expression to filter rows from the table "order_guide_supplier_collection". All fields are combined with a logical 'AND'. */
export type Order_Guide_Supplier_Collection_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Guide_Supplier_Collection_Bool_Exp>>;
  _not?: InputMaybe<Order_Guide_Supplier_Collection_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Guide_Supplier_Collection_Bool_Exp>>;
  integration_id?: InputMaybe<String_Comparison_Exp>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_guide_supplier_partitions?: InputMaybe<Order_Guide_Supplier_Partition_Bool_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  sort_order?: InputMaybe<Float8_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "order_guide_supplier_collection". */
export type Order_Guide_Supplier_Collection_Order_By = {
  integration_id?: InputMaybe<Order_By>;
  is_default?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_guide_supplier_partitions_aggregate?: InputMaybe<Order_Guide_Supplier_Partition_Aggregate_Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "order_guide_supplier_collection" */
export enum Order_Guide_Supplier_Collection_Select_Column {
  /** column name */
  IntegrationId = 'integration_id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Name = 'name',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "order_guide_supplier_collection" */
export type Order_Guide_Supplier_Collection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Guide_Supplier_Collection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Guide_Supplier_Collection_Stream_Cursor_Value_Input = {
  integration_id?: InputMaybe<Scalars['String']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  restaurant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['float8']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "order_guide_supplier_partition" */
export type Order_Guide_Supplier_Partition = Node & {
  __typename?: 'order_guide_supplier_partition';
  id: Scalars['ID']['output'];
  integration_id?: Maybe<Scalars['String']['output']>;
  is_default: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order_guide_supplier_collection_uuid: Scalars['uuid']['output'];
  sort_order?: Maybe<Scalars['float8']['output']>;
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "order_guide_supplier_partition" */
export type Order_Guide_Supplier_PartitionConnection = {
  __typename?: 'order_guide_supplier_partitionConnection';
  edges: Array<Order_Guide_Supplier_PartitionEdge>;
  pageInfo: PageInfo;
};

export type Order_Guide_Supplier_PartitionEdge = {
  __typename?: 'order_guide_supplier_partitionEdge';
  cursor: Scalars['String']['output'];
  node: Order_Guide_Supplier_Partition;
};

/** order by aggregate values of table "order_guide_supplier_partition" */
export type Order_Guide_Supplier_Partition_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Guide_Supplier_Partition_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Guide_Supplier_Partition_Max_Order_By>;
  min?: InputMaybe<Order_Guide_Supplier_Partition_Min_Order_By>;
  stddev?: InputMaybe<Order_Guide_Supplier_Partition_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Guide_Supplier_Partition_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Guide_Supplier_Partition_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Guide_Supplier_Partition_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Guide_Supplier_Partition_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Guide_Supplier_Partition_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Guide_Supplier_Partition_Variance_Order_By>;
};

/** order by avg() on columns of table "order_guide_supplier_partition" */
export type Order_Guide_Supplier_Partition_Avg_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_guide_supplier_partition". All fields are combined with a logical 'AND'. */
export type Order_Guide_Supplier_Partition_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Guide_Supplier_Partition_Bool_Exp>>;
  _not?: InputMaybe<Order_Guide_Supplier_Partition_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Guide_Supplier_Partition_Bool_Exp>>;
  integration_id?: InputMaybe<String_Comparison_Exp>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_guide_supplier_collection_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  sort_order?: InputMaybe<Float8_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "order_guide_supplier_partition" */
export type Order_Guide_Supplier_Partition_Max_Order_By = {
  integration_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_guide_supplier_collection_uuid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_guide_supplier_partition" */
export type Order_Guide_Supplier_Partition_Min_Order_By = {
  integration_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_guide_supplier_collection_uuid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_guide_supplier_partition". */
export type Order_Guide_Supplier_Partition_Order_By = {
  integration_id?: InputMaybe<Order_By>;
  is_default?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_guide_supplier_collection_uuid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "order_guide_supplier_partition" */
export enum Order_Guide_Supplier_Partition_Select_Column {
  /** column name */
  IntegrationId = 'integration_id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Name = 'name',
  /** column name */
  OrderGuideSupplierCollectionUuid = 'order_guide_supplier_collection_uuid',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  Uuid = 'uuid'
}

/** order by stddev() on columns of table "order_guide_supplier_partition" */
export type Order_Guide_Supplier_Partition_Stddev_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "order_guide_supplier_partition" */
export type Order_Guide_Supplier_Partition_Stddev_Pop_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "order_guide_supplier_partition" */
export type Order_Guide_Supplier_Partition_Stddev_Samp_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "order_guide_supplier_partition" */
export type Order_Guide_Supplier_Partition_Sum_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "order_guide_supplier_partition" */
export type Order_Guide_Supplier_Partition_Var_Pop_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "order_guide_supplier_partition" */
export type Order_Guide_Supplier_Partition_Var_Samp_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "order_guide_supplier_partition" */
export type Order_Guide_Supplier_Partition_Variance_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "order_guide" (current role has no relevant permissions) */
export enum Order_Guide_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "order_guide" */
export type Order_Guide_Var_Pop_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "order_guide" */
export type Order_Guide_Var_Samp_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "order_guide" */
export type Order_Guide_Variance_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_invoice_check_in_item_issues" */
export type Order_Invoice_Check_In_Item_Issues = Node & {
  __typename?: 'order_invoice_check_in_item_issues';
  id: Scalars['ID']['output'];
  order_invoice_check_in_item_uuid: Scalars['uuid']['output'];
  quantity: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "order_invoice_check_in_item_issues" */
export type Order_Invoice_Check_In_Item_IssuesConnection = {
  __typename?: 'order_invoice_check_in_item_issuesConnection';
  edges: Array<Order_Invoice_Check_In_Item_IssuesEdge>;
  pageInfo: PageInfo;
};

export type Order_Invoice_Check_In_Item_IssuesEdge = {
  __typename?: 'order_invoice_check_in_item_issuesEdge';
  cursor: Scalars['String']['output'];
  node: Order_Invoice_Check_In_Item_Issues;
};

/** order by aggregate values of table "order_invoice_check_in_item_issues" */
export type Order_Invoice_Check_In_Item_Issues_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Max_Order_By>;
  min?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Min_Order_By>;
  stddev?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Variance_Order_By>;
};

/** order by avg() on columns of table "order_invoice_check_in_item_issues" */
export type Order_Invoice_Check_In_Item_Issues_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_invoice_check_in_item_issues". All fields are combined with a logical 'AND'. */
export type Order_Invoice_Check_In_Item_Issues_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Invoice_Check_In_Item_Issues_Bool_Exp>>;
  _not?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Invoice_Check_In_Item_Issues_Bool_Exp>>;
  order_invoice_check_in_item_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "order_invoice_check_in_item_issues" */
export type Order_Invoice_Check_In_Item_Issues_Max_Order_By = {
  order_invoice_check_in_item_uuid?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_invoice_check_in_item_issues" */
export type Order_Invoice_Check_In_Item_Issues_Min_Order_By = {
  order_invoice_check_in_item_uuid?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_invoice_check_in_item_issues". */
export type Order_Invoice_Check_In_Item_Issues_Order_By = {
  order_invoice_check_in_item_uuid?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "order_invoice_check_in_item_issues" */
export enum Order_Invoice_Check_In_Item_Issues_Select_Column {
  /** column name */
  OrderInvoiceCheckInItemUuid = 'order_invoice_check_in_item_uuid',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Status = 'status',
  /** column name */
  Uuid = 'uuid'
}

/** order by stddev() on columns of table "order_invoice_check_in_item_issues" */
export type Order_Invoice_Check_In_Item_Issues_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "order_invoice_check_in_item_issues" */
export type Order_Invoice_Check_In_Item_Issues_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "order_invoice_check_in_item_issues" */
export type Order_Invoice_Check_In_Item_Issues_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_invoice_check_in_item_issues" */
export type Order_Invoice_Check_In_Item_Issues_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Invoice_Check_In_Item_Issues_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Invoice_Check_In_Item_Issues_Stream_Cursor_Value_Input = {
  order_invoice_check_in_item_uuid?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "order_invoice_check_in_item_issues" */
export type Order_Invoice_Check_In_Item_Issues_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "order_invoice_check_in_item_issues" */
export type Order_Invoice_Check_In_Item_Issues_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "order_invoice_check_in_item_issues" */
export type Order_Invoice_Check_In_Item_Issues_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "order_invoice_check_in_item_issues" */
export type Order_Invoice_Check_In_Item_Issues_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_invoice_check_in_items" */
export type Order_Invoice_Check_In_Items = Node & {
  __typename?: 'order_invoice_check_in_items';
  id: Scalars['ID']['output'];
  /** An array relationship */
  order_invoice_check_in_item_issues: Array<Order_Invoice_Check_In_Item_Issues>;
  /** An array relationship connection */
  order_invoice_check_in_item_issues_connection: Order_Invoice_Check_In_Item_IssuesConnection;
  order_invoice_check_in_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  order_invoice_line_item: Order_Invoice_Line_Items;
  order_invoice_line_item_uuid: Scalars['uuid']['output'];
  quantity: Scalars['float8']['output'];
  updated_at: Scalars['timestamptz']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "order_invoice_check_in_items" */
export type Order_Invoice_Check_In_ItemsOrder_Invoice_Check_In_Item_IssuesArgs = {
  distinct_on?: InputMaybe<Array<Order_Invoice_Check_In_Item_Issues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoice_Check_In_Item_Issues_Order_By>>;
  where?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Bool_Exp>;
};


/** columns and relationships of "order_invoice_check_in_items" */
export type Order_Invoice_Check_In_ItemsOrder_Invoice_Check_In_Item_Issues_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Invoice_Check_In_Item_Issues_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoice_Check_In_Item_Issues_Order_By>>;
  where?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Bool_Exp>;
};

/** A Relay connection object on "order_invoice_check_in_items" */
export type Order_Invoice_Check_In_ItemsConnection = {
  __typename?: 'order_invoice_check_in_itemsConnection';
  edges: Array<Order_Invoice_Check_In_ItemsEdge>;
  pageInfo: PageInfo;
};

export type Order_Invoice_Check_In_ItemsEdge = {
  __typename?: 'order_invoice_check_in_itemsEdge';
  cursor: Scalars['String']['output'];
  node: Order_Invoice_Check_In_Items;
};

/** order by aggregate values of table "order_invoice_check_in_items" */
export type Order_Invoice_Check_In_Items_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Invoice_Check_In_Items_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Invoice_Check_In_Items_Max_Order_By>;
  min?: InputMaybe<Order_Invoice_Check_In_Items_Min_Order_By>;
  stddev?: InputMaybe<Order_Invoice_Check_In_Items_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Invoice_Check_In_Items_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Invoice_Check_In_Items_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Invoice_Check_In_Items_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Invoice_Check_In_Items_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Invoice_Check_In_Items_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Invoice_Check_In_Items_Variance_Order_By>;
};

/** order by avg() on columns of table "order_invoice_check_in_items" */
export type Order_Invoice_Check_In_Items_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_invoice_check_in_items". All fields are combined with a logical 'AND'. */
export type Order_Invoice_Check_In_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Invoice_Check_In_Items_Bool_Exp>>;
  _not?: InputMaybe<Order_Invoice_Check_In_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Invoice_Check_In_Items_Bool_Exp>>;
  order_invoice_check_in_item_issues?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Bool_Exp>;
  order_invoice_check_in_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  order_invoice_line_item?: InputMaybe<Order_Invoice_Line_Items_Bool_Exp>;
  order_invoice_line_item_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "order_invoice_check_in_items" */
export type Order_Invoice_Check_In_Items_Max_Order_By = {
  order_invoice_check_in_uuid?: InputMaybe<Order_By>;
  order_invoice_line_item_uuid?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_invoice_check_in_items" */
export type Order_Invoice_Check_In_Items_Min_Order_By = {
  order_invoice_check_in_uuid?: InputMaybe<Order_By>;
  order_invoice_line_item_uuid?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_invoice_check_in_items". */
export type Order_Invoice_Check_In_Items_Order_By = {
  order_invoice_check_in_item_issues_aggregate?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Aggregate_Order_By>;
  order_invoice_check_in_uuid?: InputMaybe<Order_By>;
  order_invoice_line_item?: InputMaybe<Order_Invoice_Line_Items_Order_By>;
  order_invoice_line_item_uuid?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "order_invoice_check_in_items" */
export enum Order_Invoice_Check_In_Items_Select_Column {
  /** column name */
  OrderInvoiceCheckInUuid = 'order_invoice_check_in_uuid',
  /** column name */
  OrderInvoiceLineItemUuid = 'order_invoice_line_item_uuid',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** order by stddev() on columns of table "order_invoice_check_in_items" */
export type Order_Invoice_Check_In_Items_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "order_invoice_check_in_items" */
export type Order_Invoice_Check_In_Items_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "order_invoice_check_in_items" */
export type Order_Invoice_Check_In_Items_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_invoice_check_in_items" */
export type Order_Invoice_Check_In_Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Invoice_Check_In_Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Invoice_Check_In_Items_Stream_Cursor_Value_Input = {
  order_invoice_check_in_uuid?: InputMaybe<Scalars['uuid']['input']>;
  order_invoice_line_item_uuid?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "order_invoice_check_in_items" */
export type Order_Invoice_Check_In_Items_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "order_invoice_check_in_items" */
export type Order_Invoice_Check_In_Items_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "order_invoice_check_in_items" */
export type Order_Invoice_Check_In_Items_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "order_invoice_check_in_items" */
export type Order_Invoice_Check_In_Items_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_invoice_check_ins" */
export type Order_Invoice_Check_Ins = Node & {
  __typename?: 'order_invoice_check_ins';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['ID']['output'];
  /** An array relationship */
  order_invoice_check_in_items: Array<Order_Invoice_Check_In_Items>;
  /** An array relationship connection */
  order_invoice_check_in_items_connection: Order_Invoice_Check_In_ItemsConnection;
  order_invoice_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "order_invoice_check_ins" */
export type Order_Invoice_Check_InsOrder_Invoice_Check_In_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Order_Invoice_Check_In_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoice_Check_In_Items_Order_By>>;
  where?: InputMaybe<Order_Invoice_Check_In_Items_Bool_Exp>;
};


/** columns and relationships of "order_invoice_check_ins" */
export type Order_Invoice_Check_InsOrder_Invoice_Check_In_Items_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Invoice_Check_In_Items_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoice_Check_In_Items_Order_By>>;
  where?: InputMaybe<Order_Invoice_Check_In_Items_Bool_Exp>;
};

/** A Relay connection object on "order_invoice_check_ins" */
export type Order_Invoice_Check_InsConnection = {
  __typename?: 'order_invoice_check_insConnection';
  edges: Array<Order_Invoice_Check_InsEdge>;
  pageInfo: PageInfo;
};

export type Order_Invoice_Check_InsEdge = {
  __typename?: 'order_invoice_check_insEdge';
  cursor: Scalars['String']['output'];
  node: Order_Invoice_Check_Ins;
};

/** Boolean expression to filter rows from the table "order_invoice_check_ins". All fields are combined with a logical 'AND'. */
export type Order_Invoice_Check_Ins_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Invoice_Check_Ins_Bool_Exp>>;
  _not?: InputMaybe<Order_Invoice_Check_Ins_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Invoice_Check_Ins_Bool_Exp>>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  order_invoice_check_in_items?: InputMaybe<Order_Invoice_Check_In_Items_Bool_Exp>;
  order_invoice_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "order_invoice_check_ins". */
export type Order_Invoice_Check_Ins_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  order_invoice_check_in_items_aggregate?: InputMaybe<Order_Invoice_Check_In_Items_Aggregate_Order_By>;
  order_invoice_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "order_invoice_check_ins" */
export enum Order_Invoice_Check_Ins_Select_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  OrderInvoiceUuid = 'order_invoice_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "order_invoice_check_ins" */
export type Order_Invoice_Check_Ins_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Invoice_Check_Ins_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Invoice_Check_Ins_Stream_Cursor_Value_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  order_invoice_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "order_invoice_line_items" */
export type Order_Invoice_Line_Items = Node & {
  __typename?: 'order_invoice_line_items';
  base_quantity?: Maybe<Scalars['float8']['output']>;
  base_unit_of_measure?: Maybe<Scalars['String']['output']>;
  base_unit_price_in_micros?: Maybe<Scalars['bigint']['output']>;
  cost_type?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  item_code: Scalars['String']['output'];
  item_name?: Maybe<Scalars['String']['output']>;
  order_erp_unit_of_measure?: Maybe<Scalars['String']['output']>;
  order_invoice_uuid: Scalars['uuid']['output'];
  order_quantity?: Maybe<Scalars['float8']['output']>;
  ship_erp_unit_of_measure: Scalars['String']['output'];
  ship_quantity: Scalars['float8']['output'];
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  unit_cost_in_micros?: Maybe<Scalars['bigint']['output']>;
  unit_price_in_micros: Scalars['bigint']['output'];
  unit_tax_in_micros?: Maybe<Scalars['bigint']['output']>;
  uuid: Scalars['uuid']['output'];
  /** An object relationship */
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_uuid?: Maybe<Scalars['uuid']['output']>;
};

/** A Relay connection object on "order_invoice_line_items" */
export type Order_Invoice_Line_ItemsConnection = {
  __typename?: 'order_invoice_line_itemsConnection';
  edges: Array<Order_Invoice_Line_ItemsEdge>;
  pageInfo: PageInfo;
};

export type Order_Invoice_Line_ItemsEdge = {
  __typename?: 'order_invoice_line_itemsEdge';
  cursor: Scalars['String']['output'];
  node: Order_Invoice_Line_Items;
};

/** order by aggregate values of table "order_invoice_line_items" */
export type Order_Invoice_Line_Items_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Invoice_Line_Items_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Invoice_Line_Items_Max_Order_By>;
  min?: InputMaybe<Order_Invoice_Line_Items_Min_Order_By>;
  stddev?: InputMaybe<Order_Invoice_Line_Items_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Invoice_Line_Items_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Invoice_Line_Items_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Invoice_Line_Items_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Invoice_Line_Items_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Invoice_Line_Items_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Invoice_Line_Items_Variance_Order_By>;
};

/** order by avg() on columns of table "order_invoice_line_items" */
export type Order_Invoice_Line_Items_Avg_Order_By = {
  base_quantity?: InputMaybe<Order_By>;
  base_unit_price_in_micros?: InputMaybe<Order_By>;
  order_quantity?: InputMaybe<Order_By>;
  ship_quantity?: InputMaybe<Order_By>;
  unit_cost_in_micros?: InputMaybe<Order_By>;
  unit_price_in_micros?: InputMaybe<Order_By>;
  unit_tax_in_micros?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_invoice_line_items". All fields are combined with a logical 'AND'. */
export type Order_Invoice_Line_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Invoice_Line_Items_Bool_Exp>>;
  _not?: InputMaybe<Order_Invoice_Line_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Invoice_Line_Items_Bool_Exp>>;
  base_quantity?: InputMaybe<Float8_Comparison_Exp>;
  base_unit_of_measure?: InputMaybe<String_Comparison_Exp>;
  base_unit_price_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  cost_type?: InputMaybe<String_Comparison_Exp>;
  item_code?: InputMaybe<String_Comparison_Exp>;
  item_name?: InputMaybe<String_Comparison_Exp>;
  order_erp_unit_of_measure?: InputMaybe<String_Comparison_Exp>;
  order_invoice_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  order_quantity?: InputMaybe<Float8_Comparison_Exp>;
  ship_erp_unit_of_measure?: InputMaybe<String_Comparison_Exp>;
  ship_quantity?: InputMaybe<Float8_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  unit_cost_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  unit_price_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  unit_tax_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack?: InputMaybe<Variants_Packs_Bool_Exp>;
  variant_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "order_invoice_line_items" */
export type Order_Invoice_Line_Items_Max_Order_By = {
  base_quantity?: InputMaybe<Order_By>;
  base_unit_of_measure?: InputMaybe<Order_By>;
  base_unit_price_in_micros?: InputMaybe<Order_By>;
  cost_type?: InputMaybe<Order_By>;
  item_code?: InputMaybe<Order_By>;
  item_name?: InputMaybe<Order_By>;
  order_erp_unit_of_measure?: InputMaybe<Order_By>;
  order_invoice_uuid?: InputMaybe<Order_By>;
  order_quantity?: InputMaybe<Order_By>;
  ship_erp_unit_of_measure?: InputMaybe<Order_By>;
  ship_quantity?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  unit_cost_in_micros?: InputMaybe<Order_By>;
  unit_price_in_micros?: InputMaybe<Order_By>;
  unit_tax_in_micros?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_invoice_line_items" */
export type Order_Invoice_Line_Items_Min_Order_By = {
  base_quantity?: InputMaybe<Order_By>;
  base_unit_of_measure?: InputMaybe<Order_By>;
  base_unit_price_in_micros?: InputMaybe<Order_By>;
  cost_type?: InputMaybe<Order_By>;
  item_code?: InputMaybe<Order_By>;
  item_name?: InputMaybe<Order_By>;
  order_erp_unit_of_measure?: InputMaybe<Order_By>;
  order_invoice_uuid?: InputMaybe<Order_By>;
  order_quantity?: InputMaybe<Order_By>;
  ship_erp_unit_of_measure?: InputMaybe<Order_By>;
  ship_quantity?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  unit_cost_in_micros?: InputMaybe<Order_By>;
  unit_price_in_micros?: InputMaybe<Order_By>;
  unit_tax_in_micros?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_invoice_line_items". */
export type Order_Invoice_Line_Items_Order_By = {
  base_quantity?: InputMaybe<Order_By>;
  base_unit_of_measure?: InputMaybe<Order_By>;
  base_unit_price_in_micros?: InputMaybe<Order_By>;
  cost_type?: InputMaybe<Order_By>;
  item_code?: InputMaybe<Order_By>;
  item_name?: InputMaybe<Order_By>;
  order_erp_unit_of_measure?: InputMaybe<Order_By>;
  order_invoice_uuid?: InputMaybe<Order_By>;
  order_quantity?: InputMaybe<Order_By>;
  ship_erp_unit_of_measure?: InputMaybe<Order_By>;
  ship_quantity?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  unit_cost_in_micros?: InputMaybe<Order_By>;
  unit_price_in_micros?: InputMaybe<Order_By>;
  unit_tax_in_micros?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack?: InputMaybe<Variants_Packs_Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** select columns of table "order_invoice_line_items" */
export enum Order_Invoice_Line_Items_Select_Column {
  /** column name */
  BaseQuantity = 'base_quantity',
  /** column name */
  BaseUnitOfMeasure = 'base_unit_of_measure',
  /** column name */
  BaseUnitPriceInMicros = 'base_unit_price_in_micros',
  /** column name */
  CostType = 'cost_type',
  /** column name */
  ItemCode = 'item_code',
  /** column name */
  ItemName = 'item_name',
  /** column name */
  OrderErpUnitOfMeasure = 'order_erp_unit_of_measure',
  /** column name */
  OrderInvoiceUuid = 'order_invoice_uuid',
  /** column name */
  OrderQuantity = 'order_quantity',
  /** column name */
  ShipErpUnitOfMeasure = 'ship_erp_unit_of_measure',
  /** column name */
  ShipQuantity = 'ship_quantity',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  UnitCostInMicros = 'unit_cost_in_micros',
  /** column name */
  UnitPriceInMicros = 'unit_price_in_micros',
  /** column name */
  UnitTaxInMicros = 'unit_tax_in_micros',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VariantPackUuid = 'variant_pack_uuid'
}

/** order by stddev() on columns of table "order_invoice_line_items" */
export type Order_Invoice_Line_Items_Stddev_Order_By = {
  base_quantity?: InputMaybe<Order_By>;
  base_unit_price_in_micros?: InputMaybe<Order_By>;
  order_quantity?: InputMaybe<Order_By>;
  ship_quantity?: InputMaybe<Order_By>;
  unit_cost_in_micros?: InputMaybe<Order_By>;
  unit_price_in_micros?: InputMaybe<Order_By>;
  unit_tax_in_micros?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "order_invoice_line_items" */
export type Order_Invoice_Line_Items_Stddev_Pop_Order_By = {
  base_quantity?: InputMaybe<Order_By>;
  base_unit_price_in_micros?: InputMaybe<Order_By>;
  order_quantity?: InputMaybe<Order_By>;
  ship_quantity?: InputMaybe<Order_By>;
  unit_cost_in_micros?: InputMaybe<Order_By>;
  unit_price_in_micros?: InputMaybe<Order_By>;
  unit_tax_in_micros?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "order_invoice_line_items" */
export type Order_Invoice_Line_Items_Stddev_Samp_Order_By = {
  base_quantity?: InputMaybe<Order_By>;
  base_unit_price_in_micros?: InputMaybe<Order_By>;
  order_quantity?: InputMaybe<Order_By>;
  ship_quantity?: InputMaybe<Order_By>;
  unit_cost_in_micros?: InputMaybe<Order_By>;
  unit_price_in_micros?: InputMaybe<Order_By>;
  unit_tax_in_micros?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "order_invoice_line_items" */
export type Order_Invoice_Line_Items_Sum_Order_By = {
  base_quantity?: InputMaybe<Order_By>;
  base_unit_price_in_micros?: InputMaybe<Order_By>;
  order_quantity?: InputMaybe<Order_By>;
  ship_quantity?: InputMaybe<Order_By>;
  unit_cost_in_micros?: InputMaybe<Order_By>;
  unit_price_in_micros?: InputMaybe<Order_By>;
  unit_tax_in_micros?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "order_invoice_line_items" */
export type Order_Invoice_Line_Items_Var_Pop_Order_By = {
  base_quantity?: InputMaybe<Order_By>;
  base_unit_price_in_micros?: InputMaybe<Order_By>;
  order_quantity?: InputMaybe<Order_By>;
  ship_quantity?: InputMaybe<Order_By>;
  unit_cost_in_micros?: InputMaybe<Order_By>;
  unit_price_in_micros?: InputMaybe<Order_By>;
  unit_tax_in_micros?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "order_invoice_line_items" */
export type Order_Invoice_Line_Items_Var_Samp_Order_By = {
  base_quantity?: InputMaybe<Order_By>;
  base_unit_price_in_micros?: InputMaybe<Order_By>;
  order_quantity?: InputMaybe<Order_By>;
  ship_quantity?: InputMaybe<Order_By>;
  unit_cost_in_micros?: InputMaybe<Order_By>;
  unit_price_in_micros?: InputMaybe<Order_By>;
  unit_tax_in_micros?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "order_invoice_line_items" */
export type Order_Invoice_Line_Items_Variance_Order_By = {
  base_quantity?: InputMaybe<Order_By>;
  base_unit_price_in_micros?: InputMaybe<Order_By>;
  order_quantity?: InputMaybe<Order_By>;
  ship_quantity?: InputMaybe<Order_By>;
  unit_cost_in_micros?: InputMaybe<Order_By>;
  unit_price_in_micros?: InputMaybe<Order_By>;
  unit_tax_in_micros?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_invoice_status" */
export type Order_Invoice_Status = Node & {
  __typename?: 'order_invoice_status';
  balance_in_micros?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['ID']['output'];
  order_invoice_uuid: Scalars['uuid']['output'];
  use_pepper_balance: Scalars['Boolean']['output'];
  uuid: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "order_invoice_status". All fields are combined with a logical 'AND'. */
export type Order_Invoice_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Invoice_Status_Bool_Exp>>;
  _not?: InputMaybe<Order_Invoice_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Invoice_Status_Bool_Exp>>;
  balance_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  order_invoice_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  use_pepper_balance?: InputMaybe<Boolean_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "order_invoice_status". */
export type Order_Invoice_Status_Order_By = {
  balance_in_micros?: InputMaybe<Order_By>;
  order_invoice_uuid?: InputMaybe<Order_By>;
  use_pepper_balance?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_invoices" */
export type Order_Invoices = Node & {
  __typename?: 'order_invoices';
  balance_in_micros?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  chat?: Maybe<Chats>;
  chat_uuid?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  customer_id?: Maybe<Scalars['String']['output']>;
  delivery_date?: Maybe<Scalars['date']['output']>;
  document_url?: Maybe<Scalars['String']['output']>;
  due_at?: Maybe<Scalars['timestamptz']['output']>;
  erp_balance_in_micros?: Maybe<Scalars['bigint']['output']>;
  erp_order_placed_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['ID']['output'];
  integration_id?: Maybe<Scalars['String']['output']>;
  invoice_date: Scalars['timestamptz']['output'];
  invoice_number?: Maybe<Scalars['String']['output']>;
  invoice_source?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  order?: Maybe<Orders>;
  /** An object relationship */
  order_invoice_check_in?: Maybe<Order_Invoice_Check_Ins>;
  /** An array relationship */
  order_invoice_line_items: Array<Order_Invoice_Line_Items>;
  /** An array relationship connection */
  order_invoice_line_items_connection: Order_Invoice_Line_ItemsConnection;
  /** An object relationship */
  order_invoice_status?: Maybe<Order_Invoice_Status>;
  /** An array relationship */
  order_invoices_orders: Array<Order_Invoices_Orders>;
  /** An array relationship connection */
  order_invoices_orders_connection: Order_Invoices_OrdersConnection;
  order_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  payment_batch_line_items: Array<Payment_Batch_Line_Items>;
  /** An array relationship connection */
  payment_batch_line_items_connection: Payment_Batch_Line_ItemsConnection;
  seen: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  /** An object relationship */
  supplier?: Maybe<Businesses>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "order_invoices" */
export type Order_InvoicesOrder_Invoice_Line_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Order_Invoice_Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoice_Line_Items_Order_By>>;
  where?: InputMaybe<Order_Invoice_Line_Items_Bool_Exp>;
};


/** columns and relationships of "order_invoices" */
export type Order_InvoicesOrder_Invoice_Line_Items_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Invoice_Line_Items_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoice_Line_Items_Order_By>>;
  where?: InputMaybe<Order_Invoice_Line_Items_Bool_Exp>;
};


/** columns and relationships of "order_invoices" */
export type Order_InvoicesOrder_Invoices_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Order_Invoices_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoices_Orders_Order_By>>;
  where?: InputMaybe<Order_Invoices_Orders_Bool_Exp>;
};


/** columns and relationships of "order_invoices" */
export type Order_InvoicesOrder_Invoices_Orders_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Invoices_Orders_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoices_Orders_Order_By>>;
  where?: InputMaybe<Order_Invoices_Orders_Bool_Exp>;
};


/** columns and relationships of "order_invoices" */
export type Order_InvoicesPayment_Batch_Line_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Batch_Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Batch_Line_Items_Order_By>>;
  where?: InputMaybe<Payment_Batch_Line_Items_Bool_Exp>;
};


/** columns and relationships of "order_invoices" */
export type Order_InvoicesPayment_Batch_Line_Items_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Payment_Batch_Line_Items_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Batch_Line_Items_Order_By>>;
  where?: InputMaybe<Payment_Batch_Line_Items_Bool_Exp>;
};

/** A Relay connection object on "order_invoices" */
export type Order_InvoicesConnection = {
  __typename?: 'order_invoicesConnection';
  edges: Array<Order_InvoicesEdge>;
  pageInfo: PageInfo;
};

export type Order_InvoicesEdge = {
  __typename?: 'order_invoicesEdge';
  cursor: Scalars['String']['output'];
  node: Order_Invoices;
};

/** aggregated selection of "order_invoices" */
export type Order_Invoices_Aggregate = {
  __typename?: 'order_invoices_aggregate';
  aggregate?: Maybe<Order_Invoices_Aggregate_Fields>;
  nodes: Array<Order_Invoices>;
};

/** aggregate fields of "order_invoices" */
export type Order_Invoices_Aggregate_Fields = {
  __typename?: 'order_invoices_aggregate_fields';
  avg?: Maybe<Order_Invoices_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Order_Invoices_Max_Fields>;
  min?: Maybe<Order_Invoices_Min_Fields>;
  stddev?: Maybe<Order_Invoices_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Invoices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Invoices_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Invoices_Sum_Fields>;
  var_pop?: Maybe<Order_Invoices_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Invoices_Var_Samp_Fields>;
  variance?: Maybe<Order_Invoices_Variance_Fields>;
};


/** aggregate fields of "order_invoices" */
export type Order_Invoices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Invoices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "order_invoices" */
export type Order_Invoices_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Invoices_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Invoices_Max_Order_By>;
  min?: InputMaybe<Order_Invoices_Min_Order_By>;
  stddev?: InputMaybe<Order_Invoices_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Invoices_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Invoices_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Invoices_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Invoices_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Invoices_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Invoices_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Order_Invoices_Avg_Fields = {
  __typename?: 'order_invoices_avg_fields';
  balance_in_micros?: Maybe<Scalars['Float']['output']>;
  erp_balance_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "order_invoices" */
export type Order_Invoices_Avg_Order_By = {
  balance_in_micros?: InputMaybe<Order_By>;
  erp_balance_in_micros?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_invoices". All fields are combined with a logical 'AND'. */
export type Order_Invoices_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Invoices_Bool_Exp>>;
  _not?: InputMaybe<Order_Invoices_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Invoices_Bool_Exp>>;
  balance_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  chat?: InputMaybe<Chats_Bool_Exp>;
  chat_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer_id?: InputMaybe<String_Comparison_Exp>;
  delivery_date?: InputMaybe<Date_Comparison_Exp>;
  document_url?: InputMaybe<String_Comparison_Exp>;
  due_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  erp_balance_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  erp_order_placed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  integration_id?: InputMaybe<String_Comparison_Exp>;
  invoice_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  invoice_number?: InputMaybe<String_Comparison_Exp>;
  invoice_source?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_invoice_check_in?: InputMaybe<Order_Invoice_Check_Ins_Bool_Exp>;
  order_invoice_line_items?: InputMaybe<Order_Invoice_Line_Items_Bool_Exp>;
  order_invoice_status?: InputMaybe<Order_Invoice_Status_Bool_Exp>;
  order_invoices_orders?: InputMaybe<Order_Invoices_Orders_Bool_Exp>;
  order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  payment_batch_line_items?: InputMaybe<Payment_Batch_Line_Items_Bool_Exp>;
  seen?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Order_Invoices_Max_Fields = {
  __typename?: 'order_invoices_max_fields';
  balance_in_micros?: Maybe<Scalars['bigint']['output']>;
  chat_uuid?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  customer_id?: Maybe<Scalars['String']['output']>;
  delivery_date?: Maybe<Scalars['date']['output']>;
  document_url?: Maybe<Scalars['String']['output']>;
  due_at?: Maybe<Scalars['timestamptz']['output']>;
  erp_balance_in_micros?: Maybe<Scalars['bigint']['output']>;
  erp_order_placed_at?: Maybe<Scalars['timestamptz']['output']>;
  integration_id?: Maybe<Scalars['String']['output']>;
  invoice_date?: Maybe<Scalars['timestamptz']['output']>;
  invoice_number?: Maybe<Scalars['String']['output']>;
  invoice_source?: Maybe<Scalars['String']['output']>;
  order_uuid?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "order_invoices" */
export type Order_Invoices_Max_Order_By = {
  balance_in_micros?: InputMaybe<Order_By>;
  chat_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  delivery_date?: InputMaybe<Order_By>;
  document_url?: InputMaybe<Order_By>;
  due_at?: InputMaybe<Order_By>;
  erp_balance_in_micros?: InputMaybe<Order_By>;
  erp_order_placed_at?: InputMaybe<Order_By>;
  integration_id?: InputMaybe<Order_By>;
  invoice_date?: InputMaybe<Order_By>;
  invoice_number?: InputMaybe<Order_By>;
  invoice_source?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Invoices_Min_Fields = {
  __typename?: 'order_invoices_min_fields';
  balance_in_micros?: Maybe<Scalars['bigint']['output']>;
  chat_uuid?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  customer_id?: Maybe<Scalars['String']['output']>;
  delivery_date?: Maybe<Scalars['date']['output']>;
  document_url?: Maybe<Scalars['String']['output']>;
  due_at?: Maybe<Scalars['timestamptz']['output']>;
  erp_balance_in_micros?: Maybe<Scalars['bigint']['output']>;
  erp_order_placed_at?: Maybe<Scalars['timestamptz']['output']>;
  integration_id?: Maybe<Scalars['String']['output']>;
  invoice_date?: Maybe<Scalars['timestamptz']['output']>;
  invoice_number?: Maybe<Scalars['String']['output']>;
  invoice_source?: Maybe<Scalars['String']['output']>;
  order_uuid?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "order_invoices" */
export type Order_Invoices_Min_Order_By = {
  balance_in_micros?: InputMaybe<Order_By>;
  chat_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  delivery_date?: InputMaybe<Order_By>;
  document_url?: InputMaybe<Order_By>;
  due_at?: InputMaybe<Order_By>;
  erp_balance_in_micros?: InputMaybe<Order_By>;
  erp_order_placed_at?: InputMaybe<Order_By>;
  integration_id?: InputMaybe<Order_By>;
  invoice_date?: InputMaybe<Order_By>;
  invoice_number?: InputMaybe<Order_By>;
  invoice_source?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_invoices" */
export type Order_Invoices_Mutation_Response = {
  __typename?: 'order_invoices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Invoices>;
};

/** Ordering options when selecting data from "order_invoices". */
export type Order_Invoices_Order_By = {
  balance_in_micros?: InputMaybe<Order_By>;
  chat?: InputMaybe<Chats_Order_By>;
  chat_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  delivery_date?: InputMaybe<Order_By>;
  document_url?: InputMaybe<Order_By>;
  due_at?: InputMaybe<Order_By>;
  erp_balance_in_micros?: InputMaybe<Order_By>;
  erp_order_placed_at?: InputMaybe<Order_By>;
  integration_id?: InputMaybe<Order_By>;
  invoice_date?: InputMaybe<Order_By>;
  invoice_number?: InputMaybe<Order_By>;
  invoice_source?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_invoice_check_in?: InputMaybe<Order_Invoice_Check_Ins_Order_By>;
  order_invoice_line_items_aggregate?: InputMaybe<Order_Invoice_Line_Items_Aggregate_Order_By>;
  order_invoice_status?: InputMaybe<Order_Invoice_Status_Order_By>;
  order_invoices_orders_aggregate?: InputMaybe<Order_Invoices_Orders_Aggregate_Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  payment_batch_line_items_aggregate?: InputMaybe<Payment_Batch_Line_Items_Aggregate_Order_By>;
  seen?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_invoices_orders" */
export type Order_Invoices_Orders = Node & {
  __typename?: 'order_invoices_orders';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['ID']['output'];
  /** An object relationship */
  order: Orders;
  /** An object relationship */
  order_invoice: Order_Invoices;
  order_invoice_uuid: Scalars['uuid']['output'];
  order_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "order_invoices_orders" */
export type Order_Invoices_OrdersConnection = {
  __typename?: 'order_invoices_ordersConnection';
  edges: Array<Order_Invoices_OrdersEdge>;
  pageInfo: PageInfo;
};

export type Order_Invoices_OrdersEdge = {
  __typename?: 'order_invoices_ordersEdge';
  cursor: Scalars['String']['output'];
  node: Order_Invoices_Orders;
};

/** order by aggregate values of table "order_invoices_orders" */
export type Order_Invoices_Orders_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Invoices_Orders_Max_Order_By>;
  min?: InputMaybe<Order_Invoices_Orders_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "order_invoices_orders". All fields are combined with a logical 'AND'. */
export type Order_Invoices_Orders_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Invoices_Orders_Bool_Exp>>;
  _not?: InputMaybe<Order_Invoices_Orders_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Invoices_Orders_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_invoice?: InputMaybe<Order_Invoices_Bool_Exp>;
  order_invoice_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "order_invoices_orders" */
export type Order_Invoices_Orders_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  order_invoice_uuid?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_invoices_orders" */
export type Order_Invoices_Orders_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  order_invoice_uuid?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_invoices_orders". */
export type Order_Invoices_Orders_Order_By = {
  created_at?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_invoice?: InputMaybe<Order_Invoices_Order_By>;
  order_invoice_uuid?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "order_invoices_orders" */
export enum Order_Invoices_Orders_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  OrderInvoiceUuid = 'order_invoice_uuid',
  /** column name */
  OrderUuid = 'order_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** primary key columns input for table: order_invoices */
export type Order_Invoices_Pk_Columns_Input = {
  uuid: Scalars['uuid']['input'];
};

/** select columns of table "order_invoices" */
export enum Order_Invoices_Select_Column {
  /** column name */
  BalanceInMicros = 'balance_in_micros',
  /** column name */
  ChatUuid = 'chat_uuid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  DeliveryDate = 'delivery_date',
  /** column name */
  DocumentUrl = 'document_url',
  /** column name */
  DueAt = 'due_at',
  /** column name */
  ErpBalanceInMicros = 'erp_balance_in_micros',
  /** column name */
  ErpOrderPlacedAt = 'erp_order_placed_at',
  /** column name */
  IntegrationId = 'integration_id',
  /** column name */
  InvoiceDate = 'invoice_date',
  /** column name */
  InvoiceNumber = 'invoice_number',
  /** column name */
  InvoiceSource = 'invoice_source',
  /** column name */
  OrderUuid = 'order_uuid',
  /** column name */
  Seen = 'seen',
  /** column name */
  Status = 'status',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "order_invoices" */
export type Order_Invoices_Set_Input = {
  seen?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Order_Invoices_Stddev_Fields = {
  __typename?: 'order_invoices_stddev_fields';
  balance_in_micros?: Maybe<Scalars['Float']['output']>;
  erp_balance_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "order_invoices" */
export type Order_Invoices_Stddev_Order_By = {
  balance_in_micros?: InputMaybe<Order_By>;
  erp_balance_in_micros?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Invoices_Stddev_Pop_Fields = {
  __typename?: 'order_invoices_stddev_pop_fields';
  balance_in_micros?: Maybe<Scalars['Float']['output']>;
  erp_balance_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "order_invoices" */
export type Order_Invoices_Stddev_Pop_Order_By = {
  balance_in_micros?: InputMaybe<Order_By>;
  erp_balance_in_micros?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Invoices_Stddev_Samp_Fields = {
  __typename?: 'order_invoices_stddev_samp_fields';
  balance_in_micros?: Maybe<Scalars['Float']['output']>;
  erp_balance_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "order_invoices" */
export type Order_Invoices_Stddev_Samp_Order_By = {
  balance_in_micros?: InputMaybe<Order_By>;
  erp_balance_in_micros?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_invoices" */
export type Order_Invoices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Invoices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Invoices_Stream_Cursor_Value_Input = {
  balance_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  chat_uuid?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  delivery_date?: InputMaybe<Scalars['date']['input']>;
  document_url?: InputMaybe<Scalars['String']['input']>;
  due_at?: InputMaybe<Scalars['timestamptz']['input']>;
  erp_balance_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  erp_order_placed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  integration_id?: InputMaybe<Scalars['String']['input']>;
  invoice_date?: InputMaybe<Scalars['timestamptz']['input']>;
  invoice_number?: InputMaybe<Scalars['String']['input']>;
  invoice_source?: InputMaybe<Scalars['String']['input']>;
  order_uuid?: InputMaybe<Scalars['uuid']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Order_Invoices_Sum_Fields = {
  __typename?: 'order_invoices_sum_fields';
  balance_in_micros?: Maybe<Scalars['bigint']['output']>;
  erp_balance_in_micros?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "order_invoices" */
export type Order_Invoices_Sum_Order_By = {
  balance_in_micros?: InputMaybe<Order_By>;
  erp_balance_in_micros?: InputMaybe<Order_By>;
};

export type Order_Invoices_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Invoices_Set_Input>;
  where: Order_Invoices_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Order_Invoices_Var_Pop_Fields = {
  __typename?: 'order_invoices_var_pop_fields';
  balance_in_micros?: Maybe<Scalars['Float']['output']>;
  erp_balance_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "order_invoices" */
export type Order_Invoices_Var_Pop_Order_By = {
  balance_in_micros?: InputMaybe<Order_By>;
  erp_balance_in_micros?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Invoices_Var_Samp_Fields = {
  __typename?: 'order_invoices_var_samp_fields';
  balance_in_micros?: Maybe<Scalars['Float']['output']>;
  erp_balance_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "order_invoices" */
export type Order_Invoices_Var_Samp_Order_By = {
  balance_in_micros?: InputMaybe<Order_By>;
  erp_balance_in_micros?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Invoices_Variance_Fields = {
  __typename?: 'order_invoices_variance_fields';
  balance_in_micros?: Maybe<Scalars['Float']['output']>;
  erp_balance_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "order_invoices" */
export type Order_Invoices_Variance_Order_By = {
  balance_in_micros?: InputMaybe<Order_By>;
  erp_balance_in_micros?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_item_price_edits" */
export type Order_Item_Price_Edits = Node & {
  __typename?: 'order_item_price_edits';
  /** An object relationship */
  approval_request?: Maybe<Order_Price_Edit_Approval_Requests>;
  approval_request_uuid?: Maybe<Scalars['uuid']['output']>;
  created_by_uuid: Scalars['uuid']['output'];
  customer_cost_in_micros?: Maybe<Scalars['bigint']['output']>;
  gross_profit_override_in_percentage?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['ID']['output'];
  /** An object relationship */
  order_item: Orders_Items;
  order_item_uuid: Scalars['uuid']['output'];
  price_override_in_micros?: Maybe<Scalars['bigint']['output']>;
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "order_item_price_edits" */
export type Order_Item_Price_EditsConnection = {
  __typename?: 'order_item_price_editsConnection';
  edges: Array<Order_Item_Price_EditsEdge>;
  pageInfo: PageInfo;
};

export type Order_Item_Price_EditsEdge = {
  __typename?: 'order_item_price_editsEdge';
  cursor: Scalars['String']['output'];
  node: Order_Item_Price_Edits;
};

/** order by aggregate values of table "order_item_price_edits" */
export type Order_Item_Price_Edits_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Item_Price_Edits_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Item_Price_Edits_Max_Order_By>;
  min?: InputMaybe<Order_Item_Price_Edits_Min_Order_By>;
  stddev?: InputMaybe<Order_Item_Price_Edits_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Item_Price_Edits_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Item_Price_Edits_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Item_Price_Edits_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Item_Price_Edits_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Item_Price_Edits_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Item_Price_Edits_Variance_Order_By>;
};

/** order by avg() on columns of table "order_item_price_edits" */
export type Order_Item_Price_Edits_Avg_Order_By = {
  customer_cost_in_micros?: InputMaybe<Order_By>;
  gross_profit_override_in_percentage?: InputMaybe<Order_By>;
  price_override_in_micros?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_item_price_edits". All fields are combined with a logical 'AND'. */
export type Order_Item_Price_Edits_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Item_Price_Edits_Bool_Exp>>;
  _not?: InputMaybe<Order_Item_Price_Edits_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Item_Price_Edits_Bool_Exp>>;
  approval_request?: InputMaybe<Order_Price_Edit_Approval_Requests_Bool_Exp>;
  approval_request_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  customer_cost_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  gross_profit_override_in_percentage?: InputMaybe<Numeric_Comparison_Exp>;
  order_item?: InputMaybe<Orders_Items_Bool_Exp>;
  order_item_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  price_override_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "order_item_price_edits" */
export type Order_Item_Price_Edits_Max_Order_By = {
  approval_request_uuid?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  customer_cost_in_micros?: InputMaybe<Order_By>;
  gross_profit_override_in_percentage?: InputMaybe<Order_By>;
  order_item_uuid?: InputMaybe<Order_By>;
  price_override_in_micros?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_item_price_edits" */
export type Order_Item_Price_Edits_Min_Order_By = {
  approval_request_uuid?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  customer_cost_in_micros?: InputMaybe<Order_By>;
  gross_profit_override_in_percentage?: InputMaybe<Order_By>;
  order_item_uuid?: InputMaybe<Order_By>;
  price_override_in_micros?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_item_price_edits". */
export type Order_Item_Price_Edits_Order_By = {
  approval_request?: InputMaybe<Order_Price_Edit_Approval_Requests_Order_By>;
  approval_request_uuid?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  customer_cost_in_micros?: InputMaybe<Order_By>;
  gross_profit_override_in_percentage?: InputMaybe<Order_By>;
  order_item?: InputMaybe<Orders_Items_Order_By>;
  order_item_uuid?: InputMaybe<Order_By>;
  price_override_in_micros?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "order_item_price_edits" */
export enum Order_Item_Price_Edits_Select_Column {
  /** column name */
  ApprovalRequestUuid = 'approval_request_uuid',
  /** column name */
  CreatedByUuid = 'created_by_uuid',
  /** column name */
  CustomerCostInMicros = 'customer_cost_in_micros',
  /** column name */
  GrossProfitOverrideInPercentage = 'gross_profit_override_in_percentage',
  /** column name */
  OrderItemUuid = 'order_item_uuid',
  /** column name */
  PriceOverrideInMicros = 'price_override_in_micros',
  /** column name */
  Uuid = 'uuid'
}

/** order by stddev() on columns of table "order_item_price_edits" */
export type Order_Item_Price_Edits_Stddev_Order_By = {
  customer_cost_in_micros?: InputMaybe<Order_By>;
  gross_profit_override_in_percentage?: InputMaybe<Order_By>;
  price_override_in_micros?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "order_item_price_edits" */
export type Order_Item_Price_Edits_Stddev_Pop_Order_By = {
  customer_cost_in_micros?: InputMaybe<Order_By>;
  gross_profit_override_in_percentage?: InputMaybe<Order_By>;
  price_override_in_micros?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "order_item_price_edits" */
export type Order_Item_Price_Edits_Stddev_Samp_Order_By = {
  customer_cost_in_micros?: InputMaybe<Order_By>;
  gross_profit_override_in_percentage?: InputMaybe<Order_By>;
  price_override_in_micros?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "order_item_price_edits" */
export type Order_Item_Price_Edits_Sum_Order_By = {
  customer_cost_in_micros?: InputMaybe<Order_By>;
  gross_profit_override_in_percentage?: InputMaybe<Order_By>;
  price_override_in_micros?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "order_item_price_edits" */
export type Order_Item_Price_Edits_Var_Pop_Order_By = {
  customer_cost_in_micros?: InputMaybe<Order_By>;
  gross_profit_override_in_percentage?: InputMaybe<Order_By>;
  price_override_in_micros?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "order_item_price_edits" */
export type Order_Item_Price_Edits_Var_Samp_Order_By = {
  customer_cost_in_micros?: InputMaybe<Order_By>;
  gross_profit_override_in_percentage?: InputMaybe<Order_By>;
  price_override_in_micros?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "order_item_price_edits" */
export type Order_Item_Price_Edits_Variance_Order_By = {
  customer_cost_in_micros?: InputMaybe<Order_By>;
  gross_profit_override_in_percentage?: InputMaybe<Order_By>;
  price_override_in_micros?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_item_prices" */
export type Order_Item_Prices = {
  __typename?: 'order_item_prices';
  base_subtotal_at_order_micros?: Maybe<Scalars['bigint']['output']>;
  currency_code?: Maybe<Scalars['String']['output']>;
  order_item_uuid?: Maybe<Scalars['uuid']['output']>;
  order_uuid?: Maybe<Scalars['uuid']['output']>;
  pack_discount_price_at_order_micros?: Maybe<Scalars['bigint']['output']>;
  pack_price_at_invoice_micros?: Maybe<Scalars['bigint']['output']>;
  pack_price_at_order_micros?: Maybe<Scalars['bigint']['output']>;
  pack_promotion_price_at_order_micros?: Maybe<Scalars['bigint']['output']>;
  pack_quantity_at_invoice?: Maybe<Scalars['float8']['output']>;
  pack_quantity_at_order?: Maybe<Scalars['float8']['output']>;
  pack_volume_price_at_order_micros?: Maybe<Scalars['bigint']['output']>;
  promotion_discount_micros?: Maybe<Scalars['bigint']['output']>;
  subtotal_at_invoice_micros?: Maybe<Scalars['bigint']['output']>;
  subtotal_at_order_micros?: Maybe<Scalars['bigint']['output']>;
  tax_at_invoice_micros?: Maybe<Scalars['bigint']['output']>;
  tax_at_order_micros?: Maybe<Scalars['bigint']['output']>;
  unit_discount_price_at_order_micros?: Maybe<Scalars['bigint']['output']>;
  unit_price_at_invoice_micros?: Maybe<Scalars['bigint']['output']>;
  unit_price_at_order_micros?: Maybe<Scalars['bigint']['output']>;
  unit_promotion_price_at_order_micros?: Maybe<Scalars['bigint']['output']>;
  unit_quantity_at_invoice?: Maybe<Scalars['float8']['output']>;
  unit_quantity_at_order?: Maybe<Scalars['float8']['output']>;
  unit_volume_price_at_order_micros?: Maybe<Scalars['bigint']['output']>;
  volume_discount_micros?: Maybe<Scalars['bigint']['output']>;
};

/** Boolean expression to filter rows from the table "order_item_prices". All fields are combined with a logical 'AND'. */
export type Order_Item_Prices_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Item_Prices_Bool_Exp>>;
  _not?: InputMaybe<Order_Item_Prices_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Item_Prices_Bool_Exp>>;
  base_subtotal_at_order_micros?: InputMaybe<Bigint_Comparison_Exp>;
  currency_code?: InputMaybe<String_Comparison_Exp>;
  order_item_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  pack_discount_price_at_order_micros?: InputMaybe<Bigint_Comparison_Exp>;
  pack_price_at_invoice_micros?: InputMaybe<Bigint_Comparison_Exp>;
  pack_price_at_order_micros?: InputMaybe<Bigint_Comparison_Exp>;
  pack_promotion_price_at_order_micros?: InputMaybe<Bigint_Comparison_Exp>;
  pack_quantity_at_invoice?: InputMaybe<Float8_Comparison_Exp>;
  pack_quantity_at_order?: InputMaybe<Float8_Comparison_Exp>;
  pack_volume_price_at_order_micros?: InputMaybe<Bigint_Comparison_Exp>;
  promotion_discount_micros?: InputMaybe<Bigint_Comparison_Exp>;
  subtotal_at_invoice_micros?: InputMaybe<Bigint_Comparison_Exp>;
  subtotal_at_order_micros?: InputMaybe<Bigint_Comparison_Exp>;
  tax_at_invoice_micros?: InputMaybe<Bigint_Comparison_Exp>;
  tax_at_order_micros?: InputMaybe<Bigint_Comparison_Exp>;
  unit_discount_price_at_order_micros?: InputMaybe<Bigint_Comparison_Exp>;
  unit_price_at_invoice_micros?: InputMaybe<Bigint_Comparison_Exp>;
  unit_price_at_order_micros?: InputMaybe<Bigint_Comparison_Exp>;
  unit_promotion_price_at_order_micros?: InputMaybe<Bigint_Comparison_Exp>;
  unit_quantity_at_invoice?: InputMaybe<Float8_Comparison_Exp>;
  unit_quantity_at_order?: InputMaybe<Float8_Comparison_Exp>;
  unit_volume_price_at_order_micros?: InputMaybe<Bigint_Comparison_Exp>;
  volume_discount_micros?: InputMaybe<Bigint_Comparison_Exp>;
};

/** Ordering options when selecting data from "order_item_prices". */
export type Order_Item_Prices_Order_By = {
  base_subtotal_at_order_micros?: InputMaybe<Order_By>;
  currency_code?: InputMaybe<Order_By>;
  order_item_uuid?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  pack_discount_price_at_order_micros?: InputMaybe<Order_By>;
  pack_price_at_invoice_micros?: InputMaybe<Order_By>;
  pack_price_at_order_micros?: InputMaybe<Order_By>;
  pack_promotion_price_at_order_micros?: InputMaybe<Order_By>;
  pack_quantity_at_invoice?: InputMaybe<Order_By>;
  pack_quantity_at_order?: InputMaybe<Order_By>;
  pack_volume_price_at_order_micros?: InputMaybe<Order_By>;
  promotion_discount_micros?: InputMaybe<Order_By>;
  subtotal_at_invoice_micros?: InputMaybe<Order_By>;
  subtotal_at_order_micros?: InputMaybe<Order_By>;
  tax_at_invoice_micros?: InputMaybe<Order_By>;
  tax_at_order_micros?: InputMaybe<Order_By>;
  unit_discount_price_at_order_micros?: InputMaybe<Order_By>;
  unit_price_at_invoice_micros?: InputMaybe<Order_By>;
  unit_price_at_order_micros?: InputMaybe<Order_By>;
  unit_promotion_price_at_order_micros?: InputMaybe<Order_By>;
  unit_quantity_at_invoice?: InputMaybe<Order_By>;
  unit_quantity_at_order?: InputMaybe<Order_By>;
  unit_volume_price_at_order_micros?: InputMaybe<Order_By>;
  volume_discount_micros?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_item_promotion_rel" */
export type Order_Item_Promotion_Rel = Node & {
  __typename?: 'order_item_promotion_rel';
  applied_count: Scalars['Int']['output'];
  discount_in_micros?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['ID']['output'];
  /** An object relationship */
  order_item: Orders_Items;
  order_item_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  promotion: Promotions;
  promotion_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "order_item_promotion_rel" */
export type Order_Item_Promotion_RelConnection = {
  __typename?: 'order_item_promotion_relConnection';
  edges: Array<Order_Item_Promotion_RelEdge>;
  pageInfo: PageInfo;
};

export type Order_Item_Promotion_RelEdge = {
  __typename?: 'order_item_promotion_relEdge';
  cursor: Scalars['String']['output'];
  node: Order_Item_Promotion_Rel;
};

/** order by aggregate values of table "order_item_promotion_rel" */
export type Order_Item_Promotion_Rel_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Item_Promotion_Rel_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Item_Promotion_Rel_Max_Order_By>;
  min?: InputMaybe<Order_Item_Promotion_Rel_Min_Order_By>;
  stddev?: InputMaybe<Order_Item_Promotion_Rel_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Item_Promotion_Rel_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Item_Promotion_Rel_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Item_Promotion_Rel_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Item_Promotion_Rel_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Item_Promotion_Rel_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Item_Promotion_Rel_Variance_Order_By>;
};

/** order by avg() on columns of table "order_item_promotion_rel" */
export type Order_Item_Promotion_Rel_Avg_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_item_promotion_rel". All fields are combined with a logical 'AND'. */
export type Order_Item_Promotion_Rel_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Item_Promotion_Rel_Bool_Exp>>;
  _not?: InputMaybe<Order_Item_Promotion_Rel_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Item_Promotion_Rel_Bool_Exp>>;
  applied_count?: InputMaybe<Int_Comparison_Exp>;
  discount_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  order_item?: InputMaybe<Orders_Items_Bool_Exp>;
  order_item_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  promotion?: InputMaybe<Promotions_Bool_Exp>;
  promotion_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "order_item_promotion_rel" */
export type Order_Item_Promotion_Rel_Max_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
  order_item_uuid?: InputMaybe<Order_By>;
  promotion_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_item_promotion_rel" */
export type Order_Item_Promotion_Rel_Min_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
  order_item_uuid?: InputMaybe<Order_By>;
  promotion_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_item_promotion_rel". */
export type Order_Item_Promotion_Rel_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
  order_item?: InputMaybe<Orders_Items_Order_By>;
  order_item_uuid?: InputMaybe<Order_By>;
  promotion?: InputMaybe<Promotions_Order_By>;
  promotion_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "order_item_promotion_rel" */
export enum Order_Item_Promotion_Rel_Select_Column {
  /** column name */
  AppliedCount = 'applied_count',
  /** column name */
  DiscountInMicros = 'discount_in_micros',
  /** column name */
  OrderItemUuid = 'order_item_uuid',
  /** column name */
  PromotionUuid = 'promotion_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** order by stddev() on columns of table "order_item_promotion_rel" */
export type Order_Item_Promotion_Rel_Stddev_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "order_item_promotion_rel" */
export type Order_Item_Promotion_Rel_Stddev_Pop_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "order_item_promotion_rel" */
export type Order_Item_Promotion_Rel_Stddev_Samp_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "order_item_promotion_rel" */
export type Order_Item_Promotion_Rel_Sum_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "order_item_promotion_rel" */
export type Order_Item_Promotion_Rel_Var_Pop_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "order_item_promotion_rel" */
export type Order_Item_Promotion_Rel_Var_Samp_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "order_item_promotion_rel" */
export type Order_Item_Promotion_Rel_Variance_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_item_ratings" */
export type Order_Item_Ratings = Node & {
  __typename?: 'order_item_ratings';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order_item_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  orders_item: Orders_Items;
  photo_url_list?: Maybe<Scalars['_text']['output']>;
  rating: Scalars['Int']['output'];
  uuid: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "order_item_ratings". All fields are combined with a logical 'AND'. */
export type Order_Item_Ratings_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Item_Ratings_Bool_Exp>>;
  _not?: InputMaybe<Order_Item_Ratings_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Item_Ratings_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  order_item_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  orders_item?: InputMaybe<Orders_Items_Bool_Exp>;
  photo_url_list?: InputMaybe<_Text_Comparison_Exp>;
  rating?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "order_item_ratings". */
export type Order_Item_Ratings_Order_By = {
  comment?: InputMaybe<Order_By>;
  order_item_uuid?: InputMaybe<Order_By>;
  orders_item?: InputMaybe<Orders_Items_Order_By>;
  photo_url_list?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_price_edit_approval_requests" */
export type Order_Price_Edit_Approval_Requests = Node & {
  __typename?: 'order_price_edit_approval_requests';
  approved_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  notified_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  order: Orders;
  /** An array relationship */
  order_item_price_edits: Array<Order_Item_Price_Edits>;
  /** An array relationship connection */
  order_item_price_edits_connection: Order_Item_Price_EditsConnection;
  order_uuid: Scalars['uuid']['output'];
  rejected_at?: Maybe<Scalars['timestamptz']['output']>;
  review_note?: Maybe<Scalars['String']['output']>;
  reviewed_by_uuid?: Maybe<Scalars['uuid']['output']>;
  submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "order_price_edit_approval_requests" */
export type Order_Price_Edit_Approval_RequestsOrder_Item_Price_EditsArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Price_Edits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Item_Price_Edits_Order_By>>;
  where?: InputMaybe<Order_Item_Price_Edits_Bool_Exp>;
};


/** columns and relationships of "order_price_edit_approval_requests" */
export type Order_Price_Edit_Approval_RequestsOrder_Item_Price_Edits_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Item_Price_Edits_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Item_Price_Edits_Order_By>>;
  where?: InputMaybe<Order_Item_Price_Edits_Bool_Exp>;
};

/** A Relay connection object on "order_price_edit_approval_requests" */
export type Order_Price_Edit_Approval_RequestsConnection = {
  __typename?: 'order_price_edit_approval_requestsConnection';
  edges: Array<Order_Price_Edit_Approval_RequestsEdge>;
  pageInfo: PageInfo;
};

export type Order_Price_Edit_Approval_RequestsEdge = {
  __typename?: 'order_price_edit_approval_requestsEdge';
  cursor: Scalars['String']['output'];
  node: Order_Price_Edit_Approval_Requests;
};

/** order by aggregate values of table "order_price_edit_approval_requests" */
export type Order_Price_Edit_Approval_Requests_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Price_Edit_Approval_Requests_Max_Order_By>;
  min?: InputMaybe<Order_Price_Edit_Approval_Requests_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "order_price_edit_approval_requests". All fields are combined with a logical 'AND'. */
export type Order_Price_Edit_Approval_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Price_Edit_Approval_Requests_Bool_Exp>>;
  _not?: InputMaybe<Order_Price_Edit_Approval_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Price_Edit_Approval_Requests_Bool_Exp>>;
  approved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  notified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_item_price_edits?: InputMaybe<Order_Item_Price_Edits_Bool_Exp>;
  order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  rejected_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  review_note?: InputMaybe<String_Comparison_Exp>;
  reviewed_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "order_price_edit_approval_requests" */
export type Order_Price_Edit_Approval_Requests_Max_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  notified_at?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  rejected_at?: InputMaybe<Order_By>;
  review_note?: InputMaybe<Order_By>;
  reviewed_by_uuid?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_price_edit_approval_requests" */
export type Order_Price_Edit_Approval_Requests_Min_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  notified_at?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  rejected_at?: InputMaybe<Order_By>;
  review_note?: InputMaybe<Order_By>;
  reviewed_by_uuid?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_price_edit_approval_requests". */
export type Order_Price_Edit_Approval_Requests_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  notified_at?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_item_price_edits_aggregate?: InputMaybe<Order_Item_Price_Edits_Aggregate_Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  rejected_at?: InputMaybe<Order_By>;
  review_note?: InputMaybe<Order_By>;
  reviewed_by_uuid?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "order_price_edit_approval_requests" */
export enum Order_Price_Edit_Approval_Requests_Select_Column {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  CreatedByUuid = 'created_by_uuid',
  /** column name */
  NotifiedAt = 'notified_at',
  /** column name */
  OrderUuid = 'order_uuid',
  /** column name */
  RejectedAt = 'rejected_at',
  /** column name */
  ReviewNote = 'review_note',
  /** column name */
  ReviewedByUuid = 'reviewed_by_uuid',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  Uuid = 'uuid'
}

/** columns and relationships of "order_promotion_rel" */
export type Order_Promotion_Rel = Node & {
  __typename?: 'order_promotion_rel';
  applied_count: Scalars['Int']['output'];
  discount_in_micros?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['ID']['output'];
  /** An object relationship */
  order: Orders;
  order_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  promotion: Promotions;
  promotion_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "order_promotion_rel" */
export type Order_Promotion_RelConnection = {
  __typename?: 'order_promotion_relConnection';
  edges: Array<Order_Promotion_RelEdge>;
  pageInfo: PageInfo;
};

export type Order_Promotion_RelEdge = {
  __typename?: 'order_promotion_relEdge';
  cursor: Scalars['String']['output'];
  node: Order_Promotion_Rel;
};

/** order by aggregate values of table "order_promotion_rel" */
export type Order_Promotion_Rel_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Promotion_Rel_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Promotion_Rel_Max_Order_By>;
  min?: InputMaybe<Order_Promotion_Rel_Min_Order_By>;
  stddev?: InputMaybe<Order_Promotion_Rel_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Promotion_Rel_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Promotion_Rel_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Promotion_Rel_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Promotion_Rel_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Promotion_Rel_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Promotion_Rel_Variance_Order_By>;
};

/** order by avg() on columns of table "order_promotion_rel" */
export type Order_Promotion_Rel_Avg_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_promotion_rel". All fields are combined with a logical 'AND'. */
export type Order_Promotion_Rel_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Promotion_Rel_Bool_Exp>>;
  _not?: InputMaybe<Order_Promotion_Rel_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Promotion_Rel_Bool_Exp>>;
  applied_count?: InputMaybe<Int_Comparison_Exp>;
  discount_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  promotion?: InputMaybe<Promotions_Bool_Exp>;
  promotion_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "order_promotion_rel" */
export type Order_Promotion_Rel_Max_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  promotion_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_promotion_rel" */
export type Order_Promotion_Rel_Min_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  promotion_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_promotion_rel". */
export type Order_Promotion_Rel_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  promotion?: InputMaybe<Promotions_Order_By>;
  promotion_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "order_promotion_rel" */
export enum Order_Promotion_Rel_Select_Column {
  /** column name */
  AppliedCount = 'applied_count',
  /** column name */
  DiscountInMicros = 'discount_in_micros',
  /** column name */
  OrderUuid = 'order_uuid',
  /** column name */
  PromotionUuid = 'promotion_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** order by stddev() on columns of table "order_promotion_rel" */
export type Order_Promotion_Rel_Stddev_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "order_promotion_rel" */
export type Order_Promotion_Rel_Stddev_Pop_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "order_promotion_rel" */
export type Order_Promotion_Rel_Stddev_Samp_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "order_promotion_rel" */
export type Order_Promotion_Rel_Sum_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "order_promotion_rel" */
export type Order_Promotion_Rel_Var_Pop_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "order_promotion_rel" */
export type Order_Promotion_Rel_Var_Samp_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "order_promotion_rel" */
export type Order_Promotion_Rel_Variance_Order_By = {
  applied_count?: InputMaybe<Order_By>;
  discount_in_micros?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_status_updates" */
export type Order_Status_Updates = Node & {
  __typename?: 'order_status_updates';
  id: Scalars['ID']['output'];
  /** An object relationship */
  order: Orders;
  order_uuid: Scalars['uuid']['output'];
  status: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "order_status_updates". All fields are combined with a logical 'AND'. */
export type Order_Status_Updates_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Status_Updates_Bool_Exp>>;
  _not?: InputMaybe<Order_Status_Updates_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Status_Updates_Bool_Exp>>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "order_status_updates". */
export type Order_Status_Updates_Order_By = {
  order?: InputMaybe<Orders_Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_tracking" */
export type Order_Tracking = Node & {
  __typename?: 'order_tracking';
  id: Scalars['ID']['output'];
  lower_bound_delivery_datetime?: Maybe<Scalars['timestamptz']['output']>;
  order_completed_delivery_datetime?: Maybe<Scalars['timestamptz']['output']>;
  order_uuid: Scalars['uuid']['output'];
  status: Scalars['String']['output'];
  upper_bound_delivery_datetime?: Maybe<Scalars['timestamptz']['output']>;
  uuid: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "order_tracking". All fields are combined with a logical 'AND'. */
export type Order_Tracking_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Tracking_Bool_Exp>>;
  _not?: InputMaybe<Order_Tracking_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Tracking_Bool_Exp>>;
  lower_bound_delivery_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  order_completed_delivery_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  upper_bound_delivery_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "order_tracking". */
export type Order_Tracking_Order_By = {
  lower_bound_delivery_datetime?: InputMaybe<Order_By>;
  order_completed_delivery_datetime?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  upper_bound_delivery_datetime?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "orders" */
export type Orders = Node & {
  __typename?: 'orders';
  additional_input_values?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  chat: Chats;
  chat_uuid: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by: Employees;
  created_by_uuid: Scalars['uuid']['output'];
  created_source: Scalars['String']['output'];
  currency_code?: Maybe<Scalars['String']['output']>;
  customer_facing_id: Scalars['String']['output'];
  delivery_instructions?: Maybe<Scalars['String']['output']>;
  discount_codes?: Maybe<Scalars['_text']['output']>;
  fulfillment_display_name?: Maybe<Scalars['String']['output']>;
  fulfillment_timeslot_end?: Maybe<Scalars['time']['output']>;
  fulfillment_timeslot_start?: Maybe<Scalars['time']['output']>;
  fulfillment_type: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoice_photo_url_list?: Maybe<Scalars['_text']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  order?: Maybe<Orders>;
  /** An array relationship */
  order_attention_items: Array<Order_Attention_Items>;
  /** An array relationship connection */
  order_attention_items_connection: Order_Attention_ItemsConnection;
  order_domain?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  order_fees: Array<Order_Fees>;
  /** An array relationship */
  order_fulfillment_fees: Array<Order_Fulfillment_Fees>;
  /** An array relationship */
  order_invoices: Array<Order_Invoices>;
  /** An aggregate relationship */
  order_invoices_aggregate: Order_Invoices_Aggregate;
  /** An array relationship connection */
  order_invoices_connection: Order_InvoicesConnection;
  /** An array relationship */
  order_invoices_orders: Array<Order_Invoices_Orders>;
  /** An array relationship connection */
  order_invoices_orders_connection: Order_Invoices_OrdersConnection;
  /** An array relationship */
  order_price_edit_approval_requests: Array<Order_Price_Edit_Approval_Requests>;
  /** An array relationship connection */
  order_price_edit_approval_requests_connection: Order_Price_Edit_Approval_RequestsConnection;
  /** An array relationship */
  order_promotion_rels: Array<Order_Promotion_Rel>;
  /** An array relationship connection */
  order_promotion_rels_connection: Order_Promotion_RelConnection;
  /** An object relationship */
  order_tracking?: Maybe<Order_Tracking>;
  /** An array relationship */
  orders_items: Array<Orders_Items>;
  /** An aggregate relationship */
  orders_items_aggregate: Orders_Items_Aggregate;
  /** An array relationship connection */
  orders_items_connection: Orders_ItemsConnection;
  parent_order_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  parent_orders: Array<Orders>;
  /** An aggregate relationship */
  parent_orders_aggregate: Orders_Aggregate;
  /** An array relationship connection */
  parent_orders_connection: OrdersConnection;
  /** An array relationship */
  parent_smart_orders: Array<Smart_Order>;
  /** An aggregate relationship */
  parent_smart_orders_aggregate: Smart_Order_Aggregate;
  /** An array relationship connection */
  parent_smart_orders_connection: Smart_OrderConnection;
  placed_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  placed_by?: Maybe<Employees>;
  placed_by_uuid?: Maybe<Scalars['uuid']['output']>;
  po_number?: Maybe<Scalars['String']['output']>;
  rated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  rated_by?: Maybe<Employees>;
  rated_by_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  restaurant: Businesses;
  restaurant_desired_delivery_time?: Maybe<Scalars['timestamptz']['output']>;
  restaurant_uuid: Scalars['uuid']['output'];
  review_requested_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  review_requested_by?: Maybe<Employees>;
  review_requested_by_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  smart_orders: Array<Smart_Order>;
  /** An aggregate relationship */
  smart_orders_aggregate: Smart_Order_Aggregate;
  /** An array relationship connection */
  smart_orders_connection: Smart_OrderConnection;
  status: Scalars['String']['output'];
  /** An object relationship */
  storefront_metadata?: Maybe<Storefront_Order_Metadata>;
  /** An object relationship */
  supplier: Businesses;
  supplier_accepted_delivery_time?: Maybe<Scalars['timestamptz']['output']>;
  supplier_uuid: Scalars['uuid']['output'];
  total_discount_in_micros?: Maybe<Scalars['bigint']['output']>;
  total_tax_in_micros?: Maybe<Scalars['bigint']['output']>;
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "orders" */
export type OrdersAdditional_Input_ValuesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Attention_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Order_Attention_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Attention_Items_Order_By>>;
  where?: InputMaybe<Order_Attention_Items_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Attention_Items_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Attention_Items_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Attention_Items_Order_By>>;
  where?: InputMaybe<Order_Attention_Items_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_FeesArgs = {
  distinct_on?: InputMaybe<Array<Order_Fees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Fees_Order_By>>;
  where?: InputMaybe<Order_Fees_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Fulfillment_FeesArgs = {
  distinct_on?: InputMaybe<Array<Order_Fulfillment_Fees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Fulfillment_Fees_Order_By>>;
  where?: InputMaybe<Order_Fulfillment_Fees_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_InvoicesArgs = {
  distinct_on?: InputMaybe<Array<Order_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoices_Order_By>>;
  where?: InputMaybe<Order_Invoices_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Invoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoices_Order_By>>;
  where?: InputMaybe<Order_Invoices_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Invoices_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Invoices_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoices_Order_By>>;
  where?: InputMaybe<Order_Invoices_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Invoices_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Order_Invoices_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoices_Orders_Order_By>>;
  where?: InputMaybe<Order_Invoices_Orders_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Invoices_Orders_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Invoices_Orders_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoices_Orders_Order_By>>;
  where?: InputMaybe<Order_Invoices_Orders_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Price_Edit_Approval_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Order_Price_Edit_Approval_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Price_Edit_Approval_Requests_Order_By>>;
  where?: InputMaybe<Order_Price_Edit_Approval_Requests_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Price_Edit_Approval_Requests_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Price_Edit_Approval_Requests_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Price_Edit_Approval_Requests_Order_By>>;
  where?: InputMaybe<Order_Price_Edit_Approval_Requests_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Promotion_RelsArgs = {
  distinct_on?: InputMaybe<Array<Order_Promotion_Rel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Promotion_Rel_Order_By>>;
  where?: InputMaybe<Order_Promotion_Rel_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Promotion_Rels_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Promotion_Rel_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Promotion_Rel_Order_By>>;
  where?: InputMaybe<Order_Promotion_Rel_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrders_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Orders_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Items_Order_By>>;
  where?: InputMaybe<Orders_Items_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrders_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Items_Order_By>>;
  where?: InputMaybe<Orders_Items_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrders_Items_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Orders_Items_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Items_Order_By>>;
  where?: InputMaybe<Orders_Items_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersParent_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersParent_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersParent_Orders_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersParent_Smart_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Smart_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Order_By>>;
  where?: InputMaybe<Smart_Order_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersParent_Smart_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Smart_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Order_By>>;
  where?: InputMaybe<Smart_Order_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersParent_Smart_Orders_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Smart_Order_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Order_By>>;
  where?: InputMaybe<Smart_Order_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersSmart_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Smart_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Order_By>>;
  where?: InputMaybe<Smart_Order_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersSmart_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Smart_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Order_By>>;
  where?: InputMaybe<Smart_Order_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersSmart_Orders_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Smart_Order_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Order_By>>;
  where?: InputMaybe<Smart_Order_Bool_Exp>;
};

/** A Relay connection object on "orders" */
export type OrdersConnection = {
  __typename?: 'ordersConnection';
  edges: Array<OrdersEdge>;
  pageInfo: PageInfo;
};

export type OrdersEdge = {
  __typename?: 'ordersEdge';
  cursor: Scalars['String']['output'];
  node: Orders;
};

/** aggregated selection of "orders" */
export type Orders_Aggregate = {
  __typename?: 'orders_aggregate';
  aggregate?: Maybe<Orders_Aggregate_Fields>;
  nodes: Array<Orders>;
};

/** aggregate fields of "orders" */
export type Orders_Aggregate_Fields = {
  __typename?: 'orders_aggregate_fields';
  avg?: Maybe<Orders_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Orders_Max_Fields>;
  min?: Maybe<Orders_Min_Fields>;
  stddev?: Maybe<Orders_Stddev_Fields>;
  stddev_pop?: Maybe<Orders_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Orders_Stddev_Samp_Fields>;
  sum?: Maybe<Orders_Sum_Fields>;
  var_pop?: Maybe<Orders_Var_Pop_Fields>;
  var_samp?: Maybe<Orders_Var_Samp_Fields>;
  variance?: Maybe<Orders_Variance_Fields>;
};


/** aggregate fields of "orders" */
export type Orders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Orders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "orders" */
export type Orders_Aggregate_Order_By = {
  avg?: InputMaybe<Orders_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Orders_Max_Order_By>;
  min?: InputMaybe<Orders_Min_Order_By>;
  stddev?: InputMaybe<Orders_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Orders_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Orders_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Orders_Sum_Order_By>;
  var_pop?: InputMaybe<Orders_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Orders_Var_Samp_Order_By>;
  variance?: InputMaybe<Orders_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Orders_Avg_Fields = {
  __typename?: 'orders_avg_fields';
  total_discount_in_micros?: Maybe<Scalars['Float']['output']>;
  total_tax_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "orders" */
export type Orders_Avg_Order_By = {
  total_discount_in_micros?: InputMaybe<Order_By>;
  total_tax_in_micros?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "orders". All fields are combined with a logical 'AND'. */
export type Orders_Bool_Exp = {
  _and?: InputMaybe<Array<Orders_Bool_Exp>>;
  _not?: InputMaybe<Orders_Bool_Exp>;
  _or?: InputMaybe<Array<Orders_Bool_Exp>>;
  additional_input_values?: InputMaybe<Jsonb_Comparison_Exp>;
  chat?: InputMaybe<Chats_Bool_Exp>;
  chat_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Employees_Bool_Exp>;
  created_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  created_source?: InputMaybe<String_Comparison_Exp>;
  currency_code?: InputMaybe<String_Comparison_Exp>;
  customer_facing_id?: InputMaybe<String_Comparison_Exp>;
  delivery_instructions?: InputMaybe<String_Comparison_Exp>;
  discount_codes?: InputMaybe<_Text_Comparison_Exp>;
  fulfillment_display_name?: InputMaybe<String_Comparison_Exp>;
  fulfillment_timeslot_end?: InputMaybe<Time_Comparison_Exp>;
  fulfillment_timeslot_start?: InputMaybe<Time_Comparison_Exp>;
  fulfillment_type?: InputMaybe<String_Comparison_Exp>;
  invoice_photo_url_list?: InputMaybe<_Text_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_attention_items?: InputMaybe<Order_Attention_Items_Bool_Exp>;
  order_domain?: InputMaybe<String_Comparison_Exp>;
  order_fees?: InputMaybe<Order_Fees_Bool_Exp>;
  order_fulfillment_fees?: InputMaybe<Order_Fulfillment_Fees_Bool_Exp>;
  order_invoices?: InputMaybe<Order_Invoices_Bool_Exp>;
  order_invoices_orders?: InputMaybe<Order_Invoices_Orders_Bool_Exp>;
  order_price_edit_approval_requests?: InputMaybe<Order_Price_Edit_Approval_Requests_Bool_Exp>;
  order_promotion_rels?: InputMaybe<Order_Promotion_Rel_Bool_Exp>;
  order_tracking?: InputMaybe<Order_Tracking_Bool_Exp>;
  orders_items?: InputMaybe<Orders_Items_Bool_Exp>;
  parent_order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  parent_orders?: InputMaybe<Orders_Bool_Exp>;
  parent_smart_orders?: InputMaybe<Smart_Order_Bool_Exp>;
  placed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  placed_by?: InputMaybe<Employees_Bool_Exp>;
  placed_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  po_number?: InputMaybe<String_Comparison_Exp>;
  rated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  rated_by?: InputMaybe<Employees_Bool_Exp>;
  rated_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  restaurant?: InputMaybe<Businesses_Bool_Exp>;
  restaurant_desired_delivery_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  review_requested_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  review_requested_by?: InputMaybe<Employees_Bool_Exp>;
  review_requested_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  smart_orders?: InputMaybe<Smart_Order_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  storefront_metadata?: InputMaybe<Storefront_Order_Metadata_Bool_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_accepted_delivery_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  total_discount_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  total_tax_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "orders_items" */
export type Orders_Items = Node & {
  __typename?: 'orders_items';
  added_at: Scalars['timestamptz']['output'];
  added_by_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  cart_details_at_invoice?: Maybe<Cart_Details>;
  cart_details_at_invoice_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  cart_details_at_supplier_acceptance?: Maybe<Cart_Details>;
  cart_details_at_supplier_acceptance_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  cart_details_at_time_of_order: Cart_Details;
  cart_details_at_time_of_order_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  cart_details_for_pricing_pack?: Maybe<Cart_Details>;
  cart_details_for_pricing_pack_uuid?: Maybe<Scalars['uuid']['output']>;
  earliest_fulfillment_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  order: Orders;
  /** An array relationship */
  order_attention_items: Array<Order_Attention_Items>;
  /** An array relationship connection */
  order_attention_items_connection: Order_Attention_ItemsConnection;
  /** An object relationship */
  order_item_prices?: Maybe<Order_Item_Prices>;
  /** An array relationship */
  order_item_promotion_rels: Array<Order_Item_Promotion_Rel>;
  /** An array relationship connection */
  order_item_promotion_rels_connection: Order_Item_Promotion_RelConnection;
  /** An object relationship */
  order_item_rating?: Maybe<Order_Item_Ratings>;
  order_uuid: Scalars['uuid']['output'];
  /** An array relationship */
  orders_items_modifier_options: Array<Orders_Items_Modifier_Options>;
  /** An array relationship connection */
  orders_items_modifier_options_connection: Orders_Items_Modifier_OptionsConnection;
  /** An object relationship */
  pack: Packs;
  pack_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  price_edit?: Maybe<Order_Item_Price_Edits>;
  /** An object relationship */
  pricing_pack?: Maybe<Packs>;
  pricing_pack_uuid?: Maybe<Scalars['uuid']['output']>;
  restaurant_display_name: Scalars['String']['output'];
  /** An object relationship */
  restaurant_variant_pack_subscription?: Maybe<Restaurant_Variant_Pack_Subscriptions>;
  restaurant_variant_pack_subscription_uuid?: Maybe<Scalars['uuid']['output']>;
  substitution?: Maybe<Scalars['jsonb']['output']>;
  uuid: Scalars['uuid']['output'];
  variant_pack_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  variants_pack: Variants_Packs;
};


/** columns and relationships of "orders_items" */
export type Orders_ItemsOrder_Attention_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Order_Attention_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Attention_Items_Order_By>>;
  where?: InputMaybe<Order_Attention_Items_Bool_Exp>;
};


/** columns and relationships of "orders_items" */
export type Orders_ItemsOrder_Attention_Items_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Attention_Items_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Attention_Items_Order_By>>;
  where?: InputMaybe<Order_Attention_Items_Bool_Exp>;
};


/** columns and relationships of "orders_items" */
export type Orders_ItemsOrder_Item_Promotion_RelsArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Promotion_Rel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Item_Promotion_Rel_Order_By>>;
  where?: InputMaybe<Order_Item_Promotion_Rel_Bool_Exp>;
};


/** columns and relationships of "orders_items" */
export type Orders_ItemsOrder_Item_Promotion_Rels_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Item_Promotion_Rel_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Item_Promotion_Rel_Order_By>>;
  where?: InputMaybe<Order_Item_Promotion_Rel_Bool_Exp>;
};


/** columns and relationships of "orders_items" */
export type Orders_ItemsOrders_Items_Modifier_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Orders_Items_Modifier_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Items_Modifier_Options_Order_By>>;
  where?: InputMaybe<Orders_Items_Modifier_Options_Bool_Exp>;
};


/** columns and relationships of "orders_items" */
export type Orders_ItemsOrders_Items_Modifier_Options_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Orders_Items_Modifier_Options_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Items_Modifier_Options_Order_By>>;
  where?: InputMaybe<Orders_Items_Modifier_Options_Bool_Exp>;
};


/** columns and relationships of "orders_items" */
export type Orders_ItemsSubstitutionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "orders_items" */
export type Orders_ItemsConnection = {
  __typename?: 'orders_itemsConnection';
  edges: Array<Orders_ItemsEdge>;
  pageInfo: PageInfo;
};

export type Orders_ItemsEdge = {
  __typename?: 'orders_itemsEdge';
  cursor: Scalars['String']['output'];
  node: Orders_Items;
};

/** aggregated selection of "orders_items" */
export type Orders_Items_Aggregate = {
  __typename?: 'orders_items_aggregate';
  aggregate?: Maybe<Orders_Items_Aggregate_Fields>;
  nodes: Array<Orders_Items>;
};

/** aggregate fields of "orders_items" */
export type Orders_Items_Aggregate_Fields = {
  __typename?: 'orders_items_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Orders_Items_Max_Fields>;
  min?: Maybe<Orders_Items_Min_Fields>;
};


/** aggregate fields of "orders_items" */
export type Orders_Items_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Orders_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "orders_items" */
export type Orders_Items_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Orders_Items_Max_Order_By>;
  min?: InputMaybe<Orders_Items_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "orders_items". All fields are combined with a logical 'AND'. */
export type Orders_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Orders_Items_Bool_Exp>>;
  _not?: InputMaybe<Orders_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Orders_Items_Bool_Exp>>;
  added_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  added_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  cart_details_at_invoice?: InputMaybe<Cart_Details_Bool_Exp>;
  cart_details_at_invoice_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  cart_details_at_supplier_acceptance?: InputMaybe<Cart_Details_Bool_Exp>;
  cart_details_at_supplier_acceptance_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  cart_details_at_time_of_order?: InputMaybe<Cart_Details_Bool_Exp>;
  cart_details_at_time_of_order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  cart_details_for_pricing_pack?: InputMaybe<Cart_Details_Bool_Exp>;
  cart_details_for_pricing_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  earliest_fulfillment_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_attention_items?: InputMaybe<Order_Attention_Items_Bool_Exp>;
  order_item_prices?: InputMaybe<Order_Item_Prices_Bool_Exp>;
  order_item_promotion_rels?: InputMaybe<Order_Item_Promotion_Rel_Bool_Exp>;
  order_item_rating?: InputMaybe<Order_Item_Ratings_Bool_Exp>;
  order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  orders_items_modifier_options?: InputMaybe<Orders_Items_Modifier_Options_Bool_Exp>;
  pack?: InputMaybe<Packs_Bool_Exp>;
  pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  price_edit?: InputMaybe<Order_Item_Price_Edits_Bool_Exp>;
  pricing_pack?: InputMaybe<Packs_Bool_Exp>;
  pricing_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  restaurant_display_name?: InputMaybe<String_Comparison_Exp>;
  restaurant_variant_pack_subscription?: InputMaybe<Restaurant_Variant_Pack_Subscriptions_Bool_Exp>;
  restaurant_variant_pack_subscription_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  substitution?: InputMaybe<Jsonb_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variants_pack?: InputMaybe<Variants_Packs_Bool_Exp>;
};

/** aggregate max on columns */
export type Orders_Items_Max_Fields = {
  __typename?: 'orders_items_max_fields';
  added_at?: Maybe<Scalars['timestamptz']['output']>;
  added_by_uuid?: Maybe<Scalars['uuid']['output']>;
  cart_details_at_invoice_uuid?: Maybe<Scalars['uuid']['output']>;
  cart_details_at_supplier_acceptance_uuid?: Maybe<Scalars['uuid']['output']>;
  cart_details_at_time_of_order_uuid?: Maybe<Scalars['uuid']['output']>;
  cart_details_for_pricing_pack_uuid?: Maybe<Scalars['uuid']['output']>;
  earliest_fulfillment_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  order_uuid?: Maybe<Scalars['uuid']['output']>;
  pack_uuid?: Maybe<Scalars['uuid']['output']>;
  pricing_pack_uuid?: Maybe<Scalars['uuid']['output']>;
  restaurant_display_name?: Maybe<Scalars['String']['output']>;
  restaurant_variant_pack_subscription_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
  variant_pack_uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "orders_items" */
export type Orders_Items_Max_Order_By = {
  added_at?: InputMaybe<Order_By>;
  added_by_uuid?: InputMaybe<Order_By>;
  cart_details_at_invoice_uuid?: InputMaybe<Order_By>;
  cart_details_at_supplier_acceptance_uuid?: InputMaybe<Order_By>;
  cart_details_at_time_of_order_uuid?: InputMaybe<Order_By>;
  cart_details_for_pricing_pack_uuid?: InputMaybe<Order_By>;
  earliest_fulfillment_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  pack_uuid?: InputMaybe<Order_By>;
  pricing_pack_uuid?: InputMaybe<Order_By>;
  restaurant_display_name?: InputMaybe<Order_By>;
  restaurant_variant_pack_subscription_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Orders_Items_Min_Fields = {
  __typename?: 'orders_items_min_fields';
  added_at?: Maybe<Scalars['timestamptz']['output']>;
  added_by_uuid?: Maybe<Scalars['uuid']['output']>;
  cart_details_at_invoice_uuid?: Maybe<Scalars['uuid']['output']>;
  cart_details_at_supplier_acceptance_uuid?: Maybe<Scalars['uuid']['output']>;
  cart_details_at_time_of_order_uuid?: Maybe<Scalars['uuid']['output']>;
  cart_details_for_pricing_pack_uuid?: Maybe<Scalars['uuid']['output']>;
  earliest_fulfillment_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  order_uuid?: Maybe<Scalars['uuid']['output']>;
  pack_uuid?: Maybe<Scalars['uuid']['output']>;
  pricing_pack_uuid?: Maybe<Scalars['uuid']['output']>;
  restaurant_display_name?: Maybe<Scalars['String']['output']>;
  restaurant_variant_pack_subscription_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
  variant_pack_uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "orders_items" */
export type Orders_Items_Min_Order_By = {
  added_at?: InputMaybe<Order_By>;
  added_by_uuid?: InputMaybe<Order_By>;
  cart_details_at_invoice_uuid?: InputMaybe<Order_By>;
  cart_details_at_supplier_acceptance_uuid?: InputMaybe<Order_By>;
  cart_details_at_time_of_order_uuid?: InputMaybe<Order_By>;
  cart_details_for_pricing_pack_uuid?: InputMaybe<Order_By>;
  earliest_fulfillment_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  pack_uuid?: InputMaybe<Order_By>;
  pricing_pack_uuid?: InputMaybe<Order_By>;
  restaurant_display_name?: InputMaybe<Order_By>;
  restaurant_variant_pack_subscription_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "orders_items_modifier_options" */
export type Orders_Items_Modifier_Options = Node & {
  __typename?: 'orders_items_modifier_options';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order_item_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "orders_items_modifier_options" */
export type Orders_Items_Modifier_OptionsConnection = {
  __typename?: 'orders_items_modifier_optionsConnection';
  edges: Array<Orders_Items_Modifier_OptionsEdge>;
  pageInfo: PageInfo;
};

export type Orders_Items_Modifier_OptionsEdge = {
  __typename?: 'orders_items_modifier_optionsEdge';
  cursor: Scalars['String']['output'];
  node: Orders_Items_Modifier_Options;
};

/** order by aggregate values of table "orders_items_modifier_options" */
export type Orders_Items_Modifier_Options_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Orders_Items_Modifier_Options_Max_Order_By>;
  min?: InputMaybe<Orders_Items_Modifier_Options_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "orders_items_modifier_options". All fields are combined with a logical 'AND'. */
export type Orders_Items_Modifier_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Orders_Items_Modifier_Options_Bool_Exp>>;
  _not?: InputMaybe<Orders_Items_Modifier_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Orders_Items_Modifier_Options_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_item_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "orders_items_modifier_options" */
export type Orders_Items_Modifier_Options_Max_Order_By = {
  name?: InputMaybe<Order_By>;
  order_item_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "orders_items_modifier_options" */
export type Orders_Items_Modifier_Options_Min_Order_By = {
  name?: InputMaybe<Order_By>;
  order_item_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "orders_items_modifier_options". */
export type Orders_Items_Modifier_Options_Order_By = {
  name?: InputMaybe<Order_By>;
  order_item_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "orders_items_modifier_options" */
export enum Orders_Items_Modifier_Options_Select_Column {
  /** column name */
  Name = 'name',
  /** column name */
  OrderItemUuid = 'order_item_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Ordering options when selecting data from "orders_items". */
export type Orders_Items_Order_By = {
  added_at?: InputMaybe<Order_By>;
  added_by_uuid?: InputMaybe<Order_By>;
  cart_details_at_invoice?: InputMaybe<Cart_Details_Order_By>;
  cart_details_at_invoice_uuid?: InputMaybe<Order_By>;
  cart_details_at_supplier_acceptance?: InputMaybe<Cart_Details_Order_By>;
  cart_details_at_supplier_acceptance_uuid?: InputMaybe<Order_By>;
  cart_details_at_time_of_order?: InputMaybe<Cart_Details_Order_By>;
  cart_details_at_time_of_order_uuid?: InputMaybe<Order_By>;
  cart_details_for_pricing_pack?: InputMaybe<Cart_Details_Order_By>;
  cart_details_for_pricing_pack_uuid?: InputMaybe<Order_By>;
  earliest_fulfillment_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_attention_items_aggregate?: InputMaybe<Order_Attention_Items_Aggregate_Order_By>;
  order_item_prices?: InputMaybe<Order_Item_Prices_Order_By>;
  order_item_promotion_rels_aggregate?: InputMaybe<Order_Item_Promotion_Rel_Aggregate_Order_By>;
  order_item_rating?: InputMaybe<Order_Item_Ratings_Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  orders_items_modifier_options_aggregate?: InputMaybe<Orders_Items_Modifier_Options_Aggregate_Order_By>;
  pack?: InputMaybe<Packs_Order_By>;
  pack_uuid?: InputMaybe<Order_By>;
  price_edit?: InputMaybe<Order_Item_Price_Edits_Order_By>;
  pricing_pack?: InputMaybe<Packs_Order_By>;
  pricing_pack_uuid?: InputMaybe<Order_By>;
  restaurant_display_name?: InputMaybe<Order_By>;
  restaurant_variant_pack_subscription?: InputMaybe<Restaurant_Variant_Pack_Subscriptions_Order_By>;
  restaurant_variant_pack_subscription_uuid?: InputMaybe<Order_By>;
  substitution?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
  variants_pack?: InputMaybe<Variants_Packs_Order_By>;
};

/** select columns of table "orders_items" */
export enum Orders_Items_Select_Column {
  /** column name */
  AddedAt = 'added_at',
  /** column name */
  AddedByUuid = 'added_by_uuid',
  /** column name */
  CartDetailsAtInvoiceUuid = 'cart_details_at_invoice_uuid',
  /** column name */
  CartDetailsAtSupplierAcceptanceUuid = 'cart_details_at_supplier_acceptance_uuid',
  /** column name */
  CartDetailsAtTimeOfOrderUuid = 'cart_details_at_time_of_order_uuid',
  /** column name */
  CartDetailsForPricingPackUuid = 'cart_details_for_pricing_pack_uuid',
  /** column name */
  EarliestFulfillmentAt = 'earliest_fulfillment_at',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  OrderUuid = 'order_uuid',
  /** column name */
  PackUuid = 'pack_uuid',
  /** column name */
  PricingPackUuid = 'pricing_pack_uuid',
  /** column name */
  RestaurantDisplayName = 'restaurant_display_name',
  /** column name */
  RestaurantVariantPackSubscriptionUuid = 'restaurant_variant_pack_subscription_uuid',
  /** column name */
  Substitution = 'substitution',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VariantPackUuid = 'variant_pack_uuid'
}

/** Streaming cursor of the table "orders_items" */
export type Orders_Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Orders_Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Orders_Items_Stream_Cursor_Value_Input = {
  added_at?: InputMaybe<Scalars['timestamptz']['input']>;
  added_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
  cart_details_at_invoice_uuid?: InputMaybe<Scalars['uuid']['input']>;
  cart_details_at_supplier_acceptance_uuid?: InputMaybe<Scalars['uuid']['input']>;
  cart_details_at_time_of_order_uuid?: InputMaybe<Scalars['uuid']['input']>;
  cart_details_for_pricing_pack_uuid?: InputMaybe<Scalars['uuid']['input']>;
  earliest_fulfillment_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  order_uuid?: InputMaybe<Scalars['uuid']['input']>;
  pack_uuid?: InputMaybe<Scalars['uuid']['input']>;
  pricing_pack_uuid?: InputMaybe<Scalars['uuid']['input']>;
  restaurant_display_name?: InputMaybe<Scalars['String']['input']>;
  restaurant_variant_pack_subscription_uuid?: InputMaybe<Scalars['uuid']['input']>;
  substitution?: InputMaybe<Scalars['jsonb']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
  variant_pack_uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Orders_Max_Fields = {
  __typename?: 'orders_max_fields';
  chat_uuid?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_uuid?: Maybe<Scalars['uuid']['output']>;
  created_source?: Maybe<Scalars['String']['output']>;
  currency_code?: Maybe<Scalars['String']['output']>;
  customer_facing_id?: Maybe<Scalars['String']['output']>;
  delivery_instructions?: Maybe<Scalars['String']['output']>;
  fulfillment_display_name?: Maybe<Scalars['String']['output']>;
  fulfillment_type?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  order_domain?: Maybe<Scalars['String']['output']>;
  parent_order_uuid?: Maybe<Scalars['uuid']['output']>;
  placed_at?: Maybe<Scalars['timestamptz']['output']>;
  placed_by_uuid?: Maybe<Scalars['uuid']['output']>;
  po_number?: Maybe<Scalars['String']['output']>;
  rated_at?: Maybe<Scalars['timestamptz']['output']>;
  rated_by_uuid?: Maybe<Scalars['uuid']['output']>;
  restaurant_desired_delivery_time?: Maybe<Scalars['timestamptz']['output']>;
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  review_requested_at?: Maybe<Scalars['timestamptz']['output']>;
  review_requested_by_uuid?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier_accepted_delivery_time?: Maybe<Scalars['timestamptz']['output']>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  total_discount_in_micros?: Maybe<Scalars['bigint']['output']>;
  total_tax_in_micros?: Maybe<Scalars['bigint']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "orders" */
export type Orders_Max_Order_By = {
  chat_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  created_source?: InputMaybe<Order_By>;
  currency_code?: InputMaybe<Order_By>;
  customer_facing_id?: InputMaybe<Order_By>;
  delivery_instructions?: InputMaybe<Order_By>;
  fulfillment_display_name?: InputMaybe<Order_By>;
  fulfillment_type?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  order_domain?: InputMaybe<Order_By>;
  parent_order_uuid?: InputMaybe<Order_By>;
  placed_at?: InputMaybe<Order_By>;
  placed_by_uuid?: InputMaybe<Order_By>;
  po_number?: InputMaybe<Order_By>;
  rated_at?: InputMaybe<Order_By>;
  rated_by_uuid?: InputMaybe<Order_By>;
  restaurant_desired_delivery_time?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  review_requested_at?: InputMaybe<Order_By>;
  review_requested_by_uuid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_accepted_delivery_time?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  total_discount_in_micros?: InputMaybe<Order_By>;
  total_tax_in_micros?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Orders_Min_Fields = {
  __typename?: 'orders_min_fields';
  chat_uuid?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_uuid?: Maybe<Scalars['uuid']['output']>;
  created_source?: Maybe<Scalars['String']['output']>;
  currency_code?: Maybe<Scalars['String']['output']>;
  customer_facing_id?: Maybe<Scalars['String']['output']>;
  delivery_instructions?: Maybe<Scalars['String']['output']>;
  fulfillment_display_name?: Maybe<Scalars['String']['output']>;
  fulfillment_type?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  order_domain?: Maybe<Scalars['String']['output']>;
  parent_order_uuid?: Maybe<Scalars['uuid']['output']>;
  placed_at?: Maybe<Scalars['timestamptz']['output']>;
  placed_by_uuid?: Maybe<Scalars['uuid']['output']>;
  po_number?: Maybe<Scalars['String']['output']>;
  rated_at?: Maybe<Scalars['timestamptz']['output']>;
  rated_by_uuid?: Maybe<Scalars['uuid']['output']>;
  restaurant_desired_delivery_time?: Maybe<Scalars['timestamptz']['output']>;
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  review_requested_at?: Maybe<Scalars['timestamptz']['output']>;
  review_requested_by_uuid?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier_accepted_delivery_time?: Maybe<Scalars['timestamptz']['output']>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  total_discount_in_micros?: Maybe<Scalars['bigint']['output']>;
  total_tax_in_micros?: Maybe<Scalars['bigint']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "orders" */
export type Orders_Min_Order_By = {
  chat_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  created_source?: InputMaybe<Order_By>;
  currency_code?: InputMaybe<Order_By>;
  customer_facing_id?: InputMaybe<Order_By>;
  delivery_instructions?: InputMaybe<Order_By>;
  fulfillment_display_name?: InputMaybe<Order_By>;
  fulfillment_type?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  order_domain?: InputMaybe<Order_By>;
  parent_order_uuid?: InputMaybe<Order_By>;
  placed_at?: InputMaybe<Order_By>;
  placed_by_uuid?: InputMaybe<Order_By>;
  po_number?: InputMaybe<Order_By>;
  rated_at?: InputMaybe<Order_By>;
  rated_by_uuid?: InputMaybe<Order_By>;
  restaurant_desired_delivery_time?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  review_requested_at?: InputMaybe<Order_By>;
  review_requested_by_uuid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_accepted_delivery_time?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  total_discount_in_micros?: InputMaybe<Order_By>;
  total_tax_in_micros?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "orders" */
export type Orders_Mutation_Response = {
  __typename?: 'orders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Orders>;
};

/** Ordering options when selecting data from "orders". */
export type Orders_Order_By = {
  additional_input_values?: InputMaybe<Order_By>;
  chat?: InputMaybe<Chats_Order_By>;
  chat_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Employees_Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  created_source?: InputMaybe<Order_By>;
  currency_code?: InputMaybe<Order_By>;
  customer_facing_id?: InputMaybe<Order_By>;
  delivery_instructions?: InputMaybe<Order_By>;
  discount_codes?: InputMaybe<Order_By>;
  fulfillment_display_name?: InputMaybe<Order_By>;
  fulfillment_timeslot_end?: InputMaybe<Order_By>;
  fulfillment_timeslot_start?: InputMaybe<Order_By>;
  fulfillment_type?: InputMaybe<Order_By>;
  invoice_photo_url_list?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_attention_items_aggregate?: InputMaybe<Order_Attention_Items_Aggregate_Order_By>;
  order_domain?: InputMaybe<Order_By>;
  order_fees_aggregate?: InputMaybe<Order_Fees_Aggregate_Order_By>;
  order_fulfillment_fees_aggregate?: InputMaybe<Order_Fulfillment_Fees_Aggregate_Order_By>;
  order_invoices_aggregate?: InputMaybe<Order_Invoices_Aggregate_Order_By>;
  order_invoices_orders_aggregate?: InputMaybe<Order_Invoices_Orders_Aggregate_Order_By>;
  order_price_edit_approval_requests_aggregate?: InputMaybe<Order_Price_Edit_Approval_Requests_Aggregate_Order_By>;
  order_promotion_rels_aggregate?: InputMaybe<Order_Promotion_Rel_Aggregate_Order_By>;
  order_tracking?: InputMaybe<Order_Tracking_Order_By>;
  orders_items_aggregate?: InputMaybe<Orders_Items_Aggregate_Order_By>;
  parent_order_uuid?: InputMaybe<Order_By>;
  parent_orders_aggregate?: InputMaybe<Orders_Aggregate_Order_By>;
  parent_smart_orders_aggregate?: InputMaybe<Smart_Order_Aggregate_Order_By>;
  placed_at?: InputMaybe<Order_By>;
  placed_by?: InputMaybe<Employees_Order_By>;
  placed_by_uuid?: InputMaybe<Order_By>;
  po_number?: InputMaybe<Order_By>;
  rated_at?: InputMaybe<Order_By>;
  rated_by?: InputMaybe<Employees_Order_By>;
  rated_by_uuid?: InputMaybe<Order_By>;
  restaurant?: InputMaybe<Businesses_Order_By>;
  restaurant_desired_delivery_time?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  review_requested_at?: InputMaybe<Order_By>;
  review_requested_by?: InputMaybe<Employees_Order_By>;
  review_requested_by_uuid?: InputMaybe<Order_By>;
  smart_orders_aggregate?: InputMaybe<Smart_Order_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  storefront_metadata?: InputMaybe<Storefront_Order_Metadata_Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_accepted_delivery_time?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  total_discount_in_micros?: InputMaybe<Order_By>;
  total_tax_in_micros?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: orders */
export type Orders_Pk_Columns_Input = {
  uuid: Scalars['uuid']['input'];
};

/** select columns of table "orders" */
export enum Orders_Select_Column {
  /** column name */
  AdditionalInputValues = 'additional_input_values',
  /** column name */
  ChatUuid = 'chat_uuid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUuid = 'created_by_uuid',
  /** column name */
  CreatedSource = 'created_source',
  /** column name */
  CurrencyCode = 'currency_code',
  /** column name */
  CustomerFacingId = 'customer_facing_id',
  /** column name */
  DeliveryInstructions = 'delivery_instructions',
  /** column name */
  DiscountCodes = 'discount_codes',
  /** column name */
  FulfillmentDisplayName = 'fulfillment_display_name',
  /** column name */
  FulfillmentTimeslotEnd = 'fulfillment_timeslot_end',
  /** column name */
  FulfillmentTimeslotStart = 'fulfillment_timeslot_start',
  /** column name */
  FulfillmentType = 'fulfillment_type',
  /** column name */
  InvoicePhotoUrlList = 'invoice_photo_url_list',
  /** column name */
  Notes = 'notes',
  /** column name */
  OrderDomain = 'order_domain',
  /** column name */
  ParentOrderUuid = 'parent_order_uuid',
  /** column name */
  PlacedAt = 'placed_at',
  /** column name */
  PlacedByUuid = 'placed_by_uuid',
  /** column name */
  PoNumber = 'po_number',
  /** column name */
  RatedAt = 'rated_at',
  /** column name */
  RatedByUuid = 'rated_by_uuid',
  /** column name */
  RestaurantDesiredDeliveryTime = 'restaurant_desired_delivery_time',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  ReviewRequestedAt = 'review_requested_at',
  /** column name */
  ReviewRequestedByUuid = 'review_requested_by_uuid',
  /** column name */
  Status = 'status',
  /** column name */
  SupplierAcceptedDeliveryTime = 'supplier_accepted_delivery_time',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  TotalDiscountInMicros = 'total_discount_in_micros',
  /** column name */
  TotalTaxInMicros = 'total_tax_in_micros',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "orders" */
export type Orders_Set_Input = {
  fulfillment_timeslot_end?: InputMaybe<Scalars['time']['input']>;
  fulfillment_timeslot_start?: InputMaybe<Scalars['time']['input']>;
  fulfillment_type?: InputMaybe<Scalars['String']['input']>;
  restaurant_desired_delivery_time?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Orders_Stddev_Fields = {
  __typename?: 'orders_stddev_fields';
  total_discount_in_micros?: Maybe<Scalars['Float']['output']>;
  total_tax_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "orders" */
export type Orders_Stddev_Order_By = {
  total_discount_in_micros?: InputMaybe<Order_By>;
  total_tax_in_micros?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Orders_Stddev_Pop_Fields = {
  __typename?: 'orders_stddev_pop_fields';
  total_discount_in_micros?: Maybe<Scalars['Float']['output']>;
  total_tax_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "orders" */
export type Orders_Stddev_Pop_Order_By = {
  total_discount_in_micros?: InputMaybe<Order_By>;
  total_tax_in_micros?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Orders_Stddev_Samp_Fields = {
  __typename?: 'orders_stddev_samp_fields';
  total_discount_in_micros?: Maybe<Scalars['Float']['output']>;
  total_tax_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "orders" */
export type Orders_Stddev_Samp_Order_By = {
  total_discount_in_micros?: InputMaybe<Order_By>;
  total_tax_in_micros?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "orders" */
export type Orders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Orders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Orders_Stream_Cursor_Value_Input = {
  additional_input_values?: InputMaybe<Scalars['jsonb']['input']>;
  chat_uuid?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
  created_source?: InputMaybe<Scalars['String']['input']>;
  currency_code?: InputMaybe<Scalars['String']['input']>;
  customer_facing_id?: InputMaybe<Scalars['String']['input']>;
  delivery_instructions?: InputMaybe<Scalars['String']['input']>;
  discount_codes?: InputMaybe<Scalars['_text']['input']>;
  fulfillment_display_name?: InputMaybe<Scalars['String']['input']>;
  fulfillment_timeslot_end?: InputMaybe<Scalars['time']['input']>;
  fulfillment_timeslot_start?: InputMaybe<Scalars['time']['input']>;
  fulfillment_type?: InputMaybe<Scalars['String']['input']>;
  invoice_photo_url_list?: InputMaybe<Scalars['_text']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  order_domain?: InputMaybe<Scalars['String']['input']>;
  parent_order_uuid?: InputMaybe<Scalars['uuid']['input']>;
  placed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  placed_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
  po_number?: InputMaybe<Scalars['String']['input']>;
  rated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  rated_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
  restaurant_desired_delivery_time?: InputMaybe<Scalars['timestamptz']['input']>;
  restaurant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  review_requested_at?: InputMaybe<Scalars['timestamptz']['input']>;
  review_requested_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier_accepted_delivery_time?: InputMaybe<Scalars['timestamptz']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  total_discount_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  total_tax_in_micros?: InputMaybe<Scalars['bigint']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Orders_Sum_Fields = {
  __typename?: 'orders_sum_fields';
  total_discount_in_micros?: Maybe<Scalars['bigint']['output']>;
  total_tax_in_micros?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "orders" */
export type Orders_Sum_Order_By = {
  total_discount_in_micros?: InputMaybe<Order_By>;
  total_tax_in_micros?: InputMaybe<Order_By>;
};

export type Orders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Orders_Set_Input>;
  where: Orders_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Orders_Var_Pop_Fields = {
  __typename?: 'orders_var_pop_fields';
  total_discount_in_micros?: Maybe<Scalars['Float']['output']>;
  total_tax_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "orders" */
export type Orders_Var_Pop_Order_By = {
  total_discount_in_micros?: InputMaybe<Order_By>;
  total_tax_in_micros?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Orders_Var_Samp_Fields = {
  __typename?: 'orders_var_samp_fields';
  total_discount_in_micros?: Maybe<Scalars['Float']['output']>;
  total_tax_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "orders" */
export type Orders_Var_Samp_Order_By = {
  total_discount_in_micros?: InputMaybe<Order_By>;
  total_tax_in_micros?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Orders_Variance_Fields = {
  __typename?: 'orders_variance_fields';
  total_discount_in_micros?: Maybe<Scalars['Float']['output']>;
  total_tax_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "orders" */
export type Orders_Variance_Order_By = {
  total_discount_in_micros?: InputMaybe<Order_By>;
  total_tax_in_micros?: InputMaybe<Order_By>;
};

/** columns and relationships of "packs" */
export type Packs = Node & {
  __typename?: 'packs';
  base_unit?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  max_unit_size: Scalars['float8']['output'];
  min_unit_size: Scalars['float8']['output'];
  unit: Scalars['String']['output'];
  unit_count: Scalars['float8']['output'];
  uuid: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "packs". All fields are combined with a logical 'AND'. */
export type Packs_Bool_Exp = {
  _and?: InputMaybe<Array<Packs_Bool_Exp>>;
  _not?: InputMaybe<Packs_Bool_Exp>;
  _or?: InputMaybe<Array<Packs_Bool_Exp>>;
  base_unit?: InputMaybe<String_Comparison_Exp>;
  max_unit_size?: InputMaybe<Float8_Comparison_Exp>;
  min_unit_size?: InputMaybe<Float8_Comparison_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
  unit_count?: InputMaybe<Float8_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "packs". */
export type Packs_Order_By = {
  base_unit?: InputMaybe<Order_By>;
  max_unit_size?: InputMaybe<Order_By>;
  min_unit_size?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  unit_count?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "pad_payment_method" */
export type Pad_Payment_Method = Node & {
  __typename?: 'pad_payment_method';
  consent_date?: Maybe<Scalars['date']['output']>;
  id: Scalars['ID']['output'];
  payment_method_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "pad_payment_method" */
export type Pad_Payment_MethodConnection = {
  __typename?: 'pad_payment_methodConnection';
  edges: Array<Pad_Payment_MethodEdge>;
  pageInfo: PageInfo;
};

export type Pad_Payment_MethodEdge = {
  __typename?: 'pad_payment_methodEdge';
  cursor: Scalars['String']['output'];
  node: Pad_Payment_Method;
};

/** Boolean expression to filter rows from the table "pad_payment_method". All fields are combined with a logical 'AND'. */
export type Pad_Payment_Method_Bool_Exp = {
  _and?: InputMaybe<Array<Pad_Payment_Method_Bool_Exp>>;
  _not?: InputMaybe<Pad_Payment_Method_Bool_Exp>;
  _or?: InputMaybe<Array<Pad_Payment_Method_Bool_Exp>>;
  consent_date?: InputMaybe<Date_Comparison_Exp>;
  payment_method_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "pad_payment_method". */
export type Pad_Payment_Method_Order_By = {
  consent_date?: InputMaybe<Order_By>;
  payment_method_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "pad_payment_method" */
export enum Pad_Payment_Method_Select_Column {
  /** column name */
  ConsentDate = 'consent_date',
  /** column name */
  PaymentMethodUuid = 'payment_method_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "pad_payment_method" */
export type Pad_Payment_Method_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pad_Payment_Method_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pad_Payment_Method_Stream_Cursor_Value_Input = {
  consent_date?: InputMaybe<Scalars['date']['input']>;
  payment_method_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "pay_by_link_recipients" */
export type Pay_By_Link_Recipients = Node & {
  __typename?: 'pay_by_link_recipients';
  email?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  employee?: Maybe<Employees>;
  employee_uuid?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['ID']['output'];
  phone_number?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "pay_by_link_recipients". All fields are combined with a logical 'AND'. */
export type Pay_By_Link_Recipients_Bool_Exp = {
  _and?: InputMaybe<Array<Pay_By_Link_Recipients_Bool_Exp>>;
  _not?: InputMaybe<Pay_By_Link_Recipients_Bool_Exp>;
  _or?: InputMaybe<Array<Pay_By_Link_Recipients_Bool_Exp>>;
  email?: InputMaybe<String_Comparison_Exp>;
  employee?: InputMaybe<Employees_Bool_Exp>;
  employee_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "pay_by_link_recipients". */
export type Pay_By_Link_Recipients_Order_By = {
  email?: InputMaybe<Order_By>;
  employee?: InputMaybe<Employees_Order_By>;
  employee_uuid?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "payment_batch_amount" */
export type Payment_Batch_Amount = {
  __typename?: 'payment_batch_amount';
  charged_amount_in_micros?: Maybe<Scalars['bigint']['output']>;
  net_amount_in_micros?: Maybe<Scalars['bigint']['output']>;
  payment_batch_uuid?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "payment_batch_amount". All fields are combined with a logical 'AND'. */
export type Payment_Batch_Amount_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Batch_Amount_Bool_Exp>>;
  _not?: InputMaybe<Payment_Batch_Amount_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Batch_Amount_Bool_Exp>>;
  charged_amount_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  net_amount_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  payment_batch_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "payment_batch_amount". */
export type Payment_Batch_Amount_Order_By = {
  charged_amount_in_micros?: InputMaybe<Order_By>;
  net_amount_in_micros?: InputMaybe<Order_By>;
  payment_batch_uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "payment_batch_line_items" */
export type Payment_Batch_Line_Items = Node & {
  __typename?: 'payment_batch_line_items';
  amount_in_micros: Scalars['bigint']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  credit_memo?: Maybe<Credit_Memos>;
  credit_memo_uuid?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  order_invoice?: Maybe<Order_Invoices>;
  order_invoice_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  payment_batch: Payment_Batches;
  transaction_fees_type?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "payment_batch_line_items" */
export type Payment_Batch_Line_ItemsConnection = {
  __typename?: 'payment_batch_line_itemsConnection';
  edges: Array<Payment_Batch_Line_ItemsEdge>;
  pageInfo: PageInfo;
};

export type Payment_Batch_Line_ItemsEdge = {
  __typename?: 'payment_batch_line_itemsEdge';
  cursor: Scalars['String']['output'];
  node: Payment_Batch_Line_Items;
};

/** order by aggregate values of table "payment_batch_line_items" */
export type Payment_Batch_Line_Items_Aggregate_Order_By = {
  avg?: InputMaybe<Payment_Batch_Line_Items_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payment_Batch_Line_Items_Max_Order_By>;
  min?: InputMaybe<Payment_Batch_Line_Items_Min_Order_By>;
  stddev?: InputMaybe<Payment_Batch_Line_Items_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payment_Batch_Line_Items_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payment_Batch_Line_Items_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payment_Batch_Line_Items_Sum_Order_By>;
  var_pop?: InputMaybe<Payment_Batch_Line_Items_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payment_Batch_Line_Items_Var_Samp_Order_By>;
  variance?: InputMaybe<Payment_Batch_Line_Items_Variance_Order_By>;
};

/** order by avg() on columns of table "payment_batch_line_items" */
export type Payment_Batch_Line_Items_Avg_Order_By = {
  amount_in_micros?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payment_batch_line_items". All fields are combined with a logical 'AND'. */
export type Payment_Batch_Line_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Batch_Line_Items_Bool_Exp>>;
  _not?: InputMaybe<Payment_Batch_Line_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Batch_Line_Items_Bool_Exp>>;
  amount_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_memo?: InputMaybe<Credit_Memos_Bool_Exp>;
  credit_memo_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_invoice?: InputMaybe<Order_Invoices_Bool_Exp>;
  order_invoice_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  payment_batch?: InputMaybe<Payment_Batches_Bool_Exp>;
  transaction_fees_type?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "payment_batch_line_items" */
export type Payment_Batch_Line_Items_Max_Order_By = {
  amount_in_micros?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_memo_uuid?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_invoice_uuid?: InputMaybe<Order_By>;
  transaction_fees_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "payment_batch_line_items" */
export type Payment_Batch_Line_Items_Min_Order_By = {
  amount_in_micros?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_memo_uuid?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_invoice_uuid?: InputMaybe<Order_By>;
  transaction_fees_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "payment_batch_line_items". */
export type Payment_Batch_Line_Items_Order_By = {
  amount_in_micros?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_memo?: InputMaybe<Credit_Memos_Order_By>;
  credit_memo_uuid?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_invoice?: InputMaybe<Order_Invoices_Order_By>;
  order_invoice_uuid?: InputMaybe<Order_By>;
  payment_batch?: InputMaybe<Payment_Batches_Order_By>;
  transaction_fees_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "payment_batch_line_items" */
export enum Payment_Batch_Line_Items_Select_Column {
  /** column name */
  AmountInMicros = 'amount_in_micros',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditMemoUuid = 'credit_memo_uuid',
  /** column name */
  Name = 'name',
  /** column name */
  OrderInvoiceUuid = 'order_invoice_uuid',
  /** column name */
  TransactionFeesType = 'transaction_fees_type',
  /** column name */
  Type = 'type',
  /** column name */
  Uuid = 'uuid'
}

/** order by stddev() on columns of table "payment_batch_line_items" */
export type Payment_Batch_Line_Items_Stddev_Order_By = {
  amount_in_micros?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "payment_batch_line_items" */
export type Payment_Batch_Line_Items_Stddev_Pop_Order_By = {
  amount_in_micros?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "payment_batch_line_items" */
export type Payment_Batch_Line_Items_Stddev_Samp_Order_By = {
  amount_in_micros?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "payment_batch_line_items" */
export type Payment_Batch_Line_Items_Sum_Order_By = {
  amount_in_micros?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "payment_batch_line_items" */
export type Payment_Batch_Line_Items_Var_Pop_Order_By = {
  amount_in_micros?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "payment_batch_line_items" */
export type Payment_Batch_Line_Items_Var_Samp_Order_By = {
  amount_in_micros?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "payment_batch_line_items" */
export type Payment_Batch_Line_Items_Variance_Order_By = {
  amount_in_micros?: InputMaybe<Order_By>;
};

/** columns and relationships of "payment_batches" */
export type Payment_Batches = Node & {
  __typename?: 'payment_batches';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by: Employees;
  created_by_uuid: Scalars['uuid']['output'];
  customer_facing_id: Scalars['String']['output'];
  document_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  link_paid_at?: Maybe<Scalars['timestamptz']['output']>;
  link_paid_by_uuid?: Maybe<Scalars['uuid']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  paid_source: Scalars['String']['output'];
  /** An object relationship */
  pay_by_link_recipient?: Maybe<Pay_By_Link_Recipients>;
  /** Entity that receives the money */
  payee_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  payment_batch_amount?: Maybe<Payment_Batch_Amount>;
  /** An array relationship */
  payment_batch_line_items: Array<Payment_Batch_Line_Items>;
  /** An array relationship connection */
  payment_batch_line_items_connection: Payment_Batch_Line_ItemsConnection;
  payment_due_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  payment_method?: Maybe<Payment_Methods>;
  payment_method_display_text?: Maybe<Scalars['String']['output']>;
  payment_method_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  payor?: Maybe<Businesses>;
  /** Entity that pays the money */
  payor_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  restaurant?: Maybe<Businesses>;
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  result_code?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  /** An object relationship */
  supplier: Businesses;
  supplier_uuid: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "payment_batches" */
export type Payment_BatchesPayment_Batch_Line_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Batch_Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Batch_Line_Items_Order_By>>;
  where?: InputMaybe<Payment_Batch_Line_Items_Bool_Exp>;
};


/** columns and relationships of "payment_batches" */
export type Payment_BatchesPayment_Batch_Line_Items_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Payment_Batch_Line_Items_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Batch_Line_Items_Order_By>>;
  where?: InputMaybe<Payment_Batch_Line_Items_Bool_Exp>;
};

/** A Relay connection object on "payment_batches" */
export type Payment_BatchesConnection = {
  __typename?: 'payment_batchesConnection';
  edges: Array<Payment_BatchesEdge>;
  pageInfo: PageInfo;
};

export type Payment_BatchesEdge = {
  __typename?: 'payment_batchesEdge';
  cursor: Scalars['String']['output'];
  node: Payment_Batches;
};

/** aggregated selection of "payment_batches" */
export type Payment_Batches_Aggregate = {
  __typename?: 'payment_batches_aggregate';
  aggregate?: Maybe<Payment_Batches_Aggregate_Fields>;
  nodes: Array<Payment_Batches>;
};

/** aggregate fields of "payment_batches" */
export type Payment_Batches_Aggregate_Fields = {
  __typename?: 'payment_batches_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Payment_Batches_Max_Fields>;
  min?: Maybe<Payment_Batches_Min_Fields>;
};


/** aggregate fields of "payment_batches" */
export type Payment_Batches_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Batches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "payment_batches" */
export type Payment_Batches_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payment_Batches_Max_Order_By>;
  min?: InputMaybe<Payment_Batches_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "payment_batches". All fields are combined with a logical 'AND'. */
export type Payment_Batches_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Batches_Bool_Exp>>;
  _not?: InputMaybe<Payment_Batches_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Batches_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Employees_Bool_Exp>;
  created_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  customer_facing_id?: InputMaybe<String_Comparison_Exp>;
  document_url?: InputMaybe<String_Comparison_Exp>;
  link_paid_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  link_paid_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  memo?: InputMaybe<String_Comparison_Exp>;
  paid_source?: InputMaybe<String_Comparison_Exp>;
  pay_by_link_recipient?: InputMaybe<Pay_By_Link_Recipients_Bool_Exp>;
  payee_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  payment_batch_amount?: InputMaybe<Payment_Batch_Amount_Bool_Exp>;
  payment_batch_line_items?: InputMaybe<Payment_Batch_Line_Items_Bool_Exp>;
  payment_due_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  payment_method?: InputMaybe<Payment_Methods_Bool_Exp>;
  payment_method_display_text?: InputMaybe<String_Comparison_Exp>;
  payment_method_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  payor?: InputMaybe<Businesses_Bool_Exp>;
  payor_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  restaurant?: InputMaybe<Businesses_Bool_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  result_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Payment_Batches_Max_Fields = {
  __typename?: 'payment_batches_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_uuid?: Maybe<Scalars['uuid']['output']>;
  customer_facing_id?: Maybe<Scalars['String']['output']>;
  document_url?: Maybe<Scalars['String']['output']>;
  link_paid_at?: Maybe<Scalars['timestamptz']['output']>;
  link_paid_by_uuid?: Maybe<Scalars['uuid']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  paid_source?: Maybe<Scalars['String']['output']>;
  /** Entity that receives the money */
  payee_uuid?: Maybe<Scalars['uuid']['output']>;
  payment_due_at?: Maybe<Scalars['timestamptz']['output']>;
  payment_method_display_text?: Maybe<Scalars['String']['output']>;
  payment_method_uuid?: Maybe<Scalars['uuid']['output']>;
  /** Entity that pays the money */
  payor_uuid?: Maybe<Scalars['uuid']['output']>;
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  result_code?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "payment_batches" */
export type Payment_Batches_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  customer_facing_id?: InputMaybe<Order_By>;
  document_url?: InputMaybe<Order_By>;
  link_paid_at?: InputMaybe<Order_By>;
  link_paid_by_uuid?: InputMaybe<Order_By>;
  memo?: InputMaybe<Order_By>;
  paid_source?: InputMaybe<Order_By>;
  /** Entity that receives the money */
  payee_uuid?: InputMaybe<Order_By>;
  payment_due_at?: InputMaybe<Order_By>;
  payment_method_display_text?: InputMaybe<Order_By>;
  payment_method_uuid?: InputMaybe<Order_By>;
  /** Entity that pays the money */
  payor_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  result_code?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Batches_Min_Fields = {
  __typename?: 'payment_batches_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_uuid?: Maybe<Scalars['uuid']['output']>;
  customer_facing_id?: Maybe<Scalars['String']['output']>;
  document_url?: Maybe<Scalars['String']['output']>;
  link_paid_at?: Maybe<Scalars['timestamptz']['output']>;
  link_paid_by_uuid?: Maybe<Scalars['uuid']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  paid_source?: Maybe<Scalars['String']['output']>;
  /** Entity that receives the money */
  payee_uuid?: Maybe<Scalars['uuid']['output']>;
  payment_due_at?: Maybe<Scalars['timestamptz']['output']>;
  payment_method_display_text?: Maybe<Scalars['String']['output']>;
  payment_method_uuid?: Maybe<Scalars['uuid']['output']>;
  /** Entity that pays the money */
  payor_uuid?: Maybe<Scalars['uuid']['output']>;
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  result_code?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "payment_batches" */
export type Payment_Batches_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  customer_facing_id?: InputMaybe<Order_By>;
  document_url?: InputMaybe<Order_By>;
  link_paid_at?: InputMaybe<Order_By>;
  link_paid_by_uuid?: InputMaybe<Order_By>;
  memo?: InputMaybe<Order_By>;
  paid_source?: InputMaybe<Order_By>;
  /** Entity that receives the money */
  payee_uuid?: InputMaybe<Order_By>;
  payment_due_at?: InputMaybe<Order_By>;
  payment_method_display_text?: InputMaybe<Order_By>;
  payment_method_uuid?: InputMaybe<Order_By>;
  /** Entity that pays the money */
  payor_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  result_code?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "payment_batches". */
export type Payment_Batches_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Employees_Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  customer_facing_id?: InputMaybe<Order_By>;
  document_url?: InputMaybe<Order_By>;
  link_paid_at?: InputMaybe<Order_By>;
  link_paid_by_uuid?: InputMaybe<Order_By>;
  memo?: InputMaybe<Order_By>;
  paid_source?: InputMaybe<Order_By>;
  pay_by_link_recipient?: InputMaybe<Pay_By_Link_Recipients_Order_By>;
  payee_uuid?: InputMaybe<Order_By>;
  payment_batch_amount?: InputMaybe<Payment_Batch_Amount_Order_By>;
  payment_batch_line_items_aggregate?: InputMaybe<Payment_Batch_Line_Items_Aggregate_Order_By>;
  payment_due_at?: InputMaybe<Order_By>;
  payment_method?: InputMaybe<Payment_Methods_Order_By>;
  payment_method_display_text?: InputMaybe<Order_By>;
  payment_method_uuid?: InputMaybe<Order_By>;
  payor?: InputMaybe<Businesses_Order_By>;
  payor_uuid?: InputMaybe<Order_By>;
  restaurant?: InputMaybe<Businesses_Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  result_code?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "payment_batches" */
export enum Payment_Batches_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUuid = 'created_by_uuid',
  /** column name */
  CustomerFacingId = 'customer_facing_id',
  /** column name */
  DocumentUrl = 'document_url',
  /** column name */
  LinkPaidAt = 'link_paid_at',
  /** column name */
  LinkPaidByUuid = 'link_paid_by_uuid',
  /** column name */
  Memo = 'memo',
  /** column name */
  PaidSource = 'paid_source',
  /** column name */
  PayeeUuid = 'payee_uuid',
  /** column name */
  PaymentDueAt = 'payment_due_at',
  /** column name */
  PaymentMethodDisplayText = 'payment_method_display_text',
  /** column name */
  PaymentMethodUuid = 'payment_method_uuid',
  /** column name */
  PayorUuid = 'payor_uuid',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  ResultCode = 'result_code',
  /** column name */
  Status = 'status',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUuid = 'updated_by_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "payment_batches" */
export type Payment_Batches_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Batches_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Batches_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
  customer_facing_id?: InputMaybe<Scalars['String']['input']>;
  document_url?: InputMaybe<Scalars['String']['input']>;
  link_paid_at?: InputMaybe<Scalars['timestamptz']['input']>;
  link_paid_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  paid_source?: InputMaybe<Scalars['String']['input']>;
  /** Entity that receives the money */
  payee_uuid?: InputMaybe<Scalars['uuid']['input']>;
  payment_due_at?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_method_display_text?: InputMaybe<Scalars['String']['input']>;
  payment_method_uuid?: InputMaybe<Scalars['uuid']['input']>;
  /** Entity that pays the money */
  payor_uuid?: InputMaybe<Scalars['uuid']['input']>;
  restaurant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  result_code?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "payment_links" */
export type Payment_Links = Node & {
  __typename?: 'payment_links';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['ID']['output'];
};

/** A Relay connection object on "payment_links" */
export type Payment_LinksConnection = {
  __typename?: 'payment_linksConnection';
  edges: Array<Payment_LinksEdge>;
  pageInfo: PageInfo;
};

export type Payment_LinksEdge = {
  __typename?: 'payment_linksEdge';
  cursor: Scalars['String']['output'];
  node: Payment_Links;
};

/** Boolean expression to filter rows from the table "payment_links". All fields are combined with a logical 'AND'. */
export type Payment_Links_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Links_Bool_Exp>>;
  _not?: InputMaybe<Payment_Links_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Links_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "payment_links". */
export type Payment_Links_Order_By = {
  created_at?: InputMaybe<Order_By>;
};

/** select columns of table "payment_links" */
export enum Payment_Links_Select_Column {
  /** column name */
  CreatedAt = 'created_at'
}

/** Streaming cursor of the table "payment_links" */
export type Payment_Links_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Links_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Links_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "payment_methods" */
export type Payment_Methods = Node & {
  __typename?: 'payment_methods';
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  display_text: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_default: Scalars['Boolean']['output'];
  /** Entity that will receive money via this method */
  payee_uuid: Scalars['uuid']['output'];
  payment_id: Scalars['String']['output'];
  payment_method_sub_type?: Maybe<Scalars['String']['output']>;
  payment_method_type: Scalars['String']['output'];
  /** Entity that will pay money via this method */
  payor_uuid: Scalars['uuid']['output'];
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  supplier: Businesses;
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "payment_methods" */
export type Payment_MethodsConnection = {
  __typename?: 'payment_methodsConnection';
  edges: Array<Payment_MethodsEdge>;
  pageInfo: PageInfo;
};

export type Payment_MethodsEdge = {
  __typename?: 'payment_methodsEdge';
  cursor: Scalars['String']['output'];
  node: Payment_Methods;
};

/** order by aggregate values of table "payment_methods" */
export type Payment_Methods_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payment_Methods_Max_Order_By>;
  min?: InputMaybe<Payment_Methods_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "payment_methods". All fields are combined with a logical 'AND'. */
export type Payment_Methods_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Methods_Bool_Exp>>;
  _not?: InputMaybe<Payment_Methods_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Methods_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_text?: InputMaybe<String_Comparison_Exp>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  payee_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  payment_id?: InputMaybe<String_Comparison_Exp>;
  payment_method_sub_type?: InputMaybe<String_Comparison_Exp>;
  payment_method_type?: InputMaybe<String_Comparison_Exp>;
  payor_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "payment_methods" */
export type Payment_Methods_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  display_text?: InputMaybe<Order_By>;
  /** Entity that will receive money via this method */
  payee_uuid?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
  payment_method_sub_type?: InputMaybe<Order_By>;
  payment_method_type?: InputMaybe<Order_By>;
  /** Entity that will pay money via this method */
  payor_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "payment_methods" */
export type Payment_Methods_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  display_text?: InputMaybe<Order_By>;
  /** Entity that will receive money via this method */
  payee_uuid?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
  payment_method_sub_type?: InputMaybe<Order_By>;
  payment_method_type?: InputMaybe<Order_By>;
  /** Entity that will pay money via this method */
  payor_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "payment_methods" */
export type Payment_Methods_Mutation_Response = {
  __typename?: 'payment_methods_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Methods>;
};

/** Ordering options when selecting data from "payment_methods". */
export type Payment_Methods_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  display_text?: InputMaybe<Order_By>;
  is_default?: InputMaybe<Order_By>;
  payee_uuid?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
  payment_method_sub_type?: InputMaybe<Order_By>;
  payment_method_type?: InputMaybe<Order_By>;
  payor_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payment_methods */
export type Payment_Methods_Pk_Columns_Input = {
  uuid: Scalars['uuid']['input'];
};

/** select columns of table "payment_methods" */
export enum Payment_Methods_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DisplayText = 'display_text',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  PayeeUuid = 'payee_uuid',
  /** column name */
  PaymentId = 'payment_id',
  /** column name */
  PaymentMethodSubType = 'payment_method_sub_type',
  /** column name */
  PaymentMethodType = 'payment_method_type',
  /** column name */
  PayorUuid = 'payor_uuid',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "payment_methods" */
export type Payment_Methods_Set_Input = {
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "payment_methods" */
export type Payment_Methods_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Methods_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Methods_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_text?: InputMaybe<Scalars['String']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  /** Entity that will receive money via this method */
  payee_uuid?: InputMaybe<Scalars['uuid']['input']>;
  payment_id?: InputMaybe<Scalars['String']['input']>;
  payment_method_sub_type?: InputMaybe<Scalars['String']['input']>;
  payment_method_type?: InputMaybe<Scalars['String']['input']>;
  /** Entity that will pay money via this method */
  payor_uuid?: InputMaybe<Scalars['uuid']['input']>;
  restaurant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

export type Payment_Methods_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Methods_Set_Input>;
  where: Payment_Methods_Bool_Exp;
};

/** columns and relationships of "payment_plans" */
export type Payment_Plans = Node & {
  __typename?: 'payment_plans';
  id: Scalars['ID']['output'];
  installment_amount_in_micros: Scalars['bigint']['output'];
  payment_method_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  restaurant: Businesses;
  restaurant_uuid: Scalars['uuid']['output'];
  start_date: Scalars['date']['output'];
  status: Scalars['String']['output'];
  /** An object relationship */
  supplier: Businesses;
  supplier_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  task_frequency_settings: Task_Frequency_Settings;
  task_frequency_settings_uuid: Scalars['uuid']['output'];
  total_amount_in_micros: Scalars['bigint']['output'];
  uuid: Scalars['uuid']['output'];
};

/** columns and relationships of "planogram_restaurants" */
export type Planogram_Restaurants = Node & {
  __typename?: 'planogram_restaurants';
  id: Scalars['ID']['output'];
  planogram_uuid: Scalars['uuid']['output'];
  restaurant_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};

/** columns and relationships of "planogram_variant_packs" */
export type Planogram_Variant_Packs = Node & {
  __typename?: 'planogram_variant_packs';
  id: Scalars['ID']['output'];
  planogram_uuid: Scalars['uuid']['output'];
  quantity: Scalars['Int']['output'];
  sort_order?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['uuid']['output'];
  /** An object relationship */
  variant_pack: Variants_Packs;
  variant_pack_uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "planogram_variant_packs" */
export type Planogram_Variant_PacksConnection = {
  __typename?: 'planogram_variant_packsConnection';
  edges: Array<Planogram_Variant_PacksEdge>;
  pageInfo: PageInfo;
};

export type Planogram_Variant_PacksEdge = {
  __typename?: 'planogram_variant_packsEdge';
  cursor: Scalars['String']['output'];
  node: Planogram_Variant_Packs;
};

/** aggregated selection of "planogram_variant_packs" */
export type Planogram_Variant_Packs_Aggregate = {
  __typename?: 'planogram_variant_packs_aggregate';
  aggregate?: Maybe<Planogram_Variant_Packs_Aggregate_Fields>;
  nodes: Array<Planogram_Variant_Packs>;
};

/** aggregate fields of "planogram_variant_packs" */
export type Planogram_Variant_Packs_Aggregate_Fields = {
  __typename?: 'planogram_variant_packs_aggregate_fields';
  avg?: Maybe<Planogram_Variant_Packs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Planogram_Variant_Packs_Max_Fields>;
  min?: Maybe<Planogram_Variant_Packs_Min_Fields>;
  stddev?: Maybe<Planogram_Variant_Packs_Stddev_Fields>;
  stddev_pop?: Maybe<Planogram_Variant_Packs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Planogram_Variant_Packs_Stddev_Samp_Fields>;
  sum?: Maybe<Planogram_Variant_Packs_Sum_Fields>;
  var_pop?: Maybe<Planogram_Variant_Packs_Var_Pop_Fields>;
  var_samp?: Maybe<Planogram_Variant_Packs_Var_Samp_Fields>;
  variance?: Maybe<Planogram_Variant_Packs_Variance_Fields>;
};


/** aggregate fields of "planogram_variant_packs" */
export type Planogram_Variant_Packs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Planogram_Variant_Packs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "planogram_variant_packs" */
export type Planogram_Variant_Packs_Aggregate_Order_By = {
  avg?: InputMaybe<Planogram_Variant_Packs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Planogram_Variant_Packs_Max_Order_By>;
  min?: InputMaybe<Planogram_Variant_Packs_Min_Order_By>;
  stddev?: InputMaybe<Planogram_Variant_Packs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Planogram_Variant_Packs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Planogram_Variant_Packs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Planogram_Variant_Packs_Sum_Order_By>;
  var_pop?: InputMaybe<Planogram_Variant_Packs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Planogram_Variant_Packs_Var_Samp_Order_By>;
  variance?: InputMaybe<Planogram_Variant_Packs_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Planogram_Variant_Packs_Avg_Fields = {
  __typename?: 'planogram_variant_packs_avg_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "planogram_variant_packs" */
export type Planogram_Variant_Packs_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "planogram_variant_packs". All fields are combined with a logical 'AND'. */
export type Planogram_Variant_Packs_Bool_Exp = {
  _and?: InputMaybe<Array<Planogram_Variant_Packs_Bool_Exp>>;
  _not?: InputMaybe<Planogram_Variant_Packs_Bool_Exp>;
  _or?: InputMaybe<Array<Planogram_Variant_Packs_Bool_Exp>>;
  planogram_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  sort_order?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack?: InputMaybe<Variants_Packs_Bool_Exp>;
  variant_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Planogram_Variant_Packs_Max_Fields = {
  __typename?: 'planogram_variant_packs_max_fields';
  planogram_uuid?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
  variant_pack_uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "planogram_variant_packs" */
export type Planogram_Variant_Packs_Max_Order_By = {
  planogram_uuid?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Planogram_Variant_Packs_Min_Fields = {
  __typename?: 'planogram_variant_packs_min_fields';
  planogram_uuid?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
  variant_pack_uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "planogram_variant_packs" */
export type Planogram_Variant_Packs_Min_Order_By = {
  planogram_uuid?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "planogram_variant_packs". */
export type Planogram_Variant_Packs_Order_By = {
  planogram_uuid?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack?: InputMaybe<Variants_Packs_Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** select columns of table "planogram_variant_packs" */
export enum Planogram_Variant_Packs_Select_Column {
  /** column name */
  PlanogramUuid = 'planogram_uuid',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VariantPackUuid = 'variant_pack_uuid'
}

/** aggregate stddev on columns */
export type Planogram_Variant_Packs_Stddev_Fields = {
  __typename?: 'planogram_variant_packs_stddev_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "planogram_variant_packs" */
export type Planogram_Variant_Packs_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Planogram_Variant_Packs_Stddev_Pop_Fields = {
  __typename?: 'planogram_variant_packs_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "planogram_variant_packs" */
export type Planogram_Variant_Packs_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Planogram_Variant_Packs_Stddev_Samp_Fields = {
  __typename?: 'planogram_variant_packs_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "planogram_variant_packs" */
export type Planogram_Variant_Packs_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Planogram_Variant_Packs_Sum_Fields = {
  __typename?: 'planogram_variant_packs_sum_fields';
  quantity?: Maybe<Scalars['Int']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "planogram_variant_packs" */
export type Planogram_Variant_Packs_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Planogram_Variant_Packs_Var_Pop_Fields = {
  __typename?: 'planogram_variant_packs_var_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "planogram_variant_packs" */
export type Planogram_Variant_Packs_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Planogram_Variant_Packs_Var_Samp_Fields = {
  __typename?: 'planogram_variant_packs_var_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "planogram_variant_packs" */
export type Planogram_Variant_Packs_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Planogram_Variant_Packs_Variance_Fields = {
  __typename?: 'planogram_variant_packs_variance_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "planogram_variant_packs" */
export type Planogram_Variant_Packs_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** columns and relationships of "planograms" */
export type Planograms = Node & {
  __typename?: 'planograms';
  created_at: Scalars['timestamptz']['output'];
  created_by_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  planogram_variant_packs: Array<Planogram_Variant_Packs>;
  /** An aggregate relationship */
  planogram_variant_packs_aggregate: Planogram_Variant_Packs_Aggregate;
  /** An array relationship connection */
  planogram_variant_packs_connection: Planogram_Variant_PacksConnection;
  show_by_default: Scalars['Boolean']['output'];
  /** An object relationship */
  supplier: Businesses;
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "planograms" */
export type PlanogramsPlanogram_Variant_PacksArgs = {
  distinct_on?: InputMaybe<Array<Planogram_Variant_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planogram_Variant_Packs_Order_By>>;
  where?: InputMaybe<Planogram_Variant_Packs_Bool_Exp>;
};


/** columns and relationships of "planograms" */
export type PlanogramsPlanogram_Variant_Packs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Planogram_Variant_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planogram_Variant_Packs_Order_By>>;
  where?: InputMaybe<Planogram_Variant_Packs_Bool_Exp>;
};


/** columns and relationships of "planograms" */
export type PlanogramsPlanogram_Variant_Packs_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Planogram_Variant_Packs_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planogram_Variant_Packs_Order_By>>;
  where?: InputMaybe<Planogram_Variant_Packs_Bool_Exp>;
};

/** A Relay connection object on "planograms" */
export type PlanogramsConnection = {
  __typename?: 'planogramsConnection';
  edges: Array<PlanogramsEdge>;
  pageInfo: PageInfo;
};

export type PlanogramsEdge = {
  __typename?: 'planogramsEdge';
  cursor: Scalars['String']['output'];
  node: Planograms;
};

/** Boolean expression to filter rows from the table "planograms". All fields are combined with a logical 'AND'. */
export type Planograms_Bool_Exp = {
  _and?: InputMaybe<Array<Planograms_Bool_Exp>>;
  _not?: InputMaybe<Planograms_Bool_Exp>;
  _or?: InputMaybe<Array<Planograms_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  planogram_variant_packs?: InputMaybe<Planogram_Variant_Packs_Bool_Exp>;
  show_by_default?: InputMaybe<Boolean_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "planograms". */
export type Planograms_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  planogram_variant_packs_aggregate?: InputMaybe<Planogram_Variant_Packs_Aggregate_Order_By>;
  show_by_default?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "planograms" */
export enum Planograms_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUuid = 'created_by_uuid',
  /** column name */
  Name = 'name',
  /** column name */
  ShowByDefault = 'show_by_default',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "planograms" */
export type Planograms_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Planograms_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Planograms_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  show_by_default?: InputMaybe<Scalars['Boolean']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "pricing_price_draft_update_batches" */
export type Pricing_Price_Draft_Update_Batches = Node & {
  __typename?: 'pricing_price_draft_update_batches';
  created_by_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  /** An array relationship */
  pricing_price_draft_updates: Array<Pricing_Price_Draft_Updates>;
  /** An aggregate relationship */
  pricing_price_draft_updates_aggregate: Pricing_Price_Draft_Updates_Aggregate;
  /** An array relationship connection */
  pricing_price_draft_updates_connection: Pricing_Price_Draft_UpdatesConnection;
  submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  supplier?: Maybe<Businesses>;
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "pricing_price_draft_update_batches" */
export type Pricing_Price_Draft_Update_BatchesPricing_Price_Draft_UpdatesArgs = {
  distinct_on?: InputMaybe<Array<Pricing_Price_Draft_Updates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pricing_Price_Draft_Updates_Order_By>>;
  where?: InputMaybe<Pricing_Price_Draft_Updates_Bool_Exp>;
};


/** columns and relationships of "pricing_price_draft_update_batches" */
export type Pricing_Price_Draft_Update_BatchesPricing_Price_Draft_Updates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pricing_Price_Draft_Updates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pricing_Price_Draft_Updates_Order_By>>;
  where?: InputMaybe<Pricing_Price_Draft_Updates_Bool_Exp>;
};


/** columns and relationships of "pricing_price_draft_update_batches" */
export type Pricing_Price_Draft_Update_BatchesPricing_Price_Draft_Updates_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Pricing_Price_Draft_Updates_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pricing_Price_Draft_Updates_Order_By>>;
  where?: InputMaybe<Pricing_Price_Draft_Updates_Bool_Exp>;
};

/** A Relay connection object on "pricing_price_draft_update_batches" */
export type Pricing_Price_Draft_Update_BatchesConnection = {
  __typename?: 'pricing_price_draft_update_batchesConnection';
  edges: Array<Pricing_Price_Draft_Update_BatchesEdge>;
  pageInfo: PageInfo;
};

export type Pricing_Price_Draft_Update_BatchesEdge = {
  __typename?: 'pricing_price_draft_update_batchesEdge';
  cursor: Scalars['String']['output'];
  node: Pricing_Price_Draft_Update_Batches;
};

/** Boolean expression to filter rows from the table "pricing_price_draft_update_batches". All fields are combined with a logical 'AND'. */
export type Pricing_Price_Draft_Update_Batches_Bool_Exp = {
  _and?: InputMaybe<Array<Pricing_Price_Draft_Update_Batches_Bool_Exp>>;
  _not?: InputMaybe<Pricing_Price_Draft_Update_Batches_Bool_Exp>;
  _or?: InputMaybe<Array<Pricing_Price_Draft_Update_Batches_Bool_Exp>>;
  created_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  pricing_price_draft_updates?: InputMaybe<Pricing_Price_Draft_Updates_Bool_Exp>;
  submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "pricing_price_draft_update_batches". */
export type Pricing_Price_Draft_Update_Batches_Order_By = {
  created_by_uuid?: InputMaybe<Order_By>;
  pricing_price_draft_updates_aggregate?: InputMaybe<Pricing_Price_Draft_Updates_Aggregate_Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "pricing_price_draft_update_batches" */
export enum Pricing_Price_Draft_Update_Batches_Select_Column {
  /** column name */
  CreatedByUuid = 'created_by_uuid',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "pricing_price_draft_update_batches" */
export type Pricing_Price_Draft_Update_Batches_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pricing_Price_Draft_Update_Batches_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pricing_Price_Draft_Update_Batches_Stream_Cursor_Value_Input = {
  created_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
  submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "pricing_price_draft_updates" */
export type Pricing_Price_Draft_Updates = Node & {
  __typename?: 'pricing_price_draft_updates';
  gross_profit_in_percentage?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['ID']['output'];
  new_price_in_micros: Scalars['bigint']['output'];
  pricing_price_draft_update_batch_uuid: Scalars['uuid']['output'];
  restaurant_uuid: Scalars['uuid']['output'];
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
  variant_pack_uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "pricing_price_draft_updates" */
export type Pricing_Price_Draft_UpdatesConnection = {
  __typename?: 'pricing_price_draft_updatesConnection';
  edges: Array<Pricing_Price_Draft_UpdatesEdge>;
  pageInfo: PageInfo;
};

export type Pricing_Price_Draft_UpdatesEdge = {
  __typename?: 'pricing_price_draft_updatesEdge';
  cursor: Scalars['String']['output'];
  node: Pricing_Price_Draft_Updates;
};

/** aggregated selection of "pricing_price_draft_updates" */
export type Pricing_Price_Draft_Updates_Aggregate = {
  __typename?: 'pricing_price_draft_updates_aggregate';
  aggregate?: Maybe<Pricing_Price_Draft_Updates_Aggregate_Fields>;
  nodes: Array<Pricing_Price_Draft_Updates>;
};

/** aggregate fields of "pricing_price_draft_updates" */
export type Pricing_Price_Draft_Updates_Aggregate_Fields = {
  __typename?: 'pricing_price_draft_updates_aggregate_fields';
  avg?: Maybe<Pricing_Price_Draft_Updates_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pricing_Price_Draft_Updates_Max_Fields>;
  min?: Maybe<Pricing_Price_Draft_Updates_Min_Fields>;
  stddev?: Maybe<Pricing_Price_Draft_Updates_Stddev_Fields>;
  stddev_pop?: Maybe<Pricing_Price_Draft_Updates_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pricing_Price_Draft_Updates_Stddev_Samp_Fields>;
  sum?: Maybe<Pricing_Price_Draft_Updates_Sum_Fields>;
  var_pop?: Maybe<Pricing_Price_Draft_Updates_Var_Pop_Fields>;
  var_samp?: Maybe<Pricing_Price_Draft_Updates_Var_Samp_Fields>;
  variance?: Maybe<Pricing_Price_Draft_Updates_Variance_Fields>;
};


/** aggregate fields of "pricing_price_draft_updates" */
export type Pricing_Price_Draft_Updates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pricing_Price_Draft_Updates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "pricing_price_draft_updates" */
export type Pricing_Price_Draft_Updates_Aggregate_Order_By = {
  avg?: InputMaybe<Pricing_Price_Draft_Updates_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pricing_Price_Draft_Updates_Max_Order_By>;
  min?: InputMaybe<Pricing_Price_Draft_Updates_Min_Order_By>;
  stddev?: InputMaybe<Pricing_Price_Draft_Updates_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pricing_Price_Draft_Updates_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pricing_Price_Draft_Updates_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pricing_Price_Draft_Updates_Sum_Order_By>;
  var_pop?: InputMaybe<Pricing_Price_Draft_Updates_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pricing_Price_Draft_Updates_Var_Samp_Order_By>;
  variance?: InputMaybe<Pricing_Price_Draft_Updates_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Pricing_Price_Draft_Updates_Avg_Fields = {
  __typename?: 'pricing_price_draft_updates_avg_fields';
  gross_profit_in_percentage?: Maybe<Scalars['Float']['output']>;
  new_price_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "pricing_price_draft_updates" */
export type Pricing_Price_Draft_Updates_Avg_Order_By = {
  gross_profit_in_percentage?: InputMaybe<Order_By>;
  new_price_in_micros?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "pricing_price_draft_updates". All fields are combined with a logical 'AND'. */
export type Pricing_Price_Draft_Updates_Bool_Exp = {
  _and?: InputMaybe<Array<Pricing_Price_Draft_Updates_Bool_Exp>>;
  _not?: InputMaybe<Pricing_Price_Draft_Updates_Bool_Exp>;
  _or?: InputMaybe<Array<Pricing_Price_Draft_Updates_Bool_Exp>>;
  gross_profit_in_percentage?: InputMaybe<Numeric_Comparison_Exp>;
  new_price_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  pricing_price_draft_update_batch_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pricing_Price_Draft_Updates_Max_Fields = {
  __typename?: 'pricing_price_draft_updates_max_fields';
  gross_profit_in_percentage?: Maybe<Scalars['numeric']['output']>;
  new_price_in_micros?: Maybe<Scalars['bigint']['output']>;
  pricing_price_draft_update_batch_uuid?: Maybe<Scalars['uuid']['output']>;
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
  variant_pack_uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "pricing_price_draft_updates" */
export type Pricing_Price_Draft_Updates_Max_Order_By = {
  gross_profit_in_percentage?: InputMaybe<Order_By>;
  new_price_in_micros?: InputMaybe<Order_By>;
  pricing_price_draft_update_batch_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pricing_Price_Draft_Updates_Min_Fields = {
  __typename?: 'pricing_price_draft_updates_min_fields';
  gross_profit_in_percentage?: Maybe<Scalars['numeric']['output']>;
  new_price_in_micros?: Maybe<Scalars['bigint']['output']>;
  pricing_price_draft_update_batch_uuid?: Maybe<Scalars['uuid']['output']>;
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
  variant_pack_uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "pricing_price_draft_updates" */
export type Pricing_Price_Draft_Updates_Min_Order_By = {
  gross_profit_in_percentage?: InputMaybe<Order_By>;
  new_price_in_micros?: InputMaybe<Order_By>;
  pricing_price_draft_update_batch_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "pricing_price_draft_updates". */
export type Pricing_Price_Draft_Updates_Order_By = {
  gross_profit_in_percentage?: InputMaybe<Order_By>;
  new_price_in_micros?: InputMaybe<Order_By>;
  pricing_price_draft_update_batch_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** select columns of table "pricing_price_draft_updates" */
export enum Pricing_Price_Draft_Updates_Select_Column {
  /** column name */
  GrossProfitInPercentage = 'gross_profit_in_percentage',
  /** column name */
  NewPriceInMicros = 'new_price_in_micros',
  /** column name */
  PricingPriceDraftUpdateBatchUuid = 'pricing_price_draft_update_batch_uuid',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VariantPackUuid = 'variant_pack_uuid'
}

/** aggregate stddev on columns */
export type Pricing_Price_Draft_Updates_Stddev_Fields = {
  __typename?: 'pricing_price_draft_updates_stddev_fields';
  gross_profit_in_percentage?: Maybe<Scalars['Float']['output']>;
  new_price_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "pricing_price_draft_updates" */
export type Pricing_Price_Draft_Updates_Stddev_Order_By = {
  gross_profit_in_percentage?: InputMaybe<Order_By>;
  new_price_in_micros?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pricing_Price_Draft_Updates_Stddev_Pop_Fields = {
  __typename?: 'pricing_price_draft_updates_stddev_pop_fields';
  gross_profit_in_percentage?: Maybe<Scalars['Float']['output']>;
  new_price_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "pricing_price_draft_updates" */
export type Pricing_Price_Draft_Updates_Stddev_Pop_Order_By = {
  gross_profit_in_percentage?: InputMaybe<Order_By>;
  new_price_in_micros?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pricing_Price_Draft_Updates_Stddev_Samp_Fields = {
  __typename?: 'pricing_price_draft_updates_stddev_samp_fields';
  gross_profit_in_percentage?: Maybe<Scalars['Float']['output']>;
  new_price_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "pricing_price_draft_updates" */
export type Pricing_Price_Draft_Updates_Stddev_Samp_Order_By = {
  gross_profit_in_percentage?: InputMaybe<Order_By>;
  new_price_in_micros?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Pricing_Price_Draft_Updates_Sum_Fields = {
  __typename?: 'pricing_price_draft_updates_sum_fields';
  gross_profit_in_percentage?: Maybe<Scalars['numeric']['output']>;
  new_price_in_micros?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "pricing_price_draft_updates" */
export type Pricing_Price_Draft_Updates_Sum_Order_By = {
  gross_profit_in_percentage?: InputMaybe<Order_By>;
  new_price_in_micros?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Pricing_Price_Draft_Updates_Var_Pop_Fields = {
  __typename?: 'pricing_price_draft_updates_var_pop_fields';
  gross_profit_in_percentage?: Maybe<Scalars['Float']['output']>;
  new_price_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "pricing_price_draft_updates" */
export type Pricing_Price_Draft_Updates_Var_Pop_Order_By = {
  gross_profit_in_percentage?: InputMaybe<Order_By>;
  new_price_in_micros?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pricing_Price_Draft_Updates_Var_Samp_Fields = {
  __typename?: 'pricing_price_draft_updates_var_samp_fields';
  gross_profit_in_percentage?: Maybe<Scalars['Float']['output']>;
  new_price_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "pricing_price_draft_updates" */
export type Pricing_Price_Draft_Updates_Var_Samp_Order_By = {
  gross_profit_in_percentage?: InputMaybe<Order_By>;
  new_price_in_micros?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pricing_Price_Draft_Updates_Variance_Fields = {
  __typename?: 'pricing_price_draft_updates_variance_fields';
  gross_profit_in_percentage?: Maybe<Scalars['Float']['output']>;
  new_price_in_micros?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "pricing_price_draft_updates" */
export type Pricing_Price_Draft_Updates_Variance_Order_By = {
  gross_profit_in_percentage?: InputMaybe<Order_By>;
  new_price_in_micros?: InputMaybe<Order_By>;
};

/** columns and relationships of "pricing_recommendations" */
export type Pricing_Recommendations = Node & {
  __typename?: 'pricing_recommendations';
  id: Scalars['ID']['output'];
  review_status: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "pricing_recommendations" */
export type Pricing_RecommendationsConnection = {
  __typename?: 'pricing_recommendationsConnection';
  edges: Array<Pricing_RecommendationsEdge>;
  pageInfo: PageInfo;
};

export type Pricing_RecommendationsEdge = {
  __typename?: 'pricing_recommendationsEdge';
  cursor: Scalars['String']['output'];
  node: Pricing_Recommendations;
};

/** aggregated selection of "pricing_recommendations" */
export type Pricing_Recommendations_Aggregate = {
  __typename?: 'pricing_recommendations_aggregate';
  aggregate?: Maybe<Pricing_Recommendations_Aggregate_Fields>;
  nodes: Array<Pricing_Recommendations>;
};

/** aggregate fields of "pricing_recommendations" */
export type Pricing_Recommendations_Aggregate_Fields = {
  __typename?: 'pricing_recommendations_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Pricing_Recommendations_Max_Fields>;
  min?: Maybe<Pricing_Recommendations_Min_Fields>;
};


/** aggregate fields of "pricing_recommendations" */
export type Pricing_Recommendations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pricing_Recommendations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "pricing_recommendations" */
export type Pricing_Recommendations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pricing_Recommendations_Max_Order_By>;
  min?: InputMaybe<Pricing_Recommendations_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "pricing_recommendations". All fields are combined with a logical 'AND'. */
export type Pricing_Recommendations_Bool_Exp = {
  _and?: InputMaybe<Array<Pricing_Recommendations_Bool_Exp>>;
  _not?: InputMaybe<Pricing_Recommendations_Bool_Exp>;
  _or?: InputMaybe<Array<Pricing_Recommendations_Bool_Exp>>;
  review_status?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pricing_Recommendations_Max_Fields = {
  __typename?: 'pricing_recommendations_max_fields';
  review_status?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "pricing_recommendations" */
export type Pricing_Recommendations_Max_Order_By = {
  review_status?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pricing_Recommendations_Min_Fields = {
  __typename?: 'pricing_recommendations_min_fields';
  review_status?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "pricing_recommendations" */
export type Pricing_Recommendations_Min_Order_By = {
  review_status?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "pricing_recommendations". */
export type Pricing_Recommendations_Order_By = {
  review_status?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "pricing_recommendations" */
export enum Pricing_Recommendations_Select_Column {
  /** column name */
  ReviewStatus = 'review_status',
  /** column name */
  Uuid = 'uuid'
}

/** columns and relationships of "pricing_task_runs" */
export type Pricing_Task_Runs = Node & {
  __typename?: 'pricing_task_runs';
  auto_publish_at?: Maybe<Scalars['timestamptz']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  methodology_summary?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  pricing_recommendations: Array<Pricing_Recommendations>;
  /** An aggregate relationship */
  pricing_recommendations_aggregate: Pricing_Recommendations_Aggregate;
  /** An array relationship connection */
  pricing_recommendations_connection: Pricing_RecommendationsConnection;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  status: Scalars['String']['output'];
  /** An object relationship */
  supplier?: Maybe<Businesses>;
  supplier_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  task?: Maybe<Pricing_Tasks>;
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "pricing_task_runs" */
export type Pricing_Task_RunsPricing_RecommendationsArgs = {
  distinct_on?: InputMaybe<Array<Pricing_Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pricing_Recommendations_Order_By>>;
  where?: InputMaybe<Pricing_Recommendations_Bool_Exp>;
};


/** columns and relationships of "pricing_task_runs" */
export type Pricing_Task_RunsPricing_Recommendations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pricing_Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pricing_Recommendations_Order_By>>;
  where?: InputMaybe<Pricing_Recommendations_Bool_Exp>;
};


/** columns and relationships of "pricing_task_runs" */
export type Pricing_Task_RunsPricing_Recommendations_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Pricing_Recommendations_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pricing_Recommendations_Order_By>>;
  where?: InputMaybe<Pricing_Recommendations_Bool_Exp>;
};

/** A Relay connection object on "pricing_task_runs" */
export type Pricing_Task_RunsConnection = {
  __typename?: 'pricing_task_runsConnection';
  edges: Array<Pricing_Task_RunsEdge>;
  pageInfo: PageInfo;
};

export type Pricing_Task_RunsEdge = {
  __typename?: 'pricing_task_runsEdge';
  cursor: Scalars['String']['output'];
  node: Pricing_Task_Runs;
};

/** aggregated selection of "pricing_task_runs" */
export type Pricing_Task_Runs_Aggregate = {
  __typename?: 'pricing_task_runs_aggregate';
  aggregate?: Maybe<Pricing_Task_Runs_Aggregate_Fields>;
  nodes: Array<Pricing_Task_Runs>;
};

/** aggregate fields of "pricing_task_runs" */
export type Pricing_Task_Runs_Aggregate_Fields = {
  __typename?: 'pricing_task_runs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Pricing_Task_Runs_Max_Fields>;
  min?: Maybe<Pricing_Task_Runs_Min_Fields>;
};


/** aggregate fields of "pricing_task_runs" */
export type Pricing_Task_Runs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pricing_Task_Runs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "pricing_task_runs". All fields are combined with a logical 'AND'. */
export type Pricing_Task_Runs_Bool_Exp = {
  _and?: InputMaybe<Array<Pricing_Task_Runs_Bool_Exp>>;
  _not?: InputMaybe<Pricing_Task_Runs_Bool_Exp>;
  _or?: InputMaybe<Array<Pricing_Task_Runs_Bool_Exp>>;
  auto_publish_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  error_message?: InputMaybe<String_Comparison_Exp>;
  methodology_summary?: InputMaybe<String_Comparison_Exp>;
  pricing_recommendations?: InputMaybe<Pricing_Recommendations_Bool_Exp>;
  published_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  task?: InputMaybe<Pricing_Tasks_Bool_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pricing_Task_Runs_Max_Fields = {
  __typename?: 'pricing_task_runs_max_fields';
  auto_publish_at?: Maybe<Scalars['timestamptz']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  methodology_summary?: Maybe<Scalars['String']['output']>;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Pricing_Task_Runs_Min_Fields = {
  __typename?: 'pricing_task_runs_min_fields';
  auto_publish_at?: Maybe<Scalars['timestamptz']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  methodology_summary?: Maybe<Scalars['String']['output']>;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "pricing_task_runs". */
export type Pricing_Task_Runs_Order_By = {
  auto_publish_at?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  methodology_summary?: InputMaybe<Order_By>;
  pricing_recommendations_aggregate?: InputMaybe<Pricing_Recommendations_Aggregate_Order_By>;
  published_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  task?: InputMaybe<Pricing_Tasks_Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "pricing_task_runs" */
export enum Pricing_Task_Runs_Select_Column {
  /** column name */
  AutoPublishAt = 'auto_publish_at',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  MethodologySummary = 'methodology_summary',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  Status = 'status',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "pricing_task_runs" */
export type Pricing_Task_Runs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pricing_Task_Runs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pricing_Task_Runs_Stream_Cursor_Value_Input = {
  auto_publish_at?: InputMaybe<Scalars['timestamptz']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  methodology_summary?: InputMaybe<Scalars['String']['input']>;
  published_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "pricing_tasks" */
export type Pricing_Tasks = Node & {
  __typename?: 'pricing_tasks';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "pricing_tasks". All fields are combined with a logical 'AND'. */
export type Pricing_Tasks_Bool_Exp = {
  _and?: InputMaybe<Array<Pricing_Tasks_Bool_Exp>>;
  _not?: InputMaybe<Pricing_Tasks_Bool_Exp>;
  _or?: InputMaybe<Array<Pricing_Tasks_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "pricing_tasks". */
export type Pricing_Tasks_Order_By = {
  name?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "print_tag_batch_variant_packs" */
export type Print_Tag_Batch_Variant_Packs = Node & {
  __typename?: 'print_tag_batch_variant_packs';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['ID']['output'];
  print_tag_batch_uuid: Scalars['uuid']['output'];
  quantity: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  uuid: Scalars['uuid']['output'];
  /** An object relationship */
  variant_pack: Variants_Packs;
  variant_pack_uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "print_tag_batch_variant_packs" */
export type Print_Tag_Batch_Variant_PacksConnection = {
  __typename?: 'print_tag_batch_variant_packsConnection';
  edges: Array<Print_Tag_Batch_Variant_PacksEdge>;
  pageInfo: PageInfo;
};

export type Print_Tag_Batch_Variant_PacksEdge = {
  __typename?: 'print_tag_batch_variant_packsEdge';
  cursor: Scalars['String']['output'];
  node: Print_Tag_Batch_Variant_Packs;
};

/** aggregated selection of "print_tag_batch_variant_packs" */
export type Print_Tag_Batch_Variant_Packs_Aggregate = {
  __typename?: 'print_tag_batch_variant_packs_aggregate';
  aggregate?: Maybe<Print_Tag_Batch_Variant_Packs_Aggregate_Fields>;
  nodes: Array<Print_Tag_Batch_Variant_Packs>;
};

/** aggregate fields of "print_tag_batch_variant_packs" */
export type Print_Tag_Batch_Variant_Packs_Aggregate_Fields = {
  __typename?: 'print_tag_batch_variant_packs_aggregate_fields';
  avg?: Maybe<Print_Tag_Batch_Variant_Packs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Print_Tag_Batch_Variant_Packs_Max_Fields>;
  min?: Maybe<Print_Tag_Batch_Variant_Packs_Min_Fields>;
  stddev?: Maybe<Print_Tag_Batch_Variant_Packs_Stddev_Fields>;
  stddev_pop?: Maybe<Print_Tag_Batch_Variant_Packs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Print_Tag_Batch_Variant_Packs_Stddev_Samp_Fields>;
  sum?: Maybe<Print_Tag_Batch_Variant_Packs_Sum_Fields>;
  var_pop?: Maybe<Print_Tag_Batch_Variant_Packs_Var_Pop_Fields>;
  var_samp?: Maybe<Print_Tag_Batch_Variant_Packs_Var_Samp_Fields>;
  variance?: Maybe<Print_Tag_Batch_Variant_Packs_Variance_Fields>;
};


/** aggregate fields of "print_tag_batch_variant_packs" */
export type Print_Tag_Batch_Variant_Packs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Print_Tag_Batch_Variant_Packs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "print_tag_batch_variant_packs" */
export type Print_Tag_Batch_Variant_Packs_Aggregate_Order_By = {
  avg?: InputMaybe<Print_Tag_Batch_Variant_Packs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Print_Tag_Batch_Variant_Packs_Max_Order_By>;
  min?: InputMaybe<Print_Tag_Batch_Variant_Packs_Min_Order_By>;
  stddev?: InputMaybe<Print_Tag_Batch_Variant_Packs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Print_Tag_Batch_Variant_Packs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Print_Tag_Batch_Variant_Packs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Print_Tag_Batch_Variant_Packs_Sum_Order_By>;
  var_pop?: InputMaybe<Print_Tag_Batch_Variant_Packs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Print_Tag_Batch_Variant_Packs_Var_Samp_Order_By>;
  variance?: InputMaybe<Print_Tag_Batch_Variant_Packs_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Print_Tag_Batch_Variant_Packs_Avg_Fields = {
  __typename?: 'print_tag_batch_variant_packs_avg_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "print_tag_batch_variant_packs" */
export type Print_Tag_Batch_Variant_Packs_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "print_tag_batch_variant_packs". All fields are combined with a logical 'AND'. */
export type Print_Tag_Batch_Variant_Packs_Bool_Exp = {
  _and?: InputMaybe<Array<Print_Tag_Batch_Variant_Packs_Bool_Exp>>;
  _not?: InputMaybe<Print_Tag_Batch_Variant_Packs_Bool_Exp>;
  _or?: InputMaybe<Array<Print_Tag_Batch_Variant_Packs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  print_tag_batch_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack?: InputMaybe<Variants_Packs_Bool_Exp>;
  variant_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Print_Tag_Batch_Variant_Packs_Max_Fields = {
  __typename?: 'print_tag_batch_variant_packs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  print_tag_batch_uuid?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
  variant_pack_uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "print_tag_batch_variant_packs" */
export type Print_Tag_Batch_Variant_Packs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  print_tag_batch_uuid?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Print_Tag_Batch_Variant_Packs_Min_Fields = {
  __typename?: 'print_tag_batch_variant_packs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  print_tag_batch_uuid?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
  variant_pack_uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "print_tag_batch_variant_packs" */
export type Print_Tag_Batch_Variant_Packs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  print_tag_batch_uuid?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "print_tag_batch_variant_packs". */
export type Print_Tag_Batch_Variant_Packs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  print_tag_batch_uuid?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack?: InputMaybe<Variants_Packs_Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** select columns of table "print_tag_batch_variant_packs" */
export enum Print_Tag_Batch_Variant_Packs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  PrintTagBatchUuid = 'print_tag_batch_uuid',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VariantPackUuid = 'variant_pack_uuid'
}

/** aggregate stddev on columns */
export type Print_Tag_Batch_Variant_Packs_Stddev_Fields = {
  __typename?: 'print_tag_batch_variant_packs_stddev_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "print_tag_batch_variant_packs" */
export type Print_Tag_Batch_Variant_Packs_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Print_Tag_Batch_Variant_Packs_Stddev_Pop_Fields = {
  __typename?: 'print_tag_batch_variant_packs_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "print_tag_batch_variant_packs" */
export type Print_Tag_Batch_Variant_Packs_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Print_Tag_Batch_Variant_Packs_Stddev_Samp_Fields = {
  __typename?: 'print_tag_batch_variant_packs_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "print_tag_batch_variant_packs" */
export type Print_Tag_Batch_Variant_Packs_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Print_Tag_Batch_Variant_Packs_Sum_Fields = {
  __typename?: 'print_tag_batch_variant_packs_sum_fields';
  quantity?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "print_tag_batch_variant_packs" */
export type Print_Tag_Batch_Variant_Packs_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Print_Tag_Batch_Variant_Packs_Var_Pop_Fields = {
  __typename?: 'print_tag_batch_variant_packs_var_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "print_tag_batch_variant_packs" */
export type Print_Tag_Batch_Variant_Packs_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Print_Tag_Batch_Variant_Packs_Var_Samp_Fields = {
  __typename?: 'print_tag_batch_variant_packs_var_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "print_tag_batch_variant_packs" */
export type Print_Tag_Batch_Variant_Packs_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Print_Tag_Batch_Variant_Packs_Variance_Fields = {
  __typename?: 'print_tag_batch_variant_packs_variance_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "print_tag_batch_variant_packs" */
export type Print_Tag_Batch_Variant_Packs_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "print_tag_batches" */
export type Print_Tag_Batches = Node & {
  __typename?: 'print_tag_batches';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  print_tag_batch_variant_packs: Array<Print_Tag_Batch_Variant_Packs>;
  /** An aggregate relationship */
  print_tag_batch_variant_packs_aggregate: Print_Tag_Batch_Variant_Packs_Aggregate;
  /** An array relationship connection */
  print_tag_batch_variant_packs_connection: Print_Tag_Batch_Variant_PacksConnection;
  /** An object relationship */
  print_tag_template: Print_Tag_Templates;
  print_tag_template_uuid: Scalars['uuid']['output'];
  requested_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  restaurant: Businesses;
  restaurant_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "print_tag_batches" */
export type Print_Tag_BatchesPrint_Tag_Batch_Variant_PacksArgs = {
  distinct_on?: InputMaybe<Array<Print_Tag_Batch_Variant_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Print_Tag_Batch_Variant_Packs_Order_By>>;
  where?: InputMaybe<Print_Tag_Batch_Variant_Packs_Bool_Exp>;
};


/** columns and relationships of "print_tag_batches" */
export type Print_Tag_BatchesPrint_Tag_Batch_Variant_Packs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Print_Tag_Batch_Variant_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Print_Tag_Batch_Variant_Packs_Order_By>>;
  where?: InputMaybe<Print_Tag_Batch_Variant_Packs_Bool_Exp>;
};


/** columns and relationships of "print_tag_batches" */
export type Print_Tag_BatchesPrint_Tag_Batch_Variant_Packs_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Print_Tag_Batch_Variant_Packs_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Print_Tag_Batch_Variant_Packs_Order_By>>;
  where?: InputMaybe<Print_Tag_Batch_Variant_Packs_Bool_Exp>;
};

/** A Relay connection object on "print_tag_batches" */
export type Print_Tag_BatchesConnection = {
  __typename?: 'print_tag_batchesConnection';
  edges: Array<Print_Tag_BatchesEdge>;
  pageInfo: PageInfo;
};

export type Print_Tag_BatchesEdge = {
  __typename?: 'print_tag_batchesEdge';
  cursor: Scalars['String']['output'];
  node: Print_Tag_Batches;
};

/** Boolean expression to filter rows from the table "print_tag_batches". All fields are combined with a logical 'AND'. */
export type Print_Tag_Batches_Bool_Exp = {
  _and?: InputMaybe<Array<Print_Tag_Batches_Bool_Exp>>;
  _not?: InputMaybe<Print_Tag_Batches_Bool_Exp>;
  _or?: InputMaybe<Array<Print_Tag_Batches_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  print_tag_batch_variant_packs?: InputMaybe<Print_Tag_Batch_Variant_Packs_Bool_Exp>;
  print_tag_template?: InputMaybe<Print_Tag_Templates_Bool_Exp>;
  print_tag_template_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  requested_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  restaurant?: InputMaybe<Businesses_Bool_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "print_tag_batches". */
export type Print_Tag_Batches_Order_By = {
  created_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  print_tag_batch_variant_packs_aggregate?: InputMaybe<Print_Tag_Batch_Variant_Packs_Aggregate_Order_By>;
  print_tag_template?: InputMaybe<Print_Tag_Templates_Order_By>;
  print_tag_template_uuid?: InputMaybe<Order_By>;
  requested_at?: InputMaybe<Order_By>;
  restaurant?: InputMaybe<Businesses_Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "print_tag_batches" */
export enum Print_Tag_Batches_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Name = 'name',
  /** column name */
  PrintTagTemplateUuid = 'print_tag_template_uuid',
  /** column name */
  RequestedAt = 'requested_at',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "print_tag_batches" */
export type Print_Tag_Batches_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Print_Tag_Batches_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Print_Tag_Batches_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  print_tag_template_uuid?: InputMaybe<Scalars['uuid']['input']>;
  requested_at?: InputMaybe<Scalars['timestamptz']['input']>;
  restaurant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "print_tag_template_assignments" */
export type Print_Tag_Template_Assignments = Node & {
  __typename?: 'print_tag_template_assignments';
  id: Scalars['ID']['output'];
  /** An object relationship */
  print_tag_template: Print_Tag_Templates;
  print_tag_template_uuid: Scalars['uuid']['output'];
  restaurant_group_uuid?: Maybe<Scalars['uuid']['output']>;
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "print_tag_template_assignments" */
export type Print_Tag_Template_AssignmentsConnection = {
  __typename?: 'print_tag_template_assignmentsConnection';
  edges: Array<Print_Tag_Template_AssignmentsEdge>;
  pageInfo: PageInfo;
};

export type Print_Tag_Template_AssignmentsEdge = {
  __typename?: 'print_tag_template_assignmentsEdge';
  cursor: Scalars['String']['output'];
  node: Print_Tag_Template_Assignments;
};

/** Boolean expression to filter rows from the table "print_tag_template_assignments". All fields are combined with a logical 'AND'. */
export type Print_Tag_Template_Assignments_Bool_Exp = {
  _and?: InputMaybe<Array<Print_Tag_Template_Assignments_Bool_Exp>>;
  _not?: InputMaybe<Print_Tag_Template_Assignments_Bool_Exp>;
  _or?: InputMaybe<Array<Print_Tag_Template_Assignments_Bool_Exp>>;
  print_tag_template?: InputMaybe<Print_Tag_Templates_Bool_Exp>;
  print_tag_template_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  restaurant_group_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "print_tag_template_assignments". */
export type Print_Tag_Template_Assignments_Order_By = {
  print_tag_template?: InputMaybe<Print_Tag_Templates_Order_By>;
  print_tag_template_uuid?: InputMaybe<Order_By>;
  restaurant_group_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "print_tag_template_assignments" */
export enum Print_Tag_Template_Assignments_Select_Column {
  /** column name */
  PrintTagTemplateUuid = 'print_tag_template_uuid',
  /** column name */
  RestaurantGroupUuid = 'restaurant_group_uuid',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "print_tag_template_assignments" */
export type Print_Tag_Template_Assignments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Print_Tag_Template_Assignments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Print_Tag_Template_Assignments_Stream_Cursor_Value_Input = {
  print_tag_template_uuid?: InputMaybe<Scalars['uuid']['input']>;
  restaurant_group_uuid?: InputMaybe<Scalars['uuid']['input']>;
  restaurant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "print_tag_templates" */
export type Print_Tag_Templates = Node & {
  __typename?: 'print_tag_templates';
  display_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  name: Scalars['String']['output'];
  offline_printer_text_template?: Maybe<Scalars['String']['output']>;
  preview_image_url_list?: Maybe<Scalars['_text']['output']>;
  printer_text_language: Scalars['String']['output'];
  printer_text_template: Scalars['String']['output'];
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "print_tag_templates" */
export type Print_Tag_TemplatesMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "print_tag_templates" */
export type Print_Tag_TemplatesConnection = {
  __typename?: 'print_tag_templatesConnection';
  edges: Array<Print_Tag_TemplatesEdge>;
  pageInfo: PageInfo;
};

export type Print_Tag_TemplatesEdge = {
  __typename?: 'print_tag_templatesEdge';
  cursor: Scalars['String']['output'];
  node: Print_Tag_Templates;
};

/** Boolean expression to filter rows from the table "print_tag_templates". All fields are combined with a logical 'AND'. */
export type Print_Tag_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Print_Tag_Templates_Bool_Exp>>;
  _not?: InputMaybe<Print_Tag_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Print_Tag_Templates_Bool_Exp>>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  offline_printer_text_template?: InputMaybe<String_Comparison_Exp>;
  preview_image_url_list?: InputMaybe<_Text_Comparison_Exp>;
  printer_text_language?: InputMaybe<String_Comparison_Exp>;
  printer_text_template?: InputMaybe<String_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "print_tag_templates". */
export type Print_Tag_Templates_Order_By = {
  display_name?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  offline_printer_text_template?: InputMaybe<Order_By>;
  preview_image_url_list?: InputMaybe<Order_By>;
  printer_text_language?: InputMaybe<Order_By>;
  printer_text_template?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "print_tag_templates" */
export enum Print_Tag_Templates_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  OfflinePrinterTextTemplate = 'offline_printer_text_template',
  /** column name */
  PreviewImageUrlList = 'preview_image_url_list',
  /** column name */
  PrinterTextLanguage = 'printer_text_language',
  /** column name */
  PrinterTextTemplate = 'printer_text_template',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "print_tag_templates" */
export type Print_Tag_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Print_Tag_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Print_Tag_Templates_Stream_Cursor_Value_Input = {
  display_name?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offline_printer_text_template?: InputMaybe<Scalars['String']['input']>;
  preview_image_url_list?: InputMaybe<Scalars['_text']['input']>;
  printer_text_language?: InputMaybe<Scalars['String']['input']>;
  printer_text_template?: InputMaybe<Scalars['String']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "promotion_component_groups" */
export type Promotion_Component_Groups = Node & {
  __typename?: 'promotion_component_groups';
  id: Scalars['ID']['output'];
  promotion_uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "promotion_component_groups" */
export type Promotion_Component_GroupsConnection = {
  __typename?: 'promotion_component_groupsConnection';
  edges: Array<Promotion_Component_GroupsEdge>;
  pageInfo: PageInfo;
};

export type Promotion_Component_GroupsEdge = {
  __typename?: 'promotion_component_groupsEdge';
  cursor: Scalars['String']['output'];
  node: Promotion_Component_Groups;
};

/** Boolean expression to filter rows from the table "promotion_component_groups". All fields are combined with a logical 'AND'. */
export type Promotion_Component_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Promotion_Component_Groups_Bool_Exp>>;
  _not?: InputMaybe<Promotion_Component_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Promotion_Component_Groups_Bool_Exp>>;
  promotion_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "promotion_component_groups". */
export type Promotion_Component_Groups_Order_By = {
  promotion_uuid?: InputMaybe<Order_By>;
};

/** select columns of table "promotion_component_groups" */
export enum Promotion_Component_Groups_Select_Column {
  /** column name */
  PromotionUuid = 'promotion_uuid'
}

/** Streaming cursor of the table "promotion_component_groups" */
export type Promotion_Component_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Promotion_Component_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Promotion_Component_Groups_Stream_Cursor_Value_Input = {
  promotion_uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "promotion_effect_variant_pack_rel" */
export type Promotion_Effect_Variant_Pack_Rel = Node & {
  __typename?: 'promotion_effect_variant_pack_rel';
  id: Scalars['ID']['output'];
  promotion_effect_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
  /** An object relationship */
  variant_pack: Variants_Packs;
  variant_pack_uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "promotion_effect_variant_pack_rel" */
export type Promotion_Effect_Variant_Pack_RelConnection = {
  __typename?: 'promotion_effect_variant_pack_relConnection';
  edges: Array<Promotion_Effect_Variant_Pack_RelEdge>;
  pageInfo: PageInfo;
};

export type Promotion_Effect_Variant_Pack_RelEdge = {
  __typename?: 'promotion_effect_variant_pack_relEdge';
  cursor: Scalars['String']['output'];
  node: Promotion_Effect_Variant_Pack_Rel;
};

/** order by aggregate values of table "promotion_effect_variant_pack_rel" */
export type Promotion_Effect_Variant_Pack_Rel_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Promotion_Effect_Variant_Pack_Rel_Max_Order_By>;
  min?: InputMaybe<Promotion_Effect_Variant_Pack_Rel_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "promotion_effect_variant_pack_rel". All fields are combined with a logical 'AND'. */
export type Promotion_Effect_Variant_Pack_Rel_Bool_Exp = {
  _and?: InputMaybe<Array<Promotion_Effect_Variant_Pack_Rel_Bool_Exp>>;
  _not?: InputMaybe<Promotion_Effect_Variant_Pack_Rel_Bool_Exp>;
  _or?: InputMaybe<Array<Promotion_Effect_Variant_Pack_Rel_Bool_Exp>>;
  promotion_effect_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack?: InputMaybe<Variants_Packs_Bool_Exp>;
  variant_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "promotion_effect_variant_pack_rel" */
export type Promotion_Effect_Variant_Pack_Rel_Max_Order_By = {
  promotion_effect_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "promotion_effect_variant_pack_rel" */
export type Promotion_Effect_Variant_Pack_Rel_Min_Order_By = {
  promotion_effect_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "promotion_effect_variant_pack_rel". */
export type Promotion_Effect_Variant_Pack_Rel_Order_By = {
  promotion_effect_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack?: InputMaybe<Variants_Packs_Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** select columns of table "promotion_effect_variant_pack_rel" */
export enum Promotion_Effect_Variant_Pack_Rel_Select_Column {
  /** column name */
  PromotionEffectUuid = 'promotion_effect_uuid',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VariantPackUuid = 'variant_pack_uuid'
}

/** columns and relationships of "promotion_effects" */
export type Promotion_Effects = Node & {
  __typename?: 'promotion_effects';
  id: Scalars['ID']['output'];
  metadata: Scalars['jsonb']['output'];
  promotion_component_group_uuid: Scalars['uuid']['output'];
  /** An array relationship */
  promotion_effect_variant_pack_rels: Array<Promotion_Effect_Variant_Pack_Rel>;
  /** An array relationship connection */
  promotion_effect_variant_pack_rels_connection: Promotion_Effect_Variant_Pack_RelConnection;
  promotion_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "promotion_effects" */
export type Promotion_EffectsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "promotion_effects" */
export type Promotion_EffectsPromotion_Effect_Variant_Pack_RelsArgs = {
  distinct_on?: InputMaybe<Array<Promotion_Effect_Variant_Pack_Rel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Promotion_Effect_Variant_Pack_Rel_Order_By>>;
  where?: InputMaybe<Promotion_Effect_Variant_Pack_Rel_Bool_Exp>;
};


/** columns and relationships of "promotion_effects" */
export type Promotion_EffectsPromotion_Effect_Variant_Pack_Rels_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Promotion_Effect_Variant_Pack_Rel_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Promotion_Effect_Variant_Pack_Rel_Order_By>>;
  where?: InputMaybe<Promotion_Effect_Variant_Pack_Rel_Bool_Exp>;
};

/** A Relay connection object on "promotion_effects" */
export type Promotion_EffectsConnection = {
  __typename?: 'promotion_effectsConnection';
  edges: Array<Promotion_EffectsEdge>;
  pageInfo: PageInfo;
};

export type Promotion_EffectsEdge = {
  __typename?: 'promotion_effectsEdge';
  cursor: Scalars['String']['output'];
  node: Promotion_Effects;
};

/** order by aggregate values of table "promotion_effects" */
export type Promotion_Effects_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Promotion_Effects_Max_Order_By>;
  min?: InputMaybe<Promotion_Effects_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "promotion_effects". All fields are combined with a logical 'AND'. */
export type Promotion_Effects_Bool_Exp = {
  _and?: InputMaybe<Array<Promotion_Effects_Bool_Exp>>;
  _not?: InputMaybe<Promotion_Effects_Bool_Exp>;
  _or?: InputMaybe<Array<Promotion_Effects_Bool_Exp>>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  promotion_component_group_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  promotion_effect_variant_pack_rels?: InputMaybe<Promotion_Effect_Variant_Pack_Rel_Bool_Exp>;
  promotion_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "promotion_effects" */
export type Promotion_Effects_Max_Order_By = {
  promotion_component_group_uuid?: InputMaybe<Order_By>;
  promotion_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "promotion_effects" */
export type Promotion_Effects_Min_Order_By = {
  promotion_component_group_uuid?: InputMaybe<Order_By>;
  promotion_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "promotion_effects". */
export type Promotion_Effects_Order_By = {
  metadata?: InputMaybe<Order_By>;
  promotion_component_group_uuid?: InputMaybe<Order_By>;
  promotion_effect_variant_pack_rels_aggregate?: InputMaybe<Promotion_Effect_Variant_Pack_Rel_Aggregate_Order_By>;
  promotion_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "promotion_effects" */
export enum Promotion_Effects_Select_Column {
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PromotionComponentGroupUuid = 'promotion_component_group_uuid',
  /** column name */
  PromotionUuid = 'promotion_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** columns and relationships of "promotion_eligibilities" */
export type Promotion_Eligibilities = Node & {
  __typename?: 'promotion_eligibilities';
  id: Scalars['ID']['output'];
  metadata: Scalars['jsonb']['output'];
  promotion_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "promotion_eligibilities" */
export type Promotion_EligibilitiesMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "promotion_eligibilities" */
export type Promotion_EligibilitiesConnection = {
  __typename?: 'promotion_eligibilitiesConnection';
  edges: Array<Promotion_EligibilitiesEdge>;
  pageInfo: PageInfo;
};

export type Promotion_EligibilitiesEdge = {
  __typename?: 'promotion_eligibilitiesEdge';
  cursor: Scalars['String']['output'];
  node: Promotion_Eligibilities;
};

/** order by aggregate values of table "promotion_eligibilities" */
export type Promotion_Eligibilities_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Promotion_Eligibilities_Max_Order_By>;
  min?: InputMaybe<Promotion_Eligibilities_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "promotion_eligibilities". All fields are combined with a logical 'AND'. */
export type Promotion_Eligibilities_Bool_Exp = {
  _and?: InputMaybe<Array<Promotion_Eligibilities_Bool_Exp>>;
  _not?: InputMaybe<Promotion_Eligibilities_Bool_Exp>;
  _or?: InputMaybe<Array<Promotion_Eligibilities_Bool_Exp>>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  promotion_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "promotion_eligibilities" */
export type Promotion_Eligibilities_Max_Order_By = {
  promotion_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "promotion_eligibilities" */
export type Promotion_Eligibilities_Min_Order_By = {
  promotion_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "promotion_eligibilities". */
export type Promotion_Eligibilities_Order_By = {
  metadata?: InputMaybe<Order_By>;
  promotion_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "promotion_eligibilities" */
export enum Promotion_Eligibilities_Select_Column {
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PromotionUuid = 'promotion_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** columns and relationships of "promotion_qualification_variant_pack_rel" */
export type Promotion_Qualification_Variant_Pack_Rel = Node & {
  __typename?: 'promotion_qualification_variant_pack_rel';
  id: Scalars['ID']['output'];
  promotion_qualification_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
  /** An object relationship */
  variant_pack: Variants_Packs;
  variant_pack_uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "promotion_qualification_variant_pack_rel" */
export type Promotion_Qualification_Variant_Pack_RelConnection = {
  __typename?: 'promotion_qualification_variant_pack_relConnection';
  edges: Array<Promotion_Qualification_Variant_Pack_RelEdge>;
  pageInfo: PageInfo;
};

export type Promotion_Qualification_Variant_Pack_RelEdge = {
  __typename?: 'promotion_qualification_variant_pack_relEdge';
  cursor: Scalars['String']['output'];
  node: Promotion_Qualification_Variant_Pack_Rel;
};

/** order by aggregate values of table "promotion_qualification_variant_pack_rel" */
export type Promotion_Qualification_Variant_Pack_Rel_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Promotion_Qualification_Variant_Pack_Rel_Max_Order_By>;
  min?: InputMaybe<Promotion_Qualification_Variant_Pack_Rel_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "promotion_qualification_variant_pack_rel". All fields are combined with a logical 'AND'. */
export type Promotion_Qualification_Variant_Pack_Rel_Bool_Exp = {
  _and?: InputMaybe<Array<Promotion_Qualification_Variant_Pack_Rel_Bool_Exp>>;
  _not?: InputMaybe<Promotion_Qualification_Variant_Pack_Rel_Bool_Exp>;
  _or?: InputMaybe<Array<Promotion_Qualification_Variant_Pack_Rel_Bool_Exp>>;
  promotion_qualification_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack?: InputMaybe<Variants_Packs_Bool_Exp>;
  variant_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "promotion_qualification_variant_pack_rel" */
export type Promotion_Qualification_Variant_Pack_Rel_Max_Order_By = {
  promotion_qualification_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "promotion_qualification_variant_pack_rel" */
export type Promotion_Qualification_Variant_Pack_Rel_Min_Order_By = {
  promotion_qualification_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "promotion_qualification_variant_pack_rel". */
export type Promotion_Qualification_Variant_Pack_Rel_Order_By = {
  promotion_qualification_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack?: InputMaybe<Variants_Packs_Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** select columns of table "promotion_qualification_variant_pack_rel" */
export enum Promotion_Qualification_Variant_Pack_Rel_Select_Column {
  /** column name */
  PromotionQualificationUuid = 'promotion_qualification_uuid',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VariantPackUuid = 'variant_pack_uuid'
}

/** columns and relationships of "promotion_qualifications" */
export type Promotion_Qualifications = Node & {
  __typename?: 'promotion_qualifications';
  id: Scalars['ID']['output'];
  metadata: Scalars['jsonb']['output'];
  promotion_component_group_uuid: Scalars['uuid']['output'];
  /** An array relationship */
  promotion_qualification_variant_pack_rels: Array<Promotion_Qualification_Variant_Pack_Rel>;
  /** An array relationship connection */
  promotion_qualification_variant_pack_rels_connection: Promotion_Qualification_Variant_Pack_RelConnection;
  promotion_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "promotion_qualifications" */
export type Promotion_QualificationsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "promotion_qualifications" */
export type Promotion_QualificationsPromotion_Qualification_Variant_Pack_RelsArgs = {
  distinct_on?: InputMaybe<Array<Promotion_Qualification_Variant_Pack_Rel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Promotion_Qualification_Variant_Pack_Rel_Order_By>>;
  where?: InputMaybe<Promotion_Qualification_Variant_Pack_Rel_Bool_Exp>;
};


/** columns and relationships of "promotion_qualifications" */
export type Promotion_QualificationsPromotion_Qualification_Variant_Pack_Rels_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Promotion_Qualification_Variant_Pack_Rel_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Promotion_Qualification_Variant_Pack_Rel_Order_By>>;
  where?: InputMaybe<Promotion_Qualification_Variant_Pack_Rel_Bool_Exp>;
};

/** A Relay connection object on "promotion_qualifications" */
export type Promotion_QualificationsConnection = {
  __typename?: 'promotion_qualificationsConnection';
  edges: Array<Promotion_QualificationsEdge>;
  pageInfo: PageInfo;
};

export type Promotion_QualificationsEdge = {
  __typename?: 'promotion_qualificationsEdge';
  cursor: Scalars['String']['output'];
  node: Promotion_Qualifications;
};

/** order by aggregate values of table "promotion_qualifications" */
export type Promotion_Qualifications_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Promotion_Qualifications_Max_Order_By>;
  min?: InputMaybe<Promotion_Qualifications_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "promotion_qualifications". All fields are combined with a logical 'AND'. */
export type Promotion_Qualifications_Bool_Exp = {
  _and?: InputMaybe<Array<Promotion_Qualifications_Bool_Exp>>;
  _not?: InputMaybe<Promotion_Qualifications_Bool_Exp>;
  _or?: InputMaybe<Array<Promotion_Qualifications_Bool_Exp>>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  promotion_component_group_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  promotion_qualification_variant_pack_rels?: InputMaybe<Promotion_Qualification_Variant_Pack_Rel_Bool_Exp>;
  promotion_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "promotion_qualifications" */
export type Promotion_Qualifications_Max_Order_By = {
  promotion_component_group_uuid?: InputMaybe<Order_By>;
  promotion_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "promotion_qualifications" */
export type Promotion_Qualifications_Min_Order_By = {
  promotion_component_group_uuid?: InputMaybe<Order_By>;
  promotion_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "promotion_qualifications". */
export type Promotion_Qualifications_Order_By = {
  metadata?: InputMaybe<Order_By>;
  promotion_component_group_uuid?: InputMaybe<Order_By>;
  promotion_qualification_variant_pack_rels_aggregate?: InputMaybe<Promotion_Qualification_Variant_Pack_Rel_Aggregate_Order_By>;
  promotion_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "promotion_qualifications" */
export enum Promotion_Qualifications_Select_Column {
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PromotionComponentGroupUuid = 'promotion_component_group_uuid',
  /** column name */
  PromotionUuid = 'promotion_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** columns and relationships of "promotions" */
export type Promotions = Node & {
  __typename?: 'promotions';
  audience_type: Scalars['String']['output'];
  background_color_end: Scalars['String']['output'];
  background_color_start: Scalars['String']['output'];
  background_image_url?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  discount_type: Scalars['String']['output'];
  ended_at?: Maybe<Scalars['timestamptz']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  hide_marketing_tile: Scalars['Boolean']['output'];
  hide_tagline: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  marketing_text?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  order_item_promotion_rels: Array<Order_Item_Promotion_Rel>;
  /** An array relationship connection */
  order_item_promotion_rels_connection: Order_Item_Promotion_RelConnection;
  /** An array relationship */
  order_promotion_rels: Array<Order_Promotion_Rel>;
  /** An array relationship connection */
  order_promotion_rels_connection: Order_Promotion_RelConnection;
  pack_price_in_micros?: Maybe<Scalars['bigint']['output']>;
  photo_url_list?: Maybe<Scalars['_text']['output']>;
  /** An array relationship */
  promotion_effects: Array<Promotion_Effects>;
  /** An array relationship connection */
  promotion_effects_connection: Promotion_EffectsConnection;
  /** An array relationship */
  promotion_eligibilities: Array<Promotion_Eligibilities>;
  /** An array relationship connection */
  promotion_eligibilities_connection: Promotion_EligibilitiesConnection;
  /** An array relationship */
  promotion_qualifications: Array<Promotion_Qualifications>;
  /** An array relationship connection */
  promotion_qualifications_connection: Promotion_QualificationsConnection;
  /** An array relationship */
  promotions_restaurants: Array<Promotions_Restaurants>;
  /** An array relationship connection */
  promotions_restaurants_connection: Promotions_RestaurantsConnection;
  send_push_notification: Scalars['Boolean']['output'];
  sort_order?: Maybe<Scalars['float8']['output']>;
  starts_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  supplier: Businesses;
  supplier_uuid: Scalars['uuid']['output'];
  tagline?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "promotions" */
export type PromotionsOrder_Item_Promotion_RelsArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Promotion_Rel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Item_Promotion_Rel_Order_By>>;
  where?: InputMaybe<Order_Item_Promotion_Rel_Bool_Exp>;
};


/** columns and relationships of "promotions" */
export type PromotionsOrder_Item_Promotion_Rels_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Item_Promotion_Rel_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Item_Promotion_Rel_Order_By>>;
  where?: InputMaybe<Order_Item_Promotion_Rel_Bool_Exp>;
};


/** columns and relationships of "promotions" */
export type PromotionsOrder_Promotion_RelsArgs = {
  distinct_on?: InputMaybe<Array<Order_Promotion_Rel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Promotion_Rel_Order_By>>;
  where?: InputMaybe<Order_Promotion_Rel_Bool_Exp>;
};


/** columns and relationships of "promotions" */
export type PromotionsOrder_Promotion_Rels_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Promotion_Rel_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Promotion_Rel_Order_By>>;
  where?: InputMaybe<Order_Promotion_Rel_Bool_Exp>;
};


/** columns and relationships of "promotions" */
export type PromotionsPromotion_EffectsArgs = {
  distinct_on?: InputMaybe<Array<Promotion_Effects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Promotion_Effects_Order_By>>;
  where?: InputMaybe<Promotion_Effects_Bool_Exp>;
};


/** columns and relationships of "promotions" */
export type PromotionsPromotion_Effects_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Promotion_Effects_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Promotion_Effects_Order_By>>;
  where?: InputMaybe<Promotion_Effects_Bool_Exp>;
};


/** columns and relationships of "promotions" */
export type PromotionsPromotion_EligibilitiesArgs = {
  distinct_on?: InputMaybe<Array<Promotion_Eligibilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Promotion_Eligibilities_Order_By>>;
  where?: InputMaybe<Promotion_Eligibilities_Bool_Exp>;
};


/** columns and relationships of "promotions" */
export type PromotionsPromotion_Eligibilities_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Promotion_Eligibilities_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Promotion_Eligibilities_Order_By>>;
  where?: InputMaybe<Promotion_Eligibilities_Bool_Exp>;
};


/** columns and relationships of "promotions" */
export type PromotionsPromotion_QualificationsArgs = {
  distinct_on?: InputMaybe<Array<Promotion_Qualifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Promotion_Qualifications_Order_By>>;
  where?: InputMaybe<Promotion_Qualifications_Bool_Exp>;
};


/** columns and relationships of "promotions" */
export type PromotionsPromotion_Qualifications_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Promotion_Qualifications_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Promotion_Qualifications_Order_By>>;
  where?: InputMaybe<Promotion_Qualifications_Bool_Exp>;
};


/** columns and relationships of "promotions" */
export type PromotionsPromotions_RestaurantsArgs = {
  distinct_on?: InputMaybe<Array<Promotions_Restaurants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Promotions_Restaurants_Order_By>>;
  where?: InputMaybe<Promotions_Restaurants_Bool_Exp>;
};


/** columns and relationships of "promotions" */
export type PromotionsPromotions_Restaurants_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Promotions_Restaurants_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Promotions_Restaurants_Order_By>>;
  where?: InputMaybe<Promotions_Restaurants_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "promotions". All fields are combined with a logical 'AND'. */
export type Promotions_Bool_Exp = {
  _and?: InputMaybe<Array<Promotions_Bool_Exp>>;
  _not?: InputMaybe<Promotions_Bool_Exp>;
  _or?: InputMaybe<Array<Promotions_Bool_Exp>>;
  audience_type?: InputMaybe<String_Comparison_Exp>;
  background_color_end?: InputMaybe<String_Comparison_Exp>;
  background_color_start?: InputMaybe<String_Comparison_Exp>;
  background_image_url?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  discount_type?: InputMaybe<String_Comparison_Exp>;
  ended_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hide_marketing_tile?: InputMaybe<Boolean_Comparison_Exp>;
  hide_tagline?: InputMaybe<Boolean_Comparison_Exp>;
  marketing_text?: InputMaybe<String_Comparison_Exp>;
  order_item_promotion_rels?: InputMaybe<Order_Item_Promotion_Rel_Bool_Exp>;
  order_promotion_rels?: InputMaybe<Order_Promotion_Rel_Bool_Exp>;
  pack_price_in_micros?: InputMaybe<Bigint_Comparison_Exp>;
  photo_url_list?: InputMaybe<_Text_Comparison_Exp>;
  promotion_effects?: InputMaybe<Promotion_Effects_Bool_Exp>;
  promotion_eligibilities?: InputMaybe<Promotion_Eligibilities_Bool_Exp>;
  promotion_qualifications?: InputMaybe<Promotion_Qualifications_Bool_Exp>;
  promotions_restaurants?: InputMaybe<Promotions_Restaurants_Bool_Exp>;
  send_push_notification?: InputMaybe<Boolean_Comparison_Exp>;
  sort_order?: InputMaybe<Float8_Comparison_Exp>;
  starts_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  tagline?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "promotions". */
export type Promotions_Order_By = {
  audience_type?: InputMaybe<Order_By>;
  background_color_end?: InputMaybe<Order_By>;
  background_color_start?: InputMaybe<Order_By>;
  background_image_url?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  discount_type?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  hide_marketing_tile?: InputMaybe<Order_By>;
  hide_tagline?: InputMaybe<Order_By>;
  marketing_text?: InputMaybe<Order_By>;
  order_item_promotion_rels_aggregate?: InputMaybe<Order_Item_Promotion_Rel_Aggregate_Order_By>;
  order_promotion_rels_aggregate?: InputMaybe<Order_Promotion_Rel_Aggregate_Order_By>;
  pack_price_in_micros?: InputMaybe<Order_By>;
  photo_url_list?: InputMaybe<Order_By>;
  promotion_effects_aggregate?: InputMaybe<Promotion_Effects_Aggregate_Order_By>;
  promotion_eligibilities_aggregate?: InputMaybe<Promotion_Eligibilities_Aggregate_Order_By>;
  promotion_qualifications_aggregate?: InputMaybe<Promotion_Qualifications_Aggregate_Order_By>;
  promotions_restaurants_aggregate?: InputMaybe<Promotions_Restaurants_Aggregate_Order_By>;
  send_push_notification?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  starts_at?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  tagline?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "promotions_restaurants" */
export type Promotions_Restaurants = Node & {
  __typename?: 'promotions_restaurants';
  id: Scalars['ID']['output'];
  /** An object relationship */
  promotion: Promotions;
  promotion_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  restaurant: Businesses;
  restaurant_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "promotions_restaurants" */
export type Promotions_RestaurantsConnection = {
  __typename?: 'promotions_restaurantsConnection';
  edges: Array<Promotions_RestaurantsEdge>;
  pageInfo: PageInfo;
};

export type Promotions_RestaurantsEdge = {
  __typename?: 'promotions_restaurantsEdge';
  cursor: Scalars['String']['output'];
  node: Promotions_Restaurants;
};

/** order by aggregate values of table "promotions_restaurants" */
export type Promotions_Restaurants_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Promotions_Restaurants_Max_Order_By>;
  min?: InputMaybe<Promotions_Restaurants_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "promotions_restaurants". All fields are combined with a logical 'AND'. */
export type Promotions_Restaurants_Bool_Exp = {
  _and?: InputMaybe<Array<Promotions_Restaurants_Bool_Exp>>;
  _not?: InputMaybe<Promotions_Restaurants_Bool_Exp>;
  _or?: InputMaybe<Array<Promotions_Restaurants_Bool_Exp>>;
  promotion?: InputMaybe<Promotions_Bool_Exp>;
  promotion_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  restaurant?: InputMaybe<Businesses_Bool_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "promotions_restaurants" */
export type Promotions_Restaurants_Max_Order_By = {
  promotion_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "promotions_restaurants" */
export type Promotions_Restaurants_Min_Order_By = {
  promotion_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "promotions_restaurants". */
export type Promotions_Restaurants_Order_By = {
  promotion?: InputMaybe<Promotions_Order_By>;
  promotion_uuid?: InputMaybe<Order_By>;
  restaurant?: InputMaybe<Businesses_Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "promotions_restaurants" */
export enum Promotions_Restaurants_Select_Column {
  /** column name */
  PromotionUuid = 'promotion_uuid',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  Uuid = 'uuid'
}

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "analytics_alerts" */
  analytics_alerts: Array<Analytics_Alerts>;
  /** fetch aggregated fields from the table: "analytics_alerts" */
  analytics_alerts_aggregate: Analytics_Alerts_Aggregate;
  /** fetch data from the table: "analytics_alerts" using primary key columns */
  analytics_alerts_by_pk?: Maybe<Analytics_Alerts>;
  /** fetch data from the table: "analytics_alerts" */
  analytics_alerts_connection: Analytics_AlertsConnection;
  /** fetch data from the table: "application_decision_notifications" */
  application_decision_notifications: Array<Application_Decision_Notifications>;
  /** fetch data from the table: "application_decision_notifications" using primary key columns */
  application_decision_notifications_by_pk?: Maybe<Application_Decision_Notifications>;
  /** fetch data from the table: "application_decision_notifications" */
  application_decision_notifications_connection: Application_Decision_NotificationsConnection;
  /** fetch data from the table: "auto_pay_settings" */
  auto_pay_settings: Array<Auto_Pay_Settings>;
  /** fetch data from the table: "auto_pay_settings" using primary key columns */
  auto_pay_settings_by_pk?: Maybe<Auto_Pay_Settings>;
  /** fetch data from the table: "auto_pay_settings" */
  auto_pay_settings_connection: Auto_Pay_SettingsConnection;
  /** fetch data from the table: "brand_page_variant_packs" */
  brand_page_variant_packs: Array<Brand_Page_Variant_Packs>;
  /** fetch data from the table: "brand_pages" */
  brand_pages: Array<Brand_Pages>;
  /** fetch data from the table: "brand_pages" using primary key columns */
  brand_pages_by_pk?: Maybe<Brand_Pages>;
  /** fetch data from the table: "brand_pages" */
  brand_pages_connection: Brand_PagesConnection;
  /** fetch data from the table: "business_organizations" */
  business_organizations: Array<Business_Organizations>;
  /** fetch data from the table: "business_organizations" using primary key columns */
  business_organizations_by_pk?: Maybe<Business_Organizations>;
  /** fetch data from the table: "business_organizations" */
  business_organizations_connection: Business_OrganizationsConnection;
  /** An array relationship */
  businesses: Array<Businesses>;
  /** fetch data from the table: "businesses" using primary key columns */
  businesses_by_pk?: Maybe<Businesses>;
  /** An array relationship connection */
  businesses_connection: BusinessesConnection;
  /** List variant packs whose served data changed, oldest change first. Changes from about the last minute are held back, so a change that is still being written is not missed. See `completeThrough`. */
  changedVariantPacks: ChangedVariantPacksPage;
  /** fetch data from the table: "chat_last_message" */
  chat_last_message: Array<Chat_Last_Message>;
  /** fetch data from the table: "chat_unread_message_count" */
  chat_unread_message_count: Array<Chat_Unread_Message_Count>;
  /** fetch data from the table: "chats" */
  chats: Array<Chats>;
  /** fetch data from the table: "chats" using primary key columns */
  chats_by_pk?: Maybe<Chats>;
  /** fetch data from the table: "chats" */
  chats_connection: ChatsConnection;
  /** fetch data from the table: "chats_route_metadata" */
  chats_route_metadata: Array<Chats_Route_Metadata>;
  /** fetch data from the table: "chats_route_metadata" */
  chats_route_metadata_connection: Chats_Route_MetadataConnection;
  /** fetch data from the table: "credit_application_consent_acceptances" */
  credit_application_consent_acceptances: Array<Credit_Application_Consent_Acceptances>;
  /** fetch data from the table: "credit_application_consent_acceptances" using primary key columns */
  credit_application_consent_acceptances_by_pk?: Maybe<Credit_Application_Consent_Acceptances>;
  /** fetch data from the table: "credit_application_consent_acceptances" */
  credit_application_consent_acceptances_connection: Credit_Application_Consent_AcceptancesConnection;
  /** fetch data from the table: "credit_application_form_fields" */
  credit_application_form_fields: Array<Credit_Application_Form_Fields>;
  /** fetch data from the table: "credit_application_form_fields" using primary key columns */
  credit_application_form_fields_by_pk?: Maybe<Credit_Application_Form_Fields>;
  /** fetch data from the table: "credit_application_form_fields" */
  credit_application_form_fields_connection: Credit_Application_Form_FieldsConnection;
  /** fetch data from the table: "credit_application_form_sections" */
  credit_application_form_sections: Array<Credit_Application_Form_Sections>;
  /** fetch data from the table: "credit_application_form_sections" using primary key columns */
  credit_application_form_sections_by_pk?: Maybe<Credit_Application_Form_Sections>;
  /** fetch data from the table: "credit_application_form_sections" */
  credit_application_form_sections_connection: Credit_Application_Form_SectionsConnection;
  /** fetch data from the table: "credit_application_form_versions" */
  credit_application_form_versions: Array<Credit_Application_Form_Versions>;
  /** fetch data from the table: "credit_application_form_versions" using primary key columns */
  credit_application_form_versions_by_pk?: Maybe<Credit_Application_Form_Versions>;
  /** fetch data from the table: "credit_application_form_versions" */
  credit_application_form_versions_connection: Credit_Application_Form_VersionsConnection;
  /** An array relationship */
  credit_application_forms: Array<Credit_Application_Forms>;
  /** fetch data from the table: "credit_application_forms" using primary key columns */
  credit_application_forms_by_pk?: Maybe<Credit_Application_Forms>;
  /** An array relationship connection */
  credit_application_forms_connection: Credit_Application_FormsConnection;
  /** An array relationship */
  credit_applications: Array<Credit_Applications>;
  /** fetch data from the table: "credit_applications" using primary key columns */
  credit_applications_by_pk?: Maybe<Credit_Applications>;
  /** An array relationship connection */
  credit_applications_connection: Credit_ApplicationsConnection;
  /** fetch data from the table: "credit_form_version_form_section_rel" */
  credit_form_version_form_section_rel: Array<Credit_Form_Version_Form_Section_Rel>;
  /** fetch data from the table: "credit_form_version_form_section_rel" using primary key columns */
  credit_form_version_form_section_rel_by_pk?: Maybe<Credit_Form_Version_Form_Section_Rel>;
  /** fetch data from the table: "credit_form_version_form_section_rel" */
  credit_form_version_form_section_rel_connection: Credit_Form_Version_Form_Section_RelConnection;
  /** fetch data from the table: "credit_memos" */
  credit_memos: Array<Credit_Memos>;
  /** fetch data from the table: "credit_memos" using primary key columns */
  credit_memos_by_pk?: Maybe<Credit_Memos>;
  /** fetch data from the table: "credit_memos" */
  credit_memos_connection: Credit_MemosConnection;
  /** An array relationship */
  credit_request_batch_line_items: Array<Credit_Request_Batch_Line_Items>;
  /** fetch data from the table: "credit_request_batch_line_items" using primary key columns */
  credit_request_batch_line_items_by_pk?: Maybe<Credit_Request_Batch_Line_Items>;
  /** An array relationship connection */
  credit_request_batch_line_items_connection: Credit_Request_Batch_Line_ItemsConnection;
  /** An array relationship */
  credit_request_batches: Array<Credit_Request_Batches>;
  /** An aggregate relationship */
  credit_request_batches_aggregate: Credit_Request_Batches_Aggregate;
  /** fetch data from the table: "credit_request_batches" using primary key columns */
  credit_request_batches_by_pk?: Maybe<Credit_Request_Batches>;
  /** An array relationship connection */
  credit_request_batches_connection: Credit_Request_BatchesConnection;
  /** fetch data from the table: "credit_request_reasons" */
  credit_request_reasons: Array<Credit_Request_Reasons>;
  /** fetch data from the table: "credit_request_reasons" using primary key columns */
  credit_request_reasons_by_pk?: Maybe<Credit_Request_Reasons>;
  /** fetch data from the table: "credit_request_reasons" */
  credit_request_reasons_connection: Credit_Request_ReasonsConnection;
  /** fetch data from the table: "crm_activities" */
  crm_activities: Array<Crm_Activities>;
  /** fetch aggregated fields from the table: "crm_activities" */
  crm_activities_aggregate: Crm_Activities_Aggregate;
  /** fetch data from the table: "crm_activities" using primary key columns */
  crm_activities_by_pk?: Maybe<Crm_Activities>;
  /** fetch data from the table: "crm_activities" */
  crm_activities_connection: Crm_ActivitiesConnection;
  /** fetch data from the table: "crm_activity_notes" */
  crm_activity_notes: Array<Crm_Activity_Notes>;
  /** fetch data from the table: "crm_activity_notes" using primary key columns */
  crm_activity_notes_by_pk?: Maybe<Crm_Activity_Notes>;
  /** fetch data from the table: "crm_activity_notes" */
  crm_activity_notes_connection: Crm_Activity_NotesConnection;
  /** fetch data from the table: "employee_chats" */
  employee_chats: Array<Employee_Chats>;
  /** fetch data from the table: "employee_smart_orders" */
  employee_smart_orders: Array<Employee_Smart_Orders>;
  /** fetch data from the table: "employees" */
  employees: Array<Employees>;
  /** fetch data from the table: "employees" using primary key columns */
  employees_by_pk?: Maybe<Employees>;
  /** fetch data from the table: "employees" */
  employees_connection: EmployeesConnection;
  getAdyenDropinConfig: GetAdyenDropinConfigResponse;
  getAllHubAlerts: GetAllHubAnalyticsAlertsResponse;
  getAnalyticsAlerts: GetAnalyticsAlertsResponse;
  getAutoPayCustomers: Array<AutoPayCustomer>;
  getAutoPayRunPreview: AutoPayRunPreviewResponse;
  getAutoPaySettingCustomers: Array<AutoPayCustomer>;
  getAutoPaySettings: Array<AutoPaySettingsResponse>;
  getAutoPaySettingsV2: Array<SupplierAutoPaySettings>;
  getAutopayStatus: AutoPayStatusResponse;
  getAvailableCreditMemosByCustomer: Array<GetAvailableCreditMemosByCustomerResponse>;
  getAvailableOrderFulfillments: Array<GetAvailableOrderFulfillmentResponse>;
  getBrandPageDetails: Array<GetBrandPageDetailsResponse>;
  getBrandPageVariantPacks: Array<GetBrandPageVariantPacksResponse>;
  getBrandsCarousel: Array<GetBrandsCarouselResponse>;
  getBusinessDetails: BusinessDetailsResponse;
  getBusinessOrganizationPricingConfig: OrgPricingConfigResponse;
  getCardDetails: GetCardDetailsResponse;
  getChatbotMessages: GetChatbotMessageResponse;
  getCollectedManualPayments: GetCollectedManualPaymentsResponse;
  getCreditMemoById: GetCreditMemoByIdResponse;
  getCreditRequestVariantPackEligibility: GetCreditRequestEligibilityResponse;
  getCriticalItems: Array<VariantPackResponse>;
  getCrmActivities: CrmActivitiesPage;
  getCustomerDetailData: GetCustomerDetailDataResponse;
  getCustomerListData: GetCustomerListDataResponse;
  getCustomerListDataForBusinessOrganization: GetCustomerListDataForBusinessOrganizationResponse;
  getDisplayAdVariantPacksEvents: Array<GetDisplayAdVariantPacksEventsResponse>;
  getDsrAnalyticsModels: GetAnalyticsModelsResponse;
  getExternalContentForRestaurant: Array<ExternalContentResponse>;
  getExternalContentUrlForRestaurant: GetExternalContentUrlForRestaurantResponse;
  getFinanceHubCustomerList: GetFinanceHubCustomerListResponse;
  getGtinFiltersForCategory: GetGtinFiltersForCategoryResponse;
  getGtinFiltersForGroup: GetGtinFiltersForCategoryResponse;
  getGuestModeContent: Array<GetGuestModeContentResponse>;
  getHubCardData: GetHubCardDataResponse;
  getHubCurrentOrders: Array<GetHubCurrentOrdersResponse>;
  getHubPastOrders: GetHubPastOrdersResponse;
  getInvoiceGrossProfit: GetOrderInvoiceGrossProfitResponse;
  getItemRecommendations: Array<GetItemRecommendationResponse>;
  getItemSubstitutions: Array<GetItemSubstitutionsResponse>;
  getItemsFromMenuImages: GetItemsFromMenuImagesResponse;
  getLeadTimeFulfillment: Array<GetLeadTimeFulfillmentResponse>;
  getManualDeposits: GetManualDepositsResponse;
  getNearbyBusinessesV2: Array<BusinessSearchResponse>;
  getNextAutopayInfo: NextAutoPayInfoResponse;
  getNextDeliveryDateForSubscriptionSettings: NextDeliveryDateResponse;
  getObiItems: GetObiItemsResponse;
  getOrder: GetOrderResponse;
  getOrderConstraintsForRestaurant: Array<GetOrderConstraintsForRestaurantResponse>;
  getOrderEntryItemDetail: GetOrderEntryItemDetailResponse;
  getOrderEntryItemsFromCart: OrderEntryTablePage;
  getOrderEntryItemsFromOrderGuide: OrderEntryTablePage;
  getOrderEntryItemsFromVariantPackIds: OrderEntryTablePage;
  getOrderEntrySummary: GetOrderEntrySummaryResponse;
  getOrderEstimatedCommission: GetOrderEstimatedCommissionResponse;
  getOrderFees: Array<GetOrderFeesResponse>;
  getOrderFulfillmentFees: Array<OrderFulfillmentFee>;
  getOrderGrossProfit: GetOrderGrossProfitResponse;
  getOrderGuideCollectionsForOrderEntry: GetOrderGuideCollectionsForOrderEntryResponse;
  getOrderGuideItems: Array<OrderGuideItemEntryResponse>;
  getOrderGuidePriceQuoteKey: PriceQuoteByOrderGuideResponse;
  getOrderInvoiceById: GetOrderInvoiceByIdResponse;
  getOrderInvoiceByOrder: OrderInvoiceByOrderResponse;
  getOrderPdf: UrlResponse;
  getOrders: Array<OrderResponse>;
  getPadConsentForms: GetPadConsentFormsResponse;
  getPadConsentFormsForPaymentMethod: GetPadConsentFormsForPaymentMethodResponse;
  getParSheetPdf: UrlResponse;
  getPaymentLinkLineItems: GetPaymentLinkLineItemsResponse;
  getPaymentLinks: GetPaymentLinksResponse;
  getPaymentPlanNextRunDate: Array<GetPaymentPlanNextRunDateResponse>;
  getPaymentPlans: GetPaymentPlansResponse;
  getPendingOrderPriceEditApprovalRequest: GetPendingOrderPriceEditApprovalRequestResponse;
  getPeriodSalesAnalytics: Array<GetPeriodSalesAnalyticsResponse>;
  getPriceEditDisplayInfo: PriceEditDisplayInfoResponse;
  getPriceQuote: GetPriceQuoteResponse;
  getPriceQuoteDetails: PriceQuoteDetailsResponse;
  getPriceQuotes: Array<GetPriceQuoteSummaryResponse>;
  getPriceTrendsData: GetPriceTrendsDataResponse;
  getPriceTrendsDataWithCustomerGroups: GetPriceTrendsWithCustomerGroupsDataResponse;
  getPricingBookmarks: GetPricingBookmarksResponse;
  getPricingHubAgentRecs: PricingHubAgentRecs;
  getPricingHubCostChanges: PricingHubCostChanges;
  getPricingHubCustomers: PricingHubCustomers;
  getPricingHubRecentPriceChanges: Array<PricingHubRecentChange>;
  getPricingRecommendations: GetPricingRecommendationsResponse;
  getPricingRecommendationsForBusinessOrganization: GetPricingRecommendationsResponse;
  getPricingTaskRunsByTypeForBusinessOrganization: GetPricingTaskRunsByTypeForBusinessOrganizationResponse;
  getPricingTaskRunsForBusinessOrganization: GetPricingTaskRunsForBusinessOrganizationResponse;
  getPrintTagTemplatesForRestaurant: Array<GetPrintTagTemplateForRestaurantResponse>;
  getPromotionsForRestaurant: Array<GetPromotionForRestaurantResponse>;
  getProspectFinderCategoryOptions: Array<YelpCategoryOptionResponse>;
  getResolvedLeadTimeFulfillment: Array<GetResolvedLeadTimeFulfillmentResponse>;
  getRestaurantEmployees: Array<GetRestaurantEmployeesResponse>;
  getRestaurantPlanograms: Array<GetRestaurantPlanogramsResponse>;
  getRestaurantVariantPackSubscriptions: Array<RestaurantVariantPackSubscriptionData>;
  getSalesAnalyticsAlerts: GetSalesAnalyticsAlertsResponse;
  getSalesAnalyticsData: GetSalesDataAnalyticsResponse;
  getSalesPortalAccountListFilterCounts: SalesPortalAccountListFilterCounts;
  getSalesPortalAccountListInfo: Array<SalesPortalAccountInfo>;
  getSalesPortalAccountListInfoPaginated: SalesPortalAccountListInfoPage;
  getSalesPortalAccountListMetrics: Array<SalesPortalAccountMetrics>;
  getSalesPortalAccounts: Array<SalesPortalAccount>;
  getSalesPortalAccountsPaginated: SalesPortalAccountsPage;
  getSalesPortalManagerPipelineSummary: Array<ManagerPipelineStage>;
  getSalesPortalManagerProspectForecast: Array<ManagerForecastWindow>;
  getSalesPortalManagerProspectList: Array<ManagerProspectRow>;
  getSalesPortalManagerRepSummaries: Array<ManagerRepSummary>;
  getSalesPortalOrderGuideCollections: GetSalesPortalOrderGuideCollectionsResponse;
  getSalesPortalOrderGuideCollectionsForOrderEntry: GetSalesPortalOrderGuideCollectionsForOrderEntryResponse;
  getSalesPortalOrderGuideItems: Array<SalesPortalOrderGuideItem>;
  getSalesPortalProspectDetails: SalesPortalProspectDetails;
  getSalesPortalProspectListInfo: Array<SalesPortalProspectInfo>;
  getSalesPortalTabs: GetSalesPortalTabsResponse;
  getSampleRequestVariantPacks: Array<GetSampleRequestVariantPacksResponse>;
  getSearchFilters: Array<SearchFilterResponse>;
  getSmartOrderAssignableEmployees: GetSmartOrderAssignableEmployeesResponse;
  getSmartOrderDetails: Array<GetSmartOrderDetailsResponse>;
  getSmartOrderInboundAssignees: GetSmartOrderInboundAssigneesResponse;
  getSmartOrderInboundHistory: GetSmartOrderInboundHistoryResponse;
  getSmartOrderResults: Array<GetSmartOrderResponse>;
  getSupplierCatalogVariantPackGroups: Array<GetSupplierCatalogVariantPackGroupResponse>;
  getSupplierCategoryItems: Array<GetSupplierCategoryItemsResponse>;
  getSupplierVariantPackGroupItems: Array<GetSupplierVariantPackGroupItemResponse>;
  getSupplierVariantPackGroupItemsExpanded: Array<GetSupplierVariantPackGroupItemExpandedResponse>;
  getUniversalAppLink: GetUniversalAppLinkResponse;
  getUnpaidInvoiceList: GetUnpaidInvoiceListResponse;
  getUnpaidInvoiceSummary: GetUnpaidInvoiceSummaryResponse;
  getUnpaidOrderInvoicesByCustomer: Array<GetUnpaidOrderInvoicesByCustomerResponse>;
  getUnreadChatMessageCount: Array<UnreadChatMessageCountResponse>;
  getVariantPackCostChangeData: Array<VariantPackCostChange>;
  getVariantPackCostChangeDataForBusinessOrganization: Array<OrgVariantPackCostChange>;
  getVariantPackDetailedCostChangeData: Array<DetailVariantPackCostChange>;
  getVariantPackGroups: Array<GetVariantPackGroupsResponse>;
  getVariantPackInfoList: Array<GetVariantPackInfoResponse>;
  getVariantPackInvoicesForCreditRequest: GetVariantPackInvoicesForCreditRequestResponse;
  getVariantPackLastPurchaseInfo: Array<GetVariantPackLastPurchaseInfoResponse>;
  getVariantPackPricingPriceDraftUpdates: GetVariantPackPriceDraftUpdatesResponse;
  getVariantPackPrintTagConfiguration: Array<VariantPackPrintTagConfiguration>;
  getVariantPackPurchaseHistory: Array<GetVariantPackPurchaseHistoryResponse>;
  getVariantPackSubstitutions: Array<GetVariantPackSubstitutionsResponse>;
  getVisibleVariantPackPrintingPrices: GetVisibleVariantPackPrintingPricesResponse;
  getVisibleVariantPacksByVariantPackGroups: Array<GetVisibleVariantPacksByVariantPackGroupResponse>;
  getWhitelabelConfig: GetWhitelabelConfigResponse;
  /** fetch data from the table: "ghost_agents" */
  ghost_agents: Array<Ghost_Agents>;
  /** fetch data from the table: "ghost_agents" using primary key columns */
  ghost_agents_by_pk?: Maybe<Ghost_Agents>;
  /** fetch data from the table: "ghost_agents" */
  ghost_agents_connection: Ghost_AgentsConnection;
  /** fetch data from the table: "ghost_conversations" */
  ghost_conversations: Array<Ghost_Conversations>;
  /** fetch data from the table: "ghost_conversations" using primary key columns */
  ghost_conversations_by_pk?: Maybe<Ghost_Conversations>;
  /** fetch data from the table: "ghost_conversations" */
  ghost_conversations_connection: Ghost_ConversationsConnection;
  /** fetch data from the table: "ghost_execution_logs" */
  ghost_execution_logs: Array<Ghost_Execution_Logs>;
  /** fetch data from the table: "ghost_execution_logs" using primary key columns */
  ghost_execution_logs_by_pk?: Maybe<Ghost_Execution_Logs>;
  /** fetch data from the table: "ghost_execution_logs" */
  ghost_execution_logs_connection: Ghost_Execution_LogsConnection;
  /** fetch data from the table: "ghost_messages" */
  ghost_messages: Array<Ghost_Messages>;
  /** fetch data from the table: "ghost_messages" using primary key columns */
  ghost_messages_by_pk?: Maybe<Ghost_Messages>;
  /** fetch data from the table: "ghost_messages" */
  ghost_messages_connection: Ghost_MessagesConnection;
  /** fetch data from the table: "gtin_metadata" */
  gtin_metadata: Array<Gtin_Metadata>;
  /** fetch data from the table: "gtin_metadata" using primary key columns */
  gtin_metadata_by_pk?: Maybe<Gtin_Metadata>;
  /** fetch data from the table: "gtin_metadata" */
  gtin_metadata_connection: Gtin_MetadataConnection;
  /** fetch data from the table: "hub_last_visited" */
  hub_last_visited: Array<Hub_Last_Visited>;
  /** fetch data from the table: "hub_last_visited" using primary key columns */
  hub_last_visited_by_pk?: Maybe<Hub_Last_Visited>;
  /** fetch data from the table: "hub_last_visited" */
  hub_last_visited_connection: Hub_Last_VisitedConnection;
  /** An array relationship */
  menu_item_ingredients: Array<Menu_Item_Ingredients>;
  /** fetch data from the table: "menu_item_ingredients" using primary key columns */
  menu_item_ingredients_by_pk?: Maybe<Menu_Item_Ingredients>;
  /** An array relationship connection */
  menu_item_ingredients_connection: Menu_Item_IngredientsConnection;
  /** fetch data from the table: "menu_items" */
  menu_items: Array<Menu_Items>;
  /** fetch data from the table: "menu_items" using primary key columns */
  menu_items_by_pk?: Maybe<Menu_Items>;
  /** fetch data from the table: "menu_items" */
  menu_items_connection: Menu_ItemsConnection;
  /** An array relationship */
  messages: Array<Messages>;
  /** fetch data from the table: "messages" using primary key columns */
  messages_by_pk?: Maybe<Messages>;
  /** An array relationship connection */
  messages_connection: MessagesConnection;
  /** fetch data from the table: "mobile_payment_terminals" */
  mobile_payment_terminals: Array<Mobile_Payment_Terminals>;
  /** fetch data from the table: "mobile_payment_terminals" using primary key columns */
  mobile_payment_terminals_by_pk?: Maybe<Mobile_Payment_Terminals>;
  /** fetch data from the table: "mobile_payment_terminals" */
  mobile_payment_terminals_connection: Mobile_Payment_TerminalsConnection;
  node?: Maybe<Node>;
  /** fetch data from the table: "order_guide" */
  order_guide: Array<Order_Guide>;
  /** fetch data from the table: "order_guide" using primary key columns */
  order_guide_by_pk?: Maybe<Order_Guide>;
  /** fetch data from the table: "order_guide" */
  order_guide_connection: Order_GuideConnection;
  /** fetch data from the table: "order_guide_restaurant_collection" */
  order_guide_restaurant_collection: Array<Order_Guide_Restaurant_Collection>;
  /** fetch data from the table: "order_guide_restaurant_collection" using primary key columns */
  order_guide_restaurant_collection_by_pk?: Maybe<Order_Guide_Restaurant_Collection>;
  /** fetch data from the table: "order_guide_restaurant_collection" */
  order_guide_restaurant_collection_connection: Order_Guide_Restaurant_CollectionConnection;
  /** fetch data from the table: "order_guide_supplier_collection" */
  order_guide_supplier_collection: Array<Order_Guide_Supplier_Collection>;
  /** fetch data from the table: "order_guide_supplier_collection" using primary key columns */
  order_guide_supplier_collection_by_pk?: Maybe<Order_Guide_Supplier_Collection>;
  /** fetch data from the table: "order_guide_supplier_collection" */
  order_guide_supplier_collection_connection: Order_Guide_Supplier_CollectionConnection;
  /** An array relationship */
  order_invoice_check_in_item_issues: Array<Order_Invoice_Check_In_Item_Issues>;
  /** fetch data from the table: "order_invoice_check_in_item_issues" using primary key columns */
  order_invoice_check_in_item_issues_by_pk?: Maybe<Order_Invoice_Check_In_Item_Issues>;
  /** An array relationship connection */
  order_invoice_check_in_item_issues_connection: Order_Invoice_Check_In_Item_IssuesConnection;
  /** An array relationship */
  order_invoice_check_in_items: Array<Order_Invoice_Check_In_Items>;
  /** fetch data from the table: "order_invoice_check_in_items" using primary key columns */
  order_invoice_check_in_items_by_pk?: Maybe<Order_Invoice_Check_In_Items>;
  /** An array relationship connection */
  order_invoice_check_in_items_connection: Order_Invoice_Check_In_ItemsConnection;
  /** fetch data from the table: "order_invoice_check_ins" */
  order_invoice_check_ins: Array<Order_Invoice_Check_Ins>;
  /** fetch data from the table: "order_invoice_check_ins" using primary key columns */
  order_invoice_check_ins_by_pk?: Maybe<Order_Invoice_Check_Ins>;
  /** fetch data from the table: "order_invoice_check_ins" */
  order_invoice_check_ins_connection: Order_Invoice_Check_InsConnection;
  /** An array relationship */
  order_invoices: Array<Order_Invoices>;
  /** An aggregate relationship */
  order_invoices_aggregate: Order_Invoices_Aggregate;
  /** fetch data from the table: "order_invoices" using primary key columns */
  order_invoices_by_pk?: Maybe<Order_Invoices>;
  /** An array relationship connection */
  order_invoices_connection: Order_InvoicesConnection;
  /** An array relationship */
  orders: Array<Orders>;
  /** An aggregate relationship */
  orders_aggregate: Orders_Aggregate;
  /** fetch data from the table: "orders" using primary key columns */
  orders_by_pk?: Maybe<Orders>;
  /** An array relationship connection */
  orders_connection: OrdersConnection;
  /** An array relationship */
  orders_items: Array<Orders_Items>;
  /** An aggregate relationship */
  orders_items_aggregate: Orders_Items_Aggregate;
  /** fetch data from the table: "orders_items" using primary key columns */
  orders_items_by_pk?: Maybe<Orders_Items>;
  /** An array relationship connection */
  orders_items_connection: Orders_ItemsConnection;
  /** fetch data from the table: "pad_payment_method" */
  pad_payment_method: Array<Pad_Payment_Method>;
  /** fetch data from the table: "pad_payment_method" using primary key columns */
  pad_payment_method_by_pk?: Maybe<Pad_Payment_Method>;
  /** fetch data from the table: "pad_payment_method" */
  pad_payment_method_connection: Pad_Payment_MethodConnection;
  /** fetch data from the table: "payment_batches" */
  payment_batches: Array<Payment_Batches>;
  /** fetch aggregated fields from the table: "payment_batches" */
  payment_batches_aggregate: Payment_Batches_Aggregate;
  /** fetch data from the table: "payment_batches" using primary key columns */
  payment_batches_by_pk?: Maybe<Payment_Batches>;
  /** fetch data from the table: "payment_batches" */
  payment_batches_connection: Payment_BatchesConnection;
  /** fetch data from the table: "payment_links" */
  payment_links: Array<Payment_Links>;
  /** fetch data from the table: "payment_links" */
  payment_links_connection: Payment_LinksConnection;
  /** fetch data from the table: "payment_methods" */
  payment_methods: Array<Payment_Methods>;
  /** fetch data from the table: "payment_methods" using primary key columns */
  payment_methods_by_pk?: Maybe<Payment_Methods>;
  /** fetch data from the table: "payment_methods" */
  payment_methods_connection: Payment_MethodsConnection;
  plaidGetSessionInfo: PlaidGetSessionInfoResponse;
  /** fetch data from the table: "planograms" */
  planograms: Array<Planograms>;
  /** fetch data from the table: "planograms" using primary key columns */
  planograms_by_pk?: Maybe<Planograms>;
  /** fetch data from the table: "planograms" */
  planograms_connection: PlanogramsConnection;
  /** fetch data from the table: "pricing_price_draft_update_batches" */
  pricing_price_draft_update_batches: Array<Pricing_Price_Draft_Update_Batches>;
  /** fetch data from the table: "pricing_price_draft_update_batches" using primary key columns */
  pricing_price_draft_update_batches_by_pk?: Maybe<Pricing_Price_Draft_Update_Batches>;
  /** fetch data from the table: "pricing_price_draft_update_batches" */
  pricing_price_draft_update_batches_connection: Pricing_Price_Draft_Update_BatchesConnection;
  /** fetch data from the table: "pricing_task_runs" */
  pricing_task_runs: Array<Pricing_Task_Runs>;
  /** fetch aggregated fields from the table: "pricing_task_runs" */
  pricing_task_runs_aggregate: Pricing_Task_Runs_Aggregate;
  /** fetch data from the table: "pricing_task_runs" using primary key columns */
  pricing_task_runs_by_pk?: Maybe<Pricing_Task_Runs>;
  /** fetch data from the table: "pricing_task_runs" */
  pricing_task_runs_connection: Pricing_Task_RunsConnection;
  /** fetch data from the table: "print_tag_batches" */
  print_tag_batches: Array<Print_Tag_Batches>;
  /** fetch data from the table: "print_tag_batches" using primary key columns */
  print_tag_batches_by_pk?: Maybe<Print_Tag_Batches>;
  /** fetch data from the table: "print_tag_batches" */
  print_tag_batches_connection: Print_Tag_BatchesConnection;
  /** fetch data from the table: "print_tag_template_assignments" */
  print_tag_template_assignments: Array<Print_Tag_Template_Assignments>;
  /** fetch data from the table: "print_tag_template_assignments" using primary key columns */
  print_tag_template_assignments_by_pk?: Maybe<Print_Tag_Template_Assignments>;
  /** fetch data from the table: "print_tag_template_assignments" */
  print_tag_template_assignments_connection: Print_Tag_Template_AssignmentsConnection;
  /** fetch data from the table: "print_tag_templates" */
  print_tag_templates: Array<Print_Tag_Templates>;
  /** fetch data from the table: "print_tag_templates" using primary key columns */
  print_tag_templates_by_pk?: Maybe<Print_Tag_Templates>;
  /** fetch data from the table: "print_tag_templates" */
  print_tag_templates_connection: Print_Tag_TemplatesConnection;
  /** fetch data from the table: "promotion_component_groups" */
  promotion_component_groups: Array<Promotion_Component_Groups>;
  /** fetch data from the table: "promotion_component_groups" */
  promotion_component_groups_connection: Promotion_Component_GroupsConnection;
  renderPrintCreditRequestTemplate: RenderedTemplateResponse;
  renderPrintOrderTemplate: RenderedTemplateResponse;
  renderPrintTagBatchTemplatesForRestaurant: Array<RenderPrintTagTemplateForRestaurantResponse>;
  renderPrintTagTemplateForRestaurant: Array<RenderPrintTagTemplateForRestaurantResponse>;
  /** fetch data from the table: "restaurant_groups" */
  restaurant_groups: Array<Restaurant_Groups>;
  /** fetch data from the table: "restaurant_groups" using primary key columns */
  restaurant_groups_by_pk?: Maybe<Restaurant_Groups>;
  /** fetch data from the table: "restaurant_groups" */
  restaurant_groups_connection: Restaurant_GroupsConnection;
  /** fetch data from the table: "sales_rep_chat_relations" */
  sales_rep_chat_relations: Array<Sales_Rep_Chat_Relations>;
  /** fetch data from the table: "sales_rep_chat_relations" using primary key columns */
  sales_rep_chat_relations_by_pk?: Maybe<Sales_Rep_Chat_Relations>;
  /** fetch data from the table: "sales_rep_chat_relations" */
  sales_rep_chat_relations_connection: Sales_Rep_Chat_RelationsConnection;
  /** Retrieve SALT documents from source, override, or split collections. */
  saltDocs: Array<SaltSourceDocumentTypeSaltOverrideDocumentTypeSplitDocumentType>;
  /** This query exists only for interception. */
  saltItem: ItemInfoWithVpUuidType;
  saltItems: ItemInfoWithVpUuidListType;
  searchCatalogForOrderEntryItems: OrderEntryTablePage;
  searchCatalogForOrderGuideItems: Array<SalesPortalOrderGuideItem>;
  searchManualMenuItemIngredients: Array<MenuItemIngredientOutput>;
  searchOrderHistory: SearchOrderHistoryResponse;
  searchPriceQuoteItems: SearchPriceQuoteItemsResponse;
  searchPublicVariantPacks: Array<VariantPackWithFiltersResponse>;
  searchRecentlyOrderedVariantPacksByUpc: Array<SearchVariantPacksResponse>;
  searchVariantPacks: Array<VariantPackWithAvailabilityResponse>;
  searchVariantPacksByUpc: Array<SearchVariantPacksResponse>;
  searchVariantPacksForBusinessOrganization: Array<SearchVariantPacksForBusinessOrganizationResponse>;
  searchVariantPacksForCreditRequest: Array<SearchVariantPacksForCreditRequestResponse>;
  /** fetch data from the table: "smart_order" */
  smart_order: Array<Smart_Order>;
  /** fetch aggregated fields from the table: "smart_order" */
  smart_order_aggregate: Smart_Order_Aggregate;
  /** fetch data from the table: "smart_order" using primary key columns */
  smart_order_by_pk?: Maybe<Smart_Order>;
  /** fetch data from the table: "smart_order" */
  smart_order_connection: Smart_OrderConnection;
  /** fetch data from the table: "smart_order_message_rel" */
  smart_order_message_rel: Array<Smart_Order_Message_Rel>;
  /** fetch aggregated fields from the table: "smart_order_message_rel" */
  smart_order_message_rel_aggregate: Smart_Order_Message_Rel_Aggregate;
  /** fetch data from the table: "smart_order_message_rel" using primary key columns */
  smart_order_message_rel_by_pk?: Maybe<Smart_Order_Message_Rel>;
  /** fetch data from the table: "smart_order_message_rel" */
  smart_order_message_rel_connection: Smart_Order_Message_RelConnection;
  /** fetch data from the table: "smart_order_search_term_corrections" */
  smart_order_search_term_corrections: Array<Smart_Order_Search_Term_Corrections>;
  /** fetch data from the table: "smart_order_search_term_corrections" using primary key columns */
  smart_order_search_term_corrections_by_pk?: Maybe<Smart_Order_Search_Term_Corrections>;
  /** fetch data from the table: "smart_order_search_term_corrections" */
  smart_order_search_term_corrections_connection: Smart_Order_Search_Term_CorrectionsConnection;
  /** fetch data from the table: "supplier_payments_status" */
  supplier_payments_status: Array<Supplier_Payments_Status>;
  /** fetch data from the table: "task_frequency_settings" */
  task_frequency_settings: Array<Task_Frequency_Settings>;
  /** fetch data from the table: "task_frequency_settings" */
  task_frequency_settings_connection: Task_Frequency_SettingsConnection;
  /** UpdatedSaltItem query will be a stub for now. */
  updatedSaltItem: ItemInfoWithVpUuidType;
  validateCreditRequest: ValidateCreditRequestBatchResponse;
  /** fetch data from the table: "variant_pack_groups" */
  variant_pack_groups: Array<Variant_Pack_Groups>;
  /** fetch data from the table: "variant_pack_groups" using primary key columns */
  variant_pack_groups_by_pk?: Maybe<Variant_Pack_Groups>;
  /** fetch data from the table: "variant_pack_groups" */
  variant_pack_groups_connection: Variant_Pack_GroupsConnection;
  /** fetch data from the table: "variants_packs" */
  variants_packs: Array<Variants_Packs>;
  /** fetch aggregated fields from the table: "variants_packs" */
  variants_packs_aggregate: Variants_Packs_Aggregate;
  /** fetch data from the table: "variants_packs" using primary key columns */
  variants_packs_by_pk?: Maybe<Variants_Packs>;
  /** fetch data from the table: "variants_packs" */
  variants_packs_connection: Variants_PacksConnection;
  /** fetch data from the table: "variants_packs_substitution_suppliers" */
  variants_packs_substitution_suppliers: Array<Variants_Packs_Substitution_Suppliers>;
  /** fetch data from the table: "variants_packs_substitution_suppliers" using primary key columns */
  variants_packs_substitution_suppliers_by_pk?: Maybe<Variants_Packs_Substitution_Suppliers>;
  /** fetch data from the table: "variants_packs_substitution_suppliers" */
  variants_packs_substitution_suppliers_connection: Variants_Packs_Substitution_SuppliersConnection;
  /** fetch data from the table: "visible_variant_packs" */
  visible_variant_packs: Array<Visible_Variant_Packs>;
  /** fetch aggregated fields from the table: "visible_variant_packs" */
  visible_variant_packs_aggregate: Visible_Variant_Packs_Aggregate;
  /** An array relationship */
  whitelabel_config: Array<Whitelabel_Config>;
  /** fetch data from the table: "whitelabel_config" using primary key columns */
  whitelabel_config_by_pk?: Maybe<Whitelabel_Config>;
  /** An array relationship connection */
  whitelabel_config_connection: Whitelabel_ConfigConnection;
};


export type Query_RootAnalytics_AlertsArgs = {
  distinct_on?: InputMaybe<Array<Analytics_Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Analytics_Alerts_Order_By>>;
  where?: InputMaybe<Analytics_Alerts_Bool_Exp>;
};


export type Query_RootAnalytics_Alerts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Analytics_Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Analytics_Alerts_Order_By>>;
  where?: InputMaybe<Analytics_Alerts_Bool_Exp>;
};


export type Query_RootAnalytics_Alerts_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootAnalytics_Alerts_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Analytics_Alerts_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Analytics_Alerts_Order_By>>;
  where?: InputMaybe<Analytics_Alerts_Bool_Exp>;
};


export type Query_RootApplication_Decision_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Application_Decision_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Decision_Notifications_Order_By>>;
  where?: InputMaybe<Application_Decision_Notifications_Bool_Exp>;
};


export type Query_RootApplication_Decision_Notifications_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootApplication_Decision_Notifications_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Application_Decision_Notifications_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Decision_Notifications_Order_By>>;
  where?: InputMaybe<Application_Decision_Notifications_Bool_Exp>;
};


export type Query_RootAuto_Pay_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Auto_Pay_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auto_Pay_Settings_Order_By>>;
  where?: InputMaybe<Auto_Pay_Settings_Bool_Exp>;
};


export type Query_RootAuto_Pay_Settings_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootAuto_Pay_Settings_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Auto_Pay_Settings_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auto_Pay_Settings_Order_By>>;
  where?: InputMaybe<Auto_Pay_Settings_Bool_Exp>;
};


export type Query_RootBrand_Page_Variant_PacksArgs = {
  distinct_on?: InputMaybe<Array<Brand_Page_Variant_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Page_Variant_Packs_Order_By>>;
  where?: InputMaybe<Brand_Page_Variant_Packs_Bool_Exp>;
};


export type Query_RootBrand_PagesArgs = {
  distinct_on?: InputMaybe<Array<Brand_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Pages_Order_By>>;
  where?: InputMaybe<Brand_Pages_Bool_Exp>;
};


export type Query_RootBrand_Pages_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootBrand_Pages_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Brand_Pages_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Pages_Order_By>>;
  where?: InputMaybe<Brand_Pages_Bool_Exp>;
};


export type Query_RootBusiness_OrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Business_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Business_Organizations_Order_By>>;
  where?: InputMaybe<Business_Organizations_Bool_Exp>;
};


export type Query_RootBusiness_Organizations_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootBusiness_Organizations_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Business_Organizations_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Business_Organizations_Order_By>>;
  where?: InputMaybe<Business_Organizations_Bool_Exp>;
};


export type Query_RootBusinessesArgs = {
  distinct_on?: InputMaybe<Array<Businesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Businesses_Order_By>>;
  where?: InputMaybe<Businesses_Bool_Exp>;
};


export type Query_RootBusinesses_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootBusinesses_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Businesses_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Businesses_Order_By>>;
  where?: InputMaybe<Businesses_Bool_Exp>;
};


export type Query_RootChangedVariantPacksArgs = {
  after?: InputMaybe<ChangedVariantPacksCursorInput>;
  limit?: Scalars['Int']['input'];
};


export type Query_RootChat_Last_MessageArgs = {
  distinct_on?: InputMaybe<Array<Chat_Last_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Last_Message_Order_By>>;
  where?: InputMaybe<Chat_Last_Message_Bool_Exp>;
};


export type Query_RootChat_Unread_Message_CountArgs = {
  distinct_on?: InputMaybe<Array<Chat_Unread_Message_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Unread_Message_Count_Order_By>>;
  where?: InputMaybe<Chat_Unread_Message_Count_Bool_Exp>;
};


export type Query_RootChatsArgs = {
  distinct_on?: InputMaybe<Array<Chats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Order_By>>;
  where?: InputMaybe<Chats_Bool_Exp>;
};


export type Query_RootChats_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootChats_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Chats_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Order_By>>;
  where?: InputMaybe<Chats_Bool_Exp>;
};


export type Query_RootChats_Route_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Chats_Route_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Route_Metadata_Order_By>>;
  where?: InputMaybe<Chats_Route_Metadata_Bool_Exp>;
};


export type Query_RootChats_Route_Metadata_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Chats_Route_Metadata_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Route_Metadata_Order_By>>;
  where?: InputMaybe<Chats_Route_Metadata_Bool_Exp>;
};


export type Query_RootCredit_Application_Consent_AcceptancesArgs = {
  distinct_on?: InputMaybe<Array<Credit_Application_Consent_Acceptances_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Consent_Acceptances_Order_By>>;
  where?: InputMaybe<Credit_Application_Consent_Acceptances_Bool_Exp>;
};


export type Query_RootCredit_Application_Consent_Acceptances_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootCredit_Application_Consent_Acceptances_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Application_Consent_Acceptances_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Consent_Acceptances_Order_By>>;
  where?: InputMaybe<Credit_Application_Consent_Acceptances_Bool_Exp>;
};


export type Query_RootCredit_Application_Form_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Application_Form_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Form_Fields_Order_By>>;
  where?: InputMaybe<Credit_Application_Form_Fields_Bool_Exp>;
};


export type Query_RootCredit_Application_Form_Fields_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootCredit_Application_Form_Fields_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Application_Form_Fields_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Form_Fields_Order_By>>;
  where?: InputMaybe<Credit_Application_Form_Fields_Bool_Exp>;
};


export type Query_RootCredit_Application_Form_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Application_Form_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Form_Sections_Order_By>>;
  where?: InputMaybe<Credit_Application_Form_Sections_Bool_Exp>;
};


export type Query_RootCredit_Application_Form_Sections_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootCredit_Application_Form_Sections_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Application_Form_Sections_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Form_Sections_Order_By>>;
  where?: InputMaybe<Credit_Application_Form_Sections_Bool_Exp>;
};


export type Query_RootCredit_Application_Form_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Application_Form_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Form_Versions_Order_By>>;
  where?: InputMaybe<Credit_Application_Form_Versions_Bool_Exp>;
};


export type Query_RootCredit_Application_Form_Versions_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootCredit_Application_Form_Versions_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Application_Form_Versions_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Form_Versions_Order_By>>;
  where?: InputMaybe<Credit_Application_Form_Versions_Bool_Exp>;
};


export type Query_RootCredit_Application_FormsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Application_Forms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Forms_Order_By>>;
  where?: InputMaybe<Credit_Application_Forms_Bool_Exp>;
};


export type Query_RootCredit_Application_Forms_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootCredit_Application_Forms_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Application_Forms_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Forms_Order_By>>;
  where?: InputMaybe<Credit_Application_Forms_Bool_Exp>;
};


export type Query_RootCredit_ApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Applications_Order_By>>;
  where?: InputMaybe<Credit_Applications_Bool_Exp>;
};


export type Query_RootCredit_Applications_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootCredit_Applications_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Applications_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Applications_Order_By>>;
  where?: InputMaybe<Credit_Applications_Bool_Exp>;
};


export type Query_RootCredit_Form_Version_Form_Section_RelArgs = {
  distinct_on?: InputMaybe<Array<Credit_Form_Version_Form_Section_Rel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Form_Version_Form_Section_Rel_Order_By>>;
  where?: InputMaybe<Credit_Form_Version_Form_Section_Rel_Bool_Exp>;
};


export type Query_RootCredit_Form_Version_Form_Section_Rel_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootCredit_Form_Version_Form_Section_Rel_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Form_Version_Form_Section_Rel_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Form_Version_Form_Section_Rel_Order_By>>;
  where?: InputMaybe<Credit_Form_Version_Form_Section_Rel_Bool_Exp>;
};


export type Query_RootCredit_MemosArgs = {
  distinct_on?: InputMaybe<Array<Credit_Memos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Memos_Order_By>>;
  where?: InputMaybe<Credit_Memos_Bool_Exp>;
};


export type Query_RootCredit_Memos_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootCredit_Memos_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Memos_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Memos_Order_By>>;
  where?: InputMaybe<Credit_Memos_Bool_Exp>;
};


export type Query_RootCredit_Request_Batch_Line_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Request_Batch_Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Batch_Line_Items_Order_By>>;
  where?: InputMaybe<Credit_Request_Batch_Line_Items_Bool_Exp>;
};


export type Query_RootCredit_Request_Batch_Line_Items_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootCredit_Request_Batch_Line_Items_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Request_Batch_Line_Items_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Batch_Line_Items_Order_By>>;
  where?: InputMaybe<Credit_Request_Batch_Line_Items_Bool_Exp>;
};


export type Query_RootCredit_Request_BatchesArgs = {
  distinct_on?: InputMaybe<Array<Credit_Request_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Batches_Order_By>>;
  where?: InputMaybe<Credit_Request_Batches_Bool_Exp>;
};


export type Query_RootCredit_Request_Batches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Request_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Batches_Order_By>>;
  where?: InputMaybe<Credit_Request_Batches_Bool_Exp>;
};


export type Query_RootCredit_Request_Batches_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootCredit_Request_Batches_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Request_Batches_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Batches_Order_By>>;
  where?: InputMaybe<Credit_Request_Batches_Bool_Exp>;
};


export type Query_RootCredit_Request_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Request_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Reasons_Order_By>>;
  where?: InputMaybe<Credit_Request_Reasons_Bool_Exp>;
};


export type Query_RootCredit_Request_Reasons_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootCredit_Request_Reasons_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Request_Reasons_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Reasons_Order_By>>;
  where?: InputMaybe<Credit_Request_Reasons_Bool_Exp>;
};


export type Query_RootCrm_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Crm_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Activities_Order_By>>;
  where?: InputMaybe<Crm_Activities_Bool_Exp>;
};


export type Query_RootCrm_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Activities_Order_By>>;
  where?: InputMaybe<Crm_Activities_Bool_Exp>;
};


export type Query_RootCrm_Activities_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootCrm_Activities_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Crm_Activities_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Activities_Order_By>>;
  where?: InputMaybe<Crm_Activities_Bool_Exp>;
};


export type Query_RootCrm_Activity_NotesArgs = {
  distinct_on?: InputMaybe<Array<Crm_Activity_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Activity_Notes_Order_By>>;
  where?: InputMaybe<Crm_Activity_Notes_Bool_Exp>;
};


export type Query_RootCrm_Activity_Notes_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootCrm_Activity_Notes_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Crm_Activity_Notes_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Activity_Notes_Order_By>>;
  where?: InputMaybe<Crm_Activity_Notes_Bool_Exp>;
};


export type Query_RootEmployee_ChatsArgs = {
  distinct_on?: InputMaybe<Array<Employee_Chats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Employee_Chats_Order_By>>;
  where?: InputMaybe<Employee_Chats_Bool_Exp>;
};


export type Query_RootEmployee_Smart_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Employee_Smart_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Employee_Smart_Orders_Order_By>>;
  where?: InputMaybe<Employee_Smart_Orders_Bool_Exp>;
};


export type Query_RootEmployeesArgs = {
  distinct_on?: InputMaybe<Array<Employees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Employees_Order_By>>;
  where?: InputMaybe<Employees_Bool_Exp>;
};


export type Query_RootEmployees_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootEmployees_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Employees_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Employees_Order_By>>;
  where?: InputMaybe<Employees_Bool_Exp>;
};


export type Query_RootGetAdyenDropinConfigArgs = {
  payee_id?: InputMaybe<Scalars['uuid']['input']>;
  payor_id?: InputMaybe<Scalars['uuid']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
};


export type Query_RootGetAllHubAlertsArgs = {
  business_organization_id?: InputMaybe<Scalars['uuid']['input']>;
  filters?: InputMaybe<HubCardFilters>;
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
  user_timezone?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetAnalyticsAlertsArgs = {
  alert_statuses?: InputMaybe<Array<AnalyticsAlertStatusType>>;
  alert_types?: InputMaybe<Array<AnalyticsAlertType>>;
  chat_id?: InputMaybe<Scalars['uuid']['input']>;
  restaurant_id?: InputMaybe<Scalars['uuid']['input']>;
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
};


export type Query_RootGetAutoPayCustomersArgs = {
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetAutoPayRunPreviewArgs = {
  aps_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetAutoPaySettingCustomersArgs = {
  auto_pay_setting_id: Scalars['uuid']['input'];
};


export type Query_RootGetAutoPaySettingsArgs = {
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetAutoPaySettingsV2Args = {
  business_organization_id: Scalars['uuid']['input'];
};


export type Query_RootGetAutopayStatusArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetAvailableCreditMemosByCustomerArgs = {
  credit_date_filter?: InputMaybe<DateFilterInput>;
  restaurant_id?: InputMaybe<Scalars['uuid']['input']>;
  search_input?: InputMaybe<Scalars['String']['input']>;
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
  usable_after?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetAvailableOrderFulfillmentsArgs = {
  end_date?: InputMaybe<Scalars['String']['input']>;
  fulfillment_name?: InputMaybe<FulfillmentName>;
  restaurant_id: Scalars['uuid']['input'];
  start_date?: InputMaybe<Scalars['String']['input']>;
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetBrandPageDetailsArgs = {
  fulfillment_date?: InputMaybe<Scalars['String']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};


export type Query_RootGetBrandPageVariantPacksArgs = {
  brand_page_id: Scalars['uuid']['input'];
  fulfillment_date?: InputMaybe<Scalars['String']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetBrandsCarouselArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetBusinessDetailsArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
};


export type Query_RootGetCardDetailsArgs = {
  encrypted_card_number: Scalars['String']['input'];
};


export type Query_RootGetChatbotMessagesArgs = {
  restaurant_id: Scalars['uuid']['input'];
  session_id: Scalars['String']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetCollectedManualPaymentsArgs = {
  employee_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetCreditMemoByIdArgs = {
  credit_memo_id: Scalars['uuid']['input'];
};


export type Query_RootGetCreditRequestVariantPackEligibilityArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetCriticalItemsArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetCrmActivitiesArgs = {
  cursor?: InputMaybe<Scalars['uuid']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetCustomerDetailDataArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
};


export type Query_RootGetCustomerListDataArgs = {
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetDisplayAdVariantPacksEventsArgs = {
  fulfillment_date?: InputMaybe<Scalars['String']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetExternalContentForRestaurantArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetExternalContentUrlForRestaurantArgs = {
  external_content_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetFinanceHubCustomerListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type Query_RootGetGtinFiltersForCategoryArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetGtinFiltersForGroupArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_group_id?: InputMaybe<Scalars['uuid']['input']>;
};


export type Query_RootGetGuestModeContentArgs = {
  business_organization_id: Scalars['uuid']['input'];
};


export type Query_RootGetHubCardDataArgs = {
  analytics_type: HubCardType;
  business_organization_id: Scalars['uuid']['input'];
  localization_context?: InputMaybe<LocalizationContext>;
  user_id: Scalars['uuid']['input'];
  user_timezone?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetHubCurrentOrdersArgs = {
  business_organization_id: Scalars['uuid']['input'];
  localization_context?: InputMaybe<LocalizationContext>;
  user_timezone?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetHubPastOrdersArgs = {
  business_organization_id: Scalars['uuid']['input'];
  localization_context?: InputMaybe<LocalizationContext>;
  lookback_days?: InputMaybe<Scalars['Int']['input']>;
  start_date: Scalars['String']['input'];
  user_timezone?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetInvoiceGrossProfitArgs = {
  order_invoice_id: Scalars['uuid']['input'];
};


export type Query_RootGetItemRecommendationsArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetItemSubstitutionsArgs = {
  fulfillment_date: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};


export type Query_RootGetItemsFromMenuImagesArgs = {
  image_urls: Array<Scalars['String']['input']>;
};


export type Query_RootGetLeadTimeFulfillmentArgs = {
  desired_fulfillment_date?: InputMaybe<Scalars['String']['input']>;
  fulfillment_settings_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetManualDepositsArgs = {
  employee_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetNearbyBusinessesV2Args = {
  categories?: InputMaybe<Scalars['String']['input']>;
  is_current_restaurant?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['String']['input']>;
  sort_by?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetNextAutopayInfoArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetNextDeliveryDateForSubscriptionSettingsArgs = {
  frequency_days: Scalars['Int']['input'];
  fulfillment_settings_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  restaurant_variant_pack_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  supplier_id: Scalars['uuid']['input'];
  weekday: DaysOfWeek;
};


export type Query_RootGetObiItemsArgs = {
  filter_from: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetOrderArgs = {
  order_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetOrderConstraintsForRestaurantArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetOrderEntryItemDetailArgs = {
  delivery_date: Scalars['String']['input'];
  purchase_history_limit?: InputMaybe<Scalars['Int']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};


export type Query_RootGetOrderEntryItemsFromCartArgs = {
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetOrderEntryItemsFromOrderGuideArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order_guide_collection_id?: InputMaybe<Scalars['uuid']['input']>;
  order_guide_item_filter?: InputMaybe<OrderEntryOrderGuideItemFilter>;
  order_guide_partition_id?: InputMaybe<Scalars['uuid']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetOrderEntryItemsFromVariantPackIdsArgs = {
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_ids: Array<Scalars['uuid']['input']>;
};


export type Query_RootGetOrderEntrySummaryArgs = {
  order_ids: Array<Scalars['uuid']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetOrderEstimatedCommissionArgs = {
  business_organization_id: Scalars['uuid']['input'];
  employee_id: Scalars['uuid']['input'];
  order_ids: Array<Scalars['uuid']['input']>;
};


export type Query_RootGetOrderFeesArgs = {
  order_ids: Array<Scalars['uuid']['input']>;
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetOrderFulfillmentFeesArgs = {
  order_id: Scalars['uuid']['input'];
};


export type Query_RootGetOrderGrossProfitArgs = {
  order_id: Scalars['uuid']['input'];
};


export type Query_RootGetOrderGuideCollectionsForOrderEntryArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetOrderGuideItemsArgs = {
  collection_id?: InputMaybe<Scalars['uuid']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetOrderGuidePriceQuoteKeyArgs = {
  employee_id: Scalars['uuid']['input'];
  order_guide_collection_id: Scalars['uuid']['input'];
};


export type Query_RootGetOrderInvoiceByIdArgs = {
  order_invoice_id: Scalars['uuid']['input'];
};


export type Query_RootGetOrderInvoiceByOrderArgs = {
  order_id: Scalars['uuid']['input'];
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
};


export type Query_RootGetOrderPdfArgs = {
  order_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  show_item_descriptions?: InputMaybe<Scalars['Boolean']['input']>;
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetOrdersArgs = {
  filters?: InputMaybe<GetOrdersFiltersInput>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetPadConsentFormsArgs = {
  account_type: Scalars['String']['input'];
  consent_city: Scalars['String']['input'];
  consent_email: Scalars['String']['input'];
  consent_employee_name: Scalars['String']['input'];
  consent_phone_number: Scalars['String']['input'];
  consent_postal_code: Scalars['String']['input'];
  consent_province: Scalars['String']['input'];
  consent_street_address: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetPadConsentFormsForPaymentMethodArgs = {
  payment_method_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetParSheetPdfArgs = {
  collection_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  sort_order?: InputMaybe<OrderGuideSortOrder>;
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetPaymentLinkLineItemsArgs = {
  payment_link_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetPaymentLinksArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetPaymentPlanNextRunDateArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetPaymentPlansArgs = {
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetPendingOrderPriceEditApprovalRequestArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetPeriodSalesAnalyticsArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetPriceEditDisplayInfoArgs = {
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  order_guide_only?: InputMaybe<Scalars['Boolean']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_ids?: InputMaybe<Array<Scalars['uuid']['input']>>;
};


export type Query_RootGetPriceQuoteArgs = {
  price_quote_id: Scalars['uuid']['input'];
};


export type Query_RootGetPriceQuoteDetailsArgs = {
  file_format?: InputMaybe<PriceQuoteFormat>;
  price_quote_key: Scalars['String']['input'];
};


export type Query_RootGetPriceQuotesArgs = {
  business_organization_id: Scalars['uuid']['input'];
};


export type Query_RootGetPriceTrendsDataArgs = {
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};


export type Query_RootGetPriceTrendsDataWithCustomerGroupsArgs = {
  restaurant_group_ids: Array<Scalars['uuid']['input']>;
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};


export type Query_RootGetPricingRecommendationsArgs = {
  supplier_id: Scalars['uuid']['input'];
  task_run_id: Scalars['uuid']['input'];
};


export type Query_RootGetPricingRecommendationsForBusinessOrganizationArgs = {
  task_type_id?: InputMaybe<Scalars['uuid']['input']>;
};


export type Query_RootGetPrintTagTemplatesForRestaurantArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_ids: Array<Scalars['uuid']['input']>;
};


export type Query_RootGetPromotionsForRestaurantArgs = {
  include_volume_promotions?: InputMaybe<Scalars['Boolean']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetProspectFinderCategoryOptionsArgs = {
  business_organization_id: Scalars['uuid']['input'];
};


export type Query_RootGetResolvedLeadTimeFulfillmentArgs = {
  desired_fulfillment_date?: InputMaybe<Scalars['String']['input']>;
  fulfillment_settings_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetRestaurantEmployeesArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetRestaurantPlanogramsArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetRestaurantVariantPackSubscriptionsArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetSalesAnalyticsAlertsArgs = {
  chat_id: Scalars['uuid']['input'];
};


export type Query_RootGetSalesAnalyticsDataArgs = {
  chat_id: Scalars['uuid']['input'];
  end_time: Scalars['String']['input'];
  start_time: Scalars['String']['input'];
};


export type Query_RootGetSalesPortalAccountListFilterCountsArgs = {
  business_organization_id: Scalars['uuid']['input'];
  filters?: InputMaybe<SalesPortalAccountListFilters>;
};


export type Query_RootGetSalesPortalAccountListInfoArgs = {
  business_organization_id: Scalars['uuid']['input'];
  user_timezone?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetSalesPortalAccountListInfoPaginatedArgs = {
  business_organization_id: Scalars['uuid']['input'];
  cursor?: InputMaybe<Scalars['uuid']['input']>;
  filters?: InputMaybe<SalesPortalAccountListFilters>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  user_timezone?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetSalesPortalAccountListMetricsArgs = {
  business_organization_id: Scalars['uuid']['input'];
};


export type Query_RootGetSalesPortalAccountsArgs = {
  business_organization_id: Scalars['uuid']['input'];
};


export type Query_RootGetSalesPortalAccountsPaginatedArgs = {
  business_organization_id: Scalars['uuid']['input'];
  cursor?: InputMaybe<Scalars['uuid']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  search_term?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetSalesPortalManagerPipelineSummaryArgs = {
  business_organization_id: Scalars['uuid']['input'];
  employee_ids: Array<Scalars['uuid']['input']>;
};


export type Query_RootGetSalesPortalManagerProspectForecastArgs = {
  business_organization_id: Scalars['uuid']['input'];
  employee_ids: Array<Scalars['uuid']['input']>;
  stages: Array<ChatProspectStage>;
  user_timezone: Scalars['String']['input'];
};


export type Query_RootGetSalesPortalManagerProspectListArgs = {
  business_organization_id: Scalars['uuid']['input'];
  employee_ids: Array<Scalars['uuid']['input']>;
  stages: Array<ChatProspectStage>;
  user_timezone: Scalars['String']['input'];
};


export type Query_RootGetSalesPortalManagerRepSummariesArgs = {
  business_organization_id: Scalars['uuid']['input'];
  user_timezone: Scalars['String']['input'];
};


export type Query_RootGetSalesPortalOrderGuideCollectionsArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetSalesPortalOrderGuideCollectionsForOrderEntryArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetSalesPortalOrderGuideItemsArgs = {
  collection_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetSalesPortalProspectDetailsArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetSalesPortalProspectListInfoArgs = {
  business_organization_id: Scalars['uuid']['input'];
  user_timezone?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetSalesPortalTabsArgs = {
  business_organization_id: Scalars['uuid']['input'];
};


export type Query_RootGetSampleRequestVariantPacksArgs = {
  fulfillment_date?: InputMaybe<Scalars['String']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetSearchFiltersArgs = {
  restaurant_id?: InputMaybe<Scalars['uuid']['input']>;
  supplier_id: Scalars['uuid']['input'];
  variant_pack_group_id?: InputMaybe<Scalars['uuid']['input']>;
};


export type Query_RootGetSmartOrderAssignableEmployeesArgs = {
  smart_order_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetSmartOrderDetailsArgs = {
  merge_uuid?: InputMaybe<Scalars['uuid']['input']>;
  smart_order_id: Scalars['uuid']['input'];
  thread_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type Query_RootGetSmartOrderInboundAssigneesArgs = {
  business_organization_id: Scalars['uuid']['input'];
};


export type Query_RootGetSmartOrderInboundHistoryArgs = {
  assigned_employee_ids?: InputMaybe<Array<Scalars['uuid']['input']>>;
  business_organization_id: Scalars['uuid']['input'];
  include_unassigned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SmartOrderInboundHistoryOrderBy>;
  search_term?: InputMaybe<Scalars['String']['input']>;
  statuses: Array<SmartOrderStatus>;
};


export type Query_RootGetSmartOrderResultsArgs = {
  is_restricted_search?: InputMaybe<Scalars['Boolean']['input']>;
  requested_items: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetSupplierCatalogVariantPackGroupsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  restaurant_id?: InputMaybe<Scalars['uuid']['input']>;
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetSupplierCategoryItemsArgs = {
  category_item_limit?: InputMaybe<Scalars['Int']['input']>;
  restaurant_id?: InputMaybe<Scalars['uuid']['input']>;
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetSupplierVariantPackGroupItemsArgs = {
  restaurant_id?: InputMaybe<Scalars['uuid']['input']>;
  supplier_id: Scalars['uuid']['input'];
  variant_pack_group_item_limit?: InputMaybe<Scalars['Int']['input']>;
};


export type Query_RootGetSupplierVariantPackGroupItemsExpandedArgs = {
  include_group_memberships?: InputMaybe<Scalars['Boolean']['input']>;
  include_null_variant_pack_group_items?: InputMaybe<Scalars['Boolean']['input']>;
  include_salt?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  restaurant_id?: InputMaybe<Scalars['uuid']['input']>;
  supplier_id: Scalars['uuid']['input'];
  variant_pack_group_ids?: InputMaybe<Array<Scalars['uuid']['input']>>;
  variant_pack_group_item_limit?: InputMaybe<Scalars['Int']['input']>;
};


export type Query_RootGetUnpaidInvoiceListArgs = {
  invoice_sources?: InputMaybe<Array<OrderInvoiceSource>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  overdue_bucket?: InputMaybe<InvoiceListAgingBucket>;
  record_type?: InputMaybe<InvoiceListRecordType>;
  search_input?: InputMaybe<Scalars['String']['input']>;
  sort_by?: InputMaybe<InvoiceListSortField>;
  sort_direction?: InputMaybe<InvoiceListSortDirection>;
};


export type Query_RootGetUnpaidOrderInvoicesByCustomerArgs = {
  invoice_due_date?: InputMaybe<DateFilterInput>;
  order_fulfillment_date?: InputMaybe<DateFilterInput>;
  restaurant_id?: InputMaybe<Scalars['uuid']['input']>;
  search_input?: InputMaybe<Scalars['String']['input']>;
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
};


export type Query_RootGetVariantPackCostChangeDataArgs = {
  end_date?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetVariantPackCostChangeDataForBusinessOrganizationArgs = {
  variant_pack_ids?: InputMaybe<Array<Scalars['uuid']['input']>>;
};


export type Query_RootGetVariantPackDetailedCostChangeDataArgs = {
  end_date?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  supplier_id?: InputMaybe<Scalars['uuid']['input']>;
  variant_pack_id: Scalars['uuid']['input'];
};


export type Query_RootGetVariantPackGroupsArgs = {
  restaurant_id?: InputMaybe<Scalars['uuid']['input']>;
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetVariantPackInfoListArgs = {
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  order_guide_only?: InputMaybe<Scalars['Boolean']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id_list?: InputMaybe<Array<Scalars['uuid']['input']>>;
};


export type Query_RootGetVariantPackInvoicesForCreditRequestArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};


export type Query_RootGetVariantPackLastPurchaseInfoArgs = {
  chat_id: Scalars['uuid']['input'];
};


export type Query_RootGetVariantPackPricingPriceDraftUpdatesArgs = {
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id: Scalars['uuid']['input'];
};


export type Query_RootGetVariantPackPrintTagConfigurationArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_id_list: Array<Scalars['uuid']['input']>;
};


export type Query_RootGetVariantPackPurchaseHistoryArgs = {
  chat_id: Scalars['uuid']['input'];
  external_item_id?: InputMaybe<Scalars['String']['input']>;
  item_id?: InputMaybe<Scalars['uuid']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<VariantPackPurchaseHistoryOrderBy>;
  variant_pack_id?: InputMaybe<Scalars['uuid']['input']>;
};


export type Query_RootGetVariantPackSubstitutionsArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_ids: Array<Scalars['uuid']['input']>;
};


export type Query_RootGetVisibleVariantPackPrintingPricesArgs = {
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootGetVisibleVariantPacksByVariantPackGroupsArgs = {
  restaurant_id?: InputMaybe<Scalars['uuid']['input']>;
  supplier_id: Scalars['uuid']['input'];
  variant_pack_group_ids: Array<Scalars['uuid']['input']>;
};


export type Query_RootGetWhitelabelConfigArgs = {
  business_organization_id: Scalars['uuid']['input'];
};


export type Query_RootGhost_AgentsArgs = {
  distinct_on?: InputMaybe<Array<Ghost_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ghost_Agents_Order_By>>;
  where?: InputMaybe<Ghost_Agents_Bool_Exp>;
};


export type Query_RootGhost_Agents_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootGhost_Agents_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Ghost_Agents_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ghost_Agents_Order_By>>;
  where?: InputMaybe<Ghost_Agents_Bool_Exp>;
};


export type Query_RootGhost_ConversationsArgs = {
  distinct_on?: InputMaybe<Array<Ghost_Conversations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ghost_Conversations_Order_By>>;
  where?: InputMaybe<Ghost_Conversations_Bool_Exp>;
};


export type Query_RootGhost_Conversations_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootGhost_Conversations_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Ghost_Conversations_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ghost_Conversations_Order_By>>;
  where?: InputMaybe<Ghost_Conversations_Bool_Exp>;
};


export type Query_RootGhost_Execution_LogsArgs = {
  distinct_on?: InputMaybe<Array<Ghost_Execution_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ghost_Execution_Logs_Order_By>>;
  where?: InputMaybe<Ghost_Execution_Logs_Bool_Exp>;
};


export type Query_RootGhost_Execution_Logs_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootGhost_Execution_Logs_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Ghost_Execution_Logs_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ghost_Execution_Logs_Order_By>>;
  where?: InputMaybe<Ghost_Execution_Logs_Bool_Exp>;
};


export type Query_RootGhost_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Ghost_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ghost_Messages_Order_By>>;
  where?: InputMaybe<Ghost_Messages_Bool_Exp>;
};


export type Query_RootGhost_Messages_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootGhost_Messages_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Ghost_Messages_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ghost_Messages_Order_By>>;
  where?: InputMaybe<Ghost_Messages_Bool_Exp>;
};


export type Query_RootGtin_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Gtin_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gtin_Metadata_Order_By>>;
  where?: InputMaybe<Gtin_Metadata_Bool_Exp>;
};


export type Query_RootGtin_Metadata_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootGtin_Metadata_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Gtin_Metadata_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gtin_Metadata_Order_By>>;
  where?: InputMaybe<Gtin_Metadata_Bool_Exp>;
};


export type Query_RootHub_Last_VisitedArgs = {
  distinct_on?: InputMaybe<Array<Hub_Last_Visited_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hub_Last_Visited_Order_By>>;
  where?: InputMaybe<Hub_Last_Visited_Bool_Exp>;
};


export type Query_RootHub_Last_Visited_By_PkArgs = {
  employee_uuid: Scalars['uuid']['input'];
};


export type Query_RootHub_Last_Visited_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Hub_Last_Visited_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hub_Last_Visited_Order_By>>;
  where?: InputMaybe<Hub_Last_Visited_Bool_Exp>;
};


export type Query_RootMenu_Item_IngredientsArgs = {
  distinct_on?: InputMaybe<Array<Menu_Item_Ingredients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menu_Item_Ingredients_Order_By>>;
  where?: InputMaybe<Menu_Item_Ingredients_Bool_Exp>;
};


export type Query_RootMenu_Item_Ingredients_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootMenu_Item_Ingredients_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Menu_Item_Ingredients_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menu_Item_Ingredients_Order_By>>;
  where?: InputMaybe<Menu_Item_Ingredients_Bool_Exp>;
};


export type Query_RootMenu_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Menu_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menu_Items_Order_By>>;
  where?: InputMaybe<Menu_Items_Bool_Exp>;
};


export type Query_RootMenu_Items_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootMenu_Items_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Menu_Items_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menu_Items_Order_By>>;
  where?: InputMaybe<Menu_Items_Bool_Exp>;
};


export type Query_RootMessagesArgs = {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


export type Query_RootMessages_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootMessages_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


export type Query_RootMobile_Payment_TerminalsArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Payment_Terminals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Payment_Terminals_Order_By>>;
  where?: InputMaybe<Mobile_Payment_Terminals_Bool_Exp>;
};


export type Query_RootMobile_Payment_Terminals_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootMobile_Payment_Terminals_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Mobile_Payment_Terminals_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Payment_Terminals_Order_By>>;
  where?: InputMaybe<Mobile_Payment_Terminals_Bool_Exp>;
};


export type Query_RootNodeArgs = {
  id: Scalars['ID']['input'];
};


export type Query_RootOrder_GuideArgs = {
  distinct_on?: InputMaybe<Array<Order_Guide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Guide_Order_By>>;
  where?: InputMaybe<Order_Guide_Bool_Exp>;
};


export type Query_RootOrder_Guide_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootOrder_Guide_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Guide_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Guide_Order_By>>;
  where?: InputMaybe<Order_Guide_Bool_Exp>;
};


export type Query_RootOrder_Guide_Restaurant_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Order_Guide_Restaurant_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Guide_Restaurant_Collection_Order_By>>;
  where?: InputMaybe<Order_Guide_Restaurant_Collection_Bool_Exp>;
};


export type Query_RootOrder_Guide_Restaurant_Collection_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootOrder_Guide_Restaurant_Collection_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Guide_Restaurant_Collection_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Guide_Restaurant_Collection_Order_By>>;
  where?: InputMaybe<Order_Guide_Restaurant_Collection_Bool_Exp>;
};


export type Query_RootOrder_Guide_Supplier_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Order_Guide_Supplier_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Guide_Supplier_Collection_Order_By>>;
  where?: InputMaybe<Order_Guide_Supplier_Collection_Bool_Exp>;
};


export type Query_RootOrder_Guide_Supplier_Collection_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootOrder_Guide_Supplier_Collection_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Guide_Supplier_Collection_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Guide_Supplier_Collection_Order_By>>;
  where?: InputMaybe<Order_Guide_Supplier_Collection_Bool_Exp>;
};


export type Query_RootOrder_Invoice_Check_In_Item_IssuesArgs = {
  distinct_on?: InputMaybe<Array<Order_Invoice_Check_In_Item_Issues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoice_Check_In_Item_Issues_Order_By>>;
  where?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Bool_Exp>;
};


export type Query_RootOrder_Invoice_Check_In_Item_Issues_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootOrder_Invoice_Check_In_Item_Issues_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Invoice_Check_In_Item_Issues_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoice_Check_In_Item_Issues_Order_By>>;
  where?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Bool_Exp>;
};


export type Query_RootOrder_Invoice_Check_In_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Order_Invoice_Check_In_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoice_Check_In_Items_Order_By>>;
  where?: InputMaybe<Order_Invoice_Check_In_Items_Bool_Exp>;
};


export type Query_RootOrder_Invoice_Check_In_Items_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootOrder_Invoice_Check_In_Items_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Invoice_Check_In_Items_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoice_Check_In_Items_Order_By>>;
  where?: InputMaybe<Order_Invoice_Check_In_Items_Bool_Exp>;
};


export type Query_RootOrder_Invoice_Check_InsArgs = {
  distinct_on?: InputMaybe<Array<Order_Invoice_Check_Ins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoice_Check_Ins_Order_By>>;
  where?: InputMaybe<Order_Invoice_Check_Ins_Bool_Exp>;
};


export type Query_RootOrder_Invoice_Check_Ins_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootOrder_Invoice_Check_Ins_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Invoice_Check_Ins_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoice_Check_Ins_Order_By>>;
  where?: InputMaybe<Order_Invoice_Check_Ins_Bool_Exp>;
};


export type Query_RootOrder_InvoicesArgs = {
  distinct_on?: InputMaybe<Array<Order_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoices_Order_By>>;
  where?: InputMaybe<Order_Invoices_Bool_Exp>;
};


export type Query_RootOrder_Invoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoices_Order_By>>;
  where?: InputMaybe<Order_Invoices_Bool_Exp>;
};


export type Query_RootOrder_Invoices_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootOrder_Invoices_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Invoices_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoices_Order_By>>;
  where?: InputMaybe<Order_Invoices_Bool_Exp>;
};


export type Query_RootOrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Query_RootOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Query_RootOrders_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootOrders_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Query_RootOrders_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Orders_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Items_Order_By>>;
  where?: InputMaybe<Orders_Items_Bool_Exp>;
};


export type Query_RootOrders_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Items_Order_By>>;
  where?: InputMaybe<Orders_Items_Bool_Exp>;
};


export type Query_RootOrders_Items_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootOrders_Items_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Orders_Items_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Items_Order_By>>;
  where?: InputMaybe<Orders_Items_Bool_Exp>;
};


export type Query_RootPad_Payment_MethodArgs = {
  distinct_on?: InputMaybe<Array<Pad_Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pad_Payment_Method_Order_By>>;
  where?: InputMaybe<Pad_Payment_Method_Bool_Exp>;
};


export type Query_RootPad_Payment_Method_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootPad_Payment_Method_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Pad_Payment_Method_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pad_Payment_Method_Order_By>>;
  where?: InputMaybe<Pad_Payment_Method_Bool_Exp>;
};


export type Query_RootPayment_BatchesArgs = {
  distinct_on?: InputMaybe<Array<Payment_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Batches_Order_By>>;
  where?: InputMaybe<Payment_Batches_Bool_Exp>;
};


export type Query_RootPayment_Batches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Batches_Order_By>>;
  where?: InputMaybe<Payment_Batches_Bool_Exp>;
};


export type Query_RootPayment_Batches_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootPayment_Batches_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Payment_Batches_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Batches_Order_By>>;
  where?: InputMaybe<Payment_Batches_Bool_Exp>;
};


export type Query_RootPayment_LinksArgs = {
  distinct_on?: InputMaybe<Array<Payment_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Links_Order_By>>;
  where?: InputMaybe<Payment_Links_Bool_Exp>;
};


export type Query_RootPayment_Links_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Payment_Links_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Links_Order_By>>;
  where?: InputMaybe<Payment_Links_Bool_Exp>;
};


export type Query_RootPayment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Query_RootPayment_Methods_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootPayment_Methods_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Query_RootPlaidGetSessionInfoArgs = {
  session_token: Scalars['String']['input'];
};


export type Query_RootPlanogramsArgs = {
  distinct_on?: InputMaybe<Array<Planograms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planograms_Order_By>>;
  where?: InputMaybe<Planograms_Bool_Exp>;
};


export type Query_RootPlanograms_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootPlanograms_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Planograms_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planograms_Order_By>>;
  where?: InputMaybe<Planograms_Bool_Exp>;
};


export type Query_RootPricing_Price_Draft_Update_BatchesArgs = {
  distinct_on?: InputMaybe<Array<Pricing_Price_Draft_Update_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pricing_Price_Draft_Update_Batches_Order_By>>;
  where?: InputMaybe<Pricing_Price_Draft_Update_Batches_Bool_Exp>;
};


export type Query_RootPricing_Price_Draft_Update_Batches_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootPricing_Price_Draft_Update_Batches_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Pricing_Price_Draft_Update_Batches_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pricing_Price_Draft_Update_Batches_Order_By>>;
  where?: InputMaybe<Pricing_Price_Draft_Update_Batches_Bool_Exp>;
};


export type Query_RootPricing_Task_RunsArgs = {
  distinct_on?: InputMaybe<Array<Pricing_Task_Runs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pricing_Task_Runs_Order_By>>;
  where?: InputMaybe<Pricing_Task_Runs_Bool_Exp>;
};


export type Query_RootPricing_Task_Runs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pricing_Task_Runs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pricing_Task_Runs_Order_By>>;
  where?: InputMaybe<Pricing_Task_Runs_Bool_Exp>;
};


export type Query_RootPricing_Task_Runs_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootPricing_Task_Runs_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Pricing_Task_Runs_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pricing_Task_Runs_Order_By>>;
  where?: InputMaybe<Pricing_Task_Runs_Bool_Exp>;
};


export type Query_RootPrint_Tag_BatchesArgs = {
  distinct_on?: InputMaybe<Array<Print_Tag_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Print_Tag_Batches_Order_By>>;
  where?: InputMaybe<Print_Tag_Batches_Bool_Exp>;
};


export type Query_RootPrint_Tag_Batches_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootPrint_Tag_Batches_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Print_Tag_Batches_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Print_Tag_Batches_Order_By>>;
  where?: InputMaybe<Print_Tag_Batches_Bool_Exp>;
};


export type Query_RootPrint_Tag_Template_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Print_Tag_Template_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Print_Tag_Template_Assignments_Order_By>>;
  where?: InputMaybe<Print_Tag_Template_Assignments_Bool_Exp>;
};


export type Query_RootPrint_Tag_Template_Assignments_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootPrint_Tag_Template_Assignments_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Print_Tag_Template_Assignments_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Print_Tag_Template_Assignments_Order_By>>;
  where?: InputMaybe<Print_Tag_Template_Assignments_Bool_Exp>;
};


export type Query_RootPrint_Tag_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Print_Tag_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Print_Tag_Templates_Order_By>>;
  where?: InputMaybe<Print_Tag_Templates_Bool_Exp>;
};


export type Query_RootPrint_Tag_Templates_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootPrint_Tag_Templates_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Print_Tag_Templates_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Print_Tag_Templates_Order_By>>;
  where?: InputMaybe<Print_Tag_Templates_Bool_Exp>;
};


export type Query_RootPromotion_Component_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Promotion_Component_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Promotion_Component_Groups_Order_By>>;
  where?: InputMaybe<Promotion_Component_Groups_Bool_Exp>;
};


export type Query_RootPromotion_Component_Groups_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Promotion_Component_Groups_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Promotion_Component_Groups_Order_By>>;
  where?: InputMaybe<Promotion_Component_Groups_Bool_Exp>;
};


export type Query_RootRenderPrintCreditRequestTemplateArgs = {
  credit_request_batch_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootRenderPrintOrderTemplateArgs = {
  order_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootRenderPrintTagBatchTemplatesForRestaurantArgs = {
  order_by?: InputMaybe<PrintTagBatchRenderOrderBy>;
  print_tag_batch_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootRenderPrintTagTemplateForRestaurantArgs = {
  print_tag_template_id: Scalars['uuid']['input'];
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_inputs: Array<VariantPackInput>;
};


export type Query_RootRestaurant_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Restaurant_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Groups_Order_By>>;
  where?: InputMaybe<Restaurant_Groups_Bool_Exp>;
};


export type Query_RootRestaurant_Groups_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootRestaurant_Groups_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Restaurant_Groups_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Groups_Order_By>>;
  where?: InputMaybe<Restaurant_Groups_Bool_Exp>;
};


export type Query_RootSales_Rep_Chat_RelationsArgs = {
  distinct_on?: InputMaybe<Array<Sales_Rep_Chat_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sales_Rep_Chat_Relations_Order_By>>;
  where?: InputMaybe<Sales_Rep_Chat_Relations_Bool_Exp>;
};


export type Query_RootSales_Rep_Chat_Relations_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootSales_Rep_Chat_Relations_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Sales_Rep_Chat_Relations_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sales_Rep_Chat_Relations_Order_By>>;
  where?: InputMaybe<Sales_Rep_Chat_Relations_Bool_Exp>;
};


export type Query_RootSaltDocsArgs = {
  collection: DocumentCollection;
  identifiers: Array<DocumentIdentifierInput>;
};


export type Query_RootSaltItemArgs = {
  locale?: Scalars['String']['input'];
  restaurantId: Scalars['uuid']['input'];
  saltId?: InputMaybe<Scalars['String']['input']>;
  supplierId: Scalars['uuid']['input'];
  vpId: Scalars['uuid']['input'];
};


export type Query_RootSaltItemsArgs = {
  items: Array<SaltItemInput>;
  locale: Scalars['String']['input'];
  restaurantId: Scalars['uuid']['input'];
  supplierId: Scalars['uuid']['input'];
};


export type Query_RootSearchCatalogForOrderEntryItemsArgs = {
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  restaurant_id: Scalars['uuid']['input'];
  search_term: Scalars['String']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootSearchCatalogForOrderGuideItemsArgs = {
  restaurant_id: Scalars['uuid']['input'];
  search_term: Scalars['String']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootSearchManualMenuItemIngredientsArgs = {
  restaurant_id: Scalars['uuid']['input'];
  search_text: Scalars['String']['input'];
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootSearchOrderHistoryArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters: Array<SearchOrderHistoryFilterInput>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  restaurant_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_by?: InputMaybe<SearchOrderHistorySortByInput>;
  supplier_id: Scalars['uuid']['input'];
};


export type Query_RootSearchPriceQuoteItemsArgs = {
  chat_id: Scalars['uuid']['input'];
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
};


export type Query_RootSearchPublicVariantPacksArgs = {
  filters?: InputMaybe<Array<SearchFilterInput>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  supplier_id: Scalars['uuid']['input'];
  variant_pack_group_id?: InputMaybe<Scalars['uuid']['input']>;
};


export type Query_RootSearchRecentlyOrderedVariantPacksByUpcArgs = {
  filters?: InputMaybe<Array<SearchFilterInput>>;
  include_order_counts?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
  search_sort_order?: InputMaybe<SearchSortOrder>;
  supplier_id: Scalars['uuid']['input'];
  variant_pack_group_id?: InputMaybe<Scalars['uuid']['input']>;
};


export type Query_RootSearchVariantPacksArgs = {
  availability_fulfillment_date?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<SearchFilterInput>>;
  fulfillment_date?: InputMaybe<Scalars['String']['input']>;
  include_order_counts?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
  search_sort_order?: InputMaybe<SearchSortOrder>;
  supplier_id: Scalars['uuid']['input'];
  variant_pack_group_id?: InputMaybe<Scalars['uuid']['input']>;
};


export type Query_RootSearchVariantPacksByUpcArgs = {
  filters?: InputMaybe<Array<SearchFilterInput>>;
  include_order_counts?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
  search_sort_order?: InputMaybe<SearchSortOrder>;
  supplier_id: Scalars['uuid']['input'];
  variant_pack_group_id?: InputMaybe<Scalars['uuid']['input']>;
};


export type Query_RootSearchVariantPacksForBusinessOrganizationArgs = {
  query: Scalars['String']['input'];
};


export type Query_RootSearchVariantPacksForCreditRequestArgs = {
  filters?: InputMaybe<Array<SearchFilterInput>>;
  include_order_counts?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_invoice_id?: InputMaybe<Scalars['uuid']['input']>;
  query: Scalars['String']['input'];
  restaurant_id: Scalars['uuid']['input'];
  search_sort_order?: InputMaybe<SearchSortOrder>;
  supplier_id: Scalars['uuid']['input'];
  variant_pack_group_id?: InputMaybe<Scalars['uuid']['input']>;
  variant_pack_id?: InputMaybe<Scalars['uuid']['input']>;
  variant_pack_ids?: InputMaybe<Array<Scalars['uuid']['input']>>;
};


export type Query_RootSmart_OrderArgs = {
  distinct_on?: InputMaybe<Array<Smart_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Order_By>>;
  where?: InputMaybe<Smart_Order_Bool_Exp>;
};


export type Query_RootSmart_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Smart_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Order_By>>;
  where?: InputMaybe<Smart_Order_Bool_Exp>;
};


export type Query_RootSmart_Order_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootSmart_Order_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Smart_Order_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Order_By>>;
  where?: InputMaybe<Smart_Order_Bool_Exp>;
};


export type Query_RootSmart_Order_Message_RelArgs = {
  distinct_on?: InputMaybe<Array<Smart_Order_Message_Rel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Message_Rel_Order_By>>;
  where?: InputMaybe<Smart_Order_Message_Rel_Bool_Exp>;
};


export type Query_RootSmart_Order_Message_Rel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Smart_Order_Message_Rel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Message_Rel_Order_By>>;
  where?: InputMaybe<Smart_Order_Message_Rel_Bool_Exp>;
};


export type Query_RootSmart_Order_Message_Rel_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootSmart_Order_Message_Rel_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Smart_Order_Message_Rel_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Message_Rel_Order_By>>;
  where?: InputMaybe<Smart_Order_Message_Rel_Bool_Exp>;
};


export type Query_RootSmart_Order_Search_Term_CorrectionsArgs = {
  distinct_on?: InputMaybe<Array<Smart_Order_Search_Term_Corrections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Search_Term_Corrections_Order_By>>;
  where?: InputMaybe<Smart_Order_Search_Term_Corrections_Bool_Exp>;
};


export type Query_RootSmart_Order_Search_Term_Corrections_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootSmart_Order_Search_Term_Corrections_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Smart_Order_Search_Term_Corrections_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Search_Term_Corrections_Order_By>>;
  where?: InputMaybe<Smart_Order_Search_Term_Corrections_Bool_Exp>;
};


export type Query_RootSupplier_Payments_StatusArgs = {
  distinct_on?: InputMaybe<Array<Supplier_Payments_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supplier_Payments_Status_Order_By>>;
  where?: InputMaybe<Supplier_Payments_Status_Bool_Exp>;
};


export type Query_RootTask_Frequency_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Task_Frequency_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Frequency_Settings_Order_By>>;
  where?: InputMaybe<Task_Frequency_Settings_Bool_Exp>;
};


export type Query_RootTask_Frequency_Settings_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Task_Frequency_Settings_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Frequency_Settings_Order_By>>;
  where?: InputMaybe<Task_Frequency_Settings_Bool_Exp>;
};


export type Query_RootUpdatedSaltItemArgs = {
  locale?: Scalars['String']['input'];
  restaurantId: Scalars['uuid']['input'];
  saltId?: InputMaybe<Scalars['String']['input']>;
  supplierId: Scalars['uuid']['input'];
  vpUuid: Scalars['String']['input'];
};


export type Query_RootValidateCreditRequestArgs = {
  chat_id: Scalars['uuid']['input'];
  credit_request_batch_line_items: Array<CreditRequestBatchLineItemInput>;
};


export type Query_RootVariant_Pack_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Variant_Pack_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variant_Pack_Groups_Order_By>>;
  where?: InputMaybe<Variant_Pack_Groups_Bool_Exp>;
};


export type Query_RootVariant_Pack_Groups_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootVariant_Pack_Groups_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Variant_Pack_Groups_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variant_Pack_Groups_Order_By>>;
  where?: InputMaybe<Variant_Pack_Groups_Bool_Exp>;
};


export type Query_RootVariants_PacksArgs = {
  distinct_on?: InputMaybe<Array<Variants_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variants_Packs_Order_By>>;
  where?: InputMaybe<Variants_Packs_Bool_Exp>;
};


export type Query_RootVariants_Packs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variants_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variants_Packs_Order_By>>;
  where?: InputMaybe<Variants_Packs_Bool_Exp>;
};


export type Query_RootVariants_Packs_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootVariants_Packs_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Variants_Packs_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variants_Packs_Order_By>>;
  where?: InputMaybe<Variants_Packs_Bool_Exp>;
};


export type Query_RootVariants_Packs_Substitution_SuppliersArgs = {
  distinct_on?: InputMaybe<Array<Variants_Packs_Substitution_Suppliers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variants_Packs_Substitution_Suppliers_Order_By>>;
  where?: InputMaybe<Variants_Packs_Substitution_Suppliers_Bool_Exp>;
};


export type Query_RootVariants_Packs_Substitution_Suppliers_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootVariants_Packs_Substitution_Suppliers_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Variants_Packs_Substitution_Suppliers_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variants_Packs_Substitution_Suppliers_Order_By>>;
  where?: InputMaybe<Variants_Packs_Substitution_Suppliers_Bool_Exp>;
};


export type Query_RootVisible_Variant_PacksArgs = {
  distinct_on?: InputMaybe<Array<Visible_Variant_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visible_Variant_Packs_Order_By>>;
  where?: InputMaybe<Visible_Variant_Packs_Bool_Exp>;
};


export type Query_RootVisible_Variant_Packs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visible_Variant_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visible_Variant_Packs_Order_By>>;
  where?: InputMaybe<Visible_Variant_Packs_Bool_Exp>;
};


export type Query_RootWhitelabel_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Whitelabel_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whitelabel_Config_Order_By>>;
  where?: InputMaybe<Whitelabel_Config_Bool_Exp>;
};


export type Query_RootWhitelabel_Config_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Query_RootWhitelabel_Config_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Whitelabel_Config_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whitelabel_Config_Order_By>>;
  where?: InputMaybe<Whitelabel_Config_Bool_Exp>;
};

/** columns and relationships of "restaurant_group_members" */
export type Restaurant_Group_Members = Node & {
  __typename?: 'restaurant_group_members';
  id: Scalars['ID']['output'];
  /** An object relationship */
  restaurant: Businesses;
  /** An object relationship */
  restaurant_group: Restaurant_Groups;
  restaurant_group_uuid: Scalars['uuid']['output'];
  restaurant_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "restaurant_group_members" */
export type Restaurant_Group_MembersConnection = {
  __typename?: 'restaurant_group_membersConnection';
  edges: Array<Restaurant_Group_MembersEdge>;
  pageInfo: PageInfo;
};

export type Restaurant_Group_MembersEdge = {
  __typename?: 'restaurant_group_membersEdge';
  cursor: Scalars['String']['output'];
  node: Restaurant_Group_Members;
};

/** aggregated selection of "restaurant_group_members" */
export type Restaurant_Group_Members_Aggregate = {
  __typename?: 'restaurant_group_members_aggregate';
  aggregate?: Maybe<Restaurant_Group_Members_Aggregate_Fields>;
  nodes: Array<Restaurant_Group_Members>;
};

/** aggregate fields of "restaurant_group_members" */
export type Restaurant_Group_Members_Aggregate_Fields = {
  __typename?: 'restaurant_group_members_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Restaurant_Group_Members_Max_Fields>;
  min?: Maybe<Restaurant_Group_Members_Min_Fields>;
};


/** aggregate fields of "restaurant_group_members" */
export type Restaurant_Group_Members_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Restaurant_Group_Members_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "restaurant_group_members" */
export type Restaurant_Group_Members_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Restaurant_Group_Members_Max_Order_By>;
  min?: InputMaybe<Restaurant_Group_Members_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "restaurant_group_members". All fields are combined with a logical 'AND'. */
export type Restaurant_Group_Members_Bool_Exp = {
  _and?: InputMaybe<Array<Restaurant_Group_Members_Bool_Exp>>;
  _not?: InputMaybe<Restaurant_Group_Members_Bool_Exp>;
  _or?: InputMaybe<Array<Restaurant_Group_Members_Bool_Exp>>;
  restaurant?: InputMaybe<Businesses_Bool_Exp>;
  restaurant_group?: InputMaybe<Restaurant_Groups_Bool_Exp>;
  restaurant_group_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Restaurant_Group_Members_Max_Fields = {
  __typename?: 'restaurant_group_members_max_fields';
  restaurant_group_uuid?: Maybe<Scalars['uuid']['output']>;
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "restaurant_group_members" */
export type Restaurant_Group_Members_Max_Order_By = {
  restaurant_group_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Restaurant_Group_Members_Min_Fields = {
  __typename?: 'restaurant_group_members_min_fields';
  restaurant_group_uuid?: Maybe<Scalars['uuid']['output']>;
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "restaurant_group_members" */
export type Restaurant_Group_Members_Min_Order_By = {
  restaurant_group_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "restaurant_group_members". */
export type Restaurant_Group_Members_Order_By = {
  restaurant?: InputMaybe<Businesses_Order_By>;
  restaurant_group?: InputMaybe<Restaurant_Groups_Order_By>;
  restaurant_group_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "restaurant_group_members" */
export enum Restaurant_Group_Members_Select_Column {
  /** column name */
  RestaurantGroupUuid = 'restaurant_group_uuid',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** columns and relationships of "restaurant_groups" */
export type Restaurant_Groups = Node & {
  __typename?: 'restaurant_groups';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  owner: Businesses;
  owner_uuid: Scalars['uuid']['output'];
  /** An array relationship */
  restaurant_group_members: Array<Restaurant_Group_Members>;
  /** An aggregate relationship */
  restaurant_group_members_aggregate: Restaurant_Group_Members_Aggregate;
  /** An array relationship connection */
  restaurant_group_members_connection: Restaurant_Group_MembersConnection;
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "restaurant_groups" */
export type Restaurant_GroupsRestaurant_Group_MembersArgs = {
  distinct_on?: InputMaybe<Array<Restaurant_Group_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Group_Members_Order_By>>;
  where?: InputMaybe<Restaurant_Group_Members_Bool_Exp>;
};


/** columns and relationships of "restaurant_groups" */
export type Restaurant_GroupsRestaurant_Group_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Restaurant_Group_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Group_Members_Order_By>>;
  where?: InputMaybe<Restaurant_Group_Members_Bool_Exp>;
};


/** columns and relationships of "restaurant_groups" */
export type Restaurant_GroupsRestaurant_Group_Members_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Restaurant_Group_Members_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Group_Members_Order_By>>;
  where?: InputMaybe<Restaurant_Group_Members_Bool_Exp>;
};

/** A Relay connection object on "restaurant_groups" */
export type Restaurant_GroupsConnection = {
  __typename?: 'restaurant_groupsConnection';
  edges: Array<Restaurant_GroupsEdge>;
  pageInfo: PageInfo;
};

export type Restaurant_GroupsEdge = {
  __typename?: 'restaurant_groupsEdge';
  cursor: Scalars['String']['output'];
  node: Restaurant_Groups;
};

/** Boolean expression to filter rows from the table "restaurant_groups". All fields are combined with a logical 'AND'. */
export type Restaurant_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Restaurant_Groups_Bool_Exp>>;
  _not?: InputMaybe<Restaurant_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Restaurant_Groups_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<Businesses_Bool_Exp>;
  owner_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  restaurant_group_members?: InputMaybe<Restaurant_Group_Members_Bool_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "restaurant_groups". */
export type Restaurant_Groups_Order_By = {
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Businesses_Order_By>;
  owner_uuid?: InputMaybe<Order_By>;
  restaurant_group_members_aggregate?: InputMaybe<Restaurant_Group_Members_Aggregate_Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "restaurant_groups" */
export enum Restaurant_Groups_Select_Column {
  /** column name */
  Name = 'name',
  /** column name */
  OwnerUuid = 'owner_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "restaurant_groups" */
export type Restaurant_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Restaurant_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Restaurant_Groups_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  owner_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "restaurant_item_overrides" */
export type Restaurant_Item_Overrides = Node & {
  __typename?: 'restaurant_item_overrides';
  category?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  item_uuid: Scalars['uuid']['output'];
  restaurant_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "restaurant_item_overrides" */
export type Restaurant_Item_OverridesConnection = {
  __typename?: 'restaurant_item_overridesConnection';
  edges: Array<Restaurant_Item_OverridesEdge>;
  pageInfo: PageInfo;
};

export type Restaurant_Item_OverridesEdge = {
  __typename?: 'restaurant_item_overridesEdge';
  cursor: Scalars['String']['output'];
  node: Restaurant_Item_Overrides;
};

/** order by aggregate values of table "restaurant_item_overrides" */
export type Restaurant_Item_Overrides_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Restaurant_Item_Overrides_Max_Order_By>;
  min?: InputMaybe<Restaurant_Item_Overrides_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "restaurant_item_overrides". All fields are combined with a logical 'AND'. */
export type Restaurant_Item_Overrides_Bool_Exp = {
  _and?: InputMaybe<Array<Restaurant_Item_Overrides_Bool_Exp>>;
  _not?: InputMaybe<Restaurant_Item_Overrides_Bool_Exp>;
  _or?: InputMaybe<Array<Restaurant_Item_Overrides_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  item_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "restaurant_item_overrides" */
export type Restaurant_Item_Overrides_Max_Order_By = {
  category?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  item_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "restaurant_item_overrides" */
export type Restaurant_Item_Overrides_Min_Order_By = {
  category?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  item_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "restaurant_item_overrides". */
export type Restaurant_Item_Overrides_Order_By = {
  category?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  item_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "restaurant_item_overrides" */
export enum Restaurant_Item_Overrides_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  ItemUuid = 'item_uuid',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** columns and relationships of "restaurant_variant_pack_overrides" */
export type Restaurant_Variant_Pack_Overrides = Node & {
  __typename?: 'restaurant_variant_pack_overrides';
  id: Scalars['ID']['output'];
  list_prices?: Maybe<Scalars['jsonb']['output']>;
  restaurant_uuid: Scalars['uuid']['output'];
  supplier_uuid: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by_uuid?: Maybe<Scalars['uuid']['output']>;
  user_defined_metadata?: Maybe<Scalars['jsonb']['output']>;
  uuid: Scalars['uuid']['output'];
  variant_pack_metadata?: Maybe<Scalars['jsonb']['output']>;
  variant_pack_uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "restaurant_variant_pack_overrides" */
export type Restaurant_Variant_Pack_OverridesList_PricesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "restaurant_variant_pack_overrides" */
export type Restaurant_Variant_Pack_OverridesUser_Defined_MetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "restaurant_variant_pack_overrides" */
export type Restaurant_Variant_Pack_OverridesVariant_Pack_MetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "restaurant_variant_pack_overrides" */
export type Restaurant_Variant_Pack_OverridesConnection = {
  __typename?: 'restaurant_variant_pack_overridesConnection';
  edges: Array<Restaurant_Variant_Pack_OverridesEdge>;
  pageInfo: PageInfo;
};

export type Restaurant_Variant_Pack_OverridesEdge = {
  __typename?: 'restaurant_variant_pack_overridesEdge';
  cursor: Scalars['String']['output'];
  node: Restaurant_Variant_Pack_Overrides;
};

/** order by aggregate values of table "restaurant_variant_pack_overrides" */
export type Restaurant_Variant_Pack_Overrides_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Restaurant_Variant_Pack_Overrides_Max_Order_By>;
  min?: InputMaybe<Restaurant_Variant_Pack_Overrides_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "restaurant_variant_pack_overrides". All fields are combined with a logical 'AND'. */
export type Restaurant_Variant_Pack_Overrides_Bool_Exp = {
  _and?: InputMaybe<Array<Restaurant_Variant_Pack_Overrides_Bool_Exp>>;
  _not?: InputMaybe<Restaurant_Variant_Pack_Overrides_Bool_Exp>;
  _or?: InputMaybe<Array<Restaurant_Variant_Pack_Overrides_Bool_Exp>>;
  list_prices?: InputMaybe<Jsonb_Comparison_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  user_defined_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  variant_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "restaurant_variant_pack_overrides" */
export type Restaurant_Variant_Pack_Overrides_Max_Order_By = {
  restaurant_uuid?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "restaurant_variant_pack_overrides" */
export type Restaurant_Variant_Pack_Overrides_Min_Order_By = {
  restaurant_uuid?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "restaurant_variant_pack_overrides". */
export type Restaurant_Variant_Pack_Overrides_Order_By = {
  list_prices?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_uuid?: InputMaybe<Order_By>;
  user_defined_metadata?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_metadata?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** select columns of table "restaurant_variant_pack_overrides" */
export enum Restaurant_Variant_Pack_Overrides_Select_Column {
  /** column name */
  ListPrices = 'list_prices',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUuid = 'updated_by_uuid',
  /** column name */
  UserDefinedMetadata = 'user_defined_metadata',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VariantPackMetadata = 'variant_pack_metadata',
  /** column name */
  VariantPackUuid = 'variant_pack_uuid'
}

/** columns and relationships of "restaurant_variant_pack_subscriptions" */
export type Restaurant_Variant_Pack_Subscriptions = Node & {
  __typename?: 'restaurant_variant_pack_subscriptions';
  config: Scalars['jsonb']['output'];
  created_at: Scalars['timestamptz']['output'];
  fulfillment_settings_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  pause_from?: Maybe<Scalars['date']['output']>;
  pause_until?: Maybe<Scalars['date']['output']>;
  restaurant_uuid: Scalars['uuid']['output'];
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
  /** An object relationship */
  variant_pack: Variants_Packs;
  variant_pack_uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "restaurant_variant_pack_subscriptions" */
export type Restaurant_Variant_Pack_SubscriptionsConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "restaurant_variant_pack_subscriptions". All fields are combined with a logical 'AND'. */
export type Restaurant_Variant_Pack_Subscriptions_Bool_Exp = {
  _and?: InputMaybe<Array<Restaurant_Variant_Pack_Subscriptions_Bool_Exp>>;
  _not?: InputMaybe<Restaurant_Variant_Pack_Subscriptions_Bool_Exp>;
  _or?: InputMaybe<Array<Restaurant_Variant_Pack_Subscriptions_Bool_Exp>>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fulfillment_settings_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  pause_from?: InputMaybe<Date_Comparison_Exp>;
  pause_until?: InputMaybe<Date_Comparison_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack?: InputMaybe<Variants_Packs_Bool_Exp>;
  variant_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "restaurant_variant_pack_subscriptions". */
export type Restaurant_Variant_Pack_Subscriptions_Order_By = {
  config?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fulfillment_settings_uuid?: InputMaybe<Order_By>;
  pause_from?: InputMaybe<Order_By>;
  pause_until?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack?: InputMaybe<Variants_Packs_Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "sales_rep_chat_relations" */
export type Sales_Rep_Chat_Relations = Node & {
  __typename?: 'sales_rep_chat_relations';
  /** An object relationship */
  chat: Chats;
  chat_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  created_by: Employees;
  /** An object relationship */
  employee: Employees;
  employee_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  /** An object relationship */
  updated_by: Employees;
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "sales_rep_chat_relations" */
export type Sales_Rep_Chat_RelationsConnection = {
  __typename?: 'sales_rep_chat_relationsConnection';
  edges: Array<Sales_Rep_Chat_RelationsEdge>;
  pageInfo: PageInfo;
};

export type Sales_Rep_Chat_RelationsEdge = {
  __typename?: 'sales_rep_chat_relationsEdge';
  cursor: Scalars['String']['output'];
  node: Sales_Rep_Chat_Relations;
};

/** Boolean expression to filter rows from the table "sales_rep_chat_relations". All fields are combined with a logical 'AND'. */
export type Sales_Rep_Chat_Relations_Bool_Exp = {
  _and?: InputMaybe<Array<Sales_Rep_Chat_Relations_Bool_Exp>>;
  _not?: InputMaybe<Sales_Rep_Chat_Relations_Bool_Exp>;
  _or?: InputMaybe<Array<Sales_Rep_Chat_Relations_Bool_Exp>>;
  chat?: InputMaybe<Chats_Bool_Exp>;
  chat_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  created_by?: InputMaybe<Employees_Bool_Exp>;
  employee?: InputMaybe<Employees_Bool_Exp>;
  employee_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_by?: InputMaybe<Employees_Bool_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "sales_rep_chat_relations". */
export type Sales_Rep_Chat_Relations_Order_By = {
  chat?: InputMaybe<Chats_Order_By>;
  chat_uuid?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Employees_Order_By>;
  employee?: InputMaybe<Employees_Order_By>;
  employee_uuid?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Employees_Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "sales_rep_chat_relations" */
export enum Sales_Rep_Chat_Relations_Select_Column {
  /** column name */
  ChatUuid = 'chat_uuid',
  /** column name */
  EmployeeUuid = 'employee_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "sales_rep_chat_relations" */
export type Sales_Rep_Chat_Relations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sales_Rep_Chat_Relations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sales_Rep_Chat_Relations_Stream_Cursor_Value_Input = {
  chat_uuid?: InputMaybe<Scalars['uuid']['input']>;
  employee_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "sample_requests" */
export type Sample_Requests = Node & {
  __typename?: 'sample_requests';
  /** An object relationship */
  address?: Maybe<Addresses>;
  address_uuid?: Maybe<Scalars['uuid']['output']>;
  contact_email?: Maybe<Scalars['String']['output']>;
  follow_up_response?: Maybe<Scalars['jsonb']['output']>;
  follow_up_submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['ID']['output'];
  qualification_responses?: Maybe<Scalars['jsonb']['output']>;
  qualified_at?: Maybe<Scalars['timestamptz']['output']>;
  requested_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  requested_by: Employees;
  requested_by_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  restaurant: Businesses;
  status: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "sample_requests" */
export type Sample_RequestsFollow_Up_ResponseArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "sample_requests" */
export type Sample_RequestsQualification_ResponsesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']['input']>;
  _gt?: InputMaybe<Scalars['smallint']['input']>;
  _gte?: InputMaybe<Scalars['smallint']['input']>;
  _in?: InputMaybe<Array<Scalars['smallint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['smallint']['input']>;
  _lte?: InputMaybe<Scalars['smallint']['input']>;
  _neq?: InputMaybe<Scalars['smallint']['input']>;
  _nin?: InputMaybe<Array<Scalars['smallint']['input']>>;
};

/** columns and relationships of "smart_order" */
export type Smart_Order = Node & {
  __typename?: 'smart_order';
  /** An object relationship */
  assigned_employee?: Maybe<Employees>;
  assigned_employee_uuid?: Maybe<Scalars['uuid']['output']>;
  attachment_urls?: Maybe<Scalars['_varchar']['output']>;
  attachments?: Maybe<Scalars['jsonb']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by?: Maybe<Employees>;
  created_by_uuid?: Maybe<Scalars['uuid']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  fulfillment_at?: Maybe<Scalars['timestamptz']['output']>;
  fulfillment_type: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_auto_submitted: Scalars['Boolean']['output'];
  kickback_details?: Maybe<Scalars['_text']['output']>;
  kickback_reason?: Maybe<Scalars['String']['output']>;
  last_viewed_at?: Maybe<Scalars['timestamptz']['output']>;
  merge_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  order?: Maybe<Orders>;
  order_notes?: Maybe<Scalars['String']['output']>;
  order_uuid?: Maybe<Scalars['uuid']['output']>;
  original_fulfillment_at?: Maybe<Scalars['timestamptz']['output']>;
  original_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  po_number?: Maybe<Scalars['String']['output']>;
  processing_status: Scalars['String']['output'];
  /** An object relationship */
  restaurant?: Maybe<Businesses>;
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  review_duration_seconds?: Maybe<Scalars['numeric']['output']>;
  search_inputs: Scalars['_jsonb']['output'];
  search_text?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  smart_order_results: Array<Smart_Order_Result>;
  /** An array relationship connection */
  smart_order_results_connection: Smart_Order_ResultConnection;
  /** An array relationship */
  smart_order_search_inputs: Array<Smart_Order_Search_Input>;
  /** An array relationship connection */
  smart_order_search_inputs_connection: Smart_Order_Search_InputConnection;
  /** An array relationship */
  smart_order_segments: Array<Smart_Order_Segment>;
  /** An array relationship connection */
  smart_order_segments_connection: Smart_Order_SegmentConnection;
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  submit_type: Scalars['String']['output'];
  /** An object relationship */
  supplier: Businesses;
  supplier_uuid: Scalars['uuid']['output'];
  thread_id?: Maybe<Scalars['String']['output']>;
  translations?: Maybe<Scalars['jsonb']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  updated_by_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid: Scalars['uuid']['output'];
  voicemail_recording_url?: Maybe<Scalars['String']['output']>;
  voicemail_word_timestamps?: Maybe<Scalars['_jsonb']['output']>;
};


/** columns and relationships of "smart_order" */
export type Smart_OrderAttachmentsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "smart_order" */
export type Smart_OrderSmart_Order_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Smart_Order_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Result_Order_By>>;
  where?: InputMaybe<Smart_Order_Result_Bool_Exp>;
};


/** columns and relationships of "smart_order" */
export type Smart_OrderSmart_Order_Results_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Smart_Order_Result_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Result_Order_By>>;
  where?: InputMaybe<Smart_Order_Result_Bool_Exp>;
};


/** columns and relationships of "smart_order" */
export type Smart_OrderSmart_Order_Search_InputsArgs = {
  distinct_on?: InputMaybe<Array<Smart_Order_Search_Input_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Search_Input_Order_By>>;
  where?: InputMaybe<Smart_Order_Search_Input_Bool_Exp>;
};


/** columns and relationships of "smart_order" */
export type Smart_OrderSmart_Order_Search_Inputs_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Smart_Order_Search_Input_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Search_Input_Order_By>>;
  where?: InputMaybe<Smart_Order_Search_Input_Bool_Exp>;
};


/** columns and relationships of "smart_order" */
export type Smart_OrderSmart_Order_SegmentsArgs = {
  distinct_on?: InputMaybe<Array<Smart_Order_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Segment_Order_By>>;
  where?: InputMaybe<Smart_Order_Segment_Bool_Exp>;
};


/** columns and relationships of "smart_order" */
export type Smart_OrderSmart_Order_Segments_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Smart_Order_Segment_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Segment_Order_By>>;
  where?: InputMaybe<Smart_Order_Segment_Bool_Exp>;
};


/** columns and relationships of "smart_order" */
export type Smart_OrderTranslationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "smart_order" */
export type Smart_OrderConnection = {
  __typename?: 'smart_orderConnection';
  edges: Array<Smart_OrderEdge>;
  pageInfo: PageInfo;
};

export type Smart_OrderEdge = {
  __typename?: 'smart_orderEdge';
  cursor: Scalars['String']['output'];
  node: Smart_Order;
};

/** aggregated selection of "smart_order" */
export type Smart_Order_Aggregate = {
  __typename?: 'smart_order_aggregate';
  aggregate?: Maybe<Smart_Order_Aggregate_Fields>;
  nodes: Array<Smart_Order>;
};

/** aggregate fields of "smart_order" */
export type Smart_Order_Aggregate_Fields = {
  __typename?: 'smart_order_aggregate_fields';
  avg?: Maybe<Smart_Order_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Smart_Order_Max_Fields>;
  min?: Maybe<Smart_Order_Min_Fields>;
  stddev?: Maybe<Smart_Order_Stddev_Fields>;
  stddev_pop?: Maybe<Smart_Order_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Smart_Order_Stddev_Samp_Fields>;
  sum?: Maybe<Smart_Order_Sum_Fields>;
  var_pop?: Maybe<Smart_Order_Var_Pop_Fields>;
  var_samp?: Maybe<Smart_Order_Var_Samp_Fields>;
  variance?: Maybe<Smart_Order_Variance_Fields>;
};


/** aggregate fields of "smart_order" */
export type Smart_Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Smart_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "smart_order" */
export type Smart_Order_Aggregate_Order_By = {
  avg?: InputMaybe<Smart_Order_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Smart_Order_Max_Order_By>;
  min?: InputMaybe<Smart_Order_Min_Order_By>;
  stddev?: InputMaybe<Smart_Order_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Smart_Order_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Smart_Order_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Smart_Order_Sum_Order_By>;
  var_pop?: InputMaybe<Smart_Order_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Smart_Order_Var_Samp_Order_By>;
  variance?: InputMaybe<Smart_Order_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Smart_Order_Avg_Fields = {
  __typename?: 'smart_order_avg_fields';
  review_duration_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "smart_order" */
export type Smart_Order_Avg_Order_By = {
  review_duration_seconds?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "smart_order". All fields are combined with a logical 'AND'. */
export type Smart_Order_Bool_Exp = {
  _and?: InputMaybe<Array<Smart_Order_Bool_Exp>>;
  _not?: InputMaybe<Smart_Order_Bool_Exp>;
  _or?: InputMaybe<Array<Smart_Order_Bool_Exp>>;
  assigned_employee?: InputMaybe<Employees_Bool_Exp>;
  assigned_employee_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  attachment_urls?: InputMaybe<_Varchar_Comparison_Exp>;
  attachments?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Employees_Bool_Exp>;
  created_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  email_address?: InputMaybe<String_Comparison_Exp>;
  fulfillment_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fulfillment_type?: InputMaybe<String_Comparison_Exp>;
  is_auto_submitted?: InputMaybe<Boolean_Comparison_Exp>;
  kickback_details?: InputMaybe<_Text_Comparison_Exp>;
  kickback_reason?: InputMaybe<String_Comparison_Exp>;
  last_viewed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  merge_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_notes?: InputMaybe<String_Comparison_Exp>;
  order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  original_fulfillment_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  po_number?: InputMaybe<String_Comparison_Exp>;
  processing_status?: InputMaybe<String_Comparison_Exp>;
  restaurant?: InputMaybe<Businesses_Bool_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  review_duration_seconds?: InputMaybe<Numeric_Comparison_Exp>;
  search_inputs?: InputMaybe<_Jsonb_Comparison_Exp>;
  search_text?: InputMaybe<String_Comparison_Exp>;
  smart_order_results?: InputMaybe<Smart_Order_Result_Bool_Exp>;
  smart_order_search_inputs?: InputMaybe<Smart_Order_Search_Input_Bool_Exp>;
  smart_order_segments?: InputMaybe<Smart_Order_Segment_Bool_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  submit_type?: InputMaybe<String_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  thread_id?: InputMaybe<String_Comparison_Exp>;
  translations?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  voicemail_recording_url?: InputMaybe<String_Comparison_Exp>;
  voicemail_word_timestamps?: InputMaybe<_Jsonb_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "smart_order" */
export type Smart_Order_Inc_Input = {
  review_duration_seconds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Smart_Order_Max_Fields = {
  __typename?: 'smart_order_max_fields';
  assigned_employee_uuid?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_uuid?: Maybe<Scalars['uuid']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  fulfillment_at?: Maybe<Scalars['timestamptz']['output']>;
  fulfillment_type?: Maybe<Scalars['String']['output']>;
  kickback_reason?: Maybe<Scalars['String']['output']>;
  last_viewed_at?: Maybe<Scalars['timestamptz']['output']>;
  merge_uuid?: Maybe<Scalars['uuid']['output']>;
  order_notes?: Maybe<Scalars['String']['output']>;
  order_uuid?: Maybe<Scalars['uuid']['output']>;
  original_fulfillment_at?: Maybe<Scalars['timestamptz']['output']>;
  original_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  po_number?: Maybe<Scalars['String']['output']>;
  processing_status?: Maybe<Scalars['String']['output']>;
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  review_duration_seconds?: Maybe<Scalars['numeric']['output']>;
  search_text?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  submit_type?: Maybe<Scalars['String']['output']>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  thread_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
  voicemail_recording_url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "smart_order" */
export type Smart_Order_Max_Order_By = {
  assigned_employee_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  fulfillment_at?: InputMaybe<Order_By>;
  fulfillment_type?: InputMaybe<Order_By>;
  kickback_reason?: InputMaybe<Order_By>;
  last_viewed_at?: InputMaybe<Order_By>;
  merge_uuid?: InputMaybe<Order_By>;
  order_notes?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  original_fulfillment_at?: InputMaybe<Order_By>;
  original_sent_at?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  po_number?: InputMaybe<Order_By>;
  processing_status?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  review_duration_seconds?: InputMaybe<Order_By>;
  search_text?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  submit_type?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  voicemail_recording_url?: InputMaybe<Order_By>;
};

/** columns and relationships of "smart_order_message_rel" */
export type Smart_Order_Message_Rel = Node & {
  __typename?: 'smart_order_message_rel';
  id: Scalars['ID']['output'];
  message_id: Scalars['String']['output'];
  smart_order_uuid: Scalars['uuid']['output'];
  thread_id: Scalars['String']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "smart_order_message_rel" */
export type Smart_Order_Message_RelConnection = {
  __typename?: 'smart_order_message_relConnection';
  edges: Array<Smart_Order_Message_RelEdge>;
  pageInfo: PageInfo;
};

export type Smart_Order_Message_RelEdge = {
  __typename?: 'smart_order_message_relEdge';
  cursor: Scalars['String']['output'];
  node: Smart_Order_Message_Rel;
};

/** aggregated selection of "smart_order_message_rel" */
export type Smart_Order_Message_Rel_Aggregate = {
  __typename?: 'smart_order_message_rel_aggregate';
  aggregate?: Maybe<Smart_Order_Message_Rel_Aggregate_Fields>;
  nodes: Array<Smart_Order_Message_Rel>;
};

/** aggregate fields of "smart_order_message_rel" */
export type Smart_Order_Message_Rel_Aggregate_Fields = {
  __typename?: 'smart_order_message_rel_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Smart_Order_Message_Rel_Max_Fields>;
  min?: Maybe<Smart_Order_Message_Rel_Min_Fields>;
};


/** aggregate fields of "smart_order_message_rel" */
export type Smart_Order_Message_Rel_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Smart_Order_Message_Rel_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "smart_order_message_rel". All fields are combined with a logical 'AND'. */
export type Smart_Order_Message_Rel_Bool_Exp = {
  _and?: InputMaybe<Array<Smart_Order_Message_Rel_Bool_Exp>>;
  _not?: InputMaybe<Smart_Order_Message_Rel_Bool_Exp>;
  _or?: InputMaybe<Array<Smart_Order_Message_Rel_Bool_Exp>>;
  message_id?: InputMaybe<String_Comparison_Exp>;
  smart_order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  thread_id?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Smart_Order_Message_Rel_Max_Fields = {
  __typename?: 'smart_order_message_rel_max_fields';
  message_id?: Maybe<Scalars['String']['output']>;
  smart_order_uuid?: Maybe<Scalars['uuid']['output']>;
  thread_id?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Smart_Order_Message_Rel_Min_Fields = {
  __typename?: 'smart_order_message_rel_min_fields';
  message_id?: Maybe<Scalars['String']['output']>;
  smart_order_uuid?: Maybe<Scalars['uuid']['output']>;
  thread_id?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "smart_order_message_rel". */
export type Smart_Order_Message_Rel_Order_By = {
  message_id?: InputMaybe<Order_By>;
  smart_order_uuid?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "smart_order_message_rel" */
export enum Smart_Order_Message_Rel_Select_Column {
  /** column name */
  MessageId = 'message_id',
  /** column name */
  SmartOrderUuid = 'smart_order_uuid',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "smart_order_message_rel" */
export type Smart_Order_Message_Rel_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Smart_Order_Message_Rel_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Smart_Order_Message_Rel_Stream_Cursor_Value_Input = {
  message_id?: InputMaybe<Scalars['String']['input']>;
  smart_order_uuid?: InputMaybe<Scalars['uuid']['input']>;
  thread_id?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate min on columns */
export type Smart_Order_Min_Fields = {
  __typename?: 'smart_order_min_fields';
  assigned_employee_uuid?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_uuid?: Maybe<Scalars['uuid']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  fulfillment_at?: Maybe<Scalars['timestamptz']['output']>;
  fulfillment_type?: Maybe<Scalars['String']['output']>;
  kickback_reason?: Maybe<Scalars['String']['output']>;
  last_viewed_at?: Maybe<Scalars['timestamptz']['output']>;
  merge_uuid?: Maybe<Scalars['uuid']['output']>;
  order_notes?: Maybe<Scalars['String']['output']>;
  order_uuid?: Maybe<Scalars['uuid']['output']>;
  original_fulfillment_at?: Maybe<Scalars['timestamptz']['output']>;
  original_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  po_number?: Maybe<Scalars['String']['output']>;
  processing_status?: Maybe<Scalars['String']['output']>;
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  review_duration_seconds?: Maybe<Scalars['numeric']['output']>;
  search_text?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  submit_type?: Maybe<Scalars['String']['output']>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  thread_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
  voicemail_recording_url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "smart_order" */
export type Smart_Order_Min_Order_By = {
  assigned_employee_uuid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  fulfillment_at?: InputMaybe<Order_By>;
  fulfillment_type?: InputMaybe<Order_By>;
  kickback_reason?: InputMaybe<Order_By>;
  last_viewed_at?: InputMaybe<Order_By>;
  merge_uuid?: InputMaybe<Order_By>;
  order_notes?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  original_fulfillment_at?: InputMaybe<Order_By>;
  original_sent_at?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  po_number?: InputMaybe<Order_By>;
  processing_status?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  review_duration_seconds?: InputMaybe<Order_By>;
  search_text?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  submit_type?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  voicemail_recording_url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "smart_order" */
export type Smart_Order_Mutation_Response = {
  __typename?: 'smart_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Smart_Order>;
};

/** Ordering options when selecting data from "smart_order". */
export type Smart_Order_Order_By = {
  assigned_employee?: InputMaybe<Employees_Order_By>;
  assigned_employee_uuid?: InputMaybe<Order_By>;
  attachment_urls?: InputMaybe<Order_By>;
  attachments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Employees_Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  fulfillment_at?: InputMaybe<Order_By>;
  fulfillment_type?: InputMaybe<Order_By>;
  is_auto_submitted?: InputMaybe<Order_By>;
  kickback_details?: InputMaybe<Order_By>;
  kickback_reason?: InputMaybe<Order_By>;
  last_viewed_at?: InputMaybe<Order_By>;
  merge_uuid?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_notes?: InputMaybe<Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  original_fulfillment_at?: InputMaybe<Order_By>;
  original_sent_at?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  po_number?: InputMaybe<Order_By>;
  processing_status?: InputMaybe<Order_By>;
  restaurant?: InputMaybe<Businesses_Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  review_duration_seconds?: InputMaybe<Order_By>;
  search_inputs?: InputMaybe<Order_By>;
  search_text?: InputMaybe<Order_By>;
  smart_order_results_aggregate?: InputMaybe<Smart_Order_Result_Aggregate_Order_By>;
  smart_order_search_inputs_aggregate?: InputMaybe<Smart_Order_Search_Input_Aggregate_Order_By>;
  smart_order_segments_aggregate?: InputMaybe<Smart_Order_Segment_Aggregate_Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  submit_type?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  translations?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  voicemail_recording_url?: InputMaybe<Order_By>;
  voicemail_word_timestamps?: InputMaybe<Order_By>;
};

/** primary key columns input for table: smart_order */
export type Smart_Order_Pk_Columns_Input = {
  uuid: Scalars['uuid']['input'];
};

/** columns and relationships of "smart_order_result" */
export type Smart_Order_Result = Node & {
  __typename?: 'smart_order_result';
  id: Scalars['ID']['output'];
  quantity: Scalars['float8']['output'];
  rank: Scalars['Int']['output'];
  search_term: Scalars['String']['output'];
  smart_order_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
  /** An object relationship */
  variant_pack: Variants_Packs;
  variant_pack_uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "smart_order_result" */
export type Smart_Order_ResultConnection = {
  __typename?: 'smart_order_resultConnection';
  edges: Array<Smart_Order_ResultEdge>;
  pageInfo: PageInfo;
};

export type Smart_Order_ResultEdge = {
  __typename?: 'smart_order_resultEdge';
  cursor: Scalars['String']['output'];
  node: Smart_Order_Result;
};

/** order by aggregate values of table "smart_order_result" */
export type Smart_Order_Result_Aggregate_Order_By = {
  avg?: InputMaybe<Smart_Order_Result_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Smart_Order_Result_Max_Order_By>;
  min?: InputMaybe<Smart_Order_Result_Min_Order_By>;
  stddev?: InputMaybe<Smart_Order_Result_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Smart_Order_Result_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Smart_Order_Result_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Smart_Order_Result_Sum_Order_By>;
  var_pop?: InputMaybe<Smart_Order_Result_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Smart_Order_Result_Var_Samp_Order_By>;
  variance?: InputMaybe<Smart_Order_Result_Variance_Order_By>;
};

/** order by avg() on columns of table "smart_order_result" */
export type Smart_Order_Result_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "smart_order_result". All fields are combined with a logical 'AND'. */
export type Smart_Order_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Smart_Order_Result_Bool_Exp>>;
  _not?: InputMaybe<Smart_Order_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Smart_Order_Result_Bool_Exp>>;
  quantity?: InputMaybe<Float8_Comparison_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
  search_term?: InputMaybe<String_Comparison_Exp>;
  smart_order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack?: InputMaybe<Variants_Packs_Bool_Exp>;
  variant_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "smart_order_result" */
export type Smart_Order_Result_Max_Order_By = {
  quantity?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  search_term?: InputMaybe<Order_By>;
  smart_order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "smart_order_result" */
export type Smart_Order_Result_Min_Order_By = {
  quantity?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  search_term?: InputMaybe<Order_By>;
  smart_order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "smart_order_result". */
export type Smart_Order_Result_Order_By = {
  quantity?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  search_term?: InputMaybe<Order_By>;
  smart_order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack?: InputMaybe<Variants_Packs_Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** select columns of table "smart_order_result" */
export enum Smart_Order_Result_Select_Column {
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Rank = 'rank',
  /** column name */
  SearchTerm = 'search_term',
  /** column name */
  SmartOrderUuid = 'smart_order_uuid',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VariantPackUuid = 'variant_pack_uuid'
}

/** order by stddev() on columns of table "smart_order_result" */
export type Smart_Order_Result_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "smart_order_result" */
export type Smart_Order_Result_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "smart_order_result" */
export type Smart_Order_Result_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "smart_order_result" */
export type Smart_Order_Result_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "smart_order_result" */
export type Smart_Order_Result_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "smart_order_result" */
export type Smart_Order_Result_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "smart_order_result" */
export type Smart_Order_Result_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** columns and relationships of "smart_order_search_input" */
export type Smart_Order_Search_Input = Node & {
  __typename?: 'smart_order_search_input';
  alternative_matches?: Maybe<Scalars['_uuid']['output']>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  intent: Scalars['String']['output'];
  item_notes?: Maybe<Scalars['String']['output']>;
  matched_image_location?: Maybe<Scalars['jsonb']['output']>;
  matched_text?: Maybe<Scalars['String']['output']>;
  original_pack_unit?: Maybe<Scalars['String']['output']>;
  original_quantity?: Maybe<Scalars['float8']['output']>;
  pack_unit?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['float8']['output'];
  requested_item_code?: Maybe<Scalars['String']['output']>;
  requested_item_name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  smart_order: Smart_Order;
  /** An object relationship */
  smart_order_search_term: Smart_Order_Search_Term;
  smart_order_search_term_uuid: Scalars['uuid']['output'];
  smart_order_uuid: Scalars['uuid']['output'];
  translations?: Maybe<Scalars['jsonb']['output']>;
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "smart_order_search_input" */
export type Smart_Order_Search_InputMatched_Image_LocationArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "smart_order_search_input" */
export type Smart_Order_Search_InputTranslationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "smart_order_search_input" */
export type Smart_Order_Search_InputConnection = {
  __typename?: 'smart_order_search_inputConnection';
  edges: Array<Smart_Order_Search_InputEdge>;
  pageInfo: PageInfo;
};

export type Smart_Order_Search_InputEdge = {
  __typename?: 'smart_order_search_inputEdge';
  cursor: Scalars['String']['output'];
  node: Smart_Order_Search_Input;
};

/** order by aggregate values of table "smart_order_search_input" */
export type Smart_Order_Search_Input_Aggregate_Order_By = {
  avg?: InputMaybe<Smart_Order_Search_Input_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Smart_Order_Search_Input_Max_Order_By>;
  min?: InputMaybe<Smart_Order_Search_Input_Min_Order_By>;
  stddev?: InputMaybe<Smart_Order_Search_Input_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Smart_Order_Search_Input_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Smart_Order_Search_Input_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Smart_Order_Search_Input_Sum_Order_By>;
  var_pop?: InputMaybe<Smart_Order_Search_Input_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Smart_Order_Search_Input_Var_Samp_Order_By>;
  variance?: InputMaybe<Smart_Order_Search_Input_Variance_Order_By>;
};

/** order by avg() on columns of table "smart_order_search_input" */
export type Smart_Order_Search_Input_Avg_Order_By = {
  index?: InputMaybe<Order_By>;
  original_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "smart_order_search_input". All fields are combined with a logical 'AND'. */
export type Smart_Order_Search_Input_Bool_Exp = {
  _and?: InputMaybe<Array<Smart_Order_Search_Input_Bool_Exp>>;
  _not?: InputMaybe<Smart_Order_Search_Input_Bool_Exp>;
  _or?: InputMaybe<Array<Smart_Order_Search_Input_Bool_Exp>>;
  alternative_matches?: InputMaybe<_Uuid_Comparison_Exp>;
  index?: InputMaybe<Int_Comparison_Exp>;
  intent?: InputMaybe<String_Comparison_Exp>;
  item_notes?: InputMaybe<String_Comparison_Exp>;
  matched_image_location?: InputMaybe<Jsonb_Comparison_Exp>;
  matched_text?: InputMaybe<String_Comparison_Exp>;
  original_pack_unit?: InputMaybe<String_Comparison_Exp>;
  original_quantity?: InputMaybe<Float8_Comparison_Exp>;
  pack_unit?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Float8_Comparison_Exp>;
  requested_item_code?: InputMaybe<String_Comparison_Exp>;
  requested_item_name?: InputMaybe<String_Comparison_Exp>;
  smart_order?: InputMaybe<Smart_Order_Bool_Exp>;
  smart_order_search_term?: InputMaybe<Smart_Order_Search_Term_Bool_Exp>;
  smart_order_search_term_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  smart_order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  translations?: InputMaybe<Jsonb_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "smart_order_search_input" */
export type Smart_Order_Search_Input_Inc_Input = {
  quantity?: InputMaybe<Scalars['float8']['input']>;
};

/** order by max() on columns of table "smart_order_search_input" */
export type Smart_Order_Search_Input_Max_Order_By = {
  index?: InputMaybe<Order_By>;
  intent?: InputMaybe<Order_By>;
  item_notes?: InputMaybe<Order_By>;
  matched_text?: InputMaybe<Order_By>;
  original_pack_unit?: InputMaybe<Order_By>;
  original_quantity?: InputMaybe<Order_By>;
  pack_unit?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  requested_item_code?: InputMaybe<Order_By>;
  requested_item_name?: InputMaybe<Order_By>;
  smart_order_search_term_uuid?: InputMaybe<Order_By>;
  smart_order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "smart_order_search_input" */
export type Smart_Order_Search_Input_Min_Order_By = {
  index?: InputMaybe<Order_By>;
  intent?: InputMaybe<Order_By>;
  item_notes?: InputMaybe<Order_By>;
  matched_text?: InputMaybe<Order_By>;
  original_pack_unit?: InputMaybe<Order_By>;
  original_quantity?: InputMaybe<Order_By>;
  pack_unit?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  requested_item_code?: InputMaybe<Order_By>;
  requested_item_name?: InputMaybe<Order_By>;
  smart_order_search_term_uuid?: InputMaybe<Order_By>;
  smart_order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "smart_order_search_input" */
export type Smart_Order_Search_Input_Mutation_Response = {
  __typename?: 'smart_order_search_input_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Smart_Order_Search_Input>;
};

/** Ordering options when selecting data from "smart_order_search_input". */
export type Smart_Order_Search_Input_Order_By = {
  alternative_matches?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  intent?: InputMaybe<Order_By>;
  item_notes?: InputMaybe<Order_By>;
  matched_image_location?: InputMaybe<Order_By>;
  matched_text?: InputMaybe<Order_By>;
  original_pack_unit?: InputMaybe<Order_By>;
  original_quantity?: InputMaybe<Order_By>;
  pack_unit?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  requested_item_code?: InputMaybe<Order_By>;
  requested_item_name?: InputMaybe<Order_By>;
  smart_order?: InputMaybe<Smart_Order_Order_By>;
  smart_order_search_term?: InputMaybe<Smart_Order_Search_Term_Order_By>;
  smart_order_search_term_uuid?: InputMaybe<Order_By>;
  smart_order_uuid?: InputMaybe<Order_By>;
  translations?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: smart_order_search_input */
export type Smart_Order_Search_Input_Pk_Columns_Input = {
  uuid: Scalars['uuid']['input'];
};

/** select columns of table "smart_order_search_input" */
export enum Smart_Order_Search_Input_Select_Column {
  /** column name */
  AlternativeMatches = 'alternative_matches',
  /** column name */
  Index = 'index',
  /** column name */
  Intent = 'intent',
  /** column name */
  ItemNotes = 'item_notes',
  /** column name */
  MatchedImageLocation = 'matched_image_location',
  /** column name */
  MatchedText = 'matched_text',
  /** column name */
  OriginalPackUnit = 'original_pack_unit',
  /** column name */
  OriginalQuantity = 'original_quantity',
  /** column name */
  PackUnit = 'pack_unit',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  RequestedItemCode = 'requested_item_code',
  /** column name */
  RequestedItemName = 'requested_item_name',
  /** column name */
  SmartOrderSearchTermUuid = 'smart_order_search_term_uuid',
  /** column name */
  SmartOrderUuid = 'smart_order_uuid',
  /** column name */
  Translations = 'translations',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "smart_order_search_input" */
export type Smart_Order_Search_Input_Set_Input = {
  item_notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['float8']['input']>;
};

/** order by stddev() on columns of table "smart_order_search_input" */
export type Smart_Order_Search_Input_Stddev_Order_By = {
  index?: InputMaybe<Order_By>;
  original_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "smart_order_search_input" */
export type Smart_Order_Search_Input_Stddev_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
  original_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "smart_order_search_input" */
export type Smart_Order_Search_Input_Stddev_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
  original_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "smart_order_search_input" */
export type Smart_Order_Search_Input_Sum_Order_By = {
  index?: InputMaybe<Order_By>;
  original_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

export type Smart_Order_Search_Input_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Smart_Order_Search_Input_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Smart_Order_Search_Input_Set_Input>;
  where: Smart_Order_Search_Input_Bool_Exp;
};

/** order by var_pop() on columns of table "smart_order_search_input" */
export type Smart_Order_Search_Input_Var_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
  original_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "smart_order_search_input" */
export type Smart_Order_Search_Input_Var_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
  original_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "smart_order_search_input" */
export type Smart_Order_Search_Input_Variance_Order_By = {
  index?: InputMaybe<Order_By>;
  original_quantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "smart_order_search_term" */
export type Smart_Order_Search_Term = Node & {
  __typename?: 'smart_order_search_term';
  effective_search_term: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  original_search_term: Scalars['String']['output'];
  restaurant_uuid: Scalars['uuid']['output'];
  /** An array relationship */
  smart_order_search_inputs: Array<Smart_Order_Search_Input>;
  /** An array relationship connection */
  smart_order_search_inputs_connection: Smart_Order_Search_InputConnection;
  status: Scalars['String']['output'];
  supplier_uuid: Scalars['uuid']['output'];
  translations?: Maybe<Scalars['jsonb']['output']>;
  uuid: Scalars['uuid']['output'];
  variant_pack_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  variants_pack?: Maybe<Variants_Packs>;
};


/** columns and relationships of "smart_order_search_term" */
export type Smart_Order_Search_TermSmart_Order_Search_InputsArgs = {
  distinct_on?: InputMaybe<Array<Smart_Order_Search_Input_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Search_Input_Order_By>>;
  where?: InputMaybe<Smart_Order_Search_Input_Bool_Exp>;
};


/** columns and relationships of "smart_order_search_term" */
export type Smart_Order_Search_TermSmart_Order_Search_Inputs_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Smart_Order_Search_Input_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Search_Input_Order_By>>;
  where?: InputMaybe<Smart_Order_Search_Input_Bool_Exp>;
};


/** columns and relationships of "smart_order_search_term" */
export type Smart_Order_Search_TermTranslationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "smart_order_search_term". All fields are combined with a logical 'AND'. */
export type Smart_Order_Search_Term_Bool_Exp = {
  _and?: InputMaybe<Array<Smart_Order_Search_Term_Bool_Exp>>;
  _not?: InputMaybe<Smart_Order_Search_Term_Bool_Exp>;
  _or?: InputMaybe<Array<Smart_Order_Search_Term_Bool_Exp>>;
  effective_search_term?: InputMaybe<String_Comparison_Exp>;
  original_search_term?: InputMaybe<String_Comparison_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  smart_order_search_inputs?: InputMaybe<Smart_Order_Search_Input_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  translations?: InputMaybe<Jsonb_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variants_pack?: InputMaybe<Variants_Packs_Bool_Exp>;
};

/** columns and relationships of "smart_order_search_term_corrections" */
export type Smart_Order_Search_Term_Corrections = Node & {
  __typename?: 'smart_order_search_term_corrections';
  id: Scalars['ID']['output'];
  /** An object relationship */
  new_search_term: Smart_Order_Search_Term;
  new_search_term_uuid: Scalars['uuid']['output'];
  old_search_term_uuid: Scalars['uuid']['output'];
  /** An object relationship */
  smart_order: Smart_Order;
  smart_order_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "smart_order_search_term_corrections" */
export type Smart_Order_Search_Term_CorrectionsConnection = {
  __typename?: 'smart_order_search_term_correctionsConnection';
  edges: Array<Smart_Order_Search_Term_CorrectionsEdge>;
  pageInfo: PageInfo;
};

export type Smart_Order_Search_Term_CorrectionsEdge = {
  __typename?: 'smart_order_search_term_correctionsEdge';
  cursor: Scalars['String']['output'];
  node: Smart_Order_Search_Term_Corrections;
};

/** Boolean expression to filter rows from the table "smart_order_search_term_corrections". All fields are combined with a logical 'AND'. */
export type Smart_Order_Search_Term_Corrections_Bool_Exp = {
  _and?: InputMaybe<Array<Smart_Order_Search_Term_Corrections_Bool_Exp>>;
  _not?: InputMaybe<Smart_Order_Search_Term_Corrections_Bool_Exp>;
  _or?: InputMaybe<Array<Smart_Order_Search_Term_Corrections_Bool_Exp>>;
  new_search_term?: InputMaybe<Smart_Order_Search_Term_Bool_Exp>;
  new_search_term_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  old_search_term_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  smart_order?: InputMaybe<Smart_Order_Bool_Exp>;
  smart_order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "smart_order_search_term_corrections". */
export type Smart_Order_Search_Term_Corrections_Order_By = {
  new_search_term?: InputMaybe<Smart_Order_Search_Term_Order_By>;
  new_search_term_uuid?: InputMaybe<Order_By>;
  old_search_term_uuid?: InputMaybe<Order_By>;
  smart_order?: InputMaybe<Smart_Order_Order_By>;
  smart_order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "smart_order_search_term_corrections" */
export enum Smart_Order_Search_Term_Corrections_Select_Column {
  /** column name */
  NewSearchTermUuid = 'new_search_term_uuid',
  /** column name */
  OldSearchTermUuid = 'old_search_term_uuid',
  /** column name */
  SmartOrderUuid = 'smart_order_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "smart_order_search_term_corrections" */
export type Smart_Order_Search_Term_Corrections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Smart_Order_Search_Term_Corrections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Smart_Order_Search_Term_Corrections_Stream_Cursor_Value_Input = {
  new_search_term_uuid?: InputMaybe<Scalars['uuid']['input']>;
  old_search_term_uuid?: InputMaybe<Scalars['uuid']['input']>;
  smart_order_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** Ordering options when selecting data from "smart_order_search_term". */
export type Smart_Order_Search_Term_Order_By = {
  effective_search_term?: InputMaybe<Order_By>;
  original_search_term?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  smart_order_search_inputs_aggregate?: InputMaybe<Smart_Order_Search_Input_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  translations?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
  variants_pack?: InputMaybe<Variants_Packs_Order_By>;
};

/** columns and relationships of "smart_order_segment" */
export type Smart_Order_Segment = Node & {
  __typename?: 'smart_order_segment';
  attachment_index?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  matched_text?: Maybe<Scalars['String']['output']>;
  smart_order_search_input_uuid?: Maybe<Scalars['uuid']['output']>;
  smart_order_uuid: Scalars['uuid']['output'];
  sort_order: Scalars['Int']['output'];
  start_seconds?: Maybe<Scalars['float8']['output']>;
  translations?: Maybe<Scalars['jsonb']['output']>;
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "smart_order_segment" */
export type Smart_Order_SegmentTranslationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "smart_order_segment" */
export type Smart_Order_SegmentConnection = {
  __typename?: 'smart_order_segmentConnection';
  edges: Array<Smart_Order_SegmentEdge>;
  pageInfo: PageInfo;
};

export type Smart_Order_SegmentEdge = {
  __typename?: 'smart_order_segmentEdge';
  cursor: Scalars['String']['output'];
  node: Smart_Order_Segment;
};

/** order by aggregate values of table "smart_order_segment" */
export type Smart_Order_Segment_Aggregate_Order_By = {
  avg?: InputMaybe<Smart_Order_Segment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Smart_Order_Segment_Max_Order_By>;
  min?: InputMaybe<Smart_Order_Segment_Min_Order_By>;
  stddev?: InputMaybe<Smart_Order_Segment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Smart_Order_Segment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Smart_Order_Segment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Smart_Order_Segment_Sum_Order_By>;
  var_pop?: InputMaybe<Smart_Order_Segment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Smart_Order_Segment_Var_Samp_Order_By>;
  variance?: InputMaybe<Smart_Order_Segment_Variance_Order_By>;
};

/** order by avg() on columns of table "smart_order_segment" */
export type Smart_Order_Segment_Avg_Order_By = {
  attachment_index?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  start_seconds?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "smart_order_segment". All fields are combined with a logical 'AND'. */
export type Smart_Order_Segment_Bool_Exp = {
  _and?: InputMaybe<Array<Smart_Order_Segment_Bool_Exp>>;
  _not?: InputMaybe<Smart_Order_Segment_Bool_Exp>;
  _or?: InputMaybe<Array<Smart_Order_Segment_Bool_Exp>>;
  attachment_index?: InputMaybe<Int_Comparison_Exp>;
  matched_text?: InputMaybe<String_Comparison_Exp>;
  smart_order_search_input_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  smart_order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  sort_order?: InputMaybe<Int_Comparison_Exp>;
  start_seconds?: InputMaybe<Float8_Comparison_Exp>;
  translations?: InputMaybe<Jsonb_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "smart_order_segment" */
export type Smart_Order_Segment_Max_Order_By = {
  attachment_index?: InputMaybe<Order_By>;
  matched_text?: InputMaybe<Order_By>;
  smart_order_search_input_uuid?: InputMaybe<Order_By>;
  smart_order_uuid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  start_seconds?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "smart_order_segment" */
export type Smart_Order_Segment_Min_Order_By = {
  attachment_index?: InputMaybe<Order_By>;
  matched_text?: InputMaybe<Order_By>;
  smart_order_search_input_uuid?: InputMaybe<Order_By>;
  smart_order_uuid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  start_seconds?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "smart_order_segment". */
export type Smart_Order_Segment_Order_By = {
  attachment_index?: InputMaybe<Order_By>;
  matched_text?: InputMaybe<Order_By>;
  smart_order_search_input_uuid?: InputMaybe<Order_By>;
  smart_order_uuid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  start_seconds?: InputMaybe<Order_By>;
  translations?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "smart_order_segment" */
export enum Smart_Order_Segment_Select_Column {
  /** column name */
  AttachmentIndex = 'attachment_index',
  /** column name */
  MatchedText = 'matched_text',
  /** column name */
  SmartOrderSearchInputUuid = 'smart_order_search_input_uuid',
  /** column name */
  SmartOrderUuid = 'smart_order_uuid',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  StartSeconds = 'start_seconds',
  /** column name */
  Translations = 'translations',
  /** column name */
  Uuid = 'uuid'
}

/** order by stddev() on columns of table "smart_order_segment" */
export type Smart_Order_Segment_Stddev_Order_By = {
  attachment_index?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  start_seconds?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "smart_order_segment" */
export type Smart_Order_Segment_Stddev_Pop_Order_By = {
  attachment_index?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  start_seconds?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "smart_order_segment" */
export type Smart_Order_Segment_Stddev_Samp_Order_By = {
  attachment_index?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  start_seconds?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "smart_order_segment" */
export type Smart_Order_Segment_Sum_Order_By = {
  attachment_index?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  start_seconds?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "smart_order_segment" */
export type Smart_Order_Segment_Var_Pop_Order_By = {
  attachment_index?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  start_seconds?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "smart_order_segment" */
export type Smart_Order_Segment_Var_Samp_Order_By = {
  attachment_index?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  start_seconds?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "smart_order_segment" */
export type Smart_Order_Segment_Variance_Order_By = {
  attachment_index?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  start_seconds?: InputMaybe<Order_By>;
};

/** select columns of table "smart_order" */
export enum Smart_Order_Select_Column {
  /** column name */
  AssignedEmployeeUuid = 'assigned_employee_uuid',
  /** column name */
  AttachmentUrls = 'attachment_urls',
  /** column name */
  Attachments = 'attachments',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUuid = 'created_by_uuid',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FulfillmentAt = 'fulfillment_at',
  /** column name */
  FulfillmentType = 'fulfillment_type',
  /** column name */
  IsAutoSubmitted = 'is_auto_submitted',
  /** column name */
  KickbackDetails = 'kickback_details',
  /** column name */
  KickbackReason = 'kickback_reason',
  /** column name */
  LastViewedAt = 'last_viewed_at',
  /** column name */
  MergeUuid = 'merge_uuid',
  /** column name */
  OrderNotes = 'order_notes',
  /** column name */
  OrderUuid = 'order_uuid',
  /** column name */
  OriginalFulfillmentAt = 'original_fulfillment_at',
  /** column name */
  OriginalSentAt = 'original_sent_at',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PoNumber = 'po_number',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  ReviewDurationSeconds = 'review_duration_seconds',
  /** column name */
  SearchInputs = 'search_inputs',
  /** column name */
  SearchText = 'search_text',
  /** column name */
  Source = 'source',
  /** column name */
  Status = 'status',
  /** column name */
  Subject = 'subject',
  /** column name */
  SubmitType = 'submit_type',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  Translations = 'translations',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUuid = 'updated_by_uuid',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VoicemailRecordingUrl = 'voicemail_recording_url',
  /** column name */
  VoicemailWordTimestamps = 'voicemail_word_timestamps'
}

/** input type for updating data in table "smart_order" */
export type Smart_Order_Set_Input = {
  assigned_employee_uuid?: InputMaybe<Scalars['uuid']['input']>;
  fulfillment_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fulfillment_type?: InputMaybe<Scalars['String']['input']>;
  last_viewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  merge_uuid?: InputMaybe<Scalars['uuid']['input']>;
  order_notes?: InputMaybe<Scalars['String']['input']>;
  po_number?: InputMaybe<Scalars['String']['input']>;
  review_duration_seconds?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Smart_Order_Stddev_Fields = {
  __typename?: 'smart_order_stddev_fields';
  review_duration_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "smart_order" */
export type Smart_Order_Stddev_Order_By = {
  review_duration_seconds?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Smart_Order_Stddev_Pop_Fields = {
  __typename?: 'smart_order_stddev_pop_fields';
  review_duration_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "smart_order" */
export type Smart_Order_Stddev_Pop_Order_By = {
  review_duration_seconds?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Smart_Order_Stddev_Samp_Fields = {
  __typename?: 'smart_order_stddev_samp_fields';
  review_duration_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "smart_order" */
export type Smart_Order_Stddev_Samp_Order_By = {
  review_duration_seconds?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "smart_order" */
export type Smart_Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Smart_Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Smart_Order_Stream_Cursor_Value_Input = {
  assigned_employee_uuid?: InputMaybe<Scalars['uuid']['input']>;
  attachment_urls?: InputMaybe<Scalars['_varchar']['input']>;
  attachments?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  fulfillment_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fulfillment_type?: InputMaybe<Scalars['String']['input']>;
  is_auto_submitted?: InputMaybe<Scalars['Boolean']['input']>;
  kickback_details?: InputMaybe<Scalars['_text']['input']>;
  kickback_reason?: InputMaybe<Scalars['String']['input']>;
  last_viewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  merge_uuid?: InputMaybe<Scalars['uuid']['input']>;
  order_notes?: InputMaybe<Scalars['String']['input']>;
  order_uuid?: InputMaybe<Scalars['uuid']['input']>;
  original_fulfillment_at?: InputMaybe<Scalars['timestamptz']['input']>;
  original_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  po_number?: InputMaybe<Scalars['String']['input']>;
  processing_status?: InputMaybe<Scalars['String']['input']>;
  restaurant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  review_duration_seconds?: InputMaybe<Scalars['numeric']['input']>;
  search_inputs?: InputMaybe<Scalars['_jsonb']['input']>;
  search_text?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  submit_type?: InputMaybe<Scalars['String']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  thread_id?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
  voicemail_recording_url?: InputMaybe<Scalars['String']['input']>;
  voicemail_word_timestamps?: InputMaybe<Scalars['_jsonb']['input']>;
};

/** aggregate sum on columns */
export type Smart_Order_Sum_Fields = {
  __typename?: 'smart_order_sum_fields';
  review_duration_seconds?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "smart_order" */
export type Smart_Order_Sum_Order_By = {
  review_duration_seconds?: InputMaybe<Order_By>;
};

export type Smart_Order_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Smart_Order_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Smart_Order_Set_Input>;
  where: Smart_Order_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Smart_Order_Var_Pop_Fields = {
  __typename?: 'smart_order_var_pop_fields';
  review_duration_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "smart_order" */
export type Smart_Order_Var_Pop_Order_By = {
  review_duration_seconds?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Smart_Order_Var_Samp_Fields = {
  __typename?: 'smart_order_var_samp_fields';
  review_duration_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "smart_order" */
export type Smart_Order_Var_Samp_Order_By = {
  review_duration_seconds?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Smart_Order_Variance_Fields = {
  __typename?: 'smart_order_variance_fields';
  review_duration_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "smart_order" */
export type Smart_Order_Variance_Order_By = {
  review_duration_seconds?: InputMaybe<Order_By>;
};

/** columns and relationships of "storefront_order_metadata" */
export type Storefront_Order_Metadata = Node & {
  __typename?: 'storefront_order_metadata';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  order: Orders;
  order_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
  visibility: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "storefront_order_metadata". All fields are combined with a logical 'AND'. */
export type Storefront_Order_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Storefront_Order_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Storefront_Order_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Storefront_Order_Metadata_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  visibility?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "storefront_order_metadata". */
export type Storefront_Order_Metadata_Order_By = {
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "analytics_alerts" */
  analytics_alerts: Array<Analytics_Alerts>;
  /** fetch aggregated fields from the table: "analytics_alerts" */
  analytics_alerts_aggregate: Analytics_Alerts_Aggregate;
  /** fetch data from the table: "analytics_alerts" using primary key columns */
  analytics_alerts_by_pk?: Maybe<Analytics_Alerts>;
  /** fetch data from the table: "analytics_alerts" */
  analytics_alerts_connection: Analytics_AlertsConnection;
  /** fetch data from the table in a streaming manner : "analytics_alerts" */
  analytics_alerts_stream: Array<Analytics_Alerts>;
  /** fetch data from the table: "application_decision_notifications" */
  application_decision_notifications: Array<Application_Decision_Notifications>;
  /** fetch data from the table: "application_decision_notifications" using primary key columns */
  application_decision_notifications_by_pk?: Maybe<Application_Decision_Notifications>;
  /** fetch data from the table: "application_decision_notifications" */
  application_decision_notifications_connection: Application_Decision_NotificationsConnection;
  /** fetch data from the table in a streaming manner : "application_decision_notifications" */
  application_decision_notifications_stream: Array<Application_Decision_Notifications>;
  /** fetch data from the table: "auto_pay_settings" */
  auto_pay_settings: Array<Auto_Pay_Settings>;
  /** fetch data from the table: "auto_pay_settings" using primary key columns */
  auto_pay_settings_by_pk?: Maybe<Auto_Pay_Settings>;
  /** fetch data from the table: "auto_pay_settings" */
  auto_pay_settings_connection: Auto_Pay_SettingsConnection;
  /** fetch data from the table in a streaming manner : "auto_pay_settings" */
  auto_pay_settings_stream: Array<Auto_Pay_Settings>;
  /** fetch data from the table: "brand_page_variant_packs" */
  brand_page_variant_packs: Array<Brand_Page_Variant_Packs>;
  /** fetch data from the table in a streaming manner : "brand_page_variant_packs" */
  brand_page_variant_packs_stream: Array<Brand_Page_Variant_Packs>;
  /** fetch data from the table: "brand_pages" */
  brand_pages: Array<Brand_Pages>;
  /** fetch data from the table: "brand_pages" using primary key columns */
  brand_pages_by_pk?: Maybe<Brand_Pages>;
  /** fetch data from the table: "brand_pages" */
  brand_pages_connection: Brand_PagesConnection;
  /** fetch data from the table in a streaming manner : "brand_pages" */
  brand_pages_stream: Array<Brand_Pages>;
  /** fetch data from the table: "business_organizations" */
  business_organizations: Array<Business_Organizations>;
  /** fetch data from the table: "business_organizations" using primary key columns */
  business_organizations_by_pk?: Maybe<Business_Organizations>;
  /** fetch data from the table: "business_organizations" */
  business_organizations_connection: Business_OrganizationsConnection;
  /** fetch data from the table in a streaming manner : "business_organizations" */
  business_organizations_stream: Array<Business_Organizations>;
  /** An array relationship */
  businesses: Array<Businesses>;
  /** fetch data from the table: "businesses" using primary key columns */
  businesses_by_pk?: Maybe<Businesses>;
  /** An array relationship connection */
  businesses_connection: BusinessesConnection;
  /** fetch data from the table in a streaming manner : "businesses" */
  businesses_stream: Array<Businesses>;
  /** fetch data from the table: "chat_last_message" */
  chat_last_message: Array<Chat_Last_Message>;
  /** fetch data from the table in a streaming manner : "chat_last_message" */
  chat_last_message_stream: Array<Chat_Last_Message>;
  /** fetch data from the table: "chat_unread_message_count" */
  chat_unread_message_count: Array<Chat_Unread_Message_Count>;
  /** fetch data from the table in a streaming manner : "chat_unread_message_count" */
  chat_unread_message_count_stream: Array<Chat_Unread_Message_Count>;
  /** fetch data from the table: "chats" */
  chats: Array<Chats>;
  /** fetch data from the table: "chats" using primary key columns */
  chats_by_pk?: Maybe<Chats>;
  /** fetch data from the table: "chats" */
  chats_connection: ChatsConnection;
  /** fetch data from the table: "chats_route_metadata" */
  chats_route_metadata: Array<Chats_Route_Metadata>;
  /** fetch data from the table: "chats_route_metadata" */
  chats_route_metadata_connection: Chats_Route_MetadataConnection;
  /** fetch data from the table in a streaming manner : "chats_route_metadata" */
  chats_route_metadata_stream: Array<Chats_Route_Metadata>;
  /** fetch data from the table in a streaming manner : "chats" */
  chats_stream: Array<Chats>;
  /** fetch data from the table: "credit_application_consent_acceptances" */
  credit_application_consent_acceptances: Array<Credit_Application_Consent_Acceptances>;
  /** fetch data from the table: "credit_application_consent_acceptances" using primary key columns */
  credit_application_consent_acceptances_by_pk?: Maybe<Credit_Application_Consent_Acceptances>;
  /** fetch data from the table: "credit_application_consent_acceptances" */
  credit_application_consent_acceptances_connection: Credit_Application_Consent_AcceptancesConnection;
  /** fetch data from the table in a streaming manner : "credit_application_consent_acceptances" */
  credit_application_consent_acceptances_stream: Array<Credit_Application_Consent_Acceptances>;
  /** fetch data from the table: "credit_application_form_fields" */
  credit_application_form_fields: Array<Credit_Application_Form_Fields>;
  /** fetch data from the table: "credit_application_form_fields" using primary key columns */
  credit_application_form_fields_by_pk?: Maybe<Credit_Application_Form_Fields>;
  /** fetch data from the table: "credit_application_form_fields" */
  credit_application_form_fields_connection: Credit_Application_Form_FieldsConnection;
  /** fetch data from the table in a streaming manner : "credit_application_form_fields" */
  credit_application_form_fields_stream: Array<Credit_Application_Form_Fields>;
  /** fetch data from the table: "credit_application_form_sections" */
  credit_application_form_sections: Array<Credit_Application_Form_Sections>;
  /** fetch data from the table: "credit_application_form_sections" using primary key columns */
  credit_application_form_sections_by_pk?: Maybe<Credit_Application_Form_Sections>;
  /** fetch data from the table: "credit_application_form_sections" */
  credit_application_form_sections_connection: Credit_Application_Form_SectionsConnection;
  /** fetch data from the table in a streaming manner : "credit_application_form_sections" */
  credit_application_form_sections_stream: Array<Credit_Application_Form_Sections>;
  /** fetch data from the table: "credit_application_form_versions" */
  credit_application_form_versions: Array<Credit_Application_Form_Versions>;
  /** fetch data from the table: "credit_application_form_versions" using primary key columns */
  credit_application_form_versions_by_pk?: Maybe<Credit_Application_Form_Versions>;
  /** fetch data from the table: "credit_application_form_versions" */
  credit_application_form_versions_connection: Credit_Application_Form_VersionsConnection;
  /** fetch data from the table in a streaming manner : "credit_application_form_versions" */
  credit_application_form_versions_stream: Array<Credit_Application_Form_Versions>;
  /** An array relationship */
  credit_application_forms: Array<Credit_Application_Forms>;
  /** fetch data from the table: "credit_application_forms" using primary key columns */
  credit_application_forms_by_pk?: Maybe<Credit_Application_Forms>;
  /** An array relationship connection */
  credit_application_forms_connection: Credit_Application_FormsConnection;
  /** fetch data from the table in a streaming manner : "credit_application_forms" */
  credit_application_forms_stream: Array<Credit_Application_Forms>;
  /** An array relationship */
  credit_applications: Array<Credit_Applications>;
  /** fetch data from the table: "credit_applications" using primary key columns */
  credit_applications_by_pk?: Maybe<Credit_Applications>;
  /** An array relationship connection */
  credit_applications_connection: Credit_ApplicationsConnection;
  /** fetch data from the table in a streaming manner : "credit_applications" */
  credit_applications_stream: Array<Credit_Applications>;
  /** fetch data from the table: "credit_form_version_form_section_rel" */
  credit_form_version_form_section_rel: Array<Credit_Form_Version_Form_Section_Rel>;
  /** fetch data from the table: "credit_form_version_form_section_rel" using primary key columns */
  credit_form_version_form_section_rel_by_pk?: Maybe<Credit_Form_Version_Form_Section_Rel>;
  /** fetch data from the table: "credit_form_version_form_section_rel" */
  credit_form_version_form_section_rel_connection: Credit_Form_Version_Form_Section_RelConnection;
  /** fetch data from the table in a streaming manner : "credit_form_version_form_section_rel" */
  credit_form_version_form_section_rel_stream: Array<Credit_Form_Version_Form_Section_Rel>;
  /** fetch data from the table: "credit_memos" */
  credit_memos: Array<Credit_Memos>;
  /** fetch data from the table: "credit_memos" using primary key columns */
  credit_memos_by_pk?: Maybe<Credit_Memos>;
  /** fetch data from the table: "credit_memos" */
  credit_memos_connection: Credit_MemosConnection;
  /** fetch data from the table in a streaming manner : "credit_memos" */
  credit_memos_stream: Array<Credit_Memos>;
  /** An array relationship */
  credit_request_batch_line_items: Array<Credit_Request_Batch_Line_Items>;
  /** fetch data from the table: "credit_request_batch_line_items" using primary key columns */
  credit_request_batch_line_items_by_pk?: Maybe<Credit_Request_Batch_Line_Items>;
  /** An array relationship connection */
  credit_request_batch_line_items_connection: Credit_Request_Batch_Line_ItemsConnection;
  /** fetch data from the table in a streaming manner : "credit_request_batch_line_items" */
  credit_request_batch_line_items_stream: Array<Credit_Request_Batch_Line_Items>;
  /** An array relationship */
  credit_request_batches: Array<Credit_Request_Batches>;
  /** An aggregate relationship */
  credit_request_batches_aggregate: Credit_Request_Batches_Aggregate;
  /** fetch data from the table: "credit_request_batches" using primary key columns */
  credit_request_batches_by_pk?: Maybe<Credit_Request_Batches>;
  /** An array relationship connection */
  credit_request_batches_connection: Credit_Request_BatchesConnection;
  /** fetch data from the table in a streaming manner : "credit_request_batches" */
  credit_request_batches_stream: Array<Credit_Request_Batches>;
  /** fetch data from the table: "credit_request_reasons" */
  credit_request_reasons: Array<Credit_Request_Reasons>;
  /** fetch data from the table: "credit_request_reasons" using primary key columns */
  credit_request_reasons_by_pk?: Maybe<Credit_Request_Reasons>;
  /** fetch data from the table: "credit_request_reasons" */
  credit_request_reasons_connection: Credit_Request_ReasonsConnection;
  /** fetch data from the table in a streaming manner : "credit_request_reasons" */
  credit_request_reasons_stream: Array<Credit_Request_Reasons>;
  /** fetch data from the table: "crm_activities" */
  crm_activities: Array<Crm_Activities>;
  /** fetch aggregated fields from the table: "crm_activities" */
  crm_activities_aggregate: Crm_Activities_Aggregate;
  /** fetch data from the table: "crm_activities" using primary key columns */
  crm_activities_by_pk?: Maybe<Crm_Activities>;
  /** fetch data from the table: "crm_activities" */
  crm_activities_connection: Crm_ActivitiesConnection;
  /** fetch data from the table in a streaming manner : "crm_activities" */
  crm_activities_stream: Array<Crm_Activities>;
  /** fetch data from the table: "crm_activity_notes" */
  crm_activity_notes: Array<Crm_Activity_Notes>;
  /** fetch data from the table: "crm_activity_notes" using primary key columns */
  crm_activity_notes_by_pk?: Maybe<Crm_Activity_Notes>;
  /** fetch data from the table: "crm_activity_notes" */
  crm_activity_notes_connection: Crm_Activity_NotesConnection;
  /** fetch data from the table in a streaming manner : "crm_activity_notes" */
  crm_activity_notes_stream: Array<Crm_Activity_Notes>;
  /** fetch data from the table: "employee_chats" */
  employee_chats: Array<Employee_Chats>;
  /** fetch data from the table in a streaming manner : "employee_chats" */
  employee_chats_stream: Array<Employee_Chats>;
  /** fetch data from the table: "employee_smart_orders" */
  employee_smart_orders: Array<Employee_Smart_Orders>;
  /** fetch data from the table in a streaming manner : "employee_smart_orders" */
  employee_smart_orders_stream: Array<Employee_Smart_Orders>;
  /** fetch data from the table: "employees" */
  employees: Array<Employees>;
  /** fetch data from the table: "employees" using primary key columns */
  employees_by_pk?: Maybe<Employees>;
  /** fetch data from the table: "employees" */
  employees_connection: EmployeesConnection;
  /** fetch data from the table in a streaming manner : "employees" */
  employees_stream: Array<Employees>;
  /** fetch data from the table: "ghost_agents" */
  ghost_agents: Array<Ghost_Agents>;
  /** fetch data from the table: "ghost_agents" using primary key columns */
  ghost_agents_by_pk?: Maybe<Ghost_Agents>;
  /** fetch data from the table: "ghost_agents" */
  ghost_agents_connection: Ghost_AgentsConnection;
  /** fetch data from the table in a streaming manner : "ghost_agents" */
  ghost_agents_stream: Array<Ghost_Agents>;
  /** fetch data from the table: "ghost_conversations" */
  ghost_conversations: Array<Ghost_Conversations>;
  /** fetch data from the table: "ghost_conversations" using primary key columns */
  ghost_conversations_by_pk?: Maybe<Ghost_Conversations>;
  /** fetch data from the table: "ghost_conversations" */
  ghost_conversations_connection: Ghost_ConversationsConnection;
  /** fetch data from the table in a streaming manner : "ghost_conversations" */
  ghost_conversations_stream: Array<Ghost_Conversations>;
  /** fetch data from the table: "ghost_execution_logs" */
  ghost_execution_logs: Array<Ghost_Execution_Logs>;
  /** fetch data from the table: "ghost_execution_logs" using primary key columns */
  ghost_execution_logs_by_pk?: Maybe<Ghost_Execution_Logs>;
  /** fetch data from the table: "ghost_execution_logs" */
  ghost_execution_logs_connection: Ghost_Execution_LogsConnection;
  /** fetch data from the table in a streaming manner : "ghost_execution_logs" */
  ghost_execution_logs_stream: Array<Ghost_Execution_Logs>;
  /** fetch data from the table: "ghost_messages" */
  ghost_messages: Array<Ghost_Messages>;
  /** fetch data from the table: "ghost_messages" using primary key columns */
  ghost_messages_by_pk?: Maybe<Ghost_Messages>;
  /** fetch data from the table: "ghost_messages" */
  ghost_messages_connection: Ghost_MessagesConnection;
  /** fetch data from the table in a streaming manner : "ghost_messages" */
  ghost_messages_stream: Array<Ghost_Messages>;
  /** fetch data from the table: "gtin_metadata" */
  gtin_metadata: Array<Gtin_Metadata>;
  /** fetch data from the table: "gtin_metadata" using primary key columns */
  gtin_metadata_by_pk?: Maybe<Gtin_Metadata>;
  /** fetch data from the table: "gtin_metadata" */
  gtin_metadata_connection: Gtin_MetadataConnection;
  /** fetch data from the table in a streaming manner : "gtin_metadata" */
  gtin_metadata_stream: Array<Gtin_Metadata>;
  /** fetch data from the table: "hub_last_visited" */
  hub_last_visited: Array<Hub_Last_Visited>;
  /** fetch data from the table: "hub_last_visited" using primary key columns */
  hub_last_visited_by_pk?: Maybe<Hub_Last_Visited>;
  /** fetch data from the table: "hub_last_visited" */
  hub_last_visited_connection: Hub_Last_VisitedConnection;
  /** fetch data from the table in a streaming manner : "hub_last_visited" */
  hub_last_visited_stream: Array<Hub_Last_Visited>;
  /** An array relationship */
  menu_item_ingredients: Array<Menu_Item_Ingredients>;
  /** fetch data from the table: "menu_item_ingredients" using primary key columns */
  menu_item_ingredients_by_pk?: Maybe<Menu_Item_Ingredients>;
  /** An array relationship connection */
  menu_item_ingredients_connection: Menu_Item_IngredientsConnection;
  /** fetch data from the table in a streaming manner : "menu_item_ingredients" */
  menu_item_ingredients_stream: Array<Menu_Item_Ingredients>;
  /** fetch data from the table: "menu_items" */
  menu_items: Array<Menu_Items>;
  /** fetch data from the table: "menu_items" using primary key columns */
  menu_items_by_pk?: Maybe<Menu_Items>;
  /** fetch data from the table: "menu_items" */
  menu_items_connection: Menu_ItemsConnection;
  /** fetch data from the table in a streaming manner : "menu_items" */
  menu_items_stream: Array<Menu_Items>;
  /** An array relationship */
  messages: Array<Messages>;
  /** fetch data from the table: "messages" using primary key columns */
  messages_by_pk?: Maybe<Messages>;
  /** An array relationship connection */
  messages_connection: MessagesConnection;
  /** fetch data from the table in a streaming manner : "messages" */
  messages_stream: Array<Messages>;
  /** fetch data from the table: "mobile_payment_terminals" */
  mobile_payment_terminals: Array<Mobile_Payment_Terminals>;
  /** fetch data from the table: "mobile_payment_terminals" using primary key columns */
  mobile_payment_terminals_by_pk?: Maybe<Mobile_Payment_Terminals>;
  /** fetch data from the table: "mobile_payment_terminals" */
  mobile_payment_terminals_connection: Mobile_Payment_TerminalsConnection;
  /** fetch data from the table in a streaming manner : "mobile_payment_terminals" */
  mobile_payment_terminals_stream: Array<Mobile_Payment_Terminals>;
  node?: Maybe<Node>;
  /** fetch data from the table: "order_guide" */
  order_guide: Array<Order_Guide>;
  /** fetch data from the table: "order_guide" using primary key columns */
  order_guide_by_pk?: Maybe<Order_Guide>;
  /** fetch data from the table: "order_guide" */
  order_guide_connection: Order_GuideConnection;
  /** fetch data from the table: "order_guide_restaurant_collection" */
  order_guide_restaurant_collection: Array<Order_Guide_Restaurant_Collection>;
  /** fetch data from the table: "order_guide_restaurant_collection" using primary key columns */
  order_guide_restaurant_collection_by_pk?: Maybe<Order_Guide_Restaurant_Collection>;
  /** fetch data from the table: "order_guide_restaurant_collection" */
  order_guide_restaurant_collection_connection: Order_Guide_Restaurant_CollectionConnection;
  /** fetch data from the table in a streaming manner : "order_guide_restaurant_collection" */
  order_guide_restaurant_collection_stream: Array<Order_Guide_Restaurant_Collection>;
  /** fetch data from the table in a streaming manner : "order_guide" */
  order_guide_stream: Array<Order_Guide>;
  /** fetch data from the table: "order_guide_supplier_collection" */
  order_guide_supplier_collection: Array<Order_Guide_Supplier_Collection>;
  /** fetch data from the table: "order_guide_supplier_collection" using primary key columns */
  order_guide_supplier_collection_by_pk?: Maybe<Order_Guide_Supplier_Collection>;
  /** fetch data from the table: "order_guide_supplier_collection" */
  order_guide_supplier_collection_connection: Order_Guide_Supplier_CollectionConnection;
  /** fetch data from the table in a streaming manner : "order_guide_supplier_collection" */
  order_guide_supplier_collection_stream: Array<Order_Guide_Supplier_Collection>;
  /** An array relationship */
  order_invoice_check_in_item_issues: Array<Order_Invoice_Check_In_Item_Issues>;
  /** fetch data from the table: "order_invoice_check_in_item_issues" using primary key columns */
  order_invoice_check_in_item_issues_by_pk?: Maybe<Order_Invoice_Check_In_Item_Issues>;
  /** An array relationship connection */
  order_invoice_check_in_item_issues_connection: Order_Invoice_Check_In_Item_IssuesConnection;
  /** fetch data from the table in a streaming manner : "order_invoice_check_in_item_issues" */
  order_invoice_check_in_item_issues_stream: Array<Order_Invoice_Check_In_Item_Issues>;
  /** An array relationship */
  order_invoice_check_in_items: Array<Order_Invoice_Check_In_Items>;
  /** fetch data from the table: "order_invoice_check_in_items" using primary key columns */
  order_invoice_check_in_items_by_pk?: Maybe<Order_Invoice_Check_In_Items>;
  /** An array relationship connection */
  order_invoice_check_in_items_connection: Order_Invoice_Check_In_ItemsConnection;
  /** fetch data from the table in a streaming manner : "order_invoice_check_in_items" */
  order_invoice_check_in_items_stream: Array<Order_Invoice_Check_In_Items>;
  /** fetch data from the table: "order_invoice_check_ins" */
  order_invoice_check_ins: Array<Order_Invoice_Check_Ins>;
  /** fetch data from the table: "order_invoice_check_ins" using primary key columns */
  order_invoice_check_ins_by_pk?: Maybe<Order_Invoice_Check_Ins>;
  /** fetch data from the table: "order_invoice_check_ins" */
  order_invoice_check_ins_connection: Order_Invoice_Check_InsConnection;
  /** fetch data from the table in a streaming manner : "order_invoice_check_ins" */
  order_invoice_check_ins_stream: Array<Order_Invoice_Check_Ins>;
  /** An array relationship */
  order_invoices: Array<Order_Invoices>;
  /** An aggregate relationship */
  order_invoices_aggregate: Order_Invoices_Aggregate;
  /** fetch data from the table: "order_invoices" using primary key columns */
  order_invoices_by_pk?: Maybe<Order_Invoices>;
  /** An array relationship connection */
  order_invoices_connection: Order_InvoicesConnection;
  /** fetch data from the table in a streaming manner : "order_invoices" */
  order_invoices_stream: Array<Order_Invoices>;
  /** An array relationship */
  orders: Array<Orders>;
  /** An aggregate relationship */
  orders_aggregate: Orders_Aggregate;
  /** fetch data from the table: "orders" using primary key columns */
  orders_by_pk?: Maybe<Orders>;
  /** An array relationship connection */
  orders_connection: OrdersConnection;
  /** An array relationship */
  orders_items: Array<Orders_Items>;
  /** An aggregate relationship */
  orders_items_aggregate: Orders_Items_Aggregate;
  /** fetch data from the table: "orders_items" using primary key columns */
  orders_items_by_pk?: Maybe<Orders_Items>;
  /** An array relationship connection */
  orders_items_connection: Orders_ItemsConnection;
  /** fetch data from the table in a streaming manner : "orders_items" */
  orders_items_stream: Array<Orders_Items>;
  /** fetch data from the table in a streaming manner : "orders" */
  orders_stream: Array<Orders>;
  /** fetch data from the table: "pad_payment_method" */
  pad_payment_method: Array<Pad_Payment_Method>;
  /** fetch data from the table: "pad_payment_method" using primary key columns */
  pad_payment_method_by_pk?: Maybe<Pad_Payment_Method>;
  /** fetch data from the table: "pad_payment_method" */
  pad_payment_method_connection: Pad_Payment_MethodConnection;
  /** fetch data from the table in a streaming manner : "pad_payment_method" */
  pad_payment_method_stream: Array<Pad_Payment_Method>;
  /** fetch data from the table: "payment_batches" */
  payment_batches: Array<Payment_Batches>;
  /** fetch aggregated fields from the table: "payment_batches" */
  payment_batches_aggregate: Payment_Batches_Aggregate;
  /** fetch data from the table: "payment_batches" using primary key columns */
  payment_batches_by_pk?: Maybe<Payment_Batches>;
  /** fetch data from the table: "payment_batches" */
  payment_batches_connection: Payment_BatchesConnection;
  /** fetch data from the table in a streaming manner : "payment_batches" */
  payment_batches_stream: Array<Payment_Batches>;
  /** fetch data from the table: "payment_links" */
  payment_links: Array<Payment_Links>;
  /** fetch data from the table: "payment_links" */
  payment_links_connection: Payment_LinksConnection;
  /** fetch data from the table in a streaming manner : "payment_links" */
  payment_links_stream: Array<Payment_Links>;
  /** fetch data from the table: "payment_methods" */
  payment_methods: Array<Payment_Methods>;
  /** fetch data from the table: "payment_methods" using primary key columns */
  payment_methods_by_pk?: Maybe<Payment_Methods>;
  /** fetch data from the table: "payment_methods" */
  payment_methods_connection: Payment_MethodsConnection;
  /** fetch data from the table in a streaming manner : "payment_methods" */
  payment_methods_stream: Array<Payment_Methods>;
  /** fetch data from the table: "planograms" */
  planograms: Array<Planograms>;
  /** fetch data from the table: "planograms" using primary key columns */
  planograms_by_pk?: Maybe<Planograms>;
  /** fetch data from the table: "planograms" */
  planograms_connection: PlanogramsConnection;
  /** fetch data from the table in a streaming manner : "planograms" */
  planograms_stream: Array<Planograms>;
  /** fetch data from the table: "pricing_price_draft_update_batches" */
  pricing_price_draft_update_batches: Array<Pricing_Price_Draft_Update_Batches>;
  /** fetch data from the table: "pricing_price_draft_update_batches" using primary key columns */
  pricing_price_draft_update_batches_by_pk?: Maybe<Pricing_Price_Draft_Update_Batches>;
  /** fetch data from the table: "pricing_price_draft_update_batches" */
  pricing_price_draft_update_batches_connection: Pricing_Price_Draft_Update_BatchesConnection;
  /** fetch data from the table in a streaming manner : "pricing_price_draft_update_batches" */
  pricing_price_draft_update_batches_stream: Array<Pricing_Price_Draft_Update_Batches>;
  /** fetch data from the table: "pricing_task_runs" */
  pricing_task_runs: Array<Pricing_Task_Runs>;
  /** fetch aggregated fields from the table: "pricing_task_runs" */
  pricing_task_runs_aggregate: Pricing_Task_Runs_Aggregate;
  /** fetch data from the table: "pricing_task_runs" using primary key columns */
  pricing_task_runs_by_pk?: Maybe<Pricing_Task_Runs>;
  /** fetch data from the table: "pricing_task_runs" */
  pricing_task_runs_connection: Pricing_Task_RunsConnection;
  /** fetch data from the table in a streaming manner : "pricing_task_runs" */
  pricing_task_runs_stream: Array<Pricing_Task_Runs>;
  /** fetch data from the table: "print_tag_batches" */
  print_tag_batches: Array<Print_Tag_Batches>;
  /** fetch data from the table: "print_tag_batches" using primary key columns */
  print_tag_batches_by_pk?: Maybe<Print_Tag_Batches>;
  /** fetch data from the table: "print_tag_batches" */
  print_tag_batches_connection: Print_Tag_BatchesConnection;
  /** fetch data from the table in a streaming manner : "print_tag_batches" */
  print_tag_batches_stream: Array<Print_Tag_Batches>;
  /** fetch data from the table: "print_tag_template_assignments" */
  print_tag_template_assignments: Array<Print_Tag_Template_Assignments>;
  /** fetch data from the table: "print_tag_template_assignments" using primary key columns */
  print_tag_template_assignments_by_pk?: Maybe<Print_Tag_Template_Assignments>;
  /** fetch data from the table: "print_tag_template_assignments" */
  print_tag_template_assignments_connection: Print_Tag_Template_AssignmentsConnection;
  /** fetch data from the table in a streaming manner : "print_tag_template_assignments" */
  print_tag_template_assignments_stream: Array<Print_Tag_Template_Assignments>;
  /** fetch data from the table: "print_tag_templates" */
  print_tag_templates: Array<Print_Tag_Templates>;
  /** fetch data from the table: "print_tag_templates" using primary key columns */
  print_tag_templates_by_pk?: Maybe<Print_Tag_Templates>;
  /** fetch data from the table: "print_tag_templates" */
  print_tag_templates_connection: Print_Tag_TemplatesConnection;
  /** fetch data from the table in a streaming manner : "print_tag_templates" */
  print_tag_templates_stream: Array<Print_Tag_Templates>;
  /** fetch data from the table: "promotion_component_groups" */
  promotion_component_groups: Array<Promotion_Component_Groups>;
  /** fetch data from the table: "promotion_component_groups" */
  promotion_component_groups_connection: Promotion_Component_GroupsConnection;
  /** fetch data from the table in a streaming manner : "promotion_component_groups" */
  promotion_component_groups_stream: Array<Promotion_Component_Groups>;
  /** fetch data from the table: "restaurant_groups" */
  restaurant_groups: Array<Restaurant_Groups>;
  /** fetch data from the table: "restaurant_groups" using primary key columns */
  restaurant_groups_by_pk?: Maybe<Restaurant_Groups>;
  /** fetch data from the table: "restaurant_groups" */
  restaurant_groups_connection: Restaurant_GroupsConnection;
  /** fetch data from the table in a streaming manner : "restaurant_groups" */
  restaurant_groups_stream: Array<Restaurant_Groups>;
  /** fetch data from the table: "sales_rep_chat_relations" */
  sales_rep_chat_relations: Array<Sales_Rep_Chat_Relations>;
  /** fetch data from the table: "sales_rep_chat_relations" using primary key columns */
  sales_rep_chat_relations_by_pk?: Maybe<Sales_Rep_Chat_Relations>;
  /** fetch data from the table: "sales_rep_chat_relations" */
  sales_rep_chat_relations_connection: Sales_Rep_Chat_RelationsConnection;
  /** fetch data from the table in a streaming manner : "sales_rep_chat_relations" */
  sales_rep_chat_relations_stream: Array<Sales_Rep_Chat_Relations>;
  /** fetch data from the table: "smart_order" */
  smart_order: Array<Smart_Order>;
  /** fetch aggregated fields from the table: "smart_order" */
  smart_order_aggregate: Smart_Order_Aggregate;
  /** fetch data from the table: "smart_order" using primary key columns */
  smart_order_by_pk?: Maybe<Smart_Order>;
  /** fetch data from the table: "smart_order" */
  smart_order_connection: Smart_OrderConnection;
  /** fetch data from the table: "smart_order_message_rel" */
  smart_order_message_rel: Array<Smart_Order_Message_Rel>;
  /** fetch aggregated fields from the table: "smart_order_message_rel" */
  smart_order_message_rel_aggregate: Smart_Order_Message_Rel_Aggregate;
  /** fetch data from the table: "smart_order_message_rel" using primary key columns */
  smart_order_message_rel_by_pk?: Maybe<Smart_Order_Message_Rel>;
  /** fetch data from the table: "smart_order_message_rel" */
  smart_order_message_rel_connection: Smart_Order_Message_RelConnection;
  /** fetch data from the table in a streaming manner : "smart_order_message_rel" */
  smart_order_message_rel_stream: Array<Smart_Order_Message_Rel>;
  /** fetch data from the table: "smart_order_search_term_corrections" */
  smart_order_search_term_corrections: Array<Smart_Order_Search_Term_Corrections>;
  /** fetch data from the table: "smart_order_search_term_corrections" using primary key columns */
  smart_order_search_term_corrections_by_pk?: Maybe<Smart_Order_Search_Term_Corrections>;
  /** fetch data from the table: "smart_order_search_term_corrections" */
  smart_order_search_term_corrections_connection: Smart_Order_Search_Term_CorrectionsConnection;
  /** fetch data from the table in a streaming manner : "smart_order_search_term_corrections" */
  smart_order_search_term_corrections_stream: Array<Smart_Order_Search_Term_Corrections>;
  /** fetch data from the table in a streaming manner : "smart_order" */
  smart_order_stream: Array<Smart_Order>;
  /** fetch data from the table: "supplier_payments_status" */
  supplier_payments_status: Array<Supplier_Payments_Status>;
  /** fetch data from the table in a streaming manner : "supplier_payments_status" */
  supplier_payments_status_stream: Array<Supplier_Payments_Status>;
  /** fetch data from the table: "task_frequency_settings" */
  task_frequency_settings: Array<Task_Frequency_Settings>;
  /** fetch data from the table: "task_frequency_settings" */
  task_frequency_settings_connection: Task_Frequency_SettingsConnection;
  /** fetch data from the table in a streaming manner : "task_frequency_settings" */
  task_frequency_settings_stream: Array<Task_Frequency_Settings>;
  /** fetch data from the table: "variant_pack_groups" */
  variant_pack_groups: Array<Variant_Pack_Groups>;
  /** fetch data from the table: "variant_pack_groups" using primary key columns */
  variant_pack_groups_by_pk?: Maybe<Variant_Pack_Groups>;
  /** fetch data from the table: "variant_pack_groups" */
  variant_pack_groups_connection: Variant_Pack_GroupsConnection;
  /** fetch data from the table in a streaming manner : "variant_pack_groups" */
  variant_pack_groups_stream: Array<Variant_Pack_Groups>;
  /** fetch data from the table: "variants_packs" */
  variants_packs: Array<Variants_Packs>;
  /** fetch aggregated fields from the table: "variants_packs" */
  variants_packs_aggregate: Variants_Packs_Aggregate;
  /** fetch data from the table: "variants_packs" using primary key columns */
  variants_packs_by_pk?: Maybe<Variants_Packs>;
  /** fetch data from the table: "variants_packs" */
  variants_packs_connection: Variants_PacksConnection;
  /** fetch data from the table in a streaming manner : "variants_packs" */
  variants_packs_stream: Array<Variants_Packs>;
  /** fetch data from the table: "variants_packs_substitution_suppliers" */
  variants_packs_substitution_suppliers: Array<Variants_Packs_Substitution_Suppliers>;
  /** fetch data from the table: "variants_packs_substitution_suppliers" using primary key columns */
  variants_packs_substitution_suppliers_by_pk?: Maybe<Variants_Packs_Substitution_Suppliers>;
  /** fetch data from the table: "variants_packs_substitution_suppliers" */
  variants_packs_substitution_suppliers_connection: Variants_Packs_Substitution_SuppliersConnection;
  /** fetch data from the table in a streaming manner : "variants_packs_substitution_suppliers" */
  variants_packs_substitution_suppliers_stream: Array<Variants_Packs_Substitution_Suppliers>;
  /** fetch data from the table: "visible_variant_packs" */
  visible_variant_packs: Array<Visible_Variant_Packs>;
  /** fetch aggregated fields from the table: "visible_variant_packs" */
  visible_variant_packs_aggregate: Visible_Variant_Packs_Aggregate;
  /** fetch data from the table in a streaming manner : "visible_variant_packs" */
  visible_variant_packs_stream: Array<Visible_Variant_Packs>;
  /** An array relationship */
  whitelabel_config: Array<Whitelabel_Config>;
  /** fetch data from the table: "whitelabel_config" using primary key columns */
  whitelabel_config_by_pk?: Maybe<Whitelabel_Config>;
  /** An array relationship connection */
  whitelabel_config_connection: Whitelabel_ConfigConnection;
  /** fetch data from the table in a streaming manner : "whitelabel_config" */
  whitelabel_config_stream: Array<Whitelabel_Config>;
};


export type Subscription_RootAnalytics_AlertsArgs = {
  distinct_on?: InputMaybe<Array<Analytics_Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Analytics_Alerts_Order_By>>;
  where?: InputMaybe<Analytics_Alerts_Bool_Exp>;
};


export type Subscription_RootAnalytics_Alerts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Analytics_Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Analytics_Alerts_Order_By>>;
  where?: InputMaybe<Analytics_Alerts_Bool_Exp>;
};


export type Subscription_RootAnalytics_Alerts_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootAnalytics_Alerts_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Analytics_Alerts_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Analytics_Alerts_Order_By>>;
  where?: InputMaybe<Analytics_Alerts_Bool_Exp>;
};


export type Subscription_RootAnalytics_Alerts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Analytics_Alerts_Stream_Cursor_Input>>;
  where?: InputMaybe<Analytics_Alerts_Bool_Exp>;
};


export type Subscription_RootApplication_Decision_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Application_Decision_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Decision_Notifications_Order_By>>;
  where?: InputMaybe<Application_Decision_Notifications_Bool_Exp>;
};


export type Subscription_RootApplication_Decision_Notifications_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootApplication_Decision_Notifications_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Application_Decision_Notifications_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Decision_Notifications_Order_By>>;
  where?: InputMaybe<Application_Decision_Notifications_Bool_Exp>;
};


export type Subscription_RootApplication_Decision_Notifications_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Application_Decision_Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Application_Decision_Notifications_Bool_Exp>;
};


export type Subscription_RootAuto_Pay_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Auto_Pay_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auto_Pay_Settings_Order_By>>;
  where?: InputMaybe<Auto_Pay_Settings_Bool_Exp>;
};


export type Subscription_RootAuto_Pay_Settings_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootAuto_Pay_Settings_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Auto_Pay_Settings_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auto_Pay_Settings_Order_By>>;
  where?: InputMaybe<Auto_Pay_Settings_Bool_Exp>;
};


export type Subscription_RootAuto_Pay_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auto_Pay_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Auto_Pay_Settings_Bool_Exp>;
};


export type Subscription_RootBrand_Page_Variant_PacksArgs = {
  distinct_on?: InputMaybe<Array<Brand_Page_Variant_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Page_Variant_Packs_Order_By>>;
  where?: InputMaybe<Brand_Page_Variant_Packs_Bool_Exp>;
};


export type Subscription_RootBrand_Page_Variant_Packs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Brand_Page_Variant_Packs_Stream_Cursor_Input>>;
  where?: InputMaybe<Brand_Page_Variant_Packs_Bool_Exp>;
};


export type Subscription_RootBrand_PagesArgs = {
  distinct_on?: InputMaybe<Array<Brand_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Pages_Order_By>>;
  where?: InputMaybe<Brand_Pages_Bool_Exp>;
};


export type Subscription_RootBrand_Pages_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootBrand_Pages_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Brand_Pages_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Pages_Order_By>>;
  where?: InputMaybe<Brand_Pages_Bool_Exp>;
};


export type Subscription_RootBrand_Pages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Brand_Pages_Stream_Cursor_Input>>;
  where?: InputMaybe<Brand_Pages_Bool_Exp>;
};


export type Subscription_RootBusiness_OrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Business_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Business_Organizations_Order_By>>;
  where?: InputMaybe<Business_Organizations_Bool_Exp>;
};


export type Subscription_RootBusiness_Organizations_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootBusiness_Organizations_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Business_Organizations_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Business_Organizations_Order_By>>;
  where?: InputMaybe<Business_Organizations_Bool_Exp>;
};


export type Subscription_RootBusiness_Organizations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Business_Organizations_Stream_Cursor_Input>>;
  where?: InputMaybe<Business_Organizations_Bool_Exp>;
};


export type Subscription_RootBusinessesArgs = {
  distinct_on?: InputMaybe<Array<Businesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Businesses_Order_By>>;
  where?: InputMaybe<Businesses_Bool_Exp>;
};


export type Subscription_RootBusinesses_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootBusinesses_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Businesses_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Businesses_Order_By>>;
  where?: InputMaybe<Businesses_Bool_Exp>;
};


export type Subscription_RootBusinesses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Businesses_Stream_Cursor_Input>>;
  where?: InputMaybe<Businesses_Bool_Exp>;
};


export type Subscription_RootChat_Last_MessageArgs = {
  distinct_on?: InputMaybe<Array<Chat_Last_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Last_Message_Order_By>>;
  where?: InputMaybe<Chat_Last_Message_Bool_Exp>;
};


export type Subscription_RootChat_Last_Message_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chat_Last_Message_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Last_Message_Bool_Exp>;
};


export type Subscription_RootChat_Unread_Message_CountArgs = {
  distinct_on?: InputMaybe<Array<Chat_Unread_Message_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Unread_Message_Count_Order_By>>;
  where?: InputMaybe<Chat_Unread_Message_Count_Bool_Exp>;
};


export type Subscription_RootChat_Unread_Message_Count_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chat_Unread_Message_Count_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Unread_Message_Count_Bool_Exp>;
};


export type Subscription_RootChatsArgs = {
  distinct_on?: InputMaybe<Array<Chats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Order_By>>;
  where?: InputMaybe<Chats_Bool_Exp>;
};


export type Subscription_RootChats_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootChats_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Chats_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Order_By>>;
  where?: InputMaybe<Chats_Bool_Exp>;
};


export type Subscription_RootChats_Route_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Chats_Route_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Route_Metadata_Order_By>>;
  where?: InputMaybe<Chats_Route_Metadata_Bool_Exp>;
};


export type Subscription_RootChats_Route_Metadata_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Chats_Route_Metadata_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chats_Route_Metadata_Order_By>>;
  where?: InputMaybe<Chats_Route_Metadata_Bool_Exp>;
};


export type Subscription_RootChats_Route_Metadata_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chats_Route_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Chats_Route_Metadata_Bool_Exp>;
};


export type Subscription_RootChats_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chats_Stream_Cursor_Input>>;
  where?: InputMaybe<Chats_Bool_Exp>;
};


export type Subscription_RootCredit_Application_Consent_AcceptancesArgs = {
  distinct_on?: InputMaybe<Array<Credit_Application_Consent_Acceptances_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Consent_Acceptances_Order_By>>;
  where?: InputMaybe<Credit_Application_Consent_Acceptances_Bool_Exp>;
};


export type Subscription_RootCredit_Application_Consent_Acceptances_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootCredit_Application_Consent_Acceptances_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Application_Consent_Acceptances_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Consent_Acceptances_Order_By>>;
  where?: InputMaybe<Credit_Application_Consent_Acceptances_Bool_Exp>;
};


export type Subscription_RootCredit_Application_Consent_Acceptances_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Credit_Application_Consent_Acceptances_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Application_Consent_Acceptances_Bool_Exp>;
};


export type Subscription_RootCredit_Application_Form_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Application_Form_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Form_Fields_Order_By>>;
  where?: InputMaybe<Credit_Application_Form_Fields_Bool_Exp>;
};


export type Subscription_RootCredit_Application_Form_Fields_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootCredit_Application_Form_Fields_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Application_Form_Fields_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Form_Fields_Order_By>>;
  where?: InputMaybe<Credit_Application_Form_Fields_Bool_Exp>;
};


export type Subscription_RootCredit_Application_Form_Fields_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Credit_Application_Form_Fields_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Application_Form_Fields_Bool_Exp>;
};


export type Subscription_RootCredit_Application_Form_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Application_Form_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Form_Sections_Order_By>>;
  where?: InputMaybe<Credit_Application_Form_Sections_Bool_Exp>;
};


export type Subscription_RootCredit_Application_Form_Sections_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootCredit_Application_Form_Sections_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Application_Form_Sections_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Form_Sections_Order_By>>;
  where?: InputMaybe<Credit_Application_Form_Sections_Bool_Exp>;
};


export type Subscription_RootCredit_Application_Form_Sections_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Credit_Application_Form_Sections_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Application_Form_Sections_Bool_Exp>;
};


export type Subscription_RootCredit_Application_Form_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Application_Form_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Form_Versions_Order_By>>;
  where?: InputMaybe<Credit_Application_Form_Versions_Bool_Exp>;
};


export type Subscription_RootCredit_Application_Form_Versions_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootCredit_Application_Form_Versions_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Application_Form_Versions_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Form_Versions_Order_By>>;
  where?: InputMaybe<Credit_Application_Form_Versions_Bool_Exp>;
};


export type Subscription_RootCredit_Application_Form_Versions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Credit_Application_Form_Versions_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Application_Form_Versions_Bool_Exp>;
};


export type Subscription_RootCredit_Application_FormsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Application_Forms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Forms_Order_By>>;
  where?: InputMaybe<Credit_Application_Forms_Bool_Exp>;
};


export type Subscription_RootCredit_Application_Forms_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootCredit_Application_Forms_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Application_Forms_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Application_Forms_Order_By>>;
  where?: InputMaybe<Credit_Application_Forms_Bool_Exp>;
};


export type Subscription_RootCredit_Application_Forms_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Credit_Application_Forms_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Application_Forms_Bool_Exp>;
};


export type Subscription_RootCredit_ApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Applications_Order_By>>;
  where?: InputMaybe<Credit_Applications_Bool_Exp>;
};


export type Subscription_RootCredit_Applications_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootCredit_Applications_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Applications_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Applications_Order_By>>;
  where?: InputMaybe<Credit_Applications_Bool_Exp>;
};


export type Subscription_RootCredit_Applications_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Credit_Applications_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Applications_Bool_Exp>;
};


export type Subscription_RootCredit_Form_Version_Form_Section_RelArgs = {
  distinct_on?: InputMaybe<Array<Credit_Form_Version_Form_Section_Rel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Form_Version_Form_Section_Rel_Order_By>>;
  where?: InputMaybe<Credit_Form_Version_Form_Section_Rel_Bool_Exp>;
};


export type Subscription_RootCredit_Form_Version_Form_Section_Rel_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootCredit_Form_Version_Form_Section_Rel_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Form_Version_Form_Section_Rel_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Form_Version_Form_Section_Rel_Order_By>>;
  where?: InputMaybe<Credit_Form_Version_Form_Section_Rel_Bool_Exp>;
};


export type Subscription_RootCredit_Form_Version_Form_Section_Rel_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Credit_Form_Version_Form_Section_Rel_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Form_Version_Form_Section_Rel_Bool_Exp>;
};


export type Subscription_RootCredit_MemosArgs = {
  distinct_on?: InputMaybe<Array<Credit_Memos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Memos_Order_By>>;
  where?: InputMaybe<Credit_Memos_Bool_Exp>;
};


export type Subscription_RootCredit_Memos_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootCredit_Memos_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Memos_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Memos_Order_By>>;
  where?: InputMaybe<Credit_Memos_Bool_Exp>;
};


export type Subscription_RootCredit_Memos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Credit_Memos_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Memos_Bool_Exp>;
};


export type Subscription_RootCredit_Request_Batch_Line_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Request_Batch_Line_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Batch_Line_Items_Order_By>>;
  where?: InputMaybe<Credit_Request_Batch_Line_Items_Bool_Exp>;
};


export type Subscription_RootCredit_Request_Batch_Line_Items_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootCredit_Request_Batch_Line_Items_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Request_Batch_Line_Items_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Batch_Line_Items_Order_By>>;
  where?: InputMaybe<Credit_Request_Batch_Line_Items_Bool_Exp>;
};


export type Subscription_RootCredit_Request_Batch_Line_Items_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Credit_Request_Batch_Line_Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Request_Batch_Line_Items_Bool_Exp>;
};


export type Subscription_RootCredit_Request_BatchesArgs = {
  distinct_on?: InputMaybe<Array<Credit_Request_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Batches_Order_By>>;
  where?: InputMaybe<Credit_Request_Batches_Bool_Exp>;
};


export type Subscription_RootCredit_Request_Batches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Request_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Batches_Order_By>>;
  where?: InputMaybe<Credit_Request_Batches_Bool_Exp>;
};


export type Subscription_RootCredit_Request_Batches_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootCredit_Request_Batches_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Request_Batches_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Batches_Order_By>>;
  where?: InputMaybe<Credit_Request_Batches_Bool_Exp>;
};


export type Subscription_RootCredit_Request_Batches_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Credit_Request_Batches_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Request_Batches_Bool_Exp>;
};


export type Subscription_RootCredit_Request_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Request_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Reasons_Order_By>>;
  where?: InputMaybe<Credit_Request_Reasons_Bool_Exp>;
};


export type Subscription_RootCredit_Request_Reasons_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootCredit_Request_Reasons_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Credit_Request_Reasons_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Request_Reasons_Order_By>>;
  where?: InputMaybe<Credit_Request_Reasons_Bool_Exp>;
};


export type Subscription_RootCredit_Request_Reasons_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Credit_Request_Reasons_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Request_Reasons_Bool_Exp>;
};


export type Subscription_RootCrm_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Crm_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Activities_Order_By>>;
  where?: InputMaybe<Crm_Activities_Bool_Exp>;
};


export type Subscription_RootCrm_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Activities_Order_By>>;
  where?: InputMaybe<Crm_Activities_Bool_Exp>;
};


export type Subscription_RootCrm_Activities_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootCrm_Activities_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Crm_Activities_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Activities_Order_By>>;
  where?: InputMaybe<Crm_Activities_Bool_Exp>;
};


export type Subscription_RootCrm_Activities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Crm_Activities_Stream_Cursor_Input>>;
  where?: InputMaybe<Crm_Activities_Bool_Exp>;
};


export type Subscription_RootCrm_Activity_NotesArgs = {
  distinct_on?: InputMaybe<Array<Crm_Activity_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Activity_Notes_Order_By>>;
  where?: InputMaybe<Crm_Activity_Notes_Bool_Exp>;
};


export type Subscription_RootCrm_Activity_Notes_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootCrm_Activity_Notes_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Crm_Activity_Notes_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Activity_Notes_Order_By>>;
  where?: InputMaybe<Crm_Activity_Notes_Bool_Exp>;
};


export type Subscription_RootCrm_Activity_Notes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Crm_Activity_Notes_Stream_Cursor_Input>>;
  where?: InputMaybe<Crm_Activity_Notes_Bool_Exp>;
};


export type Subscription_RootEmployee_ChatsArgs = {
  distinct_on?: InputMaybe<Array<Employee_Chats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Employee_Chats_Order_By>>;
  where?: InputMaybe<Employee_Chats_Bool_Exp>;
};


export type Subscription_RootEmployee_Chats_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Employee_Chats_Stream_Cursor_Input>>;
  where?: InputMaybe<Employee_Chats_Bool_Exp>;
};


export type Subscription_RootEmployee_Smart_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Employee_Smart_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Employee_Smart_Orders_Order_By>>;
  where?: InputMaybe<Employee_Smart_Orders_Bool_Exp>;
};


export type Subscription_RootEmployee_Smart_Orders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Employee_Smart_Orders_Stream_Cursor_Input>>;
  where?: InputMaybe<Employee_Smart_Orders_Bool_Exp>;
};


export type Subscription_RootEmployeesArgs = {
  distinct_on?: InputMaybe<Array<Employees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Employees_Order_By>>;
  where?: InputMaybe<Employees_Bool_Exp>;
};


export type Subscription_RootEmployees_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootEmployees_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Employees_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Employees_Order_By>>;
  where?: InputMaybe<Employees_Bool_Exp>;
};


export type Subscription_RootEmployees_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Employees_Stream_Cursor_Input>>;
  where?: InputMaybe<Employees_Bool_Exp>;
};


export type Subscription_RootGhost_AgentsArgs = {
  distinct_on?: InputMaybe<Array<Ghost_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ghost_Agents_Order_By>>;
  where?: InputMaybe<Ghost_Agents_Bool_Exp>;
};


export type Subscription_RootGhost_Agents_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootGhost_Agents_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Ghost_Agents_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ghost_Agents_Order_By>>;
  where?: InputMaybe<Ghost_Agents_Bool_Exp>;
};


export type Subscription_RootGhost_Agents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ghost_Agents_Stream_Cursor_Input>>;
  where?: InputMaybe<Ghost_Agents_Bool_Exp>;
};


export type Subscription_RootGhost_ConversationsArgs = {
  distinct_on?: InputMaybe<Array<Ghost_Conversations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ghost_Conversations_Order_By>>;
  where?: InputMaybe<Ghost_Conversations_Bool_Exp>;
};


export type Subscription_RootGhost_Conversations_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootGhost_Conversations_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Ghost_Conversations_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ghost_Conversations_Order_By>>;
  where?: InputMaybe<Ghost_Conversations_Bool_Exp>;
};


export type Subscription_RootGhost_Conversations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ghost_Conversations_Stream_Cursor_Input>>;
  where?: InputMaybe<Ghost_Conversations_Bool_Exp>;
};


export type Subscription_RootGhost_Execution_LogsArgs = {
  distinct_on?: InputMaybe<Array<Ghost_Execution_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ghost_Execution_Logs_Order_By>>;
  where?: InputMaybe<Ghost_Execution_Logs_Bool_Exp>;
};


export type Subscription_RootGhost_Execution_Logs_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootGhost_Execution_Logs_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Ghost_Execution_Logs_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ghost_Execution_Logs_Order_By>>;
  where?: InputMaybe<Ghost_Execution_Logs_Bool_Exp>;
};


export type Subscription_RootGhost_Execution_Logs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ghost_Execution_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Ghost_Execution_Logs_Bool_Exp>;
};


export type Subscription_RootGhost_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Ghost_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ghost_Messages_Order_By>>;
  where?: InputMaybe<Ghost_Messages_Bool_Exp>;
};


export type Subscription_RootGhost_Messages_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootGhost_Messages_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Ghost_Messages_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ghost_Messages_Order_By>>;
  where?: InputMaybe<Ghost_Messages_Bool_Exp>;
};


export type Subscription_RootGhost_Messages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ghost_Messages_Stream_Cursor_Input>>;
  where?: InputMaybe<Ghost_Messages_Bool_Exp>;
};


export type Subscription_RootGtin_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Gtin_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gtin_Metadata_Order_By>>;
  where?: InputMaybe<Gtin_Metadata_Bool_Exp>;
};


export type Subscription_RootGtin_Metadata_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootGtin_Metadata_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Gtin_Metadata_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gtin_Metadata_Order_By>>;
  where?: InputMaybe<Gtin_Metadata_Bool_Exp>;
};


export type Subscription_RootGtin_Metadata_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gtin_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Gtin_Metadata_Bool_Exp>;
};


export type Subscription_RootHub_Last_VisitedArgs = {
  distinct_on?: InputMaybe<Array<Hub_Last_Visited_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hub_Last_Visited_Order_By>>;
  where?: InputMaybe<Hub_Last_Visited_Bool_Exp>;
};


export type Subscription_RootHub_Last_Visited_By_PkArgs = {
  employee_uuid: Scalars['uuid']['input'];
};


export type Subscription_RootHub_Last_Visited_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Hub_Last_Visited_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Hub_Last_Visited_Order_By>>;
  where?: InputMaybe<Hub_Last_Visited_Bool_Exp>;
};


export type Subscription_RootHub_Last_Visited_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Hub_Last_Visited_Stream_Cursor_Input>>;
  where?: InputMaybe<Hub_Last_Visited_Bool_Exp>;
};


export type Subscription_RootMenu_Item_IngredientsArgs = {
  distinct_on?: InputMaybe<Array<Menu_Item_Ingredients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menu_Item_Ingredients_Order_By>>;
  where?: InputMaybe<Menu_Item_Ingredients_Bool_Exp>;
};


export type Subscription_RootMenu_Item_Ingredients_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootMenu_Item_Ingredients_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Menu_Item_Ingredients_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menu_Item_Ingredients_Order_By>>;
  where?: InputMaybe<Menu_Item_Ingredients_Bool_Exp>;
};


export type Subscription_RootMenu_Item_Ingredients_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Menu_Item_Ingredients_Stream_Cursor_Input>>;
  where?: InputMaybe<Menu_Item_Ingredients_Bool_Exp>;
};


export type Subscription_RootMenu_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Menu_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menu_Items_Order_By>>;
  where?: InputMaybe<Menu_Items_Bool_Exp>;
};


export type Subscription_RootMenu_Items_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootMenu_Items_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Menu_Items_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Menu_Items_Order_By>>;
  where?: InputMaybe<Menu_Items_Bool_Exp>;
};


export type Subscription_RootMenu_Items_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Menu_Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Menu_Items_Bool_Exp>;
};


export type Subscription_RootMessagesArgs = {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


export type Subscription_RootMessages_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootMessages_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


export type Subscription_RootMessages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Messages_Stream_Cursor_Input>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


export type Subscription_RootMobile_Payment_TerminalsArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Payment_Terminals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Payment_Terminals_Order_By>>;
  where?: InputMaybe<Mobile_Payment_Terminals_Bool_Exp>;
};


export type Subscription_RootMobile_Payment_Terminals_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootMobile_Payment_Terminals_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Mobile_Payment_Terminals_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Payment_Terminals_Order_By>>;
  where?: InputMaybe<Mobile_Payment_Terminals_Bool_Exp>;
};


export type Subscription_RootMobile_Payment_Terminals_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mobile_Payment_Terminals_Stream_Cursor_Input>>;
  where?: InputMaybe<Mobile_Payment_Terminals_Bool_Exp>;
};


export type Subscription_RootNodeArgs = {
  id: Scalars['ID']['input'];
};


export type Subscription_RootOrder_GuideArgs = {
  distinct_on?: InputMaybe<Array<Order_Guide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Guide_Order_By>>;
  where?: InputMaybe<Order_Guide_Bool_Exp>;
};


export type Subscription_RootOrder_Guide_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootOrder_Guide_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Guide_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Guide_Order_By>>;
  where?: InputMaybe<Order_Guide_Bool_Exp>;
};


export type Subscription_RootOrder_Guide_Restaurant_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Order_Guide_Restaurant_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Guide_Restaurant_Collection_Order_By>>;
  where?: InputMaybe<Order_Guide_Restaurant_Collection_Bool_Exp>;
};


export type Subscription_RootOrder_Guide_Restaurant_Collection_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootOrder_Guide_Restaurant_Collection_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Guide_Restaurant_Collection_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Guide_Restaurant_Collection_Order_By>>;
  where?: InputMaybe<Order_Guide_Restaurant_Collection_Bool_Exp>;
};


export type Subscription_RootOrder_Guide_Restaurant_Collection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Guide_Restaurant_Collection_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Guide_Restaurant_Collection_Bool_Exp>;
};


export type Subscription_RootOrder_Guide_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Guide_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Guide_Bool_Exp>;
};


export type Subscription_RootOrder_Guide_Supplier_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Order_Guide_Supplier_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Guide_Supplier_Collection_Order_By>>;
  where?: InputMaybe<Order_Guide_Supplier_Collection_Bool_Exp>;
};


export type Subscription_RootOrder_Guide_Supplier_Collection_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootOrder_Guide_Supplier_Collection_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Guide_Supplier_Collection_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Guide_Supplier_Collection_Order_By>>;
  where?: InputMaybe<Order_Guide_Supplier_Collection_Bool_Exp>;
};


export type Subscription_RootOrder_Guide_Supplier_Collection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Guide_Supplier_Collection_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Guide_Supplier_Collection_Bool_Exp>;
};


export type Subscription_RootOrder_Invoice_Check_In_Item_IssuesArgs = {
  distinct_on?: InputMaybe<Array<Order_Invoice_Check_In_Item_Issues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoice_Check_In_Item_Issues_Order_By>>;
  where?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Bool_Exp>;
};


export type Subscription_RootOrder_Invoice_Check_In_Item_Issues_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootOrder_Invoice_Check_In_Item_Issues_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Invoice_Check_In_Item_Issues_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoice_Check_In_Item_Issues_Order_By>>;
  where?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Bool_Exp>;
};


export type Subscription_RootOrder_Invoice_Check_In_Item_Issues_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Invoice_Check_In_Item_Issues_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Invoice_Check_In_Item_Issues_Bool_Exp>;
};


export type Subscription_RootOrder_Invoice_Check_In_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Order_Invoice_Check_In_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoice_Check_In_Items_Order_By>>;
  where?: InputMaybe<Order_Invoice_Check_In_Items_Bool_Exp>;
};


export type Subscription_RootOrder_Invoice_Check_In_Items_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootOrder_Invoice_Check_In_Items_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Invoice_Check_In_Items_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoice_Check_In_Items_Order_By>>;
  where?: InputMaybe<Order_Invoice_Check_In_Items_Bool_Exp>;
};


export type Subscription_RootOrder_Invoice_Check_In_Items_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Invoice_Check_In_Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Invoice_Check_In_Items_Bool_Exp>;
};


export type Subscription_RootOrder_Invoice_Check_InsArgs = {
  distinct_on?: InputMaybe<Array<Order_Invoice_Check_Ins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoice_Check_Ins_Order_By>>;
  where?: InputMaybe<Order_Invoice_Check_Ins_Bool_Exp>;
};


export type Subscription_RootOrder_Invoice_Check_Ins_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootOrder_Invoice_Check_Ins_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Invoice_Check_Ins_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoice_Check_Ins_Order_By>>;
  where?: InputMaybe<Order_Invoice_Check_Ins_Bool_Exp>;
};


export type Subscription_RootOrder_Invoice_Check_Ins_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Invoice_Check_Ins_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Invoice_Check_Ins_Bool_Exp>;
};


export type Subscription_RootOrder_InvoicesArgs = {
  distinct_on?: InputMaybe<Array<Order_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoices_Order_By>>;
  where?: InputMaybe<Order_Invoices_Bool_Exp>;
};


export type Subscription_RootOrder_Invoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoices_Order_By>>;
  where?: InputMaybe<Order_Invoices_Bool_Exp>;
};


export type Subscription_RootOrder_Invoices_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootOrder_Invoices_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Invoices_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Invoices_Order_By>>;
  where?: InputMaybe<Order_Invoices_Bool_Exp>;
};


export type Subscription_RootOrder_Invoices_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Invoices_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Invoices_Bool_Exp>;
};


export type Subscription_RootOrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Subscription_RootOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Subscription_RootOrders_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootOrders_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Subscription_RootOrders_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Orders_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Items_Order_By>>;
  where?: InputMaybe<Orders_Items_Bool_Exp>;
};


export type Subscription_RootOrders_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Items_Order_By>>;
  where?: InputMaybe<Orders_Items_Bool_Exp>;
};


export type Subscription_RootOrders_Items_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootOrders_Items_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Orders_Items_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Items_Order_By>>;
  where?: InputMaybe<Orders_Items_Bool_Exp>;
};


export type Subscription_RootOrders_Items_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Orders_Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Orders_Items_Bool_Exp>;
};


export type Subscription_RootOrders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Orders_Stream_Cursor_Input>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Subscription_RootPad_Payment_MethodArgs = {
  distinct_on?: InputMaybe<Array<Pad_Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pad_Payment_Method_Order_By>>;
  where?: InputMaybe<Pad_Payment_Method_Bool_Exp>;
};


export type Subscription_RootPad_Payment_Method_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootPad_Payment_Method_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Pad_Payment_Method_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pad_Payment_Method_Order_By>>;
  where?: InputMaybe<Pad_Payment_Method_Bool_Exp>;
};


export type Subscription_RootPad_Payment_Method_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pad_Payment_Method_Stream_Cursor_Input>>;
  where?: InputMaybe<Pad_Payment_Method_Bool_Exp>;
};


export type Subscription_RootPayment_BatchesArgs = {
  distinct_on?: InputMaybe<Array<Payment_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Batches_Order_By>>;
  where?: InputMaybe<Payment_Batches_Bool_Exp>;
};


export type Subscription_RootPayment_Batches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Batches_Order_By>>;
  where?: InputMaybe<Payment_Batches_Bool_Exp>;
};


export type Subscription_RootPayment_Batches_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootPayment_Batches_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Payment_Batches_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Batches_Order_By>>;
  where?: InputMaybe<Payment_Batches_Bool_Exp>;
};


export type Subscription_RootPayment_Batches_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Payment_Batches_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Batches_Bool_Exp>;
};


export type Subscription_RootPayment_LinksArgs = {
  distinct_on?: InputMaybe<Array<Payment_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Links_Order_By>>;
  where?: InputMaybe<Payment_Links_Bool_Exp>;
};


export type Subscription_RootPayment_Links_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Payment_Links_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Links_Order_By>>;
  where?: InputMaybe<Payment_Links_Bool_Exp>;
};


export type Subscription_RootPayment_Links_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Payment_Links_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Links_Bool_Exp>;
};


export type Subscription_RootPayment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Subscription_RootPayment_Methods_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootPayment_Methods_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Subscription_RootPayment_Methods_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Payment_Methods_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Subscription_RootPlanogramsArgs = {
  distinct_on?: InputMaybe<Array<Planograms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planograms_Order_By>>;
  where?: InputMaybe<Planograms_Bool_Exp>;
};


export type Subscription_RootPlanograms_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootPlanograms_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Planograms_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planograms_Order_By>>;
  where?: InputMaybe<Planograms_Bool_Exp>;
};


export type Subscription_RootPlanograms_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Planograms_Stream_Cursor_Input>>;
  where?: InputMaybe<Planograms_Bool_Exp>;
};


export type Subscription_RootPricing_Price_Draft_Update_BatchesArgs = {
  distinct_on?: InputMaybe<Array<Pricing_Price_Draft_Update_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pricing_Price_Draft_Update_Batches_Order_By>>;
  where?: InputMaybe<Pricing_Price_Draft_Update_Batches_Bool_Exp>;
};


export type Subscription_RootPricing_Price_Draft_Update_Batches_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootPricing_Price_Draft_Update_Batches_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Pricing_Price_Draft_Update_Batches_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pricing_Price_Draft_Update_Batches_Order_By>>;
  where?: InputMaybe<Pricing_Price_Draft_Update_Batches_Bool_Exp>;
};


export type Subscription_RootPricing_Price_Draft_Update_Batches_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pricing_Price_Draft_Update_Batches_Stream_Cursor_Input>>;
  where?: InputMaybe<Pricing_Price_Draft_Update_Batches_Bool_Exp>;
};


export type Subscription_RootPricing_Task_RunsArgs = {
  distinct_on?: InputMaybe<Array<Pricing_Task_Runs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pricing_Task_Runs_Order_By>>;
  where?: InputMaybe<Pricing_Task_Runs_Bool_Exp>;
};


export type Subscription_RootPricing_Task_Runs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pricing_Task_Runs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pricing_Task_Runs_Order_By>>;
  where?: InputMaybe<Pricing_Task_Runs_Bool_Exp>;
};


export type Subscription_RootPricing_Task_Runs_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootPricing_Task_Runs_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Pricing_Task_Runs_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pricing_Task_Runs_Order_By>>;
  where?: InputMaybe<Pricing_Task_Runs_Bool_Exp>;
};


export type Subscription_RootPricing_Task_Runs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pricing_Task_Runs_Stream_Cursor_Input>>;
  where?: InputMaybe<Pricing_Task_Runs_Bool_Exp>;
};


export type Subscription_RootPrint_Tag_BatchesArgs = {
  distinct_on?: InputMaybe<Array<Print_Tag_Batches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Print_Tag_Batches_Order_By>>;
  where?: InputMaybe<Print_Tag_Batches_Bool_Exp>;
};


export type Subscription_RootPrint_Tag_Batches_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootPrint_Tag_Batches_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Print_Tag_Batches_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Print_Tag_Batches_Order_By>>;
  where?: InputMaybe<Print_Tag_Batches_Bool_Exp>;
};


export type Subscription_RootPrint_Tag_Batches_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Print_Tag_Batches_Stream_Cursor_Input>>;
  where?: InputMaybe<Print_Tag_Batches_Bool_Exp>;
};


export type Subscription_RootPrint_Tag_Template_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Print_Tag_Template_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Print_Tag_Template_Assignments_Order_By>>;
  where?: InputMaybe<Print_Tag_Template_Assignments_Bool_Exp>;
};


export type Subscription_RootPrint_Tag_Template_Assignments_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootPrint_Tag_Template_Assignments_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Print_Tag_Template_Assignments_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Print_Tag_Template_Assignments_Order_By>>;
  where?: InputMaybe<Print_Tag_Template_Assignments_Bool_Exp>;
};


export type Subscription_RootPrint_Tag_Template_Assignments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Print_Tag_Template_Assignments_Stream_Cursor_Input>>;
  where?: InputMaybe<Print_Tag_Template_Assignments_Bool_Exp>;
};


export type Subscription_RootPrint_Tag_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Print_Tag_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Print_Tag_Templates_Order_By>>;
  where?: InputMaybe<Print_Tag_Templates_Bool_Exp>;
};


export type Subscription_RootPrint_Tag_Templates_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootPrint_Tag_Templates_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Print_Tag_Templates_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Print_Tag_Templates_Order_By>>;
  where?: InputMaybe<Print_Tag_Templates_Bool_Exp>;
};


export type Subscription_RootPrint_Tag_Templates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Print_Tag_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Print_Tag_Templates_Bool_Exp>;
};


export type Subscription_RootPromotion_Component_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Promotion_Component_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Promotion_Component_Groups_Order_By>>;
  where?: InputMaybe<Promotion_Component_Groups_Bool_Exp>;
};


export type Subscription_RootPromotion_Component_Groups_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Promotion_Component_Groups_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Promotion_Component_Groups_Order_By>>;
  where?: InputMaybe<Promotion_Component_Groups_Bool_Exp>;
};


export type Subscription_RootPromotion_Component_Groups_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Promotion_Component_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Promotion_Component_Groups_Bool_Exp>;
};


export type Subscription_RootRestaurant_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Restaurant_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Groups_Order_By>>;
  where?: InputMaybe<Restaurant_Groups_Bool_Exp>;
};


export type Subscription_RootRestaurant_Groups_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootRestaurant_Groups_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Restaurant_Groups_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Groups_Order_By>>;
  where?: InputMaybe<Restaurant_Groups_Bool_Exp>;
};


export type Subscription_RootRestaurant_Groups_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Restaurant_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Restaurant_Groups_Bool_Exp>;
};


export type Subscription_RootSales_Rep_Chat_RelationsArgs = {
  distinct_on?: InputMaybe<Array<Sales_Rep_Chat_Relations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sales_Rep_Chat_Relations_Order_By>>;
  where?: InputMaybe<Sales_Rep_Chat_Relations_Bool_Exp>;
};


export type Subscription_RootSales_Rep_Chat_Relations_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootSales_Rep_Chat_Relations_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Sales_Rep_Chat_Relations_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sales_Rep_Chat_Relations_Order_By>>;
  where?: InputMaybe<Sales_Rep_Chat_Relations_Bool_Exp>;
};


export type Subscription_RootSales_Rep_Chat_Relations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sales_Rep_Chat_Relations_Stream_Cursor_Input>>;
  where?: InputMaybe<Sales_Rep_Chat_Relations_Bool_Exp>;
};


export type Subscription_RootSmart_OrderArgs = {
  distinct_on?: InputMaybe<Array<Smart_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Order_By>>;
  where?: InputMaybe<Smart_Order_Bool_Exp>;
};


export type Subscription_RootSmart_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Smart_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Order_By>>;
  where?: InputMaybe<Smart_Order_Bool_Exp>;
};


export type Subscription_RootSmart_Order_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootSmart_Order_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Smart_Order_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Order_By>>;
  where?: InputMaybe<Smart_Order_Bool_Exp>;
};


export type Subscription_RootSmart_Order_Message_RelArgs = {
  distinct_on?: InputMaybe<Array<Smart_Order_Message_Rel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Message_Rel_Order_By>>;
  where?: InputMaybe<Smart_Order_Message_Rel_Bool_Exp>;
};


export type Subscription_RootSmart_Order_Message_Rel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Smart_Order_Message_Rel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Message_Rel_Order_By>>;
  where?: InputMaybe<Smart_Order_Message_Rel_Bool_Exp>;
};


export type Subscription_RootSmart_Order_Message_Rel_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootSmart_Order_Message_Rel_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Smart_Order_Message_Rel_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Message_Rel_Order_By>>;
  where?: InputMaybe<Smart_Order_Message_Rel_Bool_Exp>;
};


export type Subscription_RootSmart_Order_Message_Rel_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Smart_Order_Message_Rel_Stream_Cursor_Input>>;
  where?: InputMaybe<Smart_Order_Message_Rel_Bool_Exp>;
};


export type Subscription_RootSmart_Order_Search_Term_CorrectionsArgs = {
  distinct_on?: InputMaybe<Array<Smart_Order_Search_Term_Corrections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Search_Term_Corrections_Order_By>>;
  where?: InputMaybe<Smart_Order_Search_Term_Corrections_Bool_Exp>;
};


export type Subscription_RootSmart_Order_Search_Term_Corrections_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootSmart_Order_Search_Term_Corrections_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Smart_Order_Search_Term_Corrections_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Order_Search_Term_Corrections_Order_By>>;
  where?: InputMaybe<Smart_Order_Search_Term_Corrections_Bool_Exp>;
};


export type Subscription_RootSmart_Order_Search_Term_Corrections_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Smart_Order_Search_Term_Corrections_Stream_Cursor_Input>>;
  where?: InputMaybe<Smart_Order_Search_Term_Corrections_Bool_Exp>;
};


export type Subscription_RootSmart_Order_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Smart_Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Smart_Order_Bool_Exp>;
};


export type Subscription_RootSupplier_Payments_StatusArgs = {
  distinct_on?: InputMaybe<Array<Supplier_Payments_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supplier_Payments_Status_Order_By>>;
  where?: InputMaybe<Supplier_Payments_Status_Bool_Exp>;
};


export type Subscription_RootSupplier_Payments_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Supplier_Payments_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Supplier_Payments_Status_Bool_Exp>;
};


export type Subscription_RootTask_Frequency_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Task_Frequency_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Frequency_Settings_Order_By>>;
  where?: InputMaybe<Task_Frequency_Settings_Bool_Exp>;
};


export type Subscription_RootTask_Frequency_Settings_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Task_Frequency_Settings_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Frequency_Settings_Order_By>>;
  where?: InputMaybe<Task_Frequency_Settings_Bool_Exp>;
};


export type Subscription_RootTask_Frequency_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Task_Frequency_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Task_Frequency_Settings_Bool_Exp>;
};


export type Subscription_RootVariant_Pack_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Variant_Pack_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variant_Pack_Groups_Order_By>>;
  where?: InputMaybe<Variant_Pack_Groups_Bool_Exp>;
};


export type Subscription_RootVariant_Pack_Groups_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootVariant_Pack_Groups_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Variant_Pack_Groups_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variant_Pack_Groups_Order_By>>;
  where?: InputMaybe<Variant_Pack_Groups_Bool_Exp>;
};


export type Subscription_RootVariant_Pack_Groups_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variant_Pack_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Variant_Pack_Groups_Bool_Exp>;
};


export type Subscription_RootVariants_PacksArgs = {
  distinct_on?: InputMaybe<Array<Variants_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variants_Packs_Order_By>>;
  where?: InputMaybe<Variants_Packs_Bool_Exp>;
};


export type Subscription_RootVariants_Packs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variants_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variants_Packs_Order_By>>;
  where?: InputMaybe<Variants_Packs_Bool_Exp>;
};


export type Subscription_RootVariants_Packs_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootVariants_Packs_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Variants_Packs_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variants_Packs_Order_By>>;
  where?: InputMaybe<Variants_Packs_Bool_Exp>;
};


export type Subscription_RootVariants_Packs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variants_Packs_Stream_Cursor_Input>>;
  where?: InputMaybe<Variants_Packs_Bool_Exp>;
};


export type Subscription_RootVariants_Packs_Substitution_SuppliersArgs = {
  distinct_on?: InputMaybe<Array<Variants_Packs_Substitution_Suppliers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variants_Packs_Substitution_Suppliers_Order_By>>;
  where?: InputMaybe<Variants_Packs_Substitution_Suppliers_Bool_Exp>;
};


export type Subscription_RootVariants_Packs_Substitution_Suppliers_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootVariants_Packs_Substitution_Suppliers_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Variants_Packs_Substitution_Suppliers_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variants_Packs_Substitution_Suppliers_Order_By>>;
  where?: InputMaybe<Variants_Packs_Substitution_Suppliers_Bool_Exp>;
};


export type Subscription_RootVariants_Packs_Substitution_Suppliers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variants_Packs_Substitution_Suppliers_Stream_Cursor_Input>>;
  where?: InputMaybe<Variants_Packs_Substitution_Suppliers_Bool_Exp>;
};


export type Subscription_RootVisible_Variant_PacksArgs = {
  distinct_on?: InputMaybe<Array<Visible_Variant_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visible_Variant_Packs_Order_By>>;
  where?: InputMaybe<Visible_Variant_Packs_Bool_Exp>;
};


export type Subscription_RootVisible_Variant_Packs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visible_Variant_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visible_Variant_Packs_Order_By>>;
  where?: InputMaybe<Visible_Variant_Packs_Bool_Exp>;
};


export type Subscription_RootVisible_Variant_Packs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Visible_Variant_Packs_Stream_Cursor_Input>>;
  where?: InputMaybe<Visible_Variant_Packs_Bool_Exp>;
};


export type Subscription_RootWhitelabel_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Whitelabel_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whitelabel_Config_Order_By>>;
  where?: InputMaybe<Whitelabel_Config_Bool_Exp>;
};


export type Subscription_RootWhitelabel_Config_By_PkArgs = {
  uuid: Scalars['uuid']['input'];
};


export type Subscription_RootWhitelabel_Config_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Whitelabel_Config_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Whitelabel_Config_Order_By>>;
  where?: InputMaybe<Whitelabel_Config_Bool_Exp>;
};


export type Subscription_RootWhitelabel_Config_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Whitelabel_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Whitelabel_Config_Bool_Exp>;
};

/** columns and relationships of "supplier_employee_overrides" */
export type Supplier_Employee_Overrides = Node & {
  __typename?: 'supplier_employee_overrides';
  contact_emails: Scalars['_text']['output'];
  contact_phone_numbers: Scalars['_varchar']['output'];
  employee_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  supplier: Businesses;
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "supplier_employee_overrides" */
export type Supplier_Employee_OverridesConnection = {
  __typename?: 'supplier_employee_overridesConnection';
  edges: Array<Supplier_Employee_OverridesEdge>;
  pageInfo: PageInfo;
};

export type Supplier_Employee_OverridesEdge = {
  __typename?: 'supplier_employee_overridesEdge';
  cursor: Scalars['String']['output'];
  node: Supplier_Employee_Overrides;
};

/** order by aggregate values of table "supplier_employee_overrides" */
export type Supplier_Employee_Overrides_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supplier_Employee_Overrides_Max_Order_By>;
  min?: InputMaybe<Supplier_Employee_Overrides_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "supplier_employee_overrides". All fields are combined with a logical 'AND'. */
export type Supplier_Employee_Overrides_Bool_Exp = {
  _and?: InputMaybe<Array<Supplier_Employee_Overrides_Bool_Exp>>;
  _not?: InputMaybe<Supplier_Employee_Overrides_Bool_Exp>;
  _or?: InputMaybe<Array<Supplier_Employee_Overrides_Bool_Exp>>;
  contact_emails?: InputMaybe<_Text_Comparison_Exp>;
  contact_phone_numbers?: InputMaybe<_Varchar_Comparison_Exp>;
  employee_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "supplier_employee_overrides" */
export type Supplier_Employee_Overrides_Max_Order_By = {
  employee_uuid?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "supplier_employee_overrides" */
export type Supplier_Employee_Overrides_Min_Order_By = {
  employee_uuid?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "supplier_employee_overrides". */
export type Supplier_Employee_Overrides_Order_By = {
  contact_emails?: InputMaybe<Order_By>;
  contact_phone_numbers?: InputMaybe<Order_By>;
  employee_uuid?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "supplier_employee_overrides" */
export enum Supplier_Employee_Overrides_Select_Column {
  /** column name */
  ContactEmails = 'contact_emails',
  /** column name */
  ContactPhoneNumbers = 'contact_phone_numbers',
  /** column name */
  EmployeeUuid = 'employee_uuid',
  /** column name */
  Name = 'name',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** columns and relationships of "supplier_loyalty_program_restaurant_users" */
export type Supplier_Loyalty_Program_Restaurant_Users = Node & {
  __typename?: 'supplier_loyalty_program_restaurant_users';
  employee_uuid: Scalars['uuid']['output'];
  id: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  /** An object relationship */
  supplier_loyalty_program_restaurant: Supplier_Loyalty_Program_Restaurants;
  supplier_loyalty_program_restaurant_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "supplier_loyalty_program_restaurant_users" */
export type Supplier_Loyalty_Program_Restaurant_UsersConnection = {
  __typename?: 'supplier_loyalty_program_restaurant_usersConnection';
  edges: Array<Supplier_Loyalty_Program_Restaurant_UsersEdge>;
  pageInfo: PageInfo;
};

export type Supplier_Loyalty_Program_Restaurant_UsersEdge = {
  __typename?: 'supplier_loyalty_program_restaurant_usersEdge';
  cursor: Scalars['String']['output'];
  node: Supplier_Loyalty_Program_Restaurant_Users;
};

/** order by aggregate values of table "supplier_loyalty_program_restaurant_users" */
export type Supplier_Loyalty_Program_Restaurant_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supplier_Loyalty_Program_Restaurant_Users_Max_Order_By>;
  min?: InputMaybe<Supplier_Loyalty_Program_Restaurant_Users_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "supplier_loyalty_program_restaurant_users". All fields are combined with a logical 'AND'. */
export type Supplier_Loyalty_Program_Restaurant_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Supplier_Loyalty_Program_Restaurant_Users_Bool_Exp>>;
  _not?: InputMaybe<Supplier_Loyalty_Program_Restaurant_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Supplier_Loyalty_Program_Restaurant_Users_Bool_Exp>>;
  employee_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  supplier_loyalty_program_restaurant?: InputMaybe<Supplier_Loyalty_Program_Restaurants_Bool_Exp>;
  supplier_loyalty_program_restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "supplier_loyalty_program_restaurant_users" */
export type Supplier_Loyalty_Program_Restaurant_Users_Max_Order_By = {
  employee_uuid?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  supplier_loyalty_program_restaurant_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "supplier_loyalty_program_restaurant_users" */
export type Supplier_Loyalty_Program_Restaurant_Users_Min_Order_By = {
  employee_uuid?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  supplier_loyalty_program_restaurant_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "supplier_loyalty_program_restaurant_users". */
export type Supplier_Loyalty_Program_Restaurant_Users_Order_By = {
  employee_uuid?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  supplier_loyalty_program_restaurant?: InputMaybe<Supplier_Loyalty_Program_Restaurants_Order_By>;
  supplier_loyalty_program_restaurant_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "supplier_loyalty_program_restaurant_users" */
export enum Supplier_Loyalty_Program_Restaurant_Users_Select_Column {
  /** column name */
  EmployeeUuid = 'employee_uuid',
  /** column name */
  Role = 'role',
  /** column name */
  SupplierLoyaltyProgramRestaurantUuid = 'supplier_loyalty_program_restaurant_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** columns and relationships of "supplier_loyalty_program_restaurants" */
export type Supplier_Loyalty_Program_Restaurants = Node & {
  __typename?: 'supplier_loyalty_program_restaurants';
  enrollment_form_responses?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['ID']['output'];
  /** An array relationship */
  loyalty_terms_acceptance_logs: Array<Loyalty_Terms_Acceptance_Log>;
  /** An array relationship connection */
  loyalty_terms_acceptance_logs_connection: Loyalty_Terms_Acceptance_LogConnection;
  /** An object relationship */
  restaurant: Businesses;
  restaurant_uuid: Scalars['uuid']['output'];
  status: Scalars['String']['output'];
  /** An object relationship */
  supplier_loyalty_program: Supplier_Loyalty_Programs;
  /** An array relationship */
  supplier_loyalty_program_restaurant_users: Array<Supplier_Loyalty_Program_Restaurant_Users>;
  /** An array relationship connection */
  supplier_loyalty_program_restaurant_users_connection: Supplier_Loyalty_Program_Restaurant_UsersConnection;
  supplier_loyalty_program_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "supplier_loyalty_program_restaurants" */
export type Supplier_Loyalty_Program_RestaurantsEnrollment_Form_ResponsesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "supplier_loyalty_program_restaurants" */
export type Supplier_Loyalty_Program_RestaurantsLoyalty_Terms_Acceptance_LogsArgs = {
  distinct_on?: InputMaybe<Array<Loyalty_Terms_Acceptance_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Loyalty_Terms_Acceptance_Log_Order_By>>;
  where?: InputMaybe<Loyalty_Terms_Acceptance_Log_Bool_Exp>;
};


/** columns and relationships of "supplier_loyalty_program_restaurants" */
export type Supplier_Loyalty_Program_RestaurantsLoyalty_Terms_Acceptance_Logs_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Loyalty_Terms_Acceptance_Log_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Loyalty_Terms_Acceptance_Log_Order_By>>;
  where?: InputMaybe<Loyalty_Terms_Acceptance_Log_Bool_Exp>;
};


/** columns and relationships of "supplier_loyalty_program_restaurants" */
export type Supplier_Loyalty_Program_RestaurantsSupplier_Loyalty_Program_Restaurant_UsersArgs = {
  distinct_on?: InputMaybe<Array<Supplier_Loyalty_Program_Restaurant_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supplier_Loyalty_Program_Restaurant_Users_Order_By>>;
  where?: InputMaybe<Supplier_Loyalty_Program_Restaurant_Users_Bool_Exp>;
};


/** columns and relationships of "supplier_loyalty_program_restaurants" */
export type Supplier_Loyalty_Program_RestaurantsSupplier_Loyalty_Program_Restaurant_Users_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Supplier_Loyalty_Program_Restaurant_Users_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supplier_Loyalty_Program_Restaurant_Users_Order_By>>;
  where?: InputMaybe<Supplier_Loyalty_Program_Restaurant_Users_Bool_Exp>;
};

/** A Relay connection object on "supplier_loyalty_program_restaurants" */
export type Supplier_Loyalty_Program_RestaurantsConnection = {
  __typename?: 'supplier_loyalty_program_restaurantsConnection';
  edges: Array<Supplier_Loyalty_Program_RestaurantsEdge>;
  pageInfo: PageInfo;
};

export type Supplier_Loyalty_Program_RestaurantsEdge = {
  __typename?: 'supplier_loyalty_program_restaurantsEdge';
  cursor: Scalars['String']['output'];
  node: Supplier_Loyalty_Program_Restaurants;
};

/** order by aggregate values of table "supplier_loyalty_program_restaurants" */
export type Supplier_Loyalty_Program_Restaurants_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supplier_Loyalty_Program_Restaurants_Max_Order_By>;
  min?: InputMaybe<Supplier_Loyalty_Program_Restaurants_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "supplier_loyalty_program_restaurants". All fields are combined with a logical 'AND'. */
export type Supplier_Loyalty_Program_Restaurants_Bool_Exp = {
  _and?: InputMaybe<Array<Supplier_Loyalty_Program_Restaurants_Bool_Exp>>;
  _not?: InputMaybe<Supplier_Loyalty_Program_Restaurants_Bool_Exp>;
  _or?: InputMaybe<Array<Supplier_Loyalty_Program_Restaurants_Bool_Exp>>;
  enrollment_form_responses?: InputMaybe<Jsonb_Comparison_Exp>;
  loyalty_terms_acceptance_logs?: InputMaybe<Loyalty_Terms_Acceptance_Log_Bool_Exp>;
  restaurant?: InputMaybe<Businesses_Bool_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  supplier_loyalty_program?: InputMaybe<Supplier_Loyalty_Programs_Bool_Exp>;
  supplier_loyalty_program_restaurant_users?: InputMaybe<Supplier_Loyalty_Program_Restaurant_Users_Bool_Exp>;
  supplier_loyalty_program_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "supplier_loyalty_program_restaurants" */
export type Supplier_Loyalty_Program_Restaurants_Max_Order_By = {
  restaurant_uuid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_loyalty_program_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "supplier_loyalty_program_restaurants" */
export type Supplier_Loyalty_Program_Restaurants_Min_Order_By = {
  restaurant_uuid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_loyalty_program_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "supplier_loyalty_program_restaurants". */
export type Supplier_Loyalty_Program_Restaurants_Order_By = {
  enrollment_form_responses?: InputMaybe<Order_By>;
  loyalty_terms_acceptance_logs_aggregate?: InputMaybe<Loyalty_Terms_Acceptance_Log_Aggregate_Order_By>;
  restaurant?: InputMaybe<Businesses_Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier_loyalty_program?: InputMaybe<Supplier_Loyalty_Programs_Order_By>;
  supplier_loyalty_program_restaurant_users_aggregate?: InputMaybe<Supplier_Loyalty_Program_Restaurant_Users_Aggregate_Order_By>;
  supplier_loyalty_program_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "supplier_loyalty_program_restaurants" */
export enum Supplier_Loyalty_Program_Restaurants_Select_Column {
  /** column name */
  EnrollmentFormResponses = 'enrollment_form_responses',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  Status = 'status',
  /** column name */
  SupplierLoyaltyProgramUuid = 'supplier_loyalty_program_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** columns and relationships of "supplier_loyalty_programs" */
export type Supplier_Loyalty_Programs = Node & {
  __typename?: 'supplier_loyalty_programs';
  id: Scalars['ID']['output'];
  /** An object relationship */
  loyalty_program: Loyalty_Programs;
  loyalty_program_uuid: Scalars['uuid']['output'];
  permissions: Scalars['_text']['output'];
  /** An object relationship */
  supplier: Businesses;
  /** An array relationship */
  supplier_loyalty_program_restaurants: Array<Supplier_Loyalty_Program_Restaurants>;
  /** An array relationship connection */
  supplier_loyalty_program_restaurants_connection: Supplier_Loyalty_Program_RestaurantsConnection;
  supplier_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "supplier_loyalty_programs" */
export type Supplier_Loyalty_ProgramsSupplier_Loyalty_Program_RestaurantsArgs = {
  distinct_on?: InputMaybe<Array<Supplier_Loyalty_Program_Restaurants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supplier_Loyalty_Program_Restaurants_Order_By>>;
  where?: InputMaybe<Supplier_Loyalty_Program_Restaurants_Bool_Exp>;
};


/** columns and relationships of "supplier_loyalty_programs" */
export type Supplier_Loyalty_ProgramsSupplier_Loyalty_Program_Restaurants_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Supplier_Loyalty_Program_Restaurants_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Supplier_Loyalty_Program_Restaurants_Order_By>>;
  where?: InputMaybe<Supplier_Loyalty_Program_Restaurants_Bool_Exp>;
};

/** A Relay connection object on "supplier_loyalty_programs" */
export type Supplier_Loyalty_ProgramsConnection = {
  __typename?: 'supplier_loyalty_programsConnection';
  edges: Array<Supplier_Loyalty_ProgramsEdge>;
  pageInfo: PageInfo;
};

export type Supplier_Loyalty_ProgramsEdge = {
  __typename?: 'supplier_loyalty_programsEdge';
  cursor: Scalars['String']['output'];
  node: Supplier_Loyalty_Programs;
};

/** order by aggregate values of table "supplier_loyalty_programs" */
export type Supplier_Loyalty_Programs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supplier_Loyalty_Programs_Max_Order_By>;
  min?: InputMaybe<Supplier_Loyalty_Programs_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "supplier_loyalty_programs". All fields are combined with a logical 'AND'. */
export type Supplier_Loyalty_Programs_Bool_Exp = {
  _and?: InputMaybe<Array<Supplier_Loyalty_Programs_Bool_Exp>>;
  _not?: InputMaybe<Supplier_Loyalty_Programs_Bool_Exp>;
  _or?: InputMaybe<Array<Supplier_Loyalty_Programs_Bool_Exp>>;
  loyalty_program?: InputMaybe<Loyalty_Programs_Bool_Exp>;
  loyalty_program_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  permissions?: InputMaybe<_Text_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_loyalty_program_restaurants?: InputMaybe<Supplier_Loyalty_Program_Restaurants_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "supplier_loyalty_programs" */
export type Supplier_Loyalty_Programs_Max_Order_By = {
  loyalty_program_uuid?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "supplier_loyalty_programs" */
export type Supplier_Loyalty_Programs_Min_Order_By = {
  loyalty_program_uuid?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "supplier_loyalty_programs". */
export type Supplier_Loyalty_Programs_Order_By = {
  loyalty_program?: InputMaybe<Loyalty_Programs_Order_By>;
  loyalty_program_uuid?: InputMaybe<Order_By>;
  permissions?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_loyalty_program_restaurants_aggregate?: InputMaybe<Supplier_Loyalty_Program_Restaurants_Aggregate_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "supplier_loyalty_programs" */
export enum Supplier_Loyalty_Programs_Select_Column {
  /** column name */
  LoyaltyProgramUuid = 'loyalty_program_uuid',
  /** column name */
  Permissions = 'permissions',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Uuid = 'uuid'
}

/** columns and relationships of "supplier_metadata" */
export type Supplier_Metadata = Node & {
  __typename?: 'supplier_metadata';
  allow_delivery_date_edit: Scalars['Boolean']['output'];
  app_account_creation_enabled: Scalars['Boolean']['output'];
  blackout_dates?: Maybe<Scalars['_date']['output']>;
  cutoff_time?: Maybe<Scalars['time']['output']>;
  delivery_days: Scalars['jsonb']['output'];
  display_item_code: Scalars['Boolean']['output'];
  display_item_prices: Scalars['Boolean']['output'];
  dynamic_config: Scalars['jsonb']['output'];
  flat_transaction_fees?: Maybe<Scalars['jsonb']['output']>;
  fulfillment_days: Scalars['jsonb']['output'];
  fulfillment_types: Scalars['_text']['output'];
  gross_up_transaction_fees_cutoff?: Maybe<Scalars['timestamptz']['output']>;
  gtin_settings?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['ID']['output'];
  is_same_day_cutoff_time: Scalars['Boolean']['output'];
  item_price_precision: Scalars['Int']['output'];
  lead_time_split_behavior: Scalars['String']['output'];
  order_guide_merge_strategy: Scalars['String']['output'];
  po_number_display: Scalars['String']['output'];
  /** An object relationship */
  public_chat?: Maybe<Chats>;
  public_restaurant_chat_uuid?: Maybe<Scalars['uuid']['output']>;
  /** If true, the supplier will see a disclaimer on the app payments page. */
  show_chargeback_disclaimer: Scalars['Boolean']['output'];
  show_order_notes: Scalars['Boolean']['output'];
  show_upc_scanner: Scalars['Boolean']['output'];
  /** An array relationship */
  supplier: Array<Businesses>;
  /** An array relationship connection */
  supplier_connection: BusinessesConnection;
  transaction_fees: Scalars['jsonb']['output'];
  use_v2_invoices: Scalars['Boolean']['output'];
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "supplier_metadata" */
export type Supplier_MetadataDelivery_DaysArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "supplier_metadata" */
export type Supplier_MetadataDynamic_ConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "supplier_metadata" */
export type Supplier_MetadataFlat_Transaction_FeesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "supplier_metadata" */
export type Supplier_MetadataFulfillment_DaysArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "supplier_metadata" */
export type Supplier_MetadataGtin_SettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "supplier_metadata" */
export type Supplier_MetadataSupplierArgs = {
  distinct_on?: InputMaybe<Array<Businesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Businesses_Order_By>>;
  where?: InputMaybe<Businesses_Bool_Exp>;
};


/** columns and relationships of "supplier_metadata" */
export type Supplier_MetadataSupplier_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Businesses_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Businesses_Order_By>>;
  where?: InputMaybe<Businesses_Bool_Exp>;
};


/** columns and relationships of "supplier_metadata" */
export type Supplier_MetadataTransaction_FeesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "supplier_metadata". All fields are combined with a logical 'AND'. */
export type Supplier_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Supplier_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Supplier_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Supplier_Metadata_Bool_Exp>>;
  allow_delivery_date_edit?: InputMaybe<Boolean_Comparison_Exp>;
  app_account_creation_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  blackout_dates?: InputMaybe<_Date_Comparison_Exp>;
  cutoff_time?: InputMaybe<Time_Comparison_Exp>;
  delivery_days?: InputMaybe<Jsonb_Comparison_Exp>;
  display_item_code?: InputMaybe<Boolean_Comparison_Exp>;
  display_item_prices?: InputMaybe<Boolean_Comparison_Exp>;
  dynamic_config?: InputMaybe<Jsonb_Comparison_Exp>;
  flat_transaction_fees?: InputMaybe<Jsonb_Comparison_Exp>;
  fulfillment_days?: InputMaybe<Jsonb_Comparison_Exp>;
  fulfillment_types?: InputMaybe<_Text_Comparison_Exp>;
  gross_up_transaction_fees_cutoff?: InputMaybe<Timestamptz_Comparison_Exp>;
  gtin_settings?: InputMaybe<Jsonb_Comparison_Exp>;
  is_same_day_cutoff_time?: InputMaybe<Boolean_Comparison_Exp>;
  item_price_precision?: InputMaybe<Int_Comparison_Exp>;
  lead_time_split_behavior?: InputMaybe<String_Comparison_Exp>;
  order_guide_merge_strategy?: InputMaybe<String_Comparison_Exp>;
  po_number_display?: InputMaybe<String_Comparison_Exp>;
  public_chat?: InputMaybe<Chats_Bool_Exp>;
  public_restaurant_chat_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  show_chargeback_disclaimer?: InputMaybe<Boolean_Comparison_Exp>;
  show_order_notes?: InputMaybe<Boolean_Comparison_Exp>;
  show_upc_scanner?: InputMaybe<Boolean_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  transaction_fees?: InputMaybe<Jsonb_Comparison_Exp>;
  use_v2_invoices?: InputMaybe<Boolean_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "supplier_metadata". */
export type Supplier_Metadata_Order_By = {
  allow_delivery_date_edit?: InputMaybe<Order_By>;
  app_account_creation_enabled?: InputMaybe<Order_By>;
  blackout_dates?: InputMaybe<Order_By>;
  cutoff_time?: InputMaybe<Order_By>;
  delivery_days?: InputMaybe<Order_By>;
  display_item_code?: InputMaybe<Order_By>;
  display_item_prices?: InputMaybe<Order_By>;
  dynamic_config?: InputMaybe<Order_By>;
  flat_transaction_fees?: InputMaybe<Order_By>;
  fulfillment_days?: InputMaybe<Order_By>;
  fulfillment_types?: InputMaybe<Order_By>;
  gross_up_transaction_fees_cutoff?: InputMaybe<Order_By>;
  gtin_settings?: InputMaybe<Order_By>;
  is_same_day_cutoff_time?: InputMaybe<Order_By>;
  item_price_precision?: InputMaybe<Order_By>;
  lead_time_split_behavior?: InputMaybe<Order_By>;
  order_guide_merge_strategy?: InputMaybe<Order_By>;
  po_number_display?: InputMaybe<Order_By>;
  public_chat?: InputMaybe<Chats_Order_By>;
  public_restaurant_chat_uuid?: InputMaybe<Order_By>;
  show_chargeback_disclaimer?: InputMaybe<Order_By>;
  show_order_notes?: InputMaybe<Order_By>;
  show_upc_scanner?: InputMaybe<Order_By>;
  supplier_aggregate?: InputMaybe<Businesses_Aggregate_Order_By>;
  transaction_fees?: InputMaybe<Order_By>;
  use_v2_invoices?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "supplier_payments_status" */
export type Supplier_Payments_Status = {
  __typename?: 'supplier_payments_status';
  status?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "supplier_payments_status". All fields are combined with a logical 'AND'. */
export type Supplier_Payments_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Supplier_Payments_Status_Bool_Exp>>;
  _not?: InputMaybe<Supplier_Payments_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Supplier_Payments_Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "supplier_payments_status". */
export type Supplier_Payments_Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** select columns of table "supplier_payments_status" */
export enum Supplier_Payments_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** Streaming cursor of the table "supplier_payments_status" */
export type Supplier_Payments_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supplier_Payments_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supplier_Payments_Status_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "task_frequency_settings" */
export type Task_Frequency_Settings = Node & {
  __typename?: 'task_frequency_settings';
  frequency: Scalars['jsonb']['output'];
  id: Scalars['ID']['output'];
};


/** columns and relationships of "task_frequency_settings" */
export type Task_Frequency_SettingsFrequencyArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay connection object on "task_frequency_settings" */
export type Task_Frequency_SettingsConnection = {
  __typename?: 'task_frequency_settingsConnection';
  edges: Array<Task_Frequency_SettingsEdge>;
  pageInfo: PageInfo;
};

export type Task_Frequency_SettingsEdge = {
  __typename?: 'task_frequency_settingsEdge';
  cursor: Scalars['String']['output'];
  node: Task_Frequency_Settings;
};

/** Boolean expression to filter rows from the table "task_frequency_settings". All fields are combined with a logical 'AND'. */
export type Task_Frequency_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Frequency_Settings_Bool_Exp>>;
  _not?: InputMaybe<Task_Frequency_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Frequency_Settings_Bool_Exp>>;
  frequency?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Ordering options when selecting data from "task_frequency_settings". */
export type Task_Frequency_Settings_Order_By = {
  frequency?: InputMaybe<Order_By>;
};

/** select columns of table "task_frequency_settings" */
export enum Task_Frequency_Settings_Select_Column {
  /** column name */
  Frequency = 'frequency'
}

/** Streaming cursor of the table "task_frequency_settings" */
export type Task_Frequency_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Task_Frequency_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Task_Frequency_Settings_Stream_Cursor_Value_Input = {
  frequency?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']['input']>;
  _gt?: InputMaybe<Scalars['time']['input']>;
  _gte?: InputMaybe<Scalars['time']['input']>;
  _in?: InputMaybe<Array<Scalars['time']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['time']['input']>;
  _lte?: InputMaybe<Scalars['time']['input']>;
  _neq?: InputMaybe<Scalars['time']['input']>;
  _nin?: InputMaybe<Array<Scalars['time']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "variant_pack_group_members" */
export type Variant_Pack_Group_Members = Node & {
  __typename?: 'variant_pack_group_members';
  id: Scalars['ID']['output'];
  is_direct_member_group?: Maybe<Scalars['Boolean']['output']>;
  member_variant_pack_group_uuid?: Maybe<Scalars['uuid']['output']>;
  member_variant_pack_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid: Scalars['uuid']['output'];
  /** An object relationship */
  variant_pack?: Maybe<Variants_Packs>;
  /** An object relationship */
  variant_pack_group_member?: Maybe<Variant_Pack_Groups>;
  /** An object relationship */
  variant_pack_group_membership: Variant_Pack_Groups;
  variant_pack_group_uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "variant_pack_group_members" */
export type Variant_Pack_Group_MembersConnection = {
  __typename?: 'variant_pack_group_membersConnection';
  edges: Array<Variant_Pack_Group_MembersEdge>;
  pageInfo: PageInfo;
};

export type Variant_Pack_Group_MembersEdge = {
  __typename?: 'variant_pack_group_membersEdge';
  cursor: Scalars['String']['output'];
  node: Variant_Pack_Group_Members;
};

/** order by aggregate values of table "variant_pack_group_members" */
export type Variant_Pack_Group_Members_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variant_Pack_Group_Members_Max_Order_By>;
  min?: InputMaybe<Variant_Pack_Group_Members_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "variant_pack_group_members". All fields are combined with a logical 'AND'. */
export type Variant_Pack_Group_Members_Bool_Exp = {
  _and?: InputMaybe<Array<Variant_Pack_Group_Members_Bool_Exp>>;
  _not?: InputMaybe<Variant_Pack_Group_Members_Bool_Exp>;
  _or?: InputMaybe<Array<Variant_Pack_Group_Members_Bool_Exp>>;
  is_direct_member_group?: InputMaybe<Boolean_Comparison_Exp>;
  member_variant_pack_group_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  member_variant_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack?: InputMaybe<Variants_Packs_Bool_Exp>;
  variant_pack_group_member?: InputMaybe<Variant_Pack_Groups_Bool_Exp>;
  variant_pack_group_membership?: InputMaybe<Variant_Pack_Groups_Bool_Exp>;
  variant_pack_group_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "variant_pack_group_members" */
export type Variant_Pack_Group_Members_Max_Order_By = {
  member_variant_pack_group_uuid?: InputMaybe<Order_By>;
  member_variant_pack_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_group_uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "variant_pack_group_members" */
export type Variant_Pack_Group_Members_Min_Order_By = {
  member_variant_pack_group_uuid?: InputMaybe<Order_By>;
  member_variant_pack_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_group_uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "variant_pack_group_members". */
export type Variant_Pack_Group_Members_Order_By = {
  is_direct_member_group?: InputMaybe<Order_By>;
  member_variant_pack_group_uuid?: InputMaybe<Order_By>;
  member_variant_pack_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack?: InputMaybe<Variants_Packs_Order_By>;
  variant_pack_group_member?: InputMaybe<Variant_Pack_Groups_Order_By>;
  variant_pack_group_membership?: InputMaybe<Variant_Pack_Groups_Order_By>;
  variant_pack_group_uuid?: InputMaybe<Order_By>;
};

/** select columns of table "variant_pack_group_members" */
export enum Variant_Pack_Group_Members_Select_Column {
  /** column name */
  IsDirectMemberGroup = 'is_direct_member_group',
  /** column name */
  MemberVariantPackGroupUuid = 'member_variant_pack_group_uuid',
  /** column name */
  MemberVariantPackUuid = 'member_variant_pack_uuid',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VariantPackGroupUuid = 'variant_pack_group_uuid'
}

/** columns and relationships of "variant_pack_groups" */
export type Variant_Pack_Groups = Node & {
  __typename?: 'variant_pack_groups';
  /** An array relationship */
  badge_variant_pack_group_rels: Array<Badge_Variant_Pack_Group_Rel>;
  /** An array relationship connection */
  badge_variant_pack_group_rels_connection: Badge_Variant_Pack_Group_RelConnection;
  display_image_url?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  supplier_uuid: Scalars['uuid']['output'];
  type?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['uuid']['output'];
  /** An array relationship */
  variant_pack_group_members: Array<Variant_Pack_Group_Members>;
  /** An array relationship connection */
  variant_pack_group_members_connection: Variant_Pack_Group_MembersConnection;
  /** An array relationship */
  variant_pack_group_memberships: Array<Variant_Pack_Group_Members>;
  /** An array relationship connection */
  variant_pack_group_memberships_connection: Variant_Pack_Group_MembersConnection;
};


/** columns and relationships of "variant_pack_groups" */
export type Variant_Pack_GroupsBadge_Variant_Pack_Group_RelsArgs = {
  distinct_on?: InputMaybe<Array<Badge_Variant_Pack_Group_Rel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Badge_Variant_Pack_Group_Rel_Order_By>>;
  where?: InputMaybe<Badge_Variant_Pack_Group_Rel_Bool_Exp>;
};


/** columns and relationships of "variant_pack_groups" */
export type Variant_Pack_GroupsBadge_Variant_Pack_Group_Rels_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Badge_Variant_Pack_Group_Rel_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Badge_Variant_Pack_Group_Rel_Order_By>>;
  where?: InputMaybe<Badge_Variant_Pack_Group_Rel_Bool_Exp>;
};


/** columns and relationships of "variant_pack_groups" */
export type Variant_Pack_GroupsVariant_Pack_Group_MembersArgs = {
  distinct_on?: InputMaybe<Array<Variant_Pack_Group_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variant_Pack_Group_Members_Order_By>>;
  where?: InputMaybe<Variant_Pack_Group_Members_Bool_Exp>;
};


/** columns and relationships of "variant_pack_groups" */
export type Variant_Pack_GroupsVariant_Pack_Group_Members_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Variant_Pack_Group_Members_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variant_Pack_Group_Members_Order_By>>;
  where?: InputMaybe<Variant_Pack_Group_Members_Bool_Exp>;
};


/** columns and relationships of "variant_pack_groups" */
export type Variant_Pack_GroupsVariant_Pack_Group_MembershipsArgs = {
  distinct_on?: InputMaybe<Array<Variant_Pack_Group_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variant_Pack_Group_Members_Order_By>>;
  where?: InputMaybe<Variant_Pack_Group_Members_Bool_Exp>;
};


/** columns and relationships of "variant_pack_groups" */
export type Variant_Pack_GroupsVariant_Pack_Group_Memberships_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Variant_Pack_Group_Members_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variant_Pack_Group_Members_Order_By>>;
  where?: InputMaybe<Variant_Pack_Group_Members_Bool_Exp>;
};

/** A Relay connection object on "variant_pack_groups" */
export type Variant_Pack_GroupsConnection = {
  __typename?: 'variant_pack_groupsConnection';
  edges: Array<Variant_Pack_GroupsEdge>;
  pageInfo: PageInfo;
};

export type Variant_Pack_GroupsEdge = {
  __typename?: 'variant_pack_groupsEdge';
  cursor: Scalars['String']['output'];
  node: Variant_Pack_Groups;
};

/** Boolean expression to filter rows from the table "variant_pack_groups". All fields are combined with a logical 'AND'. */
export type Variant_Pack_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Variant_Pack_Groups_Bool_Exp>>;
  _not?: InputMaybe<Variant_Pack_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Variant_Pack_Groups_Bool_Exp>>;
  badge_variant_pack_group_rels?: InputMaybe<Badge_Variant_Pack_Group_Rel_Bool_Exp>;
  display_image_url?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack_group_members?: InputMaybe<Variant_Pack_Group_Members_Bool_Exp>;
  variant_pack_group_memberships?: InputMaybe<Variant_Pack_Group_Members_Bool_Exp>;
};

/** Ordering options when selecting data from "variant_pack_groups". */
export type Variant_Pack_Groups_Order_By = {
  badge_variant_pack_group_rels_aggregate?: InputMaybe<Badge_Variant_Pack_Group_Rel_Aggregate_Order_By>;
  display_image_url?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_group_members_aggregate?: InputMaybe<Variant_Pack_Group_Members_Aggregate_Order_By>;
  variant_pack_group_memberships_aggregate?: InputMaybe<Variant_Pack_Group_Members_Aggregate_Order_By>;
};

/** select columns of table "variant_pack_groups" */
export enum Variant_Pack_Groups_Select_Column {
  /** column name */
  DisplayImageUrl = 'display_image_url',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Name = 'name',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  Type = 'type',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "variant_pack_groups" */
export type Variant_Pack_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variant_Pack_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variant_Pack_Groups_Stream_Cursor_Value_Input = {
  display_image_url?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "variant_pack_salt_cache" */
export type Variant_Pack_Salt_Cache = Node & {
  __typename?: 'variant_pack_salt_cache';
  brand_name?: Maybe<Scalars['String']['output']>;
  description_translations?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['ID']['output'];
  image_urls?: Maybe<Scalars['_text']['output']>;
  name_translations?: Maybe<Scalars['jsonb']['output']>;
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "variant_pack_salt_cache" */
export type Variant_Pack_Salt_CacheDescription_TranslationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "variant_pack_salt_cache" */
export type Variant_Pack_Salt_CacheName_TranslationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "variant_pack_salt_cache". All fields are combined with a logical 'AND'. */
export type Variant_Pack_Salt_Cache_Bool_Exp = {
  _and?: InputMaybe<Array<Variant_Pack_Salt_Cache_Bool_Exp>>;
  _not?: InputMaybe<Variant_Pack_Salt_Cache_Bool_Exp>;
  _or?: InputMaybe<Array<Variant_Pack_Salt_Cache_Bool_Exp>>;
  brand_name?: InputMaybe<String_Comparison_Exp>;
  description_translations?: InputMaybe<Jsonb_Comparison_Exp>;
  image_urls?: InputMaybe<_Text_Comparison_Exp>;
  name_translations?: InputMaybe<Jsonb_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "variant_pack_salt_cache". */
export type Variant_Pack_Salt_Cache_Order_By = {
  brand_name?: InputMaybe<Order_By>;
  description_translations?: InputMaybe<Order_By>;
  image_urls?: InputMaybe<Order_By>;
  name_translations?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "variants_packs" */
export type Variants_Packs = Node & {
  __typename?: 'variants_packs';
  availability_status?: Maybe<Scalars['String']['output']>;
  available_quantity?: Maybe<Scalars['float8']['output']>;
  created_by_uuid: Scalars['uuid']['output'];
  credit_request_config?: Maybe<Scalars['jsonb']['output']>;
  daily_hide_at?: Maybe<Scalars['time']['output']>;
  daily_unhide_at?: Maybe<Scalars['time']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  external_item_id?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "variant_pack_gtin_metadata" */
  gtin_metadata?: Maybe<Array<Gtin_Metadata>>;
  id: Scalars['ID']['output'];
  /** An object relationship */
  item: Items;
  item_uuid: Scalars['uuid']['output'];
  lead_time_cutoff_time?: Maybe<Scalars['time']['output']>;
  lead_time_days?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  lead_time_settings?: Maybe<Lead_Time_Settings>;
  lead_time_settings_uuid?: Maybe<Scalars['uuid']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  modifier_options: Array<Variants_Packs_Modifier_Options>;
  /** An array relationship connection */
  modifier_options_connection: Variants_Packs_Modifier_OptionsConnection;
  /** An object relationship */
  order_constraint_rel?: Maybe<Order_Constraint_Variant_Pack_Rel>;
  /** An array relationship */
  order_guides: Array<Order_Guide>;
  /** An array relationship connection */
  order_guides_connection: Order_GuideConnection;
  /** An array relationship */
  orders_items: Array<Orders_Items>;
  /** An aggregate relationship */
  orders_items_aggregate: Orders_Items_Aggregate;
  /** An array relationship connection */
  orders_items_connection: Orders_ItemsConnection;
  /** An object relationship */
  pack: Packs;
  pack_uuid: Scalars['uuid']['output'];
  prebook_config?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  restaurant_variant_pack_overrides: Array<Restaurant_Variant_Pack_Overrides>;
  /** An array relationship connection */
  restaurant_variant_pack_overrides_connection: Restaurant_Variant_Pack_OverridesConnection;
  salt: ItemInfoWithVpUuidType;
  /** An object relationship */
  salt_cache?: Maybe<Variant_Pack_Salt_Cache>;
  salt_id: Scalars['uuid']['output'];
  /** An object relationship */
  supplier: Businesses;
  supplier_uuid: Scalars['uuid']['output'];
  upc_list?: Maybe<Scalars['_text']['output']>;
  uuid: Scalars['uuid']['output'];
  /** An array relationship */
  variant_pack_group_memberships: Array<Variant_Pack_Group_Members>;
  /** An array relationship connection */
  variant_pack_group_memberships_connection: Variant_Pack_Group_MembersConnection;
  /** An object relationship */
  visible_variant_pack?: Maybe<Visible_Variant_Packs>;
};


/** columns and relationships of "variants_packs" */
export type Variants_PacksCredit_Request_ConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "variants_packs" */
export type Variants_PacksGtin_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Gtin_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gtin_Metadata_Order_By>>;
  where?: InputMaybe<Gtin_Metadata_Bool_Exp>;
};


/** columns and relationships of "variants_packs" */
export type Variants_PacksMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "variants_packs" */
export type Variants_PacksModifier_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Variants_Packs_Modifier_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variants_Packs_Modifier_Options_Order_By>>;
  where?: InputMaybe<Variants_Packs_Modifier_Options_Bool_Exp>;
};


/** columns and relationships of "variants_packs" */
export type Variants_PacksModifier_Options_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Variants_Packs_Modifier_Options_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variants_Packs_Modifier_Options_Order_By>>;
  where?: InputMaybe<Variants_Packs_Modifier_Options_Bool_Exp>;
};


/** columns and relationships of "variants_packs" */
export type Variants_PacksOrder_GuidesArgs = {
  distinct_on?: InputMaybe<Array<Order_Guide_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Guide_Order_By>>;
  where?: InputMaybe<Order_Guide_Bool_Exp>;
};


/** columns and relationships of "variants_packs" */
export type Variants_PacksOrder_Guides_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Order_Guide_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Guide_Order_By>>;
  where?: InputMaybe<Order_Guide_Bool_Exp>;
};


/** columns and relationships of "variants_packs" */
export type Variants_PacksOrders_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Orders_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Items_Order_By>>;
  where?: InputMaybe<Orders_Items_Bool_Exp>;
};


/** columns and relationships of "variants_packs" */
export type Variants_PacksOrders_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Items_Order_By>>;
  where?: InputMaybe<Orders_Items_Bool_Exp>;
};


/** columns and relationships of "variants_packs" */
export type Variants_PacksOrders_Items_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Orders_Items_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Items_Order_By>>;
  where?: InputMaybe<Orders_Items_Bool_Exp>;
};


/** columns and relationships of "variants_packs" */
export type Variants_PacksPrebook_ConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "variants_packs" */
export type Variants_PacksRestaurant_Variant_Pack_OverridesArgs = {
  distinct_on?: InputMaybe<Array<Restaurant_Variant_Pack_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Variant_Pack_Overrides_Order_By>>;
  where?: InputMaybe<Restaurant_Variant_Pack_Overrides_Bool_Exp>;
};


/** columns and relationships of "variants_packs" */
export type Variants_PacksRestaurant_Variant_Pack_Overrides_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Restaurant_Variant_Pack_Overrides_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Restaurant_Variant_Pack_Overrides_Order_By>>;
  where?: InputMaybe<Restaurant_Variant_Pack_Overrides_Bool_Exp>;
};


/** columns and relationships of "variants_packs" */
export type Variants_PacksSaltArgs = {
  locale?: Scalars['String']['input'];
  restaurantId: Scalars['uuid']['input'];
};


/** columns and relationships of "variants_packs" */
export type Variants_PacksVariant_Pack_Group_MembershipsArgs = {
  distinct_on?: InputMaybe<Array<Variant_Pack_Group_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variant_Pack_Group_Members_Order_By>>;
  where?: InputMaybe<Variant_Pack_Group_Members_Bool_Exp>;
};


/** columns and relationships of "variants_packs" */
export type Variants_PacksVariant_Pack_Group_Memberships_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distinct_on?: InputMaybe<Array<Variant_Pack_Group_Members_Select_Column>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variant_Pack_Group_Members_Order_By>>;
  where?: InputMaybe<Variant_Pack_Group_Members_Bool_Exp>;
};

/** A Relay connection object on "variants_packs" */
export type Variants_PacksConnection = {
  __typename?: 'variants_packsConnection';
  edges: Array<Variants_PacksEdge>;
  pageInfo: PageInfo;
};

export type Variants_PacksEdge = {
  __typename?: 'variants_packsEdge';
  cursor: Scalars['String']['output'];
  node: Variants_Packs;
};

/** aggregated selection of "variants_packs" */
export type Variants_Packs_Aggregate = {
  __typename?: 'variants_packs_aggregate';
  aggregate?: Maybe<Variants_Packs_Aggregate_Fields>;
  nodes: Array<Variants_Packs>;
};

/** aggregate fields of "variants_packs" */
export type Variants_Packs_Aggregate_Fields = {
  __typename?: 'variants_packs_aggregate_fields';
  avg?: Maybe<Variants_Packs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variants_Packs_Max_Fields>;
  min?: Maybe<Variants_Packs_Min_Fields>;
  stddev?: Maybe<Variants_Packs_Stddev_Fields>;
  stddev_pop?: Maybe<Variants_Packs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variants_Packs_Stddev_Samp_Fields>;
  sum?: Maybe<Variants_Packs_Sum_Fields>;
  var_pop?: Maybe<Variants_Packs_Var_Pop_Fields>;
  var_samp?: Maybe<Variants_Packs_Var_Samp_Fields>;
  variance?: Maybe<Variants_Packs_Variance_Fields>;
};


/** aggregate fields of "variants_packs" */
export type Variants_Packs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variants_Packs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "variants_packs" */
export type Variants_Packs_Aggregate_Order_By = {
  avg?: InputMaybe<Variants_Packs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variants_Packs_Max_Order_By>;
  min?: InputMaybe<Variants_Packs_Min_Order_By>;
  stddev?: InputMaybe<Variants_Packs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Variants_Packs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Variants_Packs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Variants_Packs_Sum_Order_By>;
  var_pop?: InputMaybe<Variants_Packs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Variants_Packs_Var_Samp_Order_By>;
  variance?: InputMaybe<Variants_Packs_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Variants_Packs_Avg_Fields = {
  __typename?: 'variants_packs_avg_fields';
  available_quantity?: Maybe<Scalars['Float']['output']>;
  lead_time_days?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "variants_packs" */
export type Variants_Packs_Avg_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  lead_time_days?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "variants_packs". All fields are combined with a logical 'AND'. */
export type Variants_Packs_Bool_Exp = {
  _and?: InputMaybe<Array<Variants_Packs_Bool_Exp>>;
  _not?: InputMaybe<Variants_Packs_Bool_Exp>;
  _or?: InputMaybe<Array<Variants_Packs_Bool_Exp>>;
  availability_status?: InputMaybe<String_Comparison_Exp>;
  available_quantity?: InputMaybe<Float8_Comparison_Exp>;
  created_by_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  credit_request_config?: InputMaybe<Jsonb_Comparison_Exp>;
  daily_hide_at?: InputMaybe<Time_Comparison_Exp>;
  daily_unhide_at?: InputMaybe<Time_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  external_item_id?: InputMaybe<String_Comparison_Exp>;
  gtin_metadata?: InputMaybe<Gtin_Metadata_Bool_Exp>;
  item?: InputMaybe<Items_Bool_Exp>;
  item_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  lead_time_cutoff_time?: InputMaybe<Time_Comparison_Exp>;
  lead_time_days?: InputMaybe<Int_Comparison_Exp>;
  lead_time_settings?: InputMaybe<Lead_Time_Settings_Bool_Exp>;
  lead_time_settings_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  modifier_options?: InputMaybe<Variants_Packs_Modifier_Options_Bool_Exp>;
  order_constraint_rel?: InputMaybe<Order_Constraint_Variant_Pack_Rel_Bool_Exp>;
  order_guides?: InputMaybe<Order_Guide_Bool_Exp>;
  orders_items?: InputMaybe<Orders_Items_Bool_Exp>;
  pack?: InputMaybe<Packs_Bool_Exp>;
  pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  prebook_config?: InputMaybe<Jsonb_Comparison_Exp>;
  restaurant_variant_pack_overrides?: InputMaybe<Restaurant_Variant_Pack_Overrides_Bool_Exp>;
  salt_cache?: InputMaybe<Variant_Pack_Salt_Cache_Bool_Exp>;
  salt_id?: InputMaybe<Uuid_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  upc_list?: InputMaybe<_Text_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack_group_memberships?: InputMaybe<Variant_Pack_Group_Members_Bool_Exp>;
  visible_variant_pack?: InputMaybe<Visible_Variant_Packs_Bool_Exp>;
};

/** aggregate max on columns */
export type Variants_Packs_Max_Fields = {
  __typename?: 'variants_packs_max_fields';
  availability_status?: Maybe<Scalars['String']['output']>;
  available_quantity?: Maybe<Scalars['float8']['output']>;
  created_by_uuid?: Maybe<Scalars['uuid']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  external_item_id?: Maybe<Scalars['String']['output']>;
  item_uuid?: Maybe<Scalars['uuid']['output']>;
  lead_time_days?: Maybe<Scalars['Int']['output']>;
  lead_time_settings_uuid?: Maybe<Scalars['uuid']['output']>;
  pack_uuid?: Maybe<Scalars['uuid']['output']>;
  salt_id?: Maybe<Scalars['uuid']['output']>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "variants_packs" */
export type Variants_Packs_Max_Order_By = {
  availability_status?: InputMaybe<Order_By>;
  available_quantity?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  external_item_id?: InputMaybe<Order_By>;
  item_uuid?: InputMaybe<Order_By>;
  lead_time_days?: InputMaybe<Order_By>;
  lead_time_settings_uuid?: InputMaybe<Order_By>;
  pack_uuid?: InputMaybe<Order_By>;
  salt_id?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Variants_Packs_Min_Fields = {
  __typename?: 'variants_packs_min_fields';
  availability_status?: Maybe<Scalars['String']['output']>;
  available_quantity?: Maybe<Scalars['float8']['output']>;
  created_by_uuid?: Maybe<Scalars['uuid']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  external_item_id?: Maybe<Scalars['String']['output']>;
  item_uuid?: Maybe<Scalars['uuid']['output']>;
  lead_time_days?: Maybe<Scalars['Int']['output']>;
  lead_time_settings_uuid?: Maybe<Scalars['uuid']['output']>;
  pack_uuid?: Maybe<Scalars['uuid']['output']>;
  salt_id?: Maybe<Scalars['uuid']['output']>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "variants_packs" */
export type Variants_Packs_Min_Order_By = {
  availability_status?: InputMaybe<Order_By>;
  available_quantity?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  external_item_id?: InputMaybe<Order_By>;
  item_uuid?: InputMaybe<Order_By>;
  lead_time_days?: InputMaybe<Order_By>;
  lead_time_settings_uuid?: InputMaybe<Order_By>;
  pack_uuid?: InputMaybe<Order_By>;
  salt_id?: InputMaybe<Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** columns and relationships of "variants_packs_modifier_options" */
export type Variants_Packs_Modifier_Options = Node & {
  __typename?: 'variants_packs_modifier_options';
  id: Scalars['ID']['output'];
  /** An object relationship */
  modifier_option: Modifier_Options;
  modifier_option_uuid: Scalars['uuid']['output'];
  uuid: Scalars['uuid']['output'];
  /** An object relationship */
  variant_pack: Variants_Packs;
  variant_pack_uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "variants_packs_modifier_options" */
export type Variants_Packs_Modifier_OptionsConnection = {
  __typename?: 'variants_packs_modifier_optionsConnection';
  edges: Array<Variants_Packs_Modifier_OptionsEdge>;
  pageInfo: PageInfo;
};

export type Variants_Packs_Modifier_OptionsEdge = {
  __typename?: 'variants_packs_modifier_optionsEdge';
  cursor: Scalars['String']['output'];
  node: Variants_Packs_Modifier_Options;
};

/** order by aggregate values of table "variants_packs_modifier_options" */
export type Variants_Packs_Modifier_Options_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variants_Packs_Modifier_Options_Max_Order_By>;
  min?: InputMaybe<Variants_Packs_Modifier_Options_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "variants_packs_modifier_options". All fields are combined with a logical 'AND'. */
export type Variants_Packs_Modifier_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Variants_Packs_Modifier_Options_Bool_Exp>>;
  _not?: InputMaybe<Variants_Packs_Modifier_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Variants_Packs_Modifier_Options_Bool_Exp>>;
  modifier_option?: InputMaybe<Modifier_Options_Bool_Exp>;
  modifier_option_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack?: InputMaybe<Variants_Packs_Bool_Exp>;
  variant_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "variants_packs_modifier_options" */
export type Variants_Packs_Modifier_Options_Max_Order_By = {
  modifier_option_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "variants_packs_modifier_options" */
export type Variants_Packs_Modifier_Options_Min_Order_By = {
  modifier_option_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "variants_packs_modifier_options". */
export type Variants_Packs_Modifier_Options_Order_By = {
  modifier_option?: InputMaybe<Modifier_Options_Order_By>;
  modifier_option_uuid?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack?: InputMaybe<Variants_Packs_Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** select columns of table "variants_packs_modifier_options" */
export enum Variants_Packs_Modifier_Options_Select_Column {
  /** column name */
  ModifierOptionUuid = 'modifier_option_uuid',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  VariantPackUuid = 'variant_pack_uuid'
}

/** Ordering options when selecting data from "variants_packs". */
export type Variants_Packs_Order_By = {
  availability_status?: InputMaybe<Order_By>;
  available_quantity?: InputMaybe<Order_By>;
  created_by_uuid?: InputMaybe<Order_By>;
  credit_request_config?: InputMaybe<Order_By>;
  daily_hide_at?: InputMaybe<Order_By>;
  daily_unhide_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  external_item_id?: InputMaybe<Order_By>;
  gtin_metadata_aggregate?: InputMaybe<Gtin_Metadata_Aggregate_Order_By>;
  item?: InputMaybe<Items_Order_By>;
  item_uuid?: InputMaybe<Order_By>;
  lead_time_cutoff_time?: InputMaybe<Order_By>;
  lead_time_days?: InputMaybe<Order_By>;
  lead_time_settings?: InputMaybe<Lead_Time_Settings_Order_By>;
  lead_time_settings_uuid?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  modifier_options_aggregate?: InputMaybe<Variants_Packs_Modifier_Options_Aggregate_Order_By>;
  order_constraint_rel?: InputMaybe<Order_Constraint_Variant_Pack_Rel_Order_By>;
  order_guides_aggregate?: InputMaybe<Order_Guide_Aggregate_Order_By>;
  orders_items_aggregate?: InputMaybe<Orders_Items_Aggregate_Order_By>;
  pack?: InputMaybe<Packs_Order_By>;
  pack_uuid?: InputMaybe<Order_By>;
  prebook_config?: InputMaybe<Order_By>;
  restaurant_variant_pack_overrides_aggregate?: InputMaybe<Restaurant_Variant_Pack_Overrides_Aggregate_Order_By>;
  salt_cache?: InputMaybe<Variant_Pack_Salt_Cache_Order_By>;
  salt_id?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  upc_list?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  variant_pack_group_memberships_aggregate?: InputMaybe<Variant_Pack_Group_Members_Aggregate_Order_By>;
  visible_variant_pack?: InputMaybe<Visible_Variant_Packs_Order_By>;
};

/** select columns of table "variants_packs" */
export enum Variants_Packs_Select_Column {
  /** column name */
  AvailabilityStatus = 'availability_status',
  /** column name */
  AvailableQuantity = 'available_quantity',
  /** column name */
  CreatedByUuid = 'created_by_uuid',
  /** column name */
  CreditRequestConfig = 'credit_request_config',
  /** column name */
  DailyHideAt = 'daily_hide_at',
  /** column name */
  DailyUnhideAt = 'daily_unhide_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  ExternalItemId = 'external_item_id',
  /** column name */
  ItemUuid = 'item_uuid',
  /** column name */
  LeadTimeCutoffTime = 'lead_time_cutoff_time',
  /** column name */
  LeadTimeDays = 'lead_time_days',
  /** column name */
  LeadTimeSettingsUuid = 'lead_time_settings_uuid',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PackUuid = 'pack_uuid',
  /** column name */
  PrebookConfig = 'prebook_config',
  /** column name */
  SaltId = 'salt_id',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  UpcList = 'upc_list',
  /** column name */
  Uuid = 'uuid'
}

/** aggregate stddev on columns */
export type Variants_Packs_Stddev_Fields = {
  __typename?: 'variants_packs_stddev_fields';
  available_quantity?: Maybe<Scalars['Float']['output']>;
  lead_time_days?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "variants_packs" */
export type Variants_Packs_Stddev_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  lead_time_days?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Variants_Packs_Stddev_Pop_Fields = {
  __typename?: 'variants_packs_stddev_pop_fields';
  available_quantity?: Maybe<Scalars['Float']['output']>;
  lead_time_days?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "variants_packs" */
export type Variants_Packs_Stddev_Pop_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  lead_time_days?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Variants_Packs_Stddev_Samp_Fields = {
  __typename?: 'variants_packs_stddev_samp_fields';
  available_quantity?: Maybe<Scalars['Float']['output']>;
  lead_time_days?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "variants_packs" */
export type Variants_Packs_Stddev_Samp_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  lead_time_days?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "variants_packs" */
export type Variants_Packs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variants_Packs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variants_Packs_Stream_Cursor_Value_Input = {
  availability_status?: InputMaybe<Scalars['String']['input']>;
  available_quantity?: InputMaybe<Scalars['float8']['input']>;
  created_by_uuid?: InputMaybe<Scalars['uuid']['input']>;
  credit_request_config?: InputMaybe<Scalars['jsonb']['input']>;
  daily_hide_at?: InputMaybe<Scalars['time']['input']>;
  daily_unhide_at?: InputMaybe<Scalars['time']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_item_id?: InputMaybe<Scalars['String']['input']>;
  item_uuid?: InputMaybe<Scalars['uuid']['input']>;
  lead_time_cutoff_time?: InputMaybe<Scalars['time']['input']>;
  lead_time_days?: InputMaybe<Scalars['Int']['input']>;
  lead_time_settings_uuid?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  pack_uuid?: InputMaybe<Scalars['uuid']['input']>;
  prebook_config?: InputMaybe<Scalars['jsonb']['input']>;
  salt_id?: InputMaybe<Scalars['uuid']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  upc_list?: InputMaybe<Scalars['_text']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "variants_packs_substitution_suppliers" */
export type Variants_Packs_Substitution_Suppliers = Node & {
  __typename?: 'variants_packs_substitution_suppliers';
  id: Scalars['ID']['output'];
  sort_order?: Maybe<Scalars['float8']['output']>;
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "variants_packs_substitution_suppliers" */
export type Variants_Packs_Substitution_SuppliersConnection = {
  __typename?: 'variants_packs_substitution_suppliersConnection';
  edges: Array<Variants_Packs_Substitution_SuppliersEdge>;
  pageInfo: PageInfo;
};

export type Variants_Packs_Substitution_SuppliersEdge = {
  __typename?: 'variants_packs_substitution_suppliersEdge';
  cursor: Scalars['String']['output'];
  node: Variants_Packs_Substitution_Suppliers;
};

/** Boolean expression to filter rows from the table "variants_packs_substitution_suppliers". All fields are combined with a logical 'AND'. */
export type Variants_Packs_Substitution_Suppliers_Bool_Exp = {
  _and?: InputMaybe<Array<Variants_Packs_Substitution_Suppliers_Bool_Exp>>;
  _not?: InputMaybe<Variants_Packs_Substitution_Suppliers_Bool_Exp>;
  _or?: InputMaybe<Array<Variants_Packs_Substitution_Suppliers_Bool_Exp>>;
  sort_order?: InputMaybe<Float8_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "variants_packs_substitution_suppliers". */
export type Variants_Packs_Substitution_Suppliers_Order_By = {
  sort_order?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "variants_packs_substitution_suppliers" */
export enum Variants_Packs_Substitution_Suppliers_Select_Column {
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "variants_packs_substitution_suppliers" */
export type Variants_Packs_Substitution_Suppliers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variants_Packs_Substitution_Suppliers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variants_Packs_Substitution_Suppliers_Stream_Cursor_Value_Input = {
  sort_order?: InputMaybe<Scalars['float8']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Variants_Packs_Sum_Fields = {
  __typename?: 'variants_packs_sum_fields';
  available_quantity?: Maybe<Scalars['float8']['output']>;
  lead_time_days?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "variants_packs" */
export type Variants_Packs_Sum_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  lead_time_days?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Variants_Packs_Var_Pop_Fields = {
  __typename?: 'variants_packs_var_pop_fields';
  available_quantity?: Maybe<Scalars['Float']['output']>;
  lead_time_days?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "variants_packs" */
export type Variants_Packs_Var_Pop_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  lead_time_days?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Variants_Packs_Var_Samp_Fields = {
  __typename?: 'variants_packs_var_samp_fields';
  available_quantity?: Maybe<Scalars['Float']['output']>;
  lead_time_days?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "variants_packs" */
export type Variants_Packs_Var_Samp_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  lead_time_days?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Variants_Packs_Variance_Fields = {
  __typename?: 'variants_packs_variance_fields';
  available_quantity?: Maybe<Scalars['Float']['output']>;
  lead_time_days?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "variants_packs" */
export type Variants_Packs_Variance_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  lead_time_days?: InputMaybe<Order_By>;
};

/** columns and relationships of "visible_variant_packs" */
export type Visible_Variant_Packs = {
  __typename?: 'visible_variant_packs';
  category?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  chat?: Maybe<Chats>;
  chat_uuid?: Maybe<Scalars['uuid']['output']>;
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  supplier?: Maybe<Businesses>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  variant_pack?: Maybe<Variants_Packs>;
  variant_pack_uuid?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "visible_variant_packs" */
export type Visible_Variant_Packs_Aggregate = {
  __typename?: 'visible_variant_packs_aggregate';
  aggregate?: Maybe<Visible_Variant_Packs_Aggregate_Fields>;
  nodes: Array<Visible_Variant_Packs>;
};

/** aggregate fields of "visible_variant_packs" */
export type Visible_Variant_Packs_Aggregate_Fields = {
  __typename?: 'visible_variant_packs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Visible_Variant_Packs_Max_Fields>;
  min?: Maybe<Visible_Variant_Packs_Min_Fields>;
};


/** aggregate fields of "visible_variant_packs" */
export type Visible_Variant_Packs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Visible_Variant_Packs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "visible_variant_packs". All fields are combined with a logical 'AND'. */
export type Visible_Variant_Packs_Bool_Exp = {
  _and?: InputMaybe<Array<Visible_Variant_Packs_Bool_Exp>>;
  _not?: InputMaybe<Visible_Variant_Packs_Bool_Exp>;
  _or?: InputMaybe<Array<Visible_Variant_Packs_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  chat?: InputMaybe<Chats_Bool_Exp>;
  chat_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  restaurant_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  supplier?: InputMaybe<Businesses_Bool_Exp>;
  supplier_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  variant_pack?: InputMaybe<Variants_Packs_Bool_Exp>;
  variant_pack_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Visible_Variant_Packs_Max_Fields = {
  __typename?: 'visible_variant_packs_max_fields';
  category?: Maybe<Scalars['String']['output']>;
  chat_uuid?: Maybe<Scalars['uuid']['output']>;
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  variant_pack_uuid?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Visible_Variant_Packs_Min_Fields = {
  __typename?: 'visible_variant_packs_min_fields';
  category?: Maybe<Scalars['String']['output']>;
  chat_uuid?: Maybe<Scalars['uuid']['output']>;
  restaurant_uuid?: Maybe<Scalars['uuid']['output']>;
  supplier_uuid?: Maybe<Scalars['uuid']['output']>;
  variant_pack_uuid?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "visible_variant_packs". */
export type Visible_Variant_Packs_Order_By = {
  category?: InputMaybe<Order_By>;
  chat?: InputMaybe<Chats_Order_By>;
  chat_uuid?: InputMaybe<Order_By>;
  restaurant_uuid?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Businesses_Order_By>;
  supplier_uuid?: InputMaybe<Order_By>;
  variant_pack?: InputMaybe<Variants_Packs_Order_By>;
  variant_pack_uuid?: InputMaybe<Order_By>;
};

/** select columns of table "visible_variant_packs" */
export enum Visible_Variant_Packs_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  ChatUuid = 'chat_uuid',
  /** column name */
  RestaurantUuid = 'restaurant_uuid',
  /** column name */
  SupplierUuid = 'supplier_uuid',
  /** column name */
  VariantPackUuid = 'variant_pack_uuid'
}

/** Streaming cursor of the table "visible_variant_packs" */
export type Visible_Variant_Packs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Visible_Variant_Packs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Visible_Variant_Packs_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  chat_uuid?: InputMaybe<Scalars['uuid']['input']>;
  restaurant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  supplier_uuid?: InputMaybe<Scalars['uuid']['input']>;
  variant_pack_uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "whitelabel_config" */
export type Whitelabel_Config = Node & {
  __typename?: 'whitelabel_config';
  app_background_image_url?: Maybe<Scalars['String']['output']>;
  app_background_landscape_video_url?: Maybe<Scalars['String']['output']>;
  app_background_video_url?: Maybe<Scalars['String']['output']>;
  app_landing_logo_image?: Maybe<Scalars['String']['output']>;
  become_customer_url?: Maybe<Scalars['String']['output']>;
  business_organization_uuid: Scalars['uuid']['output'];
  cms_enabled?: Maybe<Scalars['Boolean']['output']>;
  default_login_method?: Maybe<Scalars['String']['output']>;
  guest_mode_enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  ios_icon_image: Scalars['String']['output'];
  login_methods?: Maybe<Scalars['_text']['output']>;
  login_request_enabled?: Maybe<Scalars['Boolean']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  translations_enabled?: Maybe<Scalars['Boolean']['output']>;
  universal_app_download_link?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['uuid']['output'];
};

/** A Relay connection object on "whitelabel_config" */
export type Whitelabel_ConfigConnection = {
  __typename?: 'whitelabel_configConnection';
  edges: Array<Whitelabel_ConfigEdge>;
  pageInfo: PageInfo;
};

export type Whitelabel_ConfigEdge = {
  __typename?: 'whitelabel_configEdge';
  cursor: Scalars['String']['output'];
  node: Whitelabel_Config;
};

/** order by aggregate values of table "whitelabel_config" */
export type Whitelabel_Config_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Whitelabel_Config_Max_Order_By>;
  min?: InputMaybe<Whitelabel_Config_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "whitelabel_config". All fields are combined with a logical 'AND'. */
export type Whitelabel_Config_Bool_Exp = {
  _and?: InputMaybe<Array<Whitelabel_Config_Bool_Exp>>;
  _not?: InputMaybe<Whitelabel_Config_Bool_Exp>;
  _or?: InputMaybe<Array<Whitelabel_Config_Bool_Exp>>;
  app_background_image_url?: InputMaybe<String_Comparison_Exp>;
  app_background_landscape_video_url?: InputMaybe<String_Comparison_Exp>;
  app_background_video_url?: InputMaybe<String_Comparison_Exp>;
  app_landing_logo_image?: InputMaybe<String_Comparison_Exp>;
  become_customer_url?: InputMaybe<String_Comparison_Exp>;
  business_organization_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  cms_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  default_login_method?: InputMaybe<String_Comparison_Exp>;
  guest_mode_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  ios_icon_image?: InputMaybe<String_Comparison_Exp>;
  login_methods?: InputMaybe<_Text_Comparison_Exp>;
  login_request_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  tagline?: InputMaybe<String_Comparison_Exp>;
  translations_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  universal_app_download_link?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "whitelabel_config" */
export type Whitelabel_Config_Max_Order_By = {
  app_background_image_url?: InputMaybe<Order_By>;
  app_background_landscape_video_url?: InputMaybe<Order_By>;
  app_background_video_url?: InputMaybe<Order_By>;
  app_landing_logo_image?: InputMaybe<Order_By>;
  become_customer_url?: InputMaybe<Order_By>;
  business_organization_uuid?: InputMaybe<Order_By>;
  default_login_method?: InputMaybe<Order_By>;
  ios_icon_image?: InputMaybe<Order_By>;
  tagline?: InputMaybe<Order_By>;
  universal_app_download_link?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "whitelabel_config" */
export type Whitelabel_Config_Min_Order_By = {
  app_background_image_url?: InputMaybe<Order_By>;
  app_background_landscape_video_url?: InputMaybe<Order_By>;
  app_background_video_url?: InputMaybe<Order_By>;
  app_landing_logo_image?: InputMaybe<Order_By>;
  become_customer_url?: InputMaybe<Order_By>;
  business_organization_uuid?: InputMaybe<Order_By>;
  default_login_method?: InputMaybe<Order_By>;
  ios_icon_image?: InputMaybe<Order_By>;
  tagline?: InputMaybe<Order_By>;
  universal_app_download_link?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "whitelabel_config". */
export type Whitelabel_Config_Order_By = {
  app_background_image_url?: InputMaybe<Order_By>;
  app_background_landscape_video_url?: InputMaybe<Order_By>;
  app_background_video_url?: InputMaybe<Order_By>;
  app_landing_logo_image?: InputMaybe<Order_By>;
  become_customer_url?: InputMaybe<Order_By>;
  business_organization_uuid?: InputMaybe<Order_By>;
  cms_enabled?: InputMaybe<Order_By>;
  default_login_method?: InputMaybe<Order_By>;
  guest_mode_enabled?: InputMaybe<Order_By>;
  ios_icon_image?: InputMaybe<Order_By>;
  login_methods?: InputMaybe<Order_By>;
  login_request_enabled?: InputMaybe<Order_By>;
  tagline?: InputMaybe<Order_By>;
  translations_enabled?: InputMaybe<Order_By>;
  universal_app_download_link?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "whitelabel_config" */
export enum Whitelabel_Config_Select_Column {
  /** column name */
  AppBackgroundImageUrl = 'app_background_image_url',
  /** column name */
  AppBackgroundLandscapeVideoUrl = 'app_background_landscape_video_url',
  /** column name */
  AppBackgroundVideoUrl = 'app_background_video_url',
  /** column name */
  AppLandingLogoImage = 'app_landing_logo_image',
  /** column name */
  BecomeCustomerUrl = 'become_customer_url',
  /** column name */
  BusinessOrganizationUuid = 'business_organization_uuid',
  /** column name */
  CmsEnabled = 'cms_enabled',
  /** column name */
  DefaultLoginMethod = 'default_login_method',
  /** column name */
  GuestModeEnabled = 'guest_mode_enabled',
  /** column name */
  IosIconImage = 'ios_icon_image',
  /** column name */
  LoginMethods = 'login_methods',
  /** column name */
  LoginRequestEnabled = 'login_request_enabled',
  /** column name */
  Tagline = 'tagline',
  /** column name */
  TranslationsEnabled = 'translations_enabled',
  /** column name */
  UniversalAppDownloadLink = 'universal_app_download_link',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "whitelabel_config" */
export type Whitelabel_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Whitelabel_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Whitelabel_Config_Stream_Cursor_Value_Input = {
  app_background_image_url?: InputMaybe<Scalars['String']['input']>;
  app_background_landscape_video_url?: InputMaybe<Scalars['String']['input']>;
  app_background_video_url?: InputMaybe<Scalars['String']['input']>;
  app_landing_logo_image?: InputMaybe<Scalars['String']['input']>;
  become_customer_url?: InputMaybe<Scalars['String']['input']>;
  business_organization_uuid?: InputMaybe<Scalars['uuid']['input']>;
  cms_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  default_login_method?: InputMaybe<Scalars['String']['input']>;
  guest_mode_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  ios_icon_image?: InputMaybe<Scalars['String']['input']>;
  login_methods?: InputMaybe<Scalars['_text']['input']>;
  login_request_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  translations_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  universal_app_download_link?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

export type AvailabilityTimeslotSettingsFragment = { __typename?: 'FulfillmentTimeslotSettings', default_selection: FulfillmentTimeslotSelection, lead_time_minutes?: number | null, selection_required: boolean, timeslots: Array<{ __typename?: 'FulfillmentTimeslotEntry', end_time: string, start_time: string }> };

export type AvailabilityDayFragment = { __typename?: 'OrderFulfillmentAvailability', cutoff_time?: string | null, date: string, lead_time_days?: number | null, order_minimum_display_string?: string | null, timeslot_settings?: { __typename?: 'FulfillmentTimeslotSettings', default_selection: FulfillmentTimeslotSelection, lead_time_minutes?: number | null, selection_required: boolean, timeslots: Array<{ __typename?: 'FulfillmentTimeslotEntry', end_time: string, start_time: string }> } | null };

export type AvailableOrderFulfillmentFieldsFragment = { __typename?: 'GetAvailableOrderFulfillmentResponse', default_cutoff_time?: string | null, default_lead_time_days?: number | null, fulfillment_disclaimer?: string | null, fulfillment_display_name?: string | null, fulfillment_name: FulfillmentName, fulfillment_settings_id: string, fulfillment_type: FulfillmentType, order_minimum_display_string?: string | null, primary_fulfillment_settings_id?: string | null, availability: Array<{ __typename?: 'OrderFulfillmentAvailability', cutoff_time?: string | null, date: string, lead_time_days?: number | null, order_minimum_display_string?: string | null, timeslot_settings?: { __typename?: 'FulfillmentTimeslotSettings', default_selection: FulfillmentTimeslotSelection, lead_time_minutes?: number | null, selection_required: boolean, timeslots: Array<{ __typename?: 'FulfillmentTimeslotEntry', end_time: string, start_time: string }> } | null }> };

export type AddressInputFieldsFragment = { __typename?: 'addresses', address: string, address2?: string | null, city: string, country_code: string, latitude: number, longitude: number, region?: string | null, uuid: string };

export type SampleRequest_RestaurantAddressQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
}>;


export type SampleRequest_RestaurantAddressQuery = { __typename?: 'query_root', businesses_by_pk?: { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', address: string, address2?: string | null, city: string, country_code: string, latitude: number, longitude: number, region?: string | null, uuid: string } } | null };

export type SampleRequest_SubmitMutationVariables = Exact<{
  adCampaignUUID: Scalars['uuid']['input'];
  contactInfo?: InputMaybe<RequestContactInfo>;
  formSubmitEventPayload: AdEventInput;
  qualificationResponses?: InputMaybe<Array<QualificationResponse> | QualificationResponse>;
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPackUUID: Scalars['uuid']['input'];
}>;


export type SampleRequest_SubmitMutation = { __typename?: 'mutation_root', requestASample: { __typename?: 'RequestASampleResponse', sample_request?: { __typename?: 'sample_requests', contact_email?: string | null, follow_up_response?: any | null, follow_up_submitted_at?: string | null, qualified_at?: string | null, requested_at: string, status: string, uuid: string, address?: { __typename?: 'addresses', address: string, address2?: string | null, city: string, country_code: string, latitude: number, longitude: number, region?: string | null, uuid: string } | null, requested_by: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', name?: string | null, uuid: string }> } } | null } };

export type BrandPageLinkFieldsFragment = { __typename?: 'brand_pages', brand_name: string, logo_image_url?: string | null, uuid: string };

export type BrandPage_VariantPacksViewQueryVariables = Exact<{
  variantPackUUID: Scalars['uuid']['input'];
}>;


export type BrandPage_VariantPacksViewQuery = { __typename?: 'query_root', brand_page_variant_packs: Array<{ __typename?: 'brand_page_variant_packs', uuid?: string | null, brand_page?: { __typename?: 'brand_pages', brand_name: string, logo_image_url?: string | null, uuid: string } | null }> };

export type Start_CheckInMutationVariables = Exact<{
  invoiceUUID: Scalars['uuid']['input'];
}>;


export type Start_CheckInMutation = { __typename?: 'mutation_root', retrieveOrderInvoiceCheckInItems: { __typename?: 'RetrieveOrderCheckInResponse', order_invoice_check_in?: { __typename?: 'order_invoice_check_ins', completed_at?: string | null, uuid: string } | null } };

export type CreditRequest_VariantPackInvoicesQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPackUUID: Scalars['uuid']['input'];
}>;


export type CreditRequest_VariantPackInvoicesQuery = { __typename?: 'query_root', getVariantPackInvoicesForCreditRequest: { __typename?: 'GetVariantPackInvoicesForCreditRequestResponse', invoices: Array<{ __typename?: 'VariantPackCreditRequestInvoice', available_quantity_for_credit?: number | null, date: string, quantity: number, unit_price_in_micros: number, id: string, number: string }>, other_creditable_uoms?: Array<{ __typename?: 'VariantPackCreditRequestUOM', uom: PackUnit, quantity: number }> | null } };

export type GetCreditRequestReasonsQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
}>;


export type GetCreditRequestReasonsQuery = { __typename?: 'query_root', credit_request_reasons: Array<{ __typename?: 'credit_request_reasons', invoice_required: boolean, request_period_days?: any | null, type: string, uuid: string, title: any }> };

export type CreditRequestItemFieldsFragment = { __typename?: 'items', display_name: string, name: string, uuid: string };

export type CreditRequestVariantPackFieldsFragment = { __typename?: 'variants_packs', uuid: string, pack: { __typename?: 'packs', unit: string, uuid: string }, item: { __typename?: 'items', display_name: string, name: string, uuid: string } };

export type CreditRequestBatchLineItemFieldsFragment = { __typename?: 'credit_request_batch_line_items', pack_price_in_micros: number, photo_url_list?: any | null, quantity: number, uom_override?: string | null, uuid: string, credit_request_reason: { __typename?: 'credit_request_reasons', display_name: any, uuid: string }, variant_pack: { __typename?: 'variants_packs', uuid: string, pack: { __typename?: 'packs', unit: string, uuid: string }, item: { __typename?: 'items', display_name: string, name: string, uuid: string } } };

export type CreditRequestBatchFieldsFragment = { __typename?: 'credit_request_batches', uuid: string, created_at: string, chat_uuid: string, customer_facing_id: string, order_invoice_uuid?: string | null, created_by: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', name?: string | null, uuid: string }> }, credit_request_batch_line_items: Array<{ __typename?: 'credit_request_batch_line_items', pack_price_in_micros: number, photo_url_list?: any | null, quantity: number, uom_override?: string | null, uuid: string, credit_request_reason: { __typename?: 'credit_request_reasons', display_name: any, uuid: string }, variant_pack: { __typename?: 'variants_packs', uuid: string, pack: { __typename?: 'packs', unit: string, uuid: string }, item: { __typename?: 'items', display_name: string, name: string, uuid: string } } }> };

export type CreditRequests_GetCreditRequestQueryVariables = Exact<{
  creditRequestBatchUUID: Scalars['uuid']['input'];
}>;


export type CreditRequests_GetCreditRequestQuery = { __typename?: 'query_root', credit_request_batches_by_pk?: { __typename?: 'credit_request_batches', uuid: string, created_at: string, chat_uuid: string, customer_facing_id: string, order_invoice_uuid?: string | null, created_by: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', name?: string | null, uuid: string }> }, credit_request_batch_line_items: Array<{ __typename?: 'credit_request_batch_line_items', pack_price_in_micros: number, photo_url_list?: any | null, quantity: number, uom_override?: string | null, uuid: string, credit_request_reason: { __typename?: 'credit_request_reasons', display_name: any, uuid: string }, variant_pack: { __typename?: 'variants_packs', uuid: string, pack: { __typename?: 'packs', unit: string, uuid: string }, item: { __typename?: 'items', display_name: string, name: string, uuid: string } } }> } | null };

export type CreditRequests_ValidateQueryVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
  creditRequestBatchLineItems: Array<CreditRequestBatchLineItemInput> | CreditRequestBatchLineItemInput;
}>;


export type CreditRequests_ValidateQuery = { __typename?: 'query_root', validateCreditRequest: { __typename?: 'ValidateCreditRequestBatchResponse', alerts: Array<{ __typename?: 'CreditRequestAlert', alert_level: AlertLevel, alert_message: string, ineligible_variant_pack_ids: Array<string> }> } };

export type AccountOrderFieldsFragment = { __typename?: 'orders', restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_invoices: Array<{ __typename?: 'order_invoices', invoice_date: string, uuid: string }> };

export type AccountOrdersFieldsFragment = { __typename?: 'chats', placed_orders: Array<{ __typename?: 'orders', restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_invoices: Array<{ __typename?: 'order_invoices', invoice_date: string, uuid: string }> }>, unplaced_orders: Array<{ __typename?: 'orders', restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_invoices: Array<{ __typename?: 'order_invoices', invoice_date: string, uuid: string }> }> };

export type LocationPickerAccountFieldsFragment = { __typename?: 'chats', restaurant_uuid: string, supplier_uuid: string, uuid: string, placed_orders: Array<{ __typename?: 'orders', restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_invoices: Array<{ __typename?: 'order_invoices', invoice_date: string, uuid: string }> }>, unplaced_orders: Array<{ __typename?: 'orders', restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_invoices: Array<{ __typename?: 'order_invoices', invoice_date: string, uuid: string }> }> };

export type LocationPicker_AccountsQueryVariables = Exact<{
  chatUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  unplacedOrderStatuses: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type LocationPicker_AccountsQuery = { __typename?: 'query_root', chats: Array<{ __typename?: 'chats', restaurant_uuid: string, supplier_uuid: string, uuid: string, placed_orders: Array<{ __typename?: 'orders', restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_invoices: Array<{ __typename?: 'order_invoices', invoice_date: string, uuid: string }> }>, unplaced_orders: Array<{ __typename?: 'orders', restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_invoices: Array<{ __typename?: 'order_invoices', invoice_date: string, uuid: string }> }> }> };

export type MenuItemSearch_IngredientFieldsFragment = { __typename?: 'menu_item_ingredients', ingredient_metadata: any, cost_in_micros?: number | null, ingredient_name: string, uuid: string, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null };

export type MenuItemSearch_ManualIngredientsQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  query: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type MenuItemSearch_ManualIngredientsQuery = { __typename?: 'query_root', searchManualMenuItemIngredients: Array<{ __typename?: 'MenuItemIngredientOutput', menu_item_ingredient?: { __typename?: 'menu_item_ingredients', ingredient_metadata: any, cost_in_micros?: number | null, ingredient_name: string, uuid: string, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } | null }> };

export type MenuItemSearch_AllIngredientsQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type MenuItemSearch_AllIngredientsQuery = { __typename?: 'query_root', menu_item_ingredients: Array<{ __typename?: 'menu_item_ingredients', ingredient_metadata: any, cost_in_micros?: number | null, ingredient_name: string, uuid: string, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> };

export type CheckIn_DeleteOrderInvoiceItemIssueMutationVariables = Exact<{
  checkInUUID: Scalars['uuid']['input'];
  checkInItemIssueUUID: Scalars['uuid']['input'];
}>;


export type CheckIn_DeleteOrderInvoiceItemIssueMutation = { __typename?: 'mutation_root', deleteOrderInvoiceCheckInItemIssue: { __typename?: 'SuccessResponse', success: boolean } };

export type CheckIn_CreateOrderInvoiceItemIssueMutationVariables = Exact<{
  checkInUUID: Scalars['uuid']['input'];
  checkInItemUUID: Scalars['uuid']['input'];
  quantity: Scalars['Int']['input'];
  status: OrderInvoiceCheckInItemStatus;
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
}>;


export type CheckIn_CreateOrderInvoiceItemIssueMutation = { __typename?: 'mutation_root', createOrderInvoiceCheckInItemIssue: { __typename?: 'CreateOrderInvoiceCheckInItemIssueResponse', order_invoice_check_in_item_issue?: { __typename?: 'order_invoice_check_in_item_issues', quantity: number, status: string, uuid: string } | null, order_invoice_check_in_item?: { __typename?: 'order_invoice_check_in_items', order_invoice_check_in_uuid: string, quantity: number, uuid: string, order_invoice_line_item: { __typename?: 'order_invoice_line_items', item_code: string, item_name?: string | null, ship_quantity: number, unit_price_in_micros: number, uuid: string, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }, order_invoice_check_in_item_issues: Array<{ __typename?: 'order_invoice_check_in_item_issues', quantity: number, status: string, uuid: string }> } | null } };

export type OrderGuide_CreateCollectionMutationVariables = Exact<{
  name: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type OrderGuide_CreateCollectionMutation = { __typename?: 'mutation_root', createOrderGuideCollection: { __typename?: 'OrderGuideCollectionEntryResponse', order_guide_restaurant_collection?: { __typename?: 'order_guide_restaurant_collection', is_default: boolean, linked_order_guide_supplier_collection_uuid?: string | null, name?: string | null, sort_order?: number | null, uuid: string, order_guide_restaurant_partitions: Array<{ __typename?: 'order_guide_restaurant_partition', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string }> } | null } };

export type OrderGuide_DeleteCollectionMutationVariables = Exact<{
  collectionUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type OrderGuide_DeleteCollectionMutation = { __typename?: 'mutation_root', deleteOrderGuideCollection: { __typename?: 'SuccessResponse', success: boolean } };

export type OrderGuide_DuplicateCollectionMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  collectionUUID: Scalars['uuid']['input'];
  collectionName: Scalars['String']['input'];
  duplicateParLevels: Scalars['Boolean']['input'];
}>;


export type OrderGuide_DuplicateCollectionMutation = { __typename?: 'mutation_root', duplicateOrderGuideCollection: { __typename?: 'OrderGuideCollectionEntryResponse', order_guide_restaurant_collection?: { __typename?: 'order_guide_restaurant_collection', is_default: boolean, linked_order_guide_supplier_collection_uuid?: string | null, name?: string | null, sort_order?: number | null, uuid: string, order_guide_restaurant_partitions: Array<{ __typename?: 'order_guide_restaurant_partition', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string }> } | null } };

export type OrderGuide_SetCollectionSortOrderMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  collectionUUIDList: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type OrderGuide_SetCollectionSortOrderMutation = { __typename?: 'mutation_root', sortOrderGuideCollections: Array<{ __typename?: 'OrderGuideCollectionEntryResponse', order_guide_restaurant_collection?: { __typename?: 'order_guide_restaurant_collection', is_default: boolean, linked_order_guide_supplier_collection_uuid?: string | null, name?: string | null, sort_order?: number | null, uuid: string, order_guide_restaurant_partitions: Array<{ __typename?: 'order_guide_restaurant_partition', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string }> } | null }> };

export type OrderGuide_SetCollectionMutationVariables = Exact<{
  collectionUUID: Scalars['uuid']['input'];
  collectionName?: InputMaybe<Scalars['String']['input']>;
  partitions: Array<SetOrderGuideCollectionPartitionInput> | SetOrderGuideCollectionPartitionInput;
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type OrderGuide_SetCollectionMutation = { __typename?: 'mutation_root', setOrderGuideCollection: { __typename?: 'OrderGuideCollectionEntryResponse', order_guide_collection_id: string } };

export type OrderGuide_RenameCollectionMutationVariables = Exact<{
  collectionName: Scalars['String']['input'];
  collectionUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type OrderGuide_RenameCollectionMutation = { __typename?: 'mutation_root', updateOrderGuideCollection: { __typename?: 'OrderGuideCollectionEntryResponse', order_guide_restaurant_collection?: { __typename?: 'order_guide_restaurant_collection', is_default: boolean, linked_order_guide_supplier_collection_uuid?: string | null, name?: string | null, sort_order?: number | null, uuid: string, order_guide_restaurant_partitions: Array<{ __typename?: 'order_guide_restaurant_partition', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string }> } | null } };

export type OrderItemRatingFieldsFragment = { __typename?: 'order_item_ratings', comment?: string | null, photo_url_list?: any | null, rating: number, uuid: string };

export type OrderItemListPackFieldsFragment = { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string };

export type OrderItemListFieldsFragment = { __typename?: 'orders_items', notes?: string | null, restaurant_display_name: string, substitution?: any | null, uuid: string, orders_items_modifier_options: Array<{ __typename?: 'orders_items_modifier_options', name: string, uuid: string }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, pricing_pack?: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string } | null, variants_pack: { __typename?: 'variants_packs', external_item_id?: string | null, metadata?: any | null, prebook_config?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', metadata: any, uuid: string }> | null, item: { __typename?: 'items', description?: string | null, photo_url_list?: any | null, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, brandInformation: { __typename?: 'BrandInformationType', brandName?: string | null, manufacturer?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, categories: Array<{ __typename?: 'CategoryType', level?: string | null, name?: string | null, type?: string | null }>, dietaryInformation: { __typename?: 'DietaryInformationType', ingredients: Array<string>, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, allergens: Array<{ __typename?: 'AllergenType', containmentLevel?: string | null, name?: string | null }>, dietTypes: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, nutrients: Array<{ __typename?: 'NutrientType', amount?: string | null, name?: string | null, percentDv?: string | null, unitName?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }> }, packagingAndStorage: { __typename?: 'PackagingAndStorageType', packaging: { __typename?: 'PackType', grossWeight?: string | null, netWeight?: string | null, packHeight?: string | null, packLength?: string | null, packWidth?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, storage: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, servingAndPreparation: { __typename?: 'ServingAndPreparationType', serving: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, preparation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> } }, order_item_prices?: { __typename?: 'order_item_prices', currency_code?: string | null, pack_quantity_at_invoice?: number | null, pack_quantity_at_order?: number | null, tax_at_order_micros?: number | null, unit_discount_price_at_order_micros?: number | null, unit_price_at_invoice_micros?: number | null, unit_price_at_order_micros?: number | null } | null };

export type OrderSummary_MissingEssentialItemsQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
  essentialItemUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type OrderSummary_MissingEssentialItemsQuery = { __typename?: 'query_root', visible_variant_packs: Array<{ __typename?: 'visible_variant_packs', variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> };

export type OrderInvoices_GetOrderInvoiceGrossProfitQueryVariables = Exact<{
  invoiceUUID: Scalars['uuid']['input'];
}>;


export type OrderInvoices_GetOrderInvoiceGrossProfitQuery = { __typename?: 'query_root', getInvoiceGrossProfit: { __typename?: 'GetOrderInvoiceGrossProfitResponse', gross_profit?: { __typename?: 'OrderInvoiceGrossProfit', percentage: number, amount_in_micros: number, currency_code: string } | null } };

export type GetOrderEstimatedCommissionQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  employeeUUID: Scalars['uuid']['input'];
  orderUUID: Scalars['uuid']['input'];
}>;


export type GetOrderEstimatedCommissionQuery = { __typename?: 'query_root', getOrderEstimatedCommission: { __typename?: 'GetOrderEstimatedCommissionResponse', commissions: Array<{ __typename?: 'OrderCommission', estimated_commission_in_micros: number, gross_profit_in_micros?: number | null, order_id: string }> } };

export type OrderInvoiceCheckInFieldsFragment = { __typename?: 'order_invoice_check_ins', completed_at?: string | null, uuid: string };

export type OrderPlacementFieldsFragment = { __typename?: 'orders', placed_at?: string | null, placed_by?: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', name?: string | null, uuid: string }> } | null, storefront_metadata?: { __typename?: 'storefront_order_metadata', name?: string | null, uuid: string } | null };

export type GetOrderItemFieldsFragment = { __typename?: 'orders_items', notes?: string | null, restaurant_display_name: string, substitution?: any | null, uuid: string, order_item_rating?: { __typename?: 'order_item_ratings', comment?: string | null, photo_url_list?: any | null, rating: number, uuid: string } | null, orders_items_modifier_options: Array<{ __typename?: 'orders_items_modifier_options', name: string, uuid: string }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, pricing_pack?: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string } | null, variants_pack: { __typename?: 'variants_packs', external_item_id?: string | null, metadata?: any | null, prebook_config?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', metadata: any, uuid: string }> | null, item: { __typename?: 'items', description?: string | null, photo_url_list?: any | null, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, brandInformation: { __typename?: 'BrandInformationType', brandName?: string | null, manufacturer?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, categories: Array<{ __typename?: 'CategoryType', level?: string | null, name?: string | null, type?: string | null }>, dietaryInformation: { __typename?: 'DietaryInformationType', ingredients: Array<string>, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, allergens: Array<{ __typename?: 'AllergenType', containmentLevel?: string | null, name?: string | null }>, dietTypes: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, nutrients: Array<{ __typename?: 'NutrientType', amount?: string | null, name?: string | null, percentDv?: string | null, unitName?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }> }, packagingAndStorage: { __typename?: 'PackagingAndStorageType', packaging: { __typename?: 'PackType', grossWeight?: string | null, netWeight?: string | null, packHeight?: string | null, packLength?: string | null, packWidth?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, storage: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, servingAndPreparation: { __typename?: 'ServingAndPreparationType', serving: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, preparation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> } }, order_item_prices?: { __typename?: 'order_item_prices', currency_code?: string | null, pack_quantity_at_invoice?: number | null, pack_quantity_at_order?: number | null, tax_at_order_micros?: number | null, unit_discount_price_at_order_micros?: number | null, unit_price_at_invoice_micros?: number | null, unit_price_at_order_micros?: number | null } | null };

export type OrderInvoiceLineItemFieldsFragment = { __typename?: 'order_invoice_line_items', item_code: string, item_name?: string | null, ship_erp_unit_of_measure: string, ship_quantity: number, unit_price_in_micros: number, unit_tax_in_micros?: number | null, uuid: string, variant_pack_uuid?: string | null };

export type OrderInvoiceItemsFieldsFragment = { __typename?: 'order_invoices', order_invoice_line_items: Array<{ __typename?: 'order_invoice_line_items', item_code: string, item_name?: string | null, ship_erp_unit_of_measure: string, ship_quantity: number, unit_price_in_micros: number, unit_tax_in_micros?: number | null, uuid: string, variant_pack_uuid?: string | null }> };

export type OrderInvoicePartialPaymentFieldsFragment = { __typename?: 'order_invoices', payment_batch_line_items: Array<{ __typename?: 'payment_batch_line_items', amount_in_micros: number, uuid: string, payment_batch: { __typename?: 'payment_batches', status: string, uuid: string } }> };

export type Orders_GetOrderInvoiceByOrderFieldsFragment = { __typename?: 'OrderInvoiceByOrderResponse', public_url?: string | null, order_invoice?: { __typename?: 'order_invoices', balance_in_micros?: number | null, document_url?: string | null, due_at?: string | null, erp_balance_in_micros?: number | null, invoice_number?: string | null, seen: boolean, uuid: string, order_invoice_check_in?: { __typename?: 'order_invoice_check_ins', completed_at?: string | null, uuid: string } | null, order_invoice_line_items: Array<{ __typename?: 'order_invoice_line_items', item_code: string, item_name?: string | null, ship_erp_unit_of_measure: string, ship_quantity: number, unit_price_in_micros: number, unit_tax_in_micros?: number | null, uuid: string, variant_pack_uuid?: string | null }>, order_invoice_status?: { __typename?: 'order_invoice_status', balance_in_micros?: number | null, use_pepper_balance: boolean, uuid: string } | null, payment_batch_line_items: Array<{ __typename?: 'payment_batch_line_items', amount_in_micros: number, uuid: string, payment_batch: { __typename?: 'payment_batches', status: string, uuid: string } }> } | null };

export type Orders_GetOrderFieldsFragment = { __typename?: 'orders', additional_input_values?: any | null, currency_code?: string | null, customer_facing_id: string, notes?: string | null, parent_order_uuid?: string | null, po_number?: string | null, restaurant_desired_delivery_time?: string | null, supplier_accepted_delivery_time?: string | null, uuid: string, created_source: string, fulfillment_type: string, status: string, placed_at?: string | null, fulfillment_timeslot_end?: string | null, fulfillment_timeslot_start?: string | null, orders_items: Array<{ __typename?: 'orders_items', notes?: string | null, restaurant_display_name: string, substitution?: any | null, uuid: string, order_item_rating?: { __typename?: 'order_item_ratings', comment?: string | null, photo_url_list?: any | null, rating: number, uuid: string } | null, orders_items_modifier_options: Array<{ __typename?: 'orders_items_modifier_options', name: string, uuid: string }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, pricing_pack?: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string } | null, variants_pack: { __typename?: 'variants_packs', external_item_id?: string | null, metadata?: any | null, prebook_config?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', metadata: any, uuid: string }> | null, item: { __typename?: 'items', description?: string | null, photo_url_list?: any | null, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, brandInformation: { __typename?: 'BrandInformationType', brandName?: string | null, manufacturer?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, categories: Array<{ __typename?: 'CategoryType', level?: string | null, name?: string | null, type?: string | null }>, dietaryInformation: { __typename?: 'DietaryInformationType', ingredients: Array<string>, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, allergens: Array<{ __typename?: 'AllergenType', containmentLevel?: string | null, name?: string | null }>, dietTypes: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, nutrients: Array<{ __typename?: 'NutrientType', amount?: string | null, name?: string | null, percentDv?: string | null, unitName?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }> }, packagingAndStorage: { __typename?: 'PackagingAndStorageType', packaging: { __typename?: 'PackType', grossWeight?: string | null, netWeight?: string | null, packHeight?: string | null, packLength?: string | null, packWidth?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, storage: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, servingAndPreparation: { __typename?: 'ServingAndPreparationType', serving: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, preparation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> } }, order_item_prices?: { __typename?: 'order_item_prices', currency_code?: string | null, pack_quantity_at_invoice?: number | null, pack_quantity_at_order?: number | null, tax_at_order_micros?: number | null, unit_discount_price_at_order_micros?: number | null, unit_price_at_invoice_micros?: number | null, unit_price_at_order_micros?: number | null } | null }>, smart_orders: Array<{ __typename?: 'smart_order', uuid: string, merge_uuid?: string | null, thread_id?: string | null }>, parent_smart_orders: Array<{ __typename?: 'smart_order', uuid: string, merge_uuid?: string | null, thread_id?: string | null }>, supplier: { __typename?: 'businesses', name: string, uuid: string, supplier_metadata?: { __typename?: 'supplier_metadata', display_item_code: boolean, gtin_settings?: any | null, uuid: string, display_item_prices: boolean } | null }, chat: { __typename?: 'chats', display_item_prices?: boolean | null, uuid: string }, order_items_with_exception: { __typename?: 'orders_items_aggregate', aggregate?: { __typename?: 'orders_items_aggregate_fields', count: number } | null }, order_tracking?: { __typename?: 'order_tracking', order_completed_delivery_datetime?: string | null, uuid: string, lower_bound_delivery_datetime?: string | null, status: string, upper_bound_delivery_datetime?: string | null } | null, placed_by?: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', name?: string | null, uuid: string }> } | null, storefront_metadata?: { __typename?: 'storefront_order_metadata', name?: string | null, uuid: string } | null };

export type Orders_GetOrderQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  orderUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Orders_GetOrderQuery = { __typename?: 'query_root', getOrderInvoiceByOrder: { __typename?: 'OrderInvoiceByOrderResponse', public_url?: string | null, order_invoice?: { __typename?: 'order_invoices', balance_in_micros?: number | null, document_url?: string | null, due_at?: string | null, erp_balance_in_micros?: number | null, invoice_number?: string | null, seen: boolean, uuid: string, order_invoice_check_in?: { __typename?: 'order_invoice_check_ins', completed_at?: string | null, uuid: string } | null, order_invoice_line_items: Array<{ __typename?: 'order_invoice_line_items', item_code: string, item_name?: string | null, ship_erp_unit_of_measure: string, ship_quantity: number, unit_price_in_micros: number, unit_tax_in_micros?: number | null, uuid: string, variant_pack_uuid?: string | null }>, order_invoice_status?: { __typename?: 'order_invoice_status', balance_in_micros?: number | null, use_pepper_balance: boolean, uuid: string } | null, payment_batch_line_items: Array<{ __typename?: 'payment_batch_line_items', amount_in_micros: number, uuid: string, payment_batch: { __typename?: 'payment_batches', status: string, uuid: string } }> } | null }, getOrder: { __typename?: 'GetOrderResponse', translated_fulfillment_display_name?: string | null, order?: { __typename?: 'orders', additional_input_values?: any | null, currency_code?: string | null, customer_facing_id: string, notes?: string | null, parent_order_uuid?: string | null, po_number?: string | null, restaurant_desired_delivery_time?: string | null, supplier_accepted_delivery_time?: string | null, uuid: string, created_source: string, fulfillment_type: string, status: string, placed_at?: string | null, fulfillment_timeslot_end?: string | null, fulfillment_timeslot_start?: string | null, orders_items: Array<{ __typename?: 'orders_items', notes?: string | null, restaurant_display_name: string, substitution?: any | null, uuid: string, order_item_rating?: { __typename?: 'order_item_ratings', comment?: string | null, photo_url_list?: any | null, rating: number, uuid: string } | null, orders_items_modifier_options: Array<{ __typename?: 'orders_items_modifier_options', name: string, uuid: string }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, pricing_pack?: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string } | null, variants_pack: { __typename?: 'variants_packs', external_item_id?: string | null, metadata?: any | null, prebook_config?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', metadata: any, uuid: string }> | null, item: { __typename?: 'items', description?: string | null, photo_url_list?: any | null, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, brandInformation: { __typename?: 'BrandInformationType', brandName?: string | null, manufacturer?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, categories: Array<{ __typename?: 'CategoryType', level?: string | null, name?: string | null, type?: string | null }>, dietaryInformation: { __typename?: 'DietaryInformationType', ingredients: Array<string>, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, allergens: Array<{ __typename?: 'AllergenType', containmentLevel?: string | null, name?: string | null }>, dietTypes: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, nutrients: Array<{ __typename?: 'NutrientType', amount?: string | null, name?: string | null, percentDv?: string | null, unitName?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }> }, packagingAndStorage: { __typename?: 'PackagingAndStorageType', packaging: { __typename?: 'PackType', grossWeight?: string | null, netWeight?: string | null, packHeight?: string | null, packLength?: string | null, packWidth?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, storage: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, servingAndPreparation: { __typename?: 'ServingAndPreparationType', serving: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, preparation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> } }, order_item_prices?: { __typename?: 'order_item_prices', currency_code?: string | null, pack_quantity_at_invoice?: number | null, pack_quantity_at_order?: number | null, tax_at_order_micros?: number | null, unit_discount_price_at_order_micros?: number | null, unit_price_at_invoice_micros?: number | null, unit_price_at_order_micros?: number | null } | null }>, smart_orders: Array<{ __typename?: 'smart_order', uuid: string, merge_uuid?: string | null, thread_id?: string | null }>, parent_smart_orders: Array<{ __typename?: 'smart_order', uuid: string, merge_uuid?: string | null, thread_id?: string | null }>, supplier: { __typename?: 'businesses', name: string, uuid: string, supplier_metadata?: { __typename?: 'supplier_metadata', display_item_code: boolean, gtin_settings?: any | null, uuid: string, display_item_prices: boolean } | null }, chat: { __typename?: 'chats', display_item_prices?: boolean | null, uuid: string }, order_items_with_exception: { __typename?: 'orders_items_aggregate', aggregate?: { __typename?: 'orders_items_aggregate_fields', count: number } | null }, order_tracking?: { __typename?: 'order_tracking', order_completed_delivery_datetime?: string | null, uuid: string, lower_bound_delivery_datetime?: string | null, status: string, upper_bound_delivery_datetime?: string | null } | null, placed_by?: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', name?: string | null, uuid: string }> } | null, storefront_metadata?: { __typename?: 'storefront_order_metadata', name?: string | null, uuid: string } | null } | null }, getOrderFees: Array<{ __typename?: 'GetOrderFeesResponse', amount_at_invoice_micros?: number | null, amount_at_order_micros?: number | null, display_type: OrderFeeDisplayType, name: string }> };

export type Orders_GetOrderSummaryQueryVariables = Exact<{
  orderUUID: Scalars['uuid']['input'];
}>;


export type Orders_GetOrderSummaryQuery = { __typename?: 'query_root', getOrderGrossProfit: { __typename?: 'GetOrderGrossProfitResponse', gross_profit?: { __typename?: 'OrderGrossProfit', percentage: number, amount_in_micros: number, currency_code: string } | null } };

export type PriceEditing_PriceEditDisplayInfoFragment = { __typename?: 'PriceEditDisplayInfoResponse', title_translations: Array<{ __typename?: 'PriceEditTitleTranslation', title: string, translation: string }>, variant_pack_details: Array<{ __typename?: 'PriceEditVariantPackDetail', variant_pack_id: string, detail: Array<{ __typename?: 'PriceEditDisplayInfoDetail', currency?: string | null, title: string, trend?: PriceEditDisplayInfoTrend | null, type: string, value?: string | null }>, settings?: { __typename?: 'PriceEditVariantPackDisplaySettings', disable_override_editing?: boolean | null, disable_sales_rep_info?: boolean | null, enable_peak_price_protection?: boolean | null } | null }> };

export type PriceEditing_GetPriceEditDisplayInfoQueryVariables = Exact<{
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type PriceEditing_GetPriceEditDisplayInfoQuery = { __typename?: 'query_root', getPriceEditDisplayInfo: { __typename?: 'PriceEditDisplayInfoResponse', title_translations: Array<{ __typename?: 'PriceEditTitleTranslation', title: string, translation: string }>, variant_pack_details: Array<{ __typename?: 'PriceEditVariantPackDetail', variant_pack_id: string, detail: Array<{ __typename?: 'PriceEditDisplayInfoDetail', currency?: string | null, title: string, trend?: PriceEditDisplayInfoTrend | null, type: string, value?: string | null }>, settings?: { __typename?: 'PriceEditVariantPackDisplaySettings', disable_override_editing?: boolean | null, disable_sales_rep_info?: boolean | null, enable_peak_price_protection?: boolean | null } | null }> } };

export type PriceEditing_GetOrderGuidePriceEditDisplayInfoQueryVariables = Exact<{
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type PriceEditing_GetOrderGuidePriceEditDisplayInfoQuery = { __typename?: 'query_root', getPriceEditDisplayInfo: { __typename?: 'PriceEditDisplayInfoResponse', title_translations: Array<{ __typename?: 'PriceEditTitleTranslation', title: string, translation: string }>, variant_pack_details: Array<{ __typename?: 'PriceEditVariantPackDetail', variant_pack_id: string, detail: Array<{ __typename?: 'PriceEditDisplayInfoDetail', currency?: string | null, title: string, trend?: PriceEditDisplayInfoTrend | null, type: string, value?: string | null }>, settings?: { __typename?: 'PriceEditVariantPackDisplaySettings', disable_override_editing?: boolean | null, disable_sales_rep_info?: boolean | null, enable_peak_price_protection?: boolean | null } | null }> } };

export type Orders_RateOrderMutationVariables = Exact<{
  ratings: Array<OrderItemRatingInput> | OrderItemRatingInput;
}>;


export type Orders_RateOrderMutation = { __typename?: 'mutation_root', rateOrder: { __typename?: 'OrderResponse', order?: { __typename?: 'orders', uuid: string, created_source: string, fulfillment_type: string, status: string, orders_items: Array<{ __typename?: 'orders_items', uuid: string, order_item_rating?: { __typename?: 'order_item_ratings', comment?: string | null, photo_url_list?: any | null, rating: number, uuid: string } | null }>, order_items_with_exception: { __typename?: 'orders_items_aggregate', aggregate?: { __typename?: 'orders_items_aggregate_fields', count: number } | null } } | null } };

export type ItemDetail_GtinMetadataFieldsFragment = { __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string };

export type ItemDetail_VariantsPacksFieldsFragment = { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', additional_information_config?: any | null, uuid: string, category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, brandInformation: { __typename?: 'BrandInformationType', brandName?: string | null, manufacturer?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, categories: Array<{ __typename?: 'CategoryType', level?: string | null, name?: string | null, type?: string | null }>, dietaryInformation: { __typename?: 'DietaryInformationType', ingredients: Array<string>, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, allergens: Array<{ __typename?: 'AllergenType', containmentLevel?: string | null, name?: string | null }>, dietTypes: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, nutrients: Array<{ __typename?: 'NutrientType', amount?: string | null, name?: string | null, percentDv?: string | null, unitName?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }> }, packagingAndStorage: { __typename?: 'PackagingAndStorageType', packaging: { __typename?: 'PackType', grossWeight?: string | null, netWeight?: string | null, packHeight?: string | null, packLength?: string | null, packWidth?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, storage: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, servingAndPreparation: { __typename?: 'ServingAndPreparationType', serving: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, preparation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> };

export type ItemDetail_VariantPacksQueryVariables = Exact<{
  filters: Variants_Packs_Bool_Exp;
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type ItemDetail_VariantPacksQuery = { __typename?: 'query_root', visible_variant_packs: Array<{ __typename?: 'visible_variant_packs', variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', additional_information_config?: any | null, uuid: string, category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, brandInformation: { __typename?: 'BrandInformationType', brandName?: string | null, manufacturer?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, categories: Array<{ __typename?: 'CategoryType', level?: string | null, name?: string | null, type?: string | null }>, dietaryInformation: { __typename?: 'DietaryInformationType', ingredients: Array<string>, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, allergens: Array<{ __typename?: 'AllergenType', containmentLevel?: string | null, name?: string | null }>, dietTypes: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, nutrients: Array<{ __typename?: 'NutrientType', amount?: string | null, name?: string | null, percentDv?: string | null, unitName?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }> }, packagingAndStorage: { __typename?: 'PackagingAndStorageType', packaging: { __typename?: 'PackType', grossWeight?: string | null, netWeight?: string | null, packHeight?: string | null, packLength?: string | null, packWidth?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, storage: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, servingAndPreparation: { __typename?: 'ServingAndPreparationType', serving: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, preparation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> };

export type ItemDetail_OrderHistoryFieldsFragment = { __typename?: 'GetVariantPackPurchaseHistoryResponse', item_modifiers?: string | null, fulfillment_date?: string | null, order_date?: string | null, price_in_micros?: number | null, quantity?: number | null, unit?: string | null, unit_count?: number | null, cost_info?: { __typename?: 'VariantPackCostInfoResponse', details?: Array<{ __typename?: 'VariantPackDetailedCostInfoResponse', cost_in_micros: number, type: VariantPackCostType }> | null } | null };

export type ItemDetail_PurchaseHistoryQueryVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
  itemUUID?: InputMaybe<Scalars['uuid']['input']>;
  variantPackUUID?: InputMaybe<Scalars['uuid']['input']>;
  externalItemID?: InputMaybe<Scalars['String']['input']>;
}>;


export type ItemDetail_PurchaseHistoryQuery = { __typename?: 'query_root', getVariantPackPurchaseHistory: Array<{ __typename?: 'GetVariantPackPurchaseHistoryResponse', item_modifiers?: string | null, fulfillment_date?: string | null, order_date?: string | null, price_in_micros?: number | null, quantity?: number | null, unit?: string | null, unit_count?: number | null, cost_info?: { __typename?: 'VariantPackCostInfoResponse', details?: Array<{ __typename?: 'VariantPackDetailedCostInfoResponse', cost_in_micros: number, type: VariantPackCostType }> | null } | null }> };

export type OrderEtaTrackingFieldsFragment = { __typename?: 'order_tracking', lower_bound_delivery_datetime?: string | null, order_completed_delivery_datetime?: string | null, status: string, upper_bound_delivery_datetime?: string | null, uuid: string };

export type OrderEtaFieldsFragment = { __typename?: 'orders', restaurant_desired_delivery_time?: string | null, supplier_accepted_delivery_time?: string | null, order_tracking?: { __typename?: 'order_tracking', lower_bound_delivery_datetime?: string | null, order_completed_delivery_datetime?: string | null, status: string, upper_bound_delivery_datetime?: string | null, uuid: string } | null };

export type OrderFulfillmentDateFieldsFragment = { __typename?: 'orders', fulfillment_timeslot_end?: string | null, fulfillment_timeslot_start?: string | null, restaurant_desired_delivery_time?: string | null, supplier_accepted_delivery_time?: string | null, uuid: string, order_tracking?: { __typename?: 'order_tracking', order_completed_delivery_datetime?: string | null, uuid: string } | null };

export type OrderStatusLabelFieldsFragment = { __typename?: 'orders', created_source: string, fulfillment_type: string, status: string, uuid: string, order_items_with_exception: { __typename?: 'orders_items_aggregate', aggregate?: { __typename?: 'orders_items_aggregate_fields', count: number } | null } };

export type OrderSummary_PromotionFieldsFragment = { __typename?: 'promotions', background_color_start: string, background_color_end: string, marketing_text?: string | null, uuid: string };

export type OrderSummary_ItemListFieldsFragment = { __typename?: 'orders_items', earliest_fulfillment_at?: string | null, notes?: string | null, restaurant_display_name: string, substitution?: any | null, uuid: string, order_item_promotion_rels: Array<{ __typename?: 'order_item_promotion_rel', discount_in_micros?: number | null, uuid: string, promotion: { __typename?: 'promotions', discount_type: string, expires_at?: string | null, tagline?: string | null, background_color_start: string, background_color_end: string, marketing_text?: string | null, uuid: string } }>, orders_items_modifier_options: Array<{ __typename?: 'orders_items_modifier_options', name: string, uuid: string }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, pricing_pack?: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string } | null, variants_pack: { __typename?: 'variants_packs', external_item_id?: string | null, metadata?: any | null, prebook_config?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', metadata: any, uuid: string }> | null, item: { __typename?: 'items', description?: string | null, photo_url_list?: any | null, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, brandInformation: { __typename?: 'BrandInformationType', brandName?: string | null, manufacturer?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, categories: Array<{ __typename?: 'CategoryType', level?: string | null, name?: string | null, type?: string | null }>, dietaryInformation: { __typename?: 'DietaryInformationType', ingredients: Array<string>, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, allergens: Array<{ __typename?: 'AllergenType', containmentLevel?: string | null, name?: string | null }>, dietTypes: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, nutrients: Array<{ __typename?: 'NutrientType', amount?: string | null, name?: string | null, percentDv?: string | null, unitName?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }> }, packagingAndStorage: { __typename?: 'PackagingAndStorageType', packaging: { __typename?: 'PackType', grossWeight?: string | null, netWeight?: string | null, packHeight?: string | null, packLength?: string | null, packWidth?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, storage: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, servingAndPreparation: { __typename?: 'ServingAndPreparationType', serving: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, preparation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> } }, order_item_prices?: { __typename?: 'order_item_prices', currency_code?: string | null, pack_quantity_at_invoice?: number | null, pack_quantity_at_order?: number | null, tax_at_order_micros?: number | null, unit_discount_price_at_order_micros?: number | null, unit_price_at_invoice_micros?: number | null, unit_price_at_order_micros?: number | null } | null };

export type Payments_GetAdyenDropinConfigQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Payments_GetAdyenDropinConfigQuery = { __typename?: 'query_root', getAdyenDropinConfig: { __typename?: 'GetAdyenDropinConfigResponse', client_key: string, environment: string, payment_methods_json: string } };

export type Payments_SavePaymentMethodMutationVariables = Exact<{
  paymentMethodString: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Payments_SavePaymentMethodMutation = { __typename?: 'mutation_root', savePaymentMethod: { __typename?: 'SavePaymentMethodResponse', alert_level?: AlertLevel | null, alert_message?: string | null, payment_method_id?: string | null } };

export type Ftni_CreateFtniPaymentSessionMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  orderInvoiceUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  userUUID: Scalars['uuid']['input'];
}>;


export type Ftni_CreateFtniPaymentSessionMutation = { __typename?: 'mutation_root', createFtniPaymentSession: { __typename?: 'CreateFTNIPaymentSessionResponse', payment_amount_in_micros: number, payment_endpoint_url: string, session_id: string, webhook_url: string } };

export type Payments_GetAutoPaySettingQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Payments_GetAutoPaySettingQuery = { __typename?: 'query_root', getAutopayStatus: { __typename?: 'AutoPayStatusResponse', show_error_banner: boolean, auto_payment?: { __typename?: 'auto_payments', created_at: string, uuid: string } | null } };

export type PaymentHistoryDetailListItemFieldsFragment = { __typename?: 'payment_batch_line_items', amount_in_micros: number, created_at?: string | null, name?: string | null, type: string, uuid: string, credit_memo?: { __typename?: 'credit_memos', credit_number?: string | null, uuid: string } | null, order_invoice?: { __typename?: 'order_invoices', invoice_number?: string | null, uuid: string } | null };

export type PaymentHistoryDetailFieldsFragment = { __typename?: 'payment_batches', created_at: string, customer_facing_id: string, document_url?: string | null, link_paid_at?: string | null, memo?: string | null, payment_method_display_text?: string | null, status: string, uuid: string, created_by: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', name?: string | null, uuid: string }> }, pay_by_link_recipient?: { __typename?: 'pay_by_link_recipients', email?: string | null, phone_number?: string | null, uuid: string, employee?: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', name?: string | null, uuid: string }> } | null } | null, payment_batch_amount?: { __typename?: 'payment_batch_amount', charged_amount_in_micros?: number | null, payment_batch_uuid?: string | null } | null, payment_batch_line_items: Array<{ __typename?: 'payment_batch_line_items', amount_in_micros: number, created_at?: string | null, name?: string | null, type: string, uuid: string, credit_memo?: { __typename?: 'credit_memos', credit_number?: string | null, uuid: string } | null, order_invoice?: { __typename?: 'order_invoices', invoice_number?: string | null, uuid: string } | null }>, payment_method?: { __typename?: 'payment_methods', display_text: string, uuid: string } | null };

export type Payments_GetPaymentBatchQueryVariables = Exact<{
  paymentBatchUUID: Scalars['uuid']['input'];
}>;


export type Payments_GetPaymentBatchQuery = { __typename?: 'query_root', payment_batches_by_pk?: { __typename?: 'payment_batches', created_at: string, customer_facing_id: string, document_url?: string | null, link_paid_at?: string | null, memo?: string | null, payment_method_display_text?: string | null, status: string, uuid: string, created_by: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', name?: string | null, uuid: string }> }, pay_by_link_recipient?: { __typename?: 'pay_by_link_recipients', email?: string | null, phone_number?: string | null, uuid: string, employee?: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', name?: string | null, uuid: string }> } | null } | null, payment_batch_amount?: { __typename?: 'payment_batch_amount', charged_amount_in_micros?: number | null, payment_batch_uuid?: string | null } | null, payment_batch_line_items: Array<{ __typename?: 'payment_batch_line_items', amount_in_micros: number, created_at?: string | null, name?: string | null, type: string, uuid: string, credit_memo?: { __typename?: 'credit_memos', credit_number?: string | null, uuid: string } | null, order_invoice?: { __typename?: 'order_invoices', invoice_number?: string | null, uuid: string } | null }>, payment_method?: { __typename?: 'payment_methods', display_text: string, uuid: string } | null } | null };

export type Plaid_CreatePlaidPaymentMethodMutationVariables = Exact<{
  accounts: Array<Scalars['String']['input']> | Scalars['String']['input'];
  institutionName?: InputMaybe<Scalars['String']['input']>;
  publicToken: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  sessionToken: Scalars['String']['input'];
  supplierUUID: Scalars['uuid']['input'];
  userID: Scalars['uuid']['input'];
}>;


export type Plaid_CreatePlaidPaymentMethodMutation = { __typename?: 'mutation_root', plaidCreatePaymentMethod: Array<{ __typename?: 'PlaidCreatePaymentMethodOutput', alert_level?: AlertLevel | null, alert_message?: string | null }> };

export type PaymentResponseFieldsFragment = { __typename?: 'MakePaymentResponse', alert_level?: AlertLevel | null, alert_message?: string | null, payment_batch_id?: string | null };

export type Payments_MakePaymentMutationVariables = Exact<{
  batches: Array<MakePaymentBatchInput> | MakePaymentBatchInput;
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Payments_MakePaymentMutation = { __typename?: 'mutation_root', makePayment: Array<{ __typename?: 'MakePaymentResponse', alert_level?: AlertLevel | null, alert_message?: string | null, payment_batch_id?: string | null }> };

export type Payments_MakePartialPaymentWithCreditRequestMutationVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
  creditRequestBatchLineItems: Array<CreditRequestBatchLineItemInput> | CreditRequestBatchLineItemInput;
  fees?: InputMaybe<Array<PaymentBatchFeeInput> | PaymentBatchFeeInput>;
  invoices: Array<PartialPaymentInvoiceInput> | PartialPaymentInvoiceInput;
  memo?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
}>;


export type Payments_MakePartialPaymentWithCreditRequestMutation = { __typename?: 'mutation_root', makePartialPaymentWithCreditRequest: { __typename?: 'MakePaymentResponse', alert_level?: AlertLevel | null, alert_message?: string | null, payment_batch_id?: string | null } };

export type NotificationFieldsFragment = { __typename?: 'employee_contact_info', uuid: string, wants_chat_email: boolean, wants_credit_request_email: boolean, wants_order_approval_email: boolean, wants_order_email: boolean, wants_order_tracking_notification: boolean, wants_payment_email: boolean };

export type UpdateEmployeeContactInfo_NotificationSettingsMutationVariables = Exact<{
  employeeContactInfoUUID: Scalars['uuid']['input'];
  set: Employee_Contact_Info_Set_Input;
}>;


export type UpdateEmployeeContactInfo_NotificationSettingsMutation = { __typename?: 'mutation_root', update_employee_contact_info_by_pk?: { __typename?: 'employee_contact_info', uuid: string, wants_chat_email: boolean, wants_credit_request_email: boolean, wants_order_approval_email: boolean, wants_order_email: boolean, wants_order_tracking_notification: boolean, wants_payment_email: boolean } | null };

export type Restaurant_RemoveEmployeeMutationVariables = Exact<{
  businessUUID: Scalars['uuid']['input'];
  employeeUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Restaurant_RemoveEmployeeMutation = { __typename?: 'mutation_root', removeEmployeeFromBusiness: { __typename?: 'EmployeeResponse', employee_id: string } };

export type EmployeeDetail_UpdateEmployeeRoleMutationVariables = Exact<{
  businessEmployeeUUID: Scalars['uuid']['input'];
  employeeRole: Scalars['String']['input'];
}>;


export type EmployeeDetail_UpdateEmployeeRoleMutation = { __typename?: 'mutation_root', update_businesses_employees_by_pk?: { __typename?: 'businesses_employees', employee_role: string, uuid: string } | null };

export type ChatsEmployees_UpdateShowAppPaymentsTabMutationVariables = Exact<{
  chatEmployeeUUID: Scalars['uuid']['input'];
  showAppPaymentsTab: Scalars['Boolean']['input'];
}>;


export type ChatsEmployees_UpdateShowAppPaymentsTabMutation = { __typename?: 'mutation_root', update_chats_employees_by_pk?: { __typename?: 'chats_employees', show_app_payments_tab?: boolean | null, uuid: string } | null };

export type SalesRep_VariantPackPurchaseHistoryQueryVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  variantPackUUID: Scalars['uuid']['input'];
}>;


export type SalesRep_VariantPackPurchaseHistoryQuery = { __typename?: 'query_root', getVariantPackPurchaseHistory: Array<{ __typename?: 'GetVariantPackPurchaseHistoryResponse', base_quantity?: number | null, base_unit?: string | null, base_unit_price_in_micros?: number | null, order_date?: string | null, price_in_micros?: number | null, quantity?: number | null, sales_rep_gross_profit_in_micros?: number | null, sales_rep_gross_profit_in_percentage?: number | null, total_price_in_micros?: number | null, unit?: string | null, unit_count?: number | null }> };

export type PauseVp_SubscriptionMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  restaurantVPSubscriptionUUID: Scalars['uuid']['input'];
  resumeAt: Scalars['String']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type PauseVp_SubscriptionMutation = { __typename?: 'mutation_root', pauseRestaurantVariantPackSubscription: { __typename?: 'RestaurantVariantPackSubscriptionResponse', restaurant_variant_pack_subscription?: { __typename?: 'restaurant_variant_pack_subscriptions', config: any, fulfillment_settings_uuid: string, pause_from?: any | null, pause_until?: any | null, uuid: string, variant_pack_uuid: string } | null } };

export type Substitutions_GetSubstitutionOptionsQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
  fulfillmentDate: Scalars['String']['input'];
  variantPackUUID: Scalars['uuid']['input'];
}>;


export type Substitutions_GetSubstitutionOptionsQuery = { __typename?: 'query_root', getItemSubstitutions: Array<{ __typename?: 'GetItemSubstitutionsResponse', available_quantity?: number | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> };

export type Substitutions_SetItemSubstitutionMutationVariables = Exact<{
  action: Scalars['String']['input'];
  orderUUID: Scalars['uuid']['input'];
  sourceVariantPackUUID: Scalars['uuid']['input'];
  substitutionEntries: Array<SubstitutionEntryInput> | SubstitutionEntryInput;
}>;


export type Substitutions_SetItemSubstitutionMutation = { __typename?: 'mutation_root', setItemSubstitution: { __typename?: 'SetItemSubstitutionResponse', order?: { __typename?: 'orders', additional_input_values?: any | null, fulfillment_timeslot_end?: string | null, fulfillment_timeslot_start?: string | null, fulfillment_type: string, notes?: string | null, order_domain?: string | null, placed_at?: string | null, po_number?: string | null, restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_fulfillment_fees: Array<{ __typename?: 'order_fulfillment_fees', amount_in_micros?: number | null, fulfillment_settings_name?: string | null, uuid?: string | null }>, order_invoices: Array<{ __typename?: 'order_invoices', balance_in_micros?: number | null, due_at?: string | null, invoice_date: string, invoice_number?: string | null, order_uuid?: string | null, uuid: string }>, orders_items: Array<{ __typename?: 'orders_items', earliest_fulfillment_at?: string | null, notes?: string | null, restaurant_display_name: string, uuid: string, order_item_prices?: { __typename?: 'order_item_prices', pack_quantity_at_order?: number | null } | null, variants_pack: { __typename?: 'variants_packs', metadata?: any | null, uuid: string, item: { __typename?: 'items', description?: string | null, uuid: string } } }>, storefront_metadata?: { __typename?: 'storefront_order_metadata', name?: string | null, uuid: string, visibility: string } | null } | null } };

export type PrintTagTemplateDetailFieldsFragment = { __typename?: 'print_tag_templates', display_name?: string | null, metadata?: any | null, name: string, offline_printer_text_template?: string | null, preview_image_url_list?: any | null, uuid: string };

export type PrintTagTemplateFieldsFragment = { __typename?: 'print_tag_templates', metadata?: any | null, uuid: string };

export type TagPrintBatchVariantPackFieldsFragment = { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, restaurant_variant_pack_overrides: Array<{ __typename?: 'restaurant_variant_pack_overrides', user_defined_metadata?: any | null, uuid: string }>, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> };

export type PrintTagBatchListFieldsFragment = { __typename?: 'print_tag_batches', created_at: string, name: string, requested_at?: string | null, uuid: string, print_tag_batch_variant_packs_aggregate: { __typename?: 'print_tag_batch_variant_packs_aggregate', aggregate?: { __typename?: 'print_tag_batch_variant_packs_aggregate_fields', max?: { __typename?: 'print_tag_batch_variant_packs_max_fields', updated_at?: string | null } | null, sum?: { __typename?: 'print_tag_batch_variant_packs_sum_fields', quantity?: number | null } | null } | null } };

export type PrintTagBatchFieldsFragment = { __typename?: 'print_tag_batches', name: string, uuid: string, print_tag_batch_variant_packs: Array<{ __typename?: 'print_tag_batch_variant_packs', quantity: number, uuid: string, variant_pack: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, restaurant_variant_pack_overrides: Array<{ __typename?: 'restaurant_variant_pack_overrides', user_defined_metadata?: any | null, uuid: string }>, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } }>, print_tag_template: { __typename?: 'print_tag_templates', metadata?: any | null, uuid: string } };

export type PrintTagBatchFullFieldsFragment = { __typename?: 'print_tag_batches', name: string, uuid: string, created_at: string, requested_at?: string | null, print_tag_batch_variant_packs: Array<{ __typename?: 'print_tag_batch_variant_packs', quantity: number, uuid: string, variant_pack: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, restaurant_variant_pack_overrides: Array<{ __typename?: 'restaurant_variant_pack_overrides', user_defined_metadata?: any | null, uuid: string }>, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } }>, print_tag_template: { __typename?: 'print_tag_templates', metadata?: any | null, uuid: string }, print_tag_batch_variant_packs_aggregate: { __typename?: 'print_tag_batch_variant_packs_aggregate', aggregate?: { __typename?: 'print_tag_batch_variant_packs_aggregate_fields', max?: { __typename?: 'print_tag_batch_variant_packs_max_fields', updated_at?: string | null } | null, sum?: { __typename?: 'print_tag_batch_variant_packs_sum_fields', quantity?: number | null } | null } | null } };

export type TagPrint_BatchListQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type TagPrint_BatchListQuery = { __typename?: 'query_root', print_tag_batches: Array<{ __typename?: 'print_tag_batches', created_at: string, name: string, requested_at?: string | null, uuid: string, print_tag_batch_variant_packs_aggregate: { __typename?: 'print_tag_batch_variant_packs_aggregate', aggregate?: { __typename?: 'print_tag_batch_variant_packs_aggregate_fields', max?: { __typename?: 'print_tag_batch_variant_packs_max_fields', updated_at?: string | null } | null, sum?: { __typename?: 'print_tag_batch_variant_packs_sum_fields', quantity?: number | null } | null } | null } }> };

export type TagPrint_BatchTemplateQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type TagPrint_BatchTemplateQuery = { __typename?: 'query_root', print_tag_template_assignments: Array<{ __typename?: 'print_tag_template_assignments', uuid: string, print_tag_template: { __typename?: 'print_tag_templates', display_name?: string | null, metadata?: any | null, name: string, offline_printer_text_template?: string | null, preview_image_url_list?: any | null, uuid: string } }> };

export type TagPrint_BatchDetailQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  printTagBatchUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
}>;


export type TagPrint_BatchDetailQuery = { __typename?: 'query_root', print_tag_batches_by_pk?: { __typename?: 'print_tag_batches', name: string, uuid: string, print_tag_batch_variant_packs: Array<{ __typename?: 'print_tag_batch_variant_packs', quantity: number, uuid: string, variant_pack: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, restaurant_variant_pack_overrides: Array<{ __typename?: 'restaurant_variant_pack_overrides', user_defined_metadata?: any | null, uuid: string }>, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } }>, print_tag_template: { __typename?: 'print_tag_templates', metadata?: any | null, uuid: string } } | null };

export type TagPrint_RenderBatchQueryVariables = Exact<{
  printTagBatchUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type TagPrint_RenderBatchQuery = { __typename?: 'query_root', renderPrintTagBatchTemplatesForRestaurant: Array<{ __typename?: 'RenderPrintTagTemplateForRestaurantResponse', rendered_template: string, variant_pack_id: string }> };

export type TagPrint_RestaurantVariantPackOverridesQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPackUUID: Scalars['uuid']['input'];
}>;


export type TagPrint_RestaurantVariantPackOverridesQuery = { __typename?: 'query_root', visible_variant_packs: Array<{ __typename?: 'visible_variant_packs', variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, restaurant_variant_pack_overrides: Array<{ __typename?: 'restaurant_variant_pack_overrides', user_defined_metadata?: any | null, uuid: string }>, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> };

export type TagPrint_BatchDeleteMutationVariables = Exact<{
  printTagBatchUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type TagPrint_BatchDeleteMutation = { __typename?: 'mutation_root', deletePrintTagBatchesForRestaurant: { __typename?: 'SuccessResponse', success: boolean } };

export type TagPrint_BatchRequestDeliveryMutationVariables = Exact<{
  printTagBatchUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type TagPrint_BatchRequestDeliveryMutation = { __typename?: 'mutation_root', requestPrintTagBatchDelivery: { __typename?: 'PrintTagBatchResponse', print_tag_batch?: { __typename?: 'print_tag_batches', created_at: string, name: string, requested_at?: string | null, uuid: string, print_tag_batch_variant_packs_aggregate: { __typename?: 'print_tag_batch_variant_packs_aggregate', aggregate?: { __typename?: 'print_tag_batch_variant_packs_aggregate_fields', max?: { __typename?: 'print_tag_batch_variant_packs_max_fields', updated_at?: string | null } | null, sum?: { __typename?: 'print_tag_batch_variant_packs_sum_fields', quantity?: number | null } | null } | null } } | null } };

export type PlanogramFieldsFragment = { __typename?: 'planograms', created_at: string, name: string, uuid: string, planogram_variant_packs_aggregate: { __typename?: 'planogram_variant_packs_aggregate', aggregate?: { __typename?: 'planogram_variant_packs_aggregate_fields', sum?: { __typename?: 'planogram_variant_packs_sum_fields', quantity?: number | null } | null } | null } };

export type Planograms_ListQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Planograms_ListQuery = { __typename?: 'query_root', getRestaurantPlanograms: Array<{ __typename?: 'GetRestaurantPlanogramsResponse', planogram?: { __typename?: 'planograms', created_at: string, name: string, uuid: string, planogram_variant_packs_aggregate: { __typename?: 'planogram_variant_packs_aggregate', aggregate?: { __typename?: 'planogram_variant_packs_aggregate_fields', sum?: { __typename?: 'planogram_variant_packs_sum_fields', quantity?: number | null } | null } | null } } | null }> };

export type TagPrint_UpsertBatchMutationVariables = Exact<{
  items?: InputMaybe<Array<PrintTagBatchVariantPackInput> | PrintTagBatchVariantPackInput>;
  locale: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  printTagBatchUUID?: InputMaybe<Scalars['uuid']['input']>;
  printTagTemplateUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type TagPrint_UpsertBatchMutation = { __typename?: 'mutation_root', upsertPrintTagBatchForRestaurant: { __typename?: 'PrintTagBatchResponse', print_tag_batch?: { __typename?: 'print_tag_batches', name: string, uuid: string, created_at: string, requested_at?: string | null, print_tag_batch_variant_packs: Array<{ __typename?: 'print_tag_batch_variant_packs', quantity: number, uuid: string, variant_pack: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, restaurant_variant_pack_overrides: Array<{ __typename?: 'restaurant_variant_pack_overrides', user_defined_metadata?: any | null, uuid: string }>, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } }>, print_tag_template: { __typename?: 'print_tag_templates', metadata?: any | null, uuid: string }, print_tag_batch_variant_packs_aggregate: { __typename?: 'print_tag_batch_variant_packs_aggregate', aggregate?: { __typename?: 'print_tag_batch_variant_packs_aggregate_fields', max?: { __typename?: 'print_tag_batch_variant_packs_max_fields', updated_at?: string | null } | null, sum?: { __typename?: 'print_tag_batch_variant_packs_sum_fields', quantity?: number | null } | null } | null } } | null } };

export type VariantPackPricesFragment = { __typename?: 'VariantPackPricesResponse', manufacturer_suggested_retail_price?: number | null, retail_price?: number | null, suggested_retail_price?: number | null, variant_pack_id: string };

export type TagPrint_OfflineQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type TagPrint_OfflineQuery = { __typename?: 'query_root', print_tag_batches: Array<{ __typename?: 'print_tag_batches', name: string, uuid: string, created_at: string, requested_at?: string | null, print_tag_template: { __typename?: 'print_tag_templates', metadata?: any | null, uuid: string }, print_tag_batch_variant_packs: Array<{ __typename?: 'print_tag_batch_variant_packs', quantity: number, uuid: string, variant_pack: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, restaurant_variant_pack_overrides: Array<{ __typename?: 'restaurant_variant_pack_overrides', user_defined_metadata?: any | null, uuid: string }>, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } }>, print_tag_batch_variant_packs_aggregate: { __typename?: 'print_tag_batch_variant_packs_aggregate', aggregate?: { __typename?: 'print_tag_batch_variant_packs_aggregate_fields', max?: { __typename?: 'print_tag_batch_variant_packs_max_fields', updated_at?: string | null } | null, sum?: { __typename?: 'print_tag_batch_variant_packs_sum_fields', quantity?: number | null } | null } | null } }>, print_tag_template_assignments: Array<{ __typename?: 'print_tag_template_assignments', uuid: string, print_tag_template: { __typename?: 'print_tag_templates', display_name?: string | null, metadata?: any | null, name: string, offline_printer_text_template?: string | null, preview_image_url_list?: any | null, uuid: string } }>, getVisibleVariantPackPrintingPrices: { __typename?: 'GetVisibleVariantPackPrintingPricesResponse', variant_pack_prices: Array<{ __typename?: 'VariantPackPricesResponse', manufacturer_suggested_retail_price?: number | null, retail_price?: number | null, suggested_retail_price?: number | null, variant_pack_id: string }> } };

export type Order_PrintOrderTemplateQueryVariables = Exact<{
  orderUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Order_PrintOrderTemplateQuery = { __typename?: 'query_root', renderPrintOrderTemplate: { __typename?: 'RenderedTemplateResponse', rendered_template: string } };

export type ItemDetail_TagPrintingConfigurationQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPackUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type ItemDetail_TagPrintingConfigurationQuery = { __typename?: 'query_root', getVariantPackPrintTagConfiguration: Array<{ __typename?: 'VariantPackPrintTagConfiguration', variant_pack_id: string, printer_config: { __typename?: 'TagPrinterConfiguration', language: TagPrinterLanguage, print_markup_content: string }, tag_attributes: Array<{ __typename?: 'PrintTagAttribute', key: string, value: string }> }> };

export type TagPrintingVariantPackFieldsFragment = { __typename?: 'variants_packs', uuid: string, restaurant_variant_pack_overrides: Array<{ __typename?: 'restaurant_variant_pack_overrides', user_defined_metadata?: any | null, uuid: string }> };

export type PrintTagTemplatesFieldsFragment = { __typename?: 'GetPrintTagTemplateForRestaurantResponse', preview_display_fields: Array<{ __typename?: 'PrintTagPreviewDisplayField', key: string, value: string }>, print_tag_template?: { __typename?: 'print_tag_templates', display_name?: string | null, name: string, preview_image_url_list?: any | null, uuid: string, metadata?: any | null } | null };

export type TagPrintingTemplateQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPackUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type TagPrintingTemplateQuery = { __typename?: 'query_root', visible_variant_packs: Array<{ __typename?: 'visible_variant_packs', variant_pack?: { __typename?: 'variants_packs', uuid: string, restaurant_variant_pack_overrides: Array<{ __typename?: 'restaurant_variant_pack_overrides', user_defined_metadata?: any | null, uuid: string }> } | null }>, getPrintTagTemplatesForRestaurant: Array<{ __typename?: 'GetPrintTagTemplateForRestaurantResponse', variant_pack_id: string, preview_display_fields: Array<{ __typename?: 'PrintTagPreviewDisplayField', key: string, value: string }>, print_tag_template?: { __typename?: 'print_tag_templates', display_name?: string | null, name: string, preview_image_url_list?: any | null, uuid: string, metadata?: any | null } | null }> };

export type TagPrintingRenderTemplateQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  printTagTemplateUUID: Scalars['uuid']['input'];
  variantPackInputs: Array<VariantPackInput> | VariantPackInput;
}>;


export type TagPrintingRenderTemplateQuery = { __typename?: 'query_root', renderPrintTagTemplateForRestaurant: Array<{ __typename?: 'RenderPrintTagTemplateForRestaurantResponse', print_tag_template_id: string, rendered_template: string }> };

export type SampleRequestFieldsFragment = { __typename?: 'sample_requests', contact_email?: string | null, follow_up_response?: any | null, follow_up_submitted_at?: string | null, qualified_at?: string | null, requested_at: string, status: string, uuid: string, address?: { __typename?: 'addresses', address: string, address2?: string | null, city: string, country_code: string, latitude: number, longitude: number, region?: string | null, uuid: string } | null, requested_by: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', name?: string | null, uuid: string }> } };

export type DisplayAdVariantPackFieldsFragment = { __typename?: 'GetDisplayAdVariantPacksEventsResponse', ad_campaign_id: string, ad_manager_id: string, advertiser_id: string, gtin: string, display_ad_content: { __typename?: 'DisplayAdEventContent', banner_image_url: string, description?: string | null, desktop_banner_image_url?: string | null, logo_image_url?: string | null, title?: string | null, event_data: { __typename?: 'DisplayAdContentEventData', click_event_id: string, impression_event_id: string } }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null, variant_pack_event_data: { __typename?: 'DisplayAdVariantPackEventData', add_to_cart_event_id: string, click_event_id: string, impression_event_id: string, purchase_event_id: string } };

export type Ads_DisplayAdContextQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Ads_DisplayAdContextQuery = { __typename?: 'query_root', getDisplayAdVariantPacksEvents: Array<{ __typename?: 'GetDisplayAdVariantPacksEventsResponse', ad_campaign_id: string, ad_manager_id: string, advertiser_id: string, gtin: string, display_ad_content: { __typename?: 'DisplayAdEventContent', banner_image_url: string, description?: string | null, desktop_banner_image_url?: string | null, logo_image_url?: string | null, title?: string | null, event_data: { __typename?: 'DisplayAdContentEventData', click_event_id: string, impression_event_id: string } }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null, variant_pack_event_data: { __typename?: 'DisplayAdVariantPackEventData', add_to_cart_event_id: string, click_event_id: string, impression_event_id: string, purchase_event_id: string } }> };

export type SampleRequestVariantPackFieldsFragment = { __typename?: 'GetSampleRequestVariantPacksResponse', ad_campaign_id: string, ad_manager_id: string, advertiser_id: string, advertiser_name?: string | null, gtin: string, earliest_requested_at?: string | null, follow_up_period_days?: number | null, lookback_period_days?: number | null, qualification_questions?: Array<string> | null, request_count?: number | null, request_limit?: number | null, require_contact_information?: boolean | null, variant_pack_id: string, sample_request_event_data: { __typename?: 'SampleRequestEventData', add_to_cart_event_id: string, click_event_id: string, form_submit_event_id: string, impression_event_id: string, purchase_event_id: string }, sample_request?: { __typename?: 'sample_requests', contact_email?: string | null, follow_up_response?: any | null, follow_up_submitted_at?: string | null, qualified_at?: string | null, requested_at: string, status: string, uuid: string, address?: { __typename?: 'addresses', address: string, address2?: string | null, city: string, country_code: string, latitude: number, longitude: number, region?: string | null, uuid: string } | null, requested_by: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', name?: string | null, uuid: string }> } } | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null };

export type Ads_SampleRequestContextQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Ads_SampleRequestContextQuery = { __typename?: 'query_root', getSampleRequestVariantPacks: Array<{ __typename?: 'GetSampleRequestVariantPacksResponse', ad_campaign_id: string, ad_manager_id: string, advertiser_id: string, advertiser_name?: string | null, gtin: string, earliest_requested_at?: string | null, follow_up_period_days?: number | null, lookback_period_days?: number | null, qualification_questions?: Array<string> | null, request_count?: number | null, request_limit?: number | null, require_contact_information?: boolean | null, variant_pack_id: string, sample_request_event_data: { __typename?: 'SampleRequestEventData', add_to_cart_event_id: string, click_event_id: string, form_submit_event_id: string, impression_event_id: string, purchase_event_id: string }, sample_request?: { __typename?: 'sample_requests', contact_email?: string | null, follow_up_response?: any | null, follow_up_submitted_at?: string | null, qualified_at?: string | null, requested_at: string, status: string, uuid: string, address?: { __typename?: 'addresses', address: string, address2?: string | null, city: string, country_code: string, latitude: number, longitude: number, region?: string | null, uuid: string } | null, requested_by: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', name?: string | null, uuid: string }> } } | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> };

export type AuthStackContext_GetGuestModeContentQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
}>;


export type AuthStackContext_GetGuestModeContentQuery = { __typename?: 'query_root', getGuestModeContent: Array<{ __typename?: 'GetGuestModeContentResponse', chat?: { __typename?: 'chats', uuid: string, dynamic_config: any, restaurant: { __typename?: 'businesses', name: string, uuid: string, address: { __typename?: 'addresses', address: string, timezone: string, uuid: string } }, supplier: { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', country_code: string, uuid: string }, supplier_metadata?: { __typename?: 'supplier_metadata', display_item_code: boolean, dynamic_config: any, uuid: string } | null } } | null }> };

export type AuthStackContext_WhiteLabelConfigQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
}>;


export type AuthStackContext_WhiteLabelConfigQuery = { __typename?: 'query_root', getWhitelabelConfig: { __typename?: 'GetWhitelabelConfigResponse', render_contact_form?: boolean | null, translated_become_customer_address_label: string, translated_become_customer_name_label: string, translated_tagline?: string | null, whitelabel_config?: { __typename?: 'whitelabel_config', app_background_image_url?: string | null, app_background_landscape_video_url?: string | null, app_background_video_url?: string | null, app_landing_logo_image?: string | null, become_customer_url?: string | null, cms_enabled?: boolean | null, default_login_method?: string | null, guest_mode_enabled?: boolean | null, ios_icon_image: string, login_methods?: any | null, login_request_enabled?: boolean | null, translations_enabled?: boolean | null, uuid: string } | null } };

export type CheckIn_OrderInvoiceLineItemsFieldsFragment = { __typename?: 'order_invoice_line_items', item_code: string, item_name?: string | null, ship_quantity: number, unit_price_in_micros: number, uuid: string, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null };

export type CheckIn_CheckInItemIssuesFieldsFragment = { __typename?: 'order_invoice_check_in_item_issues', quantity: number, status: string, uuid: string };

export type CheckIn_CheckInItemsFieldsFragment = { __typename?: 'order_invoice_check_in_items', order_invoice_check_in_uuid: string, quantity: number, uuid: string, order_invoice_line_item: { __typename?: 'order_invoice_line_items', item_code: string, item_name?: string | null, ship_quantity: number, unit_price_in_micros: number, uuid: string, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }, order_invoice_check_in_item_issues: Array<{ __typename?: 'order_invoice_check_in_item_issues', quantity: number, status: string, uuid: string }> };

export type CheckIn_CheckInItemsQueryVariables = Exact<{
  checkInUUID: Scalars['uuid']['input'];
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
}>;


export type CheckIn_CheckInItemsQuery = { __typename?: 'query_root', order_invoice_check_ins_by_pk?: { __typename?: 'order_invoice_check_ins', order_invoice_check_in_items: Array<{ __typename?: 'order_invoice_check_in_items', order_invoice_check_in_uuid: string, quantity: number, uuid: string, order_invoice_line_item: { __typename?: 'order_invoice_line_items', item_code: string, item_name?: string | null, ship_quantity: number, unit_price_in_micros: number, uuid: string, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }, order_invoice_check_in_item_issues: Array<{ __typename?: 'order_invoice_check_in_item_issues', quantity: number, status: string, uuid: string }> }> } | null };

export type CheckIn_OrderInvoiceItemsMutationVariables = Exact<{
  checkInUUID: Scalars['uuid']['input'];
  orderInvoiceCheckInItems: Array<CheckInOrderInvoiceItemQuantityInput> | CheckInOrderInvoiceItemQuantityInput;
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
}>;


export type CheckIn_OrderInvoiceItemsMutation = { __typename?: 'mutation_root', checkInOrderInvoiceItems: Array<{ __typename?: 'CheckInOrderInvoiceItemsResponse', order_invoice_check_in_item?: { __typename?: 'order_invoice_check_in_items', order_invoice_check_in_uuid: string, quantity: number, uuid: string, order_invoice_line_item: { __typename?: 'order_invoice_line_items', item_code: string, item_name?: string | null, ship_quantity: number, unit_price_in_micros: number, uuid: string, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }, order_invoice_check_in_item_issues: Array<{ __typename?: 'order_invoice_check_in_item_issues', quantity: number, status: string, uuid: string }> } | null }> };

export type CheckIn_CompleteOrderInvoiceCheckInMutationVariables = Exact<{
  checkInUUID: Scalars['uuid']['input'];
}>;


export type CheckIn_CompleteOrderInvoiceCheckInMutation = { __typename?: 'mutation_root', completeOrderInvoiceCheckIn: { __typename?: 'SuccessResponse', success: boolean } };

export type ExternalContentFragment = { __typename?: 'external_content', config: any, display_name?: string | null, name: string, uuid: string };

export type GetExternalContentForRestaurantQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
}>;


export type GetExternalContentForRestaurantQuery = { __typename?: 'query_root', getExternalContentForRestaurant: Array<{ __typename?: 'ExternalContentResponse', external_content?: { __typename?: 'external_content', config: any, display_name?: string | null, name: string, uuid: string } | null }> };

export type NameValueFieldsFragment = { __typename?: 'GenericAttributeType', name?: string | null, value?: string | null };

export type ItemContext_ItemBrandInfoFieldsFragment = { __typename?: 'BrandInformationType', brandName?: string | null, manufacturer?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> };

export type ItemContext_ItemDietaryInfoFieldsFragment = { __typename?: 'DietaryInformationType', ingredients: Array<string>, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, allergens: Array<{ __typename?: 'AllergenType', containmentLevel?: string | null, name?: string | null }>, dietTypes: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, nutrients: Array<{ __typename?: 'NutrientType', amount?: string | null, name?: string | null, percentDv?: string | null, unitName?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }> };

export type ItemContext_ItemPackagingAndStorageFieldsFragment = { __typename?: 'PackagingAndStorageType', packaging: { __typename?: 'PackType', grossWeight?: string | null, netWeight?: string | null, packHeight?: string | null, packLength?: string | null, packWidth?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, storage: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> };

export type ItemContext_SaltBaseItemFieldsFragment = { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> };

export type ItemContext_SaltItemFieldsFragment = { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, brandInformation: { __typename?: 'BrandInformationType', brandName?: string | null, manufacturer?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, categories: Array<{ __typename?: 'CategoryType', level?: string | null, name?: string | null, type?: string | null }>, dietaryInformation: { __typename?: 'DietaryInformationType', ingredients: Array<string>, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, allergens: Array<{ __typename?: 'AllergenType', containmentLevel?: string | null, name?: string | null }>, dietTypes: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, nutrients: Array<{ __typename?: 'NutrientType', amount?: string | null, name?: string | null, percentDv?: string | null, unitName?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }> }, packagingAndStorage: { __typename?: 'PackagingAndStorageType', packaging: { __typename?: 'PackType', grossWeight?: string | null, netWeight?: string | null, packHeight?: string | null, packLength?: string | null, packWidth?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, storage: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, servingAndPreparation: { __typename?: 'ServingAndPreparationType', serving: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, preparation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> };

export type ItemLeadTimeContext_GetResolvedLeadTimeFulfillmentQueryVariables = Exact<{
  desiredFulfillmentDate?: InputMaybe<Scalars['String']['input']>;
  fulfillmentSettingsUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type ItemLeadTimeContext_GetResolvedLeadTimeFulfillmentQuery = { __typename?: 'query_root', getResolvedLeadTimeFulfillment: Array<{ __typename?: 'GetResolvedLeadTimeFulfillmentResponse', variant_pack_ids: Array<string>, settings: { __typename?: 'GetResolvedLeadTimeFulfillmentSettings', earliest_fulfillment_at?: string | null } }> };

export type ItemRecommendation_InfoFieldsFragment = { __typename?: 'GetItemRecommendationResponse', item_recommendation_id: string, rank: number, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null };

export type ItemRecommendations_InfoListQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type ItemRecommendations_InfoListQuery = { __typename?: 'query_root', getItemRecommendations: Array<{ __typename?: 'GetItemRecommendationResponse', item_recommendation_id: string, rank: number, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> };

export type ItemsContext_PackFieldsFragment = { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string };

export type ItemsContext_ItemModifiersFieldsFragment = { __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } };

export type ItemsContext_VariantsPackGroupItemsFieldsFragment = { __typename?: 'variant_pack_groups', display_image_url?: string | null, type?: string | null, uuid: string };

export type ItemsContext_VariantsPackItemGroupsMembershipFieldsFragment = { __typename?: 'variants_packs', variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> };

export type ItemsContext_VariantPackSaltCacheFieldsFragment = { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null };

export type ItemsContext_VariantsPackFieldsFragment = { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> };

export type ItemsContext_OrderGuideItemFieldsFragment = { __typename?: 'OrderGuideItemEntryResponse', order_guide_item_id: string, order_guide_item_partition_id?: string | null, order_guide_restaurant?: { __typename?: 'order_guide_restaurant', is_minimized: boolean, memo?: string | null, notes?: string | null, order_guide_restaurant_partition_uuid: string, par_level?: number | null, persist_memo: boolean, persist_notes: boolean, persist_request: boolean, request?: string | null, sort_order?: number | null, uuid: string } | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null };

export type ItemsContext_OrderGuideRestaurantPartitionFieldsFragment = { __typename?: 'order_guide_restaurant_partition', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string };

export type ItemsContext_OrderGuideRestaurantCollectionFieldsFragment = { __typename?: 'order_guide_restaurant_collection', is_default: boolean, linked_order_guide_supplier_collection_uuid?: string | null, name?: string | null, sort_order?: number | null, uuid: string, order_guide_restaurant_partitions: Array<{ __typename?: 'order_guide_restaurant_partition', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string }> };

export type ItemsContext_OrderGuideSupplierPartitionFieldsFragment = { __typename?: 'order_guide_supplier_partition', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string };

export type ItemsContext_OrderGuideSupplierCollectionFieldsFragment = { __typename?: 'order_guide_supplier_collection', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string, order_guide_supplier_partitions: Array<{ __typename?: 'order_guide_supplier_partition', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string }> };

export type ItemsContext_MultiOrderGuideItemsQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
}>;


export type ItemsContext_MultiOrderGuideItemsQuery = { __typename?: 'query_root', getOrderGuideItems: Array<{ __typename?: 'OrderGuideItemEntryResponse', order_guide_item_id: string, order_guide_item_partition_id?: string | null, order_guide_restaurant?: { __typename?: 'order_guide_restaurant', is_minimized: boolean, memo?: string | null, notes?: string | null, order_guide_restaurant_partition_uuid: string, par_level?: number | null, persist_memo: boolean, persist_notes: boolean, persist_request: boolean, request?: string | null, sort_order?: number | null, uuid: string } | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }>, order_guide_restaurant_collection: Array<{ __typename?: 'order_guide_restaurant_collection', is_default: boolean, linked_order_guide_supplier_collection_uuid?: string | null, name?: string | null, sort_order?: number | null, uuid: string, order_guide_restaurant_partitions: Array<{ __typename?: 'order_guide_restaurant_partition', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string }> }>, order_guide_supplier_collection: Array<{ __typename?: 'order_guide_supplier_collection', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string, order_guide_supplier_partitions: Array<{ __typename?: 'order_guide_supplier_partition', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string }> }> };

export type ItemsContext_EditMultiOrderGuideItemsQueryVariables = Exact<{
  collectionUUID: Scalars['uuid']['input'];
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
}>;


export type ItemsContext_EditMultiOrderGuideItemsQuery = { __typename?: 'query_root', getOrderGuideItems: Array<{ __typename?: 'OrderGuideItemEntryResponse', order_guide_item_id: string, order_guide_item_partition_id?: string | null, order_guide_restaurant?: { __typename?: 'order_guide_restaurant', is_minimized: boolean, memo?: string | null, notes?: string | null, order_guide_restaurant_partition_uuid: string, par_level?: number | null, persist_memo: boolean, persist_notes: boolean, persist_request: boolean, request?: string | null, sort_order?: number | null, uuid: string } | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }>, order_guide_restaurant_collection: Array<{ __typename?: 'order_guide_restaurant_collection', is_default: boolean, linked_order_guide_supplier_collection_uuid?: string | null, name?: string | null, sort_order?: number | null, uuid: string, order_guide_restaurant_partitions: Array<{ __typename?: 'order_guide_restaurant_partition', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string }> }>, order_guide_supplier_collection: Array<{ __typename?: 'order_guide_supplier_collection', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string, order_guide_supplier_partitions: Array<{ __typename?: 'order_guide_supplier_partition', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string }> }> };

export type MenuInfo_MenuItemIngredientFieldsFragment = { __typename?: 'menu_item_ingredients', cost_in_micros?: number | null, ingredient_name: string, uuid: string, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null };

export type MenuInfo_MenuItemIngredientMetadataFieldsFragment = { __typename?: 'menu_item_ingredient_metadata', ingredient_metadata: any, menu_item_uuid: string, uuid: string, menu_item_ingredient: { __typename?: 'menu_item_ingredients', cost_in_micros?: number | null, ingredient_name: string, uuid: string, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } };

export type MenuInfo_MenuItemFieldsFragment = { __typename?: 'menu_items', item_name: string, price_in_micros?: number | null, uuid: string, menu_item_ingredient_metadata: Array<{ __typename?: 'menu_item_ingredient_metadata', ingredient_metadata: any, menu_item_uuid: string, uuid: string, menu_item_ingredient: { __typename?: 'menu_item_ingredients', cost_in_micros?: number | null, ingredient_name: string, uuid: string, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } }> };

export type MenuInfo_MenuInfoContextQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type MenuInfo_MenuInfoContextQuery = { __typename?: 'query_root', menu_items: Array<{ __typename?: 'menu_items', item_name: string, price_in_micros?: number | null, uuid: string, menu_item_ingredient_metadata: Array<{ __typename?: 'menu_item_ingredient_metadata', ingredient_metadata: any, menu_item_uuid: string, uuid: string, menu_item_ingredient: { __typename?: 'menu_item_ingredients', cost_in_micros?: number | null, ingredient_name: string, uuid: string, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } }> }> };

export type MenuInfo_AddMenuItemMutationVariables = Exact<{
  employeeUUID: Scalars['uuid']['input'];
  itemName: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type MenuInfo_AddMenuItemMutation = { __typename?: 'mutation_root', insert_menu_items_one?: { __typename?: 'menu_items', item_name: string, price_in_micros?: number | null, uuid: string, menu_item_ingredient_metadata: Array<{ __typename?: 'menu_item_ingredient_metadata', ingredient_metadata: any, menu_item_uuid: string, uuid: string, menu_item_ingredient: { __typename?: 'menu_item_ingredients', cost_in_micros?: number | null, ingredient_name: string, uuid: string, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } }> } | null };

export type MenuInfo_AddMenuItemIngredientMutationVariables = Exact<{
  locale: Scalars['String']['input'];
  manualIngredient?: InputMaybe<ManualIngredientFields>;
  menuItemUUID: Scalars['uuid']['input'];
  menuItemIngredientUUID?: InputMaybe<Scalars['uuid']['input']>;
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  variantPackCostInMicros?: InputMaybe<Scalars['bigint']['input']>;
  variantPackUUID?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type MenuInfo_AddMenuItemIngredientMutation = { __typename?: 'mutation_root', addMenuItemIngredient: { __typename?: 'MenuItemIngredientOutput', menu_item_ingredient?: { __typename?: 'menu_item_ingredients', cost_in_micros?: number | null, ingredient_name: string, uuid: string, menu_item_ingredient_metadata: Array<{ __typename?: 'menu_item_ingredient_metadata', ingredient_metadata: any, menu_item_uuid: string, uuid: string, menu_item_ingredient: { __typename?: 'menu_item_ingredients', cost_in_micros?: number | null, ingredient_name: string, uuid: string, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } | null } };

export type MenuInfo_EditMenuItemIngredientMutationVariables = Exact<{
  ingredientFields: EditIngredientFields;
  locale: Scalars['String']['input'];
  menuItemIngredientUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type MenuInfo_EditMenuItemIngredientMutation = { __typename?: 'mutation_root', editMenuItemIngredient: { __typename?: 'MenuItemIngredientOutput', menu_item_ingredient?: { __typename?: 'menu_item_ingredients', cost_in_micros?: number | null, ingredient_name: string, uuid: string, menu_item_ingredient_metadata: Array<{ __typename?: 'menu_item_ingredient_metadata', ingredient_metadata: any, menu_item_uuid: string, uuid: string, menu_item_ingredient: { __typename?: 'menu_item_ingredients', cost_in_micros?: number | null, ingredient_name: string, uuid: string, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } | null } };

export type MenuInfo_RemoveMenuItemIngredientMetadataMutationVariables = Exact<{
  ingredientMetadataUUID: Scalars['uuid']['input'];
}>;


export type MenuInfo_RemoveMenuItemIngredientMetadataMutation = { __typename?: 'mutation_root', delete_menu_item_ingredient_metadata_by_pk?: { __typename?: 'menu_item_ingredient_metadata', uuid: string } | null };

export type MenuInfo_RenameMenuItemMutationVariables = Exact<{
  itemName: Scalars['String']['input'];
  menuItemUUID: Scalars['uuid']['input'];
}>;


export type MenuInfo_RenameMenuItemMutation = { __typename?: 'mutation_root', update_menu_items_by_pk?: { __typename?: 'menu_items', item_name: string, uuid: string } | null };

export type MenuInfo_DeleteMenuItemMutationVariables = Exact<{
  menuItemUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type MenuInfo_DeleteMenuItemMutation = { __typename?: 'mutation_root', deleteMenuItem: { __typename?: 'SuccessResponse', success: boolean } };

export type MenuInfo_DuplicateMenuItemMutationVariables = Exact<{
  locale: Scalars['String']['input'];
  menuItemUUID: Scalars['uuid']['input'];
  menuItemName: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type MenuInfo_DuplicateMenuItemMutation = { __typename?: 'mutation_root', duplicateMenuItem: { __typename?: 'DuplicateMenuItemOutput', menu_item?: { __typename?: 'menu_items', item_name: string, price_in_micros?: number | null, uuid: string, menu_item_ingredient_metadata: Array<{ __typename?: 'menu_item_ingredient_metadata', ingredient_metadata: any, menu_item_uuid: string, uuid: string, menu_item_ingredient: { __typename?: 'menu_item_ingredients', cost_in_micros?: number | null, ingredient_name: string, uuid: string, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } }> } | null } };

export type MenuInfo_SetIngredientPortionMutationVariables = Exact<{
  ingredientUUID: Scalars['uuid']['input'];
  metadata: Scalars['jsonb']['input'];
}>;


export type MenuInfo_SetIngredientPortionMutation = { __typename?: 'mutation_root', update_menu_item_ingredient_metadata_by_pk?: { __typename?: 'menu_item_ingredient_metadata', ingredient_metadata: any, uuid: string, menu_item_ingredient_uuid: string, menu_item_uuid: string } | null };

export type MenuInfo_SetPlatePriceMutationVariables = Exact<{
  menuItemUUID: Scalars['uuid']['input'];
  priceInMicros: Scalars['bigint']['input'];
}>;


export type MenuInfo_SetPlatePriceMutation = { __typename?: 'mutation_root', update_menu_items_by_pk?: { __typename?: 'menu_items', price_in_micros?: number | null, uuid: string } | null };

export type ItemsContext_CreateDefaultOrderGuideRecordsMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type ItemsContext_CreateDefaultOrderGuideRecordsMutation = { __typename?: 'mutation_root', createDefaultOrderGuideRecords: { __typename?: 'CreateDefaultOrderGuideRecordsResponse', collection_id: string, partition_id: string } };

export type NewOrder_OrderItemFieldsFragment = { __typename?: 'orders_items', earliest_fulfillment_at?: string | null, notes?: string | null, restaurant_display_name: string, uuid: string, order_item_prices?: { __typename?: 'order_item_prices', pack_quantity_at_order?: number | null } | null, variants_pack: { __typename?: 'variants_packs', metadata?: any | null, uuid: string, item: { __typename?: 'items', description?: string | null, uuid: string } } };

export type NewOrder_OrderFieldsFragment = { __typename?: 'orders', additional_input_values?: any | null, fulfillment_timeslot_end?: string | null, fulfillment_timeslot_start?: string | null, fulfillment_type: string, notes?: string | null, order_domain?: string | null, placed_at?: string | null, po_number?: string | null, restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_fulfillment_fees: Array<{ __typename?: 'order_fulfillment_fees', amount_in_micros?: number | null, fulfillment_settings_name?: string | null, uuid?: string | null }>, order_invoices: Array<{ __typename?: 'order_invoices', balance_in_micros?: number | null, due_at?: string | null, invoice_date: string, invoice_number?: string | null, order_uuid?: string | null, uuid: string }>, orders_items: Array<{ __typename?: 'orders_items', earliest_fulfillment_at?: string | null, notes?: string | null, restaurant_display_name: string, uuid: string, order_item_prices?: { __typename?: 'order_item_prices', pack_quantity_at_order?: number | null } | null, variants_pack: { __typename?: 'variants_packs', metadata?: any | null, uuid: string, item: { __typename?: 'items', description?: string | null, uuid: string } } }>, storefront_metadata?: { __typename?: 'storefront_order_metadata', name?: string | null, uuid: string, visibility: string } | null };

export type NewOrder_OrderContextQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  unplacedOrderStatuses: Array<OrderStatus> | OrderStatus;
  orderDomains: Array<OrderDomain> | OrderDomain;
  employeeUUID?: InputMaybe<Scalars['uuid']['input']>;
  includeActiveOrder: Scalars['Boolean']['input'];
}>;


export type NewOrder_OrderContextQuery = { __typename?: 'query_root', businesses_by_pk?: { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', timezone: string, uuid: string }, supplier_chats: Array<{ __typename?: 'chats', custom_order_guide_editing_enabled: boolean, custom_order_guide_sort_editing_enabled: boolean, display_item_prices?: boolean | null, item_modifiers_enabled: boolean, order_guide_merge_strategy?: string | null, po_number_display?: string | null, uuid: string, chats_employees?: Array<{ __typename?: 'chats_employees', storefront_active_order_uuid?: string | null, uuid: string }> }>, supplier_metadata?: { __typename?: 'supplier_metadata', allow_delivery_date_edit: boolean, display_item_code: boolean, display_item_prices: boolean, gtin_settings?: any | null, order_guide_merge_strategy: string, po_number_display: string, show_order_notes: boolean, show_upc_scanner: boolean, uuid: string } | null } | null, getAvailableOrderFulfillments: Array<{ __typename?: 'GetAvailableOrderFulfillmentResponse', default_cutoff_time?: string | null, default_lead_time_days?: number | null, fulfillment_disclaimer?: string | null, fulfillment_display_name?: string | null, fulfillment_name: FulfillmentName, fulfillment_settings_id: string, fulfillment_type: FulfillmentType, order_minimum_display_string?: string | null, primary_fulfillment_settings_id?: string | null, availability: Array<{ __typename?: 'OrderFulfillmentAvailability', cutoff_time?: string | null, date: string, lead_time_days?: number | null, order_minimum_display_string?: string | null, timeslot_settings?: { __typename?: 'FulfillmentTimeslotSettings', default_selection: FulfillmentTimeslotSelection, lead_time_minutes?: number | null, selection_required: boolean, timeslots: Array<{ __typename?: 'FulfillmentTimeslotEntry', end_time: string, start_time: string }> } | null }> }>, getOrders: Array<{ __typename?: 'OrderResponse', order?: { __typename?: 'orders', additional_input_values?: any | null, fulfillment_timeslot_end?: string | null, fulfillment_timeslot_start?: string | null, fulfillment_type: string, notes?: string | null, order_domain?: string | null, placed_at?: string | null, po_number?: string | null, restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_fulfillment_fees: Array<{ __typename?: 'order_fulfillment_fees', amount_in_micros?: number | null, fulfillment_settings_name?: string | null, uuid?: string | null }>, order_invoices: Array<{ __typename?: 'order_invoices', balance_in_micros?: number | null, due_at?: string | null, invoice_date: string, invoice_number?: string | null, order_uuid?: string | null, uuid: string }>, orders_items: Array<{ __typename?: 'orders_items', earliest_fulfillment_at?: string | null, notes?: string | null, restaurant_display_name: string, uuid: string, order_item_prices?: { __typename?: 'order_item_prices', pack_quantity_at_order?: number | null } | null, variants_pack: { __typename?: 'variants_packs', metadata?: any | null, uuid: string, item: { __typename?: 'items', description?: string | null, uuid: string } } }>, storefront_metadata?: { __typename?: 'storefront_order_metadata', name?: string | null, uuid: string, visibility: string } | null } | null }> };

export type NewOrder_SetActiveOrderMutationVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
  orderUUID?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type NewOrder_SetActiveOrderMutation = { __typename?: 'mutation_root', setActiveOrder: { __typename?: 'ActiveOrderResponse', chat_employee?: { __typename?: 'chats_employees', storefront_active_order_uuid?: string | null, uuid: string } | null } };

export type PaymentMethodFieldsFragment = { __typename?: 'payment_methods', display_text: string, is_default: boolean, payment_id: string, payment_method_type: string, payment_method_sub_type?: string | null, uuid: string };

export type RestaurantAddressFieldsFragment = { __typename?: 'addresses', city: string, postal_code?: string | null, region?: string | null, route?: string | null, street_number?: string | null, uuid: string };

export type SupplierPaymentFieldsFragment = { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', country_code: string, uuid: string }, supplier_chats: Array<{ __typename?: 'chats', dynamic_config: any, flat_transaction_fees: any, transaction_fees: any, uuid: string, chat_auto_pay_settings?: Array<{ __typename?: 'chats_auto_pay_settings', auto_pay_settings: { __typename?: 'auto_pay_settings', frequency: any, is_visible_to_restaurants: boolean, max_amount_in_micros?: number | null, pay_based_on: string, uuid: string } }>, restaurant: { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', city: string, postal_code?: string | null, region?: string | null, route?: string | null, street_number?: string | null, uuid: string } } }>, supplier_metadata?: { __typename?: 'supplier_metadata', dynamic_config: any, flat_transaction_fees?: any | null, gross_up_transaction_fees_cutoff?: string | null, show_chargeback_disclaimer?: boolean, transaction_fees: any, use_v2_invoices?: boolean, uuid: string } | null };

export type AutoPaySettingsFieldsFragment = { __typename?: 'auto_pay_settings', frequency: any, is_visible_to_restaurants: boolean, max_amount_in_micros?: number | null, pay_based_on: string, uuid: string };

export type Payments_PaymentContextQueryVariables = Exact<{
  paymentMethodWhere: Payment_Methods_Bool_Exp;
  restaurantUUID: Scalars['uuid']['input'];
  skipInvoiceAndAutoPayData: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Payments_PaymentContextQuery = { __typename?: 'query_root', businesses_by_pk?: { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', country_code: string, uuid: string }, supplier_chats: Array<{ __typename?: 'chats', dynamic_config: any, flat_transaction_fees: any, transaction_fees: any, uuid: string, chat_auto_pay_settings?: Array<{ __typename?: 'chats_auto_pay_settings', auto_pay_settings: { __typename?: 'auto_pay_settings', frequency: any, is_visible_to_restaurants: boolean, max_amount_in_micros?: number | null, pay_based_on: string, uuid: string } }>, restaurant: { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', city: string, postal_code?: string | null, region?: string | null, route?: string | null, street_number?: string | null, uuid: string } } }>, supplier_metadata?: { __typename?: 'supplier_metadata', dynamic_config: any, flat_transaction_fees?: any | null, gross_up_transaction_fees_cutoff?: string | null, show_chargeback_disclaimer?: boolean, transaction_fees: any, use_v2_invoices?: boolean, uuid: string } | null } | null, auto_pay_settings?: Array<{ __typename?: 'auto_pay_settings', frequency: any, is_visible_to_restaurants: boolean, max_amount_in_micros?: number | null, pay_based_on: string, uuid: string }>, payment_methods: Array<{ __typename?: 'payment_methods', display_text: string, is_default: boolean, payment_id: string, payment_method_type: string, payment_method_sub_type?: string | null, uuid: string }> };

export type AvailableCreditMemoListFieldsFragment = { __typename?: 'CreditMemo', credit_amount_in_micros: number, credit_date?: string | null, credit_id: string, credit_number: string };

export type UnpaidInvoiceListFieldsFragment = { __typename?: 'OrderInvoice', currency_code: string, due_at?: string | null, invoice_id: string, invoice_number: string, order_fulfillment_at?: string | null, order_id?: string | null, unpaid_amount_in_micros: number };

export type Payments_PaymentsContextUnpaidListQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  invoiceRestaurantFilter?: InputMaybe<Scalars['uuid']['input']>;
  usableAfter?: InputMaybe<Scalars['String']['input']>;
}>;


export type Payments_PaymentsContextUnpaidListQuery = { __typename?: 'query_root', getAvailableCreditMemosByCustomer: Array<{ __typename?: 'GetAvailableCreditMemosByCustomerResponse', restaurant_id: string, credit_memos: Array<{ __typename?: 'CreditMemo', credit_amount_in_micros: number, credit_date?: string | null, credit_id: string, credit_number: string }> }>, getUnpaidOrderInvoicesByCustomer: Array<{ __typename?: 'GetUnpaidOrderInvoicesByCustomerResponse', restaurant_id: string, supplier_id?: string | null, order_invoices: Array<{ __typename?: 'OrderInvoice', currency_code: string, due_at?: string | null, invoice_id: string, invoice_number: string, order_fulfillment_at?: string | null, order_id?: string | null, unpaid_amount_in_micros: number }> }> };

export type AutoPaySettings_GetNextAutoPayInfoQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type AutoPaySettings_GetNextAutoPayInfoQuery = { __typename?: 'query_root', getNextAutopayInfo: { __typename?: 'NextAutoPayInfoResponse', amount_in_micros: number, date: string, auto_pay_settings?: { __typename?: 'auto_pay_settings', frequency: any, lookback_period_days: number, max_amount_in_micros?: number | null, uuid: string } | null } };

export type PaymentForm_RemovePaymentMethodMutationVariables = Exact<{
  paymentMethodUUID: Scalars['uuid']['input'];
}>;


export type PaymentForm_RemovePaymentMethodMutation = { __typename?: 'mutation_root', removePaymentMethod: { __typename?: 'RemovePaymentMethodResponse', payment_method?: { __typename?: 'payment_methods', display_text: string, is_default: boolean, payment_id: string, payment_method_type: string, payment_method_sub_type?: string | null, uuid: string } | null } };

export type Fnti_UnlockExpiredFtniSessionsMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Fnti_UnlockExpiredFtniSessionsMutation = { __typename?: 'mutation_root', unlockExpiredFtniSessions: { __typename?: 'SuccessResponse', success: boolean } };

export type AutopayContainer_SelectAutoPaySettingsMutationVariables = Exact<{
  autoPaySettingUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type AutopayContainer_SelectAutoPaySettingsMutation = { __typename?: 'mutation_root', selectAutoPaySettings: { __typename?: 'SelectAutoPaySettingsResponse', auto_pay_settings_id: string } };

export type NewOrder_ScannerCartVariantPackQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPackUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type NewOrder_ScannerCartVariantPackQuery = { __typename?: 'query_root', visible_variant_packs: Array<{ __typename?: 'visible_variant_packs', variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> };

export type Initial_SmartOrderQueryVariables = Exact<{
  smartOrderUUID: Scalars['uuid']['input'];
}>;


export type Initial_SmartOrderQuery = { __typename?: 'query_root', smart_order_by_pk?: { __typename?: 'smart_order', order_uuid?: string | null, restaurant_uuid?: string | null, uuid: string } | null };

export type SmartOrder_ResultsSmartOrderQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  smartOrderUUID: Scalars['uuid']['input'];
  businessOrganizationUUID: Scalars['uuid']['input'];
}>;


export type SmartOrder_ResultsSmartOrderQuery = { __typename?: 'query_root', smart_order: Array<{ __typename?: 'smart_order', search_inputs: any, uuid: string, smart_order_results: Array<{ __typename?: 'smart_order_result', quantity: number, search_term: string, uuid: string, variant_pack: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } }> }> };

export type SmartOrder_PlacedSmartOrderQueryVariables = Exact<{
  orderUUID: Scalars['uuid']['input'];
}>;


export type SmartOrder_PlacedSmartOrderQuery = { __typename?: 'query_root', orders_aggregate: { __typename?: 'orders_aggregate', aggregate?: { __typename?: 'orders_aggregate_fields', count: number } | null } };

export type SmartOrder_UserContextQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  userUUID: Scalars['uuid']['input'];
}>;


export type SmartOrder_UserContextQuery = { __typename?: 'query_root', businesses: Array<{ __typename?: 'businesses', uuid: string, supplier_metadata?: { __typename?: 'supplier_metadata', dynamic_config: any, uuid: string } | null }>, employees_by_pk?: { __typename?: 'employees', locale: string, name: string, uuid: string, contact_info: { __typename?: 'employee_contact_info', email?: string | null, login_email?: string | null, phone_number: string, uuid: string }, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', supplier_uuid: string, contact_emails: any, contact_phone_numbers: any, name?: string | null, uuid: string }> } | null, employee_chats: Array<{ __typename?: 'employee_chats', chat_dynamic_config?: any | null, chat_uuid?: string | null, display_item_prices?: boolean | null, restaurant_account_id?: string | null, restaurant_address?: string | null, restaurant_name?: string | null, restaurant_timezone?: string | null, restaurant_uuid?: string | null, status?: string | null, supplier_uuid?: string | null }>, whitelabel_config: Array<{ __typename?: 'whitelabel_config', translations_enabled?: boolean | null, uuid: string }> };

export type UserContextUserContactInfoFragment = { __typename?: 'employee_contact_info', email?: string | null, login_email?: string | null, phone_number: string, uuid: string };

export type UserContextUserSupplierEmployeeOverridesFragment = { __typename?: 'supplier_employee_overrides', contact_emails: any, contact_phone_numbers: any, name?: string | null, supplier_uuid: string, uuid: string };

export type UserContextUserFragment = { __typename?: 'employees', locale: string, name: string, uuid: string, contact_info: { __typename?: 'employee_contact_info', email?: string | null, login_email?: string | null, phone_number: string, uuid: string }, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', supplier_uuid: string, contact_emails: any, contact_phone_numbers: any, name?: string | null, uuid: string }> };

export type UserContextSupplierEmployeeFragment = { __typename?: 'businesses_employees', business_uuid: string, employee_config?: any | null, employee_permissions?: any | null, employee_role: string, uuid: string };

export type UserContextSupplierFragment = { __typename?: 'businesses', name: string, uuid: string, address: { __typename?: 'addresses', timezone: string, country_code: string, uuid: string }, businesses_employees: Array<{ __typename?: 'businesses_employees', business_uuid: string, employee_config?: any | null, employee_permissions?: any | null, employee_role: string, uuid: string }>, payments_status?: { __typename?: 'supplier_payments_status', status?: string | null } | null, supplier_loyalty_programs: Array<{ __typename?: 'supplier_loyalty_programs', uuid: string }>, supplier_metadata?: { __typename?: 'supplier_metadata', app_account_creation_enabled: boolean, display_item_prices: boolean, dynamic_config: any, gtin_settings?: any | null, uuid: string } | null };

export type UserContext_EmployeeQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  employeeChatsFilter: Employee_Chats_Bool_Exp;
  userUUID: Scalars['uuid']['input'];
}>;


export type UserContext_EmployeeQuery = { __typename?: 'query_root', businesses: Array<{ __typename?: 'businesses', name: string, uuid: string, address: { __typename?: 'addresses', timezone: string, country_code: string, uuid: string }, businesses_employees: Array<{ __typename?: 'businesses_employees', business_uuid: string, employee_config?: any | null, employee_permissions?: any | null, employee_role: string, uuid: string }>, payments_status?: { __typename?: 'supplier_payments_status', status?: string | null } | null, supplier_loyalty_programs: Array<{ __typename?: 'supplier_loyalty_programs', uuid: string }>, supplier_metadata?: { __typename?: 'supplier_metadata', app_account_creation_enabled: boolean, display_item_prices: boolean, dynamic_config: any, gtin_settings?: any | null, uuid: string } | null }>, employees_by_pk?: { __typename?: 'employees', locale: string, name: string, uuid: string, contact_info: { __typename?: 'employee_contact_info', email?: string | null, login_email?: string | null, phone_number: string, uuid: string }, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', supplier_uuid: string, contact_emails: any, contact_phone_numbers: any, name?: string | null, uuid: string }> } | null, employee_chats: Array<{ __typename?: 'employee_chats', app_payments_enabled?: boolean | null, chat_dynamic_config?: any | null, chat_uuid?: string | null, display_item_prices?: boolean | null, on_hold?: boolean | null, order_review_required?: boolean | null, restaurant_account_id?: string | null, restaurant_address?: string | null, restaurant_employee_role?: string | null, restaurant_name?: string | null, restaurant_timezone?: string | null, restaurant_uuid?: string | null, show_app_payments_tab?: boolean | null, status?: string | null, supplier_uuid?: string | null }>, whitelabel_config: Array<{ __typename?: 'whitelabel_config', translations_enabled?: boolean | null, uuid: string }> };

export type VariantPackCostInfoDetailsFieldsFragment = { __typename?: 'VariantPackDetailedCostInfoResponse', cost_in_micros: number, type: VariantPackCostType };

export type VariantPackInfoContext_InfoFieldsFragment = { __typename?: 'GetVariantPackInfoResponse', availability_status?: string | null, available_quantity?: number | null, currency_code: string, default_price_in_micros?: number | null, list_item_display_text?: string | null, manufacturer_suggested_retail_price_in_micros?: number | null, price_in_micros?: number | null, sales_rep_price_in_micros?: number | null, sales_rep_gross_profit_in_percentage?: number | null, suggested_retail_price_in_micros?: number | null, variant_pack_id: string, unit_count: number, cost_info?: { __typename?: 'VariantPackCostInfoResponse', details?: Array<{ __typename?: 'VariantPackDetailedCostInfoResponse', cost_in_micros: number, type: VariantPackCostType }> | null } | null, inventory_info?: { __typename?: 'VariantPackInventoryInfoResponse', quantity_on_hand?: number | null, incoming?: Array<{ __typename?: 'VariantPackIncomingInventoryResponse', date: string, quantity: number }> | null } | null, sales_rep_metadata?: { __typename?: 'VariantPackSalesRepMetadataResponse', price_ceiling_in_micros?: number | null, updated_by_name?: string | null } | null };

export type VariantPackInfoContext_GetEssentialItemsQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type VariantPackInfoContext_GetEssentialItemsQuery = { __typename?: 'query_root', getCriticalItems: Array<{ __typename?: 'VariantPackResponse', variant_pack_id: string }> };

export type VariantPackInfoContext_OrderGuideInfoListQueryVariables = Exact<{
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type VariantPackInfoContext_OrderGuideInfoListQuery = { __typename?: 'query_root', getVariantPackInfoList: Array<{ __typename?: 'GetVariantPackInfoResponse', availability_status?: string | null, available_quantity?: number | null, currency_code: string, default_price_in_micros?: number | null, list_item_display_text?: string | null, manufacturer_suggested_retail_price_in_micros?: number | null, price_in_micros?: number | null, sales_rep_price_in_micros?: number | null, sales_rep_gross_profit_in_percentage?: number | null, suggested_retail_price_in_micros?: number | null, variant_pack_id: string, unit_count: number, cost_info?: { __typename?: 'VariantPackCostInfoResponse', details?: Array<{ __typename?: 'VariantPackDetailedCostInfoResponse', cost_in_micros: number, type: VariantPackCostType }> | null } | null, inventory_info?: { __typename?: 'VariantPackInventoryInfoResponse', quantity_on_hand?: number | null, incoming?: Array<{ __typename?: 'VariantPackIncomingInventoryResponse', date: string, quantity: number }> | null } | null, sales_rep_metadata?: { __typename?: 'VariantPackSalesRepMetadataResponse', price_ceiling_in_micros?: number | null, updated_by_name?: string | null } | null }> };

export type VariantPackInfoContext_InfoListQueryVariables = Exact<{
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type VariantPackInfoContext_InfoListQuery = { __typename?: 'query_root', getVariantPackInfoList: Array<{ __typename?: 'GetVariantPackInfoResponse', availability_status?: string | null, available_quantity?: number | null, currency_code: string, default_price_in_micros?: number | null, list_item_display_text?: string | null, manufacturer_suggested_retail_price_in_micros?: number | null, price_in_micros?: number | null, sales_rep_price_in_micros?: number | null, sales_rep_gross_profit_in_percentage?: number | null, suggested_retail_price_in_micros?: number | null, variant_pack_id: string, unit_count: number, cost_info?: { __typename?: 'VariantPackCostInfoResponse', details?: Array<{ __typename?: 'VariantPackDetailedCostInfoResponse', cost_in_micros: number, type: VariantPackCostType }> | null } | null, inventory_info?: { __typename?: 'VariantPackInventoryInfoResponse', quantity_on_hand?: number | null, incoming?: Array<{ __typename?: 'VariantPackIncomingInventoryResponse', date: string, quantity: number }> | null } | null, sales_rep_metadata?: { __typename?: 'VariantPackSalesRepMetadataResponse', price_ceiling_in_micros?: number | null, updated_by_name?: string | null } | null }>, businesses_by_pk?: { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', country_code: string, uuid: string } } | null };

export type VariantPackInfoContext_LastPurchaseInfoQueryVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
}>;


export type VariantPackInfoContext_LastPurchaseInfoQuery = { __typename?: 'query_root', getVariantPackLastPurchaseInfo: Array<{ __typename?: 'GetVariantPackLastPurchaseInfoResponse', fulfillment_date?: string | null, order_date?: string | null, price_in_micros?: number | null, quantity?: number | null, unit_count?: number | null, variant_pack_id?: string | null, cost_info?: { __typename?: 'VariantPackCostInfoResponse', details?: Array<{ __typename?: 'VariantPackDetailedCostInfoResponse', cost_in_micros: number, type: VariantPackCostType }> | null } | null }> };

export type VariantPackInfoContext_OrderConstraintsQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type VariantPackInfoContext_OrderConstraintsQuery = { __typename?: 'query_root', getOrderConstraintsForRestaurant: Array<{ __typename?: 'GetOrderConstraintsForRestaurantResponse', variant_pack_id: string, order_constraints: Array<{ __typename?: 'VariantPackConstraint', max_quantity?: number | null, min_quantity?: number | null }> }> };

export type SalesPortalEmployeePermissionsQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
  userUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalEmployeePermissionsQuery = { __typename?: 'query_root', businesses_by_pk?: { __typename?: 'businesses', businesses_employees: Array<{ __typename?: 'businesses_employees', employee_permissions?: any | null, uuid: string }> } | null };

export type SalesPortalEmployeeConfigQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
  userUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalEmployeeConfigQuery = { __typename?: 'query_root', businesses_by_pk?: { __typename?: 'businesses', businesses_employees: Array<{ __typename?: 'businesses_employees', employee_config?: any | null, uuid: string }> } | null };

export type UpdateSalesRepGrossProfitOverrideMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPacks: Array<SalesRepUpdateVariantPackGrossProfitInput> | SalesRepUpdateVariantPackGrossProfitInput;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSalesRepGrossProfitOverrideMutation = { __typename?: 'mutation_root', updateSalesRepGrossProfitPercentageOverrides: Array<{ __typename?: 'GetVariantPackInfoResponse', variant_pack_id: string, default_price_in_micros?: number | null, price_in_micros?: number | null, sales_rep_price_in_micros?: number | null, sales_rep_gross_profit_in_percentage?: number | null, unit_count: number, sales_rep_metadata?: { __typename?: 'VariantPackSalesRepMetadataResponse', updated_by_name?: string | null } | null }> };

export type UpdateSalesRepPriceOverrideMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPacks: Array<SalesRepUpdateVariantPackInput> | SalesRepUpdateVariantPackInput;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSalesRepPriceOverrideMutation = { __typename?: 'mutation_root', updateSalesRepPrice: Array<{ __typename?: 'GetVariantPackInfoResponse', variant_pack_id: string, default_price_in_micros?: number | null, price_in_micros?: number | null, sales_rep_price_in_micros?: number | null, sales_rep_gross_profit_in_percentage?: number | null, unit_count: number, sales_rep_metadata?: { __typename?: 'VariantPackSalesRepMetadataResponse', updated_by_name?: string | null } | null }> };

export type FinanceHubCustomerListItemFieldsFragment = { __typename?: 'FinanceHubCustomerListItem', account_id?: string | null, address?: string | null, chat_id: string, currency_code: string, customer_name?: string | null, has_autopay: boolean, has_contact_info: boolean, has_payment_method: boolean, has_payment_plan: boolean, has_statement: boolean, invoice_count: number, outstanding_balance_in_micros: number };

export type FinanceHubCustomerListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FinanceHubCustomerListQuery = { __typename?: 'query_root', getFinanceHubCustomerList: { __typename?: 'GetFinanceHubCustomerListResponse', customers: Array<{ __typename?: 'FinanceHubCustomerListItem', account_id?: string | null, address?: string | null, chat_id: string, currency_code: string, customer_name?: string | null, has_autopay: boolean, has_contact_info: boolean, has_payment_method: boolean, has_payment_plan: boolean, has_statement: boolean, invoice_count: number, outstanding_balance_in_micros: number }> } };

export type FinanceHubInvoiceSummaryBucketFieldsFragment = { __typename?: 'UnpaidInvoiceSummaryBucket', amount_in_micros: number, count: number };

export type FinanceHubInvoiceSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type FinanceHubInvoiceSummaryQuery = { __typename?: 'query_root', getUnpaidInvoiceSummary: { __typename?: 'GetUnpaidInvoiceSummaryResponse', currency_code: string, current: { __typename?: 'UnpaidInvoiceSummaryBucket', amount_in_micros: number, count: number }, days_0_14: { __typename?: 'UnpaidInvoiceSummaryBucket', amount_in_micros: number, count: number }, days_15_30: { __typename?: 'UnpaidInvoiceSummaryBucket', amount_in_micros: number, count: number }, days_31_60: { __typename?: 'UnpaidInvoiceSummaryBucket', amount_in_micros: number, count: number }, days_61_90: { __typename?: 'UnpaidInvoiceSummaryBucket', amount_in_micros: number, count: number }, days_90_plus: { __typename?: 'UnpaidInvoiceSummaryBucket', amount_in_micros: number, count: number }, overdue: { __typename?: 'UnpaidInvoiceSummaryBucket', amount_in_micros: number, count: number }, total_credits: { __typename?: 'UnpaidInvoiceSummaryBucket', amount_in_micros: number, count: number }, total_due: { __typename?: 'UnpaidInvoiceSummaryBucket', amount_in_micros: number, count: number } } };

export type FinanceHubUnpaidInvoiceListItemFieldsFragment = { __typename?: 'UnpaidInvoiceListItem', amount_paid_in_micros: number, currency_code: string, customer_name?: string | null, days_overdue: number, due_at?: string | null, erp_last_modified_at?: string | null, invoice_number?: string | null, is_partially_paid: boolean, record_id: string, record_type: InvoiceListRecordType, remaining_balance_in_micros: number };

export type FinanceHubUnpaidInvoiceListQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  overdue_bucket?: InputMaybe<InvoiceListAgingBucket>;
  record_type?: InputMaybe<InvoiceListRecordType>;
  search_input?: InputMaybe<Scalars['String']['input']>;
  sort_by: InvoiceListSortField;
  sort_direction: InvoiceListSortDirection;
}>;


export type FinanceHubUnpaidInvoiceListQuery = { __typename?: 'query_root', getUnpaidInvoiceList: { __typename?: 'GetUnpaidInvoiceListResponse', has_more_pages: boolean, invoices: Array<{ __typename?: 'UnpaidInvoiceListItem', amount_paid_in_micros: number, currency_code: string, customer_name?: string | null, days_overdue: number, due_at?: string | null, erp_last_modified_at?: string | null, invoice_number?: string | null, is_partially_paid: boolean, record_id: string, record_type: InvoiceListRecordType, remaining_balance_in_micros: number }> } };

export type GetBusinessOrganizationPricingConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessOrganizationPricingConfigQuery = { __typename?: 'query_root', getBusinessOrganizationPricingConfig: { __typename?: 'OrgPricingConfigResponse', bookmarking_enabled: boolean, cost_change_lookback_mode: CostChangeLookbackMode, cost_change_week_anchor_day?: number | null, currency_code?: string | null, customer_table_enabled: boolean, peer_range_column_enabled: boolean, pricing_agent_enabled: boolean, pricing_management_enabled: boolean, show_invoice_history_popover: boolean, timezone?: string | null } };

export type SalesPortalAccountListQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalAccountListQuery = { __typename?: 'query_root', getSalesPortalAccounts: Array<{ __typename?: 'SalesPortalAccount', chat_id: string, currency_code: string, restaurant_id: string, supplier_id: string, restaurant?: { __typename?: 'businesses', name: string, address: { __typename?: 'addresses', address: string } } | null }> };

export type SalesPortalActivityNotesQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  cursor?: InputMaybe<Scalars['uuid']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SalesPortalActivityNotesQuery = { __typename?: 'query_root', getCrmActivities: { __typename?: 'CRMActivitiesPage', cursor?: string | null, activities: Array<{ __typename?: 'CRMActivity', uuid: string, created_at: string, created_by_name?: string | null, note?: { __typename?: 'CRMActivityNote', content: string } | null, check_in?: { __typename?: 'CRMActivityCheckIn', interactions: Array<CrmCheckInInteraction> } | null, reminder?: { __typename?: 'CRMActivityReminder', uuid: string, remind_at: string } | null }> } };

export type SalesPortalBusinessPhoneNumberQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalBusinessPhoneNumberQuery = { __typename?: 'query_root', businessDetails: { __typename?: 'BusinessDetailsResponse', phone_number?: string | null } };

export type SalesPortalChatDynamicConfigQueryVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalChatDynamicConfigQuery = { __typename?: 'query_root', employee_chats: Array<{ __typename?: 'employee_chats', chat_uuid?: string | null, chat_dynamic_config?: any | null, supplier_uuid?: string | null }> };

export type SalesPortalChatPoNumberDisplayQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalChatPoNumberDisplayQuery = { __typename?: 'query_root', businesses_by_pk?: { __typename?: 'businesses', uuid: string, supplier_chats: Array<{ __typename?: 'chats', po_number_display?: string | null, uuid: string }> } | null };

export type SalesPortalCreateActivityNoteMutationVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
  noteContent: Scalars['String']['input'];
}>;


export type SalesPortalCreateActivityNoteMutation = { __typename?: 'mutation_root', createNoteActivity: { __typename?: 'CreateNoteAcitivityResponse', crm_activity?: { __typename?: 'crm_activities', uuid: string, chat_uuid: string, created_at: string, crm_activity_notes?: { __typename?: 'crm_activity_notes', content: string, uuid: string } | null } | null } };

export type SalesPortalCreateActivityReminderMutationVariables = Exact<{
  crmActivityUUID: Scalars['uuid']['input'];
  chatUUID: Scalars['uuid']['input'];
  reminderDatetime: Scalars['String']['input'];
}>;


export type SalesPortalCreateActivityReminderMutation = { __typename?: 'mutation_root', createActivityReminder: { __typename?: 'CreateActivityReminderResponse', crm_activity_reminder?: { __typename?: 'crm_activity_reminders', remind_at: string, status: string, uuid: string } | null } };

export type SalesPortalCreateCrmActivityMutationVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
  checkIn: CrmActivityCheckInInput;
  note?: InputMaybe<CrmActivityNoteInput>;
  reminder?: InputMaybe<CrmActivityReminderInput>;
}>;


export type SalesPortalCreateCrmActivityMutation = { __typename?: 'mutation_root', createCrmActivity: { __typename?: 'CreateCRMActivityResponse', activity_id: string } };

export type SalesPortalCreateOrderGuideFromMenuItemsMutationVariables = Exact<{
  items: Array<MenuItemInput> | MenuItemInput;
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalCreateOrderGuideFromMenuItemsMutation = { __typename?: 'mutation_root', createOrderGuideFromGeneratedMenuItems: { __typename?: 'CreateOrderGuideFromGeneratedMenuItemsResponse', order_guide_collection_uuid: string, order_guide_partition_uuid: string } };

export type SalesPortalCreateOrderGuideFromMenuMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalCreateOrderGuideFromMenuMutation = { __typename?: 'mutation_root', createOrderGuideFromMenu: { __typename?: 'CreateOrderGuideFromMenuResponse', order_guide_collection_uuid: string, order_guide_partition_uuid: string } };

export type SalesPortalDetailHeaderAddressFieldsFragment = { __typename?: 'addresses', address: string, city: string, latitude: number, longitude: number, region?: string | null, uuid: string };

export type SalesPortalDetailHeaderChatFieldsFragment = { __typename?: 'chats', restaurant_account_id?: string | null, uuid: string };

export type SalesPortalDynamicConfigQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
  businessOrganizationUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalDynamicConfigQuery = { __typename?: 'query_root', businesses_by_pk?: { __typename?: 'businesses', uuid: string, supplier_metadata?: { __typename?: 'supplier_metadata', dynamic_config: any, po_number_display: string, show_order_notes: boolean } | null } | null, employee_chats: Array<{ __typename?: 'employee_chats', chat_uuid?: string | null, chat_dynamic_config?: any | null, supplier_uuid?: string | null }> };

export type SalesPortalEmployeeRoleQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
  userUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalEmployeeRoleQuery = { __typename?: 'query_root', businesses_by_pk?: { __typename?: 'businesses', uuid: string, businesses_employees: Array<{ __typename?: 'businesses_employees', employee_role: string, uuid: string, employee: { __typename?: 'employees', contact_info: { __typename?: 'employee_contact_info', email?: string | null, login_email?: string | null } } }> } | null };

export type SalesPortalMenuImageItemsQueryVariables = Exact<{
  imageUrls: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SalesPortalMenuImageItemsQuery = { __typename?: 'query_root', getItemsFromMenuImages: { __typename?: 'GetItemsFromMenuImagesResponse', items: Array<{ __typename?: 'MenuItem', ingredients: Array<string>, item_name: string }> } };

export type SalesPortalOnlineMenuQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalOnlineMenuQuery = { __typename?: 'query_root', getBusinessDetails: { __typename?: 'BusinessDetailsResponse', menu_items?: Array<{ __typename?: 'MenuItem', ingredients: Array<string>, item_name: string }> | null } };

export type PriceEditDisplayInfoDetailFieldsFragment = { __typename?: 'PriceEditDisplayInfoDetail', currency?: string | null, title: string, type: string, value?: string | null };

export type SalesPortalSignedInEmployeeQueryVariables = Exact<{
  userUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalSignedInEmployeeQuery = { __typename?: 'query_root', employees_by_pk?: { __typename?: 'employees', uuid: string, name: string } | null };

export type SalesPortalSupplierDynamicConfigQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalSupplierDynamicConfigQuery = { __typename?: 'query_root', businesses_by_pk?: { __typename?: 'businesses', uuid: string, supplier_metadata?: { __typename?: 'supplier_metadata', dynamic_config: any, po_number_display: string, show_order_notes: boolean } | null } | null };

export type SalesPortalSupplierMetadataQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalSupplierMetadataQuery = { __typename?: 'query_root', businesses_by_pk?: { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', country_code: string, timezone: string, uuid: string }, supplier_metadata?: { __typename?: 'supplier_metadata', po_number_display: string, show_order_notes: boolean } | null } | null };

export type CompleteTranslationFieldsFragment = { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string };

export type AccountDetailAr_UnpaidInvoiceFieldsFragment = { __typename?: 'OrderInvoice', due_at?: string | null, invoice_id: string, unpaid_amount_in_micros: number };

export type AccountDetailAr_CreditMemoFieldsFragment = { __typename?: 'CreditMemo', credit_amount_in_micros: number, credit_id: string };

export type SalesPortalAccountDetailArQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  usableAfter?: InputMaybe<Scalars['String']['input']>;
}>;


export type SalesPortalAccountDetailArQuery = { __typename?: 'query_root', getAvailableCreditMemosByCustomer: Array<{ __typename?: 'GetAvailableCreditMemosByCustomerResponse', restaurant_id: string, credit_memos: Array<{ __typename?: 'CreditMemo', credit_amount_in_micros: number, credit_id: string }> }>, getUnpaidOrderInvoicesByCustomer: Array<{ __typename?: 'GetUnpaidOrderInvoicesByCustomerResponse', restaurant_id: string, supplier_id?: string | null, order_invoices: Array<{ __typename?: 'OrderInvoice', due_at?: string | null, invoice_id: string, unpaid_amount_in_micros: number }> }> };

export type SalesPortalAccountDetailMetricsQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalAccountDetailMetricsQuery = { __typename?: 'query_root', periodSalesAnalytics: Array<{ __typename?: 'GetPeriodSalesAnalyticsResponse', avg_order_size: number, avg_order_size_percent_change?: number | null, currency_code: string, period_type: SalesAnalyticsPeriodType, total_orders: number, total_orders_percent_change?: number | null, total_sales_in_micros: number, total_sales_percent_change?: number | null }> };

export type SalesPortalAccountDetailSalesAlertsQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalAccountDetailSalesAlertsQuery = { __typename?: 'query_root', analyticsAlerts: { __typename?: 'GetAnalyticsAlertsResponse', alerts_json: Array<string> } };

export type SalesPortalAccountDetailsQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalAccountDetailsQuery = { __typename?: 'query_root', restaurant?: { __typename?: 'businesses', name: string, uuid: string, address: { __typename?: 'addresses', address2?: string | null, country_code: string, timezone: string, address: string, city: string, latitude: number, longitude: number, region?: string | null, uuid: string }, restaurant_chats: Array<{ __typename?: 'chats', restaurant_notes?: string | null, show_app_payments_tab: boolean, status: string, restaurant_account_id?: string | null, uuid: string }> } | null, businessDetails: { __typename?: 'BusinessDetailsResponse', hours?: Array<{ __typename?: 'OpenHours', open: Array<{ __typename?: 'OpenHoursDetails', day: number, end: string, is_overnight: boolean, start: string }> }> | null } };

export type SalesPortalAccountDetailsItemsOfInterestQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  fromDate: Scalars['String']['input'];
}>;


export type SalesPortalAccountDetailsItemsOfInterestQuery = { __typename?: 'query_root', getObiItems: { __typename?: 'GetObiItemsResponse', obi_items: Array<{ __typename?: 'ObiItem', variant_pack_uuid: string, title: string, obi_item_type: ObiItemType, event_time: string, subtitle: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string }, variant_pack?: { __typename?: 'variants_packs', uuid: string, item: { __typename?: 'items', photo_url_list?: any | null, uuid: string } } | null }> } };

export type SalesPortalEditableAccountQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalEditableAccountQuery = { __typename?: 'query_root', restaurant?: { __typename?: 'businesses', uuid: string, name: string, address: { __typename?: 'addresses', uuid: string, address: string, address2?: string | null }, restaurant_chats: Array<{ __typename?: 'chats', restaurant_account_id?: string | null, restaurant_notes?: string | null, chat_route_metadata?: { __typename?: 'chats_route_metadata', name: string } | null }> } | null };

export type SalesPortalUpdateAccountMutationVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  accountId?: InputMaybe<Scalars['String']['input']>;
  routeStop?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type SalesPortalUpdateAccountMutation = { __typename?: 'mutation_root', supplierUpdateRestaurant: { __typename?: 'SupplierCreateOrUpdateRestaurantResponse', restaurant_id: string } };

export type SalesPortalAccountListDataPaginatedQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  cursor?: InputMaybe<Scalars['uuid']['input']>;
  filters?: InputMaybe<SalesPortalAccountListFilters>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  userTimezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type SalesPortalAccountListDataPaginatedQuery = { __typename?: 'query_root', getSalesPortalAccountListInfoPaginated: { __typename?: 'SalesPortalAccountListInfoPage', cursor?: string | null, accounts: Array<{ __typename?: 'SalesPortalPaginatedAccountInfo', last_fulfilled_date_display?: string | null, restaurant_account_id?: string | null, restaurant_address: string, restaurant_id: string, restaurant_name: string, supplier_id: string }> } };

export type SalesPortalAccountListFilterCountsQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  filters?: InputMaybe<SalesPortalAccountListFilters>;
}>;


export type SalesPortalAccountListFilterCountsQuery = { __typename?: 'query_root', getSalesPortalAccountListFilterCounts: { __typename?: 'SalesPortalAccountListFilterCounts', group_counts: Array<{ __typename?: 'SalesPortalAccountListGroupCount', count: number, group_id: string, name: string }>, status_counts: Array<{ __typename?: 'SalesPortalAccountListStatusCount', count: number, status: ChatStatus }> } };

export type SalesPortalEmployeeNotificationsQueryVariables = Exact<{
  employeeUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalEmployeeNotificationsQuery = { __typename?: 'query_root', employees_by_pk?: { __typename?: 'employees', uuid: string, contact_info: { __typename?: 'employee_contact_info', uuid: string, wants_chat_email: boolean, wants_credit_request_email: boolean, wants_order_email: boolean, wants_order_tracking_notification: boolean, wants_payment_email: boolean } } | null };

export type SalesPortalRemoveEmployeeMutationVariables = Exact<{
  businessUUID: Scalars['uuid']['input'];
  employeeUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalRemoveEmployeeMutation = { __typename?: 'mutation_root', removeEmployeeFromBusiness: { __typename?: 'EmployeeResponse', employee_id: string } };

export type SalesPortalRestaurantEmployeesQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalRestaurantEmployeesQuery = { __typename?: 'query_root', getRestaurantEmployees: Array<{ __typename?: 'GetRestaurantEmployeesResponse', chat_employee_id: string, employee_contact_email?: string | null, employee_contact_phone_number: string, employee_id: string, employee_login_email?: string | null, employee_name: string, employee_status: EmployeeStatus, restaurant_employee_id: string, restaurant_employee_role: EmployeeRole, show_app_payments_tab: boolean }> };

export type SalesPortalUpdateEmployeeRoleMutationVariables = Exact<{
  businessEmployeeUUID: Scalars['uuid']['input'];
  employeeRole: Scalars['String']['input'];
}>;


export type SalesPortalUpdateEmployeeRoleMutation = { __typename?: 'mutation_root', update_businesses_employees_by_pk?: { __typename?: 'businesses_employees', employee_role: string, uuid: string } | null };

export type SalesPortalUpdateEmployeeShowPaymentsMutationVariables = Exact<{
  chatEmployeeUUID: Scalars['uuid']['input'];
  showAppPaymentsTab: Scalars['Boolean']['input'];
}>;


export type SalesPortalUpdateEmployeeShowPaymentsMutation = { __typename?: 'mutation_root', update_chats_employees_by_pk?: { __typename?: 'chats_employees', show_app_payments_tab?: boolean | null, uuid: string } | null };

export type SalesPortalInviteRestaurantEmployeeMutationVariables = Exact<{
  name: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID?: InputMaybe<Scalars['uuid']['input']>;
  contactInfo: ContactInfoInput;
  employeeRole?: InputMaybe<Scalars['String']['input']>;
}>;


export type SalesPortalInviteRestaurantEmployeeMutation = { __typename?: 'mutation_root', inviteRestaurantEmployee: { __typename?: 'InviteRestaurantEmployeeResponse', employee_id: string, is_duplicate_employee?: boolean | null } };

export type SalesPortalUpdateEmployeeNotificationsMutationVariables = Exact<{
  employeeContactInfoUUID: Scalars['uuid']['input'];
  set: Employee_Contact_Info_Set_Input;
}>;


export type SalesPortalUpdateEmployeeNotificationsMutation = { __typename?: 'mutation_root', update_employee_contact_info_by_pk?: { __typename?: 'employee_contact_info', uuid: string, wants_chat_email: boolean, wants_credit_request_email: boolean, wants_order_email: boolean, wants_order_tracking_notification: boolean, wants_payment_email: boolean } | null };

export type SalesPortalCopilotSendMessageMutationVariables = Exact<{
  text: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SalesPortalCopilotSendMessageMutation = { __typename?: 'mutation_root', salesPortalCopilotSendMessage: { __typename?: 'SalesPortalCopilotSendMessageResponse', session_id?: string | null, messages: Array<{ __typename?: 'SalesPortalCopilotMessage', text: string, timestamp: string }> } };

export type SalesPortalGetActiveAlertsQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalGetActiveAlertsQuery = { __typename?: 'query_root', getAllHubAlerts: { __typename?: 'GetAllHubAnalyticsAlertsResponse', card_data_json: Array<string> } };

export type SalesPortalUpdateAlertStatusesMutationVariables = Exact<{
  alertStatus: AnalyticsAlertStatusType;
  alertUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  businessOrganizationUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalUpdateAlertStatusesMutation = { __typename?: 'mutation_root', updateAnalyticsAlertsStatuses: { __typename?: 'UpdateAnalyticsAlertsStatusResponse', updatedCount: number } };

export type SalesPortalGetHiddenAlertsQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalGetHiddenAlertsQuery = { __typename?: 'query_root', getAllHubAlerts: { __typename?: 'GetAllHubAnalyticsAlertsResponse', card_data_json: Array<string> } };

export type SalesPortalGetHubCardDataQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  cardType: HubCardType;
  userUUID: Scalars['uuid']['input'];
  userTimezone: Scalars['String']['input'];
}>;


export type SalesPortalGetHubCardDataQuery = { __typename?: 'query_root', getHubCardData: { __typename?: 'GetHubCardDataResponse', card_data_json: Array<string> } };

export type ItemDetailContent_SaltInfoFieldsFragment = { __typename?: 'OrderEntrySaltInfo', name?: string | null, description?: string | null, long_description?: string | null, image_urls?: Array<string> | null, additional_information: Array<{ __typename?: 'OrderEntrySaltNameValuePair', name: string, value: string }>, packaging: Array<{ __typename?: 'OrderEntrySaltNameValuePair', name: string, value: string }> };

export type GetOrderEntryItemDetailQueryVariables = Exact<{
  restaurantId: Scalars['uuid']['input'];
  supplierId: Scalars['uuid']['input'];
  variantPackId: Scalars['uuid']['input'];
  deliveryDate: Scalars['String']['input'];
  purchaseHistoryLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOrderEntryItemDetailQuery = { __typename?: 'query_root', getOrderEntryItemDetail: { __typename?: 'GetOrderEntryItemDetailResponse', purchase_history: Array<{ __typename?: 'GetVariantPackPurchaseHistoryResponse', base_quantity?: number | null, base_unit?: string | null, base_unit_price_in_micros?: number | null, currency_code: string, fulfillment_date?: string | null, sales_rep_gross_profit_in_percentage?: number | null, sales_rep_gross_profit_in_micros?: number | null, item_modifiers?: string | null, order_date?: string | null, order_id?: string | null, order_item_id?: string | null, price_in_micros?: number | null, quantity?: number | null, unit?: string | null, unit_count?: number | null, total_price_in_micros?: number | null, cost_info?: { __typename?: 'VariantPackCostInfoResponse', details?: Array<{ __typename?: 'VariantPackDetailedCostInfoResponse', cost_in_micros: number, type: VariantPackCostType }> | null } | null }>, related_variant_packs: Array<{ __typename?: 'OrderEntryRelatedVariantPack', variant_pack_id: string, external_item_id?: string | null, pack_display_string: string, unit_price_in_micros?: number | null, currency_code: string, availability_status?: VariantPackAvailabilityStatus | null, salt_info?: { __typename?: 'OrderEntrySaltInfo', name?: string | null, description?: string | null, long_description?: string | null, image_urls?: Array<string> | null, additional_information: Array<{ __typename?: 'OrderEntrySaltNameValuePair', name: string, value: string }>, packaging: Array<{ __typename?: 'OrderEntrySaltNameValuePair', name: string, value: string }> } | null }>, salt_info?: { __typename?: 'OrderEntrySaltInfo', name?: string | null, description?: string | null, long_description?: string | null, image_urls?: Array<string> | null, additional_information: Array<{ __typename?: 'OrderEntrySaltNameValuePair', name: string, value: string }>, packaging: Array<{ __typename?: 'OrderEntrySaltNameValuePair', name: string, value: string }> } | null } };

export type CreateSalesPortalOrderGuideCollectionMutationVariables = Exact<{
  name: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type CreateSalesPortalOrderGuideCollectionMutation = { __typename?: 'mutation_root', createOrderGuideCollection: { __typename?: 'OrderGuideCollectionEntryResponse', order_guide_collection_id: string, order_guide_restaurant_collection?: { __typename?: 'order_guide_restaurant_collection', is_default: boolean, name?: string | null, uuid: string, order_guide_restaurant_partitions: Array<{ __typename?: 'order_guide_restaurant_partition', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string }> } | null } };

export type GetSalesPortalOrderGuideItemsQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  collectionUUID: Scalars['uuid']['input'];
}>;


export type GetSalesPortalOrderGuideItemsQuery = { __typename?: 'query_root', getSalesPortalOrderGuideItems: Array<{ __typename?: 'SalesPortalOrderGuideItem', order_guide_item_id?: string | null, order_guide_item_partition_id?: string | null, variant_pack_id: string, entry_info?: { __typename?: 'SalesPortalOrderGuideEntryInfo', par_level?: number | null, sort_order?: number | null } | null, pack_info: { __typename?: 'SalesPortalOrderGuidePackInfo', external_item_id?: string | null, max_unit_size: number, min_unit_size: number, unit: PackUnit }, item_info: { __typename?: 'SalesPortalOrderGuideItemInfo', image_url?: string | null, item_id: string, name: string } }>, order_guide_restaurant_collection: Array<{ __typename?: 'order_guide_restaurant_collection', is_default: boolean, name?: string | null, uuid: string, order_guide_restaurant_partitions: Array<{ __typename?: 'order_guide_restaurant_partition', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string }> }>, order_guide_supplier_collection: Array<{ __typename?: 'order_guide_supplier_collection', is_default: boolean, name?: string | null, uuid: string, order_guide_supplier_partitions: Array<{ __typename?: 'order_guide_supplier_partition', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string }> }> };

export type SalesPortalOrderGuides_OrderGuideRestaurantCollectionFieldsFragment = { __typename?: 'order_guide_restaurant_collection', is_default: boolean, name?: string | null, uuid: string, order_guide_restaurant_partitions: Array<{ __typename?: 'order_guide_restaurant_partition', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string }> };

export type SearchCatalogForOrderGuideQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  searchTerm: Scalars['String']['input'];
}>;


export type SearchCatalogForOrderGuideQuery = { __typename?: 'query_root', searchCatalogForOrderGuideItems: Array<{ __typename?: 'SalesPortalOrderGuideItem', variant_pack_id: string, item_info: { __typename?: 'SalesPortalOrderGuideItemInfo', image_url?: string | null, item_id: string, name: string }, pack_info: { __typename?: 'SalesPortalOrderGuidePackInfo', external_item_id?: string | null, max_unit_size: number, min_unit_size: number, unit: PackUnit } }> };

export type SetSalesPortalOrderGuideCollectionMutationVariables = Exact<{
  collectionUUID: Scalars['uuid']['input'];
  collectionName?: InputMaybe<Scalars['String']['input']>;
  partitions: Array<SetOrderGuideCollectionPartitionInput> | SetOrderGuideCollectionPartitionInput;
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SetSalesPortalOrderGuideCollectionMutation = { __typename?: 'mutation_root', setOrderGuideCollection: { __typename?: 'OrderGuideCollectionEntryResponse', order_guide_collection_id: string } };

export type CreatePriceQuoteFromOrderGuideMutationVariables = Exact<{
  chat_id: Scalars['uuid']['input'];
  variant_pack_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type CreatePriceQuoteFromOrderGuideMutation = { __typename?: 'mutation_root', createPriceQuoteFromOrderGuide: { __typename?: 'CreatePriceQuoteFromVariantPacksResponse', price_quote_id: string } };

export type OrderGuidesListCollectionsQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type OrderGuidesListCollectionsQuery = { __typename?: 'query_root', getSalesPortalOrderGuideCollections: { __typename?: 'GetSalesPortalOrderGuideCollectionsResponse', collections: Array<{ __typename?: 'SalesPortalOrderGuideCollection', is_default: boolean, name?: string | null, sort_order?: number | null, type: SalesPortalOrderGuideCollectionType, uuid: string }> }, order_guide_restaurant_collection: Array<{ __typename?: 'order_guide_restaurant_collection', linked_order_guide_supplier_collection_uuid?: string | null, uuid: string, order_guide_restaurant_partitions: Array<{ __typename?: 'order_guide_restaurant_partition', uuid: string }> }>, order_guide_supplier_collection: Array<{ __typename?: 'order_guide_supplier_collection', uuid: string, order_guide_supplier_partitions: Array<{ __typename?: 'order_guide_supplier_partition', uuid: string }> }>, chats: Array<{ __typename?: 'chats', custom_order_guide_editing_enabled: boolean, order_guide_merge_strategy?: string | null, uuid: string, supplier: { __typename?: 'businesses', uuid: string, supplier_metadata?: { __typename?: 'supplier_metadata', order_guide_merge_strategy: string, uuid: string } | null } }> };

export type SaveAndValidateSalesPortalCart_AlertFieldsFragment = { __typename?: 'SalesPortalValidationAlert', alert_level: AlertLevel, alert_message: string };

export type SaveAndValidateSalesPortalCart_OrderValidationFieldsFragment = { __typename?: 'SalesPortalCartValidation', can_place_order: boolean, alerts: Array<{ __typename?: 'SalesPortalValidationAlert', alert_level: AlertLevel, alert_message: string }> };

export type SaveAndValidateSalesPortalCartMutationVariables = Exact<{
  cart: SalesPortalCartInput;
}>;


export type SaveAndValidateSalesPortalCartMutation = { __typename?: 'mutation_root', saveSalesPortalCart: { __typename?: 'SaveSalesPortalCartResponse', success: boolean, cart: { __typename?: 'SalesPortalCartOutput', metadata: { __typename?: 'SalesPortalCartMetadataOutput', order_id?: string | null, restaurant_id: string, supplier_id: string, updated_at: string, delivery_date?: string | null, fulfillment_timeslot_end?: string | null, fulfillment_timeslot_start?: string | null, fulfillment_type: string }, cart_items: Array<{ __typename?: 'SalesPortalCartItemOutput', added_at?: string | null, quantity: number, variant_pack_id: string, order_item_id: string }> }, error?: { __typename?: 'SalesPortalCartError', code: CartUpdateError, message: string } | null, order_validation?: { __typename?: 'SalesPortalCartValidation', can_place_order: boolean, alerts: Array<{ __typename?: 'SalesPortalValidationAlert', alert_level: AlertLevel, alert_message: string }> } | null } };

export type SaveSalesPortalCart_MetadataFieldsFragment = { __typename?: 'SalesPortalCartMetadataOutput', order_id?: string | null, restaurant_id: string, supplier_id: string, updated_at: string, delivery_date?: string | null, fulfillment_timeslot_end?: string | null, fulfillment_timeslot_start?: string | null, fulfillment_type: string };

export type SaveSalesPortalCart_CartItemFieldsFragment = { __typename?: 'SalesPortalCartItemOutput', added_at?: string | null, quantity: number, variant_pack_id: string, order_item_id: string };

export type SaveSalesPortalCart_ErrorFieldsFragment = { __typename?: 'SalesPortalCartError', code: CartUpdateError, message: string };

export type SaveSalesPortalCartMutationVariables = Exact<{
  cart: SalesPortalCartInput;
}>;


export type SaveSalesPortalCartMutation = { __typename?: 'mutation_root', saveSalesPortalCart: { __typename?: 'SaveSalesPortalCartResponse', success: boolean, cart: { __typename?: 'SalesPortalCartOutput', metadata: { __typename?: 'SalesPortalCartMetadataOutput', order_id?: string | null, restaurant_id: string, supplier_id: string, updated_at: string, delivery_date?: string | null, fulfillment_timeslot_end?: string | null, fulfillment_timeslot_start?: string | null, fulfillment_type: string }, cart_items: Array<{ __typename?: 'SalesPortalCartItemOutput', added_at?: string | null, quantity: number, variant_pack_id: string, order_item_id: string }> }, error?: { __typename?: 'SalesPortalCartError', code: CartUpdateError, message: string } | null } };

export type LoadSalesPortalOrderSummary_OrderEntryFeeFieldsFragment = { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string };

export type LoadSalesPortalOrderSummary_OrderEntryOrderFeesFieldsFragment = { __typename?: 'OrderEntryOrderFees', discount?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, order_promotion_discount?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, promotion_discount?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, subtotal?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, tax?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, tip?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, total?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, volume_discount?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null };

export type LoadSalesPortalOrderSummary_OrderEntrySplitMetricsFieldsFragment = { __typename?: 'OrderEntrySplitMetrics', fulfillment_date?: string | null, fulfillment_type: OrderFulfillmentType, gross_profit_in_micros?: number | null, gross_profit_in_percentage?: number | null, item_count: number, subtotal_in_micros?: number | null, unit_count: number };

export type LoadSalesPortalOrderSummary_OrderEntryCartSummaryFieldsFragment = { __typename?: 'OrderEntryCartSummary', currency: string, order_id: string, order_fees: { __typename?: 'OrderEntryOrderFees', discount?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, order_promotion_discount?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, promotion_discount?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, subtotal?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, tax?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, tip?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, total?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, volume_discount?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null }, split_order_metrics: Array<{ __typename?: 'OrderEntrySplitMetrics', fulfillment_date?: string | null, fulfillment_type: OrderFulfillmentType, gross_profit_in_micros?: number | null, gross_profit_in_percentage?: number | null, item_count: number, subtotal_in_micros?: number | null, unit_count: number }> };

export type LoadSalesPortalOrderSummaryQueryVariables = Exact<{
  orderIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type LoadSalesPortalOrderSummaryQuery = { __typename?: 'query_root', getOrderEntrySummary: { __typename?: 'GetOrderEntrySummaryResponse', summaries: Array<{ __typename?: 'OrderEntryCartSummary', currency: string, order_id: string, order_fees: { __typename?: 'OrderEntryOrderFees', discount?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, order_promotion_discount?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, promotion_discount?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, subtotal?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, tax?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, tip?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, total?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null, volume_discount?: { __typename?: 'OrderEntryFee', amount_in_micros: number, name: string } | null }, split_order_metrics: Array<{ __typename?: 'OrderEntrySplitMetrics', fulfillment_date?: string | null, fulfillment_type: OrderFulfillmentType, gross_profit_in_micros?: number | null, gross_profit_in_percentage?: number | null, item_count: number, subtotal_in_micros?: number | null, unit_count: number }> }> } };

export type SubmitSalesPortalOrderMutationVariables = Exact<{
  orderUUID: Scalars['uuid']['input'];
  orderNotes?: InputMaybe<Scalars['String']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  additionalInputValues: Array<AdditionalInputValueInput> | AdditionalInputValueInput;
}>;


export type SubmitSalesPortalOrderMutation = { __typename?: 'mutation_root', submitOrder: { __typename?: 'SubmitOrderResponse', order_id: string } };

export type GetOrderEntryEstimatedCommissionQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  employeeUUID: Scalars['uuid']['input'];
  orderUUID: Scalars['uuid']['input'];
}>;


export type GetOrderEntryEstimatedCommissionQuery = { __typename?: 'query_root', getOrderEstimatedCommission: { __typename?: 'GetOrderEstimatedCommissionResponse', commissions: Array<{ __typename?: 'OrderCommission', estimated_commission_in_micros: number, order_id: string }> } };

export type GetOrderEntryItemsFromVariantPackIdsQueryVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
  restaurantId: Scalars['uuid']['input'];
  variantPackIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrderEntryItemsFromVariantPackIdsQuery = { __typename?: 'query_root', getOrderEntryItemsFromVariantPackIds: { __typename?: 'OrderEntryTablePage', order_entry_items: Array<{ __typename?: 'OrderEntryItem', order_guide_collection_ids?: Array<string> | null, variant_pack_id: string, item_info?: { __typename?: 'OrderEntryItemInfo', brand?: string | null, description?: string | null, image_url?: string | null, name: string, pack_size?: string | null } | null, order_info?: { __typename?: 'OrderEntryOrderInfo', added_at?: string | null, cart_quantity: number, order_item_id: string, order_id: string } | null, price_edit_display_info?: Array<{ __typename?: 'OrderEntryPriceEditDisplayInfo', key: string, currency?: string | null, trend?: PriceEditDisplayInfoTrend | null, value?: string | null, value_display?: string | null }> | null, labels: { __typename?: 'OrderEntryLabels', lead_time_label?: { __typename?: 'OrderEntryLeadTimeLabel', level: OrderEntryLabelLevel, display_text: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string } } | null, availability_label?: { __typename?: 'OrderEntryAvailabilityLabel', i18n_key: string, level: OrderEntryLabelLevel } | null, essential_item_label?: { __typename?: 'OrderEntryEssentialItemLabel', i18n_key: string, level: OrderEntryLabelLevel } | null, order_guide_labels: Array<{ __typename?: 'OrderEntryOrderGuideLabel', order_guide_name: string, level: OrderEntryLabelLevel }> }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, pack: { __typename?: 'packs', base_unit?: string | null, unit: string, max_unit_size: number, min_unit_size: number, uuid: string } } | null, request_notes?: Array<{ __typename?: 'OrderEntryCollectionRequestNote', collection_id: string, persist_request: boolean, request?: string | null }> | null, variant_pack_info?: { __typename?: 'OrderEntryVariantPackInfo', currency: string, max_quantity?: number | null, min_quantity?: number | null, on_hand_quantity?: number | null, gross_profit_in_percentage?: number | null, gross_profit_amount_display?: string | null, pack_cost_in_micros?: number | null, pack_price_in_micros?: number | null, pack_price_display?: string | null, default_pack_price_in_micros?: number | null, default_unit_price_in_micros?: number | null, unit_cost_in_micros?: number | null, unit_count: number, unit_price_in_micros?: number | null, unit_price_display?: string | null, price_edit_info: { __typename?: 'OrderEntryPriceEditInfo', active_override?: PriceEditType | null, expires_at?: string | null, expiration_source?: SalesRepOverrideExpirationSource | null, ceiling_price_in_micros?: number | null, gross_profit_override_in_percentage?: number | null, price_edited_by_user_name?: string | null, price_override_in_micros?: number | null, cost_info?: { __typename?: 'OrderEntryCostInfo', details?: Array<{ __typename?: 'OrderEntryDetailedCostInfo', cost_in_micros: number, type: VariantPackCostType }> | null } | null, variant_pack_settings?: { __typename?: 'OrderEntryVariantPackSettings', disable_override_editing?: boolean | null, disable_sales_rep_info?: boolean | null, enable_peak_price_protection?: boolean | null } | null } } | null }> } };

export type LoadSalesPortalCart_VariantPackInfoFieldsFragment = { __typename?: 'OrderEntryVariantPackInfo', currency: string, pack_price_in_micros?: number | null, unit_price_in_micros?: number | null, gross_profit_in_percentage?: number | null };

export type LoadSalesPortalCartQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type LoadSalesPortalCartQuery = { __typename?: 'query_root', getOrderEntryItemsFromCart: { __typename?: 'OrderEntryTablePage', order_entry_items: Array<{ __typename?: 'OrderEntryItem', order_guide_collection_ids?: Array<string> | null, variant_pack_id: string, item_info?: { __typename?: 'OrderEntryItemInfo', brand?: string | null, description?: string | null, image_url?: string | null, name: string, pack_size?: string | null } | null, order_info?: { __typename?: 'OrderEntryOrderInfo', added_at?: string | null, cart_quantity: number, order_item_id: string, order_id: string } | null, price_edit_display_info?: Array<{ __typename?: 'OrderEntryPriceEditDisplayInfo', key: string, currency?: string | null, trend?: PriceEditDisplayInfoTrend | null, value?: string | null, value_display?: string | null }> | null, labels: { __typename?: 'OrderEntryLabels', lead_time_label?: { __typename?: 'OrderEntryLeadTimeLabel', level: OrderEntryLabelLevel, display_text: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string } } | null, availability_label?: { __typename?: 'OrderEntryAvailabilityLabel', i18n_key: string, level: OrderEntryLabelLevel } | null, essential_item_label?: { __typename?: 'OrderEntryEssentialItemLabel', i18n_key: string, level: OrderEntryLabelLevel } | null, order_guide_labels: Array<{ __typename?: 'OrderEntryOrderGuideLabel', order_guide_name: string, level: OrderEntryLabelLevel }> }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, pack: { __typename?: 'packs', base_unit?: string | null, unit: string, max_unit_size: number, min_unit_size: number, uuid: string } } | null, request_notes?: Array<{ __typename?: 'OrderEntryCollectionRequestNote', collection_id: string, persist_request: boolean, request?: string | null }> | null, variant_pack_info?: { __typename?: 'OrderEntryVariantPackInfo', currency: string, max_quantity?: number | null, min_quantity?: number | null, on_hand_quantity?: number | null, gross_profit_in_percentage?: number | null, gross_profit_amount_display?: string | null, pack_cost_in_micros?: number | null, pack_price_in_micros?: number | null, pack_price_display?: string | null, default_pack_price_in_micros?: number | null, default_unit_price_in_micros?: number | null, unit_cost_in_micros?: number | null, unit_count: number, unit_price_in_micros?: number | null, unit_price_display?: string | null, price_edit_info: { __typename?: 'OrderEntryPriceEditInfo', active_override?: PriceEditType | null, expires_at?: string | null, expiration_source?: SalesRepOverrideExpirationSource | null, ceiling_price_in_micros?: number | null, gross_profit_override_in_percentage?: number | null, price_edited_by_user_name?: string | null, price_override_in_micros?: number | null, cost_info?: { __typename?: 'OrderEntryCostInfo', details?: Array<{ __typename?: 'OrderEntryDetailedCostInfo', cost_in_micros: number, type: VariantPackCostType }> | null } | null, variant_pack_settings?: { __typename?: 'OrderEntryVariantPackSettings', disable_override_editing?: boolean | null, disable_sales_rep_info?: boolean | null, enable_peak_price_protection?: boolean | null } | null } } | null }> } };

export type OrderEntryDataQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderGuideItemFilter?: InputMaybe<OrderEntryOrderGuideItemFilter>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderEntryDataQuery = { __typename?: 'query_root', cart: { __typename?: 'OrderEntryTablePage', order_entry_items: Array<{ __typename?: 'OrderEntryItem', order_guide_collection_ids?: Array<string> | null, variant_pack_id: string, item_info?: { __typename?: 'OrderEntryItemInfo', brand?: string | null, description?: string | null, image_url?: string | null, name: string, pack_size?: string | null } | null, order_info?: { __typename?: 'OrderEntryOrderInfo', added_at?: string | null, cart_quantity: number, order_item_id: string, order_id: string } | null, price_edit_display_info?: Array<{ __typename?: 'OrderEntryPriceEditDisplayInfo', key: string, currency?: string | null, trend?: PriceEditDisplayInfoTrend | null, value?: string | null, value_display?: string | null }> | null, labels: { __typename?: 'OrderEntryLabels', lead_time_label?: { __typename?: 'OrderEntryLeadTimeLabel', level: OrderEntryLabelLevel, display_text: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string } } | null, availability_label?: { __typename?: 'OrderEntryAvailabilityLabel', i18n_key: string, level: OrderEntryLabelLevel } | null, essential_item_label?: { __typename?: 'OrderEntryEssentialItemLabel', i18n_key: string, level: OrderEntryLabelLevel } | null, order_guide_labels: Array<{ __typename?: 'OrderEntryOrderGuideLabel', order_guide_name: string, level: OrderEntryLabelLevel }> }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, pack: { __typename?: 'packs', base_unit?: string | null, unit: string, max_unit_size: number, min_unit_size: number, uuid: string } } | null, request_notes?: Array<{ __typename?: 'OrderEntryCollectionRequestNote', collection_id: string, persist_request: boolean, request?: string | null }> | null, variant_pack_info?: { __typename?: 'OrderEntryVariantPackInfo', currency: string, max_quantity?: number | null, min_quantity?: number | null, on_hand_quantity?: number | null, gross_profit_in_percentage?: number | null, gross_profit_amount_display?: string | null, pack_cost_in_micros?: number | null, pack_price_in_micros?: number | null, pack_price_display?: string | null, default_pack_price_in_micros?: number | null, default_unit_price_in_micros?: number | null, unit_cost_in_micros?: number | null, unit_count: number, unit_price_in_micros?: number | null, unit_price_display?: string | null, price_edit_info: { __typename?: 'OrderEntryPriceEditInfo', active_override?: PriceEditType | null, expires_at?: string | null, expiration_source?: SalesRepOverrideExpirationSource | null, ceiling_price_in_micros?: number | null, gross_profit_override_in_percentage?: number | null, price_edited_by_user_name?: string | null, price_override_in_micros?: number | null, cost_info?: { __typename?: 'OrderEntryCostInfo', details?: Array<{ __typename?: 'OrderEntryDetailedCostInfo', cost_in_micros: number, type: VariantPackCostType }> | null } | null, variant_pack_settings?: { __typename?: 'OrderEntryVariantPackSettings', disable_override_editing?: boolean | null, disable_sales_rep_info?: boolean | null, enable_peak_price_protection?: boolean | null } | null } } | null }> }, orderGuide: { __typename?: 'OrderEntryTablePage', price_edit_display_headers: Array<{ __typename?: 'OrderEntryPriceEditDisplayHeader', key: string, is_confidential: boolean, category: DisplayConfigCategory, translation: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string } }>, order_entry_items: Array<{ __typename?: 'OrderEntryItem', order_guide_collection_ids?: Array<string> | null, variant_pack_id: string, item_info?: { __typename?: 'OrderEntryItemInfo', brand?: string | null, description?: string | null, image_url?: string | null, name: string, pack_size?: string | null } | null, order_info?: { __typename?: 'OrderEntryOrderInfo', added_at?: string | null, cart_quantity: number, order_item_id: string, order_id: string } | null, price_edit_display_info?: Array<{ __typename?: 'OrderEntryPriceEditDisplayInfo', key: string, currency?: string | null, trend?: PriceEditDisplayInfoTrend | null, value?: string | null, value_display?: string | null }> | null, labels: { __typename?: 'OrderEntryLabels', lead_time_label?: { __typename?: 'OrderEntryLeadTimeLabel', level: OrderEntryLabelLevel, display_text: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string } } | null, availability_label?: { __typename?: 'OrderEntryAvailabilityLabel', i18n_key: string, level: OrderEntryLabelLevel } | null, essential_item_label?: { __typename?: 'OrderEntryEssentialItemLabel', i18n_key: string, level: OrderEntryLabelLevel } | null, order_guide_labels: Array<{ __typename?: 'OrderEntryOrderGuideLabel', order_guide_name: string, level: OrderEntryLabelLevel }> }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, pack: { __typename?: 'packs', base_unit?: string | null, unit: string, max_unit_size: number, min_unit_size: number, uuid: string } } | null, request_notes?: Array<{ __typename?: 'OrderEntryCollectionRequestNote', collection_id: string, persist_request: boolean, request?: string | null }> | null, variant_pack_info?: { __typename?: 'OrderEntryVariantPackInfo', currency: string, max_quantity?: number | null, min_quantity?: number | null, on_hand_quantity?: number | null, gross_profit_in_percentage?: number | null, gross_profit_amount_display?: string | null, pack_cost_in_micros?: number | null, pack_price_in_micros?: number | null, pack_price_display?: string | null, default_pack_price_in_micros?: number | null, default_unit_price_in_micros?: number | null, unit_cost_in_micros?: number | null, unit_count: number, unit_price_in_micros?: number | null, unit_price_display?: string | null, price_edit_info: { __typename?: 'OrderEntryPriceEditInfo', active_override?: PriceEditType | null, expires_at?: string | null, expiration_source?: SalesRepOverrideExpirationSource | null, ceiling_price_in_micros?: number | null, gross_profit_override_in_percentage?: number | null, price_edited_by_user_name?: string | null, price_override_in_micros?: number | null, cost_info?: { __typename?: 'OrderEntryCostInfo', details?: Array<{ __typename?: 'OrderEntryDetailedCostInfo', cost_in_micros: number, type: VariantPackCostType }> | null } | null, variant_pack_settings?: { __typename?: 'OrderEntryVariantPackSettings', disable_override_editing?: boolean | null, disable_sales_rep_info?: boolean | null, enable_peak_price_protection?: boolean | null } | null } } | null }> } };

export type SalesPortalCatalogSearchQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  searchTerm: Scalars['String']['input'];
}>;


export type SalesPortalCatalogSearchQuery = { __typename?: 'query_root', searchCatalogForOrderEntryItems: { __typename?: 'OrderEntryTablePage', price_edit_display_headers: Array<{ __typename?: 'OrderEntryPriceEditDisplayHeader', key: string, is_confidential: boolean, category: DisplayConfigCategory, translation: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string } }>, order_entry_items: Array<{ __typename?: 'OrderEntryItem', order_guide_collection_ids?: Array<string> | null, variant_pack_id: string, item_info?: { __typename?: 'OrderEntryItemInfo', brand?: string | null, description?: string | null, image_url?: string | null, name: string, pack_size?: string | null } | null, order_info?: { __typename?: 'OrderEntryOrderInfo', added_at?: string | null, cart_quantity: number, order_item_id: string, order_id: string } | null, price_edit_display_info?: Array<{ __typename?: 'OrderEntryPriceEditDisplayInfo', key: string, currency?: string | null, trend?: PriceEditDisplayInfoTrend | null, value?: string | null, value_display?: string | null }> | null, labels: { __typename?: 'OrderEntryLabels', lead_time_label?: { __typename?: 'OrderEntryLeadTimeLabel', level: OrderEntryLabelLevel, display_text: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string } } | null, availability_label?: { __typename?: 'OrderEntryAvailabilityLabel', i18n_key: string, level: OrderEntryLabelLevel } | null, essential_item_label?: { __typename?: 'OrderEntryEssentialItemLabel', i18n_key: string, level: OrderEntryLabelLevel } | null, order_guide_labels: Array<{ __typename?: 'OrderEntryOrderGuideLabel', order_guide_name: string, level: OrderEntryLabelLevel }> }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, pack: { __typename?: 'packs', base_unit?: string | null, unit: string, max_unit_size: number, min_unit_size: number, uuid: string } } | null, request_notes?: Array<{ __typename?: 'OrderEntryCollectionRequestNote', collection_id: string, persist_request: boolean, request?: string | null }> | null, variant_pack_info?: { __typename?: 'OrderEntryVariantPackInfo', currency: string, max_quantity?: number | null, min_quantity?: number | null, on_hand_quantity?: number | null, gross_profit_in_percentage?: number | null, gross_profit_amount_display?: string | null, pack_cost_in_micros?: number | null, pack_price_in_micros?: number | null, pack_price_display?: string | null, default_pack_price_in_micros?: number | null, default_unit_price_in_micros?: number | null, unit_cost_in_micros?: number | null, unit_count: number, unit_price_in_micros?: number | null, unit_price_display?: string | null, price_edit_info: { __typename?: 'OrderEntryPriceEditInfo', active_override?: PriceEditType | null, expires_at?: string | null, expiration_source?: SalesRepOverrideExpirationSource | null, ceiling_price_in_micros?: number | null, gross_profit_override_in_percentage?: number | null, price_edited_by_user_name?: string | null, price_override_in_micros?: number | null, cost_info?: { __typename?: 'OrderEntryCostInfo', details?: Array<{ __typename?: 'OrderEntryDetailedCostInfo', cost_in_micros: number, type: VariantPackCostType }> | null } | null, variant_pack_settings?: { __typename?: 'OrderEntryVariantPackSettings', disable_override_editing?: boolean | null, disable_sales_rep_info?: boolean | null, enable_peak_price_protection?: boolean | null } | null } } | null }> } };

export type SalesPortalLastPurchaseInfoQueryVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalLastPurchaseInfoQuery = { __typename?: 'query_root', getVariantPackLastPurchaseInfo: Array<{ __typename?: 'GetVariantPackLastPurchaseInfoResponse', fulfillment_date?: string | null, order_date?: string | null, quantity?: number | null, variant_pack_id?: string | null }> };

export type SalesPortalOrderEntryTable_OrderEntryItemFieldsFragment = { __typename?: 'OrderEntryItem', order_guide_collection_ids?: Array<string> | null, variant_pack_id: string, item_info?: { __typename?: 'OrderEntryItemInfo', brand?: string | null, description?: string | null, image_url?: string | null, name: string, pack_size?: string | null } | null, order_info?: { __typename?: 'OrderEntryOrderInfo', added_at?: string | null, cart_quantity: number, order_item_id: string, order_id: string } | null, price_edit_display_info?: Array<{ __typename?: 'OrderEntryPriceEditDisplayInfo', key: string, currency?: string | null, trend?: PriceEditDisplayInfoTrend | null, value?: string | null, value_display?: string | null }> | null, labels: { __typename?: 'OrderEntryLabels', lead_time_label?: { __typename?: 'OrderEntryLeadTimeLabel', level: OrderEntryLabelLevel, display_text: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string } } | null, availability_label?: { __typename?: 'OrderEntryAvailabilityLabel', i18n_key: string, level: OrderEntryLabelLevel } | null, essential_item_label?: { __typename?: 'OrderEntryEssentialItemLabel', i18n_key: string, level: OrderEntryLabelLevel } | null, order_guide_labels: Array<{ __typename?: 'OrderEntryOrderGuideLabel', order_guide_name: string, level: OrderEntryLabelLevel }> }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, pack: { __typename?: 'packs', base_unit?: string | null, unit: string, max_unit_size: number, min_unit_size: number, uuid: string } } | null, request_notes?: Array<{ __typename?: 'OrderEntryCollectionRequestNote', collection_id: string, persist_request: boolean, request?: string | null }> | null, variant_pack_info?: { __typename?: 'OrderEntryVariantPackInfo', currency: string, max_quantity?: number | null, min_quantity?: number | null, on_hand_quantity?: number | null, gross_profit_in_percentage?: number | null, gross_profit_amount_display?: string | null, pack_cost_in_micros?: number | null, pack_price_in_micros?: number | null, pack_price_display?: string | null, default_pack_price_in_micros?: number | null, default_unit_price_in_micros?: number | null, unit_cost_in_micros?: number | null, unit_count: number, unit_price_in_micros?: number | null, unit_price_display?: string | null, price_edit_info: { __typename?: 'OrderEntryPriceEditInfo', active_override?: PriceEditType | null, expires_at?: string | null, expiration_source?: SalesRepOverrideExpirationSource | null, ceiling_price_in_micros?: number | null, gross_profit_override_in_percentage?: number | null, price_edited_by_user_name?: string | null, price_override_in_micros?: number | null, cost_info?: { __typename?: 'OrderEntryCostInfo', details?: Array<{ __typename?: 'OrderEntryDetailedCostInfo', cost_in_micros: number, type: VariantPackCostType }> | null } | null, variant_pack_settings?: { __typename?: 'OrderEntryVariantPackSettings', disable_override_editing?: boolean | null, disable_sales_rep_info?: boolean | null, enable_peak_price_protection?: boolean | null } | null } } | null };

export type SalesPortalOrderEntryTableQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderGuideItemFilter?: InputMaybe<OrderEntryOrderGuideItemFilter>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type SalesPortalOrderEntryTableQuery = { __typename?: 'query_root', getOrderEntryItemsFromOrderGuide: { __typename?: 'OrderEntryTablePage', price_edit_display_headers: Array<{ __typename?: 'OrderEntryPriceEditDisplayHeader', key: string, is_confidential: boolean, category: DisplayConfigCategory, translation: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string } }>, order_entry_items: Array<{ __typename?: 'OrderEntryItem', order_guide_collection_ids?: Array<string> | null, variant_pack_id: string, item_info?: { __typename?: 'OrderEntryItemInfo', brand?: string | null, description?: string | null, image_url?: string | null, name: string, pack_size?: string | null } | null, order_info?: { __typename?: 'OrderEntryOrderInfo', added_at?: string | null, cart_quantity: number, order_item_id: string, order_id: string } | null, price_edit_display_info?: Array<{ __typename?: 'OrderEntryPriceEditDisplayInfo', key: string, currency?: string | null, trend?: PriceEditDisplayInfoTrend | null, value?: string | null, value_display?: string | null }> | null, labels: { __typename?: 'OrderEntryLabels', lead_time_label?: { __typename?: 'OrderEntryLeadTimeLabel', level: OrderEntryLabelLevel, display_text: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string } } | null, availability_label?: { __typename?: 'OrderEntryAvailabilityLabel', i18n_key: string, level: OrderEntryLabelLevel } | null, essential_item_label?: { __typename?: 'OrderEntryEssentialItemLabel', i18n_key: string, level: OrderEntryLabelLevel } | null, order_guide_labels: Array<{ __typename?: 'OrderEntryOrderGuideLabel', order_guide_name: string, level: OrderEntryLabelLevel }> }, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, pack: { __typename?: 'packs', base_unit?: string | null, unit: string, max_unit_size: number, min_unit_size: number, uuid: string } } | null, request_notes?: Array<{ __typename?: 'OrderEntryCollectionRequestNote', collection_id: string, persist_request: boolean, request?: string | null }> | null, variant_pack_info?: { __typename?: 'OrderEntryVariantPackInfo', currency: string, max_quantity?: number | null, min_quantity?: number | null, on_hand_quantity?: number | null, gross_profit_in_percentage?: number | null, gross_profit_amount_display?: string | null, pack_cost_in_micros?: number | null, pack_price_in_micros?: number | null, pack_price_display?: string | null, default_pack_price_in_micros?: number | null, default_unit_price_in_micros?: number | null, unit_cost_in_micros?: number | null, unit_count: number, unit_price_in_micros?: number | null, unit_price_display?: string | null, price_edit_info: { __typename?: 'OrderEntryPriceEditInfo', active_override?: PriceEditType | null, expires_at?: string | null, expiration_source?: SalesRepOverrideExpirationSource | null, ceiling_price_in_micros?: number | null, gross_profit_override_in_percentage?: number | null, price_edited_by_user_name?: string | null, price_override_in_micros?: number | null, cost_info?: { __typename?: 'OrderEntryCostInfo', details?: Array<{ __typename?: 'OrderEntryDetailedCostInfo', cost_in_micros: number, type: VariantPackCostType }> | null } | null, variant_pack_settings?: { __typename?: 'OrderEntryVariantPackSettings', disable_override_editing?: boolean | null, disable_sales_rep_info?: boolean | null, enable_peak_price_protection?: boolean | null } | null } } | null }> } };

export type SalesPortalOrderGuideCollectionsQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalOrderGuideCollectionsQuery = { __typename?: 'query_root', getOrderGuideCollectionsForOrderEntry: { __typename?: 'GetOrderGuideCollectionsForOrderEntryResponse', collections: Array<{ __typename?: 'OrderGuideCollectionForOrderEntry', is_default: boolean, linked_supplier_collection_uuid?: string | null, name?: string | null, sort_order?: number | null, type: OrderGuideCollectionType, uuid: string }> } };

export type SalesPortalRestaurantFieldsFragment = { __typename?: 'businesses', uuid: string, name: string, address: { __typename?: 'addresses', address: string, timezone: string, uuid: string } };

export type SalesPortalSupplierFieldsFragment = { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', uuid: string, timezone: string, country_code: string } };

export type SalesPortalRestaurantListQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  cursor?: InputMaybe<Scalars['uuid']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type SalesPortalRestaurantListQuery = { __typename?: 'query_root', getSalesPortalAccountsPaginated: { __typename?: 'SalesPortalAccountsPage', cursor?: string | null, accounts: Array<{ __typename?: 'SalesPortalAccount', chat_id: string, on_hold: boolean, restaurant?: { __typename?: 'businesses', uuid: string, name: string, address: { __typename?: 'addresses', address: string, timezone: string, uuid: string } } | null, supplier?: { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', uuid: string, timezone: string, country_code: string } } | null }> } };

export type SalesPortalSelectedRestaurantQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalSelectedRestaurantQuery = { __typename?: 'query_root', chats: Array<{ __typename?: 'chats', on_hold: boolean, uuid: string, restaurant_uuid: string, supplier_uuid: string, restaurant: { __typename?: 'businesses', uuid: string, name: string, address: { __typename?: 'addresses', address: string, timezone: string, uuid: string } }, supplier: { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', uuid: string, timezone: string, country_code: string } } }> };

export type CheckUserSupplierMembershipQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
  userUUID: Scalars['uuid']['input'];
}>;


export type CheckUserSupplierMembershipQuery = { __typename?: 'query_root', businesses_by_pk?: { __typename?: 'businesses', uuid: string, businesses_employees: Array<{ __typename?: 'businesses_employees', uuid: string, employee_uuid: string, business_uuid: string }> } | null };

export type UpdateOrderEntryItemRequestNoteMutationVariables = Exact<{
  variantPackId: Scalars['uuid']['input'];
  supplierId: Scalars['uuid']['input'];
  restaurantId: Scalars['uuid']['input'];
  collectionId: Scalars['uuid']['input'];
  request?: InputMaybe<Scalars['String']['input']>;
  persistRequest: Scalars['Boolean']['input'];
}>;


export type UpdateOrderEntryItemRequestNoteMutation = { __typename?: 'mutation_root', updateOrderEntryItemRequestNote: { __typename?: 'SuccessResponse', success: boolean } };

export type GetPricingRecommendationsQueryVariables = Exact<{
  taskTypeUUID: Scalars['uuid']['input'];
}>;


export type GetPricingRecommendationsQuery = { __typename?: 'query_root', getPricingRecommendationsForBusinessOrganization: { __typename?: 'GetPricingRecommendationsResponse', auto_publish_at?: string | null, publish_enabled: boolean, progress: { __typename?: 'PricingRecommendationProgress', accepted: number, overridden: number, pending: number, rejected: number }, recommendations: Array<{ __typename?: 'PricingRecommendationOutput', created_at: string, gross_profit_in_percentage?: number | null, new_price_in_micros: number, published_at?: string | null, reasoning: string, restaurant_account_id?: string | null, restaurant_id: string, review_status: string, snapshot_cost_in_micros: number, snapshot_gross_profit_in_percentage?: number | null, snapshot_price_in_micros: number, supplier_id: string, task_run_id: string, uuid: string, weekly_gp_impact_in_micros?: number | null, weekly_volume?: number | null, invoice_history?: Array<{ __typename?: 'DetailVariantPackInvoiceHistoryEntry', gross_margin_percentage?: number | null, invoice_date: string, price_in_micros: number, quantity: number }> | null, peer_group?: { __typename?: 'PricingPeerGroup', id: string, min_gross_profit_in_percentage: number, max_gross_profit_in_percentage: number } | null, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, item: { __typename?: 'items', display_name: string }, pack: { __typename?: 'packs', unit: string } } | null }> } };

export type PricingTaskRunSummaryFieldsFragment = { __typename?: 'PricingTaskRunSummaryByType', accepted_recommendations_count: number, auto_publish_at?: string | null, description?: string | null, last_completed_at?: string | null, name: string, overridden_recommendations_count: number, pending_recommendations_count: number, rejected_recommendations_count: number, sort_order: number, task_group?: string | null, task_type_id: string, weekly_gp_impact_in_micros: number };

export type GetPricingTaskRunsByTypeForBusinessOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPricingTaskRunsByTypeForBusinessOrganizationQuery = { __typename?: 'query_root', getPricingTaskRunsByTypeForBusinessOrganization: { __typename?: 'GetPricingTaskRunsByTypeForBusinessOrganizationResponse', task_runs: Array<{ __typename?: 'PricingTaskRunSummaryByType', accepted_recommendations_count: number, auto_publish_at?: string | null, description?: string | null, last_completed_at?: string | null, name: string, overridden_recommendations_count: number, pending_recommendations_count: number, rejected_recommendations_count: number, sort_order: number, task_group?: string | null, task_type_id: string, weekly_gp_impact_in_micros: number }> } };

export type SubmitPricingRecommendationActionsMutationVariables = Exact<{
  actions: Array<PricingRecommendationActionInput> | PricingRecommendationActionInput;
}>;


export type SubmitPricingRecommendationActionsMutation = { __typename?: 'mutation_root', submitPricingRecommendationActionsForBusinessOrganization: { __typename?: 'SubmitPricingRecommendationActionsForBusinessOrganizationResponse', accepted_count: number, rejected_count: number, alerts_by_supplier: Array<{ __typename?: 'PricingRecommendationActionsSupplierResult', supplier_id: string, alert?: { __typename?: 'PricingRecommendationAlert', alert_level: AlertLevel, alert_message: string, deleted_draft_update_ids: Array<string> } | null }> } };

export type UpsertPricingRecommendationsStatusMutationVariables = Exact<{
  actions: Array<PricingRecommendationActionInput> | PricingRecommendationActionInput;
}>;


export type UpsertPricingRecommendationsStatusMutation = { __typename?: 'mutation_root', upsertPricingRecommendationsStatusForBusinessOrganization: { __typename?: 'UpsertPricingRecommendationsStatusForBusinessOrganizationResponse', accepted_count: number, overridden_count: number, rejected_count: number } };

export type DeletePricingBookmarksMutationVariables = Exact<{
  entries: Array<DeletePricingBookmarkEntryInput> | DeletePricingBookmarkEntryInput;
}>;


export type DeletePricingBookmarksMutation = { __typename?: 'mutation_root', deletePricingBookmarks: { __typename?: 'DeletePricingBookmarksResponse', deleted_count: number } };

export type GetPricingBookmarksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPricingBookmarksQuery = { __typename?: 'query_root', getPricingBookmarks: { __typename?: 'GetPricingBookmarksResponse', bookmarks: Array<{ __typename?: 'DetailVariantPackCostChange', bookmark_note?: string | null, bookmarked_at?: string | null, cost_in_micros?: number | null, cost_in_micros_delta?: number | null, gross_margin_delta_in_micros?: number | null, gross_profit_percentage?: number | null, is_locked?: boolean | null, price_floor_enabled: boolean, price_floor_mode?: VariantPackCostType | null, price_in_micros?: number | null, price_in_micros_delta?: number | null, restaurant_account_id?: string | null, supplier_id: string, weekly_quantity: number, groups: Array<{ __typename?: 'VariantPackGroupMembership', uuid: string, display_name: string, source: string }>, invoice_history?: Array<{ __typename?: 'DetailVariantPackInvoiceHistoryEntry', gross_margin_percentage?: number | null, invoice_date: string, price_in_micros: number, quantity: number }> | null, price_edit_display_headers?: Array<{ __typename?: 'PriceEditDisplayHeader', key: string, category: DisplayConfigCategory, translation: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string } }> | null, pricing_peer_group?: { __typename?: 'PricingPeerGroup', id: string, min_gross_profit_in_percentage: number, max_gross_profit_in_percentage: number } | null, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null, supplier_display_info?: Array<{ __typename?: 'PriceEditDisplayInfoDetail', currency?: string | null, title: string, type: string, value?: string | null }> | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, item: { __typename?: 'items', display_name: string, uuid: string }, pack: { __typename?: 'packs', unit: string, uuid: string } } | null, weekly_purchase_quantities: Array<{ __typename?: 'WeeklyPurchaseQuantity', end_date: string, quantity: number, start_date: string }> }> } };

export type PricingInvoiceHistoryFieldsFragment = { __typename?: 'DetailVariantPackInvoiceHistoryEntry', gross_margin_percentage?: number | null, invoice_date: string, price_in_micros: number, quantity: number };

export type PricingWeeklyPurchaseQuantityFieldsFragment = { __typename?: 'WeeklyPurchaseQuantity', end_date: string, quantity: number, start_date: string };

export type UpsertPricingPriceDraftUpdatesForBusinessOrganizationMutationVariables = Exact<{
  variantPacks: Array<UpsertPriceDraftForBusinessOrganizationInput> | UpsertPriceDraftForBusinessOrganizationInput;
}>;


export type UpsertPricingPriceDraftUpdatesForBusinessOrganizationMutation = { __typename?: 'mutation_root', upsertPricingPriceDraftUpdatesForBusinessOrganization: { __typename?: 'UpsertPricingPriceDraftUpdatesForBusinessOrganizationResponse', publish_enabled: boolean, total_upsert_count: number, cost_changes: Array<{ __typename?: 'DetailVariantPackCostChange', cost_in_micros?: number | null, cost_in_micros_delta?: number | null, gross_margin_delta_in_micros?: number | null, gross_profit_percentage?: number | null, is_locked?: boolean | null, price_floor_enabled: boolean, price_floor_mode?: VariantPackCostType | null, price_in_micros?: number | null, price_in_micros_delta?: number | null, restaurant_account_id?: string | null, supplier_id: string, weekly_quantity: number, groups: Array<{ __typename?: 'VariantPackGroupMembership', uuid: string, display_name: string, source: string }>, invoice_history?: Array<{ __typename?: 'DetailVariantPackInvoiceHistoryEntry', gross_margin_percentage?: number | null, invoice_date: string, price_in_micros: number, quantity: number }> | null, price_edit_display_headers?: Array<{ __typename?: 'PriceEditDisplayHeader', key: string, category: DisplayConfigCategory, translation: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string } }> | null, pricing_peer_group?: { __typename?: 'PricingPeerGroup', id: string, min_gross_profit_in_percentage: number, max_gross_profit_in_percentage: number } | null, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null, supplier_display_info?: Array<{ __typename?: 'PriceEditDisplayInfoDetail', currency?: string | null, title: string, type: string, value?: string | null }> | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, item: { __typename?: 'items', display_name: string, uuid: string }, pack: { __typename?: 'packs', unit: string, uuid: string } } | null, weekly_purchase_quantities: Array<{ __typename?: 'WeeklyPurchaseQuantity', end_date: string, quantity: number, start_date: string }> }>, per_supplier: Array<{ __typename?: 'UpsertPricingPriceDraftUpdatesForBusinessOrganizationPerSupplier', pricing_price_draft_update_batch_id: string, supplier_id: string, upsert_count: number }> } };

export type UpsertPricingBookmarksMutationVariables = Exact<{
  entries: Array<UpsertPricingBookmarkEntryInput> | UpsertPricingBookmarkEntryInput;
}>;


export type UpsertPricingBookmarksMutation = { __typename?: 'mutation_root', upsertPricingBookmarks: { __typename?: 'UpsertPricingBookmarksResponse', upsert_count: number, bookmarks: Array<{ __typename?: 'PricingBookmarkRef', bookmarked_at: string, note?: string | null, restaurant_id: string, variant_pack_id: string }> } };

export type CustomerDetailHeaderFieldsFragment = { __typename?: 'CustomerDetailHeader', line_items_total: number, margin_percentage?: number | null, order_count: number, price_floor_enabled: boolean, price_floor_mode?: VariantPackCostType | null, restaurant_account_id?: string | null, restaurant_id: string, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null };

export type CustomerDetailRowFieldsFragment = { __typename?: 'CustomerDetailRow', supplier_id: string, cost_in_micros_delta: number, current_cost_in_micros?: number | null, current_margin_percentage?: number | null, current_price_in_micros?: number | null, gross_margin_delta_in_micros: number, gross_profit_per_unit_in_micros?: number | null, last_cost_in_micros?: number | null, last_margin_percentage?: number | null, last_price_in_micros?: number | null, line_items_total: number, previous_margin_percentage?: number | null, price_in_micros_delta: number, restaurant_id: string, variant_pack_id: string, invoice_history: Array<{ __typename?: 'DetailVariantPackInvoiceHistoryEntry', gross_margin_percentage?: number | null, invoice_date: string, price_in_micros: number, quantity: number }>, price_edit_display_info: Array<{ __typename?: 'PriceEditDisplayInfoDetail', currency?: string | null, title: string, type: string, value?: string | null }>, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, item: { __typename?: 'items', display_name: string, uuid: string }, pack: { __typename?: 'packs', unit: string, uuid: string } } | null, weekly_purchase_quantities: Array<{ __typename?: 'WeeklyPurchaseQuantity', end_date: string, quantity: number, start_date: string }> };

export type PricingCustomerDetailDataQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type PricingCustomerDetailDataQuery = { __typename?: 'query_root', getCustomerDetailData: { __typename?: 'GetCustomerDetailDataResponse', header: { __typename?: 'CustomerDetailHeader', line_items_total: number, margin_percentage?: number | null, order_count: number, price_floor_enabled: boolean, price_floor_mode?: VariantPackCostType | null, restaurant_account_id?: string | null, restaurant_id: string, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null }, price_edit_display_headers: Array<{ __typename?: 'PriceEditDisplayHeader', category: DisplayConfigCategory, is_confidential: boolean, key: string, translation: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string } }>, rows: Array<{ __typename?: 'CustomerDetailRow', supplier_id: string, cost_in_micros_delta: number, current_cost_in_micros?: number | null, current_margin_percentage?: number | null, current_price_in_micros?: number | null, gross_margin_delta_in_micros: number, gross_profit_per_unit_in_micros?: number | null, last_cost_in_micros?: number | null, last_margin_percentage?: number | null, last_price_in_micros?: number | null, line_items_total: number, previous_margin_percentage?: number | null, price_in_micros_delta: number, restaurant_id: string, variant_pack_id: string, invoice_history: Array<{ __typename?: 'DetailVariantPackInvoiceHistoryEntry', gross_margin_percentage?: number | null, invoice_date: string, price_in_micros: number, quantity: number }>, price_edit_display_info: Array<{ __typename?: 'PriceEditDisplayInfoDetail', currency?: string | null, title: string, type: string, value?: string | null }>, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, item: { __typename?: 'items', display_name: string, uuid: string }, pack: { __typename?: 'packs', unit: string, uuid: string } } | null, weekly_purchase_quantities: Array<{ __typename?: 'WeeklyPurchaseQuantity', end_date: string, quantity: number, start_date: string }> }> } };

export type CustomerListRowFieldsFragment = { __typename?: 'OrgCustomerRow', gross_profit_in_micros_total: number, last_invoice_date?: string | null, line_items_total: number, margin_percentage?: number | null, order_count: number, restaurant_account_id?: string | null, restaurant_id: string, restaurant_name: string, revenue_in_micros_total: number, sales_rep_id?: string | null, sales_rep_name?: string | null, supplier_id: string };

export type PricingCustomerListDataQueryVariables = Exact<{ [key: string]: never; }>;


export type PricingCustomerListDataQuery = { __typename?: 'query_root', getCustomerListDataForBusinessOrganization: { __typename?: 'GetCustomerListDataForBusinessOrganizationResponse', customers: Array<{ __typename?: 'OrgCustomerRow', gross_profit_in_micros_total: number, last_invoice_date?: string | null, line_items_total: number, margin_percentage?: number | null, order_count: number, restaurant_account_id?: string | null, restaurant_id: string, restaurant_name: string, revenue_in_micros_total: number, sales_rep_id?: string | null, sales_rep_name?: string | null, supplier_id: string }> } };

export type SearchVariantPacksForBusinessOrganizationQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SearchVariantPacksForBusinessOrganizationQuery = { __typename?: 'query_root', searchVariantPacksForBusinessOrganization: Array<{ __typename?: 'SearchVariantPacksForBusinessOrganizationResponse', variant_pack_id: string }> };

export type SubmitPricingPriceDraftUpdatesForBusinessOrganizationMutationVariables = Exact<{ [key: string]: never; }>;


export type SubmitPricingPriceDraftUpdatesForBusinessOrganizationMutation = { __typename?: 'mutation_root', submitPricingPriceDraftUpdateBatchesForBusinessOrganization: { __typename?: 'SubmitPricingPriceDraftUpdateBatchesForBusinessOrganizationResponse', cost_changes: Array<{ __typename?: 'OrgVariantPackCostChange', cost_in_micros?: number | null, cost_in_micros_delta?: number | null, gross_margin_delta_in_micros?: number | null, gross_profit_percentage?: number | null, price_in_micros?: number | null, price_in_micros_delta?: number | null, supplier_id: string, weekly_quantity: number, groups: Array<{ __typename?: 'VariantPackGroupMembership', uuid: string, display_name: string, source: string }>, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, item: { __typename?: 'items', display_name: string, uuid: string }, pack: { __typename?: 'packs', unit: string, uuid: string } } | null }>, per_supplier: Array<{ __typename?: 'SubmitPricingPriceDraftUpdateBatchForBusinessOrganizationResult', supplier_id: string, alert?: { __typename?: 'SubmitPriceDraftBatchAlert', alert_level: AlertLevel, alert_message: string } | null }> } };

export type VariantPackGroupMembershipFieldsFragment = { __typename?: 'VariantPackGroupMembership', uuid: string, display_name: string, source: string };

export type RestaurantCostChangeFieldsFragment = { __typename?: 'businesses', name: string, uuid: string };

export type VariantPackCostChangeFieldsFragment = { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, item: { __typename?: 'items', display_name: string, uuid: string }, pack: { __typename?: 'packs', unit: string, uuid: string } };

export type VariantPackCostChangeDataFieldsFragment = { __typename?: 'OrgVariantPackCostChange', cost_in_micros?: number | null, cost_in_micros_delta?: number | null, gross_margin_delta_in_micros?: number | null, gross_profit_percentage?: number | null, price_in_micros?: number | null, price_in_micros_delta?: number | null, supplier_id: string, weekly_quantity: number, groups: Array<{ __typename?: 'VariantPackGroupMembership', uuid: string, display_name: string, source: string }>, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, item: { __typename?: 'items', display_name: string, uuid: string }, pack: { __typename?: 'packs', unit: string, uuid: string } } | null };

export type PricingPeerGroupFieldsFragment = { __typename?: 'PricingPeerGroup', id: string, min_gross_profit_in_percentage: number, max_gross_profit_in_percentage: number };

export type VariantPackDetailedCostChangeDataFieldsFragment = { __typename?: 'DetailVariantPackCostChange', cost_in_micros?: number | null, cost_in_micros_delta?: number | null, gross_margin_delta_in_micros?: number | null, gross_profit_percentage?: number | null, is_locked?: boolean | null, price_floor_enabled: boolean, price_floor_mode?: VariantPackCostType | null, price_in_micros?: number | null, price_in_micros_delta?: number | null, restaurant_account_id?: string | null, supplier_id: string, weekly_quantity: number, groups: Array<{ __typename?: 'VariantPackGroupMembership', uuid: string, display_name: string, source: string }>, invoice_history?: Array<{ __typename?: 'DetailVariantPackInvoiceHistoryEntry', gross_margin_percentage?: number | null, invoice_date: string, price_in_micros: number, quantity: number }> | null, price_edit_display_headers?: Array<{ __typename?: 'PriceEditDisplayHeader', key: string, category: DisplayConfigCategory, translation: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string } }> | null, pricing_peer_group?: { __typename?: 'PricingPeerGroup', id: string, min_gross_profit_in_percentage: number, max_gross_profit_in_percentage: number } | null, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null, supplier_display_info?: Array<{ __typename?: 'PriceEditDisplayInfoDetail', currency?: string | null, title: string, type: string, value?: string | null }> | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, item: { __typename?: 'items', display_name: string, uuid: string }, pack: { __typename?: 'packs', unit: string, uuid: string } } | null, weekly_purchase_quantities: Array<{ __typename?: 'WeeklyPurchaseQuantity', end_date: string, quantity: number, start_date: string }> };

export type PricingVariantPackCostChangeDataQueryVariables = Exact<{
  variantPackUUIDs?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type PricingVariantPackCostChangeDataQuery = { __typename?: 'query_root', getVariantPackCostChangeDataForBusinessOrganization: Array<{ __typename?: 'OrgVariantPackCostChange', cost_in_micros?: number | null, cost_in_micros_delta?: number | null, gross_margin_delta_in_micros?: number | null, gross_profit_percentage?: number | null, price_in_micros?: number | null, price_in_micros_delta?: number | null, supplier_id: string, weekly_quantity: number, groups: Array<{ __typename?: 'VariantPackGroupMembership', uuid: string, display_name: string, source: string }>, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, item: { __typename?: 'items', display_name: string, uuid: string }, pack: { __typename?: 'packs', unit: string, uuid: string } } | null }> };

export type PricingVariantPackDetailedCostChangeDataQueryVariables = Exact<{
  supplierUUID?: InputMaybe<Scalars['uuid']['input']>;
  variantPackUUID: Scalars['uuid']['input'];
}>;


export type PricingVariantPackDetailedCostChangeDataQuery = { __typename?: 'query_root', getVariantPackDetailedCostChangeData: Array<{ __typename?: 'DetailVariantPackCostChange', cost_in_micros?: number | null, cost_in_micros_delta?: number | null, gross_margin_delta_in_micros?: number | null, gross_profit_percentage?: number | null, is_locked?: boolean | null, price_floor_enabled: boolean, price_floor_mode?: VariantPackCostType | null, price_in_micros?: number | null, price_in_micros_delta?: number | null, restaurant_account_id?: string | null, supplier_id: string, weekly_quantity: number, groups: Array<{ __typename?: 'VariantPackGroupMembership', uuid: string, display_name: string, source: string }>, invoice_history?: Array<{ __typename?: 'DetailVariantPackInvoiceHistoryEntry', gross_margin_percentage?: number | null, invoice_date: string, price_in_micros: number, quantity: number }> | null, price_edit_display_headers?: Array<{ __typename?: 'PriceEditDisplayHeader', key: string, category: DisplayConfigCategory, translation: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string } }> | null, pricing_peer_group?: { __typename?: 'PricingPeerGroup', id: string, min_gross_profit_in_percentage: number, max_gross_profit_in_percentage: number } | null, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null, supplier_display_info?: Array<{ __typename?: 'PriceEditDisplayInfoDetail', currency?: string | null, title: string, type: string, value?: string | null }> | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, item: { __typename?: 'items', display_name: string, uuid: string }, pack: { __typename?: 'packs', unit: string, uuid: string } } | null, weekly_purchase_quantities: Array<{ __typename?: 'WeeklyPurchaseQuantity', end_date: string, quantity: number, start_date: string }> }> };

export type GetPricingHubAgentRecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPricingHubAgentRecsQuery = { __typename?: 'query_root', getPricingHubAgentRecs: { __typename?: 'PricingHubAgentRecs', to_review_count: number, weekly_gp_impact_in_micros: number } };

export type GetPricingHubCostChangesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPricingHubCostChangesQuery = { __typename?: 'query_root', getPricingHubCostChanges: { __typename?: 'PricingHubCostChanges', item_count: number, weekly_gp_impact_in_micros: number } };

export type GetPricingHubCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPricingHubCustomersQuery = { __typename?: 'query_root', getPricingHubCustomers: { __typename?: 'PricingHubCustomers', realized_gm_percentage?: number | null, weekly_gross_profit_in_micros: number, weekly_revenue_in_micros: number } };

export type GetPricingHubRecentPriceChangesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPricingHubRecentPriceChangesQuery = { __typename?: 'query_root', getPricingHubRecentPriceChanges: Array<{ __typename?: 'PricingHubRecentChange', base_unit?: string | null, cost_in_micros?: number | null, event: string, gross_profit_percentage?: number | null, item_name: string, price_in_micros: number, restaurant_id: string, restaurant_name: string, source: string, updated_at: string, variant_pack_id: string, weekly_gp_impact_in_micros: number }> };

export type ExportPriceQuoteMutationVariables = Exact<{
  chatId: Scalars['uuid']['input'];
  priceQuoteId: Scalars['uuid']['input'];
  fileFormat: ExportFileFormat;
}>;


export type ExportPriceQuoteMutation = { __typename?: 'mutation_root', exportPriceQuote: { __typename?: 'ExportPriceQuoteResponse', document_url: string } };

export type PriceQuotesSavedDetailQueryVariables = Exact<{
  priceQuoteId: Scalars['uuid']['input'];
}>;


export type PriceQuotesSavedDetailQuery = { __typename?: 'query_root', getPriceQuote: { __typename?: 'GetPriceQuoteResponse', account_name: string, chat_id: string, competitor_name?: string | null, currency_code: string, name: string, price_quote_id: string, quote_type: string, total_amount_in_micros: number, total_savings_in_micros?: number | null, updated_at: string, line_items: Array<{ __typename?: 'GetPriceQuoteLineItem', currency_code: string, is_catalog_item_removed: boolean, item_code?: string | null, item_description?: string | null, item_name: string, item_pack_size?: string | null, line_item_id: string, line_total_in_micros: number, pack_price_in_micros: number, per_unit_price_in_micros?: number | null, quantity: number, variant_pack_id?: string | null, competitor?: { __typename?: 'GetPriceQuoteCompetitorLineItem', item_name: string, pack_price_in_micros: number, pack_size?: string | null, savings_in_micros: number } | null }> } };

export type PriceQuotesSavedListQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
}>;


export type PriceQuotesSavedListQuery = { __typename?: 'query_root', getPriceQuotes: Array<{ __typename?: 'GetPriceQuoteSummaryResponse', account_name: string, currency_code: string, item_count: number, name: string, price_quote_id: string, quote_type: string, total_amount_in_micros: number, total_savings_in_micros?: number | null, updated_at: string }> };

export type SavePriceQuoteMutationVariables = Exact<{
  price_quote_id?: InputMaybe<Scalars['uuid']['input']>;
  chat_id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  quote_type: Scalars['String']['input'];
  competitor_name?: InputMaybe<Scalars['String']['input']>;
  line_items: Array<SavePriceQuoteLineItemInput> | SavePriceQuoteLineItemInput;
}>;


export type SavePriceQuoteMutation = { __typename?: 'mutation_root', savePriceQuote: { __typename?: 'SavePriceQuoteResponse', price_quote_id: string, name: string, created_at: string, updated_at: string } };

export type SearchPriceQuoteItemsQueryVariables = Exact<{
  chatId: Scalars['uuid']['input'];
  query: Scalars['String']['input'];
}>;


export type SearchPriceQuoteItemsQuery = { __typename?: 'query_root', searchPriceQuoteItems: { __typename?: 'SearchPriceQuoteItemsResponse', items: Array<{ __typename?: 'PriceQuoteItemSearchResult', variant_pack_id: string, item_name: string, item_code?: string | null, item_description?: string | null, item_pack_size?: string | null, currency_code: string, pack_price_in_micros: number, per_unit_price_in_micros?: number | null }> } };

export type SalesPortalProspectFinderCategoryOptionsQueryVariables = Exact<{
  businessOrganizationId: Scalars['uuid']['input'];
}>;


export type SalesPortalProspectFinderCategoryOptionsQuery = { __typename?: 'query_root', getProspectFinderCategoryOptions: Array<{ __typename?: 'YelpCategoryOptionResponse', display_name: string, yelp_alias: string }> };

export type SalesPortalProspectFinderCreateAccountMutationVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  address: Scalars['String']['input'];
  metadata?: InputMaybe<RestaurantMetadataInput>;
  creationSourceFeature?: InputMaybe<CreationSourceFeatures>;
}>;


export type SalesPortalProspectFinderCreateAccountMutation = { __typename?: 'mutation_root', supplierCreateRestaurant: { __typename?: 'SupplierCreateOrUpdateRestaurantResponse', business?: { __typename?: 'businesses', name: string, uuid: string, restaurant_chats: Array<{ __typename?: 'chats', status: string }> } | null } };

export type SalesPortalProspectFinderNearbyBusinessesQueryVariables = Exact<{
  categories?: InputMaybe<Scalars['String']['input']>;
  isCurrentRestaurant?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalProspectFinderNearbyBusinessesQuery = { __typename?: 'query_root', getNearbyBusinessesV2: Array<{ __typename?: 'BusinessSearchResponse', business_display_address: string, business_name: string, categories?: Array<string> | null, distance?: number | null, image_url?: string | null, latitude: number, longitude: number, phone_number: string, restaurant_uuid?: string | null, status?: ChatStatus | null, supplier_uuid?: string | null, yelp_business_id: string }>, businesses_by_pk?: { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', country_code: string, uuid: string } } | null };

export type SalesPortalDeactivateProspectMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalDeactivateProspectMutation = { __typename?: 'mutation_root', supplierDeactivateRestaurant: { __typename?: 'SuccessResponse', success: boolean } };

export type SalesPortalEditableProspectQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalEditableProspectQuery = { __typename?: 'query_root', getSalesPortalProspectDetails: { __typename?: 'SalesPortalProspectDetails', uuid: string, chat_id: string, stage: ChatProspectStage, processing_status: ChatProspectProcessingStatus, last_refreshed_at?: string | null, owned_by_id: string, weekly_estimated_value_in_micros?: { __typename?: 'ChatProspectAutoFillBigIntField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: number | null } | null, contact_name?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null, contact_role?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null, contact_phone?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null, contact_email?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null, incumbents?: { __typename?: 'ChatProspectAutoFillStringListField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: Array<string> | null } | null, estimated_close_date?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null } };

export type SalesPortalProspectDetailQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalProspectDetailQuery = { __typename?: 'query_root', restaurant?: { __typename?: 'businesses', name: string, uuid: string, address: { __typename?: 'addresses', address: string, city: string, latitude: number, longitude: number, region?: string | null, uuid: string }, restaurant_chats: Array<{ __typename?: 'chats', restaurant_account_id?: string | null, uuid: string }> } | null };

export type ProspectDetails_AutoFillBigIntFieldsFragment = { __typename?: 'ChatProspectAutoFillBigIntField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: number | null };

export type ProspectDetails_AutoFillStringFieldsFragment = { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null };

export type ProspectDetails_AutoFillStringListFieldsFragment = { __typename?: 'ChatProspectAutoFillStringListField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: Array<string> | null };

export type ProspectDetails_FieldsFragment = { __typename?: 'SalesPortalProspectDetails', uuid: string, chat_id: string, stage: ChatProspectStage, processing_status: ChatProspectProcessingStatus, last_refreshed_at?: string | null, owned_by_id: string, weekly_estimated_value_in_micros?: { __typename?: 'ChatProspectAutoFillBigIntField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: number | null } | null, contact_name?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null, contact_role?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null, contact_phone?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null, contact_email?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null, incumbents?: { __typename?: 'ChatProspectAutoFillStringListField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: Array<string> | null } | null, estimated_close_date?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null };

export type SalesPortalProspectStageQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalProspectStageQuery = { __typename?: 'query_root', prospectDetails: { __typename?: 'SalesPortalProspectDetails', uuid: string, chat_id: string, stage: ChatProspectStage, processing_status: ChatProspectProcessingStatus, last_refreshed_at?: string | null, owned_by_id: string, weekly_estimated_value_in_micros?: { __typename?: 'ChatProspectAutoFillBigIntField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: number | null } | null, contact_name?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null, contact_role?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null, contact_phone?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null, contact_email?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null, incumbents?: { __typename?: 'ChatProspectAutoFillStringListField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: Array<string> | null } | null, estimated_close_date?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null } };

export type SalesPortalUpdateProspectDetailsMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  prospectDetails: ProspectDetailsUpdateInput;
}>;


export type SalesPortalUpdateProspectDetailsMutation = { __typename?: 'mutation_root', updateSalesPortalProspectDetails: { __typename?: 'SalesPortalProspectDetails', uuid: string, chat_id: string, stage: ChatProspectStage, processing_status: ChatProspectProcessingStatus, last_refreshed_at?: string | null, owned_by_id: string, weekly_estimated_value_in_micros?: { __typename?: 'ChatProspectAutoFillBigIntField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: number | null } | null, contact_name?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null, contact_role?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null, contact_phone?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null, contact_email?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null, incumbents?: { __typename?: 'ChatProspectAutoFillStringListField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: Array<string> | null } | null, estimated_close_date?: { __typename?: 'ChatProspectAutoFillStringField', source: ProspectAutoFillSource, filled_at: string, confidence?: number | null, value?: string | null } | null } };

export type SalesPortalProspectFinderSupplierHqQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SalesPortalProspectFinderSupplierHqQuery = { __typename?: 'query_root', businesses_by_pk?: { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', latitude: number, longitude: number, uuid: string } } | null };

export type SalesPortalManagerPipelineSummaryQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  employeeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type SalesPortalManagerPipelineSummaryQuery = { __typename?: 'query_root', getSalesPortalManagerPipelineSummary: Array<{ __typename?: 'ManagerPipelineStage', currency_code: string, prospect_count: number, stage: ChatProspectStage, total_value_in_micros: number }> };

export type SalesPortalManagerProspectForecastQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  userTimezone: Scalars['String']['input'];
  employeeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  stages: Array<ChatProspectStage> | ChatProspectStage;
}>;


export type SalesPortalManagerProspectForecastQuery = { __typename?: 'query_root', getSalesPortalManagerProspectForecast: Array<{ __typename?: 'ManagerForecastWindow', currency_code: string, prospect_count: number, total_value_in_micros: number, window_days: number }> };

export type SalesPortalManagerProspectsQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  userTimezone: Scalars['String']['input'];
  employeeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  stages: Array<ChatProspectStage> | ChatProspectStage;
}>;


export type SalesPortalManagerProspectsQuery = { __typename?: 'query_root', getSalesPortalManagerProspectList: Array<{ __typename?: 'ManagerProspectRow', currency_code: string, last_activity_at?: string | null, owned_by_id?: string | null, owned_by_name?: string | null, restaurant_id: string, restaurant_name: string, stage: ChatProspectStage, supplier_id: string, uuid: string, weekly_estimated_value_in_micros?: number | null }> };

export type ProspectMetricsFieldsFragment = { __typename?: 'ProspectMetrics', average_conversion_days?: number | null, conversion_rate?: number | null, converted_weekly_estimated_value_in_micros?: number | null, note_count: number };

export type SalesPortalManagerRepSummariesQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  userTimezone: Scalars['String']['input'];
}>;


export type SalesPortalManagerRepSummariesQuery = { __typename?: 'query_root', getSalesPortalManagerRepSummaries: Array<{ __typename?: 'ManagerRepSummary', currency_code: string, employee_id: string, employee_name: string, uuid: string, mtd: { __typename?: 'ProspectMetrics', average_conversion_days?: number | null, conversion_rate?: number | null, converted_weekly_estimated_value_in_micros?: number | null, note_count: number }, wtd: { __typename?: 'ProspectMetrics', average_conversion_days?: number | null, conversion_rate?: number | null, converted_weekly_estimated_value_in_micros?: number | null, note_count: number }, ytd: { __typename?: 'ProspectMetrics', average_conversion_days?: number | null, conversion_rate?: number | null, converted_weekly_estimated_value_in_micros?: number | null, note_count: number } }> };

export type SalesPortalRepViewProspectsQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  userTimezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type SalesPortalRepViewProspectsQuery = { __typename?: 'query_root', getSalesPortalProspectListInfo: Array<{ __typename?: 'SalesPortalProspectInfo', currency_code: string, date_added_at: string, date_added_display: string, last_activity_at?: string | null, last_activity_display?: string | null, restaurant_address: string, restaurant_id: string, restaurant_name: string, supplier_id: string, weekly_estimated_value_in_micros?: number | null }> };

export type SearchFiltersQueryVariables = Exact<{
  restaurantUUID?: InputMaybe<Scalars['uuid']['input']>;
  supplierUUID: Scalars['uuid']['input'];
  variantPackGroupUUID?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type SearchFiltersQuery = { __typename?: 'query_root', getSearchFilters: Array<{ __typename?: 'SearchFilterResponse', display_strategy: string, type: string, name: { __typename?: 'TranslatedValue', original_value: string, translated_value: string }, values?: Array<{ __typename?: 'TranslatedValue', original_value: string, translated_value: string }> | null }> };

export type CreditRequest_SearchVariantPacksInvoicesFragment = { __typename?: 'VariantPackCreditRequestInvoice', available_quantity_for_credit?: number | null, date: string, quantity: number, unit_price_in_micros: number, id: string, number: string };

export type CreditRequest_SearchOtherUoMsFragment = { __typename?: 'VariantPackCreditRequestUOM', uom: PackUnit, quantity: number };

export type GetCreditRequestReasonFieldsFragment = { __typename?: 'credit_request_reasons', invoice_required: boolean, request_period_days?: any | null, type: string, uuid: string, title: any };

export type CreditRequestScanScreen_SearchVariantPacksFieldsFragment = { __typename?: 'SearchVariantPacksForCreditRequestResponse', eligible_for_credit: boolean, guaranteed: boolean, last_fulfillment_date?: string | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null };

export type CreditRequestScanScreen_SearchVariantPacksQueryVariables = Exact<{
  code: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type CreditRequestScanScreen_SearchVariantPacksQuery = { __typename?: 'query_root', searchVariantPacksForCreditRequest: Array<{ __typename?: 'SearchVariantPacksForCreditRequestResponse', eligible_for_credit: boolean, guaranteed: boolean, last_fulfillment_date?: string | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> };

export type CreditRequestPdpScreen_SearchVariantPacksFieldsFragment = { __typename?: 'SearchVariantPacksForCreditRequestResponse', eligible_for_credit: boolean, guaranteed: boolean };

export type CreditRequestPdpScreen_SearchVariantPacksQueryVariables = Exact<{
  code: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPackUUID?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type CreditRequestPdpScreen_SearchVariantPacksQuery = { __typename?: 'query_root', searchVariantPacksForCreditRequest: Array<{ __typename?: 'SearchVariantPacksForCreditRequestResponse', eligible_for_credit: boolean, guaranteed: boolean }> };

export type CreditRequestInvoiceItems_SearchVariantPacksFieldsFragment = { __typename?: 'SearchVariantPacksForCreditRequestResponse', eligible_for_credit: boolean, guaranteed: boolean, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null };

export type CreditRequestByInvoice_SearchVariantPacksQueryVariables = Exact<{
  code: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  orderInvoiceUUID?: InputMaybe<Scalars['uuid']['input']>;
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type CreditRequestByInvoice_SearchVariantPacksQuery = { __typename?: 'query_root', searchVariantPacksForCreditRequest: Array<{ __typename?: 'SearchVariantPacksForCreditRequestResponse', eligible_for_credit: boolean, guaranteed: boolean, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> };

export type CreditRequest_RenderPrintTemplateQueryVariables = Exact<{
  creditRequestBatchUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type CreditRequest_RenderPrintTemplateQuery = { __typename?: 'query_root', renderPrintCreditRequestTemplate: { __typename?: 'RenderedTemplateResponse', rendered_template: string } };

export type UpdateAnalyticsAlertsStatusesMutationVariables = Exact<{
  alertStatus: AnalyticsAlertStatusType;
  alertUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  businessOrganizationUUID: Scalars['uuid']['input'];
}>;


export type UpdateAnalyticsAlertsStatusesMutation = { __typename?: 'mutation_root', updateAnalyticsAlertsStatuses: { __typename?: 'UpdateAnalyticsAlertsStatusResponse', updatedCount: number } };

export type GetHubCurrentOrdersQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  userTimezone: Scalars['String']['input'];
}>;


export type GetHubCurrentOrdersQuery = { __typename?: 'query_root', getHubCurrentOrders: Array<{ __typename?: 'GetHubCurrentOrdersResponse', created_at: string, chat_id: string, is_call_sheet_order: boolean, is_draft_order?: boolean | null, ordered_by_user_id?: string | null, ordered_by_user_phone_number?: string | null, order_amount_in_micros?: number | null, order_status?: string | null, order_id?: string | null, restaurant_name: string, restaurant_id: string, supplier_id: string, description: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string }, item_count_display?: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string } | null, operator_employees: Array<{ __typename?: 'OperatorEmployeeContact', name: string, phone_number: string, user_id: string }>, restaurant_name_i18n: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string } }> };

export type GetAllHiddenHubAlertsQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type GetAllHiddenHubAlertsQuery = { __typename?: 'query_root', getAllHubAlerts: { __typename?: 'GetAllHubAnalyticsAlertsResponse', card_data_json: Array<string> } };

export type GetHubCardDataQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  cardType: HubCardType;
  userUUID: Scalars['uuid']['input'];
  userTimezone: Scalars['String']['input'];
}>;


export type GetHubCardDataQuery = { __typename?: 'query_root', getHubCardData: { __typename?: 'GetHubCardDataResponse', card_type: HubCardType, card_data_json: Array<string> } };

export type GetHubLastVisitedQueryVariables = Exact<{
  employeeUUID: Scalars['uuid']['input'];
}>;


export type GetHubLastVisitedQuery = { __typename?: 'query_root', hub_last_visited_by_pk?: { __typename?: 'hub_last_visited', last_visited_at: string } | null };

export type GetAllActiveHubAlertsQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type GetAllActiveHubAlertsQuery = { __typename?: 'query_root', getAllHubAlerts: { __typename?: 'GetAllHubAnalyticsAlertsResponse', card_data_json: Array<string> } };

export type MarkHubViewedMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkHubViewedMutation = { __typename?: 'mutation_root', updateHubLastVisited: { __typename?: 'UpdateHubLastVisitedResponse', success: boolean } };

export type GetHubPastOrdersQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  startDate: Scalars['String']['input'];
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  userTimezone: Scalars['String']['input'];
}>;


export type GetHubPastOrdersQuery = { __typename?: 'query_root', getHubPastOrders: { __typename?: 'GetHubPastOrdersResponse', next_available_date?: string | null, past_order_data: Array<{ __typename?: 'GetHubPastOrdersData', amount_in_micros?: number | null, chat_id: string, invoice_id?: string | null, order_date: string, order_id?: string | null, restaurant_id: string, restaurant_name: string, supplier_id: string, item_count_display?: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string } | null, operator_employees?: Array<{ __typename?: 'OperatorEmployeeContact', name: string, phone_number: string, user_id: string }> | null, order_date_display: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string }, restaurant_name_i18n: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string } }> } };

export type GetUnseenAnalyticsAlertCountQueryVariables = Exact<{
  employeeUUID: Scalars['uuid']['input'];
  since: Scalars['timestamptz']['input'];
  businessOrganizationUUID: Scalars['uuid']['input'];
}>;


export type GetUnseenAnalyticsAlertCountQuery = { __typename?: 'query_root', analytics_alerts_aggregate: { __typename?: 'analytics_alerts_aggregate', aggregate?: { __typename?: 'analytics_alerts_aggregate_fields', count: number } | null } };

export type VariantPackInfoBaseFragment = { __typename?: 'GetVariantPackInfoResponse', availability_status?: string | null, available_quantity?: number | null, currency_code: string, variant_pack_id: string, cost_info?: { __typename?: 'VariantPackCostInfoResponse', details?: Array<{ __typename?: 'VariantPackDetailedCostInfoResponse', cost_in_micros: number, type: VariantPackCostType }> | null } | null, inventory_info?: { __typename?: 'VariantPackInventoryInfoResponse', quantity_on_hand?: number | null } | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, metadata?: any | null, uuid: string, item: { __typename?: 'items', uuid: string, name: string, description?: string | null, photo_url_list?: any | null }, pack: { __typename?: 'packs', unit: string, max_unit_size: number, min_unit_size: number, uuid: string } } | null };

export type VariantPackPricingInfoFragment = { __typename?: 'GetVariantPackInfoResponse', price_in_micros?: number | null, sales_rep_price_in_micros?: number | null, sales_rep_gross_profit_in_percentage?: number | null };

export type GetVariantPackQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPackUUID: Scalars['uuid']['input'];
}>;


export type GetVariantPackQuery = { __typename?: 'query_root', getVariantPackInfoList: Array<{ __typename?: 'GetVariantPackInfoResponse', availability_status?: string | null, available_quantity?: number | null, currency_code: string, variant_pack_id: string, cost_info?: { __typename?: 'VariantPackCostInfoResponse', details?: Array<{ __typename?: 'VariantPackDetailedCostInfoResponse', cost_in_micros: number, type: VariantPackCostType }> | null } | null, inventory_info?: { __typename?: 'VariantPackInventoryInfoResponse', quantity_on_hand?: number | null } | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, metadata?: any | null, uuid: string, item: { __typename?: 'items', uuid: string, name: string, description?: string | null, photo_url_list?: any | null }, pack: { __typename?: 'packs', unit: string, max_unit_size: number, min_unit_size: number, uuid: string } } | null }>, businesses_by_pk?: { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', country_code: string, uuid: string }, supplier_chats: Array<{ __typename?: 'chats', item_modifiers_enabled: boolean, uuid: string }>, supplier_metadata?: { __typename?: 'supplier_metadata', display_item_code: boolean, uuid: string } | null } | null };

export type GetVariantPackPricingInfoQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPackUUID: Scalars['uuid']['input'];
}>;


export type GetVariantPackPricingInfoQuery = { __typename?: 'query_root', getVariantPackInfoList: Array<{ __typename?: 'GetVariantPackInfoResponse', availability_status?: string | null, available_quantity?: number | null, currency_code: string, variant_pack_id: string, price_in_micros?: number | null, sales_rep_price_in_micros?: number | null, sales_rep_gross_profit_in_percentage?: number | null, cost_info?: { __typename?: 'VariantPackCostInfoResponse', details?: Array<{ __typename?: 'VariantPackDetailedCostInfoResponse', cost_in_micros: number, type: VariantPackCostType }> | null } | null, inventory_info?: { __typename?: 'VariantPackInventoryInfoResponse', quantity_on_hand?: number | null } | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, metadata?: any | null, uuid: string, item: { __typename?: 'items', uuid: string, name: string, description?: string | null, photo_url_list?: any | null }, pack: { __typename?: 'packs', unit: string, max_unit_size: number, min_unit_size: number, uuid: string } } | null }>, getPriceEditDisplayInfo: { __typename?: 'PriceEditDisplayInfoResponse', title_translations: Array<{ __typename?: 'PriceEditTitleTranslation', title: string, translation: string }>, variant_pack_details: Array<{ __typename?: 'PriceEditVariantPackDetail', variant_pack_id: string, detail: Array<{ __typename?: 'PriceEditDisplayInfoDetail', currency?: string | null, title: string, trend?: PriceEditDisplayInfoTrend | null, type: string, value?: string | null }>, settings?: { __typename?: 'PriceEditVariantPackDisplaySettings', disable_override_editing?: boolean | null, disable_sales_rep_info?: boolean | null, enable_peak_price_protection?: boolean | null } | null }> } };

export type GetRelatedVariantPacksIdsQueryVariables = Exact<{
  filters: Variants_Packs_Bool_Exp;
  supplierUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
}>;


export type GetRelatedVariantPacksIdsQuery = { __typename?: 'query_root', variants_packs: Array<{ __typename?: 'variants_packs', uuid: string, external_item_id?: string | null }> };

export type GetRelatedVariantPacks_VariantPackInfoFieldsFragment = { __typename?: 'variants_packs', uuid: string, external_item_id?: string | null, pack: { __typename?: 'packs', unit: string, max_unit_size: number, min_unit_size: number, uuid: string } };

export type GetRelatedVariantPacks_VariantPackInfoFragment = { __typename?: 'GetVariantPackInfoResponse', price_in_micros?: number | null, currency_code: string, unit_count: number, variant_pack?: { __typename?: 'variants_packs', uuid: string, external_item_id?: string | null, pack: { __typename?: 'packs', unit: string, max_unit_size: number, min_unit_size: number, uuid: string } } | null };

export type GetRelatedVariantPacksQueryVariables = Exact<{
  variantPackUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRelatedVariantPacksQuery = { __typename?: 'query_root', getVariantPackInfoList: Array<{ __typename?: 'GetVariantPackInfoResponse', price_in_micros?: number | null, currency_code: string, unit_count: number, variant_pack?: { __typename?: 'variants_packs', uuid: string, external_item_id?: string | null, pack: { __typename?: 'packs', unit: string, max_unit_size: number, min_unit_size: number, uuid: string } } | null }> };

export type LeadGenerator_ProspectFinderCategoryOptionsQueryVariables = Exact<{
  businessOrganizationId: Scalars['uuid']['input'];
}>;


export type LeadGenerator_ProspectFinderCategoryOptionsQuery = { __typename?: 'query_root', getProspectFinderCategoryOptions: Array<{ __typename?: 'YelpCategoryOptionResponse', display_name: string, yelp_alias: string }> };

export type CreditRequestOfflineVariantPackFieldsFragment = { __typename?: 'variants_packs', credit_request_config?: any | null, external_item_id?: string | null, upc_list?: any | null, uuid: string, item: { __typename?: 'items', display_name: string, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, uuid: string }> }, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string } };

export type VariantPackCreditRequestDataFieldsFragment = { __typename?: 'VariantPackCreditRequestData', latest_invoice?: { __typename?: 'VariantPackCreditRequestInvoice', available_quantity_for_credit?: number | null, date: string, quantity: number, unit_price_in_micros: number, id: string, number: string } | null, other_creditable_uoms?: Array<{ __typename?: 'VariantPackCreditRequestUOM', uom: PackUnit, quantity: number }> | null, variant_pack?: { __typename?: 'variants_packs', credit_request_config?: any | null, external_item_id?: string | null, upc_list?: any | null, uuid: string, item: { __typename?: 'items', display_name: string, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, uuid: string }> }, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string } } | null };

export type CreditRequest_OfflineDataQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type CreditRequest_OfflineDataQuery = { __typename?: 'query_root', getCreditRequestVariantPackEligibility: { __typename?: 'GetCreditRequestEligibilityResponse', credit_request_reasons: Array<{ __typename?: 'CreditRequestReasonResponse', credit_request_reason?: { __typename?: 'credit_request_reasons', invoice_required: boolean, request_period_days?: any | null, type: string, uuid: string, title: any } | null }>, variant_pack_credit_request_data: Array<{ __typename?: 'VariantPackCreditRequestData', latest_invoice?: { __typename?: 'VariantPackCreditRequestInvoice', available_quantity_for_credit?: number | null, date: string, quantity: number, unit_price_in_micros: number, id: string, number: string } | null, other_creditable_uoms?: Array<{ __typename?: 'VariantPackCreditRequestUOM', uom: PackUnit, quantity: number }> | null, variant_pack?: { __typename?: 'variants_packs', credit_request_config?: any | null, external_item_id?: string | null, upc_list?: any | null, uuid: string, item: { __typename?: 'items', display_name: string, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, uuid: string }> }, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string } } | null }> } };

export type MinimalVariantPack_CatalogFieldsFragment = { __typename?: 'variants_packs', external_item_id?: string | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', metadata: any }> | null, item: { __typename?: 'items', description?: string | null, display_name: string, photo_url_list?: any | null, uuid: string }, order_constraint_rel?: { __typename?: 'order_constraint_variant_pack_rel', order_constraint: { __typename?: 'order_constraints', metadata: any } } | null, pack: { __typename?: 'packs', max_unit_size: number, min_unit_size: number, unit: string, unit_count: number }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null };

export type MinimalVariantPack_CatalogPageQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
}>;


export type MinimalVariantPack_CatalogPageQuery = { __typename?: 'query_root', variants_packs: Array<{ __typename?: 'variants_packs', external_item_id?: string | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', metadata: any }> | null, item: { __typename?: 'items', description?: string | null, display_name: string, photo_url_list?: any | null, uuid: string }, order_constraint_rel?: { __typename?: 'order_constraint_variant_pack_rel', order_constraint: { __typename?: 'order_constraints', metadata: any } } | null, pack: { __typename?: 'packs', max_unit_size: number, min_unit_size: number, unit: string, unit_count: number }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null }> };

export type MinimalVariantPack_VariantPackCountQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
}>;


export type MinimalVariantPack_VariantPackCountQuery = { __typename?: 'query_root', variants_packs_aggregate: { __typename?: 'variants_packs_aggregate', aggregate?: { __typename?: 'variants_packs_aggregate_fields', count: number } | null } };

export type MinimalVariantPack_VisibleVariantPackIDsQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type MinimalVariantPack_VisibleVariantPackIDsQuery = { __typename?: 'query_root', visible_variant_packs: Array<{ __typename?: 'visible_variant_packs', variant_pack_uuid?: string | null }> };

export type VariantPackInfoContext_OfflineInfoListQueryVariables = Exact<{
  orderGuideOnly: Scalars['Boolean']['input'];
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type VariantPackInfoContext_OfflineInfoListQuery = { __typename?: 'query_root', getVariantPackInfoList: Array<{ __typename?: 'GetVariantPackInfoResponse', availability_status?: string | null, available_quantity?: number | null, currency_code: string, default_price_in_micros?: number | null, list_item_display_text?: string | null, manufacturer_suggested_retail_price_in_micros?: number | null, price_in_micros?: number | null, sales_rep_price_in_micros?: number | null, sales_rep_gross_profit_in_percentage?: number | null, suggested_retail_price_in_micros?: number | null, variant_pack_id: string, unit_count: number, cost_info?: { __typename?: 'VariantPackCostInfoResponse', details?: Array<{ __typename?: 'VariantPackDetailedCostInfoResponse', cost_in_micros: number, type: VariantPackCostType }> | null } | null, inventory_info?: { __typename?: 'VariantPackInventoryInfoResponse', quantity_on_hand?: number | null, incoming?: Array<{ __typename?: 'VariantPackIncomingInventoryResponse', date: string, quantity: number }> | null } | null, sales_rep_metadata?: { __typename?: 'VariantPackSalesRepMetadataResponse', price_ceiling_in_micros?: number | null, updated_by_name?: string | null } | null }> };

export type NewOrder_VisibleVariantPackQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type NewOrder_VisibleVariantPackQuery = { __typename?: 'query_root', visible_variant_packs: Array<{ __typename?: 'visible_variant_packs', variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> };

export type OfflineReplay_GetDraftOrdersQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  unplacedOrderStatuses: Array<OrderStatus> | OrderStatus;
  orderDomains: Array<OrderDomain> | OrderDomain;
}>;


export type OfflineReplay_GetDraftOrdersQuery = { __typename?: 'query_root', getOrders: Array<{ __typename?: 'OrderResponse', order?: { __typename?: 'orders', restaurant_uuid: string, uuid: string } | null }> };

export type AvailableOrderFulfillmentsQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type AvailableOrderFulfillmentsQuery = { __typename?: 'query_root', getAvailableOrderFulfillments: Array<{ __typename?: 'GetAvailableOrderFulfillmentResponse', default_cutoff_time?: string | null, default_lead_time_days?: number | null, fulfillment_disclaimer?: string | null, fulfillment_display_name?: string | null, fulfillment_name: FulfillmentName, fulfillment_settings_id: string, fulfillment_type: FulfillmentType, order_minimum_display_string?: string | null, primary_fulfillment_settings_id?: string | null, availability: Array<{ __typename?: 'OrderFulfillmentAvailability', cutoff_time?: string | null, date: string, lead_time_days?: number | null, order_minimum_display_string?: string | null, timeslot_settings?: { __typename?: 'FulfillmentTimeslotSettings', default_selection: FulfillmentTimeslotSelection, lead_time_minutes?: number | null, selection_required: boolean, timeslots: Array<{ __typename?: 'FulfillmentTimeslotEntry', end_time: string, start_time: string }> } | null }> }> };

export type DraftOrdersQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  unplacedOrderStatuses: Array<OrderStatus> | OrderStatus;
  orderDomains: Array<OrderDomain> | OrderDomain;
}>;


export type DraftOrdersQuery = { __typename?: 'query_root', getOrders: Array<{ __typename?: 'OrderResponse', order?: { __typename?: 'orders', additional_input_values?: any | null, fulfillment_timeslot_end?: string | null, fulfillment_timeslot_start?: string | null, fulfillment_type: string, notes?: string | null, order_domain?: string | null, placed_at?: string | null, po_number?: string | null, restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_fulfillment_fees: Array<{ __typename?: 'order_fulfillment_fees', amount_in_micros?: number | null, fulfillment_settings_name?: string | null, uuid?: string | null }>, order_invoices: Array<{ __typename?: 'order_invoices', balance_in_micros?: number | null, due_at?: string | null, invoice_date: string, invoice_number?: string | null, order_uuid?: string | null, uuid: string }>, orders_items: Array<{ __typename?: 'orders_items', earliest_fulfillment_at?: string | null, notes?: string | null, restaurant_display_name: string, uuid: string, order_item_prices?: { __typename?: 'order_item_prices', pack_quantity_at_order?: number | null } | null, variants_pack: { __typename?: 'variants_packs', metadata?: any | null, uuid: string, item: { __typename?: 'items', description?: string | null, uuid: string } } }>, storefront_metadata?: { __typename?: 'storefront_order_metadata', name?: string | null, uuid: string, visibility: string } | null } | null }> };

export type ConfirmKlarnaPaymentMutationVariables = Exact<{
  restaurantId: Scalars['uuid']['input'];
  supplierId: Scalars['uuid']['input'];
  paymentBatchId: Scalars['uuid']['input'];
  klarnaPaymentData?: InputMaybe<Scalars['String']['input']>;
  klarnaPaymentDetails: Scalars['String']['input'];
}>;


export type ConfirmKlarnaPaymentMutation = { __typename?: 'mutation_root', confirmKlarnaPayment: { __typename?: 'ConfirmKlarnaPaymentResponse', alert_level?: AlertLevel | null, alert_message?: string | null, payment_batch_id?: string | null, payment_batch?: { __typename?: 'payment_batches', result_code?: string | null } | null } };

export type DepositManualPaymentsResponseFieldsFragment = { __typename?: 'DepositManualPaymentsResponse', alert_level?: AlertLevel | null, alert_message?: string | null, manual_deposit_id?: string | null };

export type Payments_DepositManualPaymentsMutationVariables = Exact<{
  depositNumber: Scalars['String']['input'];
  employeeUUID: Scalars['uuid']['input'];
  paymentBatches: Array<ManualDepositPaymentBatchInput> | ManualDepositPaymentBatchInput;
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Payments_DepositManualPaymentsMutation = { __typename?: 'mutation_root', depositManualPayments: { __typename?: 'DepositManualPaymentsResponse', alert_level?: AlertLevel | null, alert_message?: string | null, manual_deposit_id?: string | null } };

export type GeneratePaymentLinkMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  orderInvoiceAmounts: Array<OrderInvoiceAmountInput> | OrderInvoiceAmountInput;
  creditMemoAmounts: Array<CreditMemoAmountInput> | CreditMemoAmountInput;
}>;


export type GeneratePaymentLinkMutation = { __typename?: 'mutation_root', generatePaymentLink: { __typename?: 'GeneratePaymentLinkResponse', payment_link_url: string } };

export type GeneratePaymentStatementLinkMutationVariables = Exact<{
  employeeUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type GeneratePaymentStatementLinkMutation = { __typename?: 'mutation_root', generatePaymentStatementLink: { __typename?: 'GeneratePaymentStatementLinkResponse', payment_statement_url: string } };

export type GetCardDetailsQueryVariables = Exact<{
  encryptedCardNumber: Scalars['String']['input'];
}>;


export type GetCardDetailsQuery = { __typename?: 'query_root', getCardDetails: { __typename?: 'GetCardDetailsResponse', funding_source: CardFundingSource } };

export type CollectedManualPaymentFieldsFragment = { __typename?: 'CollectedManualPayment', collected_date: string, credit_memos_count: number, invoices_count: number, paid_source: PaidSource, payment_batch_id: string, payment_method_display_text?: string | null, total_amount_in_micros: number, payment_batch?: { __typename?: 'payment_batches', uuid: string, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null } | null };

export type Payments_GetCollectedManualPaymentsQueryVariables = Exact<{
  employeeUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Payments_GetCollectedManualPaymentsQuery = { __typename?: 'query_root', getCollectedManualPayments: { __typename?: 'GetCollectedManualPaymentsResponse', alert_level?: AlertLevel | null, alert_message?: string | null, payments: Array<{ __typename?: 'CollectedManualPayment', collected_date: string, credit_memos_count: number, invoices_count: number, paid_source: PaidSource, payment_batch_id: string, payment_method_display_text?: string | null, total_amount_in_micros: number, payment_batch?: { __typename?: 'payment_batches', uuid: string, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null } | null }> } };

export type ManualDepositSummaryFieldsFragment = { __typename?: 'ManualDepositSummary', cash_count: number, check_count: number, deposit_date: string, deposit_number: string, manual_deposit_id: string, total_amount_in_micros: number };

export type Payments_GetManualDepositsQueryVariables = Exact<{
  employeeUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Payments_GetManualDepositsQuery = { __typename?: 'query_root', getManualDeposits: { __typename?: 'GetManualDepositsResponse', alert_level?: AlertLevel | null, alert_message?: string | null, deposits: Array<{ __typename?: 'ManualDepositSummary', cash_count: number, check_count: number, deposit_date: string, deposit_number: string, manual_deposit_id: string, total_amount_in_micros: number }> } };

export type GetPaymentLinksQueryVariables = Exact<{
  restaurant_id: Scalars['uuid']['input'];
  supplier_id: Scalars['uuid']['input'];
}>;


export type GetPaymentLinksQuery = { __typename?: 'query_root', getPaymentLinks: { __typename?: 'GetPaymentLinksResponse', payment_links: Array<{ __typename?: 'PaymentLinkResponse', credit_memos_count: number, id: string, invoices_count: number, payment_link_url: string, total_remaining_balance_in_micros: number, payment_link?: { __typename?: 'payment_links', created_at: string } | null }> } };

export type InitiateKlarnaPaymentMutationVariables = Exact<{
  restaurantId: Scalars['uuid']['input'];
  supplierId: Scalars['uuid']['input'];
  invoices: Array<InvoiceInput> | InvoiceInput;
  creditMemos: Array<CreditMemoInput> | CreditMemoInput;
  paymentMethod: Scalars['String']['input'];
  feesInMicros?: InputMaybe<Scalars['bigint']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type InitiateKlarnaPaymentMutation = { __typename?: 'mutation_root', initiateKlarnaPayment: { __typename?: 'InitiateKlarnaPaymentResponse', alert_level?: AlertLevel | null, alert_message?: string | null, klarna_action?: string | null, payment_batch_id?: string | null } };

export type Payments_GetKlarnaPaymentMethodsQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Payments_GetKlarnaPaymentMethodsQuery = { __typename?: 'query_root', getAdyenDropinConfig: { __typename?: 'GetAdyenDropinConfigResponse', klarna_payment_methods: Array<string> } };

export type GetPadConsentFormsQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  accountType: Scalars['String']['input'];
  consentEmployeeName: Scalars['String']['input'];
  consentPhoneNumber: Scalars['String']['input'];
  consentEmail: Scalars['String']['input'];
  consentStreetAddress: Scalars['String']['input'];
  consentCity: Scalars['String']['input'];
  consentProvince: Scalars['String']['input'];
  consentPostalCode: Scalars['String']['input'];
}>;


export type GetPadConsentFormsQuery = { __typename?: 'query_root', getPadConsentForms: { __typename?: 'GetPadConsentFormsResponse', alert_level?: AlertLevel | null, alert_message?: string | null, pad_additional_terms_and_conditions?: string | null, pad_agreement?: string | null } };

export type SavePadPaymentMethodWithConsentMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  accountType: Scalars['String']['input'];
  consentEmployeeName: Scalars['String']['input'];
  consentPhoneNumber: Scalars['String']['input'];
  consentEmail: Scalars['String']['input'];
  consentStreetAddress: Scalars['String']['input'];
  consentCity: Scalars['String']['input'];
  consentProvince: Scalars['String']['input'];
  consentPostalCode: Scalars['String']['input'];
  paymentMethod: Scalars['String']['input'];
}>;


export type SavePadPaymentMethodWithConsentMutation = { __typename?: 'mutation_root', savePadPaymentMethodWithConsent: { __typename?: 'SavePadPaymentMethodWithConsentResponse', alert_level?: AlertLevel | null, alert_message?: string | null, payment_method_id?: string | null } };

export type UpdatePadPaymentMethodConsentMutationVariables = Exact<{
  paymentMethodUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  accountType: Scalars['String']['input'];
  consentEmployeeName: Scalars['String']['input'];
  consentPhoneNumber: Scalars['String']['input'];
  consentEmail: Scalars['String']['input'];
  consentStreetAddress: Scalars['String']['input'];
  consentCity: Scalars['String']['input'];
  consentProvince: Scalars['String']['input'];
  consentPostalCode: Scalars['String']['input'];
}>;


export type UpdatePadPaymentMethodConsentMutation = { __typename?: 'mutation_root', updatePadPaymentMethodConsent: { __typename?: 'UpdatePadPaymentMethodConsentResponse', alert_level?: AlertLevel | null, alert_message?: string | null, payment_method_id?: string | null } };

export type GetPadConsentFormsForPaymentMethodQueryVariables = Exact<{
  paymentMethodUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type GetPadConsentFormsForPaymentMethodQuery = { __typename?: 'query_root', getPadConsentFormsForPaymentMethod: { __typename?: 'GetPadConsentFormsForPaymentMethodResponse', pad_additional_terms_and_conditions?: string | null, pad_agreement?: string | null } };

export type GetPadPaymentMethodConsentQueryVariables = Exact<{
  paymentMethodUUID: Scalars['uuid']['input'];
}>;


export type GetPadPaymentMethodConsentQuery = { __typename?: 'query_root', pad_payment_method: Array<{ __typename?: 'pad_payment_method', consent_date?: any | null, uuid: string }> };

export type GetPaymentLinkLineItemsQueryVariables = Exact<{
  paymentLinkUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type GetPaymentLinkLineItemsQuery = { __typename?: 'query_root', getPaymentLinkLineItems: { __typename?: 'GetPaymentLinkLineItemsResponse', created_at: string, payment_link_url: string, total_remaining_balance_in_micros: number, credit_memos: Array<{ __typename?: 'PaymentLinkCreditMemo', remaining_balance_in_micros: number, credit_memo?: { __typename?: 'credit_memos', credit_date: string, credit_number?: string | null, uuid: string } | null }>, invoices: Array<{ __typename?: 'PaymentLinkInvoice', remaining_balance_in_micros: number, order_invoice?: { __typename?: 'order_invoices', due_at?: string | null, invoice_number?: string | null, uuid: string } | null }> } };

export type PrepareCheckCaptureMutationVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
  deviceTracking: DeviceTrackingHasuraInput;
}>;


export type PrepareCheckCaptureMutation = { __typename?: 'mutation_root', prepareCheckCapture: { __typename?: 'PrepareCheckCaptureResponse', alert_level?: string | null, alert_message?: string | null, misnap_license?: string | null, front_upload_url?: string | null, rear_upload_url?: string | null, front_s3_key?: string | null, rear_s3_key?: string | null } };

export type RecordCashPaymentResponseFieldsFragment = { __typename?: 'RecordCashPaymentResponse', alert_level?: AlertLevel | null, alert_message?: string | null, payment_batch_id?: string | null };

export type Payments_RecordCashPaymentMutationVariables = Exact<{
  creditMemos?: InputMaybe<Array<PartialPaymentCreditMemoInput> | PartialPaymentCreditMemoInput>;
  creditRequestBatchLineItems?: InputMaybe<Array<CreditRequestBatchLineItemInput> | CreditRequestBatchLineItemInput>;
  invoices: Array<PartialPaymentInvoiceInput> | PartialPaymentInvoiceInput;
  memo?: InputMaybe<Scalars['String']['input']>;
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Payments_RecordCashPaymentMutation = { __typename?: 'mutation_root', recordCashPayment: { __typename?: 'RecordCashPaymentResponse', alert_level?: AlertLevel | null, alert_message?: string | null, payment_batch_id?: string | null } };

export type RecordCheckPaymentResponseFieldsFragment = { __typename?: 'RecordCheckPaymentResponse', alert_level?: AlertLevel | null, alert_message?: string | null, payment_batch_id?: string | null };

export type Payments_RecordCheckPaymentMutationVariables = Exact<{
  checkNumber: Scalars['String']['input'];
  creditMemos?: InputMaybe<Array<PartialPaymentCreditMemoInput> | PartialPaymentCreditMemoInput>;
  creditRequestBatchLineItems?: InputMaybe<Array<CreditRequestBatchLineItemInput> | CreditRequestBatchLineItemInput>;
  invoices: Array<PartialPaymentInvoiceInput> | PartialPaymentInvoiceInput;
  memo?: InputMaybe<Scalars['String']['input']>;
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Payments_RecordCheckPaymentMutation = { __typename?: 'mutation_root', recordCheckPayment: { __typename?: 'RecordCheckPaymentResponse', alert_level?: AlertLevel | null, alert_message?: string | null, payment_batch_id?: string | null } };

export type SubmitCheckDepositMutationVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
  creditMemos: Array<SubmitCheckDepositCreditMemoInput> | SubmitCheckDepositCreditMemoInput;
  creditRequestBatchLineItems?: InputMaybe<Array<CreditRequestBatchLineItemInput> | CreditRequestBatchLineItemInput>;
  deviceTracking: DeviceTrackingHasuraInput;
  frontS3Key: Scalars['String']['input'];
  invoices: Array<SubmitCheckDepositInvoiceInput> | SubmitCheckDepositInvoiceInput;
  memoNotes: Scalars['String']['input'];
  rearS3Key: Scalars['String']['input'];
}>;


export type SubmitCheckDepositMutation = { __typename?: 'mutation_root', submitCheckDeposit: { __typename?: 'SubmitCheckDepositResponse', alert_level?: string | null, alert_message?: string | null, error_code?: string | null, payment_batch_id?: string | null } };

export type NoteActionSheet_AddNoteActivityMutationVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
  noteContent: Scalars['String']['input'];
}>;


export type NoteActionSheet_AddNoteActivityMutation = { __typename?: 'mutation_root', createNoteActivity: { __typename?: 'CreateNoteAcitivityResponse', crm_activity?: { __typename?: 'crm_activities', uuid: string, chat_uuid: string } | null } };

export type NoteActionSheet_AddNoteReminderMutationVariables = Exact<{
  crmActivityUUID: Scalars['uuid']['input'];
  chatUUID: Scalars['uuid']['input'];
  reminderDatetime: Scalars['String']['input'];
}>;


export type NoteActionSheet_AddNoteReminderMutation = { __typename?: 'mutation_root', createActivityReminder: { __typename?: 'CreateActivityReminderResponse', crm_activity_reminder?: { __typename?: 'crm_activity_reminders', remind_at: string, status: string, uuid: string } | null } };

export type GetActiveAnalyticsAlertsQueryVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
}>;


export type GetActiveAnalyticsAlertsQuery = { __typename?: 'query_root', getAnalyticsAlerts: { __typename?: 'GetAnalyticsAlertsResponse', alerts_json: Array<string> } };

export type OrderSummary_ApplyPromotionsMutationVariables = Exact<{
  discountCodes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  orderUUID: Scalars['uuid']['input'];
}>;


export type OrderSummary_ApplyPromotionsMutation = { __typename?: 'mutation_root', applyPromotions: { __typename?: 'OrderResponse', order_id: string } };

export type Auth_UserLoginMutationVariables = Exact<{
  supplierUUID?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type Auth_UserLoginMutation = { __typename?: 'mutation_root', restaurantEmployeeLogin: { __typename?: 'EmployeeResponse', employee_id: string } };

export type Catalog_CategoryItemsQueryVariables = Exact<{
  itemLimit: Scalars['Int']['input'];
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Catalog_CategoryItemsQuery = { __typename?: 'query_root', getSupplierCategoryItems: Array<{ __typename?: 'GetSupplierCategoryItemsResponse', category?: string | null, category_item_count: number, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> };

export type Catalog_CategoriesQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Catalog_CategoriesQuery = { __typename?: 'query_root', categories: Array<{ __typename?: 'visible_variant_packs', category?: string | null }> };

export type Catalog_VariantPackGroupItemsQueryVariables = Exact<{
  itemLimit: Scalars['Int']['input'];
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Catalog_VariantPackGroupItemsQuery = { __typename?: 'query_root', getSupplierVariantPackGroupItems: Array<{ __typename?: 'GetSupplierVariantPackGroupItemResponse', variant_pack_group_display_name?: string | null, variant_pack_group_item_count: number, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null, variant_pack_group?: { __typename?: 'variant_pack_groups', display_image_url?: string | null, type?: string | null, uuid: string } | null }> };

export type Catalog_ExpandedSaltInfoFragment = { __typename?: 'ExpandedSaltItemInfo', name?: string | null, description?: string | null, image_urls?: Array<string> | null };

export type Catalog_VariantPackGroupItemsExpandedFieldsFragment = { __typename?: 'GetSupplierVariantPackGroupItemExpandedResponse', variant_pack_group_id?: string | null, variant_pack_group_display_name?: string | null, variant_pack_group_item_count: number, variant_pack_id: string, variant_pack_group_data?: { __typename?: 'ExpandedVariantPackGroupData', uuid: string, display_image_url?: string | null } | null, variant_pack_data?: { __typename?: 'ExpandedVariantPackData', uuid: string, external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: Array<string> | null, item?: { __typename?: 'ExpandedItemData', uuid: string, category?: string | null, description?: string | null, display_name?: string | null, extra_keywords?: string | null, photo_url_list?: Array<string> | null, restaurant_item_overrides: Array<{ __typename?: 'ExpandedRestaurantItemOverrideData', uuid: string, display_name?: string | null, category?: string | null }> } | null, pack?: { __typename?: 'ExpandedPackData', uuid: string, base_unit?: string | null, max_unit_size?: number | null, min_unit_size?: number | null, unit?: string | null, unit_count?: number | null } | null, modifier_options: Array<{ __typename?: 'ExpandedVariantPackModifierOptionData', modifier_option: { __typename?: 'ExpandedModifierOptionData', uuid: string, name?: string | null, sort_order?: number | null, modifier_option_group?: { __typename?: 'ExpandedModifierOptionGroupData', uuid: string, name?: string | null, sort_order?: number | null } | null } }>, variant_pack_group_memberships?: Array<{ __typename?: 'ExpandedVariantPackGroupMembershipData', uuid: string, variant_pack_group_uuid: string }> | null, gtin_metadata?: Array<{ __typename?: 'ExpandedGtinMetadataData', uuid: string, gtin?: string | null, metadata?: any | null }> | null } | null, salt_data?: { __typename?: 'ExpandedSaltItemInfo', name?: string | null, description?: string | null, image_urls?: Array<string> | null } | null };

export type Catalog_VariantPackGroupItemsExpandedQueryVariables = Exact<{
  itemLimit: Scalars['Int']['input'];
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  includeSalt: Scalars['Boolean']['input'];
  variantPackGroupUUIDs?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  includeNullGroupItems?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type Catalog_VariantPackGroupItemsExpandedQuery = { __typename?: 'query_root', getSupplierVariantPackGroupItemsExpanded: Array<{ __typename?: 'GetSupplierVariantPackGroupItemExpandedResponse', variant_pack_group_id?: string | null, variant_pack_group_display_name?: string | null, variant_pack_group_item_count: number, variant_pack_id: string, variant_pack_group_data?: { __typename?: 'ExpandedVariantPackGroupData', uuid: string, display_image_url?: string | null } | null, variant_pack_data?: { __typename?: 'ExpandedVariantPackData', uuid: string, external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: Array<string> | null, item?: { __typename?: 'ExpandedItemData', uuid: string, category?: string | null, description?: string | null, display_name?: string | null, extra_keywords?: string | null, photo_url_list?: Array<string> | null, restaurant_item_overrides: Array<{ __typename?: 'ExpandedRestaurantItemOverrideData', uuid: string, display_name?: string | null, category?: string | null }> } | null, pack?: { __typename?: 'ExpandedPackData', uuid: string, base_unit?: string | null, max_unit_size?: number | null, min_unit_size?: number | null, unit?: string | null, unit_count?: number | null } | null, modifier_options: Array<{ __typename?: 'ExpandedVariantPackModifierOptionData', modifier_option: { __typename?: 'ExpandedModifierOptionData', uuid: string, name?: string | null, sort_order?: number | null, modifier_option_group?: { __typename?: 'ExpandedModifierOptionGroupData', uuid: string, name?: string | null, sort_order?: number | null } | null } }>, variant_pack_group_memberships?: Array<{ __typename?: 'ExpandedVariantPackGroupMembershipData', uuid: string, variant_pack_group_uuid: string }> | null, gtin_metadata?: Array<{ __typename?: 'ExpandedGtinMetadataData', uuid: string, gtin?: string | null, metadata?: any | null }> | null } | null, salt_data?: { __typename?: 'ExpandedSaltItemInfo', name?: string | null, description?: string | null, image_urls?: Array<string> | null } | null }> };

export type Catalog_VariantPackGroupsQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Catalog_VariantPackGroupsQuery = { __typename?: 'query_root', getSupplierCatalogVariantPackGroups: Array<{ __typename?: 'GetSupplierCatalogVariantPackGroupResponse', variant_pack_group_id?: string | null, variant_pack_group_display_name?: string | null, variant_pack_group_item_count: number, variant_pack_group_display_image_url?: string | null }> };

export type CatalogCategoryList_GtinFiltersResponseFragment = { __typename?: 'GetGTINFiltersForCategoryResponse', flag_filters: Array<GtinFilterAvailabilityFlags>, list_filters: { __typename?: 'GTINFilterListFilters', brand_names: Array<string>, free_from_allergens: Array<string>, origin_countries: Array<string>, pack_sizes: Array<string>, subcategories: Array<string> } };

export type GetVisibleVariantPacksByVariantPackGroupsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<Visible_Variant_Packs_Order_By> | Visible_Variant_Packs_Order_By;
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  skipCount: Scalars['Boolean']['input'];
  skipFilters: Scalars['Boolean']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  variantPackGroupUUID?: InputMaybe<Scalars['uuid']['input']>;
  where: Visible_Variant_Packs_Bool_Exp;
}>;


export type GetVisibleVariantPacksByVariantPackGroupsQuery = { __typename?: 'query_root', visible_variant_packs_aggregate?: { __typename?: 'visible_variant_packs_aggregate', aggregate?: { __typename?: 'visible_variant_packs_aggregate_fields', count: number } | null }, visible_variant_packs: Array<{ __typename?: 'visible_variant_packs', variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }>, getGtinFiltersForGroup?: { __typename?: 'GetGTINFiltersForCategoryResponse', flag_filters: Array<GtinFilterAvailabilityFlags>, list_filters: { __typename?: 'GTINFilterListFilters', brand_names: Array<string>, free_from_allergens: Array<string>, origin_countries: Array<string>, pack_sizes: Array<string>, subcategories: Array<string> } } };

export type CatalogCategoryList_VariantPacksQueryVariables = Exact<{
  categoryName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<Visible_Variant_Packs_Order_By> | Visible_Variant_Packs_Order_By;
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  skipCount: Scalars['Boolean']['input'];
  skipFilters: Scalars['Boolean']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  where: Visible_Variant_Packs_Bool_Exp;
}>;


export type CatalogCategoryList_VariantPacksQuery = { __typename?: 'query_root', visible_variant_packs_aggregate?: { __typename?: 'visible_variant_packs_aggregate', aggregate?: { __typename?: 'visible_variant_packs_aggregate_fields', count: number } | null }, visible_variant_packs: Array<{ __typename?: 'visible_variant_packs', variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }>, getGtinFiltersForCategory?: { __typename?: 'GetGTINFiltersForCategoryResponse', flag_filters: Array<GtinFilterAvailabilityFlags>, list_filters: { __typename?: 'GTINFilterListFilters', brand_names: Array<string>, free_from_allergens: Array<string>, origin_countries: Array<string>, pack_sizes: Array<string>, subcategories: Array<string> } } };

export type SetSmartOrderReviewDurationMutationVariables = Exact<{
  orderUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  reviewDurationSeconds: Scalars['numeric']['input'];
}>;


export type SetSmartOrderReviewDurationMutation = { __typename?: 'mutation_root', update_smart_order?: { __typename?: 'smart_order_mutation_response', returning: Array<{ __typename?: 'smart_order', uuid: string }> } | null };

export type CreditRequest_CreateCreditRequestMutationVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
  creditRequestBatchLineItems: Array<CreditRequestBatchLineItemInput> | CreditRequestBatchLineItemInput;
}>;


export type CreditRequest_CreateCreditRequestMutation = { __typename?: 'mutation_root', createCreditRequest: { __typename?: 'CreateCreditRequestBatchResponse', alerts: Array<{ __typename?: 'CreditRequestAlert', alert_level: AlertLevel, alert_message: string }>, credit_request_batch?: { __typename?: 'credit_request_batches', uuid: string } | null } };

export type CustomerGroupListFieldsFragment = { __typename?: 'restaurant_groups', uuid: string, name: string };

export type RestaurantSelect_RestaurantGroupsQueryVariables = Exact<{
  ownerUUID: Scalars['uuid']['input'];
}>;


export type RestaurantSelect_RestaurantGroupsQuery = { __typename?: 'query_root', restaurant_groups: Array<{ __typename?: 'restaurant_groups', uuid: string, name: string }> };

export type Account_InviteRestaurantEmployeeMutationVariables = Exact<{
  name: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID?: InputMaybe<Scalars['uuid']['input']>;
  contactInfo: ContactInfoInput;
  role: Scalars['String']['input'];
}>;


export type Account_InviteRestaurantEmployeeMutation = { __typename?: 'mutation_root', inviteRestaurantEmployee: { __typename?: 'InviteRestaurantEmployeeResponse', employee_id: string, is_duplicate_employee?: boolean | null, pepper_url: string, whitelabel_android_url?: string | null, whitelabel_ios_url?: string | null, whitelabel_universal_url?: string | null } };

export type BrandPageCarouselFieldsFragment = { __typename?: 'brand_pages', brand_name: string, carousel_module?: any | null, logo_image_url?: string | null, uuid: string };

export type BrandsCarouselQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type BrandsCarouselQuery = { __typename?: 'query_root', getBrandsCarousel: Array<{ __typename?: 'GetBrandsCarouselResponse', brand_page?: { __typename?: 'brand_pages', brand_name: string, carousel_module?: any | null, logo_image_url?: string | null, uuid: string } | null }> };

export type Orders_CreditRequestBatchLineItemFieldsFragment = { __typename?: 'credit_request_batch_line_items', pack_price_in_micros: number, quantity: number, uuid: string };

export type Orders_CreditRequestBatchFieldsFragment = { __typename?: 'credit_request_batches', created_at: string, customer_facing_id: string, uuid: string, credit_request_batch_line_items: Array<{ __typename?: 'credit_request_batch_line_items', pack_price_in_micros: number, quantity: number, uuid: string }> };

export type Orders_CreditRequestBatchesQueryVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type Orders_CreditRequestBatchesQuery = { __typename?: 'query_root', credit_request_batches: Array<{ __typename?: 'credit_request_batches', created_at: string, customer_facing_id: string, uuid: string, credit_request_batch_line_items: Array<{ __typename?: 'credit_request_batch_line_items', pack_price_in_micros: number, quantity: number, uuid: string }> }>, credit_request_batches_aggregate: { __typename?: 'credit_request_batches_aggregate', aggregate?: { __typename?: 'credit_request_batches_aggregate_fields', count: number } | null } };

export type OrderInvoiceFieldsFragment = { __typename?: 'order_invoices', invoice_date: string, invoice_number?: string | null, seen: boolean, uuid: string, order_invoice_check_in?: { __typename?: 'order_invoice_check_ins', completed_at?: string | null, uuid: string } | null, order_invoice_line_items: Array<{ __typename?: 'order_invoice_line_items', item_code: string, item_name?: string | null, ship_erp_unit_of_measure: string, ship_quantity: number, unit_price_in_micros: number, unit_tax_in_micros?: number | null, uuid: string, variant_pack_uuid?: string | null }> };

export type OrderHistory_InvoicesQueryVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skipCount: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type OrderHistory_InvoicesQuery = { __typename?: 'query_root', order_invoices_aggregate?: { __typename?: 'order_invoices_aggregate', aggregate?: { __typename?: 'order_invoices_aggregate_fields', count: number } | null }, order_invoices: Array<{ __typename?: 'order_invoices', invoice_date: string, invoice_number?: string | null, seen: boolean, uuid: string, order_invoice_check_in?: { __typename?: 'order_invoice_check_ins', completed_at?: string | null, uuid: string } | null, order_invoice_line_items: Array<{ __typename?: 'order_invoice_line_items', item_code: string, item_name?: string | null, ship_erp_unit_of_measure: string, ship_quantity: number, unit_price_in_micros: number, unit_tax_in_micros?: number | null, uuid: string, variant_pack_uuid?: string | null }> }> };

export type ItemDetail_DemoVariantPacksQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPackUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type ItemDetail_DemoVariantPacksQuery = { __typename?: 'query_root', visible_variant_packs: Array<{ __typename?: 'visible_variant_packs', variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> };

export type ViewInvoiceMutationVariables = Exact<{
  orderInvoiceUUID: Scalars['uuid']['input'];
}>;


export type ViewInvoiceMutation = { __typename?: 'mutation_root', update_order_invoices_by_pk?: { __typename?: 'order_invoices', seen: boolean, uuid: string } | null };

export type OrderGuide_RestaurantAddressQueryQueryVariables = Exact<{
  orderGuideCollectionUUID: Scalars['uuid']['input'];
  employeeUUID: Scalars['uuid']['input'];
}>;


export type OrderGuide_RestaurantAddressQueryQuery = { __typename?: 'query_root', getOrderGuidePriceQuoteKey: { __typename?: 'PriceQuoteByOrderGuideResponse', public_url?: string | null } };

export type OrderGuide_ExportPriceQuoteDetailsCsvQueryVariables = Exact<{
  priceQuoteKey: Scalars['String']['input'];
}>;


export type OrderGuide_ExportPriceQuoteDetailsCsvQuery = { __typename?: 'query_root', getPriceQuoteDetails: { __typename?: 'PriceQuoteDetailsResponse', price_quote_document_url: string, supplier_accent_color: string, supplier_app_icon_image_url: string, supplier_name: string } };

export type PaymentHistoryListFieldsFragment = { __typename?: 'payment_batches', created_at: string, customer_facing_id: string, link_paid_at?: string | null, status: string, uuid: string, payment_batch_amount?: { __typename?: 'payment_batch_amount', charged_amount_in_micros?: number | null, payment_batch_uuid?: string | null } | null };

export type Payments_GetPaymentHistoryListQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  where: Payment_Batches_Bool_Exp;
}>;


export type Payments_GetPaymentHistoryListQuery = { __typename?: 'query_root', payment_batches: Array<{ __typename?: 'payment_batches', created_at: string, customer_facing_id: string, link_paid_at?: string | null, status: string, uuid: string, payment_batch_amount?: { __typename?: 'payment_batch_amount', charged_amount_in_micros?: number | null, payment_batch_uuid?: string | null } | null }>, payment_batches_aggregate: { __typename?: 'payment_batches_aggregate', aggregate?: { __typename?: 'payment_batches_aggregate_fields', count: number } | null } };

export type GetPaymentPlanNextRunQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type GetPaymentPlanNextRunQuery = { __typename?: 'query_root', getPaymentPlanNextRunDate: Array<{ __typename?: 'GetPaymentPlanNextRunDateResponse', estimated_end_date: string, next_run_date: string, payment_plan?: { __typename?: 'payment_plans', installment_amount_in_micros: number, start_date: any, total_amount_in_micros: number, uuid: string, task_frequency_settings: { __typename?: 'task_frequency_settings', frequency: any }, supplier: { __typename?: 'businesses', name: string, uuid: string } } | null }> };

export type Plaid_GetPlaidSessionInfoQueryVariables = Exact<{
  sessionToken: Scalars['String']['input'];
}>;


export type Plaid_GetPlaidSessionInfoQuery = { __typename?: 'query_root', plaidGetSessionInfo: { __typename?: 'PlaidGetSessionInfoResponse', alert_level?: AlertLevel | null, alert_message?: string | null, link_token?: string | null, restaurant_id?: string | null, supplier_id?: string | null, user_id?: string | null } };

export type GetPriceTrendsDataWithCustomerGroupsQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
  variantPackUUID: Scalars['uuid']['input'];
  restaurantGroupUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetPriceTrendsDataWithCustomerGroupsQuery = { __typename?: 'query_root', getPriceTrendsDataWithCustomerGroups: { __typename?: 'GetPriceTrendsWithCustomerGroupsDataResponse', median_price_l7: number, median_price_l30: number, median_price_l90: number, median_price_yoy: number, median_gp_l7: number, median_gp_l30: number, median_gp_l90: number, median_gp_yoy: number, last_price_yoy?: number | null, last_gp_yoy?: number | null, gp_occurrences_l7: Array<{ __typename?: 'GrossProfitTrendsDataPoint', occurrences: number, gross_profit: number }>, gp_occurrences_l30: Array<{ __typename?: 'GrossProfitTrendsDataPoint', occurrences: number, gross_profit: number }>, gp_occurrences_l90: Array<{ __typename?: 'GrossProfitTrendsDataPoint', occurrences: number, gross_profit: number }>, gp_occurrences_yoy: Array<{ __typename?: 'GrossProfitTrendsDataPoint', occurrences: number, gross_profit: number }>, price_occurrences_l7: Array<{ __typename?: 'PriceTrendsDataPoint', price: number, occurrences: number }>, price_occurrences_l30: Array<{ __typename?: 'PriceTrendsDataPoint', occurrences: number, price: number }>, price_occurrences_l90: Array<{ __typename?: 'PriceTrendsDataPoint', occurrences: number, price: number }>, price_occurrences_yoy: Array<{ __typename?: 'PriceTrendsDataPoint', occurrences: number, price: number }> } };

export type VolumePromotionsContext_GetPromotionsForRestaurantQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type VolumePromotionsContext_GetPromotionsForRestaurantQuery = { __typename?: 'query_root', getPromotionsForRestaurant: Array<{ __typename?: 'GetPromotionForRestaurantResponse', promotion?: { __typename?: 'promotions', background_color_end: string, background_color_start: string, background_image_url?: string | null, discount_type: string, expires_at?: string | null, hide_marketing_tile: boolean, hide_tagline: boolean, marketing_text?: string | null, photo_url_list?: any | null, starts_at: string, tagline?: string | null, uuid: string, supplier: { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', timezone: string, uuid: string } } } | null, promotion_effect?: { __typename?: 'promotion_effects', metadata: any, promotion_component_group_uuid: string, uuid: string } | null, promotion_qualification?: { __typename?: 'promotion_qualifications', metadata: any, promotion_component_group_uuid: string, uuid: string } | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> };

export type VolumePromotionsContext_VolumePromotionFieldsFragment = { __typename?: 'promotions', background_color_end: string, background_color_start: string, background_image_url?: string | null, discount_type: string, expires_at?: string | null, hide_marketing_tile: boolean, hide_tagline: boolean, marketing_text?: string | null, photo_url_list?: any | null, starts_at: string, tagline?: string | null, uuid: string, supplier: { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', timezone: string, uuid: string } } };

export type VolumePromotionsContext_PromotionEffectFieldsFragment = { __typename?: 'promotion_effects', metadata: any, promotion_component_group_uuid: string, uuid: string };

export type VolumePromotionsContext_PromotionQualificationFieldsFragment = { __typename?: 'promotion_qualifications', metadata: any, promotion_component_group_uuid: string, uuid: string };

export type SmartOrderResponseFieldsFragment = { __typename?: 'GetSmartOrderResponse', quantity: number, search_term: string, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null };

export type Order_SmartOrderQueryVariables = Exact<{
  isRestrictedSearch: Scalars['Boolean']['input'];
  locale: Scalars['String']['input'];
  requestedItems: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Order_SmartOrderQuery = { __typename?: 'query_root', getSmartOrderResults: Array<{ __typename?: 'GetSmartOrderResponse', quantity: number, search_term: string, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> };

export type GetExternalContentUrlForRestaurantQueryVariables = Exact<{
  externalContentID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
}>;


export type GetExternalContentUrlForRestaurantQuery = { __typename?: 'query_root', getExternalContentUrlForRestaurant: { __typename?: 'GetExternalContentUrlForRestaurantResponse', url: string } };

export type Ftni_UpdateFtniPaymentMutationVariables = Exact<{
  orderInvoiceUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  userUUID: Scalars['uuid']['input'];
}>;


export type Ftni_UpdateFtniPaymentMutation = { __typename?: 'mutation_root', updateFtniPayment: { __typename?: 'SuccessResponse', success: boolean } };

export type Plaid_CreatePlaidSessionMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Plaid_CreatePlaidSessionMutation = { __typename?: 'mutation_root', plaidCreateSession: { __typename?: 'PlaidCreateSessionResponse', alert_level?: AlertLevel | null, alert_message?: string | null, session_token?: string | null } };

export type CustomerGroups_ListQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
}>;


export type CustomerGroups_ListQuery = { __typename?: 'query_root', restaurant_groups: Array<{ __typename?: 'restaurant_groups', name: string, uuid: string, restaurant_group_members: Array<{ __typename?: 'restaurant_group_members', restaurant_uuid: string, uuid: string }> }> };

export type Loyalty_GetEnrollmentDetailsQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  userUUID: Scalars['uuid']['input'];
}>;


export type Loyalty_GetEnrollmentDetailsQuery = { __typename?: 'query_root', businesses: Array<{ __typename?: 'businesses', uuid: string, supplier_loyalty_programs: Array<{ __typename?: 'supplier_loyalty_programs', permissions: any, uuid: string, loyalty_program: { __typename?: 'loyalty_programs', uuid: string, banner_image_url?: string | null, banner_text?: string | null, enrollment_completion_text?: string | null, enrollment_form_config: any, loyalty_program_terms: Array<{ __typename?: 'loyalty_program_terms', acceptance_disclaimer?: string | null, summary?: string | null, terms_url: string, uuid: string, version: string }> }, supplier_loyalty_program_restaurants: Array<{ __typename?: 'supplier_loyalty_program_restaurants', enrollment_form_responses?: any | null, restaurant_uuid: string, status: string, uuid: string, loyalty_terms_acceptance_logs: Array<{ __typename?: 'loyalty_terms_acceptance_log', loyalty_program_terms_uuid: string, uuid: string }>, supplier_loyalty_program_restaurant_users: Array<{ __typename?: 'supplier_loyalty_program_restaurant_users', role: string, uuid: string }> }> }> }> };

export type OrderGuide_CreatePartitionItemMutationVariables = Exact<{
  locale: Scalars['String']['input'];
  partitionUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPackUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
}>;


export type OrderGuide_CreatePartitionItemMutation = { __typename?: 'mutation_root', createOrderGuidePartitionItem: { __typename?: 'OrderGuideItemEntryResponse', order_guide_item_id: string, order_guide_item_partition_id?: string | null, order_guide_restaurant_partition?: { __typename?: 'order_guide_restaurant_partition', uuid: string, order_guide_restaurant_collection: { __typename?: 'order_guide_restaurant_collection', is_default: boolean, linked_order_guide_supplier_collection_uuid?: string | null, name?: string | null, sort_order?: number | null, uuid: string, order_guide_restaurant_partitions: Array<{ __typename?: 'order_guide_restaurant_partition', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string }> } } | null, order_guide_restaurant?: { __typename?: 'order_guide_restaurant', is_minimized: boolean, memo?: string | null, notes?: string | null, order_guide_restaurant_partition_uuid: string, par_level?: number | null, persist_memo: boolean, persist_notes: boolean, persist_request: boolean, request?: string | null, sort_order?: number | null, uuid: string } | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } };

export type OrderGuide_DeletePartitionItemMutationVariables = Exact<{
  partitionUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPackUUID: Scalars['uuid']['input'];
}>;


export type OrderGuide_DeletePartitionItemMutation = { __typename?: 'mutation_root', deleteOrderGuidePartitionItem: { __typename?: 'SuccessResponse', success: boolean } };

export type OrderGuide_UpdateOrderGuideItemDispositionsMutationVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  orderGuideItems: Array<UpdateOrderGuideItemDispositionsItemInput> | UpdateOrderGuideItemDispositionsItemInput;
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
}>;


export type OrderGuide_UpdateOrderGuideItemDispositionsMutation = { __typename?: 'mutation_root', updateOrderGuideItemDispositions: Array<{ __typename?: 'OrderGuideItemEntryResponse', order_guide_item_id: string, order_guide_item_partition_id?: string | null, order_guide_restaurant_partition?: { __typename?: 'order_guide_restaurant_partition', uuid: string, order_guide_restaurant_collection: { __typename?: 'order_guide_restaurant_collection', is_default: boolean, linked_order_guide_supplier_collection_uuid?: string | null, name?: string | null, sort_order?: number | null, uuid: string, order_guide_restaurant_partitions: Array<{ __typename?: 'order_guide_restaurant_partition', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string }> } } | null, order_guide_restaurant?: { __typename?: 'order_guide_restaurant', is_minimized: boolean, memo?: string | null, notes?: string | null, order_guide_restaurant_partition_uuid: string, par_level?: number | null, persist_memo: boolean, persist_notes: boolean, persist_request: boolean, request?: string | null, sort_order?: number | null, uuid: string } | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> };

export type OrderGuide_UpdateOrderGuideItemNotesMutationVariables = Exact<{
  locale: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  partitionUUID: Scalars['uuid']['input'];
  persistNotes?: InputMaybe<Scalars['Boolean']['input']>;
  isRequest?: InputMaybe<Scalars['Boolean']['input']>;
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPackUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
}>;


export type OrderGuide_UpdateOrderGuideItemNotesMutation = { __typename?: 'mutation_root', updateOrderGuideItemNotes: { __typename?: 'OrderGuideItemEntryResponse', order_guide_item_id: string, order_guide_item_partition_id?: string | null, order_guide_restaurant_partition?: { __typename?: 'order_guide_restaurant_partition', uuid: string, order_guide_restaurant_collection: { __typename?: 'order_guide_restaurant_collection', is_default: boolean, linked_order_guide_supplier_collection_uuid?: string | null, name?: string | null, sort_order?: number | null, uuid: string, order_guide_restaurant_partitions: Array<{ __typename?: 'order_guide_restaurant_partition', is_default: boolean, name?: string | null, sort_order?: number | null, uuid: string }> } } | null, order_guide_restaurant?: { __typename?: 'order_guide_restaurant', is_minimized: boolean, memo?: string | null, notes?: string | null, order_guide_restaurant_partition_uuid: string, par_level?: number | null, persist_memo: boolean, persist_notes: boolean, persist_request: boolean, request?: string | null, sort_order?: number | null, uuid: string } | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } };

export type OrderGuide_UpdateEssentialItemsMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  addedVariantPackUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  removedVariantPackUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  skipAddMutation: Scalars['Boolean']['input'];
  skipRemoveMutation: Scalars['Boolean']['input'];
}>;


export type OrderGuide_UpdateEssentialItemsMutation = { __typename?: 'mutation_root', createCriticalItems?: Array<{ __typename?: 'VariantPackResponse', variant_pack_id: string }>, deleteCriticalItems?: { __typename?: 'SuccessResponse', success: boolean } };

export type LeadGenerator_NearbyBusinessesQueryVariables = Exact<{
  categories?: InputMaybe<Scalars['String']['input']>;
  isCurrentRestaurant?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  supplierUUID: Scalars['uuid']['input'];
}>;


export type LeadGenerator_NearbyBusinessesQuery = { __typename?: 'query_root', getNearbyBusinessesV2: Array<{ __typename?: 'BusinessSearchResponse', business_display_address: string, business_name: string, categories?: Array<string> | null, distance?: number | null, image_url?: string | null, latitude: number, longitude: number, phone_number: string, restaurant_uuid?: string | null, yelp_business_id: string }>, businesses_by_pk?: { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', country_code: string, uuid: string } } | null };

export type NewOrder_CreateOrderMutationVariables = Exact<{
  createdSource?: InputMaybe<OrderSource>;
  orderDomain?: InputMaybe<OrderDomain>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
  timeslotEnd?: InputMaybe<Scalars['String']['input']>;
  timeslotStart?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
}>;


export type NewOrder_CreateOrderMutation = { __typename?: 'mutation_root', createOrder: { __typename?: 'OrderResponse', order?: { __typename?: 'orders', additional_input_values?: any | null, fulfillment_timeslot_end?: string | null, fulfillment_timeslot_start?: string | null, fulfillment_type: string, notes?: string | null, order_domain?: string | null, placed_at?: string | null, po_number?: string | null, restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_fulfillment_fees: Array<{ __typename?: 'order_fulfillment_fees', amount_in_micros?: number | null, fulfillment_settings_name?: string | null, uuid?: string | null }>, order_invoices: Array<{ __typename?: 'order_invoices', balance_in_micros?: number | null, due_at?: string | null, invoice_date: string, invoice_number?: string | null, order_uuid?: string | null, uuid: string }>, orders_items: Array<{ __typename?: 'orders_items', earliest_fulfillment_at?: string | null, notes?: string | null, restaurant_display_name: string, uuid: string, order_item_prices?: { __typename?: 'order_item_prices', pack_quantity_at_order?: number | null } | null, variants_pack: { __typename?: 'variants_packs', metadata?: any | null, uuid: string, item: { __typename?: 'items', description?: string | null, uuid: string } } }>, storefront_metadata?: { __typename?: 'storefront_order_metadata', name?: string | null, uuid: string, visibility: string } | null } | null } };

export type NewOrder_UpdateOrderMetadataMutationVariables = Exact<{
  orderUUID: Scalars['uuid']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
}>;


export type NewOrder_UpdateOrderMetadataMutation = { __typename?: 'mutation_root', updateOrderMetadata: { __typename?: 'OrderMetadataResponse', storefront_order_metadata?: { __typename?: 'storefront_order_metadata', name?: string | null, uuid: string, visibility: string } | null } };

export type NewOrder_UpdateOrderNotesMutationVariables = Exact<{
  orderUUID: Scalars['uuid']['input'];
  orderNotes?: InputMaybe<Scalars['String']['input']>;
}>;


export type NewOrder_UpdateOrderNotesMutation = { __typename?: 'mutation_root', updateOrderInputs: { __typename?: 'OrderResponse', order?: { __typename?: 'orders', notes?: string | null, uuid: string } | null } };

export type NewOrder_UpdateOrderPoNumberMutationVariables = Exact<{
  orderUUID: Scalars['uuid']['input'];
  poNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type NewOrder_UpdateOrderPoNumberMutation = { __typename?: 'mutation_root', updateOrderInputs: { __typename?: 'OrderResponse', order?: { __typename?: 'orders', po_number?: string | null, uuid: string } | null } };

export type NewOrder_UpdateOrderAdditionalInputsMutationVariables = Exact<{
  orderUUID: Scalars['uuid']['input'];
  additionalInputValues?: InputMaybe<Array<AdditionalInputValueInput> | AdditionalInputValueInput>;
}>;


export type NewOrder_UpdateOrderAdditionalInputsMutation = { __typename?: 'mutation_root', updateOrderInputs: { __typename?: 'OrderResponse', order?: { __typename?: 'orders', additional_input_values?: any | null, uuid: string } | null } };

export type NewOrder_DeleteOrderMutationVariables = Exact<{
  orderUUID: Scalars['uuid']['input'];
}>;


export type NewOrder_DeleteOrderMutation = { __typename?: 'mutation_root', deleteOrder: { __typename?: 'SuccessResponse', success: boolean } };

export type NewOrder_PunchoutOrderMessageFieldsFragment = { __typename?: 'PunchoutOrderMessage', order_message_url: string, order_message_xml: string };

export type NewOrder_SubmitOrderMutationVariables = Exact<{
  orderUUID: Scalars['uuid']['input'];
  orderNotes?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  punchoutCookie?: InputMaybe<Scalars['String']['input']>;
  additionalInputValues: Array<AdditionalInputValueInput> | AdditionalInputValueInput;
  smartOrderUUID?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type NewOrder_SubmitOrderMutation = { __typename?: 'mutation_root', submitOrder: { __typename?: 'SubmitOrderResponse', split_order_id_list?: Array<string> | null, loyalty_earns?: Array<{ __typename?: 'SubmitOrderLoyaltyEarn', order_id: string, programs: Array<{ __typename?: 'SubmitOrderLoyaltyProgramEarn', earned_points: number, program_id: string, program_name: string }> }> | null, order?: { __typename?: 'orders', additional_input_values?: any | null, fulfillment_timeslot_end?: string | null, fulfillment_timeslot_start?: string | null, fulfillment_type: string, notes?: string | null, order_domain?: string | null, placed_at?: string | null, po_number?: string | null, restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_fulfillment_fees: Array<{ __typename?: 'order_fulfillment_fees', amount_in_micros?: number | null, fulfillment_settings_name?: string | null, uuid?: string | null }>, order_invoices: Array<{ __typename?: 'order_invoices', balance_in_micros?: number | null, due_at?: string | null, invoice_date: string, invoice_number?: string | null, order_uuid?: string | null, uuid: string }>, orders_items: Array<{ __typename?: 'orders_items', earliest_fulfillment_at?: string | null, notes?: string | null, restaurant_display_name: string, uuid: string, order_item_prices?: { __typename?: 'order_item_prices', pack_quantity_at_order?: number | null } | null, variants_pack: { __typename?: 'variants_packs', metadata?: any | null, uuid: string, item: { __typename?: 'items', description?: string | null, uuid: string } } }>, storefront_metadata?: { __typename?: 'storefront_order_metadata', name?: string | null, uuid: string, visibility: string } | null } | null, punchout_order_message?: { __typename?: 'PunchoutOrderMessage', order_message_url: string, order_message_xml: string } | null } };

export type NewOrder_UpdateCartMutationVariables = Exact<{
  orderUUID: Scalars['uuid']['input'];
  updatedItems: Array<UpdateItemInput> | UpdateItemInput;
}>;


export type NewOrder_UpdateCartMutation = { __typename?: 'mutation_root', updateCart: { __typename?: 'MaybeOrderResponse', order?: { __typename?: 'orders', additional_input_values?: any | null, fulfillment_timeslot_end?: string | null, fulfillment_timeslot_start?: string | null, fulfillment_type: string, notes?: string | null, order_domain?: string | null, placed_at?: string | null, po_number?: string | null, restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_fulfillment_fees: Array<{ __typename?: 'order_fulfillment_fees', amount_in_micros?: number | null, fulfillment_settings_name?: string | null, uuid?: string | null }>, order_invoices: Array<{ __typename?: 'order_invoices', balance_in_micros?: number | null, due_at?: string | null, invoice_date: string, invoice_number?: string | null, order_uuid?: string | null, uuid: string }>, orders_items: Array<{ __typename?: 'orders_items', earliest_fulfillment_at?: string | null, notes?: string | null, restaurant_display_name: string, uuid: string, order_item_prices?: { __typename?: 'order_item_prices', pack_quantity_at_order?: number | null } | null, variants_pack: { __typename?: 'variants_packs', metadata?: any | null, uuid: string, item: { __typename?: 'items', description?: string | null, uuid: string } } }>, storefront_metadata?: { __typename?: 'storefront_order_metadata', name?: string | null, uuid: string, visibility: string } | null } | null } };

export type NewOrder_ClearCartMutationVariables = Exact<{
  orderUUID: Scalars['uuid']['input'];
}>;


export type NewOrder_ClearCartMutation = { __typename?: 'mutation_root', clearCart: { __typename?: 'SuccessResponse', success: boolean } };

export type Notifications_OrderInReviewQueryVariables = Exact<{
  orderUUID: Scalars['uuid']['input'];
}>;


export type Notifications_OrderInReviewQuery = { __typename?: 'query_root', orders_by_pk?: { __typename?: 'orders', status: string, uuid: string } | null };

export type GetItemsOfInterestQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  fromDate: Scalars['String']['input'];
}>;


export type GetItemsOfInterestQuery = { __typename?: 'query_root', getObiItems: { __typename?: 'GetObiItemsResponse', obi_items: Array<{ __typename?: 'ObiItem', variant_pack_uuid: string, title: string, obi_item_type: ObiItemType, event_time: string, subtitle: { __typename?: 'CompleteTranslation', en: string, es: string, fr: string, zh: string }, variant_pack?: { __typename?: 'variants_packs', uuid: string, item: { __typename?: 'items', photo_url_list?: any | null, uuid: string } } | null }> } };

export type OrderSummary_GetOrderPdfQueryVariables = Exact<{
  orderUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  showItemDescriptions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrderSummary_GetOrderPdfQuery = { __typename?: 'query_root', getOrderPdf: { __typename?: 'UrlResponse', url: string } };

export type OrderGuide_GetParSheetPdfQueryVariables = Exact<{
  collectionUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  sortOrder?: InputMaybe<OrderGuideSortOrder>;
}>;


export type OrderGuide_GetParSheetPdfQuery = { __typename?: 'query_root', getParSheetPdf: { __typename?: 'UrlResponse', url: string } };

export type OrderHistoryListOrderFieldsFragment = { __typename?: 'orders', restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, created_source: string, fulfillment_type: string, chat: { __typename?: 'chats', display_item_prices?: boolean | null, uuid: string }, orders_items: Array<{ __typename?: 'orders_items', notes?: string | null, uuid: string, order_item_prices?: { __typename?: 'order_item_prices', currency_code?: string | null, pack_quantity_at_invoice?: number | null, pack_quantity_at_order?: number | null, tax_at_order_micros?: number | null, unit_discount_price_at_order_micros?: number | null, unit_price_at_invoice_micros?: number | null, unit_price_at_order_micros?: number | null } | null, pack: { __typename?: 'packs', unit_count: number, uuid: string }, pricing_pack?: { __typename?: 'packs', unit_count: number, uuid: string } | null }>, order_invoices: Array<{ __typename?: 'order_invoices', invoice_number?: string | null, seen: boolean, uuid: string, order_invoice_check_in?: { __typename?: 'order_invoice_check_ins', completed_at?: string | null, uuid: string } | null, order_invoice_line_items: Array<{ __typename?: 'order_invoice_line_items', item_code: string, item_name?: string | null, ship_erp_unit_of_measure: string, ship_quantity: number, unit_price_in_micros: number, unit_tax_in_micros?: number | null, uuid: string, variant_pack_uuid?: string | null }> }>, order_invoices_orders: Array<{ __typename?: 'order_invoices_orders', uuid: string, order_invoice: { __typename?: 'order_invoices', invoice_number?: string | null, seen: boolean, uuid: string, order_invoice_check_in?: { __typename?: 'order_invoice_check_ins', completed_at?: string | null, uuid: string } | null, order_invoice_line_items: Array<{ __typename?: 'order_invoice_line_items', item_code: string, item_name?: string | null, ship_erp_unit_of_measure: string, ship_quantity: number, unit_price_in_micros: number, unit_tax_in_micros?: number | null, uuid: string, variant_pack_uuid?: string | null }> } }>, supplier: { __typename?: 'businesses', uuid: string, supplier_metadata?: { __typename?: 'supplier_metadata', display_item_prices: boolean, uuid: string } | null }, order_items_with_exception: { __typename?: 'orders_items_aggregate', aggregate?: { __typename?: 'orders_items_aggregate_fields', count: number } | null }, order_tracking?: { __typename?: 'order_tracking', lower_bound_delivery_datetime?: string | null, order_completed_delivery_datetime?: string | null, status: string, upper_bound_delivery_datetime?: string | null, uuid: string } | null };

export type OrderHistoryListOrderFeesFieldsFragment = { __typename?: 'OrderFee', amount_at_invoice_micros?: number | null, amount_at_order_micros?: number | null, display_type: OrderFeeDisplayType, name: string };

export type OrderHistoryListOrderWithFeesFieldsFragment = { __typename?: 'OrderWithFees', order?: { __typename?: 'orders', restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, created_source: string, fulfillment_type: string, chat: { __typename?: 'chats', display_item_prices?: boolean | null, uuid: string }, orders_items: Array<{ __typename?: 'orders_items', notes?: string | null, uuid: string, order_item_prices?: { __typename?: 'order_item_prices', currency_code?: string | null, pack_quantity_at_invoice?: number | null, pack_quantity_at_order?: number | null, tax_at_order_micros?: number | null, unit_discount_price_at_order_micros?: number | null, unit_price_at_invoice_micros?: number | null, unit_price_at_order_micros?: number | null } | null, pack: { __typename?: 'packs', unit_count: number, uuid: string }, pricing_pack?: { __typename?: 'packs', unit_count: number, uuid: string } | null }>, order_invoices: Array<{ __typename?: 'order_invoices', invoice_number?: string | null, seen: boolean, uuid: string, order_invoice_check_in?: { __typename?: 'order_invoice_check_ins', completed_at?: string | null, uuid: string } | null, order_invoice_line_items: Array<{ __typename?: 'order_invoice_line_items', item_code: string, item_name?: string | null, ship_erp_unit_of_measure: string, ship_quantity: number, unit_price_in_micros: number, unit_tax_in_micros?: number | null, uuid: string, variant_pack_uuid?: string | null }> }>, order_invoices_orders: Array<{ __typename?: 'order_invoices_orders', uuid: string, order_invoice: { __typename?: 'order_invoices', invoice_number?: string | null, seen: boolean, uuid: string, order_invoice_check_in?: { __typename?: 'order_invoice_check_ins', completed_at?: string | null, uuid: string } | null, order_invoice_line_items: Array<{ __typename?: 'order_invoice_line_items', item_code: string, item_name?: string | null, ship_erp_unit_of_measure: string, ship_quantity: number, unit_price_in_micros: number, unit_tax_in_micros?: number | null, uuid: string, variant_pack_uuid?: string | null }> } }>, supplier: { __typename?: 'businesses', uuid: string, supplier_metadata?: { __typename?: 'supplier_metadata', display_item_prices: boolean, uuid: string } | null }, order_items_with_exception: { __typename?: 'orders_items_aggregate', aggregate?: { __typename?: 'orders_items_aggregate_fields', count: number } | null }, order_tracking?: { __typename?: 'order_tracking', lower_bound_delivery_datetime?: string | null, order_completed_delivery_datetime?: string | null, status: string, upper_bound_delivery_datetime?: string | null, uuid: string } | null } | null, order_fees: Array<{ __typename?: 'OrderFee', amount_at_invoice_micros?: number | null, amount_at_order_micros?: number | null, display_type: OrderFeeDisplayType, name: string }> };

export type OrderHistory_SearchOrdersQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters: Array<SearchOrderHistoryFilterInput> | SearchOrderHistoryFilterInput;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  restaurantUUID?: InputMaybe<Scalars['uuid']['input']>;
  supplierUUID: Scalars['uuid']['input'];
}>;


export type OrderHistory_SearchOrdersQuery = { __typename?: 'query_root', searchOrderHistory: { __typename?: 'SearchOrderHistoryResponse', cursor?: string | null, orders: Array<{ __typename?: 'OrderWithFees', order?: { __typename?: 'orders', restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, created_source: string, fulfillment_type: string, chat: { __typename?: 'chats', display_item_prices?: boolean | null, uuid: string }, orders_items: Array<{ __typename?: 'orders_items', notes?: string | null, uuid: string, order_item_prices?: { __typename?: 'order_item_prices', currency_code?: string | null, pack_quantity_at_invoice?: number | null, pack_quantity_at_order?: number | null, tax_at_order_micros?: number | null, unit_discount_price_at_order_micros?: number | null, unit_price_at_invoice_micros?: number | null, unit_price_at_order_micros?: number | null } | null, pack: { __typename?: 'packs', unit_count: number, uuid: string }, pricing_pack?: { __typename?: 'packs', unit_count: number, uuid: string } | null }>, order_invoices: Array<{ __typename?: 'order_invoices', invoice_number?: string | null, seen: boolean, uuid: string, order_invoice_check_in?: { __typename?: 'order_invoice_check_ins', completed_at?: string | null, uuid: string } | null, order_invoice_line_items: Array<{ __typename?: 'order_invoice_line_items', item_code: string, item_name?: string | null, ship_erp_unit_of_measure: string, ship_quantity: number, unit_price_in_micros: number, unit_tax_in_micros?: number | null, uuid: string, variant_pack_uuid?: string | null }> }>, order_invoices_orders: Array<{ __typename?: 'order_invoices_orders', uuid: string, order_invoice: { __typename?: 'order_invoices', invoice_number?: string | null, seen: boolean, uuid: string, order_invoice_check_in?: { __typename?: 'order_invoice_check_ins', completed_at?: string | null, uuid: string } | null, order_invoice_line_items: Array<{ __typename?: 'order_invoice_line_items', item_code: string, item_name?: string | null, ship_erp_unit_of_measure: string, ship_quantity: number, unit_price_in_micros: number, unit_tax_in_micros?: number | null, uuid: string, variant_pack_uuid?: string | null }> } }>, supplier: { __typename?: 'businesses', uuid: string, supplier_metadata?: { __typename?: 'supplier_metadata', display_item_prices: boolean, uuid: string } | null }, order_items_with_exception: { __typename?: 'orders_items_aggregate', aggregate?: { __typename?: 'orders_items_aggregate_fields', count: number } | null }, order_tracking?: { __typename?: 'order_tracking', lower_bound_delivery_datetime?: string | null, order_completed_delivery_datetime?: string | null, status: string, upper_bound_delivery_datetime?: string | null, uuid: string } | null } | null, order_fees: Array<{ __typename?: 'OrderFee', amount_at_invoice_micros?: number | null, amount_at_order_micros?: number | null, display_type: OrderFeeDisplayType, name: string }> }> } };

export type OrderHistory_OrdersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skipCount: Scalars['Boolean']['input'];
  where: Orders_Bool_Exp;
}>;


export type OrderHistory_OrdersQuery = { __typename?: 'query_root', orders_aggregate?: { __typename?: 'orders_aggregate', aggregate?: { __typename?: 'orders_aggregate_fields', count: number } | null }, orders: Array<{ __typename?: 'orders', restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, created_source: string, fulfillment_type: string, order_fees: Array<{ __typename?: 'order_fees', amount_at_invoice_micros?: number | null, amount_at_order_micros?: number | null, display_type?: string | null, name?: string | null, uuid?: string | null }>, chat: { __typename?: 'chats', display_item_prices?: boolean | null, uuid: string }, orders_items: Array<{ __typename?: 'orders_items', notes?: string | null, uuid: string, order_item_prices?: { __typename?: 'order_item_prices', currency_code?: string | null, pack_quantity_at_invoice?: number | null, pack_quantity_at_order?: number | null, tax_at_order_micros?: number | null, unit_discount_price_at_order_micros?: number | null, unit_price_at_invoice_micros?: number | null, unit_price_at_order_micros?: number | null } | null, pack: { __typename?: 'packs', unit_count: number, uuid: string }, pricing_pack?: { __typename?: 'packs', unit_count: number, uuid: string } | null }>, order_invoices: Array<{ __typename?: 'order_invoices', invoice_number?: string | null, seen: boolean, uuid: string, order_invoice_check_in?: { __typename?: 'order_invoice_check_ins', completed_at?: string | null, uuid: string } | null, order_invoice_line_items: Array<{ __typename?: 'order_invoice_line_items', item_code: string, item_name?: string | null, ship_erp_unit_of_measure: string, ship_quantity: number, unit_price_in_micros: number, unit_tax_in_micros?: number | null, uuid: string, variant_pack_uuid?: string | null }> }>, order_invoices_orders: Array<{ __typename?: 'order_invoices_orders', uuid: string, order_invoice: { __typename?: 'order_invoices', invoice_number?: string | null, seen: boolean, uuid: string, order_invoice_check_in?: { __typename?: 'order_invoice_check_ins', completed_at?: string | null, uuid: string } | null, order_invoice_line_items: Array<{ __typename?: 'order_invoice_line_items', item_code: string, item_name?: string | null, ship_erp_unit_of_measure: string, ship_quantity: number, unit_price_in_micros: number, unit_tax_in_micros?: number | null, uuid: string, variant_pack_uuid?: string | null }> } }>, supplier: { __typename?: 'businesses', uuid: string, supplier_metadata?: { __typename?: 'supplier_metadata', display_item_prices: boolean, uuid: string } | null }, order_items_with_exception: { __typename?: 'orders_items_aggregate', aggregate?: { __typename?: 'orders_items_aggregate_fields', count: number } | null }, order_tracking?: { __typename?: 'order_tracking', lower_bound_delivery_datetime?: string | null, order_completed_delivery_datetime?: string | null, status: string, upper_bound_delivery_datetime?: string | null, uuid: string } | null }> };

export type PaginatedCrmActivitiesByChatIdQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  chatUUID: Scalars['uuid']['input'];
}>;


export type PaginatedCrmActivitiesByChatIdQuery = { __typename?: 'query_root', crm_activities: Array<{ __typename?: 'crm_activities', created_at: string, uuid: string, employee?: { __typename?: 'employees', name: string, uuid: string } | null, crm_activity_notes?: { __typename?: 'crm_activity_notes', content: string, uuid: string } | null, crm_activity_reminders: Array<{ __typename?: 'crm_activity_reminders', uuid: string, remind_at: string }> }>, crm_activities_aggregate: { __typename?: 'crm_activities_aggregate', aggregate?: { __typename?: 'crm_activities_aggregate_fields', count: number } | null } };

export type SalesRep_UpdateGrossProfitPercentMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPacks: Array<SalesRepUpdateVariantPackGrossProfitInput> | SalesRepUpdateVariantPackGrossProfitInput;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type SalesRep_UpdateGrossProfitPercentMutation = { __typename?: 'mutation_root', updateSalesRepGrossProfitPercentageOverrides: Array<{ __typename?: 'GetVariantPackInfoResponse', availability_status?: string | null, available_quantity?: number | null, currency_code: string, default_price_in_micros?: number | null, list_item_display_text?: string | null, manufacturer_suggested_retail_price_in_micros?: number | null, price_in_micros?: number | null, sales_rep_price_in_micros?: number | null, sales_rep_gross_profit_in_percentage?: number | null, suggested_retail_price_in_micros?: number | null, variant_pack_id: string, unit_count: number, cost_info?: { __typename?: 'VariantPackCostInfoResponse', details?: Array<{ __typename?: 'VariantPackDetailedCostInfoResponse', cost_in_micros: number, type: VariantPackCostType }> | null } | null, inventory_info?: { __typename?: 'VariantPackInventoryInfoResponse', quantity_on_hand?: number | null, incoming?: Array<{ __typename?: 'VariantPackIncomingInventoryResponse', date: string, quantity: number }> | null } | null, sales_rep_metadata?: { __typename?: 'VariantPackSalesRepMetadataResponse', price_ceiling_in_micros?: number | null, updated_by_name?: string | null } | null }> };

export type SalesRep_UpdatePriceMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPacks: Array<SalesRepUpdateVariantPackInput> | SalesRepUpdateVariantPackInput;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type SalesRep_UpdatePriceMutation = { __typename?: 'mutation_root', updateSalesRepPrice: Array<{ __typename?: 'GetVariantPackInfoResponse', availability_status?: string | null, available_quantity?: number | null, currency_code: string, default_price_in_micros?: number | null, list_item_display_text?: string | null, manufacturer_suggested_retail_price_in_micros?: number | null, price_in_micros?: number | null, sales_rep_price_in_micros?: number | null, sales_rep_gross_profit_in_percentage?: number | null, suggested_retail_price_in_micros?: number | null, variant_pack_id: string, unit_count: number, cost_info?: { __typename?: 'VariantPackCostInfoResponse', details?: Array<{ __typename?: 'VariantPackDetailedCostInfoResponse', cost_in_micros: number, type: VariantPackCostType }> | null } | null, inventory_info?: { __typename?: 'VariantPackInventoryInfoResponse', quantity_on_hand?: number | null, incoming?: Array<{ __typename?: 'VariantPackIncomingInventoryResponse', date: string, quantity: number }> | null } | null, sales_rep_metadata?: { __typename?: 'VariantPackSalesRepMetadataResponse', price_ceiling_in_micros?: number | null, updated_by_name?: string | null } | null }> };

export type RecoverLoginMutationVariables = Exact<{
  accountID?: InputMaybe<Scalars['String']['input']>;
  businessAddress?: InputMaybe<Scalars['String']['input']>;
  businessName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecoverLoginMutation = { __typename?: 'mutation_root', recoverLogin: { __typename?: 'SuccessResponse', success: boolean } };

export type SmartOrder_RegenerateMutationVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  smartOrderUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SmartOrder_RegenerateMutation = { __typename?: 'mutation_root', regenerateSmartOrders: Array<{ __typename?: 'RegenerateSmartOrdersResponse', smart_order?: { __typename?: 'smart_order', uuid: string, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null, smart_order_results: Array<{ __typename?: 'smart_order_result', quantity: number, search_term: string, uuid: string, variant_pack: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } }> } | null }> };

export type RestaurantEmployeeFragment = { __typename?: 'GetRestaurantEmployeesResponse', chat_employee_id: string, employee_contact_email?: string | null, employee_contact_phone_number: string, employee_contact_protected: boolean, employee_id: string, employee_login_email?: string | null, employee_name: string, employee_status: EmployeeStatus, restaurant_employee_id: string, restaurant_employee_role: EmployeeRole, show_app_payments_tab: boolean };

export type Restaurant_EmployeesQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  where?: InputMaybe<Businesses_Employees_Bool_Exp>;
}>;


export type Restaurant_EmployeesQuery = { __typename?: 'query_root', getRestaurantEmployees: Array<{ __typename?: 'GetRestaurantEmployeesResponse', chat_employee_id: string, employee_contact_email?: string | null, employee_contact_phone_number: string, employee_contact_protected: boolean, employee_id: string, employee_login_email?: string | null, employee_name: string, employee_status: EmployeeStatus, restaurant_employee_id: string, restaurant_employee_role: EmployeeRole, show_app_payments_tab: boolean }> };

export type TotalSales_GetSalesAnalyticsDataQueryVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
  startTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
}>;


export type TotalSales_GetSalesAnalyticsDataQuery = { __typename?: 'query_root', getSalesAnalyticsData: { __typename?: 'GetSalesDataAnalyticsResponse', avg_order_size: number, total_orders: number, total_sales_in_micros: number, total_sales_percent_over_period?: number | null, total_sales_data: Array<{ __typename?: 'TotalSalesByDay', date: string, total_sales_amount_in_micros: number }> } };

export type NotificationToken_SaveMutationVariables = Exact<{
  deviceIdentifier: Scalars['String']['input'];
  notificationToken: Scalars['String']['input'];
  businessOrganizationUUID?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type NotificationToken_SaveMutation = { __typename?: 'mutation_root', insert_notification_tokens_one?: { __typename?: 'notification_tokens', uuid: string } | null };

export type ScannerScreen_SearchQueryVariables = Exact<{
  code: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type ScannerScreen_SearchQuery = { __typename?: 'query_root', searchVariantPacksByUpc: Array<{ __typename?: 'SearchVariantPacksResponse', variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> };

export type SearchCatalog_VariantPackFieldsFragment = { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> };

export type SearchCatalog_SearchFilterFieldsFragment = { __typename?: 'SearchFilterResponse', display_strategy: string, type: string, name: { __typename?: 'TranslatedValue', original_value: string, translated_value: string }, values?: Array<{ __typename?: 'TranslatedValue', original_value: string, translated_value: string }> | null };

export type SearchSupplierCatalog_ItemsQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  query: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPackGroupUUID?: InputMaybe<Scalars['uuid']['input']>;
  searchSortOrder?: InputMaybe<SearchSortOrder>;
  availabilityFulfillmentDate?: InputMaybe<Scalars['String']['input']>;
  fulfillmentDate?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<SearchFilterInput> | SearchFilterInput>;
  includeOrderCounts?: InputMaybe<Scalars['Boolean']['input']>;
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchSupplierCatalog_ItemsQuery = { __typename?: 'query_root', searchVariantPacks: Array<{ __typename?: 'VariantPackWithAvailabilityResponse', available_quantity?: number | null, total_count?: number | null, next_offset?: number | null, filters?: Array<{ __typename?: 'SearchFilterResponse', display_strategy: string, type: string, name: { __typename?: 'TranslatedValue', original_value: string, translated_value: string }, values?: Array<{ __typename?: 'TranslatedValue', original_value: string, translated_value: string }> | null }> | null, paid_search_event_data?: { __typename?: 'PaidSearchEventData', ad_campaign_id: string, ad_manager_id: string, add_to_cart_event_id: string, advertiser_id: string, click_event_id: string, impression_event_id: string, gtin: string, matching_keyword: string, purchase_event_id: string, variant_pack_id: string } | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null, variant_pack_order_counts?: Array<{ __typename?: 'VariantPackOrderCount', days: number, order_count: number }> | null }> };

export type SearchPublicSupplierCatalog_ItemsQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  query: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  filters?: InputMaybe<Array<SearchFilterInput> | SearchFilterInput>;
  supplierUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  variantPackGroupUUID?: InputMaybe<Scalars['uuid']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchPublicSupplierCatalog_ItemsQuery = { __typename?: 'query_root', searchPublicVariantPacks: Array<{ __typename?: 'VariantPackWithFiltersResponse', filters?: Array<{ __typename?: 'SearchFilterResponse', display_strategy: string, type: string, name: { __typename?: 'TranslatedValue', original_value: string, translated_value: string }, values?: Array<{ __typename?: 'TranslatedValue', original_value: string, translated_value: string }> | null }> | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> };

export type SetupAppMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SetupAppMutation = { __typename?: 'mutation_root', setupApp: { __typename?: 'SetupAppResponse', restaurant_id: string } };

export type Auth_UserLogoutMutationVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
}>;


export type Auth_UserLogoutMutation = { __typename?: 'mutation_root', restaurantEmployeeLogout: { __typename?: 'EmployeeResponse', employee_id: string } };

export type UnreadSmartOrdersQueryVariables = Exact<{
  where: Smart_Order_Bool_Exp;
}>;


export type UnreadSmartOrdersQuery = { __typename?: 'query_root', smart_order_aggregate: { __typename?: 'smart_order_aggregate', aggregate?: { __typename?: 'smart_order_aggregate_fields', count: number } | null } };

export type MarkSmartOrderAsReadMutationVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  orderUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type MarkSmartOrderAsReadMutation = { __typename?: 'mutation_root', update_smart_order?: { __typename?: 'smart_order_mutation_response', returning: Array<{ __typename?: 'smart_order', status: string, updated_at: string, uuid: string }> } | null };

export type Loyalty_SubmitEnrollmentFormMutationVariables = Exact<{
  supplierLoyaltyProgramRestaurantUUID: Scalars['uuid']['input'];
  responses: Array<LoyaltyEnrollmentFormResponseInput> | LoyaltyEnrollmentFormResponseInput;
}>;


export type Loyalty_SubmitEnrollmentFormMutation = { __typename?: 'mutation_root', submitLoyaltyEnrollmentForm: { __typename?: 'SubmitLoyaltyEnrollmentFormResponse', alert_level?: AlertLevel | null, alert_message?: string | null, error_code?: LoyaltyProgramErrorCode | null, supplier_loyalty_program_restaurant_id?: string | null } };

export type Loyalty_SubmitTermsDecisionMutationVariables = Exact<{
  supplierLoyaltyProgramRestaurantUUID: Scalars['uuid']['input'];
  loyaltyProgramTermsUUID: Scalars['uuid']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  isAccepted: Scalars['Boolean']['input'];
}>;


export type Loyalty_SubmitTermsDecisionMutation = { __typename?: 'mutation_root', submitLoyaltyProgramTermsDecision: { __typename?: 'SubmitLoyaltyProgramTermsDecisionResponse', alert_level?: AlertLevel | null, alert_message?: string | null, error_code?: LoyaltyProgramErrorCode | null, supplier_loyalty_program_restaurant_id?: string | null } };

export type SubmitProspectiveCustomerMutationVariables = Exact<{
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  contactPhoneNumber: Scalars['String']['input'];
  restaurantAddress: Scalars['String']['input'];
  restaurantName: Scalars['String']['input'];
}>;


export type SubmitProspectiveCustomerMutation = { __typename?: 'mutation_root', submitProspectiveCustomer: { __typename?: 'SuccessResponse', success: boolean } };

export type SampleRequest_FollowUpSubmitMutationVariables = Exact<{
  followUpResponse?: InputMaybe<FollowUpResponse>;
  restaurantUUID: Scalars['uuid']['input'];
  sampleRequestUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SampleRequest_FollowUpSubmitMutation = { __typename?: 'mutation_root', submitSampleRequestFollowUp: { __typename?: 'RequestASampleResponse', sample_request?: { __typename?: 'sample_requests', contact_email?: string | null, follow_up_response?: any | null, follow_up_submitted_at?: string | null, qualified_at?: string | null, requested_at: string, status: string, uuid: string, address?: { __typename?: 'addresses', address: string, address2?: string | null, city: string, country_code: string, latitude: number, longitude: number, region?: string | null, uuid: string } | null, requested_by: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', name?: string | null, uuid: string }> } } | null } };

export type GetSupplierAddressCountryCodeQueryVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
}>;


export type GetSupplierAddressCountryCodeQuery = { __typename?: 'query_root', businesses_by_pk?: { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', country_code: string, uuid: string } } | null };

export type ChatSupplier_SupplierEmployeesQueryVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
}>;


export type ChatSupplier_SupplierEmployeesQuery = { __typename?: 'query_root', chats_by_pk?: { __typename?: 'chats', uuid: string, supplier: { __typename?: 'businesses', uuid: string, businesses_employees: Array<{ __typename?: 'businesses_employees', employee_uuid: string, uuid: string }> } } | null };

export type Supplier_DeactivateRestaurantMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Supplier_DeactivateRestaurantMutation = { __typename?: 'mutation_root', supplierDeactivateRestaurant: { __typename?: 'SuccessResponse', success: boolean } };

export type SyncUserData_UpdateEmployeeMutationVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  userUUID: Scalars['uuid']['input'];
  set?: InputMaybe<Employees_Set_Input>;
}>;


export type SyncUserData_UpdateEmployeeMutation = { __typename?: 'mutation_root', update_employees_by_pk?: { __typename?: 'employees', locale: string, name: string, uuid: string, contact_info: { __typename?: 'employee_contact_info', email?: string | null, login_email?: string | null, phone_number: string, uuid: string }, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', supplier_uuid: string, contact_emails: any, contact_phone_numbers: any, name?: string | null, uuid: string }> } | null };

export type UseTransactionFees_SupplierChatsQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type UseTransactionFees_SupplierChatsQuery = { __typename?: 'query_root', businesses_by_pk?: { __typename?: 'businesses', uuid: string, supplier_chats: Array<{ __typename?: 'chats', flat_transaction_fees: any, transaction_fees: any, uuid: string }>, supplier_metadata?: { __typename?: 'supplier_metadata', flat_transaction_fees?: any | null, gross_up_transaction_fees_cutoff?: string | null, transaction_fees: any, uuid: string } | null } | null };

export type UniversalLink_GetAppLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type UniversalLink_GetAppLinkQuery = { __typename?: 'query_root', getUniversalAppLink: { __typename?: 'GetUniversalAppLinkResponse', url?: string | null } };

export type NewOrder_UpdateFulfillmentMutationVariables = Exact<{
  orderUUID: Scalars['uuid']['input'];
  set: Orders_Set_Input;
  unplacedOrderStatuses: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type NewOrder_UpdateFulfillmentMutation = { __typename?: 'mutation_root', update_orders?: { __typename?: 'orders_mutation_response', returning: Array<{ __typename?: 'orders', fulfillment_type: string, restaurant_desired_delivery_time?: string | null, fulfillment_timeslot_start?: string | null, fulfillment_timeslot_end?: string | null, uuid: string }> } | null };

export type ValidateOrderLoyaltyFieldsFragment = { __typename?: 'ValidateOrderLoyalty', can_enroll: boolean, enrollment_status: string, estimated_points: number, program_id: string, program_name: string, supplier_loyalty_program_restaurant_id: string, items: Array<{ __typename?: 'ValidateOrderLoyaltyItem', estimated_points: number, order_item_id: string }> };

export type ValidateOrderFieldsFragment = { __typename?: 'orders', discount_codes?: any | null, fulfillment_timeslot_end?: string | null, fulfillment_timeslot_start?: string | null, fulfillment_type: string, restaurant_desired_delivery_time?: string | null, status: string, uuid: string, orders_items: Array<{ __typename?: 'orders_items', earliest_fulfillment_at?: string | null, notes?: string | null, restaurant_display_name: string, substitution?: any | null, uuid: string, order_item_promotion_rels: Array<{ __typename?: 'order_item_promotion_rel', discount_in_micros?: number | null, uuid: string, promotion: { __typename?: 'promotions', discount_type: string, expires_at?: string | null, tagline?: string | null, background_color_start: string, background_color_end: string, marketing_text?: string | null, uuid: string } }>, orders_items_modifier_options: Array<{ __typename?: 'orders_items_modifier_options', name: string, uuid: string }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, pricing_pack?: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string } | null, variants_pack: { __typename?: 'variants_packs', external_item_id?: string | null, metadata?: any | null, prebook_config?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', metadata: any, uuid: string }> | null, item: { __typename?: 'items', description?: string | null, photo_url_list?: any | null, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, brandInformation: { __typename?: 'BrandInformationType', brandName?: string | null, manufacturer?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, categories: Array<{ __typename?: 'CategoryType', level?: string | null, name?: string | null, type?: string | null }>, dietaryInformation: { __typename?: 'DietaryInformationType', ingredients: Array<string>, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, allergens: Array<{ __typename?: 'AllergenType', containmentLevel?: string | null, name?: string | null }>, dietTypes: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, nutrients: Array<{ __typename?: 'NutrientType', amount?: string | null, name?: string | null, percentDv?: string | null, unitName?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }> }, packagingAndStorage: { __typename?: 'PackagingAndStorageType', packaging: { __typename?: 'PackType', grossWeight?: string | null, netWeight?: string | null, packHeight?: string | null, packLength?: string | null, packWidth?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, storage: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, servingAndPreparation: { __typename?: 'ServingAndPreparationType', serving: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, preparation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> } }, order_item_prices?: { __typename?: 'order_item_prices', currency_code?: string | null, pack_quantity_at_invoice?: number | null, pack_quantity_at_order?: number | null, tax_at_order_micros?: number | null, unit_discount_price_at_order_micros?: number | null, unit_price_at_invoice_micros?: number | null, unit_price_at_order_micros?: number | null } | null }>, order_promotion_rels: Array<{ __typename?: 'order_promotion_rel', discount_in_micros?: number | null, uuid: string, promotion: { __typename?: 'promotions', background_color_start: string, background_color_end: string, marketing_text?: string | null, uuid: string } }>, supplier: { __typename?: 'businesses', uuid: string, supplier_metadata?: { __typename?: 'supplier_metadata', lead_time_split_behavior: string, uuid: string } | null } };

export type OrderSummary_ValidateOrderMutationVariables = Exact<{
  locale: Scalars['String']['input'];
  orderUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  ordersItemsOrderBy: Array<Orders_Items_Order_By> | Orders_Items_Order_By;
  smartOrderUUID?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type OrderSummary_ValidateOrderMutation = { __typename?: 'mutation_root', validateOrder: { __typename?: 'ValidateOrderResponse', can_place_order: boolean, missing_essential_item_ids?: Array<string> | null, translated_fulfillment_display_name?: string | null, alerts?: Array<{ __typename?: 'ValidateOrderAlert', alert_code?: string | null, alert_level: AlertLevel, alert_message: string, order_fulfillment_date?: string | null }> | null, loyalty?: Array<{ __typename?: 'ValidateOrderLoyalty', can_enroll: boolean, enrollment_status: string, estimated_points: number, program_id: string, program_name: string, supplier_loyalty_program_restaurant_id: string, items: Array<{ __typename?: 'ValidateOrderLoyaltyItem', estimated_points: number, order_item_id: string }> }> | null, order?: { __typename?: 'orders', discount_codes?: any | null, fulfillment_timeslot_end?: string | null, fulfillment_timeslot_start?: string | null, fulfillment_type: string, restaurant_desired_delivery_time?: string | null, status: string, uuid: string, orders_items: Array<{ __typename?: 'orders_items', earliest_fulfillment_at?: string | null, notes?: string | null, restaurant_display_name: string, substitution?: any | null, uuid: string, order_item_promotion_rels: Array<{ __typename?: 'order_item_promotion_rel', discount_in_micros?: number | null, uuid: string, promotion: { __typename?: 'promotions', discount_type: string, expires_at?: string | null, tagline?: string | null, background_color_start: string, background_color_end: string, marketing_text?: string | null, uuid: string } }>, orders_items_modifier_options: Array<{ __typename?: 'orders_items_modifier_options', name: string, uuid: string }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, pricing_pack?: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string } | null, variants_pack: { __typename?: 'variants_packs', external_item_id?: string | null, metadata?: any | null, prebook_config?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', metadata: any, uuid: string }> | null, item: { __typename?: 'items', description?: string | null, photo_url_list?: any | null, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, brandInformation: { __typename?: 'BrandInformationType', brandName?: string | null, manufacturer?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, categories: Array<{ __typename?: 'CategoryType', level?: string | null, name?: string | null, type?: string | null }>, dietaryInformation: { __typename?: 'DietaryInformationType', ingredients: Array<string>, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, allergens: Array<{ __typename?: 'AllergenType', containmentLevel?: string | null, name?: string | null }>, dietTypes: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, nutrients: Array<{ __typename?: 'NutrientType', amount?: string | null, name?: string | null, percentDv?: string | null, unitName?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }> }, packagingAndStorage: { __typename?: 'PackagingAndStorageType', packaging: { __typename?: 'PackType', grossWeight?: string | null, netWeight?: string | null, packHeight?: string | null, packLength?: string | null, packWidth?: string | null, additionalInformation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, storage: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, servingAndPreparation: { __typename?: 'ServingAndPreparationType', serving: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, preparation: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> } }, order_item_prices?: { __typename?: 'order_item_prices', currency_code?: string | null, pack_quantity_at_invoice?: number | null, pack_quantity_at_order?: number | null, tax_at_order_micros?: number | null, unit_discount_price_at_order_micros?: number | null, unit_price_at_invoice_micros?: number | null, unit_price_at_order_micros?: number | null } | null }>, order_promotion_rels: Array<{ __typename?: 'order_promotion_rel', discount_in_micros?: number | null, uuid: string, promotion: { __typename?: 'promotions', background_color_start: string, background_color_end: string, marketing_text?: string | null, uuid: string } }>, supplier: { __typename?: 'businesses', uuid: string, supplier_metadata?: { __typename?: 'supplier_metadata', lead_time_split_behavior: string, uuid: string } | null } } | null, order_fees: Array<{ __typename?: 'OrderFee', amount_at_invoice_micros?: number | null, amount_at_order_micros?: number | null, display_type: OrderFeeDisplayType, name: string }>, order_minimum?: { __typename?: 'OrderMinimum', amount: number, is_hard: boolean, unit: OrderConstraintUnit } | null, section_headers?: Array<{ __typename?: 'SectionHeader', header_text: string, order_fulfillment_date?: string | null }> | null } };

export type VariantPackInfoContext_GetGroupsQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type VariantPackInfoContext_GetGroupsQuery = { __typename?: 'query_root', getVariantPackGroups: Array<{ __typename?: 'GetVariantPackGroupsResponse', translated_display_name: string, variant_pack_group_id: string, variant_pack_group?: { __typename?: 'variant_pack_groups', type?: string | null, uuid: string, badge_variant_pack_group_rels: Array<{ __typename?: 'badge_variant_pack_group_rel', uuid: string, badge: { __typename?: 'badges', background_color?: string | null, name: string, uuid: string, image_url: string, short_name?: string | null, sort_order: number } }>, variant_pack_group_members: Array<{ __typename?: 'variant_pack_group_members', is_direct_member_group?: boolean | null, member_variant_pack_group_uuid?: string | null, uuid: string }> } | null }> };

export type VariantPackInfoContext_GroupBadgeFieldsFragment = { __typename?: 'badges', background_color?: string | null, name: string, uuid: string, image_url: string, short_name?: string | null, sort_order: number };

export type BrandPageFieldsFragment = { __typename?: 'brand_pages', brand_name: string, logo_image_url?: string | null, storefront_module?: any | null, uuid: string };

export type BrandPageVariantPacksFieldsFragment = { __typename?: 'GetBrandPageVariantPacksResponse', collection_title?: string | null, brand_page?: { __typename?: 'brand_pages', brand_name: string, logo_image_url?: string | null, storefront_module?: any | null, uuid: string } | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null };

export type BrandPageVariantPacksQueryVariables = Exact<{
  brandPageUUID: Scalars['uuid']['input'];
  fulfillmentDate?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type BrandPageVariantPacksQuery = { __typename?: 'query_root', getBrandPageVariantPacks: Array<{ __typename?: 'GetBrandPageVariantPacksResponse', collection_title?: string | null, brand_page?: { __typename?: 'brand_pages', brand_name: string, logo_image_url?: string | null, storefront_module?: any | null, uuid: string } | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> };

export type ChatDetails_AddMessageMutationVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
  mediaContentURL?: InputMaybe<Scalars['String']['input']>;
  textContent?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChatDetails_AddMessageMutation = { __typename?: 'mutation_root', addMessageToChatFromRestaurantEmployee: { __typename?: 'MessageResponse', message?: { __typename?: 'messages', media_content_url?: string | null, sent_at: string, sent_by_name?: string | null, sent_by_uuid: string, text_content?: string | null, type: string, uuid: string, order_invoice?: { __typename?: 'order_invoices', invoice_number?: string | null, uuid: string, order?: { __typename?: 'orders', customer_facing_id: string, uuid: string } | null } | null, order_status_update?: { __typename?: 'order_status_updates', status: string, uuid: string, order: { __typename?: 'orders', customer_facing_id: string, fulfillment_type: string, uuid: string } } | null, credit_request_batches_messages: Array<{ __typename?: 'credit_request_batches_messages', uuid: string, credit_request_batch: { __typename?: 'credit_request_batches', uuid: string } }> } | null } };

export type ChatDetails_SendChatbotMessageMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  sessionID?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
}>;


export type ChatDetails_SendChatbotMessageMutation = { __typename?: 'mutation_root', sendChatbotMessage: { __typename?: 'SendChatbotMessageResponse', session_id: string, messages: Array<{ __typename?: 'ChatbotMessage', id: string, text: string, timestamp: string }> } };

export type ChatDetails_GetChatbotMessagesQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  sessionID: Scalars['String']['input'];
}>;


export type ChatDetails_GetChatbotMessagesQuery = { __typename?: 'query_root', getChatbotMessages: { __typename?: 'GetChatbotMessageResponse', session_id: string, messages: Array<{ __typename?: 'ChatbotMessage', id: string, role: ChatbotMessageRole, text: string, timestamp: string }> } };

export type ChatsContext_MarkChatViewedMutationVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
  lastMessageTimestamp: Scalars['String']['input'];
}>;


export type ChatsContext_MarkChatViewedMutation = { __typename?: 'mutation_root', viewMessage: { __typename?: 'SuccessResponse', success: boolean } };

export type ChatsContext_UnreadCountSubscriptionVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  userUUID: Scalars['uuid']['input'];
}>;


export type ChatsContext_UnreadCountSubscription = { __typename?: 'subscription_root', chat_unread_message_count: Array<{ __typename?: 'chat_unread_message_count', chat_uuid?: string | null, unread_message_count?: number | null }> };

export type ChatDetails_ChatMessageOrderStatusUpdateFragment = { __typename?: 'order_status_updates', status: string, uuid: string, order: { __typename?: 'orders', customer_facing_id: string, fulfillment_type: string, uuid: string } };

export type ChatDetails_ChatMessageOrderInvoiceFragment = { __typename?: 'order_invoices', invoice_number?: string | null, uuid: string, order?: { __typename?: 'orders', customer_facing_id: string, uuid: string } | null };

export type ChatDetails_ChatMessageCreditRequestMessageFragment = { __typename?: 'credit_request_batches_messages', uuid: string, credit_request_batch: { __typename?: 'credit_request_batches', uuid: string } };

export type ChatDetails_ChatMessageFragment = { __typename?: 'messages', media_content_url?: string | null, sent_at: string, sent_by_name?: string | null, sent_by_uuid: string, text_content?: string | null, type: string, uuid: string, order_invoice?: { __typename?: 'order_invoices', invoice_number?: string | null, uuid: string, order?: { __typename?: 'orders', customer_facing_id: string, uuid: string } | null } | null, order_status_update?: { __typename?: 'order_status_updates', status: string, uuid: string, order: { __typename?: 'orders', customer_facing_id: string, fulfillment_type: string, uuid: string } } | null, credit_request_batches_messages: Array<{ __typename?: 'credit_request_batches_messages', uuid: string, credit_request_batch: { __typename?: 'credit_request_batches', uuid: string } }> };

export type ChatDetails_ChatMessageEdgeFragment = { __typename?: 'messagesEdge', cursor: string, node: { __typename?: 'messages', media_content_url?: string | null, sent_at: string, sent_by_name?: string | null, sent_by_uuid: string, text_content?: string | null, type: string, uuid: string, order_invoice?: { __typename?: 'order_invoices', invoice_number?: string | null, uuid: string, order?: { __typename?: 'orders', customer_facing_id: string, uuid: string } | null } | null, order_status_update?: { __typename?: 'order_status_updates', status: string, uuid: string, order: { __typename?: 'orders', customer_facing_id: string, fulfillment_type: string, uuid: string } } | null, credit_request_batches_messages: Array<{ __typename?: 'credit_request_batches_messages', uuid: string, credit_request_batch: { __typename?: 'credit_request_batches', uuid: string } }> } };

export type ChatDetails_ChatMessagesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  chatUUID: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChatDetails_ChatMessagesQuery = { __typename?: 'query_root', chats_connection: { __typename?: 'chatsConnection', edges: Array<{ __typename?: 'chatsEdge', node: { __typename?: 'chats', uuid: string, supplier: { __typename?: 'businesses', name: string, uuid: string } } }> }, messages_connection: { __typename?: 'messagesConnection', edges: Array<{ __typename?: 'messagesEdge', cursor: string, node: { __typename?: 'messages', media_content_url?: string | null, sent_at: string, sent_by_name?: string | null, sent_by_uuid: string, text_content?: string | null, type: string, uuid: string, order_invoice?: { __typename?: 'order_invoices', invoice_number?: string | null, uuid: string, order?: { __typename?: 'orders', customer_facing_id: string, uuid: string } | null } | null, order_status_update?: { __typename?: 'order_status_updates', status: string, uuid: string, order: { __typename?: 'orders', customer_facing_id: string, fulfillment_type: string, uuid: string } } | null, credit_request_batches_messages: Array<{ __typename?: 'credit_request_batches_messages', uuid: string, credit_request_batch: { __typename?: 'credit_request_batches', uuid: string } }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type ChatDetails_MessagesSubscriptionVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
  now: Scalars['timestamptz']['input'];
  userUUID: Scalars['uuid']['input'];
}>;


export type ChatDetails_MessagesSubscription = { __typename?: 'subscription_root', chat_last_message: Array<{ __typename?: 'chat_last_message', last_message_uuid?: string | null }> };

export type ChatDetails_NewChatMessagesQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  chatUUID: Scalars['uuid']['input'];
}>;


export type ChatDetails_NewChatMessagesQuery = { __typename?: 'query_root', messages_connection: { __typename?: 'messagesConnection', edges: Array<{ __typename?: 'messagesEdge', cursor: string, node: { __typename?: 'messages', media_content_url?: string | null, sent_at: string, sent_by_name?: string | null, sent_by_uuid: string, text_content?: string | null, type: string, uuid: string, order_invoice?: { __typename?: 'order_invoices', invoice_number?: string | null, uuid: string, order?: { __typename?: 'orders', customer_facing_id: string, uuid: string } | null } | null, order_status_update?: { __typename?: 'order_status_updates', status: string, uuid: string, order: { __typename?: 'orders', customer_facing_id: string, fulfillment_type: string, uuid: string } } | null, credit_request_batches_messages: Array<{ __typename?: 'credit_request_batches_messages', uuid: string, credit_request_batch: { __typename?: 'credit_request_batches', uuid: string } }> } }> } };

export type CreditMemoLineItemFieldsFragment = { __typename?: 'credit_memo_line_items', item_code?: string | null, item_name?: string | null, pack_unit?: string | null, quantity: number, unit_price_in_micros: number, uuid: string, orders_item?: { __typename?: 'orders_items', restaurant_display_name: string, uuid: string, orders_items_modifier_options: Array<{ __typename?: 'orders_items_modifier_options', name: string, uuid: string }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, variants_pack: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string }, order_item_prices?: { __typename?: 'order_item_prices', currency_code?: string | null, pack_quantity_at_invoice?: number | null, pack_quantity_at_order?: number | null, tax_at_order_micros?: number | null, unit_discount_price_at_order_micros?: number | null, unit_price_at_invoice_micros?: number | null, unit_price_at_order_micros?: number | null } | null, pricing_pack?: { __typename?: 'packs', unit_count: number, uuid: string } | null } | null, variants_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, item: { __typename?: 'items', name: string, uuid: string }, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string } } | null };

export type CreditMemo_GetCreditMemoByIdQueryVariables = Exact<{
  creditMemoUUID: Scalars['uuid']['input'];
}>;


export type CreditMemo_GetCreditMemoByIdQuery = { __typename?: 'query_root', getCreditMemoById: { __typename?: 'GetCreditMemoByIdResponse', public_url?: string | null, credit_memo?: { __typename?: 'credit_memos', balance_in_micros?: number | null, credit_date: string, credit_number?: string | null, uuid: string, credit_memo_line_items: Array<{ __typename?: 'credit_memo_line_items', item_code?: string | null, item_name?: string | null, pack_unit?: string | null, quantity: number, unit_price_in_micros: number, uuid: string, orders_item?: { __typename?: 'orders_items', restaurant_display_name: string, uuid: string, orders_items_modifier_options: Array<{ __typename?: 'orders_items_modifier_options', name: string, uuid: string }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, variants_pack: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string }, order_item_prices?: { __typename?: 'order_item_prices', currency_code?: string | null, pack_quantity_at_invoice?: number | null, pack_quantity_at_order?: number | null, tax_at_order_micros?: number | null, unit_discount_price_at_order_micros?: number | null, unit_price_at_invoice_micros?: number | null, unit_price_at_order_micros?: number | null } | null, pricing_pack?: { __typename?: 'packs', unit_count: number, uuid: string } | null } | null, variants_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, uuid: string, item: { __typename?: 'items', name: string, uuid: string }, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string } } | null }> } | null } };

export type Invoice_GetPdfUrlQueryVariables = Exact<{
  invoiceUUID: Scalars['uuid']['input'];
}>;


export type Invoice_GetPdfUrlQuery = { __typename?: 'query_root', getOrderInvoiceById: { __typename?: 'GetOrderInvoiceByIdResponse', public_url?: string | null, order_invoice?: { __typename?: 'order_invoices', document_url?: string | null, seen: boolean, uuid: string } | null } };

export type OrderInvoiceOrderFieldsFragment = { __typename?: 'orders', customer_facing_id: string, fulfillment_type: string, placed_at?: string | null, uuid: string, restaurant_desired_delivery_time?: string | null, supplier_accepted_delivery_time?: string | null, fulfillment_timeslot_end?: string | null, fulfillment_timeslot_start?: string | null, placed_by?: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', name?: string | null, uuid: string }> } | null, order_tracking?: { __typename?: 'order_tracking', order_completed_delivery_datetime?: string | null, uuid: string, lower_bound_delivery_datetime?: string | null, status: string, upper_bound_delivery_datetime?: string | null } | null };

export type Invoice_GetInvoiceByIdQueryVariables = Exact<{
  invoiceUUID: Scalars['uuid']['input'];
}>;


export type Invoice_GetInvoiceByIdQuery = { __typename?: 'query_root', getOrderInvoiceById: { __typename?: 'GetOrderInvoiceByIdResponse', public_url?: string | null, translated_order_fulfillment_display_name?: string | null, order_invoice?: { __typename?: 'order_invoices', chat_uuid?: string | null, document_url?: string | null, due_at?: string | null, erp_balance_in_micros?: number | null, invoice_date: string, invoice_number?: string | null, seen: boolean, uuid: string, order_invoice_check_in?: { __typename?: 'order_invoice_check_ins', completed_at?: string | null, uuid: string } | null, order_invoice_line_items: Array<{ __typename?: 'order_invoice_line_items', variant_pack_uuid?: string | null, item_code: string, item_name?: string | null, ship_erp_unit_of_measure: string, ship_quantity: number, unit_price_in_micros: number, unit_tax_in_micros?: number | null, uuid: string }>, order_invoice_status?: { __typename?: 'order_invoice_status', balance_in_micros?: number | null, use_pepper_balance: boolean, uuid: string } | null, payment_batch_line_items: Array<{ __typename?: 'payment_batch_line_items', amount_in_micros: number, uuid: string, payment_batch: { __typename?: 'payment_batches', status: string, uuid: string } }> } | null, order?: { __typename?: 'orders', customer_facing_id: string, fulfillment_type: string, placed_at?: string | null, uuid: string, restaurant_desired_delivery_time?: string | null, supplier_accepted_delivery_time?: string | null, fulfillment_timeslot_end?: string | null, fulfillment_timeslot_start?: string | null, placed_by?: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', name?: string | null, uuid: string }> } | null, order_tracking?: { __typename?: 'order_tracking', order_completed_delivery_datetime?: string | null, uuid: string, lower_bound_delivery_datetime?: string | null, status: string, upper_bound_delivery_datetime?: string | null } | null } | null } };

export type Locations_CreateAccountMutationVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  address: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  accountID?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  routeStop?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<RestaurantMetadataInput>;
  setAsProspect?: InputMaybe<Scalars['Boolean']['input']>;
  creationSourceFeature?: InputMaybe<CreationSourceFeatures>;
}>;


export type Locations_CreateAccountMutation = { __typename?: 'mutation_root', supplierCreateRestaurant: { __typename?: 'SupplierCreateOrUpdateRestaurantResponse', business?: { __typename?: 'businesses', name: string, uuid: string } | null } };

export type Locations_AccountRelationshipFieldsFragment = { __typename?: 'chats', restaurant_account_id?: string | null, restaurant_notes?: string | null, uuid: string, chat_route_metadata?: { __typename?: 'chats_route_metadata', name: string } | null, placed_orders: Array<{ __typename?: 'orders', restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_invoices: Array<{ __typename?: 'order_invoices', invoice_date: string, uuid: string }> }>, unplaced_orders: Array<{ __typename?: 'orders', restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_invoices: Array<{ __typename?: 'order_invoices', invoice_date: string, uuid: string }> }> };

export type Locations_AccountFieldsFragment = { __typename?: 'businesses', name: string, uuid: string, address: { __typename?: 'addresses', address: string, address2?: string | null, city: string, country_code: string, latitude: number, longitude: number, region?: string | null, uuid: string }, restaurant_chats: Array<{ __typename?: 'chats', restaurant_account_id?: string | null, restaurant_notes?: string | null, uuid: string, chat_route_metadata?: { __typename?: 'chats_route_metadata', name: string } | null, placed_orders: Array<{ __typename?: 'orders', restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_invoices: Array<{ __typename?: 'order_invoices', invoice_date: string, uuid: string }> }>, unplaced_orders: Array<{ __typename?: 'orders', restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_invoices: Array<{ __typename?: 'order_invoices', invoice_date: string, uuid: string }> }> }> };

export type Locations_EditRestaurantMutationVariables = Exact<{
  supplierUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  accountID?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  routeStop?: InputMaybe<Scalars['String']['input']>;
  unplacedOrderStatuses: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type Locations_EditRestaurantMutation = { __typename?: 'mutation_root', supplierUpdateRestaurant: { __typename?: 'SupplierCreateOrUpdateRestaurantResponse', business?: { __typename?: 'businesses', name: string, uuid: string, address: { __typename?: 'addresses', address: string, address2?: string | null, city: string, country_code: string, latitude: number, longitude: number, region?: string | null, uuid: string }, restaurant_chats: Array<{ __typename?: 'chats', restaurant_account_id?: string | null, restaurant_notes?: string | null, uuid: string, chat_route_metadata?: { __typename?: 'chats_route_metadata', name: string } | null, placed_orders: Array<{ __typename?: 'orders', restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_invoices: Array<{ __typename?: 'order_invoices', invoice_date: string, uuid: string }> }>, unplaced_orders: Array<{ __typename?: 'orders', restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_invoices: Array<{ __typename?: 'order_invoices', invoice_date: string, uuid: string }> }> }> } | null } };

export type DuplicateOrderToAccountsMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  sourceOrderUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  targetRestaurantsUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DuplicateOrderToAccountsMutation = { __typename?: 'mutation_root', copyRestaurantOrder: { __typename?: 'SuccessResponse', success: boolean } };

export type OrderGuide_CreateFromMenuMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type OrderGuide_CreateFromMenuMutation = { __typename?: 'mutation_root', createOrderGuideFromMenu: { __typename?: 'CreateOrderGuideFromMenuResponse', order_guide_collection_uuid: string, order_guide_partition_uuid: string } };

export type Locations_GetBusinessDetailsQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type Locations_GetBusinessDetailsQuery = { __typename?: 'query_root', getBusinessDetails: { __typename?: 'BusinessDetailsResponse', phone_number?: string | null, hours?: Array<{ __typename?: 'OpenHours', open: Array<{ __typename?: 'OpenHoursDetails', day: number, end: string, is_overnight: boolean, start: string }> }> | null, menu_items?: Array<{ __typename?: 'MenuItem', category?: string | null, ingredients: Array<string>, item_name: string }> | null } };

export type Locations_GetSupplierAndRestaurantFieldsQueryVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  unplacedOrderStatuses: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type Locations_GetSupplierAndRestaurantFieldsQuery = { __typename?: 'query_root', supplier?: { __typename?: 'businesses', uuid: string, address: { __typename?: 'addresses', country_code: string, uuid: string } } | null, restaurant?: { __typename?: 'businesses', name: string, uuid: string, address: { __typename?: 'addresses', address: string, address2?: string | null, city: string, country_code: string, latitude: number, longitude: number, region?: string | null, uuid: string }, restaurant_chats: Array<{ __typename?: 'chats', restaurant_account_id?: string | null, restaurant_notes?: string | null, uuid: string, chat_route_metadata?: { __typename?: 'chats_route_metadata', name: string } | null, placed_orders: Array<{ __typename?: 'orders', restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_invoices: Array<{ __typename?: 'order_invoices', invoice_date: string, uuid: string }> }>, unplaced_orders: Array<{ __typename?: 'orders', restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_invoices: Array<{ __typename?: 'order_invoices', invoice_date: string, uuid: string }> }> }> } | null };

export type Locations_GetAssignedSalesRepInfoQueryVariables = Exact<{
  chatUUID: Scalars['uuid']['input'];
}>;


export type Locations_GetAssignedSalesRepInfoQuery = { __typename?: 'query_root', sales_rep_chat_relations: Array<{ __typename?: 'sales_rep_chat_relations', employee: { __typename?: 'employees', name: string, uuid: string } }> };

export type MenuAi_GetItemsFromMenuImagesQueryVariables = Exact<{
  imageUrls: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type MenuAi_GetItemsFromMenuImagesQuery = { __typename?: 'query_root', getItemsFromMenuImages: { __typename?: 'GetItemsFromMenuImagesResponse', items: Array<{ __typename?: 'MenuItem', item_name: string, ingredients: Array<string>, category?: string | null }> } };

export type OrderGuide_CreateOrderGuideFromGeneratedMenuItemsMutationVariables = Exact<{
  items: Array<MenuItemInput> | MenuItemInput;
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type OrderGuide_CreateOrderGuideFromGeneratedMenuItemsMutation = { __typename?: 'mutation_root', createOrderGuideFromGeneratedMenuItems: { __typename?: 'CreateOrderGuideFromGeneratedMenuItemsResponse', order_guide_collection_uuid: string, order_guide_partition_uuid: string } };

export type Substitutions_ClearItemSubstitutionMutationVariables = Exact<{
  orderUUID: Scalars['uuid']['input'];
  sourceVariantPackUUID: Scalars['uuid']['input'];
}>;


export type Substitutions_ClearItemSubstitutionMutation = { __typename?: 'mutation_root', clearItemSubstitution: { __typename?: 'ClearItemSubstitutionResponse', order?: { __typename?: 'orders', additional_input_values?: any | null, fulfillment_timeslot_end?: string | null, fulfillment_timeslot_start?: string | null, fulfillment_type: string, notes?: string | null, order_domain?: string | null, placed_at?: string | null, po_number?: string | null, restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_fulfillment_fees: Array<{ __typename?: 'order_fulfillment_fees', amount_in_micros?: number | null, fulfillment_settings_name?: string | null, uuid?: string | null }>, order_invoices: Array<{ __typename?: 'order_invoices', balance_in_micros?: number | null, due_at?: string | null, invoice_date: string, invoice_number?: string | null, order_uuid?: string | null, uuid: string }>, orders_items: Array<{ __typename?: 'orders_items', earliest_fulfillment_at?: string | null, notes?: string | null, restaurant_display_name: string, uuid: string, order_item_prices?: { __typename?: 'order_item_prices', pack_quantity_at_order?: number | null } | null, variants_pack: { __typename?: 'variants_packs', metadata?: any | null, uuid: string, item: { __typename?: 'items', description?: string | null, uuid: string } } }>, storefront_metadata?: { __typename?: 'storefront_order_metadata', name?: string | null, uuid: string, visibility: string } | null } | null } };

export type NewOrder_ReorderMutationVariables = Exact<{
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  timeslotEnd?: InputMaybe<Scalars['String']['input']>;
  timeslotStart?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
  previousOrderUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type NewOrder_ReorderMutation = { __typename?: 'mutation_root', reorder: { __typename?: 'OrderResponse', order?: { __typename?: 'orders', additional_input_values?: any | null, fulfillment_timeslot_end?: string | null, fulfillment_timeslot_start?: string | null, fulfillment_type: string, notes?: string | null, order_domain?: string | null, placed_at?: string | null, po_number?: string | null, restaurant_desired_delivery_time?: string | null, status: string, supplier_accepted_delivery_time?: string | null, uuid: string, order_fulfillment_fees: Array<{ __typename?: 'order_fulfillment_fees', amount_in_micros?: number | null, fulfillment_settings_name?: string | null, uuid?: string | null }>, order_invoices: Array<{ __typename?: 'order_invoices', balance_in_micros?: number | null, due_at?: string | null, invoice_date: string, invoice_number?: string | null, order_uuid?: string | null, uuid: string }>, orders_items: Array<{ __typename?: 'orders_items', earliest_fulfillment_at?: string | null, notes?: string | null, restaurant_display_name: string, uuid: string, order_item_prices?: { __typename?: 'order_item_prices', pack_quantity_at_order?: number | null } | null, variants_pack: { __typename?: 'variants_packs', metadata?: any | null, uuid: string, item: { __typename?: 'items', description?: string | null, uuid: string } } }>, storefront_metadata?: { __typename?: 'storefront_order_metadata', name?: string | null, uuid: string, visibility: string } | null } | null } };

export type OrderInbound_SearchUnmatchedItemsQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  query: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
}>;


export type OrderInbound_SearchUnmatchedItemsQuery = { __typename?: 'query_root', searchVariantPacks: Array<{ __typename?: 'VariantPackWithAvailabilityResponse', variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null, variant_pack_order_counts?: Array<{ __typename?: 'VariantPackOrderCount', days: number, order_count: number }> | null }> };

export type SmartOrder_MergeMutationVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  smartOrdersToUpdate: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  mergeUUID: Scalars['uuid']['input'];
  assignedEmployeeUUID?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt: Scalars['timestamptz']['input'];
  updatedBy: Scalars['uuid']['input'];
}>;


export type SmartOrder_MergeMutation = { __typename?: 'mutation_root', update_smart_order?: { __typename?: 'smart_order_mutation_response', returning: Array<{ __typename?: 'smart_order', merge_uuid?: string | null, uuid: string, updated_at: string, assigned_employee?: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', uuid: string, name?: string | null }> } | null }> } | null };

export type SmartOrderSearchInputsFieldsFragment = { __typename?: 'smart_order_search_input', index: number, intent: string, item_notes?: string | null, matched_image_location?: any | null, matched_text?: string | null, original_pack_unit?: string | null, original_quantity?: number | null, pack_unit?: string | null, quantity: number, requested_item_code?: string | null, requested_item_name?: string | null, smart_order_uuid: string, translations?: any | null, uuid: string, search_term: { __typename?: 'smart_order_search_term', status: string, translations?: any | null, uuid: string, term: string, original_term: string, variants_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } };

export type OrderInboundAssignedEmployeeFieldsFragment = { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', uuid: string, name?: string | null }> };

export type SmartOrderSegmentFieldsFragment = { __typename?: 'smart_order_segment', attachment_index?: number | null, matched_text?: string | null, smart_order_search_input_uuid?: string | null, sort_order: number, start_seconds?: number | null, translations?: any | null, uuid: string };

export type SmartOrderFieldsFragment = { __typename?: 'smart_order', attachments?: any | null, created_at: string, email_address?: string | null, fulfillment_at?: string | null, fulfillment_type: string, merge_uuid?: string | null, order_notes?: string | null, order_uuid?: string | null, original_fulfillment_at?: string | null, original_sent_at?: string | null, po_number?: string | null, phone_number?: string | null, processing_status: string, search_text?: string | null, source: string, status: string, subject?: string | null, supplier_uuid: string, thread_id?: string | null, translations?: any | null, updated_at: string, uuid: string, voicemail_word_timestamps?: any | null, assigned_employee?: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', uuid: string, name?: string | null }> } | null, created_by?: { __typename?: 'employees', name: string, uuid: string, contact_info: { __typename?: 'employee_contact_info', email?: string | null, login_email?: string | null, phone_number: string, uuid: string }, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', contact_emails: any, contact_phone_numbers: any, name?: string | null, supplier_uuid: string, uuid: string }> } | null, order?: { __typename?: 'orders', notes?: string | null, uuid: string } | null, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null, search_inputs: Array<{ __typename?: 'smart_order_search_input', index: number, intent: string, item_notes?: string | null, matched_image_location?: any | null, matched_text?: string | null, original_pack_unit?: string | null, original_quantity?: number | null, pack_unit?: string | null, quantity: number, requested_item_code?: string | null, requested_item_name?: string | null, smart_order_uuid: string, translations?: any | null, uuid: string, search_term: { __typename?: 'smart_order_search_term', status: string, translations?: any | null, uuid: string, term: string, original_term: string, variants_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } }>, smart_order_segments: Array<{ __typename?: 'smart_order_segment', attachment_index?: number | null, matched_text?: string | null, smart_order_search_input_uuid?: string | null, sort_order: number, start_seconds?: number | null, translations?: any | null, uuid: string }> };

export type OrderInboundListSubscriptionFieldsFragment = { __typename?: 'employee_smart_orders', assigned_employee_name?: string | null, assigned_employee_uuid?: string | null, merge_uuid?: string | null, processing_status?: string | null, restaurant_name?: string | null, restaurant_uuid?: string | null, smart_order_uuid?: string | null, status?: string | null, supplier_employee_override_name?: string | null, supplier_employee_override_uuid?: string | null };

export type OrderInbounds_ListSubscriptionSubscriptionVariables = Exact<{
  lastCreatedAt: Scalars['timestamptz']['input'];
  employeeUUID: Scalars['uuid']['input'];
  businessOrganizationUUID: Scalars['uuid']['input'];
  orderUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type OrderInbounds_ListSubscriptionSubscription = { __typename?: 'subscription_root', employee_smart_orders: Array<{ __typename?: 'employee_smart_orders', assigned_employee_name?: string | null, assigned_employee_uuid?: string | null, merge_uuid?: string | null, processing_status?: string | null, restaurant_name?: string | null, restaurant_uuid?: string | null, smart_order_uuid?: string | null, status?: string | null, supplier_employee_override_name?: string | null, supplier_employee_override_uuid?: string | null }> };

export type OrderInboundListSearchInputFieldsFragment = { __typename?: 'smart_order_search_input', matched_text?: string | null, pack_unit?: string | null, quantity: number, translations?: any | null, uuid: string, search_term: { __typename?: 'smart_order_search_term', status: string, translations?: any | null, uuid: string, term: string } };

export type OrderInboundListFieldsFragment = { __typename?: 'smart_order', attachments?: any | null, created_at: string, email_address?: string | null, fulfillment_at?: string | null, fulfillment_type: string, merge_uuid?: string | null, order_uuid?: string | null, phone_number?: string | null, processing_status: string, search_text?: string | null, source: string, status: string, supplier_uuid: string, thread_id?: string | null, translations?: any | null, updated_at: string, uuid: string, assigned_employee?: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', uuid: string, name?: string | null }> } | null, created_by?: { __typename?: 'employees', name: string, uuid: string, contact_info: { __typename?: 'employee_contact_info', email?: string | null, login_email?: string | null, phone_number: string, uuid: string }, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', contact_emails: any, contact_phone_numbers: any, name?: string | null, supplier_uuid: string, uuid: string }> } | null, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null, search_inputs: Array<{ __typename?: 'smart_order_search_input', matched_text?: string | null, pack_unit?: string | null, quantity: number, translations?: any | null, uuid: string, search_term: { __typename?: 'smart_order_search_term', status: string, translations?: any | null, uuid: string, term: string } }> };

export type OrderInbounds_ThreadMessageRelsSubscriptionVariables = Exact<{
  threadIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OrderInbounds_ThreadMessageRelsSubscription = { __typename?: 'subscription_root', smart_order_message_rel: Array<{ __typename?: 'smart_order_message_rel', message_id: string, smart_order_uuid: string, thread_id: string, uuid: string }> };

export type OrderInbounds_ListQueryVariables = Exact<{
  where: Smart_Order_Bool_Exp;
  businessOrganizationUUID: Scalars['uuid']['input'];
}>;


export type OrderInbounds_ListQuery = { __typename?: 'query_root', smart_order: Array<{ __typename?: 'smart_order', attachments?: any | null, created_at: string, email_address?: string | null, fulfillment_at?: string | null, fulfillment_type: string, merge_uuid?: string | null, order_uuid?: string | null, phone_number?: string | null, processing_status: string, search_text?: string | null, source: string, status: string, supplier_uuid: string, thread_id?: string | null, translations?: any | null, updated_at: string, uuid: string, assigned_employee?: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', uuid: string, name?: string | null }> } | null, created_by?: { __typename?: 'employees', name: string, uuid: string, contact_info: { __typename?: 'employee_contact_info', email?: string | null, login_email?: string | null, phone_number: string, uuid: string }, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', contact_emails: any, contact_phone_numbers: any, name?: string | null, supplier_uuid: string, uuid: string }> } | null, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null, search_inputs: Array<{ __typename?: 'smart_order_search_input', matched_text?: string | null, pack_unit?: string | null, quantity: number, translations?: any | null, uuid: string, search_term: { __typename?: 'smart_order_search_term', status: string, translations?: any | null, uuid: string, term: string } }> }> };

export type OrderInbounds_ListLiveUpdateQueryVariables = Exact<{
  orderUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  businessOrganizationUUID: Scalars['uuid']['input'];
}>;


export type OrderInbounds_ListLiveUpdateQuery = { __typename?: 'query_root', smart_order: Array<{ __typename?: 'smart_order', attachments?: any | null, created_at: string, email_address?: string | null, fulfillment_at?: string | null, fulfillment_type: string, merge_uuid?: string | null, order_uuid?: string | null, phone_number?: string | null, processing_status: string, search_text?: string | null, source: string, status: string, supplier_uuid: string, thread_id?: string | null, translations?: any | null, updated_at: string, uuid: string, assigned_employee?: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', uuid: string, name?: string | null }> } | null, created_by?: { __typename?: 'employees', name: string, uuid: string, contact_info: { __typename?: 'employee_contact_info', email?: string | null, login_email?: string | null, phone_number: string, uuid: string }, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', contact_emails: any, contact_phone_numbers: any, name?: string | null, supplier_uuid: string, uuid: string }> } | null, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null, search_inputs: Array<{ __typename?: 'smart_order_search_input', matched_text?: string | null, pack_unit?: string | null, quantity: number, translations?: any | null, uuid: string, search_term: { __typename?: 'smart_order_search_term', status: string, translations?: any | null, uuid: string, term: string } }> }> };

export type OrderInbounds_ListHistoryQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  statuses: Array<SmartOrderStatus> | SmartOrderStatus;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  assignedEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<SmartOrderInboundHistoryOrderBy>;
}>;


export type OrderInbounds_ListHistoryQuery = { __typename?: 'query_root', getSmartOrderInboundHistory: { __typename?: 'GetSmartOrderInboundHistoryResponse', total_count: number, smart_orders: Array<{ __typename?: 'SmartOrderInboundHistoryItem', smart_order_id: string, smart_order?: { __typename?: 'smart_order', attachments?: any | null, created_at: string, email_address?: string | null, fulfillment_at?: string | null, fulfillment_type: string, merge_uuid?: string | null, order_uuid?: string | null, phone_number?: string | null, processing_status: string, search_text?: string | null, source: string, status: string, supplier_uuid: string, thread_id?: string | null, translations?: any | null, updated_at: string, uuid: string, assigned_employee?: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', uuid: string, name?: string | null }> } | null, created_by?: { __typename?: 'employees', name: string, uuid: string, contact_info: { __typename?: 'employee_contact_info', email?: string | null, login_email?: string | null, phone_number: string, uuid: string }, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', contact_emails: any, contact_phone_numbers: any, name?: string | null, supplier_uuid: string, uuid: string }> } | null, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null, search_inputs: Array<{ __typename?: 'smart_order_search_input', matched_text?: string | null, pack_unit?: string | null, quantity: number, translations?: any | null, uuid: string, search_term: { __typename?: 'smart_order_search_term', status: string, translations?: any | null, uuid: string, term: string } }> } | null }> } };

export type OrderInbounds_ListAssigneesQueryVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
}>;


export type OrderInbounds_ListAssigneesQuery = { __typename?: 'query_root', getSmartOrderInboundAssignees: { __typename?: 'GetSmartOrderInboundAssigneesResponse', assignees: Array<{ __typename?: 'SmartOrderInboundAssignee', employee_id: string, name?: string | null }> } };

export type OrderInbounds_SwapSuggestionFieldsFragment = { __typename?: 'VariantPackMatch', variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null, variant_pack_order_counts?: Array<{ __typename?: 'VariantPackOrderCount', days: number, order_count: number }> | null };

export type OrderInbounds_SearchInputFieldsFragment = { __typename?: 'SmartOrderDetailsSearchInput', search_input_id: string, search_term_id: string, variant_pack_id?: string | null, alternative_variant_pack_matches: Array<{ __typename?: 'VariantPackMatch', variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null, variant_pack_order_counts?: Array<{ __typename?: 'VariantPackOrderCount', days: number, order_count: number }> | null }>, previous_variant_pack_matches: Array<{ __typename?: 'VariantPackMatch', variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null, variant_pack_order_counts?: Array<{ __typename?: 'VariantPackOrderCount', days: number, order_count: number }> | null }>, variant_pack_order_counts?: Array<{ __typename?: 'VariantPackOrderCount', days: number, order_count: number }> | null };

export type OrderInbounds_DetailQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  businessOrganizationUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  smartOrderUUID: Scalars['uuid']['input'];
  mergeUUID?: InputMaybe<Scalars['uuid']['input']>;
  threadIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  skipSmartOrderVariantPack?: Scalars['Boolean']['input'];
}>;


export type OrderInbounds_DetailQuery = { __typename?: 'query_root', getSmartOrderDetails: Array<{ __typename?: 'GetSmartOrderDetailsResponse', search_inputs: Array<{ __typename?: 'SmartOrderDetailsSearchInput', search_input_id: string, search_term_id: string, variant_pack_id?: string | null, alternative_variant_pack_matches: Array<{ __typename?: 'VariantPackMatch', variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null, variant_pack_order_counts?: Array<{ __typename?: 'VariantPackOrderCount', days: number, order_count: number }> | null }>, previous_variant_pack_matches: Array<{ __typename?: 'VariantPackMatch', variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null, variant_pack_order_counts?: Array<{ __typename?: 'VariantPackOrderCount', days: number, order_count: number }> | null }>, variant_pack_order_counts?: Array<{ __typename?: 'VariantPackOrderCount', days: number, order_count: number }> | null }>, smart_order?: { __typename?: 'smart_order', attachments?: any | null, created_at: string, email_address?: string | null, fulfillment_at?: string | null, fulfillment_type: string, merge_uuid?: string | null, order_notes?: string | null, order_uuid?: string | null, original_fulfillment_at?: string | null, original_sent_at?: string | null, po_number?: string | null, phone_number?: string | null, processing_status: string, search_text?: string | null, source: string, status: string, subject?: string | null, supplier_uuid: string, thread_id?: string | null, translations?: any | null, updated_at: string, uuid: string, voicemail_word_timestamps?: any | null, assigned_employee?: { __typename?: 'employees', name: string, uuid: string, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', uuid: string, name?: string | null }> } | null, created_by?: { __typename?: 'employees', name: string, uuid: string, contact_info: { __typename?: 'employee_contact_info', email?: string | null, login_email?: string | null, phone_number: string, uuid: string }, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', contact_emails: any, contact_phone_numbers: any, name?: string | null, supplier_uuid: string, uuid: string }> } | null, order?: { __typename?: 'orders', notes?: string | null, uuid: string } | null, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null, search_inputs: Array<{ __typename?: 'smart_order_search_input', index: number, intent: string, item_notes?: string | null, matched_image_location?: any | null, matched_text?: string | null, original_pack_unit?: string | null, original_quantity?: number | null, pack_unit?: string | null, quantity: number, requested_item_code?: string | null, requested_item_name?: string | null, smart_order_uuid: string, translations?: any | null, uuid: string, search_term: { __typename?: 'smart_order_search_term', status: string, translations?: any | null, uuid: string, term: string, original_term: string, variants_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } }>, smart_order_segments: Array<{ __typename?: 'smart_order_segment', attachment_index?: number | null, matched_text?: string | null, smart_order_search_input_uuid?: string | null, sort_order: number, start_seconds?: number | null, translations?: any | null, uuid: string }> } | null }> };

export type OrderInbound_AddSmartOrderItemMutationVariables = Exact<{
  quantity: Scalars['Int']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  searchTerm: Scalars['String']['input'];
  smartOrderUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPackUUID: Scalars['uuid']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  locale: Scalars['String']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipSmartOrderVariantPack?: Scalars['Boolean']['input'];
}>;


export type OrderInbound_AddSmartOrderItemMutation = { __typename?: 'mutation_root', addSmartOrderItem: { __typename?: 'AddItemToSmartOrderResponse', smart_order_search_input?: { __typename?: 'smart_order_search_input', index: number, intent: string, item_notes?: string | null, matched_image_location?: any | null, matched_text?: string | null, original_pack_unit?: string | null, original_quantity?: number | null, pack_unit?: string | null, quantity: number, requested_item_code?: string | null, requested_item_name?: string | null, smart_order_uuid: string, translations?: any | null, uuid: string, search_term: { __typename?: 'smart_order_search_term', status: string, translations?: any | null, uuid: string, term: string, original_term: string, variants_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } } | null } };

export type OrderInput_UpdateSmartOrderItemMutationVariables = Exact<{
  newSearchTerm: Scalars['String']['input'];
  newVariantPackUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  smartOrderSearchInputUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  locale: Scalars['String']['input'];
  rememberSelection?: InputMaybe<Scalars['Boolean']['input']>;
  skipGroupMemberships: Scalars['Boolean']['input'];
  recalculateQuantity: Scalars['Boolean']['input'];
  skipSmartOrderVariantPack?: Scalars['Boolean']['input'];
}>;


export type OrderInput_UpdateSmartOrderItemMutation = { __typename?: 'mutation_root', updateSearchInput: { __typename?: 'UpdateSmartOrderSearchInputResponse', smart_order_search_input?: { __typename?: 'smart_order_search_input', index: number, intent: string, item_notes?: string | null, matched_image_location?: any | null, matched_text?: string | null, original_pack_unit?: string | null, original_quantity?: number | null, pack_unit?: string | null, quantity: number, requested_item_code?: string | null, requested_item_name?: string | null, smart_order_uuid: string, translations?: any | null, uuid: string, search_term: { __typename?: 'smart_order_search_term', status: string, translations?: any | null, uuid: string, term: string, original_term: string, variants_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } } | null } };

export type OrderInput_CreateSearchTermCorrectionMutationVariables = Exact<{
  oldSearchTermUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  smartOrderUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  variantPackUUID: Scalars['uuid']['input'];
}>;


export type OrderInput_CreateSearchTermCorrectionMutation = { __typename?: 'mutation_root', createSearchTermCorrection: { __typename?: 'CreateSearchTermCorrectionResponse', search_term_correction_id: string } };

export type OrderInbounds_SearchTermCorrectionsQueryVariables = Exact<{
  smartOrderUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
}>;


export type OrderInbounds_SearchTermCorrectionsQuery = { __typename?: 'query_root', smart_order_search_term_corrections: Array<{ __typename?: 'smart_order_search_term_corrections', old_search_term_uuid: string, smart_order_uuid: string, uuid: string, new_search_term: { __typename?: 'smart_order_search_term', uuid: string, variants_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } }> };

export type OrderInbound_UpdateQuantityMutationVariables = Exact<{
  smartOrderInputUUID: Scalars['uuid']['input'];
  quantity: Scalars['float8']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipSmartOrderVariantPack?: Scalars['Boolean']['input'];
}>;


export type OrderInbound_UpdateQuantityMutation = { __typename?: 'mutation_root', update_smart_order_search_input_by_pk?: { __typename?: 'smart_order_search_input', index: number, intent: string, item_notes?: string | null, matched_image_location?: any | null, matched_text?: string | null, original_pack_unit?: string | null, original_quantity?: number | null, pack_unit?: string | null, quantity: number, requested_item_code?: string | null, requested_item_name?: string | null, smart_order_uuid: string, translations?: any | null, uuid: string, search_term: { __typename?: 'smart_order_search_term', status: string, translations?: any | null, uuid: string, term: string, original_term: string, variants_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } } | null };

export type OrderInbound_UpdateItemNotesMutationVariables = Exact<{
  smartOrderInputUUID: Scalars['uuid']['input'];
  itemNotes?: InputMaybe<Scalars['String']['input']>;
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipSmartOrderVariantPack?: Scalars['Boolean']['input'];
}>;


export type OrderInbound_UpdateItemNotesMutation = { __typename?: 'mutation_root', update_smart_order_search_input_by_pk?: { __typename?: 'smart_order_search_input', index: number, intent: string, item_notes?: string | null, matched_image_location?: any | null, matched_text?: string | null, original_pack_unit?: string | null, original_quantity?: number | null, pack_unit?: string | null, quantity: number, requested_item_code?: string | null, requested_item_name?: string | null, smart_order_uuid: string, translations?: any | null, uuid: string, search_term: { __typename?: 'smart_order_search_term', status: string, translations?: any | null, uuid: string, term: string, original_term: string, variants_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null } } | null };

export type OrderInbound_AssignSmartOrderMutationVariables = Exact<{
  employeeUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  smartOrderUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type OrderInbound_AssignSmartOrderMutation = { __typename?: 'mutation_root', assignSmartOrder: { __typename?: 'AssignSmartOrderResponse', smart_order_id: string, smart_order?: { __typename?: 'smart_order', uuid: string, restaurant?: { __typename?: 'businesses', name: string, uuid: string } | null } | null } };

export type OrderInbounds_MemorizeOrderMutationVariables = Exact<{
  orderUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type OrderInbounds_MemorizeOrderMutation = { __typename?: 'mutation_root', memorizeSmartOrder: { __typename?: 'MemorizeSmartOrderResponse', smart_order_id: string } };

export type OrderInbound_UpdateSmartOrderAssigneeMutationVariables = Exact<{
  employeeUUID?: InputMaybe<Scalars['uuid']['input']>;
  smartOrderUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type OrderInbound_UpdateSmartOrderAssigneeMutation = { __typename?: 'mutation_root', updateSmartOrderAssignee: { __typename?: 'UpdateSmartOrderAssigneeResponse', assigned_employee_id?: string | null, smart_order_ids: Array<string> } };

export type OrderInbound_UpdateFulfillmentOptionsMutationVariables = Exact<{
  uuid: Scalars['uuid']['input'];
  openStatuses: Array<Scalars['String']['input']> | Scalars['String']['input'];
  fulfillment_at: Scalars['timestamptz']['input'];
  fulfillment_type: Scalars['String']['input'];
  updatedAt: Scalars['timestamptz']['input'];
  updatedBy: Scalars['uuid']['input'];
}>;


export type OrderInbound_UpdateFulfillmentOptionsMutation = { __typename?: 'mutation_root', update_smart_order?: { __typename?: 'smart_order_mutation_response', returning: Array<{ __typename?: 'smart_order', uuid: string, fulfillment_at?: string | null, fulfillment_type: string }> } | null };

export type OrderInbound_UpdatePoNumberMutationVariables = Exact<{
  uuid: Scalars['uuid']['input'];
  openStatuses: Array<Scalars['String']['input']> | Scalars['String']['input'];
  po_number: Scalars['String']['input'];
  updatedAt: Scalars['timestamptz']['input'];
  updatedBy: Scalars['uuid']['input'];
}>;


export type OrderInbound_UpdatePoNumberMutation = { __typename?: 'mutation_root', update_smart_order?: { __typename?: 'smart_order_mutation_response', returning: Array<{ __typename?: 'smart_order', uuid: string, po_number?: string | null }> } | null };

export type OrderInbound_UpdateOrderNotesMutationVariables = Exact<{
  uuids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  openStatuses: Array<Scalars['String']['input']> | Scalars['String']['input'];
  order_notes: Scalars['String']['input'];
  updatedAt: Scalars['timestamptz']['input'];
  updatedBy: Scalars['uuid']['input'];
}>;


export type OrderInbound_UpdateOrderNotesMutation = { __typename?: 'mutation_root', update_smart_order?: { __typename?: 'smart_order_mutation_response', returning: Array<{ __typename?: 'smart_order', uuid: string, order_notes?: string | null }> } | null };

export type OrderInbound_GetVariantPackSubstitutionsQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
  supplierId: Scalars['uuid']['input'];
  variantPackIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type OrderInbound_GetVariantPackSubstitutionsQuery = { __typename?: 'query_root', getVariantPackSubstitutions: Array<{ __typename?: 'GetVariantPackSubstitutionsResponse', variant_pack_id: string, substitutions: Array<{ __typename?: 'VariantPackSubstitution', variant_pack_order_counts?: Array<{ __typename?: 'VariantPackOrderCount', days: number, order_count: number }> | null, variant_pack?: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } | null }> }> };

export type OrderInbound_GetSmartOrderAssignableEmployeesQueryVariables = Exact<{
  smartOrderUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type OrderInbound_GetSmartOrderAssignableEmployeesQuery = { __typename?: 'query_root', getSmartOrderAssignableEmployees: { __typename?: 'GetSmartOrderAssignableEmployeesResponse', assignable_employees: Array<{ __typename?: 'SmartOrderAssignableEmployee', employee_id: string, group: SmartOrderAssignableGroup, has_restaurant_access: boolean, name: string, submitted_recently: boolean }> } };

export type OrderInbound_GrantSmartOrderRestaurantAccessMutationVariables = Exact<{
  employeeUUID: Scalars['uuid']['input'];
  smartOrderUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type OrderInbound_GrantSmartOrderRestaurantAccessMutation = { __typename?: 'mutation_root', grantSmartOrderRestaurantAccess: { __typename?: 'GrantSmartOrderRestaurantAccessResponse', access_granted: boolean, employee_id: string, has_restaurant_access: boolean } };

export type SmartOrder_RejectMutationVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  smartOrdersToRemove: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  updatedAt: Scalars['timestamptz']['input'];
  updatedBy: Scalars['uuid']['input'];
}>;


export type SmartOrder_RejectMutation = { __typename?: 'mutation_root', update_smart_order?: { __typename?: 'smart_order_mutation_response', returning: Array<{ __typename?: 'smart_order', status: string, updated_at: string, uuid: string }> } | null };

export type AssignPrintTagBatch_PlanogramsMutationVariables = Exact<{
  planogramUUIDs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  printTagBatchUUID: Scalars['uuid']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type AssignPrintTagBatch_PlanogramsMutation = { __typename?: 'mutation_root', assignPrintTagBatchPlanograms: { __typename?: 'PrintTagBatchResponse', print_tag_batch_id: string } };

export type TagPrint_UpdateRetailPriceMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  retailPriceInMicros?: InputMaybe<Scalars['bigint']['input']>;
  supplierUUID: Scalars['uuid']['input'];
  variantPackUUID: Scalars['uuid']['input'];
}>;


export type TagPrint_UpdateRetailPriceMutation = { __typename?: 'mutation_root', upsertVariantPackRestaurantRetailPrice: { __typename?: 'SuccessResponse', success: boolean } };

export type OfflineOrder_SubmitMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  orderNotes?: InputMaybe<Scalars['String']['input']>;
  orderItems: Array<UpdateItemInput> | UpdateItemInput;
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  additionalInputValues?: InputMaybe<Array<AdditionalInputValueInput> | AdditionalInputValueInput>;
}>;


export type OfflineOrder_SubmitMutation = { __typename?: 'mutation_root', submitOfflineOrder: { __typename?: 'SubmitOrderResponse', order_id: string } };

export type Account_RemoveAccountFromChatsMutationVariables = Exact<{
  businessOrganizationUUID: Scalars['uuid']['input'];
  employeeUUID: Scalars['uuid']['input'];
}>;


export type Account_RemoveAccountFromChatsMutation = { __typename?: 'mutation_root', removeSelfFromChats: { __typename?: 'EmployeeResponse', employee_id: string } };

export type EmployeeContactInfo_NotificationSettingsQueryVariables = Exact<{
  employeeUUID: Scalars['uuid']['input'];
  chatUUID: Scalars['uuid']['input'];
}>;


export type EmployeeContactInfo_NotificationSettingsQuery = { __typename?: 'query_root', employees_by_pk?: { __typename?: 'employees', uuid: string, chats_employees: Array<{ __typename?: 'chats_employees', uuid: string, show_app_payments_tab?: boolean | null, chat: { __typename?: 'chats', show_app_payments_tab: boolean, uuid: string } }>, contact_info: { __typename?: 'employee_contact_info', uuid: string, wants_chat_email: boolean, wants_credit_request_email: boolean, wants_order_approval_email: boolean, wants_order_email: boolean, wants_order_tracking_notification: boolean, wants_payment_email: boolean } } | null };

export type RestaurantVp_SubscriptionFragment = { __typename?: 'restaurant_variant_pack_subscriptions', config: any, fulfillment_settings_uuid: string, pause_from?: any | null, pause_until?: any | null, uuid: string, variant_pack_uuid: string };

export type GetRestaurantVp_SubscriptionsQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  skipGroupMemberships: Scalars['Boolean']['input'];
  supplierUUID: Scalars['uuid']['input'];
  skipLiveSalt: Scalars['Boolean']['input'];
  skipSaltApi: Scalars['Boolean']['input'];
  useSaltCache: Scalars['Boolean']['input'];
}>;


export type GetRestaurantVp_SubscriptionsQuery = { __typename?: 'query_root', getRestaurantVariantPackSubscriptions: Array<{ __typename?: 'RestaurantVariantPackSubscriptionData', next_delivery_date: string, next_delivery_date_excluding_pauses: string, restaurant_variant_pack_subscription_id: string, restaurant_variant_pack_subscription?: { __typename?: 'restaurant_variant_pack_subscriptions', config: any, fulfillment_settings_uuid: string, pause_from?: any | null, pause_until?: any | null, uuid: string, variant_pack_uuid: string, variant_pack: { __typename?: 'variants_packs', external_item_id?: string | null, lead_time_cutoff_time?: string | null, lead_time_days?: number | null, metadata?: any | null, prebook_config?: any | null, upc_list?: any | null, uuid: string, gtin_metadata?: Array<{ __typename?: 'gtin_metadata', gtin: string, metadata: any, uuid: string }> | null, item: { __typename?: 'items', category?: string | null, description?: string | null, display_name: string, extra_keywords?: string | null, photo_url_list?: any | null, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, category?: string | null, uuid: string }> }, modifier_options: Array<{ __typename?: 'variants_packs_modifier_options', modifier_option: { __typename?: 'modifier_options', name: string, sort_order?: number | null, uuid: string, modifier_option_group: { __typename?: 'modifier_option_groups', name: string, sort_order?: number | null, uuid: string } } }>, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string }, salt?: { __typename?: 'ItemInfoWithVpUuidType', basicInformation: { __typename?: 'BasicInformationType', descriptions: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }>, names: Array<{ __typename?: 'GenericAttributeType', name?: string | null, value?: string | null }> }, images: Array<{ __typename?: 'ImageType', uri?: string | null }> }, salt_cache?: { __typename?: 'variant_pack_salt_cache', description_translations?: any | null, image_urls?: any | null, name_translations?: any | null } | null, variant_pack_group_memberships?: Array<{ __typename?: 'variant_pack_group_members', variant_pack_group_uuid: string, uuid: string }> } } | null }> };

export type GetNextDeliveryDateFor_SubscriptionQueryVariables = Exact<{
  frequencyDays: Scalars['Int']['input'];
  fulfillmentSettingsUUID: Scalars['uuid']['input'];
  orderDay: DaysOfWeek;
  restaurantUUID: Scalars['uuid']['input'];
  restaurantVPSubscriptionUUID?: InputMaybe<Scalars['uuid']['input']>;
  supplierUUID: Scalars['uuid']['input'];
}>;


export type GetNextDeliveryDateFor_SubscriptionQuery = { __typename?: 'query_root', getNextDeliveryDateForSubscriptionSettings: { __typename?: 'NextDeliveryDateResponse', next_delivery_date: string, next_placement_date: string } };

export type UpsertRestaurantVp_SubscriptionMutationVariables = Exact<{
  frequencyDays: Scalars['Int']['input'];
  fulfillmentSettingsUUID: Scalars['uuid']['input'];
  orderDay: DaysOfWeek;
  quantity: Scalars['Int']['input'];
  restaurantUUID: Scalars['uuid']['input'];
  restaurantVPSubscriptionUUID?: InputMaybe<Scalars['uuid']['input']>;
  supplierUUID: Scalars['uuid']['input'];
  variantPackUUID: Scalars['uuid']['input'];
}>;


export type UpsertRestaurantVp_SubscriptionMutation = { __typename?: 'mutation_root', upsertRestaurantVariantPackSubscription: { __typename?: 'RestaurantVariantPackSubscriptionResponse', restaurant_variant_pack_subscription?: { __typename?: 'restaurant_variant_pack_subscriptions', config: any, fulfillment_settings_uuid: string, pause_from?: any | null, pause_until?: any | null, uuid: string, variant_pack_uuid: string } | null } };

export type SkipNextVp_SubscriptionMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  restaurantVPSubscriptionUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type SkipNextVp_SubscriptionMutation = { __typename?: 'mutation_root', skipNextRestaurantVariantPackSubscription: { __typename?: 'RestaurantVariantPackSubscriptionResponse', restaurant_variant_pack_subscription?: { __typename?: 'restaurant_variant_pack_subscriptions', config: any, fulfillment_settings_uuid: string, pause_from?: any | null, pause_until?: any | null, uuid: string, variant_pack_uuid: string } | null } };

export type ResumeVp_SubscriptionMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  restaurantVPSubscriptionUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type ResumeVp_SubscriptionMutation = { __typename?: 'mutation_root', removeRestaurantVariantPackSubscriptionPause: { __typename?: 'RestaurantVariantPackSubscriptionResponse', restaurant_variant_pack_subscription?: { __typename?: 'restaurant_variant_pack_subscriptions', config: any, fulfillment_settings_uuid: string, pause_from?: any | null, pause_until?: any | null, uuid: string, variant_pack_uuid: string } | null } };

export type DeleteVp_SubscriptionMutationVariables = Exact<{
  restaurantUUID: Scalars['uuid']['input'];
  restaurantVPSubscriptionUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
}>;


export type DeleteVp_SubscriptionMutation = { __typename?: 'mutation_root', deleteRestaurantVariantPackSubscription: { __typename?: 'SuccessResponse', success: boolean } };

export type UpdateEmployeeFieldsFragment = { __typename?: 'employees', name: string, uuid: string, contact_info: { __typename?: 'employee_contact_info', email?: string | null, login_email?: string | null, phone_number: string, uuid: string }, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', contact_emails: any, contact_phone_numbers: any, name?: string | null, supplier_uuid: string, uuid: string }> };

export type UpdateEmployee_UpdateMutationVariables = Exact<{
  employeeUUID: Scalars['uuid']['input'];
  supplierUUID: Scalars['uuid']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  loginEmail?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateEmployee_UpdateMutation = { __typename?: 'mutation_root', updateEmployee: { __typename?: 'EmployeeResponse', employee?: { __typename?: 'employees', name: string, uuid: string, contact_info: { __typename?: 'employee_contact_info', email?: string | null, login_email?: string | null, phone_number: string, uuid: string }, supplier_employee_overrides: Array<{ __typename?: 'supplier_employee_overrides', contact_emails: any, contact_phone_numbers: any, name?: string | null, supplier_uuid: string, uuid: string }> } | null } };

export type OrderFeesFieldsFragment = { __typename?: 'order_fees', amount_at_invoice_micros?: number | null, amount_at_order_micros?: number | null, display_type?: string | null, name?: string | null, uuid?: string | null };

export type OrderFeesDetailsFieldsFragment = { __typename?: 'GetOrderFeesResponse', amount_at_invoice_micros?: number | null, amount_at_order_micros?: number | null, display_type: OrderFeeDisplayType, name: string };

export type PricePackFieldsFragment = { __typename?: 'packs', unit_count: number, uuid: string };

export type OrderItemPricesFieldsFragment = { __typename?: 'order_item_prices', currency_code?: string | null, pack_quantity_at_invoice?: number | null, pack_quantity_at_order?: number | null, tax_at_order_micros?: number | null, unit_discount_price_at_order_micros?: number | null, unit_price_at_invoice_micros?: number | null, unit_price_at_order_micros?: number | null };

export type OrderItemPriceFieldsFragment = { __typename?: 'orders_items', order_item_prices?: { __typename?: 'order_item_prices', currency_code?: string | null, pack_quantity_at_invoice?: number | null, pack_quantity_at_order?: number | null, tax_at_order_micros?: number | null, unit_discount_price_at_order_micros?: number | null, unit_price_at_invoice_micros?: number | null, unit_price_at_order_micros?: number | null } | null, pack: { __typename?: 'packs', unit_count: number, uuid: string }, pricing_pack?: { __typename?: 'packs', unit_count: number, uuid: string } | null };

export type OrderDisplayItemPricesFieldsFragment = { __typename?: 'orders', uuid: string, chat: { __typename?: 'chats', display_item_prices?: boolean | null, uuid: string }, supplier: { __typename?: 'businesses', uuid: string, supplier_metadata?: { __typename?: 'supplier_metadata', display_item_prices: boolean, uuid: string } | null } };

export type MinimalScanningVariantPackFieldsFragment = { __typename?: 'variants_packs', external_item_id?: string | null, upc_list?: any | null, uuid: string, item: { __typename?: 'items', display_name: string, uuid: string, restaurant_item_overrides: Array<{ __typename?: 'restaurant_item_overrides', display_name?: string | null, uuid: string }> }, pack: { __typename?: 'packs', base_unit?: string | null, max_unit_size: number, min_unit_size: number, unit: string, unit_count: number, uuid: string } };
